/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		8: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-game","1":"route-towns","2":"route-games","3":"route-login","4":"route-home","5":"route-about","6":"route-states","7":"route-profile"}[chunkId]||chunkId) + ".chunk." + {"0":"f6594","1":"00fcf","2":"da3fd","3":"feb26","4":"bff1b","5":"c07f5","6":"ff076","7":"8358e"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	if (opts === void 0) opts = EMPTY$1;

	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	var aAttr = a.attributes || EMPTY$1,
	    bAttr = b.attributes || EMPTY$1;
	if (aAttr.default) {
		return 1;
	}
	if (bAttr.default) {
		return -1;
	}
	var diff = rank(aAttr.path) - rank(bAttr.path);
	return diff || aAttr.path.length - bAttr.path.length;
}

function segmentize(url) {
	return strip(url).split('/');
}

function rank(url) {
	return (strip(url).match(/\/+/g) || '').length;
}

function strip(url) {
	return url.replace(/(^\/+|\/+$)/g, '');
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				return routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.slice().sort(pathRankSort).map(function (vnode) {
			var attrs = vnode.attributes || {},
			    path = attrs.path,
			    matches = exec(url, path, attrs);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
			return false;
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "3al8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__("MUsR");
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
exports.assert = function (assertion, message) {
  if (!assertion) {
    throw exports.assertionError(message);
  }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
exports.assertionError = function (message) {
  return new Error('Firebase Database (' + constants_1.CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};

//# sourceMappingURL=assert.js.map

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (load) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);
		var done = function done(child) {
			_this.setState({ child: child && child.default || child });
		};
		var r = load(done);
		if (r && r.then) r.then(done);
	}
	Async.prototype = new _preact.Component();
	Async.prototype.constructor = Async;
	Async.prototype.render = function (props, state) {
		return (0, _preact.h)(state.child, props);
	};
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "7Oow":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var stringToByteArray = function stringToByteArray(str) {
    var output = [],
        p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        while (c > 255) {
            output[p++] = c & 255;
            c >>= 8;
        }
        output[p++] = c;
    }
    return output;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function byteArrayToString(bytes) {
    var CHUNK_SIZE = 8192;
    // Special-case the simple case for speed's sake.
    if (bytes.length < CHUNK_SIZE) {
        return String.fromCharCode.apply(null, bytes);
    }
    // The remaining logic splits conversion by chunks since
    // Function#apply() has a maximum parameter count.
    // See discussion: http://goo.gl/LrWmZ9
    var str = '';
    for (var i = 0; i < bytes.length; i += CHUNK_SIZE) {
        var chunk = bytes.slice(i, i + CHUNK_SIZE);
        str += String.fromCharCode.apply(null, chunk);
    }
    return str;
};
// Static lookup maps, lazily populated by init_()
exports.base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function encodeByteArray(input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function encodeString(input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function decodeString(input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function decodeStringToByteArray(input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
exports.base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return exports.base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
exports.base64Decode = function (str) {
    try {
        return exports.base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

//# sourceMappingURL=crypt.js.map

/***/ }),

/***/ "8GLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__("p90z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("FXz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Breadcrumb = function (_Component) {
	_inherits(Breadcrumb, _Component);

	function Breadcrumb() {
		_classCallCheck(this, Breadcrumb);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Breadcrumb.prototype.render = function render(_ref) {
		var entries = _ref.entries;

		var items = entries.map(function (entry) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'li',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{ href: entry.link },
					entry.caption
				)
			);
		});
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.breadcrumb },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				null,
				items
			)
		);
	};

	return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "9BlA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__("MUsR");
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
exports.getUA = function () {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    } else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
exports.isMobileCordova = function () {
    return typeof window !== 'undefined' && !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(exports.getUA());
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
exports.isReactNative = function () {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
exports.isNodeSdk = function () {
    return constants_1.CONSTANTS.NODE_CLIENT === true || constants_1.CONSTANTS.NODE_ADMIN === true;
};

//# sourceMappingURL=environment.js.map

/***/ }),

/***/ "9fSs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
exports.contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
exports.safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
exports.extend = function (objTo, objFrom) {
    exports.forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
exports.clone = function (obj) {
    return exports.extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
exports.isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
exports.isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
exports.getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
exports.map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
exports.findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
exports.findValue = function (obj, fn, opt_this) {
    var key = exports.findKey(obj, fn, opt_this);
    return key && obj[key];
};
exports.getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
exports.getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

//# sourceMappingURL=obj.js.map

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "BtxX":
/***/ (function(module, exports) {

(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}

  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }
})(this);

/***/ }),

/***/ "CWxw":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __global = function () {
    if (typeof global !== 'undefined') {
        return global;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    throw new Error('unable to locate global object');
}();
// Polyfill Promise
if (typeof Promise === 'undefined') {
    // HACK: TS throws an error if I attempt to use 'dot-notation'
    __global['Promise'] = Promise = __webpack_require__("BtxX");
}

//# sourceMappingURL=promise.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "CXsN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button__3HbWX"};

/***/ }),

/***/ "DUiD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
  return JSON.parse(str);
}
exports.jsonEval = jsonEval;
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
  return JSON.stringify(data);
}
exports.stringify = stringify;

//# sourceMappingURL=json.js.map

/***/ }),

/***/ "FXz+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"breadcrumb__3Mpwr"};

/***/ }),

/***/ "Fi7B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var obj_1 = __webpack_require__("9fSs");
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
exports.querystring = function (querystringParams) {
    var params = [];
    obj_1.forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
exports.querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

//# sourceMappingURL=query.js.map

/***/ }),

/***/ "HW/i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var crypt_1 = __webpack_require__("7Oow");
var json_1 = __webpack_require__("DUiD");
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
exports.decode = function (token) {
    var header = {},
        claims = {},
        data = {},
        signature = '';
    try {
        var parts = token.split('.');
        header = json_1.jsonEval(crypt_1.base64Decode(parts[0]) || '');
        claims = json_1.jsonEval(crypt_1.base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isValidTimestamp = function (token) {
    var claims = exports.decode(token).claims,
        now = Math.floor(new Date().getTime() / 1000),
        validSince,
        validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        } else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        } else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return now && validSince && validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
exports.issuedAtTime = function (token) {
    var claims = exports.decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isValidFormat = function (token) {
    var decoded = exports.decode(token),
        claims = decoded.claims;
    return !!decoded.signature && !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isAdmin = function (token) {
    var claims = exports.decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

//# sourceMappingURL=jwt.js.map

/***/ }),

/***/ "IIoC":
/***/ (function(module, exports, __webpack_require__) {

(function () {
  var g,
      goog = goog || {},
      k = this;function l(a) {
    return "string" == typeof a;
  }function ba() {}
  function ca(a) {
    var b = typeof a;if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
  }function n(a) {
    return "array" == ca(a);
  }function da(a) {
    var b = ca(a);return "array" == b || "object" == b && "number" == typeof a.length;
  }function ea(a) {
    return "function" == ca(a);
  }function p(a) {
    var b = typeof a;return "object" == b && null != a || "function" == b;
  }var q = "closure_uid_" + (1E9 * Math.random() >>> 0),
      fa = 0;function ha(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }
  function ia(a, b, c) {
    if (!a) throw Error();if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);return function () {
        var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
      };
    }return function () {
      return a.apply(b, arguments);
    };
  }function r(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? r = ha : r = ia;return r.apply(null, arguments);
  }
  function ja(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);return function () {
      var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
    };
  }var t = Date.now || function () {
    return +new Date();
  };function u(a, b) {
    function c() {}c.prototype = b.prototype;a.L = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Bb = function (a, c, f) {
      for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
        d[e - 2] = arguments[e];
      }return b.prototype[c].apply(a, d);
    };
  };function ka(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, ka);else {
      var b = Error().stack;b && (this.stack = b);
    }a && (this.message = String(a));
  }u(ka, Error);ka.prototype.name = "CustomError";function la(a, b) {
    for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
      d += c.shift() + e.shift();
    }return d + c.join("%s");
  }var ma = String.prototype.trim ? function (a) {
    return a.trim();
  } : function (a) {
    return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
  };function na(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  };function oa(a, b) {
    b.unshift(a);ka.call(this, la.apply(null, b));b.shift();
  }u(oa, ka);oa.prototype.name = "AssertionError";function pa(a, b) {
    throw new oa("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
  };function w() {
    0 != ra && (sa[this[q] || (this[q] = ++fa)] = this);this.i = this.i;this.A = this.A;
  }var ra = 0,
      sa = {};w.prototype.i = !1;w.prototype.Z = function () {
    if (!this.i && (this.i = !0, this.w(), 0 != ra)) {
      var a = this[q] || (this[q] = ++fa);delete sa[a];
    }
  };w.prototype.w = function () {
    if (this.A) for (; this.A.length;) {
      this.A.shift()();
    }
  };var ta = Array.prototype.indexOf ? function (a, b, c) {
    return Array.prototype.indexOf.call(a, b, c);
  } : function (a, b, c) {
    c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (l(a)) return l(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
      if (c in a && a[c] === b) return c;
    }return -1;
  },
      ua = Array.prototype.forEach ? function (a, b, c) {
    Array.prototype.forEach.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = l(a) ? a.split("") : a, f = 0; f < d; f++) {
      f in e && b.call(c, e[f], f, a);
    }
  };
  function va(a) {
    a: {
      var b = wa;for (var c = a.length, d = l(a) ? a.split("") : a, e = 0; e < c; e++) {
        if (e in d && b.call(void 0, d[e], e, a)) {
          b = e;break a;
        }
      }b = -1;
    }return 0 > b ? null : l(a) ? a.charAt(b) : a[b];
  }function xa(a) {
    if (!n(a)) for (var b = a.length - 1; 0 <= b; b--) {
      delete a[b];
    }a.length = 0;
  }function ya(a) {
    return Array.prototype.concat.apply([], arguments);
  }function za(a) {
    var b = a.length;if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++) {
        c[d] = a[d];
      }return c;
    }return [];
  };var x;a: {
    var Aa = k.navigator;if (Aa) {
      var Ba = Aa.userAgent;if (Ba) {
        x = Ba;break a;
      }
    }x = "";
  }function y(a) {
    return -1 != x.indexOf(a);
  };function Ca(a, b, c) {
    for (var d in a) {
      b.call(c, a[d], d, a);
    }
  }function Da(a) {
    var b = [],
        c = 0,
        d;for (d in a) {
      b[c++] = a[d];
    }return b;
  }function Ea(a) {
    var b = [],
        c = 0,
        d;for (d in a) {
      b[c++] = d;
    }return b;
  }function Fa(a) {
    var b = {},
        c;for (c in a) {
      b[c] = a[c];
    }return b;
  }var Ga = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function Ha(a, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];for (c in d) {
        a[c] = d[c];
      }for (var f = 0; f < Ga.length; f++) {
        c = Ga[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
      }
    }
  };function Ia(a) {
    Ia[" "](a);return a;
  }Ia[" "] = ba;function Ja(a, b) {
    var c = Ka;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
  };var La = y("Opera"),
      z = y("Trident") || y("MSIE"),
      Ma = y("Edge"),
      Na = y("Gecko") && !(-1 != x.toLowerCase().indexOf("webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"),
      Oa = -1 != x.toLowerCase().indexOf("webkit") && !y("Edge");function Pa() {
    var a = k.document;return a ? a.documentMode : void 0;
  }var Qa;
  a: {
    var Ra = "",
        Sa = function () {
      var a = x;if (Na) return (/rv:([^\);]+)(\)|;)/.exec(a)
      );if (Ma) return (/Edge\/([\d\.]+)/.exec(a)
      );if (z) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
      );if (Oa) return (/WebKit\/(\S+)/.exec(a)
      );if (La) return (/(?:Version)[ \/]?(\S+)/.exec(a)
      );
    }();Sa && (Ra = Sa ? Sa[1] : "");if (z) {
      var Ta = Pa();if (null != Ta && Ta > parseFloat(Ra)) {
        Qa = String(Ta);break a;
      }
    }Qa = Ra;
  }var Ka = {};
  function Ua(a) {
    return Ja(a, function () {
      for (var b = 0, c = ma(String(Qa)).split("."), d = ma(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
        var h = c[f] || "",
            m = d[f] || "";do {
          h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];m = /(\d*)(\D*)(.*)/.exec(m) || ["", "", "", ""];if (0 == h[0].length && 0 == m[0].length) break;b = na(0 == h[1].length ? 0 : parseInt(h[1], 10), 0 == m[1].length ? 0 : parseInt(m[1], 10)) || na(0 == h[2].length, 0 == m[2].length) || na(h[2], m[2]);h = h[3];m = m[3];
        } while (0 == b);
      }return 0 <= b;
    });
  }var Va;var Wa = k.document;
  Va = Wa && z ? Pa() || ("CSS1Compat" == Wa.compatMode ? parseInt(Qa, 10) : 5) : void 0;var Xa = Object.freeze || function (a) {
    return a;
  };var Ya = !z || 9 <= Number(Va),
      Za = z && !Ua("9"),
      $a = function () {
    if (!k.addEventListener || !Object.defineProperty) return !1;var a = !1,
        b = Object.defineProperty({}, "passive", { get: function get() {
        a = !0;
      } });k.addEventListener("test", ba, b);k.removeEventListener("test", ba, b);return a;
  }();function A(a, b) {
    this.type = a;this.a = this.target = b;this.Qa = !0;
  }A.prototype.b = function () {
    this.Qa = !1;
  };function ab(a, b) {
    A.call(this, a ? a.type : "");this.relatedTarget = this.a = this.target = null;this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;this.key = "";this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.pointerId = 0;this.pointerType = "";this.c = null;if (a) {
      var c = this.type = a.type,
          d = a.changedTouches ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.a = b;if (b = a.relatedTarget) {
        if (Na) {
          a: {
            try {
              Ia(b.nodeName);var e = !0;break a;
            } catch (f) {}e = !1;
          }e || (b = null);
        }
      } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;null === d ? (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0);this.button = a.button;this.key = a.key || "";this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.pointerId = a.pointerId || 0;this.pointerType = l(a.pointerType) ? a.pointerType : bb[a.pointerType] || "";this.c = a;a.defaultPrevented && this.b();
    }
  }u(ab, A);var bb = Xa({ 2: "touch", 3: "pen", 4: "mouse" });ab.prototype.b = function () {
    ab.L.b.call(this);var a = this.c;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Za) try {
      if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
  };var cb = "closure_listenable_" + (1E6 * Math.random() | 0);function db(a) {
    return !(!a || !a[cb]);
  }var eb = 0;function fb(a, b, c, d, e) {
    this.listener = a;this.a = null;this.src = b;this.type = c;this.capture = !!d;this.ga = e;this.key = ++eb;this.Y = this.ca = !1;
  }function gb(a) {
    a.Y = !0;a.listener = null;a.a = null;a.src = null;a.ga = null;
  };function hb(a) {
    this.src = a;this.a = {};this.b = 0;
  }hb.prototype.add = function (a, b, c, d, e) {
    var f = a.toString();a = this.a[f];a || (a = this.a[f] = [], this.b++);var h = ib(a, b, d, e);-1 < h ? (b = a[h], c || (b.ca = !1)) : (b = new fb(b, this.src, f, !!d, e), b.ca = c, a.push(b));return b;
  };function jb(a, b) {
    var c = b.type;if (c in a.a) {
      var d = a.a[c],
          e = ta(d, b),
          f;(f = 0 <= e) && Array.prototype.splice.call(d, e, 1);f && (gb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
  }function kb(a, b, c, d, e) {
    a = a.a[b.toString()];b = -1;a && (b = ib(a, c, d, e));return -1 < b ? a[b] : null;
  }
  function ib(a, b, c, d) {
    for (var e = 0; e < a.length; ++e) {
      var f = a[e];if (!f.Y && f.listener == b && f.capture == !!c && f.ga == d) return e;
    }return -1;
  };var lb = "closure_lm_" + (1E6 * Math.random() | 0),
      mb = {},
      nb = 0;function ob(a, b, c, d, e) {
    if (d && d.once) return pb(a, b, c, d, e);if (n(b)) {
      for (var f = 0; f < b.length; f++) {
        ob(a, b[f], c, d, e);
      }return null;
    }c = qb(c);return db(a) ? a.aa(b, c, p(d) ? !!d.capture : !!d, e) : rb(a, b, c, !1, d, e);
  }
  function rb(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");var h = p(e) ? !!e.capture : !!e,
        m = sb(a);m || (a[lb] = m = new hb(a));c = m.add(b, c, d, h, f);if (c.a) return c;d = tb();c.a = d;d.src = a;d.listener = c;if (a.addEventListener) $a || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(ub(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");nb++;return c;
  }
  function tb() {
    var a = vb,
        b = Ya ? function (c) {
      return a.call(b.src, b.listener, c);
    } : function (c) {
      c = a.call(b.src, b.listener, c);if (!c) return c;
    };return b;
  }function pb(a, b, c, d, e) {
    if (n(b)) {
      for (var f = 0; f < b.length; f++) {
        pb(a, b[f], c, d, e);
      }return null;
    }c = qb(c);return db(a) ? a.Ia(b, c, p(d) ? !!d.capture : !!d, e) : rb(a, b, c, !0, d, e);
  }function wb(a, b, c, d, e) {
    if (n(b)) for (var f = 0; f < b.length; f++) {
      wb(a, b[f], c, d, e);
    } else d = p(d) ? !!d.capture : !!d, c = qb(c), db(a) ? a.wa(b, c, d, e) : a && (a = sb(a)) && (b = kb(a, b, c, d, e)) && xb(b);
  }
  function xb(a) {
    if ("number" != typeof a && a && !a.Y) {
      var b = a.src;if (db(b)) jb(b.c, a);else {
        var c = a.type,
            d = a.a;b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(ub(c), d) : b.addListener && b.removeListener && b.removeListener(d);nb--;(c = sb(b)) ? (jb(c, a), 0 == c.b && (c.src = null, b[lb] = null)) : gb(a);
      }
    }
  }function ub(a) {
    return a in mb ? mb[a] : mb[a] = "on" + a;
  }
  function yb(a, b, c, d) {
    var e = !0;if (a = sb(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
      var f = b[a];f && f.capture == c && !f.Y && (f = zb(f, d), e = e && !1 !== f);
    }return e;
  }function zb(a, b) {
    var c = a.listener,
        d = a.ga || a.src;a.ca && xb(a);return c.call(d, b);
  }
  function vb(a, b) {
    if (a.Y) return !0;if (!Ya) {
      if (!b) a: {
        b = ["window", "event"];for (var c = k, d = 0; d < b.length; d++) {
          if (c = c[b[d]], null == c) {
            b = null;break a;
          }
        }b = c;
      }d = b;b = new ab(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
        a: {
          var e = !1;if (0 == d.keyCode) try {
            d.keyCode = -1;break a;
          } catch (h) {
            e = !0;
          }if (e || void 0 == d.returnValue) d.returnValue = !0;
        }d = [];for (e = b.a; e; e = e.parentNode) {
          d.push(e);
        }a = a.type;for (e = d.length - 1; 0 <= e; e--) {
          b.a = d[e];var f = yb(d[e], a, !0, b);c = c && f;
        }for (e = 0; e < d.length; e++) {
          b.a = d[e], f = yb(d[e], a, !1, b), c = c && f;
        }
      }return c;
    }return zb(a, new ab(b, this));
  }function sb(a) {
    a = a[lb];return a instanceof hb ? a : null;
  }var Ab = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);function qb(a) {
    if (ea(a)) return a;a[Ab] || (a[Ab] = function (b) {
      return a.handleEvent(b);
    });return a[Ab];
  };function B() {
    w.call(this);this.c = new hb(this);this.P = this;this.J = null;
  }u(B, w);B.prototype[cb] = !0;g = B.prototype;g.addEventListener = function (a, b, c, d) {
    ob(this, a, b, c, d);
  };g.removeEventListener = function (a, b, c, d) {
    wb(this, a, b, c, d);
  };
  g.dispatchEvent = function (a) {
    var b,
        c = this.J;if (c) for (b = []; c; c = c.J) {
      b.push(c);
    }c = this.P;var d = a.type || a;if (l(a)) a = new A(a, c);else if (a instanceof A) a.target = a.target || c;else {
      var e = a;a = new A(d, c);Ha(a, e);
    }e = !0;if (b) for (var f = b.length - 1; 0 <= f; f--) {
      var h = a.a = b[f];e = Bb(h, d, !0, a) && e;
    }h = a.a = c;e = Bb(h, d, !0, a) && e;e = Bb(h, d, !1, a) && e;if (b) for (f = 0; f < b.length; f++) {
      h = a.a = b[f], e = Bb(h, d, !1, a) && e;
    }return e;
  };
  g.w = function () {
    B.L.w.call(this);if (this.c) {
      var a = this.c,
          b = 0,
          c;for (c in a.a) {
        for (var d = a.a[c], e = 0; e < d.length; e++) {
          ++b, gb(d[e]);
        }delete a.a[c];a.b--;
      }
    }this.J = null;
  };g.aa = function (a, b, c, d) {
    return this.c.add(String(a), b, !1, c, d);
  };g.Ia = function (a, b, c, d) {
    return this.c.add(String(a), b, !0, c, d);
  };g.wa = function (a, b, c, d) {
    var e = this.c;a = String(a).toString();if (a in e.a) {
      var f = e.a[a];b = ib(f, b, c, d);-1 < b ? (gb(f[b]), Array.prototype.splice.call(f, b, 1), 0 == f.length && (delete e.a[a], e.b--), e = !0) : e = !1;
    } else e = !1;return e;
  };
  function Bb(a, b, c, d) {
    b = a.c.a[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
      var h = b[f];if (h && !h.Y && h.capture == c) {
        var m = h.listener,
            v = h.ga || h.src;h.ca && jb(a.c, h);e = !1 !== m.call(v, d) && e;
      }
    }return e && 0 != d.Qa;
  };function Cb(a) {
    return (/^\s*$/.test(a) ? !1 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""))
    );
  }function Db(a) {
    a = String(a);if (Cb(a)) try {
      return eval("(" + a + ")");
    } catch (b) {}throw Error("Invalid JSON string: " + a);
  }function Eb(a) {
    var b = [];Fb(new Gb(), a, b);return b.join("");
  }function Gb() {}
  function Fb(a, b, c) {
    if (null == b) c.push("null");else {
      if ("object" == typeof b) {
        if (n(b)) {
          var d = b;b = d.length;c.push("[");for (var e = "", f = 0; f < b; f++) {
            c.push(e), Fb(a, d[f], c), e = ",";
          }c.push("]");return;
        }if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
          c.push("{");e = "";for (d in b) {
            Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), Hb(d, c), c.push(":"), Fb(a, f, c), e = ","));
          }c.push("}");return;
        }
      }switch (typeof b) {case "string":
          Hb(b, c);break;case "number":
          c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");break;case "boolean":
          c.push(String(b));break;case "function":
          c.push("null");break;default:
          throw Error("Unknown type: " + typeof b);}
    }
  }var Ib = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
      Jb = /\uffff/.test("\uFFFF") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
  function Hb(a, b) {
    b.push('"', a.replace(Jb, function (a) {
      var b = Ib[a];b || (b = "\\u" + (a.charCodeAt(0) | 65536).toString(16).substr(1), Ib[a] = b);return b;
    }), '"');
  };function Kb(a, b, c) {
    this.f = c;this.c = a;this.g = b;this.b = 0;this.a = null;
  }Kb.prototype.get = function () {
    if (0 < this.b) {
      this.b--;var a = this.a;this.a = a.next;a.next = null;
    } else a = this.c();return a;
  };function Lb() {
    this.b = this.a = null;
  }var C = new Kb(function () {
    return new Mb();
  }, function (a) {
    a.reset();
  }, 100);Lb.prototype.add = function (a, b) {
    var c = C.get();c.set(a, b);this.b ? this.b.next = c : this.a = c;this.b = c;
  };function Ob() {
    var a = Pb,
        b = null;a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);return b;
  }function Mb() {
    this.next = this.b = this.a = null;
  }Mb.prototype.set = function (a, b) {
    this.a = a;this.b = b;this.next = null;
  };Mb.prototype.reset = function () {
    this.next = this.b = this.a = null;
  };function Qb(a) {
    k.setTimeout(function () {
      throw a;
    }, 0);
  }var Rb;
  function Sb() {
    var a = k.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function a() {
      var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow;a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
          d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host;a = r(function (a) {
        if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
      }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
          b.postMessage(c, d);
        } };
    });if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
      var b = new a(),
          c = {},
          d = c;b.port1.onmessage = function () {
        if (void 0 !== c.next) {
          c = c.next;var a = c.Ba;c.Ba = null;a();
        }
      };return function (a) {
        d.next = { Ba: a };d = d.next;b.port2.postMessage(0);
      };
    }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
      var b = document.createElement("SCRIPT");
      b.onreadystatechange = function () {
        b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
      };document.documentElement.appendChild(b);
    } : function (a) {
      k.setTimeout(a, 0);
    };
  };var Tb;function Ub() {
    if (-1 != String(k.Promise).indexOf("[native code]")) {
      var a = k.Promise.resolve(void 0);Tb = function Tb() {
        a.then(Vb);
      };
    } else Tb = function Tb() {
      var a = Vb;!ea(k.setImmediate) || k.Window && k.Window.prototype && !y("Edge") && k.Window.prototype.setImmediate == k.setImmediate ? (Rb || (Rb = Sb()), Rb(a)) : k.setImmediate(a);
    };
  }var Wb = !1,
      Pb = new Lb();function Vb() {
    for (var a; a = Ob();) {
      try {
        a.a.call(a.b);
      } catch (b) {
        Qb(b);
      }C.g(a);C.b < C.f && (C.b++, a.next = C.a, C.a = a);
    }Wb = !1;
  };function Xb(a, b) {
    B.call(this);this.b = a || 1;this.a = b || k;this.f = r(this.jb, this);this.g = t();
  }u(Xb, B);g = Xb.prototype;g.$ = !1;g.K = null;g.jb = function () {
    if (this.$) {
      var a = t() - this.g;0 < a && a < .8 * this.b ? this.K = this.a.setTimeout(this.f, this.b - a) : (this.K && (this.a.clearTimeout(this.K), this.K = null), this.dispatchEvent("tick"), this.$ && (this.K = this.a.setTimeout(this.f, this.b), this.g = t()));
    }
  };g.start = function () {
    this.$ = !0;this.K || (this.K = this.a.setTimeout(this.f, this.b), this.g = t());
  };
  function Yb(a) {
    a.$ = !1;a.K && (a.a.clearTimeout(a.K), a.K = null);
  }g.w = function () {
    Xb.L.w.call(this);Yb(this);delete this.a;
  };function Zb(a, b, c) {
    if (ea(a)) c && (a = r(a, c));else if (a && "function" == typeof a.handleEvent) a = r(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
  };function $b(a, b, c) {
    w.call(this);this.f = null != c ? r(a, c) : a;this.c = b;this.b = r(this.cb, this);this.a = [];
  }u($b, w);g = $b.prototype;g.ha = !1;g.X = null;g.Ya = function (a) {
    this.a = arguments;this.X ? this.ha = !0 : ac(this);
  };g.w = function () {
    $b.L.w.call(this);this.X && (k.clearTimeout(this.X), this.X = null, this.ha = !1, this.a = []);
  };g.cb = function () {
    this.X = null;this.ha && (this.ha = !1, ac(this));
  };function ac(a) {
    a.X = Zb(a.b, a.c);a.f.apply(null, a.a);
  };function D(a) {
    w.call(this);this.b = a;this.a = {};
  }u(D, w);var bc = [];D.prototype.aa = function (a, b, c, d) {
    n(b) || (b && (bc[0] = b.toString()), b = bc);for (var e = 0; e < b.length; e++) {
      var f = ob(a, b[e], c || this.handleEvent, d || !1, this.b || this);if (!f) break;this.a[f.key] = f;
    }return this;
  };
  D.prototype.wa = function (a, b, c, d, e) {
    if (n(b)) for (var f = 0; f < b.length; f++) {
      this.wa(a, b[f], c, d, e);
    } else c = c || this.handleEvent, d = p(d) ? !!d.capture : !!d, e = e || this.b || this, c = qb(c), d = !!d, b = db(a) ? kb(a.c, String(b), c, d, e) : a ? (a = sb(a)) ? kb(a, b, c, d, e) : null : null, b && (xb(b), delete this.a[b.key]);return this;
  };function cc(a) {
    Ca(a.a, function (a, c) {
      this.a.hasOwnProperty(c) && xb(a);
    }, a);a.a = {};
  }D.prototype.w = function () {
    D.L.w.call(this);cc(this);
  };
  D.prototype.handleEvent = function () {
    throw Error("EventHandler.handleEvent not implemented");
  };function dc(a, b, c, d, e) {
    this.reset(a, b, c, d, e);
  }dc.prototype.a = null;var ec = 0;dc.prototype.reset = function (a, b, c, d, e) {
    "number" == typeof e || ec++;d || t();delete this.a;
  };function fc(a) {
    this.f = a;this.b = this.c = this.a = null;
  }function E(a, b) {
    this.name = a;this.value = b;
  }E.prototype.toString = function () {
    return this.name;
  };var gc = new E("SEVERE", 1E3),
      hc = new E("WARNING", 900),
      ic = new E("INFO", 800),
      jc = new E("CONFIG", 700),
      kc = new E("FINE", 500);function lc(a) {
    if (a.c) return a.c;if (a.a) return lc(a.a);pa("Root logger has no level set.");return null;
  }fc.prototype.log = function (a, b, c) {
    if (a.value >= lc(this).value) for (ea(b) && (b = b()), a = new dc(a, String(b), this.f), c && (a.a = c), c = this; c;) {
      c = c.a;
    }
  };
  var mc = {},
      nc = null;function oc(a) {
    nc || (nc = new fc(""), mc[""] = nc, nc.c = jc);var b;if (!(b = mc[a])) {
      b = new fc(a);var c = a.lastIndexOf("."),
          d = a.substr(c + 1);c = oc(a.substr(0, c));c.b || (c.b = {});c.b[d] = b;b.a = c;mc[a] = b;
    }return b;
  };function F(a, b) {
    a && a.log(hc, b, void 0);
  }function pc(a, b) {
    a && a.log(ic, b, void 0);
  }function H(a, b) {
    a && a.log(kc, b, void 0);
  };function qc() {
    this.a = oc("goog.labs.net.webChannel.WebChannelDebug");this.b = !0;
  }qc.prototype.Fa = function () {
    this.b = !1;
  };function rc(a, b, c, d, e, f) {
    I(a, function () {
      if (a.b) {
        if (f) {
          var h = "";for (var m = f.split("&"), v = 0; v < m.length; v++) {
            var G = m[v].split("=");if (1 < G.length) {
              var aa = G[0];G = G[1];var Nb = aa.split("_");h = 2 <= Nb.length && "type" == Nb[1] ? h + (aa + "=" + G + "&") : h + (aa + "=redacted&");
            }
          }
        } else h = null;
      } else h = f;return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
  }
  function sc(a, b, c, d, e, f, h) {
    I(a, function () {
      return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
  }function tc(a, b, c, d) {
    I(a, function () {
      return "XMLHTTP TEXT (" + b + "): " + uc(a, c) + (d ? " " + d : "");
    });
  }function vc(a, b) {
    I(a, function () {
      return "TIMEOUT: " + b;
    });
  }function J(a, b) {
    H(a.a, b);
  }function wc(a, b, c) {
    (a = a.a) && a.log(gc, c || "Exception", b);
  }function I(a, b) {
    pc(a.a, b);
  }function xc(a, b) {
    (a = a.a) && a.log(gc, b, void 0);
  }
  function uc(a, b) {
    if (!a.b) return b;if (!b) return null;try {
      var c = JSON.parse(b);if (c) for (var d = 0; d < c.length; d++) {
        if (n(c[d])) {
          var e = c[d];if (!(2 > e.length)) {
            var f = e[1];if (n(f) && !(1 > f.length)) {
              var h = f[0];if ("noop" != h && "stop" != h && "close" != h) for (var m = 1; m < f.length; m++) {
                f[m] = "";
              }
            }
          }
        }
      }return Eb(c);
    } catch (v) {
      return J(a, "Exception parsing expected JS array - probably was not JS"), b;
    }
  };var yc = new B();function zc(a) {
    A.call(this, "serverreachability", a);
  }u(zc, A);function Ac() {
    yc.dispatchEvent(new zc(yc));
  }function Bc(a) {
    A.call(this, "statevent", a);
  }u(Bc, A);function K() {
    yc.dispatchEvent(new Bc(yc));
  }function Cc(a) {
    A.call(this, "timingevent", a);
  }u(Cc, A);function Dc() {
    yc.dispatchEvent(new Cc(yc));
  }function Ec(a, b) {
    if (!ea(a)) throw Error("Fn must not be null and must be a function");return k.setTimeout(function () {
      a();
    }, b);
  };var Fc = { NO_ERROR: 0, kb: 1, rb: 2, qb: 3, nb: 4, pb: 5, sb: 6, Sa: 7, TIMEOUT: 8, vb: 9 };var Gc = { mb: "complete", zb: "success", Ta: "error", Sa: "abort", xb: "ready", yb: "readystatechange", TIMEOUT: "timeout", tb: "incrementaldata", wb: "progress", ob: "downloadprogress", Ab: "uploadprogress" };function Hc() {}Hc.prototype.a = null;function Ic(a) {
    var b;(b = a.a) || (b = {}, Jc(a) && (b[0] = !0, b[1] = !0), b = a.a = b);return b;
  };var Kc;function Lc() {}u(Lc, Hc);function Mc(a) {
    return (a = Jc(a)) ? new ActiveXObject(a) : new XMLHttpRequest();
  }function Jc(a) {
    if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
      for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
        var d = b[c];try {
          return new ActiveXObject(d), a.b = d;
        } catch (e) {}
      }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }return a.b;
  }Kc = new Lc();function L(a, b, c, d, e) {
    this.i = a;this.b = b;this.f = d;this.T = e || 1;this.N = new D(this);this.S = Nc;a = this.H = new Xb();a.b = Oc;a.K && a.$ ? (Yb(a), a.start()) : a.K && Yb(a);this.j = null;this.c = !1;this.G = this.g = this.h = this.J = this.C = this.U = this.s = null;this.o = [];this.a = null;this.D = 0;this.l = this.m = null;this.B = -1;this.A = !1;this.P = 0;this.I = null;this.M = !1;
  }var Nc = 45E3,
      Oc = 250;
  function Pc(a, b) {
    switch (a) {case 0:
        return "Non-200 return code (" + b + ")";case 1:
        return "XMLHTTP failure (no data)";case 2:
        return "HttpConnection timeout";default:
        return "Unknown error";}
  }var Qc = {},
      Rc = {};g = L.prototype;g.setTimeout = function (a) {
    this.S = a;
  };function Sc(a, b, c) {
    a.J = 1;a.h = Tc(M(b));a.G = c;a.M = !0;Uc(a, null);
  }function Vc(a, b, c, d) {
    a.J = 1;a.h = Tc(M(b));a.G = null;a.M = c;Uc(a, d);
  }
  function Uc(a, b) {
    a.C = t();Wc(a);a.g = M(a.h);Xc(a.g, "t", a.T);a.D = 0;a.a = a.i.da(a.i.ia() ? b : null);0 < a.P && (a.I = new $b(r(a.Ra, a, a.a), a.P));a.N.aa(a.a, "readystatechange", a.gb);b = a.j ? Fa(a.j) : {};a.G ? (a.m || (a.m = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.fa(a.g, a.m, a.G, b)) : (a.m = "GET", a.a.fa(a.g, a.m, null, b));Ac();rc(a.b, a.m, a.g, a.f, a.T, a.G);
  }g.gb = function (a) {
    a = a.target;var b = this.I;b && 3 == N(a) ? (J(this.b, "Throttling readystatechange."), b.Ya()) : this.Ra(a);
  };
  g.Ra = function (a) {
    try {
      a == this.a ? Yc(this) : F(this.b.a, "Called back with an unexpected xmlhttp");
    } catch (c) {
      if (J(this.b, "Failed call to OnXmlHttpReadyStateChanged_"), this.a && this.a.V()) {
        var b = this;wc(this.b, c, function () {
          return "ResponseText: " + b.a.V();
        });
      } else wc(this.b, c, "No response text");
    } finally {}
  };
  function Yc(a) {
    var b = N(a.a),
        c = a.a.Ga();if (!(3 > b || 3 == b && !La && !a.a.V())) {
      a.A || 4 != b || 7 == c || Ac();Zc(a);var d = a.a.W();a.B = d;(c = a.a.V()) || J(a.b, function () {
        return "No response text for uri " + a.g + " status " + d;
      });a.c = 200 == d;sc(a.b, a.m, a.g, a.f, a.T, b, d);a.c ? (a.M ? ($c(a, b, c), La && a.c && 3 == b && ad(a)) : (tc(a.b, a.f, c, null), bd(a, c)), 4 == b && cd(a), a.c && !a.A && (4 == b ? a.i.va(a) : (a.c = !1, Wc(a)))) : (400 == d && 0 < c.indexOf("Unknown SID") ? (a.l = 3, K(), F(a.b.a, "XMLHTTP Unknown SID (" + a.f + ")")) : (a.l = 0, K(), F(a.b.a, "XMLHTTP Bad status " + d + " (" + a.f + ")")), cd(a), dd(a));
    }
  }function $c(a, b, c) {
    for (var d = !0; !a.A && a.D < c.length;) {
      var e = ed(a, c);if (e == Rc) {
        4 == b && (a.l = 4, K(), d = !1);tc(a.b, a.f, null, "[Incomplete Response]");break;
      } else if (e == Qc) {
        a.l = 4;K();tc(a.b, a.f, c, "[Invalid Chunk]");d = !1;break;
      } else tc(a.b, a.f, e, null), bd(a, e);
    }4 == b && 0 == c.length && (a.l = 1, K(), d = !1);a.c = a.c && d;d || (tc(a.b, a.f, c, "[Invalid Chunked Response]"), cd(a), dd(a));
  }g.fb = function () {
    var a = N(this.a),
        b = this.a.V();this.D < b.length && (Zc(this), $c(this, a, b), this.c && 4 != a && Wc(this));
  };
  function ad(a) {
    a.N.aa(a.H, "tick", a.fb);a.H.start();
  }function ed(a, b) {
    var c = a.D,
        d = b.indexOf("\n", c);if (-1 == d) return Rc;c = Number(b.substring(c, d));if (isNaN(c)) return Qc;d += 1;if (d + c > b.length) return Rc;b = b.substr(d, c);a.D = d + c;return b;
  }g.cancel = function () {
    this.A = !0;cd(this);
  };function Wc(a) {
    a.U = t() + a.S;fd(a, a.S);
  }function fd(a, b) {
    if (null != a.s) throw Error("WatchDog timer not null");a.s = Ec(r(a.eb, a), b);
  }function Zc(a) {
    a.s && (k.clearTimeout(a.s), a.s = null);
  }
  g.eb = function () {
    this.s = null;var a = t();0 <= a - this.U ? (this.c && xc(this.b, "Received watchdog timeout even though request loaded successfully"), vc(this.b, this.g), 2 != this.J && (Ac(), K()), cd(this), this.l = 2, dd(this)) : (F(this.b.a, "WatchDog timer called too early"), fd(this, this.U - a));
  };function dd(a) {
    a.i.Ka() || a.A || a.i.va(a);
  }function cd(a) {
    Zc(a);var b = a.I;b && "function" == typeof b.Z && b.Z();a.I = null;Yb(a.H);cc(a.N);a.a && (b = a.a, a.a = null, b.abort(), b.Z());
  }
  function bd(a, b) {
    try {
      a.i.Na(a, b), Ac();
    } catch (c) {
      wc(a.b, c, "Error in httprequest callback");
    }
  };function gd(a) {
    if (a.v && "function" == typeof a.v) return a.v();if (l(a)) return a.split("");if (da(a)) {
      for (var b = [], c = a.length, d = 0; d < c; d++) {
        b.push(a[d]);
      }return b;
    }return Da(a);
  }
  function hd(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (da(a) || l(a)) ua(a, b, void 0);else {
      if (a.O && "function" == typeof a.O) var c = a.O();else if (a.v && "function" == typeof a.v) c = void 0;else if (da(a) || l(a)) {
        c = [];for (var d = a.length, e = 0; e < d; e++) {
          c.push(e);
        }
      } else c = Ea(a);d = gd(a);e = d.length;for (var f = 0; f < e; f++) {
        b.call(void 0, d[f], c && c[f], a);
      }
    }
  };function O(a, b) {
    this.b = {};this.a = [];this.c = 0;var c = arguments.length;if (1 < c) {
      if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
        this.set(arguments[d], arguments[d + 1]);
      }
    } else if (a) {
      a instanceof O ? (c = a.O(), d = a.v()) : (c = Ea(a), d = Da(a));for (var e = 0; e < c.length; e++) {
        this.set(c[e], d[e]);
      }
    }
  }g = O.prototype;g.u = function () {
    return this.c;
  };g.v = function () {
    id(this);for (var a = [], b = 0; b < this.a.length; b++) {
      a.push(this.b[this.a[b]]);
    }return a;
  };g.O = function () {
    id(this);return this.a.concat();
  };
  function jd(a) {
    a.b = {};a.a.length = 0;a.c = 0;
  }function kd(a, b) {
    return P(a.b, b) ? (delete a.b[b], a.c--, a.a.length > 2 * a.c && id(a), !0) : !1;
  }function id(a) {
    if (a.c != a.a.length) {
      for (var b = 0, c = 0; b < a.a.length;) {
        var d = a.a[b];P(a.b, d) && (a.a[c++] = d);b++;
      }a.a.length = c;
    }if (a.c != a.a.length) {
      var e = {};for (c = b = 0; b < a.a.length;) {
        d = a.a[b], P(e, d) || (a.a[c++] = d, e[d] = 1), b++;
      }a.a.length = c;
    }
  }g.get = function (a, b) {
    return P(this.b, a) ? this.b[a] : b;
  };g.set = function (a, b) {
    P(this.b, a) || (this.c++, this.a.push(a));this.b[a] = b;
  };
  g.forEach = function (a, b) {
    for (var c = this.O(), d = 0; d < c.length; d++) {
      var e = c[d],
          f = this.get(e);a.call(b, f, e, this);
    }
  };function P(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  };var ld = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function md(a, b) {
    if (a) {
      a = a.split("&");for (var c = 0; c < a.length; c++) {
        var d = a[c].indexOf("="),
            e = null;if (0 <= d) {
          var f = a[c].substring(0, d);e = a[c].substring(d + 1);
        } else f = a[c];b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
      }
    }
  };function Q(a, b) {
    this.b = this.j = this.f = "";this.i = null;this.g = this.a = "";this.h = !1;var c;a instanceof Q ? (this.h = void 0 !== b ? b : a.h, nd(this, a.f), this.j = a.j, od(this, a.b), pd(this, a.i), this.a = a.a, qd(this, rd(a.c)), this.g = a.g) : a && (c = String(a).match(ld)) ? (this.h = !!b, nd(this, c[1] || "", !0), this.j = sd(c[2] || ""), od(this, c[3] || "", !0), pd(this, c[4]), this.a = sd(c[5] || "", !0), qd(this, c[6] || "", !0), this.g = sd(c[7] || "")) : (this.h = !!b, this.c = new td(null, 0, this.h));
  }
  Q.prototype.toString = function () {
    var a = [],
        b = this.f;b && a.push(ud(b, vd, !0), ":");var c = this.b;if (c || "file" == b) a.push("//"), (b = this.j) && a.push(ud(b, vd, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.i, null != c && a.push(":", String(c));if (c = this.a) this.b && "/" != c.charAt(0) && a.push("/"), a.push(ud(c, "/" == c.charAt(0) ? wd : xd, !0));(c = this.c.toString()) && a.push("?", c);(c = this.g) && a.push("#", ud(c, yd));return a.join("");
  };
  Q.prototype.resolve = function (a) {
    var b = M(this),
        c = !!a.f;c ? nd(b, a.f) : c = !!a.j;c ? b.j = a.j : c = !!a.b;c ? od(b, a.b) : c = null != a.i;var d = a.a;if (c) pd(b, a.i);else if (c = !!a.a) {
      if ("/" != d.charAt(0)) if (this.b && !this.a) d = "/" + d;else {
        var e = b.a.lastIndexOf("/");-1 != e && (d = b.a.substr(0, e + 1) + d);
      }e = d;if (".." == e || "." == e) d = "";else if (-1 != e.indexOf("./") || -1 != e.indexOf("/.")) {
        d = 0 == e.lastIndexOf("/", 0);e = e.split("/");for (var f = [], h = 0; h < e.length;) {
          var m = e[h++];"." == m ? d && h == e.length && f.push("") : ".." == m ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && h == e.length && f.push("")) : (f.push(m), d = !0);
        }d = f.join("/");
      } else d = e;
    }c ? b.a = d : c = "" !== a.c.toString();c ? qd(b, rd(a.c)) : c = !!a.g;c && (b.g = a.g);return b;
  };function M(a) {
    return new Q(a);
  }function nd(a, b, c) {
    a.f = c ? sd(b, !0) : b;a.f && (a.f = a.f.replace(/:$/, ""));
  }function od(a, b, c) {
    a.b = c ? sd(b, !0) : b;
  }function pd(a, b) {
    if (b) {
      b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.i = b;
    } else a.i = null;
  }function qd(a, b, c) {
    b instanceof td ? (a.c = b, zd(a.c, a.h)) : (c || (b = ud(b, Ad)), a.c = new td(b, 0, a.h));
  }
  function R(a, b, c) {
    a.c.set(b, c);
  }function Xc(a, b, c) {
    n(c) || (c = [String(c)]);Bd(a.c, b, c);
  }function Tc(a) {
    R(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ t()).toString(36));return a;
  }function Cd(a) {
    return a instanceof Q ? M(a) : new Q(a, void 0);
  }function Dd(a, b, c, d) {
    var e = new Q(null, void 0);a && nd(e, a);b && od(e, b);c && pd(e, c);d && (e.a = d);return e;
  }function sd(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
  }
  function ud(a, b, c) {
    return l(a) ? (a = encodeURI(a).replace(b, Ed), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
  }function Ed(a) {
    a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
  }var vd = /[#\/\?@]/g,
      xd = /[#\?:]/g,
      wd = /[#\?]/g,
      Ad = /[#\?@]/g,
      yd = /#/g;function td(a, b, c) {
    this.b = this.a = null;this.c = a || null;this.f = !!c;
  }function S(a) {
    a.a || (a.a = new O(), a.b = 0, a.c && md(a.c, function (b, c) {
      a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
  }g = td.prototype;g.u = function () {
    S(this);return this.b;
  };
  g.add = function (a, b) {
    S(this);this.c = null;a = Fd(this, a);var c = this.a.get(a);c || this.a.set(a, c = []);c.push(b);this.b += 1;return this;
  };function Gd(a, b) {
    S(a);b = Fd(a, b);P(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, kd(a.a, b));
  }function Hd(a, b) {
    S(a);b = Fd(a, b);return P(a.a.b, b);
  }g.forEach = function (a, b) {
    S(this);this.a.forEach(function (c, d) {
      ua(c, function (c) {
        a.call(b, c, d, this);
      }, this);
    }, this);
  };
  g.O = function () {
    S(this);for (var a = this.a.v(), b = this.a.O(), c = [], d = 0; d < b.length; d++) {
      for (var e = a[d], f = 0; f < e.length; f++) {
        c.push(b[d]);
      }
    }return c;
  };g.v = function (a) {
    S(this);var b = [];if (l(a)) Hd(this, a) && (b = ya(b, this.a.get(Fd(this, a))));else {
      a = this.a.v();for (var c = 0; c < a.length; c++) {
        b = ya(b, a[c]);
      }
    }return b;
  };g.set = function (a, b) {
    S(this);this.c = null;a = Fd(this, a);Hd(this, a) && (this.b -= this.a.get(a).length);this.a.set(a, [b]);this.b += 1;return this;
  };g.get = function (a, b) {
    a = a ? this.v(a) : [];return 0 < a.length ? String(a[0]) : b;
  };
  function Bd(a, b, c) {
    Gd(a, b);0 < c.length && (a.c = null, a.a.set(Fd(a, b), za(c)), a.b += c.length);
  }g.toString = function () {
    if (this.c) return this.c;if (!this.a) return "";for (var a = [], b = this.a.O(), c = 0; c < b.length; c++) {
      var d = b[c],
          e = encodeURIComponent(String(d));d = this.v(d);for (var f = 0; f < d.length; f++) {
        var h = e;"" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));a.push(h);
      }
    }return this.c = a.join("&");
  };function rd(a) {
    var b = new td();b.c = a.c;a.a && (b.a = new O(a.a), b.b = a.b);return b;
  }
  function Fd(a, b) {
    b = String(b);a.f && (b = b.toLowerCase());return b;
  }function zd(a, b) {
    b && !a.f && (S(a), a.c = null, a.a.forEach(function (a, b) {
      var c = b.toLowerCase();b != c && (Gd(this, b), Bd(this, c, a));
    }, a));a.f = b;
  };function Id() {
    this.a = t();
  }var Jd = null;Id.prototype.set = function (a) {
    this.a = a;
  };Id.prototype.reset = function () {
    this.set(t());
  };Id.prototype.get = function () {
    return this.a;
  };function Kd() {
    Jd || (Jd = new Id());
  }function Ld() {
    Jd || (Jd = new Id());
  }u(Ld, Kd);function Md() {}var Nd = { OPEN: "a", lb: "b", Ta: "c", ub: "d" };function Od() {
    A.call(this, "d");
  }u(Od, A);function Pd() {
    A.call(this, "c");
  }u(Pd, A);function Qd(a, b) {
    this.a = a;this.b = b;this.c = this.i = null;this.h = !1;this.l = null;this.f = -1;this.m = this.g = null;
  }g = Qd.prototype;g.R = null;
  function Rd(a) {
    J(a.b, "TestConnection: starting stage 2");var b = a.a.H.a;if (null != b) J(a.b, function () {
      return  true ? "Buffered" : "Unbuffered";
    }), K(), b ? (K(), Sd(a.a, a, !1)) : (K(), Sd(a.a, a, !0));else {
      a.c = new L(a, a.b, 0, void 0, void 0);a.c.j = a.i;var c = Td(a.a, a.g, a.l);K();Xc(c, "TYPE", "xmlhttp");var d = a.a.j,
          e = a.a.J;d && e && R(c, d, e);Vc(a.c, c, !1, a.g);
    }
  }g.da = function (a) {
    return this.a.da(a);
  };g.abort = function () {
    this.c && (this.c.cancel(), this.c = null);this.f = -1;
  };g.Ka = function () {
    return !1;
  };
  g.Na = function (a, b) {
    this.f = a.B;if (0 == this.R) {
      J(this.b, "TestConnection: Got data for stage 1");if (!this.a.G && (a = a.a)) {
        var c = a.a ? a.a.getResponseHeader("X-Client-Wire-Protocol") : null;this.m = c ? c : null;this.a.j && ((a = a.a ? a.a.getResponseHeader("X-HTTP-Session-Id") : null) ? this.a.J = a : F(this.b.a, "Missing X_HTTP_SESSION_ID in the handshake response"));
      }if (b) {
        try {
          var d = this.a.ma.a.parse(b);
        } catch (e) {
          wc(this.b, e);Ud(this.a, this);return;
        }this.g = d[0];
      } else J(this.b, "TestConnection: Null responseText"), Ud(this.a, this);
    } else if (1 == this.R) if (this.h) K();else if ("11111" == b) {
      if (K(), this.h = !0, !z || 10 <= Number(Va)) this.f = 200, this.c.cancel(), J(this.b, "Test connection succeeded; using streaming connection"), K(), Sd(this.a, this, !0);
    } else K(), this.h = !1;
  };
  g.va = function () {
    this.f = this.c.B;this.c.c ? 0 == this.R ? (this.R = 1, J(this.b, "TestConnection: request complete for initial check"), Rd(this)) : 1 == this.R && (J(this.b, "TestConnection: request complete for stage 2"), this.h ? (J(this.b, "Test connection succeeded; using streaming connection"), K(), Sd(this.a, this, !0)) : (J(this.b, "Test connection failed; not using streaming"), K(), Sd(this.a, this, !1))) : (J(this.b, "TestConnection: request failed, in state " + this.R), 0 == this.R ? K() : 1 == this.R && K(), Ud(this.a, this));
  };g.ia = function () {
    return this.a.ia();
  };
  g.sa = function () {
    return this.a.sa();
  };function Vd() {
    this.a = this.b = null;
  };function T(a) {
    this.a = new O();if (a) {
      a = gd(a);for (var b = a.length, c = 0; c < b; c++) {
        this.add(a[c]);
      }
    }
  }function Wd(a) {
    var b = typeof a;return "object" == b && a || "function" == b ? "o" + (a[q] || (a[q] = ++fa)) : b.charAt(0) + a;
  }T.prototype.u = function () {
    return this.a.u();
  };T.prototype.add = function (a) {
    this.a.set(Wd(a), a);
  };T.prototype.contains = function (a) {
    a = Wd(a);return P(this.a.b, a);
  };T.prototype.v = function () {
    return this.a.v();
  };function Xd(a, b) {
    this.a = a;this.b = b;
  };function Yd(a) {
    this.g = a || Zd;this.f = k.qa && k.qa.La && k.qa.La() && k.qa.La().Cb ? this.g : 1;this.a = null;1 < this.f && (this.a = new T());this.b = null;this.c = [];
  }var Zd = 10;function $d(a, b) {
    a.a || -1 == b.indexOf("spdy") && -1 == b.indexOf("quic") && -1 == b.indexOf("h2") || (a.f = a.g, a.a = new T(), a.b && (ae(a, a.b), a.b = null));
  }function be(a) {
    return a.b ? !0 : a.a ? a.a.u() >= a.f : !1;
  }function ce(a, b) {
    return a.b ? a.b == b : a.a ? a.a.contains(b) : !1;
  }function ae(a, b) {
    a.a ? a.a.add(b) : a.b = b;
  }
  function de(a, b) {
    a.b && a.b == b ? a.b = null : a.a && a.a.contains(b) && kd(a.a.a, Wd(b));
  }Yd.prototype.cancel = function () {
    this.c = ee(this);this.b ? (this.b.cancel(), this.b = null) : this.a && 0 != this.a.a.c && (ua(this.a.v(), function (a) {
      a.cancel();
    }), jd(this.a.a));
  };function ee(a) {
    if (null != a.b) return a.c.concat(a.b.o);if (null != a.a && 0 != a.a.a.c) {
      var b = a.c;ua(a.a.v(), function (a) {
        b = b.concat(a.o);
      });return b;
    }return za(a.c);
  }function fe(a, b) {
    a.c = a.c.concat(b);
  };function ge(a, b) {
    this.a = a;this.b = b;
  }ge.prototype.stringify = function (a) {
    return k.JSON.stringify(a, this.a);
  };ge.prototype.parse = function (a) {
    return k.JSON.parse(a, this.b);
  };function he() {
    this.a = new ge();
  }function ie(a, b, c) {
    var d = c || "";try {
      hd(a, function (a, c) {
        var e = a;p(a) && (e = Eb(a));b.push(d + c + "=" + encodeURIComponent(e));
      });
    } catch (e) {
      throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
  };function je(a, b) {
    var c = new qc();J(c, "TestLoadImage: loading " + a);var d = new Image();d.onload = ja(ke, c, d, "TestLoadImage: loaded", !0, b);d.onerror = ja(ke, c, d, "TestLoadImage: error", !1, b);d.onabort = ja(ke, c, d, "TestLoadImage: abort", !1, b);d.ontimeout = ja(ke, c, d, "TestLoadImage: timeout", !1, b);k.setTimeout(function () {
      if (d.ontimeout) d.ontimeout();
    }, 1E4);d.src = a;
  }function ke(a, b, c, d, e) {
    try {
      J(a, c), b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {
      wc(a, f);
    }
  };function U(a) {
    B.call(this);this.headers = new O();this.D = a || null;this.f = !1;this.C = this.a = null;this.M = this.s = "";this.j = 0;this.g = "";this.h = this.I = this.o = this.H = !1;this.l = 0;this.B = null;this.N = le;this.G = this.m = !1;
  }u(U, B);var le = "";U.prototype.b = oc("goog.net.XhrIo");var me = /^https?$/i,
      ne = ["POST", "PUT"];g = U.prototype;
  g.fa = function (a, b, c, d) {
    if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.s + "; newUri=" + a);b = b ? b.toUpperCase() : "GET";this.s = a;this.g = "";this.j = 0;this.M = b;this.H = !1;this.f = !0;this.a = this.D ? Mc(this.D) : Mc(Kc);this.C = this.D ? Ic(this.D) : Ic(Kc);this.a.onreadystatechange = r(this.Ma, this);try {
      H(this.b, V(this, "Opening Xhr")), this.I = !0, this.a.open(b, String(a), !0), this.I = !1;
    } catch (f) {
      H(this.b, V(this, "Error opening Xhr: " + f.message));oe(this, f);return;
    }a = c || "";var e = new O(this.headers);
    d && hd(d, function (a, b) {
      e.set(b, a);
    });d = va(e.O());c = k.FormData && a instanceof k.FormData;!(0 <= ta(ne, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");e.forEach(function (a, b) {
      this.a.setRequestHeader(b, a);
    }, this);this.N && (this.a.responseType = this.N);"withCredentials" in this.a && this.a.withCredentials !== this.m && (this.a.withCredentials = this.m);try {
      pe(this), 0 < this.l && (this.G = qe(this.a), H(this.b, V(this, "Will abort after " + this.l + "ms if incomplete, xhr2 " + this.G)), this.G ? (this.a.timeout = this.l, this.a.ontimeout = r(this.Ja, this)) : this.B = Zb(this.Ja, this.l, this)), H(this.b, V(this, "Sending request")), this.o = !0, this.a.send(a), this.o = !1;
    } catch (f) {
      H(this.b, V(this, "Send error: " + f.message)), oe(this, f);
    }
  };function qe(a) {
    return z && Ua(9) && "number" == typeof a.timeout && void 0 !== a.ontimeout;
  }function wa(a) {
    return "content-type" == a.toLowerCase();
  }
  g.Ja = function () {
    "undefined" != typeof goog && this.a && (this.g = "Timed out after " + this.l + "ms, aborting", this.j = 8, H(this.b, V(this, this.g)), this.dispatchEvent("timeout"), this.abort(8));
  };function oe(a, b) {
    a.f = !1;a.a && (a.h = !0, a.a.abort(), a.h = !1);a.g = b;a.j = 5;re(a);se(a);
  }function re(a) {
    a.H || (a.H = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
  }
  g.abort = function (a) {
    this.a && this.f && (H(this.b, V(this, "Aborting")), this.f = !1, this.h = !0, this.a.abort(), this.h = !1, this.j = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), se(this));
  };g.w = function () {
    this.a && (this.f && (this.f = !1, this.h = !0, this.a.abort(), this.h = !1), se(this, !0));U.L.w.call(this);
  };g.Ma = function () {
    this.i || (this.I || this.o || this.h ? te(this) : this.bb());
  };g.bb = function () {
    te(this);
  };
  function te(a) {
    if (a.f && "undefined" != typeof goog) if (a.C[1] && 4 == N(a) && 2 == a.W()) H(a.b, V(a, "Local request error detected and ignored"));else if (a.o && 4 == N(a)) Zb(a.Ma, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == N(a)) {
      H(a.b, V(a, "Request complete"));a.f = !1;try {
        var b = a.W();a: switch (b) {case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
            var c = !0;break a;default:
            c = !1;}var d;if (!(d = c)) {
          var e;if (e = 0 === b) {
            var f = String(a.s).match(ld)[1] || null;if (!f && k.self && k.self.location) {
              var h = k.self.location.protocol;
              f = h.substr(0, h.length - 1);
            }e = !me.test(f ? f.toLowerCase() : "");
          }d = e;
        }d ? (a.dispatchEvent("complete"), a.dispatchEvent("success")) : (a.j = 6, a.g = a.Ha() + " [" + a.W() + "]", re(a));
      } finally {
        se(a);
      }
    }
  }function se(a, b) {
    if (a.a) {
      pe(a);var c = a.a,
          d = a.C[0] ? ba : null;a.a = null;a.C = null;b || a.dispatchEvent("ready");try {
        c.onreadystatechange = d;
      } catch (e) {
        (a = a.b) && a.log(gc, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
      }
    }
  }function pe(a) {
    a.a && a.G && (a.a.ontimeout = null);a.B && (k.clearTimeout(a.B), a.B = null);
  }
  function N(a) {
    return a.a ? a.a.readyState : 0;
  }g.W = function () {
    try {
      return 2 < N(this) ? this.a.status : -1;
    } catch (a) {
      return -1;
    }
  };g.Ha = function () {
    try {
      return 2 < N(this) ? this.a.statusText : "";
    } catch (a) {
      return H(this.b, "Can not get status: " + a.message), "";
    }
  };g.V = function () {
    try {
      return this.a ? this.a.responseText : "";
    } catch (a) {
      return H(this.b, "Can not get responseText: " + a.message), "";
    }
  };
  g.Za = function (a) {
    if (this.a) {
      var b = this.a.responseText;a && 0 == b.indexOf(a) && (b = b.substring(a.length));a: {
        a = b;if (k.JSON) try {
          var c = k.JSON.parse(a);break a;
        } catch (d) {}c = Db(a);
      }return c;
    }
  };g.Ga = function () {
    return this.j;
  };g.$a = function () {
    return l(this.g) ? this.g : String(this.g);
  };function V(a, b) {
    return b + " [" + a.M + " " + a.s + " " + a.W() + "]";
  };function ue(a) {
    var b = "";Ca(a, function (a, d) {
      b += d;b += ":";b += a;b += "\r\n";
    });return b;
  }function ve(a, b, c) {
    a: {
      for (d in c) {
        var d = !1;break a;
      }d = !0;
    }if (d) return a;c = ue(c);if (l(a)) {
      b = encodeURIComponent(String(b));c = null != c ? "=" + encodeURIComponent(String(c)) : "";if (b += c) {
        c = a.indexOf("#");0 > c && (c = a.length);d = a.indexOf("?");if (0 > d || d > c) {
          d = c;var e = "";
        } else e = a.substring(d + 1, c);a = [a.substr(0, d), e, a.substr(c)];c = a[1];a[1] = b ? c ? c + "&" + b : b : c;a = a[0] + (a[1] ? "?" + a[1] : "") + a[2];
      }return a;
    }R(a, b, c);return a;
  };function we(a, b, c) {
    this.ya = b || 0;this.Aa = 0;this.g = [];this.a = new qc();this.H = c || new Vd();this.ja = this.xa = this.D = this.ka = this.b = this.J = this.j = this.U = this.h = this.M = this.i = null;this.Va = this.P = 0;this.la = this.B = this.o = this.m = this.l = this.c = null;this.s = this.za = this.N = -1;this.T = this.A = this.C = 0;this.S = a && a.supportsCrossDomainXhr || !1;this.I = "";this.f = new Yd(a && a.concurrentRequestLimit);this.ma = new he();this.G = a && void 0 !== a.backgroundChannelTest ? a.backgroundChannelTest : !0;this.Ua = a && a.fastHandshake || !1;a && a.Fa && this.a.Fa();
  }
  g = we.prototype;g.pa = 8;g.F = 1;function xe(a) {
    J(a.a, "disconnect()");ye(a);if (3 == a.F) {
      var b = a.P++,
          c = M(a.D);R(c, "SID", a.I);R(c, "RID", b);R(c, "TYPE", "terminate");ze(a, c);b = new L(a, a.a, 0, b, void 0);b.J = 2;b.h = Tc(M(c));c = !1;k.navigator && k.navigator.sendBeacon && (c = k.navigator.sendBeacon(b.h.toString(), ""));!c && k.Image && (new Image().src = b.h, c = !0);c || (b.a = b.i.da(null), b.a.fa(b.h));b.C = t();Wc(b);
    }Ae(a);
  }
  function ye(a) {
    a.B && (a.B.abort(), a.B = null);a.b && (a.b.cancel(), a.b = null);a.m && (k.clearTimeout(a.m), a.m = null);Be(a);a.f.cancel();a.l && (k.clearTimeout(a.l), a.l = null);
  }function Ce(a, b) {
    1E3 == a.g.length && xc(a.a, function () {
      return "Already have 1000 queued maps upon queueing " + Eb(b);
    });a.g.push(new Xd(a.Va++, b));3 == a.F && De(a);
  }g.Ka = function () {
    return 0 == this.F;
  };function De(a) {
    be(a.f) || a.l || (a.l = Ec(r(a.Pa, a), 0), a.C = 0);
  }
  function Ee(a, b) {
    var c = a.f;if ((c.b ? 1 : c.a ? c.a.u() : 0) >= a.f.f - (a.l ? 1 : 0)) return xc(a.a, "Unexpected retry request is scheduled."), !1;if (a.l) return J(a.a, "Use the retry request that is already scheduled."), a.g = b.o.concat(a.g), !0;if (1 == a.F || 2 == a.F || 2 <= a.C) return !1;J(a.a, "Going to retry POST");a.l = Ec(r(a.Pa, a, b), Fe(a, a.C));a.C++;return !0;
  }
  g.Pa = function (a) {
    this.l = null;J(this.a, "startForwardChannel_");if (1 == this.F) {
      if (a) xc(this.a, "Not supposed to retry the open");else {
        J(this.a, "open_()");this.P = Math.floor(1E5 * Math.random());a = this.P++;var b = new L(this, this.a, 0, a, void 0),
            c = this.i;this.M && (c ? (c = Fa(c), Ha(c, this.M)) : c = this.M);null === this.h && (b.j = c);var d = Ge(this, b),
            e = M(this.D);R(e, "RID", a);0 < this.ya && R(e, "CVER", this.ya);this.G && this.j && R(e, "X-HTTP-Session-Id", this.j);ze(this, e);this.h && c && ve(e, this.h, c);ae(this.f, b);this.Ua ? (R(e, "$req", d), Sc(b, e, null)) : Sc(b, e, d);this.F = 2;
      }
    } else 3 == this.F && (a ? He(this, a) : 0 == this.g.length ? J(this.a, "startForwardChannel_ returned: nothing to send") : be(this.f) ? xc(this.a, "startForwardChannel_ returned: connection already in progress") : (He(this), J(this.a, "startForwardChannel_ finished, sent request")));
  };
  function He(a, b) {
    var c;b ? c = b.f : c = a.P++;var d = M(a.D);R(d, "SID", a.I);R(d, "RID", c);R(d, "AID", a.N);ze(a, d);a.h && a.i && ve(d, a.h, a.i);c = new L(a, a.a, 0, c, a.C + 1);null === a.h && (c.j = a.i);b && (a.g = b.o.concat(a.g));b = Ge(a, c);c.setTimeout(Math.round(1E4) + Math.round(1E4 * Math.random()));ae(a.f, c);Sc(c, d, b);
  }function ze(a, b) {
    a.c && hd({}, function (a, d) {
      R(b, d, a);
    });
  }
  function Ge(a, b) {
    var c = Math.min(a.g.length, 1E3),
        d = a.c ? r(a.c.Wa, a.c, a) : null;a: for (var e = a.g, f = -1;;) {
      var h = ["count=" + c];-1 == f ? 0 < c ? (f = e[0].a, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);for (var m = !0, v = 0; v < c; v++) {
        var G = e[v].a,
            aa = e[v].b;G -= f;if (0 > G) f = Math.max(0, e[v].a - 100), m = !1;else try {
          ie(aa, h, "req" + G + "_");
        } catch (Nb) {
          d && d(aa);
        }
      }if (m) {
        d = h.join("&");break a;
      }
    }a = a.g.splice(0, c);b.o = a;return d;
  }function Ie(a) {
    if (!a.b && !a.m) {
      a.T = 1;var b = a.Oa;Tb || Ub();Wb || (Tb(), Wb = !0);Pb.add(b, a);a.A = 0;
    }
  }
  function Je(a) {
    if (a.b || a.m) return xc(a.a, "Request already in progress"), !1;if (3 <= a.A) return !1;J(a.a, "Going to retry GET");a.T++;a.m = Ec(r(a.Oa, a), Fe(a, a.A));a.A++;return !0;
  }
  g.Oa = function () {
    this.m = null;J(this.a, "Creating new HttpRequest");this.b = new L(this, this.a, 0, "rpc", this.T);null === this.h && (this.b.j = this.i);this.b.P = 0;var a = M(this.xa);R(a, "RID", "rpc");R(a, "SID", this.I);R(a, "CI", this.la ? "0" : "1");R(a, "AID", this.N);ze(this, a);R(a, "TYPE", "xmlhttp");this.h && this.i && ve(a, this.h, this.i);Vc(this.b, a, !0, this.ja);J(this.a, "New Request created");
  };
  function Sd(a, b, c) {
    J(a.a, "Test Connection Finished");var d = b.m;d && $d(a.f, d);a.la = c;a.s = b.f;J(a.a, "connectChannel_()");a.D = Ke(a, a.ka);De(a);
  }function Ud(a, b) {
    J(a.a, "Test Connection Failed");a.s = b.f;W(a, 2);
  }
  g.Na = function (a, b) {
    if (0 != this.F && (this.b == a || ce(this.f, a))) if (this.s = a.B, ce(this.f, a) && 3 == this.F) {
      try {
        var c = this.ma.a.parse(b);
      } catch (f) {
        c = null;
      }if (n(c) && 3 == c.length) {
        if (b = c, 0 == b[0]) {
          a: if (J(this.a, "Server claims our backchannel is missing."), this.m) J(this.a, "But we are currently starting the request.");else {
            if (this.b) {
              if (this.b.C + 3E3 < a.C) Be(this), this.b.cancel(), this.b = null;else break a;
            } else F(this.a.a, "We do not have a BackChannel established");Je(this);K();
          }
        } else this.za = b[1], a = this.za - this.N, 0 < a && (b = b[2], J(this.a, b + " bytes (in " + a + " arrays) are outstanding on the BackChannel"), 37500 > b && this.la && 0 == this.A && !this.o && (this.o = Ec(r(this.ab, this), 6E3)));
      } else J(this.a, "Bad POST response data returned"), W(this, 11);
    } else if (this.b == a && Be(this), !/^[\s\xa0]*$/.test(b)) for (b = c = this.ma.a.parse(b), c = 0; c < b.length; c++) {
      var d = b[c];this.N = d[0];d = d[1];if (2 == this.F) {
        if ("c" == d[0]) {
          this.I = d[1];this.ja = d[2];var e = d[3];null != e && (this.pa = e, I(this.a, "VER=" + this.pa));d = d[4];null != d && (this.Aa = d, I(this.a, "SVER=" + this.Aa));
          this.G && (d = a.a) && ((e = d.a ? d.a.getResponseHeader("X-Client-Wire-Protocol") : null) && $d(this.f, e), this.j && ((d = d.a ? d.a.getResponseHeader("X-HTTP-Session-Id") : null) ? (this.J = d, R(this.D, this.j, d)) : F(this.a.a, "Missing X_HTTP_SESSION_ID in the handshake response")));this.F = 3;this.c && this.c.Ea(this);this.xa = Td(this, this.ja, this.ka);Ie(this);
        } else "stop" != d[0] && "close" != d[0] || W(this, 7);
      } else 3 == this.F && ("stop" == d[0] || "close" == d[0] ? "stop" == d[0] ? W(this, 7) : xe(this) : "noop" != d[0] && this.c && this.c.Da(this, d), this.A = 0);
    }
  };
  g.ab = function () {
    null != this.o && (this.o = null, this.b.cancel(), this.b = null, Je(this), K());
  };function Be(a) {
    null != a.o && (k.clearTimeout(a.o), a.o = null);
  }
  g.va = function (a) {
    J(this.a, "Request complete");var b = null;if (this.b == a) {
      Be(this);this.b = null;var c = 2;
    } else if (ce(this.f, a)) b = a.o, de(this.f, a), c = 1;else return;this.s = a.B;if (0 != this.F) if (a.c) 1 == c ? (Dc(t() - a.C), De(this)) : Ie(this);else {
      var d = a.l;if (3 == d || 0 == d && 0 < this.s) J(this.a, "Not retrying due to error type");else {
        var e = this;J(this.a, function () {
          return "Maybe retrying, last error: " + Pc(d, e.s);
        });if (1 == c && Ee(this, a) || 2 == c && Je(this)) return;J(this.a, "Exceeded max number of retries");
      }b && 0 < b.length && fe(this.f, b);J(this.a, "Error: HTTP request failed");switch (d) {case 1:
          W(this, 5);break;case 4:
          W(this, 10);break;case 3:
          W(this, 6);break;default:
          W(this, 2);}
    }
  };function Fe(a, b) {
    var c = 5E3 + Math.floor(1E4 * Math.random());a.sa() || (J(a.a, "Inactive channel"), c *= 2);return c * b;
  }
  function W(a, b) {
    I(a.a, "Error code " + b);if (2 == b) {
      var c = null;a.c && (c = null);var d = r(a.ib, a);c || (c = new Q("//www.google.com/images/cleardot.gif"), k.location && "http" == k.location.protocol || nd(c, "https"), Tc(c));je(c.toString(), d);
    } else K();J(a.a, "HttpChannel: error - " + b);a.F = 0;a.c && a.c.Ca(a, b);Ae(a);ye(a);
  }g.ib = function (a) {
    a ? I(this.a, "Successfully pinged google.com") : I(this.a, "Failed to ping google.com");K();
  };
  function Ae(a) {
    a.F = 0;a.s = -1;if (a.c) {
      var b = ee(a.f);if (0 == b.length && 0 == a.g.length) a.c.oa(a);else {
        J(a.a, function () {
          return "Number of undelivered maps, pending: " + b.length + ", outgoing: " + a.g.length;
        });a.f.c.length = 0;var c = za(a.g);a.g.length = 0;a.c.oa(a, b, c);
      }
    }
  }function Ke(a, b) {
    b = Le(a, null, b);J(a.a, "GetForwardChannelUri: " + b);return b;
  }function Td(a, b, c) {
    b = Le(a, a.ia() ? b : null, c);J(a.a, "GetBackChannelUri: " + b);return b;
  }
  function Le(a, b, c) {
    var d = Cd(c);if ("" != d.b) b && od(d, b + "." + d.b), pd(d, d.i);else {
      var e = k.location,
          f;b ? f = b + "." + e.hostname : f = e.hostname;d = Dd(e.protocol, f, e.port, c);
    }a.U && Ca(a.U, function (a, b) {
      R(d, b, a);
    });b = a.j;c = a.J;b && c && R(d, b, c);R(d, "VER", a.pa);ze(a, d);return d;
  }g.da = function (a) {
    if (a && !this.S) throw Error("Can't create secondary domain capable XhrIo object.");a = new U();a.m = this.S;return a;
  };g.sa = function () {
    return !!this.c && !0;
  };g.ia = function () {
    return this.S;
  };new Ld();function Me() {}g = Me.prototype;g.Ea = function () {};
  g.Da = function () {};g.Ca = function () {};g.oa = function () {};g.Wa = function () {};function Ne(a) {
    for (var b = arguments[0], c = 1; c < arguments.length; c++) {
      var d = arguments[c];if (0 == d.lastIndexOf("/", 0)) b = d;else {
        var e;(e = "" == b) || (e = b.length - 1, e = 0 <= e && b.indexOf("/", e) == e);e ? b += d : b += "/" + d;
      }
    }return b;
  };function Oe() {
    if (z && !(10 <= Number(Va))) throw Error("Environmental error: no available transport.");
  }Oe.prototype.a = function (a, b) {
    return new X(a, b);
  };
  function X(a, b) {
    B.call(this);this.a = new we(b, 21);this.b = a;this.s = b && b.testUrl ? b.testUrl : Ne(this.b, "test");this.f = oc("goog.labs.net.webChannel.WebChannelBaseTransport");this.g = b && b.messageUrlParams || null;a = b && b.messageHeaders || null;b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = { "X-Client-Protocol": "webchannel" });this.a.i = a;a = b && b.initMessageHeaders || null;b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = { "X-WebChannel-Content-Type": b.messageContentType });
    this.a.M = a;(a = b && b.httpHeadersOverwriteParam) && !/^[\s\xa0]*$/.test(a) && (this.a.h = a);this.o = b && b.supportsCrossDomainXhr || !1;this.m = b && b.sendRawJson || !1;(b = b && b.httpSessionIdParam) && !/^[\s\xa0]*$/.test(b) && (this.a.j = b, a = this.g, null !== a && b in a && (a = this.g, b in a && delete a[b], F(this.f, "Ignore httpSessionIdParam also specified with messageUrlParams: " + b)));this.h = new Pe(this);
  }u(X, B);
  X.prototype.j = function () {
    this.a.c = this.h;this.o && (this.a.S = !0);var a = this.a,
        b = this.s,
        c = this.b,
        d = this.g || void 0;J(a.a, "connect()");K();a.ka = c;a.U = d || {};a.G && (J(a.a, "connect() bypassed channel-test."), a.H.b = [], a.H.a = !1);J(a.a, "connectTest_()");a.B = new Qd(a, a.a);null === a.h && (a.B.i = a.i);c = b;a.h && a.i && (c = ve(b, a.h, a.i));a = a.B;a.l = c;b = Ke(a.a, a.l);K();c = a.a.H.b;null != c ? (a.g = c[0], a.R = 1, Rd(a)) : (Xc(b, "MODE", "init"), !a.a.G && a.a.j && Xc(b, "X-HTTP-Session-Id", a.a.j), a.c = new L(a, a.b, 0, void 0, void 0), a.c.j = a.i, Vc(a.c, b, !1, null), a.R = 0);
  };X.prototype.close = function () {
    xe(this.a);
  };X.prototype.l = function (a) {
    if (l(a)) {
      var b = {};b.__data__ = a;Ce(this.a, b);
    } else this.m ? (b = {}, b.__data__ = Eb(a), Ce(this.a, b)) : Ce(this.a, a);
  };X.prototype.w = function () {
    this.a.c = null;delete this.h;xe(this.a);delete this.a;X.L.w.call(this);
  };function Qe(a) {
    Od.call(this);var b = a.__sm__;if (b) {
      a: {
        for (var c in b) {
          a = c;break a;
        }a = void 0;
      }(this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
    } else this.data = a;
  }u(Qe, Od);
  function Re() {
    Pd.call(this);this.status = 1;
  }u(Re, Pd);function Pe(a) {
    this.a = a;
  }u(Pe, Me);Pe.prototype.Ea = function () {
    pc(this.a.f, "WebChannel opened on " + this.a.b);this.a.dispatchEvent("a");
  };Pe.prototype.Da = function (a, b) {
    this.a.dispatchEvent(new Qe(b));
  };Pe.prototype.Ca = function (a, b) {
    pc(this.a.f, "WebChannel aborted on " + this.a.b + " due to channel error: " + b);this.a.dispatchEvent(new Re());
  };Pe.prototype.oa = function () {
    pc(this.a.f, "WebChannel closed on " + this.a.b);this.a.dispatchEvent("b");
  };var Se = ja(function (a, b) {
    function c() {}c.prototype = a.prototype;var d = new c();a.apply(d, Array.prototype.slice.call(arguments, 1));return d;
  }, Oe);function Te() {
    this.b = [];this.a = [];
  }function Ue(a) {
    0 == a.b.length && (a.b = a.a, a.b.reverse(), a.a = []);return a.b.pop();
  }Te.prototype.u = function () {
    return this.b.length + this.a.length;
  };Te.prototype.contains = function (a) {
    return 0 <= ta(this.b, a) || 0 <= ta(this.a, a);
  };Te.prototype.v = function () {
    for (var a = [], b = this.b.length - 1; 0 <= b; --b) {
      a.push(this.b[b]);
    }var c = this.a.length;for (b = 0; b < c; ++b) {
      a.push(this.a[b]);
    }return a;
  };function Ve(a, b) {
    w.call(this);this.h = a || 0;this.c = b || 10;if (this.h > this.c) throw Error(We);this.a = new Te();this.b = new T();this.g = null;this.ba();
  }u(Ve, w);var We = "[goog.structs.Pool] Min can not be greater than max";g = Ve.prototype;g.ea = function () {
    var a = t();if (!(null != this.g && 0 > a - this.g)) {
      for (var b; 0 < this.a.u() && (b = Ue(this.a), !this.ua(b));) {
        this.ba();
      }!b && this.u() < this.c && (b = this.ra());b && (this.g = a, this.b.add(b));return b;
    }
  };g.hb = function (a) {
    return kd(this.b.a, Wd(a)) ? (this.na(a), !0) : !1;
  };
  g.na = function (a) {
    kd(this.b.a, Wd(a));this.ua(a) && this.u() < this.c ? this.a.a.push(a) : Xe(a);
  };g.ba = function () {
    for (var a = this.a; this.u() < this.h;) {
      var b = this.ra();a.a.push(b);
    }for (; this.u() > this.c && 0 < this.a.u();) {
      Xe(Ue(a));
    }
  };g.ra = function () {
    return {};
  };function Xe(a) {
    if ("function" == typeof a.Z) a.Z();else for (var b in a) {
      a[b] = null;
    }
  }g.ua = function (a) {
    return "function" == typeof a.Xa ? a.Xa() : !0;
  };g.contains = function (a) {
    return this.a.contains(a) || this.b.contains(a);
  };g.u = function () {
    return this.a.u() + this.b.u();
  };
  g.w = function () {
    Ve.L.w.call(this);if (0 < this.b.u()) throw Error("[goog.structs.Pool] Objects not released");delete this.b;for (var a = this.a; 0 != a.b.length || 0 != a.a.length;) {
      Xe(Ue(a));
    }delete this.a;
  };function Ye(a, b) {
    this.a = a;this.b = b;
  };function Ze(a) {
    this.a = [];if (a) a: {
      if (a instanceof Ze) {
        var b = a.O();a = a.v();if (0 >= this.u()) {
          for (var c = this.a, d = 0; d < b.length; d++) {
            c.push(new Ye(b[d], a[d]));
          }break a;
        }
      } else b = Ea(a), a = Da(a);for (d = 0; d < b.length; d++) {
        $e(this, b[d], a[d]);
      }
    }
  }function $e(a, b, c) {
    var d = a.a;d.push(new Ye(b, c));b = d.length - 1;a = a.a;for (c = a[b]; 0 < b;) {
      if (d = b - 1 >> 1, a[d].a > c.a) a[b] = a[d], b = d;else break;
    }a[b] = c;
  }Ze.prototype.v = function () {
    for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
      b.push(a[d].b);
    }return b;
  };
  Ze.prototype.O = function () {
    for (var a = this.a, b = [], c = a.length, d = 0; d < c; d++) {
      b.push(a[d].a);
    }return b;
  };Ze.prototype.u = function () {
    return this.a.length;
  };function af() {
    Ze.call(this);
  }u(af, Ze);function Y(a, b) {
    this.f = new af();Ve.call(this, a, b);
  }u(Y, Ve);g = Y.prototype;g.ea = function (a, b) {
    if (!a) return Y.L.ea.call(this);$e(this.f, void 0 !== b ? b : 100, a);this.ta();
  };g.ta = function () {
    for (var a = this.f; 0 < a.u();) {
      var b = this.ea();if (b) {
        var c = a,
            d = c.a,
            e = d.length;var f = d[0];if (0 >= e) f = void 0;else {
          if (1 == e) xa(d);else {
            d[0] = d.pop();d = 0;c = c.a;e = c.length;for (var h = c[d]; d < e >> 1;) {
              var m = 2 * d + 1,
                  v = 2 * d + 2;m = v < e && c[v].a < c[m].a ? v : m;if (c[m].a > h.a) break;c[d] = c[m];d = m;
            }c[d] = h;
          }f = f.b;
        }f.apply(this, [b]);
      } else break;
    }
  };
  g.na = function (a) {
    Y.L.na.call(this, a);this.ta();
  };g.ba = function () {
    Y.L.ba.call(this);this.ta();
  };g.w = function () {
    Y.L.w.call(this);k.clearTimeout(void 0);xa(this.f.a);this.f = null;
  };function Z(a, b, c, d) {
    this.l = a;this.j = !!d;Y.call(this, b, c);
  }u(Z, Y);Z.prototype.ra = function () {
    var a = new U(),
        b = this.l;b && b.forEach(function (b, d) {
      a.headers.set(d, b);
    });this.j && (a.m = !0);return a;
  };Z.prototype.ua = function (a) {
    return !a.i && !a.a;
  };Oe.prototype.createWebChannel = Oe.prototype.a;X.prototype.send = X.prototype.l;X.prototype.open = X.prototype.j;X.prototype.close = X.prototype.close;Fc.NO_ERROR = 0;Fc.TIMEOUT = 8;Fc.HTTP_ERROR = 6;Gc.COMPLETE = "complete";Md.EventType = Nd;Nd.OPEN = "a";Nd.CLOSE = "b";Nd.ERROR = "c";Nd.MESSAGE = "d";B.prototype.listen = B.prototype.aa;Z.prototype.getObject = Z.prototype.ea;Z.prototype.releaseObject = Z.prototype.hb;U.prototype.listenOnce = U.prototype.Ia;U.prototype.getLastError = U.prototype.$a;U.prototype.getLastErrorCode = U.prototype.Ga;
  U.prototype.getStatus = U.prototype.W;U.prototype.getStatusText = U.prototype.Ha;U.prototype.getResponseJson = U.prototype.Za;U.prototype.getResponseText = U.prototype.V;U.prototype.getResponseText = U.prototype.V;U.prototype.send = U.prototype.fa;module.exports = { createWebChannelTransport: Se, ErrorCode: Fc, EventType: Gc, WebChannel: Md, XhrIoPool: Z };
}).call(typeof window !== 'undefined' ? window : this);

/***/ }),

/***/ "J4Nk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "JiNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchableList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils__ = __webpack_require__("p90z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("VKRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { 'class': 'fa fa-cog fa-spin', 'aria-hidden': 'true' });

var SearchableList = function (_Component) {
	_inherits(SearchableList, _Component);

	function SearchableList() {
		_classCallCheck(this, SearchableList);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SearchableList.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var headline = _ref.headline,
		    data = _ref.data,
		    _ref$searchable = _ref.searchable,
		    searchable = _ref$searchable === undefined ? true : _ref$searchable;
		var filter = _ref2.filter;

		filter = filter || '';
		var items = data && data.filter(function (s) {
			return s.caption.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
		}).map(function (entry) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'li',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
					{ href: Object(__WEBPACK_IMPORTED_MODULE_2__components_utils__["urlencode"])(entry.link) },
					entry.caption
				)
			);
		}) || [];

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'h2',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					null,
					headline
				),
				data === undefined ? _ref3 : ""
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				{ 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.list },
				searchable ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.search, placeholder: 'Suchen...', autofocus: true, onKeyUp: function onKeyUp(e) {
							return _this2.setState({ filter: e.target.value });
						} })
				) : "",
				items
			)
		);
	};

	return SearchableList;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__("MCp7");
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/header/style.css
var header_style = __webpack_require__("u3et");
var header_style_default = /*#__PURE__*/__webpack_require__.n(header_style);

// EXTERNAL MODULE: ./components/firebase-auth.js
var firebase_auth = __webpack_require__("W5gc");
var firebase_auth_default = /*#__PURE__*/__webpack_require__.n(firebase_auth);

// CONCATENATED MODULE: ./components/header/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





__webpack_require__("eY1z");

var _ref2 = Object(preact_min["h"])('i', { 'class': 'fa fa-globe', 'aria-hidden': 'true' });

var header_Header = function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		_classCallCheck(this, Header);

		var _this = _possibleConstructorReturn(this, _Component.call(this));

		Object(firebase_auth["getUser"])(function (user) {
			_this.setState({ user: user });
		});
		return _this;
	}

	Header.prototype.render = function render(_, _ref) {
		var user = _ref.user;


		var auth = void 0;
		if (!user) {
			auth = Object(preact_min["h"])(
				match["Link"],
				{ activeClassName: header_style_default.a.active, href: '/login' },
				'Login'
			);
		} else {
			auth = Object(preact_min["h"])(
				match["Link"],
				{ activeClassName: header_style_default.a.active, href: '/profile' },
				user.displayName
			);
		}

		return Object(preact_min["h"])(
			'header',
			{ 'class': header_style_default.a.header },
			Object(preact_min["h"])(
				'h1',
				null,
				Object(preact_min["h"])(
					match["Link"],
					{ activeClassName: header_style_default.a.active, href: '/' },
					_ref2,
					' GeoTraining'
				)
			),
			Object(preact_min["h"])(
				'nav',
				null,
				auth
			)
		);
	};

	return Header;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/footer/style.css
var footer_style = __webpack_require__("ZMjw");
var footer_style_default = /*#__PURE__*/__webpack_require__.n(footer_style);

// CONCATENATED MODULE: ./components/footer/index.js


function footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





__webpack_require__("eY1z");

var footer__ref2 = Object(preact_min["h"])('i', { 'class': 'fa fa-globe', 'aria-hidden': 'true' });

var _ref3 = Object(preact_min["h"])(
	'a',
	{ href: 'https://feuerwehreinsatz.info/#navAbout', target: '_blank' },
	'Impressum'
);

var footer_Footer = function (_Component) {
	footer__inherits(Footer, _Component);

	function Footer() {
		footer__classCallCheck(this, Footer);

		var _this = footer__possibleConstructorReturn(this, _Component.call(this));

		Object(firebase_auth["getUser"])(function (user) {
			_this.setState({ user: user });
		});
		return _this;
	}

	Footer.prototype.render = function render(_, _ref) {
		var user = _ref.user;

		return Object(preact_min["h"])(
			'footer',
			{ 'class': footer_style_default.a.footer },
			Object(preact_min["h"])(
				'nav',
				null,
				Object(preact_min["h"])(
					match["Link"],
					{ activeClassName: footer_style_default.a.active, href: '/about' },
					footer__ref2,
					' About'
				),
				_ref3
			)
		);
	};

	return Footer;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function(require) {
				cb(__webpack_require__("xjyG"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/about/index.js

		

		function about_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function(require) {
				cb(__webpack_require__("9i67"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var about = (async_default()(about_load));
	
// CONCATENATED MODULE: ./routes/states/index.js

		

		function states_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function(require) {
				cb(__webpack_require__("luXU"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var states = (async_default()(states_load));
	
// CONCATENATED MODULE: ./routes/towns/index.js

		

		function towns_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function(require) {
				cb(__webpack_require__("8Liv"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var towns = (async_default()(towns_load));
	
// CONCATENATED MODULE: ./routes/games/index.js

		

		function games_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function(require) {
				cb(__webpack_require__("xhay"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var games = (async_default()(games_load));
	
// CONCATENATED MODULE: ./routes/game/index.js

		

		function game_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function(require) {
				cb(__webpack_require__("RBEH"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var game = (async_default()(game_load));
	
// CONCATENATED MODULE: ./routes/login/index.js

		

		function login_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function(require) {
				cb(__webpack_require__("IXgk"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var login = (async_default()(login_load));
	
// CONCATENATED MODULE: ./routes/profile/index.js

		

		function profile_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function(require) {
				cb(__webpack_require__("Y/TP"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var profile = (async_default()(profile_load));
	
// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ReactGA = __webpack_require__("Z70r");
ReactGA.initialize('UA-109713396-1');

function logPageView() {
	if (typeof window !== "undefined") {
		ReactGA.set({ page: window.location.pathname + window.location.search });
		ReactGA.pageview(window.location.pathname + window.location.search);
	}
}

var app__ref = Object(preact_min["h"])(header_Header, null);

var app__ref2 = Object(preact_min["h"])(home, { path: '/' });

var app__ref3 = Object(preact_min["h"])(states, { path: '/game/' });

var _ref4 = Object(preact_min["h"])(towns, { path: '/game/:stateName' });

var _ref5 = Object(preact_min["h"])(games, { path: '/game/:stateName/:townName' });

var _ref6 = Object(preact_min["h"])(game, { path: '/game/:stateName/:townName/:gameName' });

var _ref7 = Object(preact_min["h"])(login, { path: '/login' });

var _ref8 = Object(preact_min["h"])(about, { path: '/about' });

var _ref9 = Object(preact_min["h"])(profile, { path: '/profile' });

var _ref10 = Object(preact_min["h"])(footer_Footer, null);

var app_App = function (_Component) {
	app__inherits(App, _Component);

	function App() {
		var _temp, _this, _ret;

		app__classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = app__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleRoute = function (e) {
			_this.currentUrl = e.url;
			logPageView();
		}, _temp), app__possibleConstructorReturn(_this, _ret);
	}
	/** Gets fired when the route changes.
  *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
  *	@param {string} event.url	The newly routed URL
  */


	App.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ id: 'app' },
			app__ref,
			Object(preact_min["h"])(
				preact_router_es["Router"],
				{ onChange: this.handleRoute },
				app__ref2,
				app__ref3,
				_ref4,
				_ref5,
				_ref6,
				_ref7,
				_ref8,
				_ref9
			),
			_ref10
		);
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "L7k2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
exports.validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    } else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
exports.errorPrefix = errorPrefix;
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid firebase namespace.');
    }
}
exports.validateNamespace = validateNamespace;
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid function.');
}
exports.validateCallback = validateCallback;
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid context object.');
}
exports.validateContextObject = validateContextObject;

//# sourceMappingURL=validation.js.map

/***/ }),

/***/ "MB0S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error.captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
exports.patchCapture = patchCapture;
var FirebaseError = /** @class */function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        var stack;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        } else {
            var err_1 = Error.apply(this, arguments);
            this.name = ERROR_NAME;
            // Make non-enumerable getter for the property.
            Object.defineProperty(this, 'stack', {
                get: function get() {
                    return err_1.stack;
                }
            });
        }
    }
    return FirebaseError;
}();
exports.FirebaseError = FirebaseError;
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        } else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}();
exports.ErrorFactory = ErrorFactory;

//# sourceMappingURL=errors.js.map

/***/ }),

/***/ "MCp7":
/***/ (function(module, exports) {

(function (self) {
  'use strict';

  if (self.fetch) {
    return;
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  if (support.arrayBuffer) {
    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

    var isDataView = function isDataView(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj);
    };

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return { done: value === undefined, value: value };
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ',' + value : value;
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        throw new Error('unsupported BodyInit type');
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'omit';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    rawHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = 'status' in options ? options.status : 200;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  };

  Response.error = function () {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function (input, init) {
    return new Promise(function (resolve, reject) {
      var request = new Request(input, init);
      var xhr = new XMLHttpRequest();

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  };
  self.fetch.polyfill = true;
})(typeof self !== 'undefined' ? self : this);

/***/ }),

/***/ "MUsR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
exports.CONSTANTS = {
  /**
   * @define {boolean} Whether this is the client Node.js SDK.
   */
  NODE_CLIENT: false,
  /**
   * @define {boolean} Whether this is the Admin Node.js SDK.
   */
  NODE_ADMIN: false,
  /**
   * Firebase SDK Version
   */
  SDK_VERSION: '${JSCORE_VERSION}'
};

//# sourceMappingURL=constants.js.map

/***/ }),

/***/ "No41":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function () {
  var firebase = __webpack_require__("niZR");__webpack_require__("RFlV"); /*
                                                                   Copyright 2015 Google Inc. All Rights Reserved.
                                                                   Licensed under the Apache License, Version 2.0 (the "License");
                                                                   you may not use this file except in compliance with the License.
                                                                   You may obtain a copy of the License at
                                                                   http://www.apache.org/licenses/LICENSE-2.0
                                                                   Unless required by applicable law or agreed to in writing, software
                                                                   distributed under the License is distributed on an "AS IS" BASIS,
                                                                   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                   See the License for the specific language governing permissions and
                                                                   limitations under the License.
                                                                   */
  var componentHandler = { upgradeDom: function upgradeDom(optJsClass, optCssClass) {}, upgradeElement: function upgradeElement(element, optJsClass) {}, upgradeElements: function upgradeElements(elements) {}, upgradeAllRegistered: function upgradeAllRegistered() {}, registerUpgradedCallback: function registerUpgradedCallback(jsClass, callback) {}, register: function register(config) {}, downgradeElements: function downgradeElements(nodes) {} };
  componentHandler = function () {
    var registeredComponents_ = [];var createdComponents_ = [];var componentConfigProperty_ = "mdlComponentConfigInternal_";function findRegisteredClass_(name, optReplace) {
      for (var i = 0; i < registeredComponents_.length; i++) {
        if (registeredComponents_[i].className === name) {
          if (typeof optReplace !== "undefined") registeredComponents_[i] = optReplace;return registeredComponents_[i];
        }
      }return false;
    }function getUpgradedListOfElement_(element) {
      var dataUpgraded = element.getAttribute("data-upgraded");return dataUpgraded === null ? [""] : dataUpgraded.split(",");
    }function isElementUpgraded_(element, jsClass) {
      var upgradedList = getUpgradedListOfElement_(element);return upgradedList.indexOf(jsClass) !== -1;
    }function createEvent_(eventType, bubbles, cancelable) {
      if ("CustomEvent" in window && typeof window.CustomEvent === "function") return new CustomEvent(eventType, { bubbles: bubbles, cancelable: cancelable });else {
        var ev = document.createEvent("Events");ev.initEvent(eventType, bubbles, cancelable);return ev;
      }
    }function upgradeDomInternal(optJsClass, optCssClass) {
      if (typeof optJsClass === "undefined" && typeof optCssClass === "undefined") for (var i = 0; i < registeredComponents_.length; i++) {
        upgradeDomInternal(registeredComponents_[i].className, registeredComponents_[i].cssClass);
      } else {
        var jsClass = optJsClass;if (typeof optCssClass === "undefined") {
          var registeredClass = findRegisteredClass_(jsClass);if (registeredClass) optCssClass = registeredClass.cssClass;
        }var elements = document.querySelectorAll("." + optCssClass);for (var n = 0; n < elements.length; n++) {
          upgradeElementInternal(elements[n], jsClass);
        }
      }
    }function upgradeElementInternal(element, optJsClass) {
      if (!(typeof element === "object" && element instanceof Element)) throw new Error("Invalid argument provided to upgrade MDL element.");var upgradingEv = createEvent_("mdl-componentupgrading", true, true);element.dispatchEvent(upgradingEv);if (upgradingEv.defaultPrevented) return;var upgradedList = getUpgradedListOfElement_(element);var classesToUpgrade = [];if (!optJsClass) {
        var classList = element.classList;registeredComponents_.forEach(function (component) {
          if (classList.contains(component.cssClass) && classesToUpgrade.indexOf(component) === -1 && !isElementUpgraded_(element, component.className)) classesToUpgrade.push(component);
        });
      } else if (!isElementUpgraded_(element, optJsClass)) classesToUpgrade.push(findRegisteredClass_(optJsClass));for (var i = 0, n = classesToUpgrade.length, registeredClass; i < n; i++) {
        registeredClass = classesToUpgrade[i];if (registeredClass) {
          upgradedList.push(registeredClass.className);element.setAttribute("data-upgraded", upgradedList.join(","));var instance = new registeredClass.classConstructor(element);
          instance[componentConfigProperty_] = registeredClass;createdComponents_.push(instance);for (var j = 0, m = registeredClass.callbacks.length; j < m; j++) {
            registeredClass.callbacks[j](element);
          }if (registeredClass.widget) element[registeredClass.className] = instance;
        } else throw new Error("Unable to find a registered component for the given class.");var upgradedEv = createEvent_("mdl-componentupgraded", true, false);element.dispatchEvent(upgradedEv);
      }
    }function upgradeElementsInternal(elements) {
      if (!Array.isArray(elements)) if (elements instanceof Element) elements = [elements];else elements = Array.prototype.slice.call(elements);for (var i = 0, n = elements.length, element; i < n; i++) {
        element = elements[i];if (element instanceof HTMLElement) {
          upgradeElementInternal(element);if (element.children.length > 0) upgradeElementsInternal(element.children);
        }
      }
    }function registerInternal(config) {
      var widgetMissing = typeof config.widget === "undefined" && typeof config["widget"] === "undefined";var widget = true;if (!widgetMissing) widget = config.widget || config["widget"];var newConfig = { classConstructor: config.constructor || config["constructor"], className: config.classAsString || config["classAsString"], cssClass: config.cssClass || config["cssClass"], widget: widget, callbacks: [] };registeredComponents_.forEach(function (item) {
        if (item.cssClass === newConfig.cssClass) throw new Error("The provided cssClass has already been registered: " + item.cssClass);if (item.className === newConfig.className) throw new Error("The provided className has already been registered");
      });if (config.constructor.prototype.hasOwnProperty(componentConfigProperty_)) throw new Error("MDL component classes must not have " + componentConfigProperty_ + " defined as a property.");var found = findRegisteredClass_(config.classAsString, newConfig);if (!found) registeredComponents_.push(newConfig);
    }function registerUpgradedCallbackInternal(jsClass, callback) {
      var regClass = findRegisteredClass_(jsClass);if (regClass) regClass.callbacks.push(callback);
    }function upgradeAllRegisteredInternal() {
      for (var n = 0; n < registeredComponents_.length; n++) {
        upgradeDomInternal(registeredComponents_[n].className);
      }
    }function deconstructComponentInternal(component) {
      if (component) {
        var componentIndex = createdComponents_.indexOf(component);createdComponents_.splice(componentIndex, 1);var upgrades = component.element_.getAttribute("data-upgraded").split(",");var componentPlace = upgrades.indexOf(component[componentConfigProperty_].classAsString);upgrades.splice(componentPlace, 1);component.element_.setAttribute("data-upgraded", upgrades.join(","));var ev = createEvent_("mdl-componentdowngraded", true, false);component.element_.dispatchEvent(ev);
      }
    }function downgradeNodesInternal(nodes) {
      var downgradeNode = function downgradeNode(node) {
        createdComponents_.filter(function (item) {
          return item.element_ === node;
        }).forEach(deconstructComponentInternal);
      };if (nodes instanceof Array || nodes instanceof NodeList) for (var n = 0; n < nodes.length; n++) {
        downgradeNode(nodes[n]);
      } else if (nodes instanceof Node) downgradeNode(nodes);else throw new Error("Invalid argument provided to downgrade MDL nodes.");
    }return { upgradeDom: upgradeDomInternal, upgradeElement: upgradeElementInternal, upgradeElements: upgradeElementsInternal, upgradeAllRegistered: upgradeAllRegisteredInternal, registerUpgradedCallback: registerUpgradedCallbackInternal,
      register: registerInternal, downgradeElements: downgradeNodesInternal };
  }();componentHandler.ComponentConfigPublic;componentHandler.ComponentConfig;componentHandler.Component;componentHandler["upgradeDom"] = componentHandler.upgradeDom;componentHandler["upgradeElement"] = componentHandler.upgradeElement;componentHandler["upgradeElements"] = componentHandler.upgradeElements;componentHandler["upgradeAllRegistered"] = componentHandler.upgradeAllRegistered;componentHandler["registerUpgradedCallback"] = componentHandler.registerUpgradedCallback;
  componentHandler["register"] = componentHandler.register;componentHandler["downgradeElements"] = componentHandler.downgradeElements;window.componentHandler = componentHandler;window["componentHandler"] = componentHandler;
  window.addEventListener("load", function () {
    if ("classList" in document.createElement("div") && "querySelector" in document && "addEventListener" in window && Array.prototype.forEach) {
      document.documentElement.classList.add("mdl-js");componentHandler.upgradeAllRegistered();
    } else {
      componentHandler.upgradeElement = function () {};componentHandler.register = function () {};
    }
  });(function () {
    var MaterialButton = function MaterialButton(element) {
      this.element_ = element;this.init();
    };window["MaterialButton"] = MaterialButton;MaterialButton.prototype.Constant_ = {};MaterialButton.prototype.CssClasses_ = { RIPPLE_EFFECT: "mdl-js-ripple-effect", RIPPLE_CONTAINER: "mdl-button__ripple-container", RIPPLE: "mdl-ripple" };MaterialButton.prototype.blurHandler_ = function (event) {
      if (event) this.element_.blur();
    };MaterialButton.prototype.disable = function () {
      this.element_.disabled = true;
    };MaterialButton.prototype["disable"] = MaterialButton.prototype.disable;MaterialButton.prototype.enable = function () {
      this.element_.disabled = false;
    };MaterialButton.prototype["enable"] = MaterialButton.prototype.enable;MaterialButton.prototype.init = function () {
      if (this.element_) {
        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
          var rippleContainer = document.createElement("span");rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);this.rippleElement_ = document.createElement("span");this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
          rippleContainer.appendChild(this.rippleElement_);this.boundRippleBlurHandler = this.blurHandler_.bind(this);this.rippleElement_.addEventListener("mouseup", this.boundRippleBlurHandler);this.element_.appendChild(rippleContainer);
        }this.boundButtonBlurHandler = this.blurHandler_.bind(this);this.element_.addEventListener("mouseup", this.boundButtonBlurHandler);this.element_.addEventListener("mouseleave", this.boundButtonBlurHandler);
      }
    };componentHandler.register({ constructor: MaterialButton, classAsString: "MaterialButton",
      cssClass: "mdl-js-button", widget: true });
  })();(function () {
    var MaterialProgress = function MaterialProgress(element) {
      this.element_ = element;this.init();
    };window["MaterialProgress"] = MaterialProgress;MaterialProgress.prototype.Constant_ = {};MaterialProgress.prototype.CssClasses_ = { INDETERMINATE_CLASS: "mdl-progress__indeterminate" };MaterialProgress.prototype.setProgress = function (p) {
      if (this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)) return;this.progressbar_.style.width = p + "%";
    };MaterialProgress.prototype["setProgress"] = MaterialProgress.prototype.setProgress;
    MaterialProgress.prototype.setBuffer = function (p) {
      this.bufferbar_.style.width = p + "%";this.auxbar_.style.width = 100 - p + "%";
    };MaterialProgress.prototype["setBuffer"] = MaterialProgress.prototype.setBuffer;MaterialProgress.prototype.init = function () {
      if (this.element_) {
        var el = document.createElement("div");el.className = "progressbar bar bar1";this.element_.appendChild(el);this.progressbar_ = el;el = document.createElement("div");el.className = "bufferbar bar bar2";this.element_.appendChild(el);this.bufferbar_ = el;el = document.createElement("div");
        el.className = "auxbar bar bar3";this.element_.appendChild(el);this.auxbar_ = el;this.progressbar_.style.width = "0%";this.bufferbar_.style.width = "100%";this.auxbar_.style.width = "0%";this.element_.classList.add("is-upgraded");
      }
    };componentHandler.register({ constructor: MaterialProgress, classAsString: "MaterialProgress", cssClass: "mdl-js-progress", widget: true });
  })();(function () {
    var MaterialSpinner = function MaterialSpinner(element) {
      this.element_ = element;this.init();
    };window["MaterialSpinner"] = MaterialSpinner;MaterialSpinner.prototype.Constant_ = { MDL_SPINNER_LAYER_COUNT: 4 };MaterialSpinner.prototype.CssClasses_ = { MDL_SPINNER_LAYER: "mdl-spinner__layer", MDL_SPINNER_CIRCLE_CLIPPER: "mdl-spinner__circle-clipper", MDL_SPINNER_CIRCLE: "mdl-spinner__circle", MDL_SPINNER_GAP_PATCH: "mdl-spinner__gap-patch", MDL_SPINNER_LEFT: "mdl-spinner__left", MDL_SPINNER_RIGHT: "mdl-spinner__right" };
    MaterialSpinner.prototype.createLayer = function (index) {
      var layer = document.createElement("div");layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER + "-" + index);var leftClipper = document.createElement("div");leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);var gapPatch = document.createElement("div");gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);var rightClipper = document.createElement("div");rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);var circleOwners = [leftClipper, gapPatch, rightClipper];for (var i = 0; i < circleOwners.length; i++) {
        var circle = document.createElement("div");circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);circleOwners[i].appendChild(circle);
      }layer.appendChild(leftClipper);layer.appendChild(gapPatch);layer.appendChild(rightClipper);this.element_.appendChild(layer);
    };
    MaterialSpinner.prototype["createLayer"] = MaterialSpinner.prototype.createLayer;MaterialSpinner.prototype.stop = function () {
      this.element_.classList.remove("is-active");
    };MaterialSpinner.prototype["stop"] = MaterialSpinner.prototype.stop;MaterialSpinner.prototype.start = function () {
      this.element_.classList.add("is-active");
    };MaterialSpinner.prototype["start"] = MaterialSpinner.prototype.start;MaterialSpinner.prototype.init = function () {
      if (this.element_) {
        for (var i = 1; i <= this.Constant_.MDL_SPINNER_LAYER_COUNT; i++) {
          this.createLayer(i);
        }this.element_.classList.add("is-upgraded");
      }
    };componentHandler.register({ constructor: MaterialSpinner, classAsString: "MaterialSpinner", cssClass: "mdl-js-spinner", widget: true });
  })();(function () {
    var MaterialTextfield = function MaterialTextfield(element) {
      this.element_ = element;this.maxRows = this.Constant_.NO_MAX_ROWS;this.init();
    };window["MaterialTextfield"] = MaterialTextfield;MaterialTextfield.prototype.Constant_ = { NO_MAX_ROWS: -1, MAX_ROWS_ATTRIBUTE: "maxrows" };MaterialTextfield.prototype.CssClasses_ = { LABEL: "mdl-textfield__label", INPUT: "mdl-textfield__input", IS_DIRTY: "is-dirty", IS_FOCUSED: "is-focused", IS_DISABLED: "is-disabled", IS_INVALID: "is-invalid", IS_UPGRADED: "is-upgraded", HAS_PLACEHOLDER: "has-placeholder" };
    MaterialTextfield.prototype.onKeyDown_ = function (event) {
      var currentRowCount = event.target.value.split("\n").length;if (event.keyCode === 13) if (currentRowCount >= this.maxRows) event.preventDefault();
    };MaterialTextfield.prototype.onFocus_ = function (event) {
      this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
    };MaterialTextfield.prototype.onBlur_ = function (event) {
      this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
    };MaterialTextfield.prototype.onReset_ = function (event) {
      this.updateClasses_();
    };MaterialTextfield.prototype.updateClasses_ = function () {
      this.checkDisabled();this.checkValidity();this.checkDirty();this.checkFocus();
    };MaterialTextfield.prototype.checkDisabled = function () {
      if (this.input_.disabled) this.element_.classList.add(this.CssClasses_.IS_DISABLED);else this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    };MaterialTextfield.prototype["checkDisabled"] = MaterialTextfield.prototype.checkDisabled;MaterialTextfield.prototype.checkFocus = function () {
      if (Boolean(this.element_.querySelector(":focus"))) this.element_.classList.add(this.CssClasses_.IS_FOCUSED);else this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
    };MaterialTextfield.prototype["checkFocus"] = MaterialTextfield.prototype.checkFocus;MaterialTextfield.prototype.checkValidity = function () {
      if (this.input_.validity) if (this.input_.validity.valid) this.element_.classList.remove(this.CssClasses_.IS_INVALID);else this.element_.classList.add(this.CssClasses_.IS_INVALID);
    };MaterialTextfield.prototype["checkValidity"] = MaterialTextfield.prototype.checkValidity;MaterialTextfield.prototype.checkDirty = function () {
      if (this.input_.value && this.input_.value.length > 0) this.element_.classList.add(this.CssClasses_.IS_DIRTY);else this.element_.classList.remove(this.CssClasses_.IS_DIRTY);
    };MaterialTextfield.prototype["checkDirty"] = MaterialTextfield.prototype.checkDirty;MaterialTextfield.prototype.disable = function () {
      this.input_.disabled = true;this.updateClasses_();
    };MaterialTextfield.prototype["disable"] = MaterialTextfield.prototype.disable;MaterialTextfield.prototype.enable = function () {
      this.input_.disabled = false;
      this.updateClasses_();
    };MaterialTextfield.prototype["enable"] = MaterialTextfield.prototype.enable;MaterialTextfield.prototype.change = function (value) {
      this.input_.value = value || "";this.updateClasses_();
    };MaterialTextfield.prototype["change"] = MaterialTextfield.prototype.change;MaterialTextfield.prototype.init = function () {
      if (this.element_) {
        this.label_ = this.element_.querySelector("." + this.CssClasses_.LABEL);this.input_ = this.element_.querySelector("." + this.CssClasses_.INPUT);if (this.input_) {
          if (this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)) {
            this.maxRows = parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE), 10);if (isNaN(this.maxRows)) this.maxRows = this.Constant_.NO_MAX_ROWS;
          }if (this.input_.hasAttribute("placeholder")) this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);this.boundUpdateClassesHandler = this.updateClasses_.bind(this);this.boundFocusHandler = this.onFocus_.bind(this);this.boundBlurHandler = this.onBlur_.bind(this);this.boundResetHandler = this.onReset_.bind(this);this.input_.addEventListener("input", this.boundUpdateClassesHandler);
          this.input_.addEventListener("focus", this.boundFocusHandler);this.input_.addEventListener("blur", this.boundBlurHandler);this.input_.addEventListener("reset", this.boundResetHandler);if (this.maxRows !== this.Constant_.NO_MAX_ROWS) {
            this.boundKeyDownHandler = this.onKeyDown_.bind(this);this.input_.addEventListener("keydown", this.boundKeyDownHandler);
          }var invalid = this.element_.classList.contains(this.CssClasses_.IS_INVALID);this.updateClasses_();this.element_.classList.add(this.CssClasses_.IS_UPGRADED);if (invalid) this.element_.classList.add(this.CssClasses_.IS_INVALID);
          if (this.input_.hasAttribute("autofocus")) {
            this.element_.focus();this.checkFocus();
          }
        }
      }
    };componentHandler.register({ constructor: MaterialTextfield, classAsString: "MaterialTextfield", cssClass: "mdl-js-textfield", widget: true });
  })();(function () {
    var supportCustomEvent = window.CustomEvent;if (!supportCustomEvent || typeof supportCustomEvent === "object") {
      supportCustomEvent = function CustomEvent(event, x) {
        x = x || {};var ev = document.createEvent("CustomEvent");ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);return ev;
      };supportCustomEvent.prototype = window.Event.prototype;
    }function createsStackingContext(el) {
      while (el && el !== document.body) {
        var s = window.getComputedStyle(el);var invalid = function invalid(k, ok) {
          return !(s[k] === undefined || s[k] === ok);
        };if (s.opacity < 1 || invalid("zIndex", "auto") || invalid("transform", "none") || invalid("mixBlendMode", "normal") || invalid("filter", "none") || invalid("perspective", "none") || s["isolation"] === "isolate" || s.position === "fixed" || s.webkitOverflowScrolling === "touch") return true;el = el.parentElement;
      }return false;
    }function findNearestDialog(el) {
      while (el) {
        if (el.localName === "dialog") return el;el = el.parentElement;
      }return null;
    }function safeBlur(el) {
      if (el && el.blur && el !== document.body) el.blur();
    }function inNodeList(nodeList, node) {
      for (var i = 0; i < nodeList.length; ++i) {
        if (nodeList[i] === node) return true;
      }return false;
    }function isFormMethodDialog(el) {
      if (!el || !el.hasAttribute("method")) return false;return el.getAttribute("method").toLowerCase() === "dialog";
    }function dialogPolyfillInfo(dialog) {
      this.dialog_ = dialog;this.replacedStyleTop_ = false;this.openAsModal_ = false;if (!dialog.hasAttribute("role")) dialog.setAttribute("role", "dialog");dialog.show = this.show.bind(this);dialog.showModal = this.showModal.bind(this);dialog.close = this.close.bind(this);
      if (!("returnValue" in dialog)) dialog.returnValue = "";if ("MutationObserver" in window) {
        var mo = new MutationObserver(this.maybeHideModal.bind(this));mo.observe(dialog, { attributes: true, attributeFilter: ["open"] });
      } else {
        var removed = false;var cb = function () {
          removed ? this.downgradeModal() : this.maybeHideModal();removed = false;
        }.bind(this);var timeout;var delayModel = function delayModel(ev) {
          if (ev.target !== dialog) return;var cand = "DOMNodeRemoved";removed |= ev.type.substr(0, cand.length) === cand;window.clearTimeout(timeout);timeout = window.setTimeout(cb, 0);
        };["DOMAttrModified", "DOMNodeRemoved", "DOMNodeRemovedFromDocument"].forEach(function (name) {
          dialog.addEventListener(name, delayModel);
        });
      }Object.defineProperty(dialog, "open", { set: this.setOpen.bind(this), get: dialog.hasAttribute.bind(dialog, "open") });this.backdrop_ = document.createElement("div");this.backdrop_.className = "backdrop";this.backdrop_.addEventListener("click", this.backdropClick_.bind(this));
    }dialogPolyfillInfo.prototype = { get dialog() {
        return this.dialog_;
      }, maybeHideModal: function maybeHideModal() {
        if (this.dialog_.hasAttribute("open") && document.body.contains(this.dialog_)) return;this.downgradeModal();
      }, downgradeModal: function downgradeModal() {
        if (!this.openAsModal_) return;this.openAsModal_ = false;this.dialog_.style.zIndex = "";if (this.replacedStyleTop_) {
          this.dialog_.style.top = "";this.replacedStyleTop_ = false;
        }this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);dialogPolyfill.dm.removeDialog(this);
      }, setOpen: function setOpen(value) {
        if (value) this.dialog_.hasAttribute("open") || this.dialog_.setAttribute("open", "");else {
          this.dialog_.removeAttribute("open");
          this.maybeHideModal();
        }
      }, backdropClick_: function backdropClick_(e) {
        if (!this.dialog_.hasAttribute("tabindex")) {
          var fake = document.createElement("div");this.dialog_.insertBefore(fake, this.dialog_.firstChild);fake.tabIndex = -1;fake.focus();this.dialog_.removeChild(fake);
        } else this.dialog_.focus();var redirectedEvent = document.createEvent("MouseEvents");redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
        this.dialog_.dispatchEvent(redirectedEvent);e.stopPropagation();
      }, focus_: function focus_() {
        var target = this.dialog_.querySelector("[autofocus]:not([disabled])");if (!target && this.dialog_.tabIndex >= 0) target = this.dialog_;if (!target) {
          var opts = ["button", "input", "keygen", "select", "textarea"];var query = opts.map(function (el) {
            return el + ":not([disabled])";
          });query.push('[tabindex]:not([disabled]):not([tabindex=""])');target = this.dialog_.querySelector(query.join(", "));
        }safeBlur(document.activeElement);target && target.focus();
      },
      updateZIndex: function updateZIndex(dialogZ, backdropZ) {
        if (dialogZ < backdropZ) throw new Error("dialogZ should never be < backdropZ");this.dialog_.style.zIndex = dialogZ;this.backdrop_.style.zIndex = backdropZ;
      }, show: function show() {
        if (!this.dialog_.open) {
          this.setOpen(true);this.focus_();
        }
      }, showModal: function showModal() {
        if (this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");if (!document.body.contains(this.dialog_)) throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
        if (!dialogPolyfill.dm.pushDialog(this)) throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");if (createsStackingContext(this.dialog_.parentElement)) console.warn("A dialog is being shown inside a stacking context. " + "This may cause it to be unusable. For more information, see this link: " + "https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");this.setOpen(true);this.openAsModal_ = true;if (dialogPolyfill.needsCentering(this.dialog_)) {
          dialogPolyfill.reposition(this.dialog_);
          this.replacedStyleTop_ = true;
        } else this.replacedStyleTop_ = false;this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);this.focus_();
      }, close: function close(opt_returnValue) {
        if (!this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");this.setOpen(false);if (opt_returnValue !== undefined) this.dialog_.returnValue = opt_returnValue;var closeEvent = new supportCustomEvent("close", { bubbles: false,
          cancelable: false });this.dialog_.dispatchEvent(closeEvent);
      } };var dialogPolyfill = {};dialogPolyfill.reposition = function (element) {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;element.style.top = Math.max(scrollTop, topValue) + "px";
    };dialogPolyfill.isInlinePositionSetByStylesheet = function (element) {
      for (var i = 0; i < document.styleSheets.length; ++i) {
        var styleSheet = document.styleSheets[i];var cssRules = null;try {
          cssRules = styleSheet.cssRules;
        } catch (e) {}if (!cssRules) continue;for (var j = 0; j < cssRules.length; ++j) {
          var rule = cssRules[j];var selectedNodes = null;try {
            selectedNodes = document.querySelectorAll(rule.selectorText);
          } catch (e$0) {}if (!selectedNodes || !inNodeList(selectedNodes, element)) continue;var cssTop = rule.style.getPropertyValue("top");var cssBottom = rule.style.getPropertyValue("bottom");if (cssTop && cssTop !== "auto" || cssBottom && cssBottom !== "auto") return true;
        }
      }return false;
    };dialogPolyfill.needsCentering = function (dialog) {
      var computedStyle = window.getComputedStyle(dialog);if (computedStyle.position !== "absolute") return false;if (dialog.style.top !== "auto" && dialog.style.top !== "" || dialog.style.bottom !== "auto" && dialog.style.bottom !== "") return false;return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
    };dialogPolyfill.forceRegisterDialog = function (element) {
      if (window.HTMLDialogElement || element.showModal) console.warn("This browser already supports <dialog>, the polyfill " + "may not work correctly", element);if (element.localName !== "dialog") throw new Error("Failed to register dialog: The element is not a dialog.");
      new dialogPolyfillInfo(element);
    };dialogPolyfill.registerDialog = function (element) {
      if (!element.showModal) dialogPolyfill.forceRegisterDialog(element);
    };dialogPolyfill.DialogManager = function () {
      this.pendingDialogStack = [];var checkDOM = this.checkDOM_.bind(this);this.overlay = document.createElement("div");this.overlay.className = "_dialog_overlay";this.overlay.addEventListener("click", function (e) {
        this.forwardTab_ = undefined;e.stopPropagation();checkDOM([]);
      }.bind(this));this.handleKey_ = this.handleKey_.bind(this);
      this.handleFocus_ = this.handleFocus_.bind(this);this.zIndexLow_ = 1E5;this.zIndexHigh_ = 1E5 + 150;this.forwardTab_ = undefined;if ("MutationObserver" in window) this.mo_ = new MutationObserver(function (records) {
        var removed = [];records.forEach(function (rec) {
          for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
            if (!(c instanceof Element)) continue;else if (c.localName === "dialog") removed.push(c);removed = removed.concat(c.querySelectorAll("dialog"));
          }
        });removed.length && checkDOM(removed);
      });
    };dialogPolyfill.DialogManager.prototype.blockDocument = function () {
      document.documentElement.addEventListener("focus", this.handleFocus_, true);document.addEventListener("keydown", this.handleKey_);this.mo_ && this.mo_.observe(document, { childList: true, subtree: true });
    };dialogPolyfill.DialogManager.prototype.unblockDocument = function () {
      document.documentElement.removeEventListener("focus", this.handleFocus_, true);document.removeEventListener("keydown", this.handleKey_);this.mo_ && this.mo_.disconnect();
    };dialogPolyfill.DialogManager.prototype.updateStacking = function () {
      var zIndex = this.zIndexHigh_;for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
        dpi.updateZIndex(--zIndex, --zIndex);if (i === 0) this.overlay.style.zIndex = --zIndex;
      }var last = this.pendingDialogStack[0];if (last) {
        var p = last.dialog.parentNode || document.body;p.appendChild(this.overlay);
      } else if (this.overlay.parentNode) this.overlay.parentNode.removeChild(this.overlay);
    };dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function (candidate) {
      while (candidate = findNearestDialog(candidate)) {
        for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
          if (dpi.dialog === candidate) return i === 0;
        }candidate = candidate.parentElement;
      }return false;
    };dialogPolyfill.DialogManager.prototype.handleFocus_ = function (event) {
      if (this.containedByTopDialog_(event.target)) return;event.preventDefault();event.stopPropagation();safeBlur(event.target);if (this.forwardTab_ === undefined) return;var dpi = this.pendingDialogStack[0];var dialog = dpi.dialog;var position = dialog.compareDocumentPosition(event.target);if (position & Node.DOCUMENT_POSITION_PRECEDING) {
        if (this.forwardTab_) dpi.focus_();else document.documentElement.focus();
      } else ;return false;
    };dialogPolyfill.DialogManager.prototype.handleKey_ = function (event) {
      this.forwardTab_ = undefined;if (event.keyCode === 27) {
        event.preventDefault();event.stopPropagation();var cancelEvent = new supportCustomEvent("cancel", { bubbles: false, cancelable: true });var dpi = this.pendingDialogStack[0];if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) dpi.dialog.close();
      } else if (event.keyCode === 9) this.forwardTab_ = !event.shiftKey;
    };dialogPolyfill.DialogManager.prototype.checkDOM_ = function (removed) {
      var clone = this.pendingDialogStack.slice();
      clone.forEach(function (dpi) {
        if (removed.indexOf(dpi.dialog) !== -1) dpi.downgradeModal();else dpi.maybeHideModal();
      });
    };dialogPolyfill.DialogManager.prototype.pushDialog = function (dpi) {
      var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;if (this.pendingDialogStack.length >= allowed) return false;if (this.pendingDialogStack.unshift(dpi) === 1) this.blockDocument();this.updateStacking();return true;
    };dialogPolyfill.DialogManager.prototype.removeDialog = function (dpi) {
      var index = this.pendingDialogStack.indexOf(dpi);if (index === -1) return;this.pendingDialogStack.splice(index, 1);if (this.pendingDialogStack.length === 0) this.unblockDocument();this.updateStacking();
    };dialogPolyfill.dm = new dialogPolyfill.DialogManager();dialogPolyfill.formSubmitter = null;dialogPolyfill.useValue = null;if (window.HTMLDialogElement === undefined) {
      var replacementFormSubmit = function replacementFormSubmit() {
        if (!isFormMethodDialog(this)) return nativeFormSubmit.call(this);var dialog = findNearestDialog(this);dialog && dialog.close();
      };var testForm = document.createElement("form");testForm.setAttribute("method", "dialog");if (testForm.method !== "dialog") {
        var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "method");if (methodDescriptor) {
          var realGet = methodDescriptor.get;methodDescriptor.get = function () {
            if (isFormMethodDialog(this)) return "dialog";return realGet.call(this);
          };var realSet = methodDescriptor.set;methodDescriptor.set = function (v) {
            if (typeof v === "string" && v.toLowerCase() === "dialog") return this.setAttribute("method", v);return realSet.call(this, v);
          };Object.defineProperty(HTMLFormElement.prototype, "method", methodDescriptor);
        }
      }document.addEventListener("click", function (ev) {
        dialogPolyfill.formSubmitter = null;dialogPolyfill.useValue = null;if (ev.defaultPrevented) return;var target = ev.target;if (!target || !isFormMethodDialog(target.form)) return;var valid = target.type === "submit" && ["button", "input"].indexOf(target.localName) > -1;if (!valid) {
          if (!(target.localName === "input" && target.type === "image")) return;dialogPolyfill.useValue = ev.offsetX + "," + ev.offsetY;
        }var dialog = findNearestDialog(target);if (!dialog) return;
        dialogPolyfill.formSubmitter = target;
      }, false);var nativeFormSubmit = HTMLFormElement.prototype.submit;HTMLFormElement.prototype.submit = replacementFormSubmit;document.addEventListener("submit", function (ev) {
        var form = ev.target;if (!isFormMethodDialog(form)) return;ev.preventDefault();var dialog = findNearestDialog(form);if (!dialog) return;var s = dialogPolyfill.formSubmitter;if (s && s.form === form) dialog.close(dialogPolyfill.useValue || s.value);else dialog.close();dialogPolyfill.formSubmitter = null;
      }, true);
    }dialogPolyfill["forceRegisterDialog"] = dialogPolyfill.forceRegisterDialog;dialogPolyfill["registerDialog"] = dialogPolyfill.registerDialog;if ("function" === "function" && "amd" in __webpack_require__("lfEA")) !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return dialogPolyfill;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if (typeof module === "object" && typeof module["exports"] === "object") module["exports"] = dialogPolyfill;else window["dialogPolyfill"] = dialogPolyfill;
  })();(function () {
    var h,
        l = this;function m(a) {
      return void 0 !== a;
    }function aa() {}function ba(a) {
      var b = typeof a;if ("object" == b) {
        if (a) {
          if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
        } else return "null";
      } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
    }function ca(a) {
      return null != a;
    }function da(a) {
      return "array" == ba(a);
    }function ea(a) {
      var b = ba(a);return "array" == b || "object" == b && "number" == typeof a.length;
    }function n(a) {
      return "string" == typeof a;
    }function fa(a) {
      return "number" == typeof a;
    }function ga(a) {
      return "function" == ba(a);
    }function ha(a) {
      var b = typeof a;return "object" == b && null != a || "function" == b;
    }var ia = "closure_uid_" + (1E9 * Math.random() >>> 0),
        ja = 0;function ka(a, b, c) {
      return a.call.apply(a.bind, arguments);
    }function la(a, b, c) {
      if (!a) throw Error();if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);return function () {
          var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
        };
      }return function () {
        return a.apply(b, arguments);
      };
    }function p(a, b, c) {
      p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ka : la;return p.apply(null, arguments);
    }function ma(a, b) {
      var c = Array.prototype.slice.call(arguments, 1);return function () {
        var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
      };
    }function q(a, b) {
      for (var c in b) {
        a[c] = b[c];
      }
    }var na = Date.now || function () {
      return +new Date();
    };function oa(a, b) {
      a = a.split(".");var c = l;a[0] in c || !c.execScript || c.execScript("var " + a[0]);for (var d; a.length && (d = a.shift());) {
        !a.length && m(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
      }
    }function t(a, b) {
      function c() {}c.prototype = b.prototype;a.h = b.prototype;
      a.prototype = new c();a.prototype.constructor = a;a.Pe = function (a, c, f) {
        for (var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++) {
          g[k - 2] = arguments[k];
        }return b.prototype[c].apply(a, g);
      };
    }function pa(a) {
      if (Error.captureStackTrace) Error.captureStackTrace(this, pa);else {
        var b = Error().stack;b && (this.stack = b);
      }a && (this.message = String(a));
    }t(pa, Error);pa.prototype.name = "CustomError";var qa;function ra(a, b) {
      for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
        d += c.shift() + e.shift();
      }return d + c.join("%s");
    }var sa = String.prototype.trim ? function (a) {
      return a.trim();
    } : function (a) {
      return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
    };function ta(a) {
      if (!ua.test(a)) return a;-1 != a.indexOf("&") && (a = a.replace(va, "&amp;"));-1 != a.indexOf("<") && (a = a.replace(wa, "&lt;"));-1 != a.indexOf(">") && (a = a.replace(xa, "&gt;"));-1 != a.indexOf('"') && (a = a.replace(ya, "&quot;"));-1 != a.indexOf("'") && (a = a.replace(za, "&#39;"));-1 != a.indexOf("\x00") && (a = a.replace(Aa, "&#0;"));return a;
    }var va = /&/g,
        wa = /</g,
        xa = />/g,
        ya = /"/g,
        za = /'/g,
        Aa = /\x00/g,
        ua = /[\x00&<>"']/;function Ba(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    }function Ca(a, b) {
      b.unshift(a);pa.call(this, ra.apply(null, b));b.shift();
    }t(Ca, pa);Ca.prototype.name = "AssertionError";function Da(a, b) {
      throw new Ca("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    }var Ea = Array.prototype.indexOf ? function (a, b, c) {
      return Array.prototype.indexOf.call(a, b, c);
    } : function (a, b, c) {
      c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (n(a)) return n(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
        if (c in a && a[c] === b) return c;
      }return -1;
    },
        Ga = Array.prototype.forEach ? function (a, b, c) {
      Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
        f in e && b.call(c, e[f], f, a);
      }
    };function Ha(a, b) {
      for (var c = n(a) ? a.split("") : a, d = a.length - 1; 0 <= d; --d) {
        d in c && b.call(void 0, c[d], d, a);
      }
    }var Ia = Array.prototype.filter ? function (a, b, c) {
      return Array.prototype.filter.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = [], f = 0, g = n(a) ? a.split("") : a, k = 0; k < d; k++) {
        if (k in g) {
          var r = g[k];b.call(c, r, k, a) && (e[f++] = r);
        }
      }return e;
    },
        Ja = Array.prototype.map ? function (a, b, c) {
      return Array.prototype.map.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = Array(d), f = n(a) ? a.split("") : a, g = 0; g < d; g++) {
        g in f && (e[g] = b.call(c, f[g], g, a));
      }return e;
    },
        Ka = Array.prototype.some ? function (a, b, c) {
      return Array.prototype.some.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
        if (f in e && b.call(c, e[f], f, a)) return !0;
      }return !1;
    };function La(a, b, c) {
      for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
        if (f in e && b.call(c, e[f], f, a)) return f;
      }return -1;
    }function Ma(a, b) {
      return 0 <= Ea(a, b);
    }function Na(a, b) {
      b = Ea(a, b);var c;(c = 0 <= b) && Oa(a, b);return c;
    }function Oa(a, b) {
      return 1 == Array.prototype.splice.call(a, b, 1).length;
    }function Pa(a, b) {
      b = La(a, b, void 0);0 <= b && Oa(a, b);
    }function Qa(a, b) {
      var c = 0;Ha(a, function (d, e) {
        b.call(void 0, d, e, a) && Oa(a, e) && c++;
      });
    }function Ra(a) {
      return Array.prototype.concat.apply([], arguments);
    }function Sa(a) {
      var b = a.length;if (0 < b) {
        for (var c = Array(b), d = 0; d < b; d++) {
          c[d] = a[d];
        }return c;
      }return [];
    }var Ta;
    a: {
      var Ua = l.navigator;if (Ua) {
        var Va = Ua.userAgent;if (Va) {
          Ta = Va;break a;
        }
      }Ta = "";
    }function u(a) {
      return -1 != Ta.indexOf(a);
    }function Wa(a, b, c) {
      for (var d in a) {
        b.call(c, a[d], d, a);
      }
    }function Xa(a, b) {
      for (var c in a) {
        if (b.call(void 0, a[c], c, a)) return !0;
      }return !1;
    }function Ya(a) {
      var b = [],
          c = 0,
          d;for (d in a) {
        b[c++] = a[d];
      }return b;
    }function Za(a) {
      var b = [],
          c = 0,
          d;for (d in a) {
        b[c++] = d;
      }return b;
    }function $a(a) {
      var b = {},
          c;for (c in a) {
        b[c] = a[c];
      }return b;
    }var ab = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function bb(a, b) {
      for (var c, d, e = 1; e < arguments.length; e++) {
        d = arguments[e];for (c in d) {
          a[c] = d[c];
        }for (var f = 0; f < ab.length; f++) {
          c = ab[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
      }
    }function cb(a) {
      var b = arguments.length;if (1 == b && da(arguments[0])) return cb.apply(null, arguments[0]);for (var c = {}, d = 0; d < b; d++) {
        c[arguments[d]] = !0;
      }return c;
    }function db(a) {
      db[" "](a);return a;
    }db[" "] = aa;function eb(a, b) {
      var c = fb;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    }var gb = u("Opera"),
        v = u("Trident") || u("MSIE"),
        hb = u("Edge"),
        ib = hb || v,
        jb = u("Gecko") && !(-1 != Ta.toLowerCase().indexOf("webkit") && !u("Edge")) && !(u("Trident") || u("MSIE")) && !u("Edge"),
        w = -1 != Ta.toLowerCase().indexOf("webkit") && !u("Edge"),
        kb = w && u("Mobile"),
        lb = u("Macintosh");function mb() {
      var a = l.document;return a ? a.documentMode : void 0;
    }var nb;a: {
      var ob = "",
          pb = function () {
        var a = Ta;if (jb) return (/rv\:([^\);]+)(\)|;)/.exec(a)
        );if (hb) return (/Edge\/([\d\.]+)/.exec(a)
        );if (v) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
        );if (w) return (/WebKit\/(\S+)/.exec(a)
        );
        if (gb) return (/(?:Version)[ \/]?(\S+)/.exec(a)
        );
      }();pb && (ob = pb ? pb[1] : "");if (v) {
        var qb = mb();if (null != qb && qb > parseFloat(ob)) {
          nb = String(qb);break a;
        }
      }nb = ob;
    }var fb = {};function x(a) {
      return eb(a, function () {
        for (var b = 0, c = sa(String(nb)).split("."), d = sa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
          var g = c[f] || "",
              k = d[f] || "";do {
            g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];if (0 == g[0].length && 0 == k[0].length) break;b = Ba(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == k[1].length ? 0 : parseInt(k[1], 10)) || Ba(0 == g[2].length, 0 == k[2].length) || Ba(g[2], k[2]);g = g[3];k = k[3];
          } while (0 == b);
        }return 0 <= b;
      });
    }var rb = l.document,
        sb = rb && v ? mb() || ("CSS1Compat" == rb.compatMode ? parseInt(nb, 10) : 5) : void 0;var tb = !v || 9 <= Number(sb),
        ub = !jb && !v || v && 9 <= Number(sb) || jb && x("1.9.1");v && x("9");function y(a) {
      this.ze = a;
    }y.prototype.toString = function () {
      return this.ze;
    };var vb = new y("A"),
        wb = new y("APPLET"),
        xb = new y("AREA"),
        yb = new y("BASE"),
        zb = new y("BR"),
        Ab = new y("BUTTON"),
        Bb = new y("COL"),
        Cb = new y("COMMAND"),
        Db = new y("DIV"),
        Eb = new y("EMBED"),
        Fb = new y("FRAME"),
        Gb = new y("HEAD"),
        Hb = new y("HR"),
        Ib = new y("IFRAME"),
        Jb = new y("IMG"),
        Kb = new y("INPUT"),
        Lb = new y("ISINDEX"),
        Mb = new y("KEYGEN"),
        Nb = new y("LINK"),
        Ob = new y("MATH"),
        Pb = new y("META"),
        Qb = new y("NOFRAMES"),
        Rb = new y("NOSCRIPT"),
        Sb = new y("OBJECT"),
        Tb = new y("PARAM"),
        Ub = new y("SCRIPT"),
        Vb = new y("SOURCE"),
        Wb = new y("STYLE"),
        Xb = new y("SVG"),
        Yb = new y("TEMPLATE"),
        Zb = new y("TEXTAREA"),
        $b = new y("TRACK"),
        ac = new y("WBR");function bc() {
      this.Xb = "";this.vd = cc;
    }bc.prototype.Hb = !0;bc.prototype.Bb = function () {
      return this.Xb;
    };bc.prototype.toString = function () {
      return "Const{" + this.Xb + "}";
    };var cc = {};function dc(a) {
      var b = new bc();b.Xb = a;return b;
    }dc("");function ec() {
      this.Qb = "";this.wd = fc;
    }ec.prototype.Hb = !0;ec.prototype.Bb = function () {
      return this.Qb;
    };ec.prototype.lc = function () {
      return 1;
    };ec.prototype.toString = function () {
      return "TrustedResourceUrl{" + this.Qb + "}";
    };function gc() {
      var a = dc("//www.gstatic.com/accountchooser/client.js");a instanceof bc && a.constructor === bc && a.vd === cc ? a = a.Xb : (Da("expected object of type Const, got '" + a + "'"), a = "type_error:Const");var b = new ec();b.Qb = a;return b;
    }var fc = {};function hc() {
      this.ia = "";this.ud = ic;
    }hc.prototype.Hb = !0;hc.prototype.Bb = function () {
      return this.ia;
    };hc.prototype.lc = function () {
      return 1;
    };hc.prototype.toString = function () {
      return "SafeUrl{" + this.ia + "}";
    };function jc(a) {
      if (a instanceof hc && a.constructor === hc && a.ud === ic) return a.ia;Da("expected object of type SafeUrl, got '" + a + "' of type " + ba(a));return "type_error:SafeUrl";
    }var kc = /^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i;function lc(a) {
      if (a instanceof hc) return a;a = a.Hb ? a.Bb() : String(a);kc.test(a) || (a = "about:invalid#zClosurez");return mc(a);
    }var ic = {};function mc(a) {
      var b = new hc();b.ia = a;return b;
    }mc("about:blank");function nc() {
      this.ia = "";this.td = oc;this.Nc = null;
    }nc.prototype.lc = function () {
      return this.Nc;
    };nc.prototype.Hb = !0;nc.prototype.Bb = function () {
      return this.ia;
    };nc.prototype.toString = function () {
      return "SafeHtml{" + this.ia + "}";
    };function pc(a) {
      if (a instanceof nc && a.constructor === nc && a.td === oc) return a.ia;Da("expected object of type SafeHtml, got '" + a + "' of type " + ba(a));return "type_error:SafeHtml";
    }cb(wb, yb, Eb, Ib, Nb, Ob, Pb, Sb, Ub, Wb, Xb, Yb);var oc = {};nc.prototype.ee = function (a) {
      this.ia = a;this.Nc = null;return this;
    };function qc(a, b) {
      this.x = m(a) ? a : 0;this.y = m(b) ? b : 0;
    }h = qc.prototype;h.clone = function () {
      return new qc(this.x, this.y);
    };h.toString = function () {
      return "(" + this.x + ", " + this.y + ")";
    };h.ceil = function () {
      this.x = Math.ceil(this.x);this.y = Math.ceil(this.y);return this;
    };h.floor = function () {
      this.x = Math.floor(this.x);this.y = Math.floor(this.y);return this;
    };h.round = function () {
      this.x = Math.round(this.x);this.y = Math.round(this.y);return this;
    };h.translate = function (a, b) {
      a instanceof qc ? (this.x += a.x, this.y += a.y) : (this.x += Number(a), fa(b) && (this.y += b));return this;
    };h.scale = function (a, b) {
      b = fa(b) ? b : a;this.x *= a;this.y *= b;return this;
    };function rc(a, b) {
      this.width = a;this.height = b;
    }h = rc.prototype;h.clone = function () {
      return new rc(this.width, this.height);
    };h.toString = function () {
      return "(" + this.width + " x " + this.height + ")";
    };h.Ad = function () {
      return this.width * this.height;
    };h.Jb = function () {
      return !this.Ad();
    };
    h.ceil = function () {
      this.width = Math.ceil(this.width);this.height = Math.ceil(this.height);return this;
    };h.floor = function () {
      this.width = Math.floor(this.width);this.height = Math.floor(this.height);return this;
    };h.round = function () {
      this.width = Math.round(this.width);this.height = Math.round(this.height);return this;
    };h.scale = function (a, b) {
      b = fa(b) ? b : a;this.width *= a;this.height *= b;return this;
    };function sc(a) {
      return a ? new tc(uc(a)) : qa || (qa = new tc());
    }function vc(a, b) {
      var c = b || document;return c.querySelectorAll && c.querySelector ? c.querySelectorAll("." + a) : wc(a, b);
    }function xc(a, b) {
      var c = b || document;return (c.getElementsByClassName ? c.getElementsByClassName(a)[0] : c.querySelectorAll && c.querySelector ? c.querySelector("." + a) : wc(a, b)[0]) || null;
    }function wc(a, b) {
      var c, d, e;c = document;b = b || c;if (b.querySelectorAll && b.querySelector && a) return b.querySelectorAll("" + (a ? "." + a : ""));if (a && b.getElementsByClassName) {
        var f = b.getElementsByClassName(a);return f;
      }f = b.getElementsByTagName("*");if (a) {
        e = {};for (c = d = 0; b = f[c]; c++) {
          var g = b.className;"function" == typeof g.split && Ma(g.split(/\s+/), a) && (e[d++] = b);
        }e.length = d;return e;
      }return f;
    }function yc(a, b) {
      Wa(b, function (b, d) {
        "style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : zc.hasOwnProperty(d) ? a.setAttribute(zc[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b;
      });
    }var zc = { cellpadding: "cellPadding", cellspacing: "cellSpacing", colspan: "colSpan", frameborder: "frameBorder", height: "height", maxlength: "maxLength", nonce: "nonce", role: "role", rowspan: "rowSpan",
      type: "type", usemap: "useMap", valign: "vAlign", width: "width" };function Ac(a) {
      return a.scrollingElement ? a.scrollingElement : w || "CSS1Compat" != a.compatMode ? a.body || a.documentElement : a.documentElement;
    }function Bc(a, b, c, d) {
      function e(c) {
        c && b.appendChild(n(c) ? a.createTextNode(c) : c);
      }for (; d < c.length; d++) {
        var f = c[d];!ea(f) || ha(f) && 0 < f.nodeType ? e(f) : Ga(Cc(f) ? Sa(f) : f, e);
      }
    }function Dc(a) {
      return a && a.parentNode ? a.parentNode.removeChild(a) : null;
    }function uc(a) {
      return 9 == a.nodeType ? a : a.ownerDocument || a.document;
    }function Ec(a, b) {
      if ("textContent" in a) a.textContent = b;else if (3 == a.nodeType) a.data = b;else if (a.firstChild && 3 == a.firstChild.nodeType) {
        for (; a.lastChild != a.firstChild;) {
          a.removeChild(a.lastChild);
        }a.firstChild.data = b;
      } else {
        for (var c; c = a.firstChild;) {
          a.removeChild(c);
        }a.appendChild(uc(a).createTextNode(String(b)));
      }
    }function Cc(a) {
      if (a && "number" == typeof a.length) {
        if (ha(a)) return "function" == typeof a.item || "string" == typeof a.item;if (ga(a)) return "function" == typeof a.item;
      }return !1;
    }function Fc(a, b) {
      return b ? Gc(a, function (a) {
        return !b || n(a.className) && Ma(a.className.split(/\s+/), b);
      }) : null;
    }function Gc(a, b) {
      for (var c = 0; a;) {
        if (b(a)) return a;a = a.parentNode;c++;
      }return null;
    }function tc(a) {
      this.Y = a || l.document || document;
    }h = tc.prototype;h.Pa = sc;h.L = function (a) {
      return n(a) ? this.Y.getElementById(a) : a;
    };h.getElementsByTagName = function (a, b) {
      return (b || this.Y).getElementsByTagName(String(a));
    };h.mc = function (a, b) {
      return vc(a, b || this.Y);
    };h.o = function (a, b) {
      return xc(a, b || this.Y);
    };h.hc = function (a, b, c) {
      var d = this.Y,
          e = arguments,
          f = String(e[0]),
          g = e[1];
      if (!tb && g && (g.name || g.type)) {
        f = ["<", f];g.name && f.push(' name="', ta(g.name), '"');if (g.type) {
          f.push(' type="', ta(g.type), '"');var k = {};bb(k, g);delete k.type;g = k;
        }f.push(">");f = f.join("");
      }f = d.createElement(f);g && (n(g) ? f.className = g : da(g) ? f.className = g.join(" ") : yc(f, g));2 < e.length && Bc(d, f, e, 2);return f;
    };h.createElement = function (a) {
      return this.Y.createElement(String(a));
    };h.createTextNode = function (a) {
      return this.Y.createTextNode(String(a));
    };h.appendChild = function (a, b) {
      a.appendChild(b);
    };h.append = function (a, b) {
      Bc(uc(a), a, arguments, 1);
    };h.canHaveChildren = function (a) {
      if (1 != a.nodeType) return !1;switch (a.tagName) {case String(wb):case String(xb):case String(yb):case String(zb):case String(Bb):case String(Cb):case String(Eb):case String(Fb):case String(Hb):case String(Jb):case String(Kb):case String(Ib):case String(Lb):case String(Mb):case String(Nb):case String(Qb):case String(Rb):case String(Pb):case String(Sb):case String(Tb):case String(Ub):case String(Vb):case String(Wb):case String($b):case String(ac):
          return !1;}return !0;
    };
    h.removeNode = Dc;h.Rc = function (a) {
      return ub && void 0 != a.children ? a.children : Ia(a.childNodes, function (a) {
        return 1 == a.nodeType;
      });
    };h.contains = function (a, b) {
      if (!a || !b) return !1;if (a.contains && 1 == b.nodeType) return a == b || a.contains(b);if ("undefined" != typeof a.compareDocumentPosition) return a == b || !!(a.compareDocumentPosition(b) & 16);for (; b && a != b;) {
        b = b.parentNode;
      }return b == a;
    };v && x(8);function Hc(a) {
      if (a.R && "function" == typeof a.R) return a.R();if (n(a)) return a.split("");if (ea(a)) {
        for (var b = [], c = a.length, d = 0; d < c; d++) {
          b.push(a[d]);
        }return b;
      }return Ya(a);
    }function Ic(a) {
      if (a.ga && "function" == typeof a.ga) return a.ga();if (!a.R || "function" != typeof a.R) {
        if (ea(a) || n(a)) {
          var b = [];a = a.length;for (var c = 0; c < a; c++) {
            b.push(c);
          }return b;
        }return Za(a);
      }
    }function Jc(a, b, c) {
      if (a.forEach && "function" == typeof a.forEach) a.forEach(b, c);else if (ea(a) || n(a)) Ga(a, b, c);else for (var d = Ic(a), e = Hc(a), f = e.length, g = 0; g < f; g++) {
        b.call(c, e[g], d && d[g], a);
      }
    }var Kc = "StopIteration" in l ? l.StopIteration : { message: "StopIteration", stack: "" };function Lc() {}Lc.prototype.next = function () {
      throw Kc;
    };Lc.prototype.va = function () {
      return this;
    };function Mc(a) {
      if (a instanceof Lc) return a;if ("function" == typeof a.va) return a.va(!1);if (ea(a)) {
        var b = 0,
            c = new Lc();c.next = function () {
          for (;;) {
            if (b >= a.length) throw Kc;if (b in a) return a[b++];b++;
          }
        };return c;
      }throw Error("Not implemented");
    }function Nc(a, b) {
      if (ea(a)) try {
        Ga(a, b, void 0);
      } catch (c) {
        if (c !== Kc) throw c;
      } else {
        a = Mc(a);try {
          for (;;) {
            b.call(void 0, a.next(), void 0, a);
          }
        } catch (c$1) {
          if (c$1 !== Kc) throw c$1;
        }
      }
    }function Oc(a) {
      if (ea(a)) return Sa(a);a = Mc(a);var b = [];Nc(a, function (a) {
        b.push(a);
      });return b;
    }function Pc(a, b) {
      this.V = {};this.u = [];this.Xa = this.v = 0;var c = arguments.length;if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
          this.set(arguments[d], arguments[d + 1]);
        }
      } else a && this.addAll(a);
    }h = Pc.prototype;h.R = function () {
      Qc(this);for (var a = [], b = 0; b < this.u.length; b++) {
        a.push(this.V[this.u[b]]);
      }return a;
    };h.ga = function () {
      Qc(this);return this.u.concat();
    };h.Ma = function (a) {
      return Rc(this.V, a);
    };h.Jb = function () {
      return 0 == this.v;
    };
    h.clear = function () {
      this.V = {};this.Xa = this.v = this.u.length = 0;
    };h.remove = function (a) {
      return Rc(this.V, a) ? (delete this.V[a], this.v--, this.Xa++, this.u.length > 2 * this.v && Qc(this), !0) : !1;
    };function Qc(a) {
      if (a.v != a.u.length) {
        for (var b = 0, c = 0; b < a.u.length;) {
          var d = a.u[b];Rc(a.V, d) && (a.u[c++] = d);b++;
        }a.u.length = c;
      }if (a.v != a.u.length) {
        for (var e = {}, c = b = 0; b < a.u.length;) {
          d = a.u[b], Rc(e, d) || (a.u[c++] = d, e[d] = 1), b++;
        }a.u.length = c;
      }
    }h.get = function (a, b) {
      return Rc(this.V, a) ? this.V[a] : b;
    };h.set = function (a, b) {
      Rc(this.V, a) || (this.v++, this.u.push(a), this.Xa++);this.V[a] = b;
    };h.addAll = function (a) {
      var b;a instanceof Pc ? (b = a.ga(), a = a.R()) : (b = Za(a), a = Ya(a));for (var c = 0; c < b.length; c++) {
        this.set(b[c], a[c]);
      }
    };h.forEach = function (a, b) {
      for (var c = this.ga(), d = 0; d < c.length; d++) {
        var e = c[d],
            f = this.get(e);a.call(b, f, e, this);
      }
    };h.clone = function () {
      return new Pc(this);
    };h.va = function (a) {
      Qc(this);var b = 0,
          c = this.Xa,
          d = this,
          e = new Lc();e.next = function () {
        if (c != d.Xa) throw Error("The map has changed since the iterator was created");if (b >= d.u.length) throw Kc;var e = d.u[b++];return a ? e : d.V[e];
      };return e;
    };function Rc(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }var Sc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Tc(a, b) {
      if (a) {
        a = a.split("&");for (var c = 0; c < a.length; c++) {
          var d = a[c].indexOf("="),
              e,
              f = null;0 <= d ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
        }
      }
    }function Uc(a, b, c, d) {
      for (var e = c.length; 0 <= (b = a.indexOf(c, b)) && b < d;) {
        var f = a.charCodeAt(b - 1);if (38 == f || 63 == f) if (f = a.charCodeAt(b + e), !f || 61 == f || 38 == f || 35 == f) return b;b += e + 1;
      }return -1;
    }var Vc = /#|$/;function Wc(a, b) {
      var c = a.search(Vc),
          d = Uc(a, 0, b, c);if (0 > d) return null;var e = a.indexOf("&", d);if (0 > e || e > c) e = c;d += b.length + 1;return decodeURIComponent(a.substr(d, e - d).replace(/\+/g, " "));
    }var Xc = /[?&]($|#)/;function Yc(a, b) {
      this.fa = this.Ka = this.ua = "";this.Ta = null;this.Aa = this.da = "";this.S = this.fe = !1;var c;a instanceof Yc ? (this.S = m(b) ? b : a.S, Zc(this, a.ua), c = a.Ka, z(this), this.Ka = c, c = a.fa, z(this), this.fa = c, $c(this, a.Ta), c = a.da, z(this), this.da = c, ad(this, a.ja.clone()), a = a.Aa, z(this), this.Aa = a) : a && (c = String(a).match(Sc)) ? (this.S = !!b, Zc(this, c[1] || "", !0), a = c[2] || "", z(this), this.Ka = bd(a), a = c[3] || "", z(this), this.fa = bd(a, !0), $c(this, c[4]), a = c[5] || "", z(this), this.da = bd(a, !0), ad(this, c[6] || "", !0), a = c[7] || "", z(this), this.Aa = bd(a)) : (this.S = !!b, this.ja = new cd(null, 0, this.S));
    }Yc.prototype.toString = function () {
      var a = [],
          b = this.ua;b && a.push(dd(b, ed, !0), ":");var c = this.fa;if (c || "file" == b) a.push("//"), (b = this.Ka) && a.push(dd(b, ed, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.Ta, null != c && a.push(":", String(c));if (c = this.da) this.fa && "/" != c.charAt(0) && a.push("/"), a.push(dd(c, "/" == c.charAt(0) ? fd : gd, !0));(c = this.ja.toString()) && a.push("?", c);(c = this.Aa) && a.push("#", dd(c, hd));return a.join("");
    };Yc.prototype.resolve = function (a) {
      var b = this.clone(),
          c = !!a.ua;c ? Zc(b, a.ua) : c = !!a.Ka;if (c) {
        var d = a.Ka;z(b);b.Ka = d;
      } else c = !!a.fa;c ? (d = a.fa, z(b), b.fa = d) : c = null != a.Ta;d = a.da;if (c) $c(b, a.Ta);else if (c = !!a.da) {
        if ("/" != d.charAt(0)) if (this.fa && !this.da) d = "/" + d;else {
          var e = b.da.lastIndexOf("/");-1 != e && (d = b.da.substr(0, e + 1) + d);
        }e = d;if (".." == e || "." == e) d = "";else if (-1 != e.indexOf("./") || -1 != e.indexOf("/.")) {
          for (var d = 0 == e.lastIndexOf("/", 0), e = e.split("/"), f = [], g = 0; g < e.length;) {
            var k = e[g++];"." == k ? d && g == e.length && f.push("") : ".." == k ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
          }d = f.join("/");
        } else d = e;
      }c ? (z(b), b.da = d) : c = "" !== a.ja.toString();
      c ? ad(b, a.ja.clone()) : c = !!a.Aa;c && (a = a.Aa, z(b), b.Aa = a);return b;
    };Yc.prototype.clone = function () {
      return new Yc(this);
    };function Zc(a, b, c) {
      z(a);a.ua = c ? bd(b, !0) : b;a.ua && (a.ua = a.ua.replace(/:$/, ""));
    }function $c(a, b) {
      z(a);if (b) {
        b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.Ta = b;
      } else a.Ta = null;
    }function ad(a, b, c) {
      z(a);b instanceof cd ? (a.ja = b, a.ja.Cc(a.S)) : (c || (b = dd(b, id)), a.ja = new cd(b, 0, a.S));
    }function z(a) {
      if (a.fe) throw Error("Tried to modify a read-only Uri");
    }Yc.prototype.Cc = function (a) {
      this.S = a;this.ja && this.ja.Cc(a);return this;
    };function jd(a) {
      return a instanceof Yc ? a.clone() : new Yc(a, void 0);
    }function kd(a) {
      var b = window.location.href;b instanceof Yc || (b = jd(b));a instanceof Yc || (a = jd(a));return b.resolve(a);
    }function bd(a, b) {
      return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }function dd(a, b, c) {
      return n(a) ? (a = encodeURI(a).replace(b, ld), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }function ld(a) {
      a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var ed = /[#\/\?@]/g,
        gd = /[\#\?:]/g,
        fd = /[\#\?]/g,
        id = /[\#\?@]/g,
        hd = /#/g;function cd(a, b, c) {
      this.v = this.C = null;this.O = a || null;this.S = !!c;
    }function md(a) {
      a.C || (a.C = new Pc(), a.v = 0, a.O && Tc(a.O, function (b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
      }));
    }h = cd.prototype;h.add = function (a, b) {
      md(this);this.O = null;a = nd(this, a);var c = this.C.get(a);c || this.C.set(a, c = []);c.push(b);this.v += 1;return this;
    };h.remove = function (a) {
      md(this);a = nd(this, a);return this.C.Ma(a) ? (this.O = null, this.v -= this.C.get(a).length, this.C.remove(a)) : !1;
    };h.clear = function () {
      this.C = this.O = null;this.v = 0;
    };h.Jb = function () {
      md(this);return 0 == this.v;
    };h.Ma = function (a) {
      md(this);a = nd(this, a);return this.C.Ma(a);
    };h.ga = function () {
      md(this);for (var a = this.C.R(), b = this.C.ga(), c = [], d = 0; d < b.length; d++) {
        for (var e = a[d], f = 0; f < e.length; f++) {
          c.push(b[d]);
        }
      }return c;
    };h.R = function (a) {
      md(this);var b = [];if (n(a)) this.Ma(a) && (b = Ra(b, this.C.get(nd(this, a))));else {
        a = this.C.R();for (var c = 0; c < a.length; c++) {
          b = Ra(b, a[c]);
        }
      }return b;
    };h.set = function (a, b) {
      md(this);this.O = null;a = nd(this, a);this.Ma(a) && (this.v -= this.C.get(a).length);this.C.set(a, [b]);this.v += 1;return this;
    };h.get = function (a, b) {
      a = a ? this.R(a) : [];return 0 < a.length ? String(a[0]) : b;
    };h.toString = function () {
      if (this.O) return this.O;if (!this.C) return "";for (var a = [], b = this.C.ga(), c = 0; c < b.length; c++) {
        for (var d = b[c], e = encodeURIComponent(String(d)), d = this.R(d), f = 0; f < d.length; f++) {
          var g = e;"" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));a.push(g);
        }
      }return this.O = a.join("&");
    };h.clone = function () {
      var a = new cd();a.O = this.O;this.C && (a.C = this.C.clone(), a.v = this.v);return a;
    };function nd(a, b) {
      b = String(b);a.S && (b = b.toLowerCase());return b;
    }h.Cc = function (a) {
      a && !this.S && (md(this), this.O = null, this.C.forEach(function (a, c) {
        var d = c.toLowerCase();c != d && (this.remove(c), this.remove(d), 0 < a.length && (this.O = null, this.C.set(nd(this, d), Sa(a)), this.v += a.length));
      }, this));this.S = a;
    };h.extend = function (a) {
      for (var b = 0; b < arguments.length; b++) {
        Jc(arguments[b], function (a, b) {
          this.add(b, a);
        }, this);
      }
    };var od = { bf: !0 },
        pd = { df: !0 },
        qd = { cf: !0 };function A() {
      throw Error("Do not instantiate directly");
    }A.prototype.oa = null;A.prototype.toString = function () {
      return this.content;
    };function rd(a, b, c, d) {
      a: if (a = a(b || sd, void 0, c), d = (d || sc()).createElement(Db), a = td(a), a.match(ud), d.innerHTML = a, 1 == d.childNodes.length && (a = d.firstChild, 1 == a.nodeType)) {
        d = a;break a;
      }return d;
    }function td(a) {
      if (!ha(a)) return String(a);if (a instanceof A) {
        if (a.X === od) return a.content;if (a.X === qd) return ta(a.content);
      }Da("Soy template output is unsafe for use as HTML: " + a);return "zSoyz";
    }var ud = /^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i,
        sd = {};function vd(a) {
      if (null != a) switch (a.oa) {case 1:
          return 1;case -1:
          return -1;case 0:
          return 0;}return null;
    }function wd() {
      A.call(this);
    }t(wd, A);wd.prototype.X = od;function B(a) {
      return null != a && a.X === od ? a : a instanceof nc ? C(pc(a), a.lc()) : C(ta(String(String(a))), vd(a));
    }function xd() {
      A.call(this);
    }t(xd, A);xd.prototype.X = { af: !0 };xd.prototype.oa = 1;function yd() {
      A.call(this);
    }t(yd, A);yd.prototype.X = pd;yd.prototype.oa = 1;function zd() {
      A.call(this);
    }t(zd, A);zd.prototype.X = { $e: !0 };zd.prototype.oa = 1;function Ad() {
      A.call(this);
    }
    t(Ad, A);Ad.prototype.X = { Ze: !0 };Ad.prototype.oa = 1;function Bd(a, b) {
      this.content = String(a);this.oa = null != b ? b : null;
    }t(Bd, A);Bd.prototype.X = qd;function Cd(a) {
      function b(a) {
        this.content = a;
      }b.prototype = a.prototype;return function (a) {
        return new b(String(a));
      };
    }function D(a) {
      return new Bd(a, void 0);
    }var C = function (a) {
      function b(a) {
        this.content = a;
      }b.prototype = a.prototype;return function (a, d) {
        a = new b(String(a));void 0 !== d && (a.oa = d);return a;
      };
    }(wd);Cd(xd);var Dd = Cd(yd);Cd(zd);Cd(Ad);function Ed(a) {
      var b = { label: Fd("New password") };
      function c() {}c.prototype = a;a = new c();for (var d in b) {
        a[d] = b[d];
      }return a;
    }function Fd(a) {
      return (a = String(a)) ? new Bd(a, void 0) : "";
    }var Gd = function (a) {
      function b(a) {
        this.content = a;
      }b.prototype = a.prototype;return function (a, d) {
        a = String(a);if (!a) return "";a = new b(a);void 0 !== d && (a.oa = d);return a;
      };
    }(wd);function Hd(a) {
      return null != a && a.X === od ? String(String(a.content).replace(Id, "").replace(Jd, "&lt;")).replace(Kd, Ld) : ta(String(a));
    }function Md(a) {
      null != a && a.X === pd ? a = String(a).replace(Nd, Od) : a instanceof hc ? a = String(jc(a)).replace(Nd, Od) : (a = String(a), Pd.test(a) ? a = a.replace(Nd, Od) : (Da("Bad value `%s` for |filterNormalizeUri", [a]), a = "#zSoyz"));return a;
    }var Qd = { "\x00": "&#0;", "\t": "&#9;", "\n": "&#10;", "\x0B": "&#11;", "\f": "&#12;", "\r": "&#13;", " ": "&#32;", '"': "&quot;", "&": "&amp;", "'": "&#39;", "-": "&#45;", "/": "&#47;", "<": "&lt;", "=": "&#61;", ">": "&gt;", "`": "&#96;", '\x85': "&#133;", '\xA0': "&#160;", '\u2028': "&#8232;", '\u2029': "&#8233;" };function Ld(a) {
      return Qd[a];
    }var Rd = { "\x00": "%00", '\x01': "%01", '\x02': "%02", '\x03': "%03", '\x04': "%04",
      '\x05': "%05", '\x06': "%06", '\x07': "%07", "\b": "%08", "\t": "%09", "\n": "%0A", "\x0B": "%0B", "\f": "%0C", "\r": "%0D", '\x0E': "%0E", '\x0F': "%0F", '\x10': "%10", '\x11': "%11", '\x12': "%12", '\x13': "%13", '\x14': "%14", '\x15': "%15", '\x16': "%16", '\x17': "%17", '\x18': "%18", '\x19': "%19", '\x1A': "%1A", '\x1B': "%1B", '\x1C': "%1C", '\x1D': "%1D", '\x1E': "%1E", '\x1F': "%1F", " ": "%20", '"': "%22", "'": "%27", "(": "%28", ")": "%29", "<": "%3C", ">": "%3E", "\\": "%5C", "{": "%7B", "}": "%7D", '\x7F': "%7F", '\x85': "%C2%85",
      '\xA0': "%C2%A0", '\u2028': "%E2%80%A8", '\u2029': "%E2%80%A9", '\uFF01': "%EF%BC%81", '\uFF03': "%EF%BC%83", '\uFF04': "%EF%BC%84", '\uFF06': "%EF%BC%86", '\uFF07': "%EF%BC%87", '\uFF08': "%EF%BC%88", '\uFF09': "%EF%BC%89", '\uFF0A': "%EF%BC%8A", '\uFF0B': "%EF%BC%8B", '\uFF0C': "%EF%BC%8C", '\uFF0F': "%EF%BC%8F", '\uFF1A': "%EF%BC%9A", '\uFF1B': "%EF%BC%9B", '\uFF1D': "%EF%BC%9D", '\uFF1F': "%EF%BC%9F", '\uFF20': "%EF%BC%A0", '\uFF3B': "%EF%BC%BB", '\uFF3D': "%EF%BC%BD" };function Od(a) {
      return Rd[a];
    }var Kd = /[\x00\x22\x27\x3c\x3e]/g,
        Nd = /[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,
        Pd = /^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,
        Id = /<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,
        Jd = /</g;function Sd(a) {
      a.prototype.then = a.prototype.then;a.prototype.$goog_Thenable = !0;
    }function Td(a) {
      if (!a) return !1;try {
        return !!a.$goog_Thenable;
      } catch (b) {
        return !1;
      }
    }function Ud(a, b, c) {
      this.ge = c;this.Gd = a;this.se = b;this.Nb = 0;this.Fb = null;
    }Ud.prototype.get = function () {
      var a;0 < this.Nb ? (this.Nb--, a = this.Fb, this.Fb = a.next, a.next = null) : a = this.Gd();return a;
    };Ud.prototype.put = function (a) {
      this.se(a);this.Nb < this.ge && (this.Nb++, a.next = this.Fb, this.Fb = a);
    };function Vd() {
      this.$b = this.Ya = null;
    }var Xd = new Ud(function () {
      return new Wd();
    }, function (a) {
      a.reset();
    }, 100);Vd.prototype.add = function (a, b) {
      var c = Xd.get();c.set(a, b);this.$b ? this.$b.next = c : this.Ya = c;this.$b = c;
    };Vd.prototype.remove = function () {
      var a = null;this.Ya && (a = this.Ya, this.Ya = this.Ya.next, this.Ya || (this.$b = null), a.next = null);return a;
    };function Wd() {
      this.next = this.scope = this.kc = null;
    }Wd.prototype.set = function (a, b) {
      this.kc = a;this.scope = b;this.next = null;
    };Wd.prototype.reset = function () {
      this.next = this.scope = this.kc = null;
    };function Yd(a) {
      l.setTimeout(function () {
        throw a;
      }, 0);
    }var Zd;function $d() {
      var a = l.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !u("Presto") && (a = function a() {
        var a = document.createElement(String(Ib));
        a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow,
            a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
            d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host,
            a = p(function (a) {
          if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
        }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
            b.postMessage(c, d);
          } };
      });if ("undefined" !== typeof a && !u("Trident") && !u("MSIE")) {
        var b = new a(),
            c = {},
            d = c;b.port1.onmessage = function () {
          if (m(c.next)) {
            c = c.next;var a = c.Jc;c.Jc = null;a();
          }
        };return function (a) {
          d.next = { Jc: a };d = d.next;b.port2.postMessage(0);
        };
      }return "undefined" !== typeof document && "onreadystatechange" in document.createElement(String(Ub)) ? function (a) {
        var b = document.createElement(String(Ub));b.onreadystatechange = function () {
          b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
        };document.documentElement.appendChild(b);
      } : function (a) {
        l.setTimeout(a, 0);
      };
    }function ae(a, b) {
      be || ce();
      de || (be(), de = !0);ee.add(a, b);
    }var be;function ce() {
      if (-1 != String(l.Promise).indexOf("[native code]")) {
        var a = l.Promise.resolve(void 0);be = function be() {
          a.then(fe);
        };
      } else be = function be() {
        var a = fe;!ga(l.setImmediate) || l.Window && l.Window.prototype && !u("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? (Zd || (Zd = $d()), Zd(a)) : l.setImmediate(a);
      };
    }var de = !1,
        ee = new Vd();function fe() {
      for (var a; a = ee.remove();) {
        try {
          a.kc.call(a.scope);
        } catch (b) {
          Yd(b);
        }Xd.put(a);
      }de = !1;
    }function ge(a, b) {
      this.W = he;this.ka = void 0;this.La = this.la = this.s = null;this.Cb = this.jc = !1;if (a != aa) try {
        var c = this;a.call(b, function (a) {
          ie(c, je, a);
        }, function (a) {
          if (!(a instanceof ke)) try {
            if (a instanceof Error) throw a;throw Error("Promise rejected.");
          } catch (b$2) {}ie(c, le, a);
        });
      } catch (d) {
        ie(this, le, d);
      }
    }var he = 0,
        je = 2,
        le = 3;function me() {
      this.next = this.context = this.Ra = this.mb = this.xa = null;this.tb = !1;
    }me.prototype.reset = function () {
      this.context = this.Ra = this.mb = this.xa = null;this.tb = !1;
    };var ne = new Ud(function () {
      return new me();
    }, function (a) {
      a.reset();
    }, 100);function oe(a, b, c) {
      var d = ne.get();d.mb = a;d.Ra = b;d.context = c;return d;
    }function pe(a) {
      if (a instanceof ge) return a;var b = new ge(aa);ie(b, je, a);return b;
    }function qe(a) {
      return new ge(function (b, c) {
        c(a);
      });
    }ge.prototype.then = function (a, b, c) {
      return re(this, ga(a) ? a : null, ga(b) ? b : null, c);
    };Sd(ge);function se(a, b) {
      return re(a, null, b, void 0);
    }ge.prototype.cancel = function (a) {
      this.W == he && ae(function () {
        var b = new ke(a);te(this, b);
      }, this);
    };function te(a, b) {
      if (a.W == he) if (a.s) {
        var c = a.s;if (c.la) {
          for (var d = 0, e = null, f = null, g = c.la; g && (g.tb || (d++, g.xa == a && (e = g), !(e && 1 < d))); g = g.next) {
            e || (f = g);
          }e && (c.W == he && 1 == d ? te(c, b) : (f ? (d = f, d.next == c.La && (c.La = d), d.next = d.next.next) : ue(c), ve(c, e, le, b)));
        }a.s = null;
      } else ie(a, le, b);
    }function we(a, b) {
      a.la || a.W != je && a.W != le || xe(a);a.La ? a.La.next = b : a.la = b;a.La = b;
    }function re(a, b, c, d) {
      var e = oe(null, null, null);e.xa = new ge(function (a, g) {
        e.mb = b ? function (c) {
          try {
            var e = b.call(d, c);a(e);
          } catch (N) {
            g(N);
          }
        } : a;e.Ra = c ? function (b) {
          try {
            var e = c.call(d, b);!m(e) && b instanceof ke ? g(b) : a(e);
          } catch (N) {
            g(N);
          }
        } : g;
      });e.xa.s = a;we(a, e);return e.xa;
    }
    ge.prototype.De = function (a) {
      this.W = he;ie(this, je, a);
    };ge.prototype.Ee = function (a) {
      this.W = he;ie(this, le, a);
    };function ie(a, b, c) {
      if (a.W == he) {
        a === c && (b = le, c = new TypeError("Promise cannot resolve to itself"));a.W = 1;var d;a: {
          var e = c,
              f = a.De,
              g = a.Ee;if (e instanceof ge) we(e, oe(f || aa, g || null, a)), d = !0;else if (Td(e)) e.then(f, g, a), d = !0;else {
            if (ha(e)) try {
              var k = e.then;if (ga(k)) {
                ye(e, k, f, g, a);d = !0;break a;
              }
            } catch (r) {
              g.call(a, r);d = !0;break a;
            }d = !1;
          }
        }d || (a.ka = c, a.W = b, a.s = null, xe(a), b != le || c instanceof ke || ze(a, c));
      }
    }function ye(a, b, c, d, e) {
      function f(a) {
        k || (k = !0, d.call(e, a));
      }function g(a) {
        k || (k = !0, c.call(e, a));
      }var k = !1;try {
        b.call(a, g, f);
      } catch (r) {
        f(r);
      }
    }function xe(a) {
      a.jc || (a.jc = !0, ae(a.Nd, a));
    }function ue(a) {
      var b = null;a.la && (b = a.la, a.la = b.next, b.next = null);a.la || (a.La = null);return b;
    }ge.prototype.Nd = function () {
      for (var a; a = ue(this);) {
        ve(this, a, this.W, this.ka);
      }this.jc = !1;
    };function ve(a, b, c, d) {
      if (c == le && b.Ra && !b.tb) for (; a && a.Cb; a = a.s) {
        a.Cb = !1;
      }if (b.xa) b.xa.s = null, Ae(b, c, d);else try {
        b.tb ? b.mb.call(b.context) : Ae(b, c, d);
      } catch (e) {
        Be.call(null, e);
      }ne.put(b);
    }function Ae(a, b, c) {
      b == je ? a.mb.call(a.context, c) : a.Ra && a.Ra.call(a.context, c);
    }function ze(a, b) {
      a.Cb = !0;ae(function () {
        a.Cb && Be.call(null, b);
      });
    }var Be = Yd;function ke(a) {
      pa.call(this, a);
    }t(ke, pa);ke.prototype.name = "cancel";function Ce() {
      0 != De && (Ee[this[ia] || (this[ia] = ++ja)] = this);this.Na = this.Na;this.Ga = this.Ga;
    }var De = 0,
        Ee = {};Ce.prototype.Na = !1;Ce.prototype.i = function () {
      if (!this.Na && (this.Na = !0, this.f(), 0 != De)) {
        var a = this[ia] || (this[ia] = ++ja);delete Ee[a];
      }
    };function Fe(a, b) {
      a.Na ? m(void 0) ? b.call(void 0) : b() : (a.Ga || (a.Ga = []), a.Ga.push(m(void 0) ? p(b, void 0) : b));
    }Ce.prototype.f = function () {
      if (this.Ga) for (; this.Ga.length;) {
        this.Ga.shift()();
      }
    };function Ge(a) {
      a && "function" == typeof a.i && a.i();
    }var He = !v || 9 <= Number(sb),
        Ie = v && !x("9");!w || x("528");jb && x("1.9b") || v && x("8") || gb && x("9.5") || w && x("528");jb && !x("8") || v && x("9");function Je(a, b) {
      this.type = a;this.currentTarget = this.target = b;this.defaultPrevented = this.Ha = !1;this.jd = !0;
    }Je.prototype.stopPropagation = function () {
      this.Ha = !0;
    };Je.prototype.preventDefault = function () {
      this.defaultPrevented = !0;this.jd = !1;
    };function E(a, b) {
      Je.call(this, a ? a.type : "");this.relatedTarget = this.currentTarget = this.target = null;this.button = this.screenY = this.screenX = this.clientY = this.clientX = this.offsetY = this.offsetX = 0;this.key = "";this.charCode = this.keyCode = 0;this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.$ = this.state = null;a && this.init(a, b);
    }t(E, Je);E.prototype.init = function (a, b) {
      var c = this.type = a.type,
          d = a.changedTouches ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.currentTarget = b;if (b = a.relatedTarget) {
        if (jb) {
          var e;a: {
            try {
              db(b.nodeName);e = !0;break a;
            } catch (f) {}e = !1;
          }e || (b = null);
        }
      } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;null === d ? (this.offsetX = w || void 0 !== a.offsetX ? a.offsetX : a.layerX, this.offsetY = w || void 0 !== a.offsetY ? a.offsetY : a.layerY, this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0);this.button = a.button;this.keyCode = a.keyCode || 0;this.key = a.key || "";this.charCode = a.charCode || ("keypress" == c ? a.keyCode : 0);this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.state = a.state;this.$ = a;a.defaultPrevented && this.preventDefault();
    };E.prototype.stopPropagation = function () {
      E.h.stopPropagation.call(this);this.$.stopPropagation ? this.$.stopPropagation() : this.$.cancelBubble = !0;
    };E.prototype.preventDefault = function () {
      E.h.preventDefault.call(this);var a = this.$;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Ie) try {
        if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
      } catch (b) {}
    };var Ke = "closure_listenable_" + (1E6 * Math.random() | 0);function Le(a) {
      return !(!a || !a[Ke]);
    }var Me = 0;function Ne(a, b, c, d, e) {
      this.listener = a;this.Rb = null;this.src = b;this.type = c;this.Za = !!d;this.Eb = e;this.key = ++Me;this.Ua = this.ub = !1;
    }function Oe(a) {
      a.Ua = !0;a.listener = null;a.Rb = null;a.src = null;a.Eb = null;
    }function Pe(a) {
      this.src = a;this.K = {};this.sb = 0;
    }h = Pe.prototype;h.add = function (a, b, c, d, e) {
      var f = a.toString();a = this.K[f];a || (a = this.K[f] = [], this.sb++);var g = Qe(a, b, d, e);-1 < g ? (b = a[g], c || (b.ub = !1)) : (b = new Ne(b, this.src, f, !!d, e), b.ub = c, a.push(b));return b;
    };h.remove = function (a, b, c, d) {
      a = a.toString();if (!(a in this.K)) return !1;var e = this.K[a];b = Qe(e, b, c, d);return -1 < b ? (Oe(e[b]), Oa(e, b), 0 == e.length && (delete this.K[a], this.sb--), !0) : !1;
    };function Re(a, b) {
      var c = b.type;c in a.K && Na(a.K[c], b) && (Oe(b), 0 == a.K[c].length && (delete a.K[c], a.sb--));
    }h.Sb = function (a) {
      a = a && a.toString();var b = 0,
          c;for (c in this.K) {
        if (!a || c == a) {
          for (var d = this.K[c], e = 0; e < d.length; e++) {
            ++b, Oe(d[e]);
          }delete this.K[c];this.sb--;
        }
      }return b;
    };h.fb = function (a, b, c, d) {
      a = this.K[a.toString()];var e = -1;a && (e = Qe(a, b, c, d));return -1 < e ? a[e] : null;
    };h.hasListener = function (a, b) {
      var c = m(a),
          d = c ? a.toString() : "",
          e = m(b);return Xa(this.K, function (a) {
        for (var g = 0; g < a.length; ++g) {
          if (!(c && a[g].type != d || e && a[g].Za != b)) return !0;
        }return !1;
      });
    };function Qe(a, b, c, d) {
      for (var e = 0; e < a.length; ++e) {
        var f = a[e];if (!f.Ua && f.listener == b && f.Za == !!c && f.Eb == d) return e;
      }return -1;
    }var Se = "closure_lm_" + (1E6 * Math.random() | 0),
        Te = {},
        Ue = 0;function Ve(a, b, c, d, e) {
      if (da(b)) {
        for (var f = 0; f < b.length; f++) {
          Ve(a, b[f], c, d, e);
        }return null;
      }c = We(c);return Le(a) ? a.ra(b, c, d, e) : Xe(a, b, c, !1, d, e);
    }function Xe(a, b, c, d, e, f) {
      if (!b) throw Error("Invalid event type");var g = !!e,
          k = Ye(a);k || (a[Se] = k = new Pe(a));c = k.add(b, c, d, e, f);if (c.Rb) return c;d = Ze();c.Rb = d;d.src = a;d.listener = c;if (a.addEventListener) a.addEventListener(b.toString(), d, g);else if (a.attachEvent) a.attachEvent($e(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");Ue++;return c;
    }function Ze() {
      var a = af,
          b = He ? function (c) {
        return a.call(b.src, b.listener, c);
      } : function (c) {
        c = a.call(b.src, b.listener, c);if (!c) return c;
      };return b;
    }function bf(a, b, c, d, e) {
      if (da(b)) {
        for (var f = 0; f < b.length; f++) {
          bf(a, b[f], c, d, e);
        }return null;
      }c = We(c);return Le(a) ? a.Wc(b, c, d, e) : Xe(a, b, c, !0, d, e);
    }function cf(a, b, c, d, e) {
      if (da(b)) for (var f = 0; f < b.length; f++) {
        cf(a, b[f], c, d, e);
      } else c = We(c), Le(a) ? a.Gc(b, c, d, e) : a && (a = Ye(a)) && (b = a.fb(b, c, !!d, e)) && df(b);
    }function df(a) {
      if (fa(a) || !a || a.Ua) return;var b = a.src;if (Le(b)) {
        Re(b.Z, a);return;
      }var c = a.type,
          d = a.Rb;b.removeEventListener ? b.removeEventListener(c, d, a.Za) : b.detachEvent && b.detachEvent($e(c), d);Ue--;(c = Ye(b)) ? (Re(c, a), 0 == c.sb && (c.src = null, b[Se] = null)) : Oe(a);
    }function $e(a) {
      return a in Te ? Te[a] : Te[a] = "on" + a;
    }function ef(a, b, c, d) {
      var e = !0;if (a = Ye(a)) if (b = a.K[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
        var f = b[a];f && f.Za == c && !f.Ua && (f = ff(f, d), e = e && !1 !== f);
      }return e;
    }function ff(a, b) {
      var c = a.listener,
          d = a.Eb || a.src;a.ub && df(a);return c.call(d, b);
    }function af(a, b) {
      if (a.Ua) return !0;if (!He) {
        if (!b) a: {
          b = ["window", "event"];for (var c = l, d; d = b.shift();) {
            if (null != c[d]) c = c[d];else {
              b = null;break a;
            }
          }b = c;
        }d = b;b = new E(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
          a: {
            var e = !1;if (0 == d.keyCode) try {
              d.keyCode = -1;break a;
            } catch (g) {
              e = !0;
            }if (e || void 0 == d.returnValue) d.returnValue = !0;
          }d = [];
          for (e = b.currentTarget; e; e = e.parentNode) {
            d.push(e);
          }a = a.type;for (e = d.length - 1; !b.Ha && 0 <= e; e--) {
            b.currentTarget = d[e];var f = ef(d[e], a, !0, b),
                c = c && f;
          }for (e = 0; !b.Ha && e < d.length; e++) {
            b.currentTarget = d[e], f = ef(d[e], a, !1, b), c = c && f;
          }
        }return c;
      }return ff(a, new E(b, this));
    }function Ye(a) {
      a = a[Se];return a instanceof Pe ? a : null;
    }var gf = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);function We(a) {
      if (ga(a)) return a;a[gf] || (a[gf] = function (b) {
        return a.handleEvent(b);
      });return a[gf];
    }function F() {
      Ce.call(this);this.Z = new Pe(this);
      this.xd = this;this.Pb = null;
    }t(F, Ce);F.prototype[Ke] = !0;h = F.prototype;h.Dc = function (a) {
      this.Pb = a;
    };h.addEventListener = function (a, b, c, d) {
      Ve(this, a, b, c, d);
    };h.removeEventListener = function (a, b, c, d) {
      cf(this, a, b, c, d);
    };h.dispatchEvent = function (a) {
      var b,
          c = this.Pb;if (c) for (b = []; c; c = c.Pb) {
        b.push(c);
      }var c = this.xd,
          d = a.type || a;if (n(a)) a = new Je(a, c);else if (a instanceof Je) a.target = a.target || c;else {
        var e = a;a = new Je(d, c);bb(a, e);
      }var e = !0,
          f;if (b) for (var g = b.length - 1; !a.Ha && 0 <= g; g--) {
        f = a.currentTarget = b[g], e = hf(f, d, !0, a) && e;
      }a.Ha || (f = a.currentTarget = c, e = hf(f, d, !0, a) && e, a.Ha || (e = hf(f, d, !1, a) && e));if (b) for (g = 0; !a.Ha && g < b.length; g++) {
        f = a.currentTarget = b[g], e = hf(f, d, !1, a) && e;
      }return e;
    };h.f = function () {
      F.h.f.call(this);this.Z && this.Z.Sb(void 0);this.Pb = null;
    };h.ra = function (a, b, c, d) {
      return this.Z.add(String(a), b, !1, c, d);
    };h.Wc = function (a, b, c, d) {
      return this.Z.add(String(a), b, !0, c, d);
    };h.Gc = function (a, b, c, d) {
      return this.Z.remove(String(a), b, c, d);
    };function hf(a, b, c, d) {
      b = a.Z.K[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
        var g = b[f];if (g && !g.Ua && g.Za == c) {
          var k = g.listener,
              r = g.Eb || g.src;g.ub && Re(a.Z, g);e = !1 !== k.call(r, d) && e;
        }
      }return e && 0 != d.jd;
    }h.fb = function (a, b, c, d) {
      return this.Z.fb(String(a), b, c, d);
    };h.hasListener = function (a, b) {
      return this.Z.hasListener(m(a) ? String(a) : void 0, b);
    };function jf(a, b) {
      F.call(this);this.jb = a || 1;this.Wa = b || l;this.dc = p(this.Be, this);this.xc = na();
    }t(jf, F);h = jf.prototype;h.enabled = !1;h.H = null;h.setInterval = function (a) {
      this.jb = a;this.H && this.enabled ? (this.stop(), this.start()) : this.H && this.stop();
    };h.Be = function () {
      if (this.enabled) {
        var a = na() - this.xc;0 < a && a < .8 * this.jb ? this.H = this.Wa.setTimeout(this.dc, this.jb - a) : (this.H && (this.Wa.clearTimeout(this.H), this.H = null), this.dispatchEvent("tick"), this.enabled && (this.H = this.Wa.setTimeout(this.dc, this.jb), this.xc = na()));
      }
    };h.start = function () {
      this.enabled = !0;this.H || (this.H = this.Wa.setTimeout(this.dc, this.jb), this.xc = na());
    };h.stop = function () {
      this.enabled = !1;this.H && (this.Wa.clearTimeout(this.H), this.H = null);
    };h.f = function () {
      jf.h.f.call(this);
      this.stop();delete this.Wa;
    };function kf(a, b) {
      if (ga(a)) b && (a = p(a, b));else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(0) ? -1 : l.setTimeout(a, 0);
    }function lf(a) {
      a = String(a);if (/^\s*$/.test(a) ? 0 : /^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g, "@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g, "]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, ""))) try {
        return eval("(" + a + ")");
      } catch (b) {}throw Error("Invalid JSON string: " + a);
    }function mf(a) {
      var b = [];nf(new of(), a, b);return b.join("");
    }function of() {
      this.Tb = void 0;
    }function nf(a, b, c) {
      if (null == b) c.push("null");else {
        if ("object" == typeof b) {
          if (da(b)) {
            var d = b;b = d.length;c.push("[");for (var e = "", f = 0; f < b; f++) {
              c.push(e), e = d[f], nf(a, a.Tb ? a.Tb.call(d, String(f), e) : e, c), e = ",";
            }c.push("]");return;
          }if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
            c.push("{");f = "";for (d in b) {
              Object.prototype.hasOwnProperty.call(b, d) && (e = b[d], "function" != typeof e && (c.push(f), pf(d, c), c.push(":"), nf(a, a.Tb ? a.Tb.call(b, d, e) : e, c), f = ","));
            }c.push("}");return;
          }
        }switch (typeof b) {case "string":
            pf(b, c);break;case "number":
            c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");break;case "boolean":
            c.push(String(b));break;case "function":
            c.push("null");break;default:
            throw Error("Unknown type: " + typeof b);}
      }
    }var qf = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": '\\u000b' },
        rf = /\uffff/.test('\uFFFF') ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g;function pf(a, b) {
      b.push('"', a.replace(rf, function (a) {
        var b = qf[a];b || (b = '\\u' + (a.charCodeAt(0) | 65536).toString(16).substr(1), qf[a] = b);return b;
      }), '"');
    }function sf(a, b, c, d, e) {
      this.reset(a, b, c, d, e);
    }sf.prototype.ic = null;var tf = 0;sf.prototype.reset = function (a, b, c, d, e) {
      "number" == typeof e || tf++;this.qd = d || na();this.Fa = a;this.Zc = b;this.Yc = c;delete this.ic;
    };sf.prototype.ld = function (a) {
      this.Fa = a;
    };function uf(a) {
      this.$c = a;this.ib = this.na = this.Fa = this.s = null;
    }function vf(a, b) {
      this.name = a;this.value = b;
    }vf.prototype.toString = function () {
      return this.name;
    };var wf = new vf("SHOUT", 1200),
        xf = new vf("SEVERE", 1E3),
        yf = new vf("WARNING", 900),
        zf = new vf("INFO", 800),
        Af = new vf("CONFIG", 700);h = uf.prototype;h.getName = function () {
      return this.$c;
    };h.getParent = function () {
      return this.s;
    };h.Rc = function () {
      this.na || (this.na = {});return this.na;
    };h.ld = function (a) {
      this.Fa = a;
    };function Bf(a) {
      if (a.Fa) return a.Fa;if (a.s) return Bf(a.s);Da("Root logger has no level set.");return null;
    }h.log = function (a, b, c) {
      if (a.value >= Bf(this).value) for (ga(b) && (b = b()), a = new sf(a, String(b), this.$c), c && (a.ic = c), c = "log:" + a.Zc, l.console && (l.console.timeStamp ? l.console.timeStamp(c) : l.console.markTimeline && l.console.markTimeline(c)), l.msWriteProfilerMark && l.msWriteProfilerMark(c), c = this; c;) {
        b = c;var d = a;if (b.ib) for (var e = 0, f; f = b.ib[e]; e++) {
          f(d);
        }c = c.getParent();
      }
    };function Cf(a) {
      Df.log(xf, a, void 0);
    }h.info = function (a, b) {
      this.log(zf, a, b);
    };var Ef = {},
        Ff = null;function Gf() {
      Ff || (Ff = new uf(""), Ef[""] = Ff, Ff.ld(Af));
    }function Hf(a) {
      Gf();
      var b;if (!(b = Ef[a])) {
        b = new uf(a);var c = a.lastIndexOf("."),
            d = a.substr(c + 1),
            c = Hf(a.substr(0, c));c.Rc()[d] = b;b.s = c;Ef[a] = b;
      }return b;
    }function If() {
      this.hd = na();
    }var Jf = new If();If.prototype.set = function (a) {
      this.hd = a;
    };If.prototype.reset = function () {
      this.set(na());
    };If.prototype.get = function () {
      return this.hd;
    };function Kf(a) {
      this.ta = a || "";this.ye = Jf;
    }h = Kf.prototype;h.Ic = !0;h.md = !0;h.ue = !0;h.te = !0;h.nd = !1;h.we = !1;function Lf(a) {
      return 10 > a ? "0" + a : String(a);
    }function Mf(a, b) {
      a = (a.qd - b) / 1E3;b = a.toFixed(3);var c = 0;
      if (1 > a) c = 2;else for (; 100 > a;) {
        c++, a *= 10;
      }for (; 0 < c--;) {
        b = " " + b;
      }return b;
    }function Nf(a) {
      Kf.call(this, a);
    }t(Nf, Kf);function Of() {
      this.pe = p(this.yd, this);this.zb = new Nf();this.zb.md = !1;this.zb.nd = !1;this.Vc = this.zb.Ic = !1;this.Xc = "";this.Pd = {};
    }Of.prototype.yd = function (a) {
      if (!this.Pd[a.Yc]) {
        var b;b = this.zb;var c = [];c.push(b.ta, " ");if (b.md) {
          var d = new Date(a.qd);c.push("[", Lf(d.getFullYear() - 2E3) + Lf(d.getMonth() + 1) + Lf(d.getDate()) + " " + Lf(d.getHours()) + ":" + Lf(d.getMinutes()) + ":" + Lf(d.getSeconds()) + "." + Lf(Math.floor(d.getMilliseconds() / 10)), "] ");
        }b.ue && c.push("[", Mf(a, b.ye.get()), "s] ");b.te && c.push("[", a.Yc, "] ");b.we && c.push("[", a.Fa.name, "] ");c.push(a.Zc);b.nd && (d = a.ic) && c.push("\n", d instanceof Error ? d.message : d.toString());b.Ic && c.push("\n");b = c.join("");if (c = Pf) switch (a.Fa) {case wf:
            Qf(c, "info", b);break;case xf:
            Qf(c, "error", b);break;case yf:
            Qf(c, "warn", b);break;default:
            Qf(c, "debug", b);} else this.Xc += b;
      }
    };var Pf = l.console;function Qf(a, b, c) {
      if (a[b]) a[b](c);else a.log(c);
    }function Rf(a) {
      if (a.altKey && !a.ctrlKey || a.metaKey || 112 <= a.keyCode && 123 >= a.keyCode) return !1;switch (a.keyCode) {case 18:case 20:case 93:case 17:case 40:case 35:case 27:case 36:case 45:case 37:case 224:case 91:case 144:case 12:case 34:case 33:case 19:case 255:case 44:case 39:case 145:case 16:case 38:case 252:case 224:case 92:
          return !1;case 0:
          return !jb;default:
          return 166 > a.keyCode || 183 < a.keyCode;}
    }function Sf(a, b, c, d, e, f) {
      if (!(v || hb || w && x("525"))) return !0;if (lb && e) return Tf(a);if (e && !d) return !1;fa(b) && (b = Uf(b));e = 17 == b || 18 == b || lb && 91 == b;if ((!c || lb) && e || lb && 16 == b && (d || f)) return !1;if ((w || hb) && d && c) switch (a) {case 220:case 219:case 221:case 192:case 186:case 189:case 187:case 188:case 190:case 191:case 192:case 222:
          return !1;}if (v && d && b == a) return !1;switch (a) {case 13:
          return !0;case 27:
          return !(w || hb);}return Tf(a);
    }function Tf(a) {
      if (48 <= a && 57 >= a || 96 <= a && 106 >= a || 65 <= a && 90 >= a || (w || hb) && 0 == a) return !0;switch (a) {case 32:case 43:case 63:case 64:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:
          return !0;
        default:
          return !1;}
    }function Uf(a) {
      if (jb) a = Vf(a);else if (lb && w) a: switch (a) {case 93:
          a = 91;break a;}return a;
    }function Vf(a) {
      switch (a) {case 61:
          return 187;case 59:
          return 186;case 173:
          return 189;case 224:
          return 91;case 0:
          return 224;default:
          return a;}
    }function Wf(a, b, c, d) {
      this.top = a;this.right = b;this.bottom = c;this.left = d;
    }h = Wf.prototype;h.clone = function () {
      return new Wf(this.top, this.right, this.bottom, this.left);
    };h.toString = function () {
      return "(" + this.top + "t, " + this.right + "r, " + this.bottom + "b, " + this.left + "l)";
    };
    h.contains = function (a) {
      return this && a ? a instanceof Wf ? a.left >= this.left && a.right <= this.right && a.top >= this.top && a.bottom <= this.bottom : a.x >= this.left && a.x <= this.right && a.y >= this.top && a.y <= this.bottom : !1;
    };h.expand = function (a, b, c, d) {
      ha(a) ? (this.top -= a.top, this.right += a.right, this.bottom += a.bottom, this.left -= a.left) : (this.top -= a, this.right += Number(b), this.bottom += Number(c), this.left -= Number(d));return this;
    };h.ceil = function () {
      this.top = Math.ceil(this.top);this.right = Math.ceil(this.right);this.bottom = Math.ceil(this.bottom);
      this.left = Math.ceil(this.left);return this;
    };h.floor = function () {
      this.top = Math.floor(this.top);this.right = Math.floor(this.right);this.bottom = Math.floor(this.bottom);this.left = Math.floor(this.left);return this;
    };h.round = function () {
      this.top = Math.round(this.top);this.right = Math.round(this.right);this.bottom = Math.round(this.bottom);this.left = Math.round(this.left);return this;
    };h.translate = function (a, b) {
      a instanceof qc ? (this.left += a.x, this.right += a.x, this.top += a.y, this.bottom += a.y) : (this.left += a, this.right += a, fa(b) && (this.top += b, this.bottom += b));return this;
    };h.scale = function (a, b) {
      b = fa(b) ? b : a;this.left *= a;this.right *= a;this.top *= b;this.bottom *= b;return this;
    };function Xf(a, b) {
      var c = uc(a);return c.defaultView && c.defaultView.getComputedStyle && (a = c.defaultView.getComputedStyle(a, null)) ? a[b] || a.getPropertyValue(b) || "" : "";
    }function Yf(a) {
      var b;try {
        b = a.getBoundingClientRect();
      } catch (c) {
        return { left: 0, top: 0, right: 0, bottom: 0 };
      }v && a.ownerDocument.body && (a = a.ownerDocument, b.left -= a.documentElement.clientLeft + a.body.clientLeft, b.top -= a.documentElement.clientTop + a.body.clientTop);return b;
    }function Zf(a, b) {
      b = b || Ac(document);var c;c = b || Ac(document);var d = $f(a),
          e = $f(c),
          f;if (!v || 9 <= Number(sb)) g = Xf(c, "borderLeftWidth"), f = Xf(c, "borderRightWidth"), k = Xf(c, "borderTopWidth"), r = Xf(c, "borderBottomWidth"), f = new Wf(parseFloat(k), parseFloat(f), parseFloat(r), parseFloat(g));else {
        var g = ag(c, "borderLeft");f = ag(c, "borderRight");var k = ag(c, "borderTop"),
            r = ag(c, "borderBottom");f = new Wf(k, f, r, g);
      }c == Ac(document) ? (g = d.x - c.scrollLeft, d = d.y - c.scrollTop, !v || 10 <= Number(sb) || (g += f.left, d += f.top)) : (g = d.x - e.x - f.left, d = d.y - e.y - f.top);e = a.offsetWidth;f = a.offsetHeight;k = w && !e && !f;m(e) && !k || !a.getBoundingClientRect ? a = new rc(e, f) : (a = Yf(a), a = new rc(a.right - a.left, a.bottom - a.top));e = c.clientHeight - a.height;f = c.scrollLeft;k = c.scrollTop;f += Math.min(g, Math.max(g - (c.clientWidth - a.width), 0));k += Math.min(d, Math.max(d - e, 0));c = new qc(f, k);b.scrollLeft = c.x;b.scrollTop = c.y;
    }function $f(a) {
      var b = uc(a),
          c = new qc(0, 0),
          d;d = b ? uc(b) : document;d = !v || 9 <= Number(sb) || "CSS1Compat" == sc(d).Y.compatMode ? d.documentElement : d.body;if (a == d) return c;a = Yf(a);d = sc(b).Y;b = Ac(d);d = d.parentWindow || d.defaultView;b = v && x("10") && d.pageYOffset != b.scrollTop ? new qc(b.scrollLeft, b.scrollTop) : new qc(d.pageXOffset || b.scrollLeft, d.pageYOffset || b.scrollTop);c.x = a.left + b.x;c.y = a.top + b.y;return c;
    }var bg = { thin: 2, medium: 4, thick: 6 };function ag(a, b) {
      if ("none" == (a.currentStyle ? a.currentStyle[b + "Style"] : null)) return 0;var c = a.currentStyle ? a.currentStyle[b + "Width"] : null;if (c in bg) a = bg[c];else if (/^\d+px?$/.test(c)) a = parseInt(c, 10);else {
        b = a.style.left;var d = a.runtimeStyle.left;a.runtimeStyle.left = a.currentStyle.left;a.style.left = c;c = a.style.pixelLeft;a.style.left = b;a.runtimeStyle.left = d;a = +c;
      }return a;
    }function cg(a, b) {
      this.Ub = [];this.ad = a;this.Lc = b || null;this.hb = this.Oa = !1;this.ka = void 0;this.Ec = this.Bd = this.cc = !1;this.Yb = 0;this.s = null;this.ec = 0;
    }cg.prototype.cancel = function (a) {
      if (this.Oa) this.ka instanceof cg && this.ka.cancel();else {
        if (this.s) {
          var b = this.s;delete this.s;a ? b.cancel(a) : (b.ec--, 0 >= b.ec && b.cancel());
        }this.ad ? this.ad.call(this.Lc, this) : this.Ec = !0;this.Oa || (a = new dg(), eg(this), fg(this, !1, a));
      }
    };cg.prototype.Kc = function (a, b) {
      this.cc = !1;fg(this, a, b);
    };function fg(a, b, c) {
      a.Oa = !0;a.ka = c;a.hb = !b;gg(a);
    }function eg(a) {
      if (a.Oa) {
        if (!a.Ec) throw new hg();a.Ec = !1;
      }
    }function ig(a, b, c) {
      a.Ub.push([b, c, void 0]);a.Oa && gg(a);
    }cg.prototype.then = function (a, b, c) {
      var d,
          e,
          f = new ge(function (a, b) {
        d = a;e = b;
      });ig(this, d, function (a) {
        a instanceof dg ? f.cancel() : e(a);
      });return f.then(a, b, c);
    };Sd(cg);function jg(a) {
      return Ka(a.Ub, function (a) {
        return ga(a[1]);
      });
    }
    function gg(a) {
      if (a.Yb && a.Oa && jg(a)) {
        var b = a.Yb,
            c = kg[b];c && (l.clearTimeout(c.Ca), delete kg[b]);a.Yb = 0;
      }a.s && (a.s.ec--, delete a.s);for (var b = a.ka, d = c = !1; a.Ub.length && !a.cc;) {
        var e = a.Ub.shift(),
            f = e[0],
            g = e[1],
            e = e[2];if (f = a.hb ? g : f) try {
          var k = f.call(e || a.Lc, b);m(k) && (a.hb = a.hb && (k == b || k instanceof Error), a.ka = b = k);if (Td(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.cc = !0;
        } catch (r) {
          b = r, a.hb = !0, jg(a) || (c = !0);
        }
      }a.ka = b;d && (k = p(a.Kc, a, !0), d = p(a.Kc, a, !1), b instanceof cg ? (ig(b, k, d), b.Bd = !0) : b.then(k, d));c && (b = new lg(b), kg[b.Ca] = b, a.Yb = b.Ca);
    }function hg() {
      pa.call(this);
    }t(hg, pa);hg.prototype.message = "Deferred has already fired";hg.prototype.name = "AlreadyCalledError";function dg() {
      pa.call(this);
    }t(dg, pa);dg.prototype.message = "Deferred was canceled";dg.prototype.name = "CanceledError";function lg(a) {
      this.Ca = l.setTimeout(p(this.Ae, this), 0);this.Md = a;
    }lg.prototype.Ae = function () {
      delete kg[this.Ca];throw this.Md;
    };var kg = {};function mg(a) {
      Ce.call(this);this.sc = a;this.u = {};
    }t(mg, Ce);var ng = [];h = mg.prototype;
    h.ra = function (a, b, c, d) {
      da(b) || (b && (ng[0] = b.toString()), b = ng);for (var e = 0; e < b.length; e++) {
        var f = Ve(a, b[e], c || this.handleEvent, d || !1, this.sc || this);if (!f) break;this.u[f.key] = f;
      }return this;
    };h.Wc = function (a, b, c, d) {
      return og(this, a, b, c, d);
    };function og(a, b, c, d, e, f) {
      if (da(c)) for (var g = 0; g < c.length; g++) {
        og(a, b, c[g], d, e, f);
      } else {
        b = bf(b, c, d || a.handleEvent, e, f || a.sc || a);if (!b) return a;a.u[b.key] = b;
      }return a;
    }h.Gc = function (a, b, c, d, e) {
      if (da(b)) for (var f = 0; f < b.length; f++) {
        this.Gc(a, b[f], c, d, e);
      } else c = c || this.handleEvent, e = e || this.sc || this, c = We(c), d = !!d, b = Le(a) ? a.fb(b, c, d, e) : a ? (a = Ye(a)) ? a.fb(b, c, d, e) : null : null, b && (df(b), delete this.u[b.key]);return this;
    };h.Sb = function () {
      Wa(this.u, function (a, b) {
        this.u.hasOwnProperty(b) && df(a);
      }, this);this.u = {};
    };h.f = function () {
      mg.h.f.call(this);this.Sb();
    };h.handleEvent = function () {
      throw Error("EventHandler.handleEvent not implemented");
    };function pg() {}pg.ca = void 0;pg.Qd = function () {
      return pg.ca ? pg.ca : pg.ca = new pg();
    };pg.prototype.je = 0;function qg(a) {
      F.call(this);this.bb = a || sc();this.Ca = null;this.Da = !1;this.j = null;this.pa = void 0;this.vb = this.na = this.s = null;this.Ge = !1;
    }t(qg, F);h = qg.prototype;h.$d = pg.Qd();h.L = function () {
      return this.j;
    };h.mc = function (a) {
      return this.j ? this.bb.mc(a, this.j) : [];
    };h.o = function (a) {
      return this.j ? this.bb.o(a, this.j) : null;
    };function rg(a) {
      a.pa || (a.pa = new mg(a));return a.pa;
    }h.getParent = function () {
      return this.s;
    };h.Dc = function (a) {
      if (this.s && this.s != a) throw Error("Method not supported");qg.h.Dc.call(this, a);
    };h.Pa = function () {
      return this.bb;
    };h.hc = function () {
      this.j = this.bb.createElement(Db);
    };
    h.render = function (a) {
      if (this.Da) throw Error("Component already rendered");this.j || this.hc();a ? a.insertBefore(this.j, null) : this.bb.Y.body.appendChild(this.j);this.s && !this.s.Da || this.m();
    };h.m = function () {
      this.Da = !0;sg(this, function (a) {
        !a.Da && a.L() && a.m();
      });
    };h.eb = function () {
      sg(this, function (a) {
        a.Da && a.eb();
      });this.pa && this.pa.Sb();this.Da = !1;
    };h.f = function () {
      this.Da && this.eb();this.pa && (this.pa.i(), delete this.pa);sg(this, function (a) {
        a.i();
      });!this.Ge && this.j && Dc(this.j);this.s = this.j = this.vb = this.na = null;
      qg.h.f.call(this);
    };function sg(a, b) {
      a.na && Ga(a.na, b, void 0);
    }h.removeChild = function (a, b) {
      if (a) {
        var c = n(a) ? a : a.Ca || (a.Ca = ":" + (a.$d.je++).toString(36));this.vb && c ? (a = this.vb, a = (null !== a && c in a ? a[c] : void 0) || null) : a = null;if (c && a) {
          var d = this.vb;c in d && delete d[c];Na(this.na, a);b && (a.eb(), a.j && Dc(a.j));b = a;if (null == b) throw Error("Unable to set parent component");b.s = null;qg.h.Dc.call(b, null);
        }
      }if (!a) throw Error("Child is not in parent component");return a;
    };function tg(a) {
      if (a.classList) return a.classList;
      a = a.className;return n(a) && a.match(/\S+/g) || [];
    }function ug(a, b) {
      return a.classList ? a.classList.contains(b) : Ma(tg(a), b);
    }function vg(a, b) {
      a.classList ? a.classList.add(b) : ug(a, b) || (a.className += 0 < a.className.length ? " " + b : b);
    }function wg(a, b) {
      a.classList ? a.classList.remove(b) : ug(a, b) && (a.className = Ia(tg(a), function (a) {
        return a != b;
      }).join(" "));
    }function xg(a, b) {
      F.call(this);a && (this.Lb && this.detach(), this.j = a, this.Kb = Ve(this.j, "keypress", this, b), this.wc = Ve(this.j, "keydown", this.Db, b, this), this.Lb = Ve(this.j, "keyup", this.Yd, b, this));
    }t(xg, F);h = xg.prototype;h.j = null;h.Kb = null;h.wc = null;h.Lb = null;h.P = -1;h.qa = -1;h.bc = !1;var yg = { 3: 13, 12: 144, 63232: 38, 63233: 40, 63234: 37, 63235: 39, 63236: 112, 63237: 113, 63238: 114, 63239: 115, 63240: 116, 63241: 117, 63242: 118, 63243: 119, 63244: 120, 63245: 121, 63246: 122, 63247: 123, 63248: 44, 63272: 46, 63273: 36, 63275: 35, 63276: 33, 63277: 34, 63289: 144, 63302: 45 },
        zg = { Up: 38, Down: 40, Left: 37, Right: 39, Enter: 13, F1: 112, F2: 113, F3: 114, F4: 115, F5: 116, F6: 117, F7: 118, F8: 119, F9: 120, F10: 121, F11: 122, F12: 123, "U+007F": 46,
      Home: 36, End: 35, PageUp: 33, PageDown: 34, Insert: 45 },
        Ag = v || hb || w && x("525"),
        Bg = lb && jb;h = xg.prototype;h.Db = function (a) {
      if (w || hb) if (17 == this.P && !a.ctrlKey || 18 == this.P && !a.altKey || lb && 91 == this.P && !a.metaKey) this.qa = this.P = -1;-1 == this.P && (a.ctrlKey && 17 != a.keyCode ? this.P = 17 : a.altKey && 18 != a.keyCode ? this.P = 18 : a.metaKey && 91 != a.keyCode && (this.P = 91));Ag && !Sf(a.keyCode, this.P, a.shiftKey, a.ctrlKey, a.altKey, a.metaKey) ? this.handleEvent(a) : (this.qa = Uf(a.keyCode), Bg && (this.bc = a.altKey));
    };h.Yd = function (a) {
      this.qa = this.P = -1;this.bc = a.altKey;
    };h.handleEvent = function (a) {
      var b = a.$,
          c,
          d,
          e = b.altKey;v && "keypress" == a.type ? (c = this.qa, d = 13 != c && 27 != c ? b.keyCode : 0) : (w || hb) && "keypress" == a.type ? (c = this.qa, d = 0 <= b.charCode && 63232 > b.charCode && Tf(c) ? b.charCode : 0) : gb && !w ? (c = this.qa, d = Tf(c) ? b.keyCode : 0) : (c = b.keyCode || this.qa, d = b.charCode || 0, Bg && (e = this.bc), lb && 63 == d && 224 == c && (c = 191));var f = c = Uf(c);c ? 63232 <= c && c in yg ? f = yg[c] : 25 == c && a.shiftKey && (f = 9) : b.keyIdentifier && b.keyIdentifier in zg && (f = zg[b.keyIdentifier]);a = f == this.P;this.P = f;b = new Cg(f, d, a, b);b.altKey = e;this.dispatchEvent(b);
    };h.L = function () {
      return this.j;
    };h.detach = function () {
      this.Kb && (df(this.Kb), df(this.wc), df(this.Lb), this.Lb = this.wc = this.Kb = null);this.j = null;this.qa = this.P = -1;
    };h.f = function () {
      xg.h.f.call(this);this.detach();
    };function Cg(a, b, c, d) {
      E.call(this, d);this.type = "key";this.keyCode = a;this.charCode = b;this.repeat = c;
    }t(Cg, E);var Dg = !v && !(u("Safari") && !((u("Chrome") || u("CriOS")) && !u("Edge") || u("Coast") || u("Opera") || u("Edge") || u("Silk") || u("Android")));function Eg(a, b) {
      return Dg && a.dataset ? b in a.dataset ? a.dataset[b] : null : a.getAttribute("data-" + String(b).replace(/([A-Z])/g, "-$1").toLowerCase());
    }function G(a) {
      var b = a.type;if (!m(b)) return null;switch (b.toLowerCase()) {case "checkbox":case "radio":
          return a.checked ? a.value : null;case "select-one":
          return b = a.selectedIndex, 0 <= b ? a.options[b].value : null;case "select-multiple":
          for (var b = [], c, d = 0; c = a.options[d]; d++) {
            c.selected && b.push(c.value);
          }return b.length ? b : null;default:
          return m(a.value) ? a.value : null;}
    }function Fg(a, b) {
      var c;
      try {
        c = "number" == typeof a.selectionStart;
      } catch (d) {
        c = !1;
      }c ? (a.selectionStart = b, a.selectionEnd = b) : v && !x("9") && ("textarea" == a.type && (b = a.value.substring(0, b).replace(/(\r\n|\r|\n)/g, "\n").length), a = a.createTextRange(), a.collapse(!0), a.move("character", b), a.select());
    }function Gg(a) {
      F.call(this);this.j = a;Ve(a, Hg, this.Db, !1, this);Ve(a, "click", this.Uc, !1, this);
    }t(Gg, F);var Hg = jb ? "keypress" : "keydown";Gg.prototype.Db = function (a) {
      (13 == a.keyCode || w && 3 == a.keyCode) && Ig(this, a);
    };Gg.prototype.Uc = function (a) {
      Ig(this, a);
    };function Ig(a, b) {
      var c = new Jg(b);if (a.dispatchEvent(c)) {
        c = new Kg(b);try {
          a.dispatchEvent(c);
        } finally {
          b.stopPropagation();
        }
      }
    }Gg.prototype.f = function () {
      Gg.h.f.call(this);cf(this.j, Hg, this.Db, !1, this);cf(this.j, "click", this.Uc, !1, this);delete this.j;
    };function Kg(a) {
      E.call(this, a.$);this.type = "action";
    }t(Kg, E);function Jg(a) {
      E.call(this, a.$);this.type = "beforeaction";
    }t(Jg, E);function Lg(a) {
      F.call(this);this.j = a;a = v ? "focusout" : "blur";this.he = Ve(this.j, v ? "focusin" : "focus", this, !v);this.ie = Ve(this.j, a, this, !v);
    }t(Lg, F);Lg.prototype.handleEvent = function (a) {
      var b = new E(a.$);b.type = "focusin" == a.type || "focus" == a.type ? "focusin" : "focusout";this.dispatchEvent(b);
    };Lg.prototype.f = function () {
      Lg.h.f.call(this);df(this.he);df(this.ie);delete this.j;
    };function Mg(a) {
      F.call(this);this.H = null;this.j = a;a = v || hb || w && !x("531") && a.tagName == Zb;this.Qc = new mg(this);this.Qc.ra(this.j, a ? ["keydown", "paste", "cut", "drop", "input"] : "input", this);
    }t(Mg, F);Mg.prototype.handleEvent = function (a) {
      if ("input" == a.type) v && x(10) && 0 == a.keyCode && 0 == a.charCode || (Ng(this), this.dispatchEvent(Og(a)));else if ("keydown" != a.type || Rf(a)) {
        var b = "keydown" == a.type ? this.j.value : null;v && 229 == a.keyCode && (b = null);var c = Og(a);Ng(this);this.H = kf(function () {
          this.H = null;this.j.value != b && this.dispatchEvent(c);
        }, this);
      }
    };function Ng(a) {
      null != a.H && (l.clearTimeout(a.H), a.H = null);
    }function Og(a) {
      a = new E(a.$);a.type = "input";return a;
    }Mg.prototype.f = function () {
      Mg.h.f.call(this);this.Qc.i();Ng(this);delete this.j;
    };var Pg = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;
    function Qg(a) {
      var b = {},
          c = b.document || document,
          d;a instanceof ec && a.constructor === ec && a.wd === fc ? d = a.Qb : (Da("expected object of type TrustedResourceUrl, got '" + a + "' of type " + ba(a)), d = "type_error:TrustedResourceUrl");var e = document.createElement(String(Ub));a = { kd: e, rd: void 0 };var f = new cg(Rg, a),
          g = null,
          k = null != b.timeout ? b.timeout : 5E3;0 < k && (g = window.setTimeout(function () {
        Sg(e, !0);var a = new Tg(Ug, "Timeout reached for loading script " + d);eg(f);fg(f, !1, a);
      }, k), a.rd = g);e.onload = e.onreadystatechange = function () {
        e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Sg(e, b.Se || !1, g), eg(f), fg(f, !0, null));
      };e.onerror = function () {
        Sg(e, !0, g);var a = new Tg(Vg, "Error while loading script " + d);eg(f);fg(f, !1, a);
      };a = b.attributes || {};bb(a, { type: "text/javascript", charset: "UTF-8", src: d });yc(e, a);Wg(c).appendChild(e);return f;
    }function Wg(a) {
      var b = (a || document).getElementsByTagName(String(Gb));return b && 0 != b.length ? b[0] : a.documentElement;
    }function Rg() {
      if (this && this.kd) {
        var a = this.kd;a && a.tagName == Ub && Sg(a, !0, this.rd);
      }
    }function Sg(a, b, c) {
      null != c && l.clearTimeout(c);a.onload = aa;a.onerror = aa;a.onreadystatechange = aa;b && window.setTimeout(function () {
        Dc(a);
      }, 0);
    }var Vg = 0,
        Ug = 1;function Tg(a, b) {
      var c = "Jsloader error (code #" + a + ")";b && (c += ": " + b);pa.call(this, c);this.code = a;
    }t(Tg, pa);function Xg(a) {
      this.Mb = a;
    }Xg.prototype.set = function (a, b) {
      m(b) ? this.Mb.set(a, mf(b)) : this.Mb.remove(a);
    };Xg.prototype.get = function (a) {
      var b;try {
        b = this.Mb.get(a);
      } catch (c) {
        return;
      }if (null !== b) try {
        return lf(b);
      } catch (c$3) {
        throw "Storage: Invalid value was encountered";
      }
    };Xg.prototype.remove = function (a) {
      this.Mb.remove(a);
    };function Yg() {}function Zg() {}t(Zg, Yg);Zg.prototype.clear = function () {
      var a = Oc(this.va(!0)),
          b = this;Ga(a, function (a) {
        b.remove(a);
      });
    };function $g(a) {
      this.T = a;
    }t($g, Zg);function ah(a) {
      if (!a.T) return !1;try {
        return a.T.setItem("__sak", "1"), a.T.removeItem("__sak"), !0;
      } catch (b) {
        return !1;
      }
    }h = $g.prototype;h.set = function (a, b) {
      try {
        this.T.setItem(a, b);
      } catch (c) {
        if (0 == this.T.length) throw "Storage mechanism: Storage disabled";throw "Storage mechanism: Quota exceeded";
      }
    };h.get = function (a) {
      a = this.T.getItem(a);if (!n(a) && null !== a) throw "Storage mechanism: Invalid value was encountered";return a;
    };h.remove = function (a) {
      this.T.removeItem(a);
    };h.va = function (a) {
      var b = 0,
          c = this.T,
          d = new Lc();d.next = function () {
        if (b >= c.length) throw Kc;var d = c.key(b++);if (a) return d;d = c.getItem(d);if (!n(d)) throw "Storage mechanism: Invalid value was encountered";return d;
      };return d;
    };h.clear = function () {
      this.T.clear();
    };h.key = function (a) {
      return this.T.key(a);
    };function bh() {
      var a = null;try {
        a = window.localStorage || null;
      } catch (b) {}this.T = a;
    }t(bh, $g);function ch() {
      var a = null;try {
        a = window.sessionStorage || null;
      } catch (b) {}this.T = a;
    }t(ch, $g);function dh(a, b) {
      this.kb = a;this.ta = b + "::";
    }t(dh, Zg);dh.prototype.set = function (a, b) {
      this.kb.set(this.ta + a, b);
    };dh.prototype.get = function (a) {
      return this.kb.get(this.ta + a);
    };dh.prototype.remove = function (a) {
      this.kb.remove(this.ta + a);
    };dh.prototype.va = function (a) {
      var b = this.kb.va(!0),
          c = this,
          d = new Lc();d.next = function () {
        for (var d = b.next(); d.substr(0, c.ta.length) != c.ta;) {
          d = b.next();
        }return a ? d.substr(c.ta.length) : c.kb.get(d);
      };return d;
    };function eh(a) {
      this.M = void 0;this.G = {};if (a) {
        var b = Ic(a);a = Hc(a);for (var c = 0; c < b.length; c++) {
          this.set(b[c], a[c]);
        }
      }
    }h = eh.prototype;h.set = function (a, b) {
      fh(this, a, b, !1);
    };h.add = function (a, b) {
      fh(this, a, b, !0);
    };function fh(a, b, c, d) {
      for (var e = 0; e < b.length; e++) {
        var f = b.charAt(e);a.G[f] || (a.G[f] = new eh());a = a.G[f];
      }if (d && void 0 !== a.M) throw Error('The collection already contains the key "' + b + '"');a.M = c;
    }h.get = function (a) {
      a: {
        for (var b = this, c = 0; c < a.length; c++) {
          if (b = b.G[a.charAt(c)], !b) {
            a = void 0;
            break a;
          }
        }a = b;
      }return a ? a.M : void 0;
    };h.R = function () {
      var a = [];gh(this, a);return a;
    };function gh(a, b) {
      void 0 !== a.M && b.push(a.M);for (var c in a.G) {
        gh(a.G[c], b);
      }
    }h.ga = function (a) {
      var b = [];if (a) {
        for (var c = this, d = 0; d < a.length; d++) {
          var e = a.charAt(d);if (!c.G[e]) return [];c = c.G[e];
        }hh(c, a, b);
      } else hh(this, "", b);return b;
    };function hh(a, b, c) {
      void 0 !== a.M && c.push(b);for (var d in a.G) {
        hh(a.G[d], b + d, c);
      }
    }h.Ma = function (a) {
      return void 0 !== this.get(a);
    };h.clear = function () {
      this.G = {};this.M = void 0;
    };h.remove = function (a) {
      for (var b = this, c = [], d = 0; d < a.length; d++) {
        var e = a.charAt(d);if (!b.G[e]) throw Error('The collection does not have the key "' + a + '"');c.push([b, e]);b = b.G[e];
      }a = b.M;for (delete b.M; 0 < c.length;) {
        if (e = c.pop(), b = e[0], e = e[1], b.G[e].Jb()) delete b.G[e];else break;
      }return a;
    };h.clone = function () {
      return new eh(this);
    };h.Jb = function () {
      var a;if (a = void 0 === this.M) a: {
        a = this.G;for (var b in a) {
          a = !1;break a;
        }a = !0;
      }return a;
    };function ih(a) {
      a = a || {};var b = a.email,
          c = a.disabled,
          d = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="email">',
          d = a.Qe ? d + "Enter new email address" : d + "Email",
          d = d + ('</label><input type="email" name="email" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="' + Hd(null != b ? b : "") + '"' + (c ? "disabled" : "") + '></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-email-error"></p></div>');return C(d);
    }function H(a) {
      a = a || {};a = a.label;var b = '<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">',
          b = a ? b + B(a) : b + "Next";return C(b + "</button>");
    }function jh() {
      var a;a = "" + H({ label: Fd("Sign In") });return C(a);
    }function kh() {
      var a;a = "" + H({ label: Fd("Save") });return C(a);
    }function lh() {
      var a;a = "" + H({ label: Fd("Continue") });return C(a);
    }function mh(a) {
      a = a || {};a = a.label;var b = '<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="newPassword">',
          b = a ? b + B(a) : b + "Choose password";
      return C(b + '</label><input type="password" name="newPassword" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>');
    }function nh() {
      var a;
      a = {};var b = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="password">',
          b = a.current ? b + "Current password" : b + "Password";return C(b + '</label><input type="password" name="password" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-password-error"></p></div>');
    }
    function oh() {
      return C('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>');
    }function ph() {
      return C('<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">Cancel</button>');
    }function qh(a) {
      a = "" + ('<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">' + B(a.message) + '&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>');
      return C(a);
    }qh.B = "firebaseui.auth.soy2.element.infoBar";function rh(a) {
      var b = a.content;a = a.Ed;return C('<dialog class="mdl-dialog firebaseui-dialog firebaseui-id-dialog' + (a ? " " + Hd(a) : "") + '">' + B(b) + "</dialog>");
    }function sh(a) {
      var b = a.message;return C(rh({ content: Gd('<div class="firebaseui-dialog-icon-wrapper"><div class="' + Hd(a.Gb) + ' firebaseui-dialog-icon"></div></div><div class="firebaseui-progress-dialog-message">' + B(b) + "</div>") }));
    }sh.B = "firebaseui.auth.soy2.element.progressDialog";function th(a) {
      var b = '<div class="firebaseui-list-box-actions">';a = a.items;for (var c = a.length, d = 0; d < c; d++) {
        var e = a[d],
            b = b + ('<button type="button" data-listboxid="' + Hd(e.id) + '" class="mdl-button firebaseui-id-list-box-dialog-button firebaseui-list-box-dialog-button">' + (e.Gb ? '<div class="firebaseui-list-box-icon-wrapper"><div class="firebaseui-list-box-icon ' + Hd(e.Gb) + '"></div></div>' : "") + '<div class="firebaseui-list-box-label-wrapper">' + B(e.label) + "</div></button>");
      }b = "" + rh({ Ed: Fd("firebaseui-list-box-dialog"), content: Gd(b + "</div>") });return C(b);
    }th.B = "firebaseui.auth.soy2.element.listBoxDialog";function uh() {
      return C('<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>');
    }uh.B = "firebaseui.auth.soy2.element.busyIndicator";function vh(a) {
      a = a || {};var b = "";switch (a.providerId) {case "google.com":
          b += "Google";break;case "github.com":
          b += "Github";break;case "facebook.com":
          b += "Facebook";break;case "twitter.com":
          b += "Twitter";break;default:
          b += "Password";}return D(b);
    }
    function wh(a) {
      a = a || {};var b = a.Hd;a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + ih(a) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? ph() : "") + H(null) + "</div></div></form></div>");return C(a);
    }wh.B = "firebaseui.auth.soy2.page.signIn";
    function xh(a) {
      a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">' + ih(a) + nh() + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + oh() + '</div><div class="firebaseui-form-actions">' + jh() + "</div></div></form></div>");return C(a);
    }xh.B = "firebaseui.auth.soy2.page.passwordSignIn";
    function yh(a) {
      a = a || {};var b = a.qe,
          c = a.rb,
          d = a.ac,
          e = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">' + ih(a);b ? (b = a || {}, b = b.name, b = "" + ('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="name">First &amp; last name</label><input type="text" name="name" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="' + Hd(null != b ? b : "") + '"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-name-error"></p></div>'), b = C(b)) : b = "";e = e + b + mh({ Re: !0 });c ? (a = a || {}, a = "By tapping SAVE, you are indicating that you agree to the " + ('<a href="' + Hd(Md(a.rb)) + '" class="firebaseui-link" target="_blank">Terms of Service</a>'), a = C("" + ('<p class="firebaseui-tos">' + a + "</p>"))) : a = "";d = "" + (e + a + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (d ? ph() : "") + kh() + "</div></div></form></div>");return C(d);
    }yh.B = "firebaseui.auth.soy2.page.passwordSignUp";function zh(a) {
      a = a || {};var b = a.ac;a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>' + ih(a) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? ph() : "") + H({ label: Fd("Send") }) + "</div></div></form></div>");return C(a);
    }zh.B = "firebaseui.auth.soy2.page.passwordRecovery";function Ah(a) {
      var b = a.N,
          c = "";a = "Follow the instructions sent to <strong>" + (B(a.email) + "</strong> to recover your password");c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions">';b && (c += '<div class="firebaseui-form-actions">' + H({ label: Fd("Done") }) + "</div>");return C(c + "</div></div>");
    }Ah.B = "firebaseui.auth.soy2.page.passwordRecoveryEmailSent";function Bh() {
      return C('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">' + uh() + "</div></div>");
    }Bh.B = "firebaseui.auth.soy2.page.callback";function Ch(a) {
      var b = "";a = 'You\u2019ve already used <strong>' + (B(a.email) + "</strong> to sign in. Enter your password for that account.");b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">' + a + "</p>" + nh() + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + oh() + '</div><div class="firebaseui-form-actions">' + jh() + "</div></div></form></div>";return C(b);
    }Ch.B = "firebaseui.auth.soy2.page.passwordLinking";function Dh(a) {
      var b = a.email,
          c = "";a = "" + vh(a);a = Fd(a);b = 'You\u2019ve already used <strong>' + (B(b) + ("</strong>. Sign in with " + (B(a) + " to continue.")));c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">' + b + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + H({ label: Fd("Sign in with " + a) }) + "</div></div></form></div>";return C(c);
    }Dh.B = "firebaseui.auth.soy2.page.federatedLinking";function Eh(a) {
      var b = "",
          c = '<p class="firebaseui-text">for <strong>' + (B(a.email) + "</strong></p>"),
          b = b + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content">' + c + mh(Ed(a)) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + kh() + "</div></div></form></div>");return C(b);
    }Eh.B = "firebaseui.auth.soy2.page.passwordReset";function Fh(a) {
      a = a || {};a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-actions">' + (a.N ? '<div class="firebaseui-form-actions">' + lh() + "</div>" : "") + "</div></div>");return C(a);
    }Fh.B = "firebaseui.auth.soy2.page.passwordResetSuccess";function Gh(a) {
      a = a || {};a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-actions">' + (a.N ? '<div class="firebaseui-form-actions">' + H(null) + "</div>" : "") + "</div></div>");return C(a);
    }Gh.B = "firebaseui.auth.soy2.page.passwordResetFailure";function Hh(a) {
      var b = a.N,
          c = "";a = "Your sign-in email address has been changed back to <strong>" + (B(a.email) + "</strong>.");c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p><p class="firebaseui-text">If you didn\u2019t ask to change your sign-in email, it\u2019s possible someone is trying to access your account and you should <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">change your password right away</a>.</p></div><div class="firebaseui-card-actions">' + (b ? '<div class="firebaseui-form-actions">' + H(null) + "</div>" : "") + "</div></form></div>";return C(c);
    }Hh.B = "firebaseui.auth.soy2.page.emailChangeRevokeSuccess";function Ih(a) {
      a = a || {};a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Unable to update your email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">There was a problem changing your sign-in email back.</p><p class="firebaseui-text">If you try again and still can\u2019t reset your email, try asking your administrator for help.</p></div><div class="firebaseui-card-actions">' + (a.N ? '<div class="firebaseui-form-actions">' + H(null) + "</div>" : "") + "</div></div>");return C(a);
    }Ih.B = "firebaseui.auth.soy2.page.emailChangeRevokeFailure";function Jh(a) {
      a = a || {};a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-actions">' + (a.N ? '<div class="firebaseui-form-actions">' + lh() + "</div>" : "") + "</div></div>");return C(a);
    }Jh.B = "firebaseui.auth.soy2.page.emailVerificationSuccess";function Kh(a) {
      a = a || {};a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-actions">' + (a.N ? '<div class="firebaseui-form-actions">' + H(null) + "</div>" : "") + "</div></div>");return C(a);
    }Kh.B = "firebaseui.auth.soy2.page.emailVerificationFailure";function Lh(a) {
      a = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + B(a.Ld) + "</p></div></div>");return C(a);
    }Lh.B = "firebaseui.auth.soy2.page.unrecoverableError";
    function Mh(a) {
      var b = a.le,
          c = "";a = "Continue with " + (B(a.Fe) + "?");b = "You originally wanted to sign in with " + B(b);c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">' + a + '</h2><p class="firebaseui-text">' + b + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ph() + H({ label: Fd("Continue") }) + "</div></div></form></div>";return C(c);
    }Mh.B = "firebaseui.auth.soy2.page.emailMismatch";function Nh(a, b, c) {
      var d = '<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';a = a.oe;b = a.length;for (var e = 0; e < b; e++) {
        var f;f = { providerId: a[e] };var g = c,
            k = f.providerId,
            r = f,
            r = r || {},
            N = "";switch (r.providerId) {case "google.com":
            N += "firebaseui-idp-google";
            break;case "github.com":
            N += "firebaseui-idp-github";break;case "facebook.com":
            N += "firebaseui-idp-facebook";break;case "twitter.com":
            N += "firebaseui-idp-twitter";break;case "phone":
            N += "firebaseui-idp-phone";break;default:
            N += "firebaseui-idp-password";}var r = '<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised ' + Hd(D(N)) + ' firebaseui-id-idp-button" data-provider-id="' + Hd(k) + '"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="',
            N = (N = f) || {},
            Fa = "";switch (N.providerId) {case "google.com":
            Fa += Md(g.Xd);break;case "github.com":
            Fa += Md(g.Wd);break;case "facebook.com":
            Fa += Md(g.Od);break;case "twitter.com":
            Fa += Md(g.Ce);break;case "phone":
            Fa += Md(g.me);break;default:
            Fa += Md(g.ke);}g = Dd(Fa);r = r + Hd(Md(g)) + '"></span>';"password" == k ? r += '<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Email</span>' : "phone" == k ? r += '<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with phone</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Phone</span>' : (k = "Sign in with " + B(vh(f)), r += '<span class="firebaseui-idp-text firebaseui-idp-text-long">' + k + '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">' + B(vh(f)) + "</span>");f = C(r + "</button>");d += '<li class="firebaseui-list-item">' + f + "</li>";
      }return C(d + "</ul></form></div></div>");
    }Nh.B = "firebaseui.auth.soy2.page.providerSignIn";function Oh(a) {
      a = a || {};var b = a.Jd;a = a || {};a = a.lb;a = "" + ('<div class="firebaseui-phone-number"><button class="firebaseui-id-country-selector firebaseui-country-selector mdl-button mdl-js-button"><span class="firebaseui-flag firebaseui-country-selector-flag firebaseui-id-country-selector-flag"></span><span class="firebaseui-id-country-selector-code"></span></button><div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label firebaseui-textfield firebaseui-phone-input-wrapper"><label class="mdl-textfield__label firebaseui-label" for="phoneNumber">Phone number</label><input type="tel" name="phoneNumber" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-number" value="' + Hd(null != a ? a : "") + '"></div></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-phone-number-error firebaseui-id-phone-number-error"></p></div>');b = "" + ('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-start"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Enter your phone number</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + C(a) + (b ? C('<div class="firebaseui-recaptcha-wrapper"><div class="firebaseui-recaptcha-container"></div><div class="firebaseui-error-wrapper firebaseui-recaptcha-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-recaptcha-error"></p></div></div>') : "") + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ph() + H({ label: Fd("Verify") }) + '</div></div><div class="firebaseui-card-footer">' + C('<p class="firebaseui-tos">By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.</p>') + "</div></form></div>");return C(b);
    }Oh.B = "firebaseui.auth.soy2.page.phoneSignInStart";function Ph(a) {
      a = a || {};var b = a.phoneNumber,
          c = a.rb,
          d = "",
          e = 'Enter the 6-digit code we sent to <a class="firebaseui-link firebaseui-change-phone-number-link firebaseui-id-change-phone-number-link" href="javascript:void(0)">&lrm;' + (B(b) + "</a>");B(b);b = d;e = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-finish"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Verify your phone number</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + e + "</p>" + C('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="phoneConfirmationCode">6-digit code</label><input type="number" name="phoneConfirmationCode" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-confirmation-code"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-phone-confirmation-code-error"></p></div>') + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ph() + H({ label: Fd("Continue") }) + "</div></div>";c ? (a = a || {}, a = "By tapping Continue you are indicating that you agree to the " + ('<a href="' + Hd(Md(a.rb)) + '" class="firebaseui-link" target="_blank">Terms of Service</a>'), a = '<div class="firebaseui-card-footer">' + C("" + ('<p class="firebaseui-tos">' + a + "</p>")) + "</div>") : a = "";d = b + (e + a + "</form>" + C('<div class="firebaseui-resend-container"><span class="firebaseui-id-resend-countdown"></span><a href="javascript:void(0)" class="firebaseui-id-resend-link firebaseui-hidden firebaseui-link">Resend</a></div>') + "</div>");return C(d);
    }Ph.B = "firebaseui.auth.soy2.page.phoneSignInFinish";function Qh() {
      return D("Enter a valid phone number");
    }function Rh() {
      return D("This email already exists without any means of sign-in. Please reset the password to recover.");
    }function Sh() {
      return D("Please login again to perform this operation");
    }function Th(a) {
      this.ab = a;this.Fc = new eh();for (a = 0; a < this.ab.length; a++) {
        var b = this.Fc.get("+" + this.ab[a].a);b ? b.push(this.ab[a]) : this.Fc.add("+" + this.ab[a].a, [this.ab[a]]);
      }
    }Th.prototype.search = function (a) {
      var b = this.Fc,
          c = {},
          d = 0;void 0 !== b.M && (c[d] = b.M);for (; d < a.length; d++) {
        var e = a.charAt(d);if (!(e in b.G)) break;b = b.G[e];void 0 !== b.M && (c[d] = b.M);
      }for (var f in c) {
        if (c.hasOwnProperty(f)) return c[f];
      }return [];
    };function Uh(a) {
      for (var b = 0; b < Vh.length; b++) {
        if (Vh[b].b === a) return Vh[b];
      }return null;
    }var Vh = [{ name: "Afghanistan", b: "93-AF-0", a: "93", c: "AF" }, { name: '\xC5land Islands', b: "358-AX-0", a: "358", c: "AX" }, { name: "Albania", b: "355-AL-0", a: "355", c: "AL" }, { name: "Algeria", b: "213-DZ-0", a: "213", c: "DZ" }, { name: "American Samoa",
      b: "1-AS-0", a: "1", c: "AS" }, { name: "Andorra", b: "376-AD-0", a: "376", c: "AD" }, { name: "Angola", b: "244-AO-0", a: "244", c: "AO" }, { name: "Anguilla", b: "1-AI-0", a: "1", c: "AI" }, { name: "Antigua and Barbuda", b: "1-AG-0", a: "1", c: "AG" }, { name: "Argentina", b: "54-AR-0", a: "54", c: "AR" }, { name: "Armenia", b: "374-AM-0", a: "374", c: "AM" }, { name: "Aruba", b: "297-AW-0", a: "297", c: "AW" }, { name: "Ascension Island", b: "247-AC-0", a: "247", c: "AC" }, { name: "Australia", b: "61-AU-0", a: "61", c: "AU" }, { name: "Austria", b: "43-AT-0", a: "43", c: "AT" }, { name: "Azerbaijan",
      b: "994-AZ-0", a: "994", c: "AZ" }, { name: "Bahamas", b: "1-BS-0", a: "1", c: "BS" }, { name: "Bahrain", b: "973-BH-0", a: "973", c: "BH" }, { name: "Bangladesh", b: "880-BD-0", a: "880", c: "BD" }, { name: "Barbados", b: "1-BB-0", a: "1", c: "BB" }, { name: "Belarus", b: "375-BY-0", a: "375", c: "BY" }, { name: "Belgium", b: "32-BE-0", a: "32", c: "BE" }, { name: "Belize", b: "501-BZ-0", a: "501", c: "BZ" }, { name: "Benin", b: "229-BJ-0", a: "229", c: "BJ" }, { name: "Bermuda", b: "1-BM-0", a: "1", c: "BM" }, { name: "Bhutan", b: "975-BT-0", a: "975", c: "BT" }, { name: "Bolivia", b: "591-BO-0", a: "591",
      c: "BO" }, { name: "Bosnia and Herzegovina", b: "387-BA-0", a: "387", c: "BA" }, { name: "Botswana", b: "267-BW-0", a: "267", c: "BW" }, { name: "Brazil", b: "55-BR-0", a: "55", c: "BR" }, { name: "British Indian Ocean Territory", b: "246-IO-0", a: "246", c: "IO" }, { name: "British Virgin Islands", b: "1-VG-0", a: "1", c: "VG" }, { name: "Brunei", b: "673-BN-0", a: "673", c: "BN" }, { name: "Bulgaria", b: "359-BG-0", a: "359", c: "BG" }, { name: "Burkina Faso", b: "226-BF-0", a: "226", c: "BF" }, { name: "Burundi", b: "257-BI-0", a: "257", c: "BI" }, { name: "Cambodia", b: "855-KH-0", a: "855",
      c: "KH" }, { name: "Cameroon", b: "237-CM-0", a: "237", c: "CM" }, { name: "Canada", b: "1-CA-0", a: "1", c: "CA" }, { name: "Cape Verde", b: "238-CV-0", a: "238", c: "CV" }, { name: "Caribbean Netherlands", b: "599-BQ-0", a: "599", c: "BQ" }, { name: "Cayman Islands", b: "1-KY-0", a: "1", c: "KY" }, { name: "Central African Republic", b: "236-CF-0", a: "236", c: "CF" }, { name: "Chad", b: "235-TD-0", a: "235", c: "TD" }, { name: "Chile", b: "56-CL-0", a: "56", c: "CL" }, { name: "China", b: "86-CN-0", a: "86", c: "CN" }, { name: "Christmas Island", b: "61-CX-0", a: "61", c: "CX" }, { name: "Cocos [Keeling] Islands",
      b: "61-CC-0", a: "61", c: "CC" }, { name: "Colombia", b: "57-CO-0", a: "57", c: "CO" }, { name: "Comoros", b: "269-KM-0", a: "269", c: "KM" }, { name: "Democratic Republic Congo", b: "243-CD-0", a: "243", c: "CD" }, { name: "Republic of Congo", b: "242-CG-0", a: "242", c: "CG" }, { name: "Cook Islands", b: "682-CK-0", a: "682", c: "CK" }, { name: "Costa Rica", b: "506-CR-0", a: "506", c: "CR" }, { name: 'C\xF4te d\'Ivoire', b: "225-CI-0", a: "225", c: "CI" }, { name: "Croatia", b: "385-HR-0", a: "385", c: "HR" }, { name: "Cuba", b: "53-CU-0", a: "53", c: "CU" }, { name: 'Cura\xE7ao', b: "599-CW-0",
      a: "599", c: "CW" }, { name: "Cyprus", b: "357-CY-0", a: "357", c: "CY" }, { name: "Czech Republic", b: "420-CZ-0", a: "420", c: "CZ" }, { name: "Denmark", b: "45-DK-0", a: "45", c: "DK" }, { name: "Djibouti", b: "253-DJ-0", a: "253", c: "DJ" }, { name: "Dominica", b: "1-DM-0", a: "1", c: "DM" }, { name: "Dominican Republic", b: "1-DO-0", a: "1", c: "DO" }, { name: "East Timor", b: "670-TL-0", a: "670", c: "TL" }, { name: "Ecuador", b: "593-EC-0", a: "593", c: "EC" }, { name: "Egypt", b: "20-EG-0", a: "20", c: "EG" }, { name: "El Salvador", b: "503-SV-0", a: "503", c: "SV" }, { name: "Equatorial Guinea",
      b: "240-GQ-0", a: "240", c: "GQ" }, { name: "Eritrea", b: "291-ER-0", a: "291", c: "ER" }, { name: "Estonia", b: "372-EE-0", a: "372", c: "EE" }, { name: "Ethiopia", b: "251-ET-0", a: "251", c: "ET" }, { name: "Falkland Islands [Islas Malvinas]", b: "500-FK-0", a: "500", c: "FK" }, { name: "Faroe Islands", b: "298-FO-0", a: "298", c: "FO" }, { name: "Fiji", b: "679-FJ-0", a: "679", c: "FJ" }, { name: "Finland", b: "358-FI-0", a: "358", c: "FI" }, { name: "France", b: "33-FR-0", a: "33", c: "FR" }, { name: "French Guiana", b: "594-GF-0", a: "594", c: "GF" }, { name: "French Polynesia", b: "689-PF-0",
      a: "689", c: "PF" }, { name: "Gabon", b: "241-GA-0", a: "241", c: "GA" }, { name: "Gambia", b: "220-GM-0", a: "220", c: "GM" }, { name: "Georgia", b: "995-GE-0", a: "995", c: "GE" }, { name: "Germany", b: "49-DE-0", a: "49", c: "DE" }, { name: "Ghana", b: "233-GH-0", a: "233", c: "GH" }, { name: "Gibraltar", b: "350-GI-0", a: "350", c: "GI" }, { name: "Greece", b: "30-GR-0", a: "30", c: "GR" }, { name: "Greenland", b: "299-GL-0", a: "299", c: "GL" }, { name: "Grenada", b: "1-GD-0", a: "1", c: "GD" }, { name: "Guadeloupe", b: "590-GP-0", a: "590", c: "GP" }, { name: "Guam", b: "1-GU-0", a: "1", c: "GU" }, { name: "Guatemala",
      b: "502-GT-0", a: "502", c: "GT" }, { name: "Guernsey", b: "44-GG-0", a: "44", c: "GG" }, { name: "Guinea Conakry", b: "224-GN-0", a: "224", c: "GN" }, { name: "Guinea-Bissau", b: "245-GW-0", a: "245", c: "GW" }, { name: "Guyana", b: "592-GY-0", a: "592", c: "GY" }, { name: "Haiti", b: "509-HT-0", a: "509", c: "HT" }, { name: "Heard Island and McDonald Islands", b: "672-HM-0", a: "672", c: "HM" }, { name: "Honduras", b: "504-HN-0", a: "504", c: "HN" }, { name: "Hong Kong", b: "852-HK-0", a: "852", c: "HK" }, { name: "Hungary", b: "36-HU-0", a: "36", c: "HU" }, { name: "Iceland", b: "354-IS-0", a: "354",
      c: "IS" }, { name: "India", b: "91-IN-0", a: "91", c: "IN" }, { name: "Indonesia", b: "62-ID-0", a: "62", c: "ID" }, { name: "Iran", b: "98-IR-0", a: "98", c: "IR" }, { name: "Iraq", b: "964-IQ-0", a: "964", c: "IQ" }, { name: "Ireland", b: "353-IE-0", a: "353", c: "IE" }, { name: "Isle of Man", b: "44-IM-0", a: "44", c: "IM" }, { name: "Israel", b: "972-IL-0", a: "972", c: "IL" }, { name: "Italy", b: "39-IT-0", a: "39", c: "IT" }, { name: "Jamaica", b: "1-JM-0", a: "1", c: "JM" }, { name: "Japan", b: "81-JP-0", a: "81", c: "JP" }, { name: "Jersey", b: "44-JE-0", a: "44", c: "JE" }, { name: "Jordan", b: "962-JO-0",
      a: "962", c: "JO" }, { name: "Kazakhstan", b: "7-KZ-0", a: "7", c: "KZ" }, { name: "Kenya", b: "254-KE-0", a: "254", c: "KE" }, { name: "Kiribati", b: "686-KI-0", a: "686", c: "KI" }, { name: "Kosovo", b: "377-XK-0", a: "377", c: "XK" }, { name: "Kosovo", b: "381-XK-0", a: "381", c: "XK" }, { name: "Kosovo", b: "386-XK-0", a: "386", c: "XK" }, { name: "Kuwait", b: "965-KW-0", a: "965", c: "KW" }, { name: "Kyrgyzstan", b: "996-KG-0", a: "996", c: "KG" }, { name: "Laos", b: "856-LA-0", a: "856", c: "LA" }, { name: "Latvia", b: "371-LV-0", a: "371", c: "LV" }, { name: "Lebanon", b: "961-LB-0", a: "961", c: "LB" }, { name: "Lesotho", b: "266-LS-0", a: "266", c: "LS" }, { name: "Liberia", b: "231-LR-0", a: "231", c: "LR" }, { name: "Libya", b: "218-LY-0", a: "218", c: "LY" }, { name: "Liechtenstein", b: "423-LI-0", a: "423", c: "LI" }, { name: "Lithuania", b: "370-LT-0", a: "370", c: "LT" }, { name: "Luxembourg", b: "352-LU-0", a: "352", c: "LU" }, { name: "Macau", b: "853-MO-0", a: "853", c: "MO" }, { name: "Macedonia", b: "389-MK-0", a: "389", c: "MK" }, { name: "Madagascar", b: "261-MG-0", a: "261", c: "MG" }, { name: "Malawi", b: "265-MW-0", a: "265", c: "MW" }, { name: "Malaysia", b: "60-MY-0", a: "60", c: "MY" }, { name: "Maldives", b: "960-MV-0", a: "960", c: "MV" }, { name: "Mali", b: "223-ML-0", a: "223", c: "ML" }, { name: "Malta", b: "356-MT-0", a: "356", c: "MT" }, { name: "Marshall Islands", b: "692-MH-0", a: "692", c: "MH" }, { name: "Martinique", b: "596-MQ-0", a: "596", c: "MQ" }, { name: "Mauritania", b: "222-MR-0", a: "222", c: "MR" }, { name: "Mauritius", b: "230-MU-0", a: "230", c: "MU" }, { name: "Mayotte", b: "262-YT-0", a: "262", c: "YT" }, { name: "Mexico", b: "52-MX-0", a: "52", c: "MX" }, { name: "Micronesia", b: "691-FM-0", a: "691", c: "FM" }, { name: "Moldova", b: "373-MD-0", a: "373", c: "MD" }, { name: "Monaco", b: "377-MC-0", a: "377", c: "MC" }, { name: "Mongolia", b: "976-MN-0", a: "976", c: "MN" }, { name: "Montenegro", b: "382-ME-0", a: "382", c: "ME" }, { name: "Montserrat", b: "1-MS-0", a: "1", c: "MS" }, { name: "Morocco", b: "212-MA-0", a: "212", c: "MA" }, { name: "Mozambique", b: "258-MZ-0", a: "258", c: "MZ" }, { name: "Myanmar [Burma]", b: "95-MM-0", a: "95", c: "MM" }, { name: "Namibia", b: "264-NA-0", a: "264", c: "NA" }, { name: "Nauru", b: "674-NR-0", a: "674", c: "NR" }, { name: "Nepal", b: "977-NP-0", a: "977", c: "NP" }, { name: "Netherlands", b: "31-NL-0", a: "31", c: "NL" }, { name: "New Caledonia", b: "687-NC-0", a: "687", c: "NC" }, { name: "New Zealand", b: "64-NZ-0", a: "64", c: "NZ" }, { name: "Nicaragua", b: "505-NI-0", a: "505", c: "NI" }, { name: "Niger", b: "227-NE-0", a: "227", c: "NE" }, { name: "Nigeria", b: "234-NG-0", a: "234", c: "NG" }, { name: "Niue", b: "683-NU-0", a: "683", c: "NU" }, { name: "Norfolk Island", b: "672-NF-0", a: "672", c: "NF" }, { name: "North Korea", b: "850-KP-0", a: "850", c: "KP" }, { name: "Northern Mariana Islands", b: "1-MP-0", a: "1", c: "MP" }, { name: "Norway", b: "47-NO-0", a: "47", c: "NO" }, { name: "Oman", b: "968-OM-0",
      a: "968", c: "OM" }, { name: "Pakistan", b: "92-PK-0", a: "92", c: "PK" }, { name: "Palau", b: "680-PW-0", a: "680", c: "PW" }, { name: "Palestinian Territories", b: "970-PS-0", a: "970", c: "PS" }, { name: "Panama", b: "507-PA-0", a: "507", c: "PA" }, { name: "Papua New Guinea", b: "675-PG-0", a: "675", c: "PG" }, { name: "Paraguay", b: "595-PY-0", a: "595", c: "PY" }, { name: "Peru", b: "51-PE-0", a: "51", c: "PE" }, { name: "Philippines", b: "63-PH-0", a: "63", c: "PH" }, { name: "Poland", b: "48-PL-0", a: "48", c: "PL" }, { name: "Portugal", b: "351-PT-0", a: "351", c: "PT" }, { name: "Puerto Rico",
      b: "1-PR-0", a: "1", c: "PR" }, { name: "Qatar", b: "974-QA-0", a: "974", c: "QA" }, { name: 'R\xE9union', b: "262-RE-0", a: "262", c: "RE" }, { name: "Romania", b: "40-RO-0", a: "40", c: "RO" }, { name: "Russia", b: "7-RU-0", a: "7", c: "RU" }, { name: "Rwanda", b: "250-RW-0", a: "250", c: "RW" }, { name: 'Saint Barth\xE9lemy', b: "590-BL-0", a: "590", c: "BL" }, { name: "Saint Helena", b: "290-SH-0", a: "290", c: "SH" }, { name: "St. Kitts", b: "1-KN-0", a: "1", c: "KN" }, { name: "St. Lucia", b: "1-LC-0", a: "1", c: "LC" }, { name: "Saint Martin", b: "590-MF-0", a: "590", c: "MF" }, { name: "Saint Pierre and Miquelon",
      b: "508-PM-0", a: "508", c: "PM" }, { name: "St. Vincent", b: "1-VC-0", a: "1", c: "VC" }, { name: "Samoa", b: "685-WS-0", a: "685", c: "WS" }, { name: "San Marino", b: "378-SM-0", a: "378", c: "SM" }, { name: 'S\xE3o Tom\xE9 and Pr\xEDncipe', b: "239-ST-0", a: "239", c: "ST" }, { name: "Saudi Arabia", b: "966-SA-0", a: "966", c: "SA" }, { name: "Senegal", b: "221-SN-0", a: "221", c: "SN" }, { name: "Serbia", b: "381-RS-0", a: "381", c: "RS" }, { name: "Seychelles", b: "248-SC-0", a: "248", c: "SC" }, { name: "Sierra Leone", b: "232-SL-0", a: "232", c: "SL" }, { name: "Singapore", b: "65-SG-0",
      a: "65", c: "SG" }, { name: "Sint Maarten", b: "1-SX-0", a: "1", c: "SX" }, { name: "Slovakia", b: "421-SK-0", a: "421", c: "SK" }, { name: "Slovenia", b: "386-SI-0", a: "386", c: "SI" }, { name: "Solomon Islands", b: "677-SB-0", a: "677", c: "SB" }, { name: "Somalia", b: "252-SO-0", a: "252", c: "SO" }, { name: "South Africa", b: "27-ZA-0", a: "27", c: "ZA" }, { name: "South Georgia and the South Sandwich Islands", b: "500-GS-0", a: "500", c: "GS" }, { name: "South Korea", b: "82-KR-0", a: "82", c: "KR" }, { name: "South Sudan", b: "211-SS-0", a: "211", c: "SS" }, { name: "Spain", b: "34-ES-0",
      a: "34", c: "ES" }, { name: "Sri Lanka", b: "94-LK-0", a: "94", c: "LK" }, { name: "Sudan", b: "249-SD-0", a: "249", c: "SD" }, { name: "Suriname", b: "597-SR-0", a: "597", c: "SR" }, { name: "Svalbard and Jan Mayen", b: "47-SJ-0", a: "47", c: "SJ" }, { name: "Swaziland", b: "268-SZ-0", a: "268", c: "SZ" }, { name: "Sweden", b: "46-SE-0", a: "46", c: "SE" }, { name: "Switzerland", b: "41-CH-0", a: "41", c: "CH" }, { name: "Syria", b: "963-SY-0", a: "963", c: "SY" }, { name: "Taiwan", b: "886-TW-0", a: "886", c: "TW" }, { name: "Tajikistan", b: "992-TJ-0", a: "992", c: "TJ" }, { name: "Tanzania", b: "255-TZ-0",
      a: "255", c: "TZ" }, { name: "Thailand", b: "66-TH-0", a: "66", c: "TH" }, { name: "Togo", b: "228-TG-0", a: "228", c: "TG" }, { name: "Tokelau", b: "690-TK-0", a: "690", c: "TK" }, { name: "Tonga", b: "676-TO-0", a: "676", c: "TO" }, { name: "Trinidad/Tobago", b: "1-TT-0", a: "1", c: "TT" }, { name: "Tunisia", b: "216-TN-0", a: "216", c: "TN" }, { name: "Turkey", b: "90-TR-0", a: "90", c: "TR" }, { name: "Turkmenistan", b: "993-TM-0", a: "993", c: "TM" }, { name: "Turks and Caicos Islands", b: "1-TC-0", a: "1", c: "TC" }, { name: "Tuvalu", b: "688-TV-0", a: "688", c: "TV" }, { name: "U.S. Virgin Islands",
      b: "1-VI-0", a: "1", c: "VI" }, { name: "Uganda", b: "256-UG-0", a: "256", c: "UG" }, { name: "Ukraine", b: "380-UA-0", a: "380", c: "UA" }, { name: "United Arab Emirates", b: "971-AE-0", a: "971", c: "AE" }, { name: "United Kingdom", b: "44-GB-0", a: "44", c: "GB" }, { name: "United States", b: "1-US-0", a: "1", c: "US" }, { name: "Uruguay", b: "598-UY-0", a: "598", c: "UY" }, { name: "Uzbekistan", b: "998-UZ-0", a: "998", c: "UZ" }, { name: "Vanuatu", b: "678-VU-0", a: "678", c: "VU" }, { name: "Vatican City", b: "379-VA-0", a: "379", c: "VA" }, { name: "Venezuela", b: "58-VE-0", a: "58", c: "VE" }, { name: "Vietnam", b: "84-VN-0", a: "84", c: "VN" }, { name: "Wallis and Futuna", b: "681-WF-0", a: "681", c: "WF" }, { name: "Western Sahara", b: "212-EH-0", a: "212", c: "EH" }, { name: "Yemen", b: "967-YE-0", a: "967", c: "YE" }, { name: "Zambia", b: "260-ZM-0", a: "260", c: "ZM" }, { name: "Zimbabwe", b: "263-ZW-0", a: "263", c: "ZW" }];(function (a, b) {
      a.sort(function (a, d) {
        return a.name.localeCompare(d.name, b);
      });
    })(Vh, "en");var Wh = new Th(Vh);function Xh(a, b, c, d) {
      this.cb = a;this.Pc = b || null;this.ne = c || null;this.zc = d || null;
    }Xh.prototype.J = function () {
      return this.cb;
    };
    Xh.prototype.qb = function () {
      return { email: this.cb, displayName: this.Pc, photoUrl: this.ne, providerId: this.zc };
    };function Yh(a) {
      return a.email ? new Xh(a.email, a.displayName, a.photoUrl, a.providerId) : null;
    }var Zh = null;function $h(a) {
      return !(!a || -32E3 != a.code || "Service unavailable" != a.message);
    }function ai(a, b, c, d) {
      Zh || (a = { callbacks: { empty: a, select: function select(a, d) {
            a && a.account && b ? b(Yh(a.account)) : c && c(!$h(d));
          }, store: a, update: a }, language: "en", providers: void 0, ui: d }, "undefined" != typeof accountchooser && accountchooser.Api && accountchooser.Api.init ? Zh = accountchooser.Api.init(a) : (Zh = new bi(a), ci()));
    }function di(a, b, c) {
      function d() {
        var a = kd(c).toString();Zh.select(Ja(b || [], function (a) {
          return a.qb();
        }), { clientCallbackUrl: a });
      }b && b.length ? d() : Zh.checkEmpty(function (b, c) {
        b || c ? a(!$h(c)) : d();
      });
    }function bi(a) {
      this.g = a;this.g.callbacks = this.g.callbacks || {};
    }function ci() {
      var a = Zh;ga(a.g.callbacks.empty) && a.g.callbacks.empty();
    }var ei = { code: -32E3, message: "Service unavailable", data: "Service is unavailable." };h = bi.prototype;h.store = function () {
      ga(this.g.callbacks.store) && this.g.callbacks.store(void 0, ei);
    };h.select = function () {
      ga(this.g.callbacks.select) && this.g.callbacks.select(void 0, ei);
    };h.update = function () {
      ga(this.g.callbacks.update) && this.g.callbacks.update(void 0, ei);
    };h.checkDisabled = function (a) {
      a(!0);
    };h.checkEmpty = function (a) {
      a(void 0, ei);
    };h.checkAccountExist = function (a, b) {
      b(void 0, ei);
    };h.checkShouldUpdate = function (a, b) {
      b(void 0, ei);
    };function fi(a) {
      a = ha(a) && 1 == a.nodeType ? a : document.querySelector(String(a));if (null == a) throw Error("Could not find the FirebaseUI widget element on the page.");
      return a;
    }function gi(a) {
      hi(a, "upgradeElement");
    }function ii(a) {
      hi(a, "downgradeElements");
    }var ji = ["mdl-js-textfield", "mdl-js-progress", "mdl-js-spinner", "mdl-js-button"];function hi(a, b) {
      a && window.componentHandler && window.componentHandler[b] && Ga(ji, function (c) {
        if (ug(a, c)) window.componentHandler[b](a);c = vc(c, a);Ga(c, function (a) {
          window.componentHandler[b](a);
        });
      });
    }function ki() {
      this.ca = {};
    }ki.prototype.define = function (a, b) {
      if (a.toLowerCase() in this.ca) throw Error("Configuration " + a + " has already been defined.");
      this.ca[a.toLowerCase()] = b;
    };ki.prototype.update = function (a, b) {
      if (!(a.toLowerCase() in this.ca)) throw Error("Configuration " + a + " is not defined.");this.ca[a.toLowerCase()] = b;
    };ki.prototype.get = function (a) {
      if (!(a.toLowerCase() in this.ca)) throw Error("Configuration " + a + " is not defined.");return this.ca[a.toLowerCase()];
    };function li(a, b) {
      a = a.get(b);if (!a) throw Error("Configuration " + b + " is required.");return a;
    }var mi = {},
        ni = 0;function oi(a, b) {
      if (!a) throw Error("Event target element must be provided!");
      a = pi(a);if (mi[a] && mi[a].length) for (var c = 0; c < mi[a].length; c++) {
        mi[a][c].dispatchEvent(b);
      }
    }function qi(a) {
      var b = pi(a.L());mi[b] && mi[b].length && (Pa(mi[b], function (b) {
        return b == a;
      }), mi[b].length || delete mi[b]);
    }function pi(a) {
      "undefined" === typeof a.Oc && (a.Oc = ni, ni++);return a.Oc;
    }function ri(a) {
      if (!a) throw Error("Event target element must be provided!");this.Id = a;F.call(this);
    }t(ri, F);ri.prototype.L = function () {
      return this.Id;
    };ri.prototype.register = function () {
      var a = pi(this.L());mi[a] ? Ma(mi[a], this) || mi[a].push(this) : mi[a] = [this];
    };ri.prototype.unregister = function () {
      qi(this);
    };var si = { "facebook.com": "FacebookAuthProvider", "github.com": "GithubAuthProvider", "google.com": "GoogleAuthProvider", password: "EmailAuthProvider", "twitter.com": "TwitterAuthProvider", phone: "PhoneAuthProvider" };var Df;Df = Hf("firebaseui");var ti = new Of();if (1 != ti.Vc) {
      Gf();var ui = Ff,
          vi = ti.pe;ui.ib || (ui.ib = []);ui.ib.push(vi);ti.Vc = !0;
    }function wi(a, b) {
      this.cb = a;this.ya = b || null;
    }wi.prototype.J = function () {
      return this.cb;
    };wi.prototype.qb = function () {
      return { email: this.cb,
        credential: this.ya && $a(this.ya) };
    };function xi(a) {
      if (a && a.email) {
        var b;if (b = a.credential) {
          var c = (b = a.credential) && b.providerId;b = si[c] && firebase.auth[si[c]] ? b.secret && b.accessToken ? firebase.auth[si[c]].credential(b.accessToken, b.secret) : c == firebase.auth.GoogleAuthProvider.PROVIDER_ID ? firebase.auth[si[c]].credential(b.idToken, b.accessToken) : firebase.auth[si[c]].credential(b.accessToken) : null;
        }return new wi(a.email, b);
      }return null;
    }function yi(a, b) {
      this.wb = a;this.lb = b;
    }function zi(a) {
      a = sa(a);var b = Wh.search(a);
      return 0 < b.length ? new yi("1" == b[0].a ? "1-US-0" : b[0].b, sa(a.substr(b[0].a.length + 1))) : null;
    }function Ai(a) {
      var b = Uh(a.wb);if (!b) throw Error("Country ID " + a.wb + " not found.");return "+" + b.a + a.lb;
    }var Bi = /MSIE ([\d.]+).*Windows NT ([\d.]+)/,
        Ci = /Firefox\/([\d.]+)/,
        Di = /Opera[ \/]([\d.]+)(.*Version\/([\d.]+))?/,
        Ei = /Chrome\/([\d.]+)/,
        Fi = /((Windows NT ([\d.]+))|(Mac OS X ([\d_]+))).*Version\/([\d.]+).*Safari/,
        Gi = /Mac OS X;.*(?!(Version)).*Safari/,
        Hi = /Android ([\d.]+).*Safari/,
        Ii = /OS ([\d_]+) like Mac OS X.*Mobile.*Safari/,
        Ji = /Konqueror\/([\d.]+)/,
        Ki = /MSIE ([\d.]+).*Windows Phone OS ([\d.]+)/;function I(a, b) {
      this.Xa = a;a = a.split(b || ".");this.$a = [];for (b = 0; b < a.length; b++) {
        this.$a.push(parseInt(a[b], 10));
      }
    }I.prototype.compare = function (a) {
      a instanceof I || (a = new I(String(a)));for (var b = Math.max(this.$a.length, a.$a.length), c = 0; c < b; c++) {
        var d = this.$a[c],
            e = a.$a[c];if (void 0 !== d && void 0 !== e && d !== e) return d - e;if (void 0 === d) return -1;if (void 0 === e) return 1;
      }return 0;
    };function J(a, b) {
      return 0 <= a.compare(b);
    }function Li() {
      var a = window.navigator && window.navigator.userAgent;if (a) {
        var b;if (b = a.match(Di)) {
          var c = new I(b[3] || b[1]);return 0 <= a.indexOf("Opera Mini") ? !1 : 0 <= a.indexOf("Opera Mobi") ? 0 <= a.indexOf("Android") && J(c, "10.1") : J(c, "8.0");
        }if (b = a.match(Ci)) return J(new I(b[1]), "2.0");if (b = a.match(Ei)) return J(new I(b[1]), "6.0");if (b = a.match(Fi)) return c = new I(b[6]), a = b[3] && new I(b[3]), b = b[5] && new I(b[5], "_"), (!(!a || !J(a, "6.0")) || !(!b || !J(b, "10.5.6"))) && J(c, "3.0");if (b = a.match(Hi)) return J(new I(b[1]), "3.0");if (b = a.match(Ii)) return J(new I(b[1], "_"), "4.0");if (b = a.match(Ji)) return J(new I(b[1]), "4.7");if (b = a.match(Ki)) return c = new I(b[1]), a = new I(b[2]), J(c, "7.0") && J(a, "7.0");if (b = a.match(Bi)) return c = new I(b[1]), a = new I(b[2]), J(c, "7.0") && J(a, "6.0");if (a.match(Gi)) return !1;
      }return !0;
    }var Mi,
        Ni = new bh();Mi = ah(Ni) ? new dh(Ni, "firebaseui") : null;var Oi = new Xg(Mi),
        Pi,
        Qi = new ch();Pi = ah(Qi) ? new dh(Qi, "firebaseui") : null;var Ri = new Xg(Pi),
        Si = { name: "pendingEmailCredential", Sa: !1 },
        Ti = { name: "redirectUrl", Sa: !1 },
        Ui = { name: "rememberAccount", Sa: !1 },
        Vi = { name: "rememberedAccounts",
      Sa: !0 };function Wi(a, b) {
      return (a.Sa ? Oi : Ri).get(b ? a.name + ":" + b : a.name);
    }function Xi(a, b) {
      (a.Sa ? Oi : Ri).remove(b ? a.name + ":" + b : a.name);
    }function Yi(a, b, c) {
      (a.Sa ? Oi : Ri).set(c ? a.name + ":" + c : a.name, b);
    }function Zi(a, b) {
      Yi(Ti, a, b);
    }function $i(a, b) {
      Yi(Ui, a, b);
    }function aj(a) {
      a = Wi(Vi, a) || [];a = Ja(a, function (a) {
        return Yh(a);
      });return Ia(a, ca);
    }function bj(a, b) {
      var c = aj(b),
          d = La(c, function (b) {
        return b.J() == a.J() && (b.zc || null) == (a.zc || null);
      });-1 < d && Oa(c, d);c.unshift(a);Yi(Vi, Ja(c, function (a) {
        return a.qb();
      }), b);
    }function cj(a) {
      a = Wi(Si, a) || null;return xi(a);
    }function dj() {
      this.g = new ki();this.g.define("acUiConfig");this.g.define("callbacks");this.g.define("credentialHelper", ej);this.g.define("popupMode", !1);this.g.define("queryParameterForSignInSuccessUrl", "signInSuccessUrl");this.g.define("queryParameterForWidgetMode", "mode");this.g.define("signInFlow");this.g.define("signInOptions");this.g.define("signInSuccessUrl");this.g.define("siteName");this.g.define("tosUrl");this.g.define("widgetUrl");
    }var ej = "accountchooser.com",
        fj = { He: ej, NONE: "none" },
        gj = { Je: "popup", Le: "redirect" };function hj(a) {
      return a.g.get("acUiConfig") || null;
    }var ij = { Ie: "callback", Ke: "recoverEmail", Me: "resetPassword", Ne: "select", Oe: "verifyEmail" },
        jj = ["sitekey", "tabindex", "callback", "expired-callback"];function kj(a) {
      var b = a.g.get("widgetUrl") || window.location.href;return lj(a, b);
    }function lj(a, b) {
      a = mj(a);for (var c = b.search(Vc), d = 0, e, f = []; 0 <= (e = Uc(b, d, a, c));) {
        f.push(b.substring(d, e)), d = Math.min(b.indexOf("&", e) + 1 || c, c);
      }f.push(b.substr(d));b = [f.join("").replace(Xc, "$1"), "&", a];b.push("=", encodeURIComponent("select"));b[1] && (a = b[0], c = a.indexOf("#"), 0 <= c && (b.push(a.substr(c)), b[0] = a = a.substr(0, c)), c = a.indexOf("?"), 0 > c ? b[1] = "?" : c == a.length - 1 && (b[1] = void 0));return b.join("");
    }function nj(a) {
      a = a.g.get("signInOptions") || [];for (var b = [], c = 0; c < a.length; c++) {
        var d = a[c],
            d = ha(d) ? d : { provider: d };si[d.provider] && b.push(d);
      }return b;
    }function oj(a, b) {
      a = nj(a);for (var c = 0; c < a.length; c++) {
        if (a[c].provider === b) return a[c];
      }return null;
    }function pj(a) {
      return Ja(nj(a), function (a) {
        return a.provider;
      });
    }
    function qj(a) {
      var b = null;Ga(nj(a), function (a) {
        a.provider == firebase.auth.PhoneAuthProvider.PROVIDER_ID && ha(a.recaptchaParameters) && !da(a.recaptchaParameters) && (b = $a(a.recaptchaParameters));
      });if (b) {
        var c = [];Ga(jj, function (a) {
          "undefined" !== typeof b[a] && (c.push(a), delete b[a]);
        });c.length && Df && Df.log(yf, 'The following provided "recaptchaParameters" keys are not allowed: ' + c.join(", "), void 0);
      }return b;
    }function rj(a) {
      a = oj(a, firebase.auth.PhoneAuthProvider.PROVIDER_ID);var b = null;a && n(a.loginHint) && (b = zi(a.loginHint));return a && a.defaultNationalNumber || b && b.lb || null;
    }function sj(a) {
      var b = (a = oj(a, firebase.auth.PhoneAuthProvider.PROVIDER_ID)) && a.defaultCountry || null,
          c;if (c = b) {
        b = b.toUpperCase();c = [];for (var d = 0; d < Vh.length; d++) {
          Vh[d].c === b && c.push(Vh[d]);
        }
      }b = c;c = null;a && n(a.loginHint) && (c = zi(a.loginHint));return b && b[0] || c && Uh(c.wb) || null;
    }function mj(a) {
      return li(a.g, "queryParameterForWidgetMode");
    }function tj(a) {
      return a.g.get("tosUrl") || null;
    }function uj(a) {
      return (a = oj(a, firebase.auth.EmailAuthProvider.PROVIDER_ID)) && "undefined" !== typeof a.requireDisplayName ? !!a.requireDisplayName : !0;
    }function vj(a) {
      a = a.g.get("signInFlow");for (var b in gj) {
        if (gj[b] == a) return gj[b];
      }return "redirect";
    }function wj(a) {
      return xj(a).uiShown || null;
    }function xj(a) {
      return a.g.get("callbacks") || {};
    }function yj(a) {
      if ("http:" !== (window.location && window.location.protocol) && "https:" !== (window.location && window.location.protocol)) return "none";a = a.g.get("credentialHelper");for (var b in fj) {
        if (fj[b] == a) return fj[b];
      }return ej;
    }dj.prototype.Vb = function (a) {
      for (var b in a) {
        try {
          this.g.update(b, a[b]);
        } catch (c) {
          Df && Cf('Invalid config: "' + b + '"');
        }
      }kb && this.g.update("popupMode", !1);
    };dj.prototype.update = function (a, b) {
      this.g.update(a, b);
    };var zj,
        Aj,
        Bj,
        K = {};function L(a, b, c, d) {
      K[a].apply(null, Array.prototype.slice.call(arguments, 1));
    }function M(a, b) {
      var c;c = Fc(a, "firebaseui-textfield");b ? (wg(a, "firebaseui-input-invalid"), vg(a, "firebaseui-input"), c && wg(c, "firebaseui-textfield-invalid")) : (wg(a, "firebaseui-input"), vg(a, "firebaseui-input-invalid"), c && vg(c, "firebaseui-textfield-invalid"));
    }function Cj(a, b, c) {
      b = new Mg(b);Fe(a, ma(Ge, b));rg(a).ra(b, "input", c);
    }function Dj(a, b, c) {
      b = new xg(b);Fe(a, ma(Ge, b));rg(a).ra(b, "key", function (a) {
        13 == a.keyCode && (a.stopPropagation(), a.preventDefault(), c(a));
      });
    }function Ej(a, b, c) {
      b = new Lg(b);Fe(a, ma(Ge, b));rg(a).ra(b, "focusin", c);
    }function Fj(a, b, c) {
      b = new Lg(b);Fe(a, ma(Ge, b));rg(a).ra(b, "focusout", c);
    }function Gj(a, b, c) {
      b = new Gg(b);Fe(a, ma(Ge, b));rg(a).ra(b, "action", function (a) {
        a.stopPropagation();a.preventDefault();c(a);
      });
    }function Hj(a) {
      vg(a, "firebaseui-hidden");
    }function O(a, b) {
      b && Ec(a, b);wg(a, "firebaseui-hidden");
    }function Ij(a) {
      return !ug(a, "firebaseui-hidden") && "none" != a.style.display;
    }function Jj(a, b, c) {
      Kj.call(this);document.body.appendChild(a);a.showModal || window.dialogPolyfill.registerDialog(a);a.showModal();gi(a);b && Gj(this, a, function (b) {
        var c = a.getBoundingClientRect();(b.clientX < c.left || c.left + c.width < b.clientX || b.clientY < c.top || c.top + c.height < b.clientY) && Kj.call(this);
      });if (!c) {
        var d = this.L().parentElement || this.L().parentNode;if (d) {
          var e = this;this.ob = function () {
            if (a.open) {
              var b = a.getBoundingClientRect().height,
                  c = d.getBoundingClientRect().height,
                  k = d.getBoundingClientRect().top - document.body.getBoundingClientRect().top,
                  r = d.getBoundingClientRect().left - document.body.getBoundingClientRect().left,
                  N = a.getBoundingClientRect().width,
                  Fa = d.getBoundingClientRect().width;a.style.top = (k + (c - b) / 2).toString() + "px";b = r + (Fa - N) / 2;a.style.left = b.toString() + "px";a.style.right = (document.body.getBoundingClientRect().width - b - N).toString() + "px";
            } else window.removeEventListener("resize", e.ob);
          };this.ob();
          window.addEventListener("resize", this.ob, !1);
        }
      }
    }function Kj() {
      var a = Lj.call(this);a && (ii(a), a.open && a.close(), Dc(a), this.ob && window.removeEventListener("resize", this.ob));
    }function Lj() {
      return xc("firebaseui-id-dialog");
    }function Mj() {
      Dc(Nj.call(this));
    }function Nj() {
      return this.o("firebaseui-id-info-bar");
    }function Oj() {
      return this.o("firebaseui-id-dismiss-info-bar");
    }var Pj = { Xd: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg", Wd: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg",
      Od: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg", Ce: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg", ke: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg", me: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg" };function Qj(a, b, c) {
      Je.call(this, a, b);for (var d in c) {
        this[d] = c[d];
      }
    }t(Qj, Je);function P(a, b, c, d) {
      qg.call(this, c);this.pd = a;this.od = b;this.Ib = !1;this.gd = d || null;this.ea = this.pb = null;
    }t(P, qg);P.prototype.hc = function () {
      var a = rd(this.pd, this.od, Pj, this.Pa());gi(a);this.j = a;
    };P.prototype.m = function () {
      P.h.m.call(this);oi(Q(this), new Qj("pageEnter", Q(this), { pageId: this.gd }));
    };P.prototype.eb = function () {
      oi(Q(this), new Qj("pageExit", Q(this), { pageId: this.gd }));P.h.eb.call(this);
    };P.prototype.f = function () {
      window.clearTimeout(this.pb);this.od = this.pd = this.pb = null;this.Ib = !1;this.ea = null;ii(this.L());P.h.f.call(this);
    };function Rj(a) {
      a.Ib = !0;a.pb = window.setTimeout(function () {
        a.L() && null === a.ea && (a.ea = rd(uh, null, null, a.Pa()), a.L().appendChild(a.ea), gi(a.ea));
      }, 500);
    }function Sj(a, b, c, d, e) {
      function f() {
        if (a.Na) return null;a.Ib = !1;window.clearTimeout(a.pb);a.pb = null;a.ea && (ii(a.ea), Dc(a.ea), a.ea = null);
      }if (a.Ib) return null;Rj(a);return b.apply(null, c).then(d, e).then(f, f);
    }function Q(a) {
      return a.L().parentElement || a.L().parentNode;
    }function Tj(a, b, c) {
      Dj(a, b, function () {
        c.focus();
      });
    }function Uj(a, b, c) {
      Dj(a, b, function () {
        c();
      });
    }q(P.prototype, { F: function F(a) {
        Mj.call(this);var b = rd(qh, { message: a }, null, this.Pa());this.L().appendChild(b);Gj(this, Oj.call(this), function () {
          Dc(b);
        });
      }, Te: Mj, We: Nj, Ve: Oj, Wb: function Wb(a, b) {
        a = rd(sh, { Gb: a, message: b }, null, this.Pa());Jj.call(this, a);
      }, za: Kj, Ue: Lj });function Vj() {
      return this.o("firebaseui-id-submit");
    }function Wj() {
      return this.o("firebaseui-id-secondary-link");
    }function Xj(a, b) {
      var c = Vj.call(this);Gj(this, c, function (b) {
        a(b);
      });(c = Wj.call(this)) && b && Gj(this, c, function (a) {
        b(a);
      });
    }function Yj() {
      return this.o("firebaseui-id-password");
    }function Zj() {
      return this.o("firebaseui-id-password-error");
    }function ak() {
      var a = Yj.call(this),
          b = Zj.call(this);Cj(this, a, function () {
        Ij(b) && (M(a, !0), Hj(b));
      });
    }function bk() {
      var a = Yj.call(this),
          b;b = Zj.call(this);G(a) ? (M(a, !0), Hj(b), b = !0) : (M(a, !1), O(b, D("Enter your password").toString()), b = !1);return b ? G(a) : null;
    }function ck(a, b, c, d) {
      P.call(this, Ch, { email: a }, d, "passwordLinking");this.l = b;this.Ob = c;
    }t(ck, P);ck.prototype.m = function () {
      this.uc();this.A(this.l, this.Ob);Uj(this, this.aa(), this.l);this.aa().focus();ck.h.m.call(this);
    };ck.prototype.f = function () {
      this.l = null;ck.h.f.call(this);
    };ck.prototype.ma = function () {
      return G(this.o("firebaseui-id-email"));
    };q(ck.prototype, { aa: Yj, oc: Zj, uc: ak, gc: bk, D: Vj, ba: Wj, A: Xj });function dk() {
      return this.o("firebaseui-id-email");
    }function ek() {
      return this.o("firebaseui-id-email-error");
    }function fk(a) {
      var b = dk.call(this),
          c = ek.call(this);Cj(this, b, function () {
        Ij(c) && (M(b, !0), Hj(c));
      });a && Dj(this, b, function () {
        a();
      });
    }function gk() {
      return sa(G(dk.call(this)) || "");
    }function hk() {
      var a = dk.call(this),
          b;b = ek.call(this);var c = G(a) || "";c ? Pg.test(c) ? (M(a, !0), Hj(b), b = !0) : (M(a, !1), O(b, D("That email address isn't correct").toString()), b = !1) : (M(a, !1), O(b, D("Enter your email address to continue").toString()), b = !1);return b ? sa(G(a)) : null;
    }function ik(a, b, c, d) {
      P.call(this, xh, { email: c }, d, "passwordSignIn");this.l = a;this.Ob = b;
    }t(ik, P);ik.prototype.m = function () {
      this.Ea();this.uc();this.A(this.l, this.Ob);Tj(this, this.w(), this.aa());Uj(this, this.aa(), this.l);G(this.w()) ? this.aa().focus() : this.w().focus();ik.h.m.call(this);
    };ik.prototype.f = function () {
      this.Ob = this.l = null;ik.h.f.call(this);
    };
    q(ik.prototype, { w: dk, Qa: ek, Ea: fk, J: gk, ma: hk, aa: Yj, oc: Zj, uc: ak, gc: bk, D: Vj, ba: Wj, A: Xj });function R(a, b, c, d, e) {
      P.call(this, a, b, d, e || "notice");this.ha = c || null;
    }t(R, P);R.prototype.m = function () {
      this.ha && (this.A(this.ha), this.D().focus());R.h.m.call(this);
    };R.prototype.f = function () {
      this.ha = null;R.h.f.call(this);
    };q(R.prototype, { D: Vj, ba: Wj, A: Xj });function jk(a, b, c) {
      R.call(this, Ah, { email: a, N: !!b }, b, c, "passwordRecoveryEmailSent");
    }t(jk, R);function kk(a, b) {
      R.call(this, Jh, { N: !!a }, a, b, "emailVerificationSuccess");
    }
    t(kk, R);function lk(a, b) {
      R.call(this, Kh, { N: !!a }, a, b, "emailVerificationFailure");
    }t(lk, R);function mk(a, b) {
      R.call(this, Fh, { N: !!a }, a, b, "passwordResetSuccess");
    }t(mk, R);function nk(a, b) {
      R.call(this, Gh, { N: !!a }, a, b, "passwordResetFailure");
    }t(nk, R);function ok(a, b) {
      R.call(this, Ih, { N: !!a }, a, b, "emailChangeRevokeFailure");
    }t(ok, R);function pk(a, b) {
      R.call(this, Lh, { Ld: a }, void 0, b, "unrecoverableError");
    }t(pk, R);var qk = !1,
        rk = null;function sk(a, b) {
      qk = !!b;rk || ("undefined" == typeof accountchooser && Li() ? (b = gc(), rk = se(pe(Qg(b)), function () {})) : rk = pe());rk.then(a, a);
    }function tk(a, b) {
      a = S(a);(a = xj(a).accountChooserInvoked || null) ? a(b) : b();
    }function uk(a, b, c) {
      a = S(a);(a = xj(a).accountChooserResult || null) ? a(b, c) : c();
    }function vk(a, b, c, d, e) {
      d ? (L("callback", a, b), qk && c()) : tk(a, function () {
        di(function (d) {
          uk(a, d ? "empty" : "unavailable", function () {
            L("signIn", a, b);(d || qk) && c();
          });
        }, aj(T(a)), e);
      });
    }function wk(a, b, c, d) {
      function e(a) {
        a = U(a);V(b, c, void 0, a);d();
      }uk(b, "accountSelected", function () {
        $i(!1, T(b));W(b, X(b).fetchProvidersForEmail(a.J()).then(function (e) {
          xk(b, c, e, a.J(), a.Pc || null || void 0);d();
        }, e));
      });
    }function yk(a, b, c, d) {
      uk(b, a ? "addAccount" : "unavailable", function () {
        L("signIn", b, c);(a || qk) && d();
      });
    }function zk(a, b, c, d) {
      function e() {
        var b = a();b && (b = wj(S(b))) && b();
      }ai(function () {
        var f = a();f && vk(f, b, e, c, d);
      }, function (c) {
        var d = a();d && wk(c, d, b, e);
      }, function (c) {
        var d = a();d && yk(c, d, b, e);
      }, a() && hj(S(a())));
    }function Ak(a, b, c, d, e) {
      if (e) Bk(a, Ck(a).currentUser, c);else {
        if (!c) throw Error("No credential found!");var f = c;c.providerId && "password" == c.providerId && (f = null);var g = function g(c) {
          if (!c.name || "cancel" != c.name) {
            var d;a: {
              var e = c.message;try {
                var f = ((JSON.parse(e).error || {}).message || "").toLowerCase().match(/invalid.+(access|id)_token/);if (f && f.length) {
                  d = !0;break a;
                }
              } catch (g$4) {}d = !1;
            }d ? (c = Q(b), b.i(), V(a, c, void 0, D("Your sign-in session has expired. Please try again.").toString())) : (d = c && c.message || "", c.code && (d = U(c)), b.F(d));
          }
        },
            k = X(a).currentUser || d;if (!k) throw Error("User not logged in.");W(a, X(a).signOut().then(function () {
          var b = new Xh(k.email, k.displayName, k.photoURL, f && f.providerId);null != Wi(Ui, T(a)) && !Wi(Ui, T(a)) || bj(b, T(a));Xi(Ui, T(a));W(a, Ck(a).signInWithCredential(c).then(function (b) {
            Bk(a, b, f);
          }, g).then(function () {}, g));
        }, g));
      }
    }function Bk(a, b, c) {
      var d;d = S(a);d = xj(d).signInSuccess || null;var e = T(a),
          e = Wi(Ti, e) || null || void 0;Xi(Ti, T(a));var f = !1,
          g;a: {
        try {
          g = !!(window.opener && window.opener.location && window.opener.location.assign && window.opener.location.hostname === window.location.hostname && window.opener.location.protocol === window.location.protocol);break a;
        } catch (k) {}g = !1;
      }if (g) {
        if (!d || d(b, c, e)) f = !0, window.opener.location.assign(Dk(a, e));d || window.close();
      } else if (!d || d(b, c, e)) f = !0, window.location.assign(Dk(a, e));f || a.reset();
    }function Dk(a, b) {
      a = b || S(a).g.get("signInSuccessUrl");if (!a) throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");return a;
    }function U(a) {
      var b = "";switch (a.code) {case "auth/email-already-in-use":
          b += "The email address is already used by another account";
          break;case "auth/requires-recent-login":
          b += Sh();break;case "auth/too-many-requests":
          b += "You have entered an incorrect password too many times. Please try again in a few minutes.";break;case "auth/user-cancelled":
          b += "Please authorize the required permissions to sign in to the application";break;case "auth/user-not-found":
          b += "That email address doesn't match an existing account";break;case "auth/user-token-expired":
          b += Sh();break;case "auth/weak-password":
          b += "Strong passwords have at least 6 characters and a mix of letters and numbers";
          break;case "auth/wrong-password":
          b += "The email and password you entered don't match";break;case "auth/network-request-failed":
          b += "A network error has occurred";break;case "auth/invalid-phone-number":
          b += Qh();break;case "auth/invalid-verification-code":
          b += D("Wrong code. Try again.");break;case "auth/code-expired":
          b += "This code is no longer valid";}if (b = D(b).toString()) return b;try {
        return JSON.parse(a.message), Df && Cf("Internal error: " + a.message), D("Something went wrong. Please try again.").toString();
      } catch (c) {
        return a.message;
      }
    }
    function Ek(a, b, c) {
      var d = si[b] && firebase.auth[si[b]] ? new firebase.auth[si[b]]() : null;if (!d) throw Error("Invalid Firebase Auth provider!");var e;e = S(a);e = (e = oj(e, b)) && e.scopes;e = da(e) ? e : [];if (d && d.addScope) for (var f = 0; f < e.length; f++) {
        d.addScope(e[f]);
      }a = S(a);a = (a = oj(a, b)) && a.customParameters;ha(a) ? (a = $a(a), b === firebase.auth.GoogleAuthProvider.PROVIDER_ID && delete a.login_hint) : a = null;b == firebase.auth.GoogleAuthProvider.PROVIDER_ID && c && (a = a || {}, a.login_hint = c);a && d && d.setCustomParameters && d.setCustomParameters(a);
      return d;
    }function Fk(a, b, c, d) {
      function e() {
        W(a, Sj(b, p(X(a).signInWithRedirect, X(a)), [k], function () {
          if ("file:" === (window.location && window.location.protocol)) return W(a, X(a).getRedirectResult().then(function (c) {
            b.i();L("callback", a, g, pe(c));
          }, f));
        }, f));
      }function f(a) {
        a.name && "cancel" == a.name || (Df && Cf("signInWithRedirect: " + a.code), a = U(a), b.F(a));
      }var g = Q(b),
          k = Ek(a, c, d);"redirect" == vj(S(a)) ? e() : W(a, X(a).signInWithPopup(k).then(function (c) {
        b.i();L("callback", a, g, pe(c));
      }, function (c) {
        if (!c.name || "cancel" != c.name) switch (c.code) {case "auth/popup-blocked":
            e();break;case "auth/popup-closed-by-user":case "auth/cancelled-popup-request":
            break;case "auth/network-request-failed":case "auth/too-many-requests":case "auth/user-cancelled":
            b.F(U(c));break;default:
            b.i(), L("callback", a, g, qe(c));}
      }));
    }function Gk(a, b) {
      var c = b.ma(),
          d = b.gc();if (c) {
        if (d) {
          var e = firebase.auth.EmailAuthProvider.credential(c, d);W(a, Sj(b, p(X(a).signInWithEmailAndPassword, X(a)), [c, d], function () {
            Ak(a, b, e);
          }, function (a) {
            if (!a.name || "cancel" != a.name) switch (a.code) {case "auth/email-exists":
                M(b.w(), !1);O(b.Qa(), U(a));break;case "auth/too-many-requests":case "auth/wrong-password":
                M(b.aa(), !1);O(b.oc(), U(a));break;default:
                Df && Cf("verifyPassword: " + a.message), b.F(U(a));}
          }));
        } else b.aa().focus();
      } else b.w().focus();
    }function Hk(a) {
      a = pj(S(a));return 1 == a.length && a[0] == firebase.auth.EmailAuthProvider.PROVIDER_ID;
    }function Ik(a) {
      a = pj(S(a));return 1 == a.length && a[0] == firebase.auth.PhoneAuthProvider.PROVIDER_ID;
    }function V(a, b, c, d) {
      Hk(a) ? d ? L("signIn", a, b, c, d) : Jk(a, b, c) : a && Ik(a) && !d ? L("phoneSignInStart", a, b) : L("providerSignIn", a, b, d);
    }function Kk(a, b, c, d) {
      var e = Q(b);W(a, Sj(b, p(X(a).fetchProvidersForEmail, X(a)), [c], function (f) {
        $i(yj(S(a)) == ej, T(a));b.i();xk(a, e, f, c, void 0, d);
      }, function (a) {
        a = U(a);b.F(a);
      }));
    }function xk(a, b, c, d, e, f) {
      if (c.length) {
        if (Ma(c, firebase.auth.EmailAuthProvider.PROVIDER_ID)) L("passwordSignIn", a, b, d);else {
          e = new wi(d);var g = T(a);Yi(Si, e.qb(), g);L("federatedSignIn", a, b, d, c[0], f);
        }
      } else L("passwordSignUp", a, b, d, e);
    }function Jk(a, b, c) {
      yj(S(a)) == ej ? sk(function () {
        Zh ? tk(a, function () {
          di(function (d) {
            uk(a, d ? "empty" : "unavailable", function () {
              L("signIn", a, b, c);
            });
          }, aj(T(a)), kj(S(a)));
        }) : (Y(a), zk(Lk, b, !1, kj(S(a))));
      }, !1) : (qk = !1, tk(a, function () {
        uk(a, "unavailable", function () {
          L("signIn", a, b, c);
        });
      }));
    }function Mk(a) {
      var b = window.location.href;a = mj(S(a));var b = Wc(b, a) || "",
          c;for (c in ij) {
        if (ij[c].toLowerCase() == b.toLowerCase()) return ij[c];
      }return "callback";
    }function Nk(a) {
      var b = window.location.href;a = li(S(a).g, "queryParameterForSignInSuccessUrl");return Wc(b, a);
    }function Ok() {
      return Wc(window.location.href, "oobCode");
    }
    function Pk() {
      var a = Wc(window.location.href, "continueUrl");return a ? function () {
        window.location.assign(a);
      } : null;
    }function Qk(a, b) {
      var c = fi(b);switch (Mk(a)) {case "callback":
          (b = Nk(a)) && Zi(b, T(a));L("callback", a, c);break;case "resetPassword":
          L("passwordReset", a, c, Ok(), Pk());break;case "recoverEmail":
          L("emailChangeRevocation", a, c, Ok());break;case "verifyEmail":
          L("emailVerification", a, c, Ok(), Pk());break;case "select":
          if ((b = Nk(a)) && Zi(b, T(a)), Zh) {
            V(a, c);break;
          } else {
            sk(function () {
              Y(a);zk(Lk, c, !0);
            }, !0);return;
          }default:
          throw Error("Unhandled widget operation.");
      }(b = wj(S(a))) && b();
    }function Rk(a) {
      P.call(this, Bh, void 0, a, "callback");
    }t(Rk, P);function Sk(a, b, c) {
      if (c.user) {
        var d = cj(T(a)),
            e = d && d.J();if (e && !Tk(c.user, e)) Uk(a, b, c.user, c.credential);else {
          var f = d && d.ya;f ? W(a, c.user.linkWithCredential(f).then(function () {
            Vk(a, b, f);
          }, function (c) {
            Wk(a, b, c);
          })) : Vk(a, b, c.credential);
        }
      } else c = Q(b), b.i(), Xi(Si, T(a)), V(a, c);
    }function Vk(a, b, c) {
      Xi(Si, T(a));Ak(a, b, c);
    }function Wk(a, b, c) {
      var d = Q(b);Xi(Si, T(a));c = U(c);b.i();V(a, d, void 0, c);
    }function Xk(a, b, c, d) {
      var e = Q(b);W(a, X(a).fetchProvidersForEmail(c).then(function (f) {
        b.i();
        f.length ? "password" == f[0] ? L("passwordLinking", a, e, c) : L("federatedLinking", a, e, c, f[0], d) : (Xi(Si, T(a)), L("passwordRecovery", a, e, c, !1, Rh().toString()));
      }, function (c) {
        Wk(a, b, c);
      }));
    }function Uk(a, b, c, d) {
      var e = Q(b);W(a, X(a).signOut().then(function () {
        b.i();L("emailMismatch", a, e, c, d);
      }, function (a) {
        a.name && "cancel" == a.name || (a = U(a.code), b.F(a));
      }));
    }function Tk(a, b) {
      if (b == a.email) return !0;if (a.providerData) for (var c = 0; c < a.providerData.length; c++) {
        if (b == a.providerData[c].email) return !0;
      }return !1;
    }K.callback = function (a, b, c) {
      var d = new Rk();d.render(b);Z(a, d);b = c || a.getRedirectResult();W(a, b.then(function (b) {
        Sk(a, d, b);
      }, function (b) {
        if (b && "auth/account-exists-with-different-credential" == b.code && b.email && b.credential) {
          var c = xi(b),
              g = T(a);Yi(Si, c.qb(), g);Xk(a, d, b.email);
        } else b && "auth/user-cancelled" == b.code ? (c = cj(T(a)), g = U(b), c && c.ya ? Xk(a, d, c.J(), g) : c ? Kk(a, d, c.J(), g) : Wk(a, d, b)) : b && "auth/operation-not-supported-in-this-environment" == b.code && Hk(a) ? Sk(a, d, { user: null, credential: null }) : Wk(a, d, b);
      }));
    };function Yk(a, b, c, d) {
      P.call(this, Hh, { email: a, N: !!c }, d, "emailChangeRevoke");this.ed = b;this.ha = c || null;
    }t(Yk, P);Yk.prototype.m = function () {
      var a = this;Gj(this, this.o("firebaseui-id-reset-password-link"), function () {
        a.ed();
      });this.ha && (this.A(this.ha), this.D().focus());Yk.h.m.call(this);
    };Yk.prototype.f = function () {
      this.ed = this.ha = null;Yk.h.f.call(this);
    };q(Yk.prototype, { D: Vj, ba: Wj, A: Xj });function Zk() {
      return this.o("firebaseui-id-new-password");
    }function $k() {
      return this.o("firebaseui-id-password-toggle");
    }function al() {
      this.vc = !this.vc;var a = $k.call(this),
          b = Zk.call(this);this.vc ? (b.type = "text", vg(a, "firebaseui-input-toggle-off"), wg(a, "firebaseui-input-toggle-on")) : (b.type = "password", vg(a, "firebaseui-input-toggle-on"), wg(a, "firebaseui-input-toggle-off"));b.focus();
    }function bl() {
      return this.o("firebaseui-id-new-password-error");
    }function cl() {
      this.vc = !1;var a = Zk.call(this);a.type = "password";var b = bl.call(this);Cj(this, a, function () {
        Ij(b) && (M(a, !0), Hj(b));
      });var c = $k.call(this);vg(c, "firebaseui-input-toggle-on");wg(c, "firebaseui-input-toggle-off");
      Ej(this, a, function () {
        vg(c, "firebaseui-input-toggle-focus");wg(c, "firebaseui-input-toggle-blur");
      });Fj(this, a, function () {
        vg(c, "firebaseui-input-toggle-blur");wg(c, "firebaseui-input-toggle-focus");
      });Gj(this, c, p(al, this));
    }function dl() {
      var a = Zk.call(this),
          b;b = bl.call(this);G(a) ? (M(a, !0), Hj(b), b = !0) : (M(a, !1), O(b, D("Enter your password").toString()), b = !1);return b ? G(a) : null;
    }function el(a, b, c) {
      P.call(this, Eh, { email: a }, c, "passwordReset");this.l = b;
    }t(el, P);el.prototype.m = function () {
      this.tc();this.A(this.l);
      Uj(this, this.U(), this.l);this.U().focus();el.h.m.call(this);
    };el.prototype.f = function () {
      this.l = null;el.h.f.call(this);
    };q(el.prototype, { U: Zk, nc: bl, Rd: $k, tc: cl, fc: dl, D: Vj, ba: Wj, A: Xj });function fl(a, b, c, d, e) {
      var f = c.fc();f && W(a, Sj(c, p(X(a).confirmPasswordReset, X(a)), [d, f], function () {
        c.i();var d = new mk(e);d.render(b);Z(a, d);
      }, function (d) {
        gl(a, b, c, d);
      }));
    }function gl(a, b, c, d) {
      "auth/weak-password" == (d && d.code) ? (a = U(d), M(c.U(), !1), O(c.nc(), a), c.U().focus()) : (c && c.i(), c = new nk(), c.render(b), Z(a, c));
    }function hl(a, b, c) {
      var d = new Yk(c, function () {
        W(a, Sj(d, p(X(a).sendPasswordResetEmail, X(a)), [c], function () {
          d.i();d = new jk(c);d.render(b);Z(a, d);
        }, function () {
          d.F(D("Unable to send password reset code to specified email").toString());
        }));
      });d.render(b);Z(a, d);
    }K.passwordReset = function (a, b, c, d) {
      W(a, X(a).verifyPasswordResetCode(c).then(function (e) {
        var f = new el(e, function () {
          fl(a, b, f, c, d);
        });f.render(b);Z(a, f);
      }, function () {
        gl(a, b);
      }));
    };K.emailChangeRevocation = function (a, b, c) {
      var d = null;W(a, X(a).checkActionCode(c).then(function (b) {
        d = b.data.email;return X(a).applyActionCode(c);
      }).then(function () {
        hl(a, b, d);
      }, function () {
        var c = new ok();c.render(b);Z(a, c);
      }));
    };K.emailVerification = function (a, b, c, d) {
      W(a, X(a).applyActionCode(c).then(function () {
        var c = new kk(d);c.render(b);Z(a, c);
      }, function () {
        var c = new lk();c.render(b);Z(a, c);
      }));
    };function il(a, b, c, d, e) {
      P.call(this, Mh, { Fe: a, le: b }, e, "emailMismatch");this.ha = c;this.I = d;
    }t(il, P);il.prototype.m = function () {
      this.A(this.ha, this.I);this.D().focus();il.h.m.call(this);
    };il.prototype.f = function () {
      this.I = this.l = null;il.h.f.call(this);
    };q(il.prototype, { D: Vj, ba: Wj, A: Xj });K.emailMismatch = function (a, b, c, d) {
      var e = cj(T(a));if (e) {
        var f = new il(c.email, e.J(), function () {
          var b = f;Xi(Si, T(a));Ak(a, b, d, c);
        }, function () {
          var b = d.providerId,
              c = Q(f);f.i();e.ya ? L("federatedLinking", a, c, e.J(), b) : L("federatedSignIn", a, c, e.J(), b);
        });f.render(b);Z(a, f);
      } else V(a, b);
    };function jl(a, b, c, d) {
      P.call(this, Dh, { email: a, providerId: b }, d, "federatedLinking");this.l = c;
    }t(jl, P);jl.prototype.m = function () {
      this.A(this.l);this.D().focus();jl.h.m.call(this);
    };
    jl.prototype.f = function () {
      this.l = null;jl.h.f.call(this);
    };q(jl.prototype, { D: Vj, A: Xj });K.federatedLinking = function (a, b, c, d, e) {
      var f = cj(T(a));if (f && f.ya) {
        var g = new jl(c, d, function () {
          Fk(a, g, d, c);
        });g.render(b);Z(a, g);e && g.F(e);
      } else V(a, b);
    };K.federatedSignIn = function (a, b, c, d, e) {
      var f = new jl(c, d, function () {
        Fk(a, f, d, c);
      });f.render(b);Z(a, f);e && f.F(e);
    };function kl(a, b, c, d) {
      var e = b.gc();e ? W(a, Sj(b, p(X(a).signInWithEmailAndPassword, X(a)), [c, e], function (c) {
        return W(a, c.linkWithCredential(d).then(function () {
          Ak(a, b, d);
        }));
      }, function (a) {
        if (!a.name || "cancel" != a.name) switch (a.code) {case "auth/wrong-password":
            M(b.aa(), !1);O(b.oc(), U(a));break;case "auth/too-many-requests":
            b.F(U(a));break;default:
            Df && Cf("signInWithEmailAndPassword: " + a.message), b.F(U(a));}
      })) : b.aa().focus();
    }K.passwordLinking = function (a, b, c) {
      var d = cj(T(a));Xi(Si, T(a));var e = d && d.ya;if (e) {
        var f = new ck(c, function () {
          kl(a, f, c, e);
        }, function () {
          f.i();L("passwordRecovery", a, b, c);
        });f.render(b);Z(a, f);
      } else V(a, b);
    };function ll(a, b, c, d) {
      P.call(this, zh, { email: c,
        ac: !!b }, d, "passwordRecovery");this.l = a;this.I = b;
    }t(ll, P);ll.prototype.m = function () {
      this.Ea();this.A(this.l, this.I);G(this.w()) || this.w().focus();Uj(this, this.w(), this.l);ll.h.m.call(this);
    };ll.prototype.f = function () {
      this.I = this.l = null;ll.h.f.call(this);
    };q(ll.prototype, { w: dk, Qa: ek, Ea: fk, J: gk, ma: hk, D: Vj, ba: Wj, A: Xj });function ml(a, b) {
      var c = b.ma();if (c) {
        var d = Q(b);W(a, Sj(b, p(X(a).sendPasswordResetEmail, X(a)), [c], function () {
          b.i();var e = new jk(c, function () {
            e.i();V(a, d);
          });e.render(d);Z(a, e);
        }, function (a) {
          M(b.w(), !1);O(b.Qa(), U(a));
        }));
      } else b.w().focus();
    }K.passwordRecovery = function (a, b, c, d, e) {
      var f = new ll(function () {
        ml(a, f);
      }, d ? void 0 : function () {
        f.i();V(a, b);
      }, c);f.render(b);Z(a, f);e && f.F(e);
    };K.passwordSignIn = function (a, b, c) {
      var d = new ik(function () {
        Gk(a, d);
      }, function () {
        var c = d.J();d.i();L("passwordRecovery", a, b, c);
      }, c);d.render(b);Z(a, d);
    };function nl() {
      return this.o("firebaseui-id-name");
    }function ol() {
      return this.o("firebaseui-id-name-error");
    }function pl(a, b, c, d, e, f, g) {
      P.call(this, yh, { email: e, qe: b, name: f, rb: a,
        ac: !!d }, g, "passwordSignUp");this.l = c;this.I = d;this.Ac = b;
    }t(pl, P);pl.prototype.m = function () {
      this.Ea();this.Ac && this.be();this.tc();this.A(this.l, this.I);this.Ja();pl.h.m.call(this);
    };pl.prototype.f = function () {
      this.I = this.l = null;pl.h.f.call(this);
    };pl.prototype.Ja = function () {
      this.Ac ? (Tj(this, this.w(), this.gb()), Tj(this, this.gb(), this.U())) : Tj(this, this.w(), this.U());this.l && Uj(this, this.U(), this.l);G(this.w()) ? this.Ac && !G(this.gb()) ? this.gb().focus() : this.U().focus() : this.w().focus();
    };q(pl.prototype, { w: dk,
      Qa: ek, Ea: fk, J: gk, ma: hk, gb: nl, Xe: ol, be: function be() {
        var a = nl.call(this),
            b = ol.call(this);Cj(this, a, function () {
          Ij(b) && (M(a, !0), Hj(b));
        });
      }, Cd: function Cd() {
        var a = nl.call(this),
            b;b = ol.call(this);var c = G(a),
            c = !/^[\s\xa0]*$/.test(null == c ? "" : String(c));M(a, c);c ? (Hj(b), b = !0) : (O(b, D("Enter your account name").toString()), b = !1);return b ? sa(G(a)) : null;
      }, U: Zk, nc: bl, Rd: $k, tc: cl, fc: dl, D: Vj, ba: Wj, A: Xj });function ql(a, b) {
      var c = uj(S(a)),
          d = b.ma(),
          e = null;c && (e = b.Cd());var f = b.fc();if (d) {
        if (c && !e) b.gb().focus();else if (f) {
          var g = firebase.auth.EmailAuthProvider.credential(d, f);W(a, Sj(b, p(X(a).createUserWithEmailAndPassword, X(a)), [d, f], function (d) {
            return c ? W(a, d.updateProfile({ displayName: e }).then(function () {
              Ak(a, b, g);
            })) : Ak(a, b, g);
          }, function (c) {
            if (!c.name || "cancel" != c.name) {
              var e = U(c);switch (c.code) {case "auth/email-already-in-use":
                  return rl(a, b, d, c);case "auth/too-many-requests":
                  e = D("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();case "auth/operation-not-allowed":case "auth/weak-password":
                  M(b.U(), !1);O(b.nc(), e);break;default:
                  c = "setAccountInfo: " + mf(c), Df && Cf(c), b.F(e);}
            }
          }));
        } else b.U().focus();
      } else b.w().focus();
    }function rl(a, b, c, d) {
      function e() {
        var a = U(d);M(b.w(), !1);O(b.Qa(), a);b.w().focus();
      }var f = X(a).fetchProvidersForEmail(c).then(function (d) {
        d.length ? e() : (d = Q(b), b.i(), L("passwordRecovery", a, d, c, !1, Rh().toString()));
      }, function () {
        e();
      });W(a, f);return f;
    }K.passwordSignUp = function (a, b, c, d, e) {
      function f() {
        g.i();V(a, b);
      }var g = new pl(tj(S(a)), uj(S(a)), function () {
        ql(a, g);
      }, e ? void 0 : f, c, d);g.render(b);
      Z(a, g);
    };function sl() {
      return this.o("firebaseui-id-phone-confirmation-code");
    }function tl() {
      return this.o("firebaseui-id-phone-confirmation-code-error");
    }function ul() {
      return this.o("firebaseui-id-resend-countdown");
    }function vl(a, b, c, d, e, f, g, k) {
      P.call(this, Ph, { phoneNumber: e, rb: g }, k, "phoneSignInFinish");this.re = f;this.Ia = new jf(1E3);this.Bc = f;this.bd = a;this.l = b;this.I = c;this.dd = d;
    }t(vl, P);vl.prototype.m = function () {
      var a = this;this.sd(this.re);Ve(this.Ia, "tick", this.rc, !1, this);this.Ia.start();Gj(this, this.o("firebaseui-id-change-phone-number-link"), function () {
        a.bd();
      });Gj(this, this.Tc(), function () {
        a.dd();
      });this.ce(this.l);this.A(this.l, this.I);this.Ja();vl.h.m.call(this);
    };vl.prototype.f = function () {
      this.dd = this.I = this.l = this.bd = null;this.Ia.stop();cf(this.Ia, "tick", this.rc);this.Ia = null;vl.h.f.call(this);
    };vl.prototype.rc = function () {
      --this.Bc;0 < this.Bc ? this.sd(this.Bc) : (this.Ia.stop(), cf(this.Ia, "tick", this.rc), this.Zd(), this.ve());
    };vl.prototype.Ja = function () {
      this.pc().focus();
    };q(vl.prototype, { pc: sl,
      Sd: tl, ce: function ce(a) {
        var b = sl.call(this),
            c = tl.call(this);Cj(this, b, function () {
          Ij(c) && (M(b, !0), Hj(c));
        });a && Dj(this, b, function () {
          a();
        });
      }, Dd: function Dd() {
        var a = sa(G(sl.call(this)) || "");return (/^\d{6}$/.test(a) ? a : null
        );
      }, Vd: ul, sd: function sd(a) {
        var b = ul.call(this);Ec(b, D("Resend code in " + ((9 < a ? "0:" : "0:0") + a)).toString());
      }, Zd: function Zd() {
        var a = this.Vd();Hj(a);
      }, Tc: function Tc() {
        return this.o("firebaseui-id-resend-link");
      }, ve: function ve() {
        var a = this.Tc();O(a);
      }, D: Vj, ba: Wj, A: Xj });function wl(a, b, c, d) {
      function e(a) {
        b.pc().focus();
        M(b.pc(), !1);O(b.Sd(), a);
      }var f = b.Dd();f ? (b.Wb("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", D("Verifying...").toString()), W(a, Sj(b, p(d.confirm, d), [f], function () {
        b.za();b.Wb("firebaseui-icon-done", D("Verified!").toString());var c = setTimeout(function () {
          b.za();b.i();Ak(a, b, null, null, !0);
        }, 1E3);W(a, function () {
          b && b.za();clearTimeout(c);
        });
      }, function (d) {
        b.za();if (!d.name || "cancel" != d.name) {
          var f = U(d);switch (d.code) {case "auth/code-expired":
              d = Q(b);
              b.i();L("phoneSignInStart", a, d, c, f);break;case "auth/missing-verification-code":case "auth/invalid-verification-code":
              e(f);break;default:
              b.F(f);}
        }
      }))) : e(D("Wrong code. Try again.").toString());
    }K.phoneSignInFinish = function (a, b, c, d, e, f) {
      var g = new vl(function () {
        g.i();L("phoneSignInStart", a, b, c);
      }, function () {
        wl(a, g, c, e);
      }, function () {
        g.i();V(a, b);
      }, function () {
        g.i();L("phoneSignInStart", a, b, c);
      }, Ai(c), d, tj(S(a)));g.render(b);Z(a, g);f && g.F(f);
    };function xl(a, b, c) {
      a = rd(th, { items: a }, null, this.Pa());Jj.call(this, a, !0, !0);c && (c = yl(a, c)) && (c.focus(), Zf(c, a));Gj(this, a, function (a) {
        if (a = (a = Fc(a.target, "firebaseui-id-list-box-dialog-button")) && Eg(a, "listboxid")) Kj(), b(a);
      });
    }function yl(a, b) {
      a = (a || document).getElementsByTagName(String(Ab));for (var c = 0; c < a.length; c++) {
        if (Eg(a[c], "listboxid") === b) return a[c];
      }return null;
    }function zl() {
      return this.o("firebaseui-id-phone-number");
    }function Al() {
      return this.o("firebaseui-id-phone-number-error");
    }function Bl() {
      return Ja(Vh, function (a) {
        return { id: a.b, Gb: "firebaseui-flag " + Cl(a), label: a.name + " " + ('\u200E+' + a.a) };
      });
    }function Cl(a) {
      return "firebaseui-flag-" + a.c;
    }function Dl() {
      var a = this;xl.call(this, Bl(), function (b) {
        El.call(a, b, !0);a.Ba().focus();
      }, this.nb);
    }function El(a, b) {
      var c = Uh(a);if (c) {
        if (b) {
          var d = sa(G(zl.call(this)) || "");b = Wh.search(d);if (b.length && b[0].a != c.a) {
            d = "+" + c.a + d.substr(b[0].a.length + 1);b = zl.call(this);var e = b.type;if (m(e)) switch (e.toLowerCase()) {case "checkbox":case "radio":
                b.checked = d;break;case "select-one":
                b.selectedIndex = -1;if (n(d)) for (var f = 0; e = b.options[f]; f++) {
                  if (e.value == d) {
                    e.selected = !0;break;
                  }
                }break;case "select-multiple":
                n(d) && (d = [d]);for (f = 0; e = b.options[f]; f++) {
                  if (e.selected = !1, d) for (var g, k = 0; g = d[k]; k++) {
                    e.value == g && (e.selected = !0);
                  }
                }break;default:
                b.value = null != d ? d : "";}
          }
        }b = Uh(this.nb);this.nb = a;a = this.o("firebaseui-id-country-selector-flag");b && wg(a, Cl(b));vg(a, Cl(c));c = '\u200E+' + c.a;Ec(this.o("firebaseui-id-country-selector-code"), c);
      }
    }function Fl(a, b, c, d, e, f) {
      P.call(this, Oh, { Jd: c, lb: e || null }, f, "phoneSignInStart");this.Fd = d || null;this.Kd = c;this.l = a;this.I = b;
    }t(Fl, P);
    Fl.prototype.m = function () {
      this.de(this.Fd);this.A(this.l, this.I);this.Ja();Fl.h.m.call(this);
    };Fl.prototype.f = function () {
      this.I = this.l = null;Fl.h.f.call(this);
    };Fl.prototype.Ja = function () {
      this.Kd || Tj(this, this.Ba(), this.D());Uj(this, this.D(), this.l);this.Ba().focus();Fg(this.Ba(), (this.Ba().value || "").length);
    };q(Fl.prototype, { Ba: zl, Sc: Al, de: function de(a, b) {
        var c = this,
            d = zl.call(this),
            e = this.o("firebaseui-id-country-selector"),
            f = Al.call(this);El.call(this, a || "1-US-0");Gj(this, e, function () {
          Dl.call(c);
        });Cj(this, d, function () {
          Ij(f) && (M(d, !0), Hj(f));var a = sa(G(d) || ""),
              b = Uh(this.nb),
              a = Wh.search(a);a.length && a[0].a != b.a && (b = a[0], El.call(c, "1" == b.a ? "1-US-0" : b.b));
        });b && Dj(this, d, function () {
          b();
        });
      }, Td: function Td() {
        var a = sa(G(zl.call(this)) || ""),
            b = Wh.search(a),
            c = Uh(this.nb);b.length && b[0].a != c.a && El.call(this, b[0].b);b.length && (a = a.substr(b[0].a.length + 1));return a ? new yi(this.nb, a) : null;
      }, Ud: function Ud() {
        return this.o("firebaseui-recaptcha-container");
      }, qc: function qc() {
        return this.o("firebaseui-id-recaptcha-error");
      }, D: Vj,
      ba: Wj, A: Xj });function Gl(a, b, c, d) {
      var e = b.Td();e ? zj ? (b.Wb("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", D("Verifying...").toString()), W(a, Sj(b, p(Ck(a).signInWithPhoneNumber, Ck(a)), [Ai(e), c], function (c) {
        var d = Q(b);b.Wb("firebaseui-icon-done", D("Code sent!").toString());var k = setTimeout(function () {
          b.za();b.i();L("phoneSignInFinish", a, d, e, 15, c);
        }, 1E3);W(a, function () {
          b && b.za();clearTimeout(k);
        });
      }, function (a) {
        b.za();if (!a.name || "cancel" != a.name) {
          grecaptcha.reset(Bj);
          zj = null;var c = a && a.message || "";if (a.code) switch (a.code) {case "auth/too-many-requests":
              c = D("This phone number has been used too many times").toString();break;case "auth/invalid-phone-number":case "auth/missing-phone-number":
              b.Ba().focus();O(b.Sc(), Qh().toString());return;default:
              c = U(a);}b.F(c);
        }
      }))) : Aj ? O(b.qc(), D("Solve the reCAPTCHA").toString()) : !Aj && d && b.D().click() : (b.Ba().focus(), O(b.Sc(), Qh().toString()));
    }K.phoneSignInStart = function (a, b, c, d) {
      var e = qj(S(a)) || {};zj = null;Aj = !(e && "invisible" === e.size);
      var f = sj(S(a)),
          g = Ik(a) ? rj(S(a)) : null,
          k = new Fl(function (b) {
        Gl(a, k, r, !(!b || !b.keyCode));
      }, function () {
        r.clear();k.i();V(a, b);
      }, Aj, c && c.wb || f && f.b || null, c && c.lb || g);k.render(b);Z(a, k);d && k.F(d);e.callback = function (b) {
        k.qc() && Hj(k.qc());zj = b;Aj || Gl(a, k, r);
      };e["expired-callback"] = function () {
        zj = null;
      };var r = new firebase.auth.RecaptchaVerifier(Aj ? k.Ud() : k.D(), e, Ck(a).app);W(a, Sj(k, p(r.render, r), [], function (a) {
        Bj = a;
      }, function (c) {
        c.name && "cancel" == c.name || (c = U(c), k.i(), V(a, b, void 0, c));
      }));
    };function Hl(a, b, c) {
      P.call(this, Nh, { oe: b }, c, "providerSignIn");this.cd = a;
    }t(Hl, P);Hl.prototype.m = function () {
      this.ae(this.cd);Hl.h.m.call(this);
    };Hl.prototype.f = function () {
      this.cd = null;Hl.h.f.call(this);
    };q(Hl.prototype, { ae: function ae(a) {
        function b(b) {
          a(b);
        }for (var c = this.mc("firebaseui-id-idp-button"), d = 0; d < c.length; d++) {
          var e = c[d],
              f = Eg(e, "providerId");Gj(this, e, ma(b, f));
        }
      } });K.providerSignIn = function (a, b, c) {
      var d = new Hl(function (c) {
        c == firebase.auth.EmailAuthProvider.PROVIDER_ID ? (d.i(), Jk(a, b)) : c == firebase.auth.PhoneAuthProvider.PROVIDER_ID ? (d.i(), L("phoneSignInStart", a, b)) : Fk(a, d, c);
      }, pj(S(a)));d.render(b);Z(a, d);c && d.F(c);
    };function Il(a, b, c, d) {
      P.call(this, wh, { email: c, Hd: !!b }, d, "signIn");this.yc = a;this.I = b;
    }t(Il, P);Il.prototype.m = function () {
      this.Ea(this.yc);this.A(this.yc, this.I || void 0);this.Ja();Il.h.m.call(this);
    };Il.prototype.f = function () {
      this.I = this.yc = null;Il.h.f.call(this);
    };Il.prototype.Ja = function () {
      this.w().focus();Fg(this.w(), (this.w().value || "").length);
    };q(Il.prototype, { w: dk, Qa: ek, Ea: fk, J: gk, ma: hk, D: Vj, ba: Wj, A: Xj });K.signIn = function (a, b, c, d) {
      var e = Hk(a) && yj(S(a)) != ej,
          f = new Il(function () {
        var b = f,
            c = b.ma() || "";c && Kk(a, b, c);
      }, e ? null : function () {
        f.i();V(a, b, c);
      }, c);f.render(b);Z(a, f);d && f.F(d);
    };function Jl(a, b) {
      this.Mc = !1;var c = Kl(b);if (Ll[c]) throw Error('An AuthUI instance already exists for the key "' + c + '"');Ll[c] = this;this.wa = a;this.fd = null;Ml(this.wa);this.Va = firebase.initializeApp({ apiKey: a.app.options.apiKey, authDomain: a.app.options.authDomain }, a.app.name + "-firebaseui-temp").auth();Ml(this.Va);this.Va.setPersistence && this.Va.setPersistence(firebase.auth.Auth.Persistence.SESSION);this.zd = b;this.g = new dj();this.xb = this.Zb = this.Ab = this.Hc = null;this.sa = [];
    }function Ml(a) {
      a && a.INTERNAL && a.INTERNAL.logFramework && a.INTERNAL.logFramework("FirebaseUI-web");
    }var Ll = {};function Kl(a) {
      return a || "[DEFAULT]";
    }Jl.prototype.getRedirectResult = function () {
      Y(this);this.Ab || (this.Ab = pe(X(this).getRedirectResult()));return this.Ab;
    };function Z(a, b) {
      Y(a);a.xb = b;
    }var Nl = null;function Lk() {
      return Nl;
    }function X(a) {
      Y(a);return a.Va;
    }function Ck(a) {
      Y(a);
      return a.wa;
    }function T(a) {
      Y(a);return a.zd;
    }h = Jl.prototype;h.start = function (a, b) {
      Y(this);var c = this;"undefined" !== typeof this.wa.languageCode && (this.fd = this.wa.languageCode);var d = "en".replace(/_/g, "-");this.wa.languageCode = d;this.Va.languageCode = d;this.Vb(b);"complete" == l.document.readyState ? Ol(this, a) : bf(window, "load", function () {
        Ol(c, a);
      });
    };function Ol(a, b) {
      var c = fi(b);c.setAttribute("lang", "en".replace(/_/g, "-"));if (Nl) {
        var d = Nl;Y(d);cj(T(d)) && Df && Df.log(yf, "UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.", void 0);Nl.reset();
      }Nl = a;a.Zb = c;Pl(a, c);ah(new bh()) && ah(new ch()) ? Qk(a, b) : (b = fi(b), c = new pk(D("The browser you are using does not support Web Storage. Please try again in a different browser.").toString()), c.render(b), Z(a, c));
    }function W(a, b) {
      Y(a);if (b) {
        a.sa.push(b);var c = function c() {
          Qa(a.sa, function (a) {
            return a == b;
          });
        };"function" != typeof b && b.then(c, c);
      }
    }h.reset = function () {
      Y(this);this.Zb && this.Zb.removeAttribute("lang");"undefined" !== typeof this.wa.languageCode && (this.wa.languageCode = this.fd);this.Ab = pe({ user: null,
        credential: null });Nl == this && (Nl = null);this.Zb = null;for (var a = 0; a < this.sa.length; a++) {
        if ("function" == typeof this.sa[a]) this.sa[a]();else this.sa[a].cancel && this.sa[a].cancel();
      }this.sa = [];Xi(Si, T(this));this.xb && (this.xb.i(), this.xb = null);this.yb = null;
    };function Pl(a, b) {
      a.yb = null;a.Hc = new ri(b);a.Hc.register();Ve(a.Hc, "pageEnter", function (b) {
        b = b && b.Ye;if (a.yb != b) {
          var d;d = S(a);(d = xj(d).uiChanged || null) && d(a.yb, b);a.yb = b;
        }
      });
    }h.Vb = function (a) {
      Y(this);this.g.Vb(a);
    };function S(a) {
      Y(a);return a.g;
    }h.xe = function () {
      Y(this);
      var a,
          b = S(this),
          c = li(b.g, "widgetUrl");a = lj(b, c);if (S(this).g.get("popupMode")) {
        var b = (window.screen.availHeight - 600) / 2,
            c = (window.screen.availWidth - 500) / 2,
            d = a || "about:blank",
            b = { width: 500, height: 600, top: 0 < b ? b : 0, left: 0 < c ? c : 0, location: !0, resizable: !0, statusbar: !0, toolbar: !1 };b.target = b.target || d.target || "google_popup";b.width = b.width || 690;b.height = b.height || 500;var e;(c = b) || (c = {});b = window;a = d instanceof hc ? d : lc("undefined" != typeof d.href ? d.href : String(d));var d = c.target || d.target,
            f = [];for (e in c) {
          switch (e) {case "width":case "height":case "top":case "left":
              f.push(e + "=" + c[e]);break;case "target":case "noreferrer":
              break;default:
              f.push(e + "=" + (c[e] ? 1 : 0));}
        }e = f.join(",");(u("iPhone") && !u("iPod") && !u("iPad") || u("iPad") || u("iPod")) && b.navigator && b.navigator.standalone && d && "_self" != d ? (e = b.document.createElement(String(vb)), a = a instanceof hc ? a : lc(a), e.href = jc(a), e.setAttribute("target", d), c.noreferrer && e.setAttribute("rel", "noreferrer"), c = document.createEvent("MouseEvent"), c.initMouseEvent("click", !0, !0, b, 1), e.dispatchEvent(c), e = {}) : c.noreferrer ? (e = b.open("", d, e), b = jc(a), e && (ib && -1 != b.indexOf(";") && (b = "'" + b.replace(/'/g, "%27") + "'"), e.opener = null, dc("b/12014412, meta tag with sanitized URL"), b = '<META HTTP-EQUIV="refresh" content="0; url=' + ta(b) + '">', e.document.write(pc(new nc().ee(b))), e.document.close())) : e = b.open(jc(a), d, e);e && e.focus();
      } else window.location.assign(a);
    };function Y(a) {
      if (a.Mc) throw Error("AuthUI instance is deleted!");
    }h.delete = function () {
      var a = this;Y(this);return this.Va.app.delete().then(function () {
        var b = Kl(T(a));delete Ll[b];a.reset();a.Mc = !0;
      });
    };
    oa("firebaseui.auth.AuthUI", Jl);oa("firebaseui.auth.AuthUI.getInstance", function (a) {
      a = Kl(a);return Ll[a] ? Ll[a] : null;
    });oa("firebaseui.auth.AuthUI.prototype.start", Jl.prototype.start);oa("firebaseui.auth.AuthUI.prototype.setConfig", Jl.prototype.Vb);oa("firebaseui.auth.AuthUI.prototype.signIn", Jl.prototype.xe);oa("firebaseui.auth.AuthUI.prototype.reset", Jl.prototype.reset);oa("firebaseui.auth.AuthUI.prototype.delete", Jl.prototype.delete);oa("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM", ej);
    oa("firebaseui.auth.CredentialHelper.NONE", "none");
  })();
})();module.exports = firebaseui;

/***/ }),

/***/ "RFlV":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__("RJVP");

/***/ }),

/***/ "RJVP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function () {
  var firebase = __webpack_require__("qQjo").default;
  var h,
      aa = aa || {},
      k = this;function m(a) {
    return "string" == typeof a;
  }function ba(a) {
    return "boolean" == typeof a;
  }function ca() {}
  function da(a) {
    var b = typeof a;if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
  }function ea(a) {
    return null === a;
  }function fa(a) {
    return "array" == da(a);
  }function ha(a) {
    var b = da(a);return "array" == b || "object" == b && "number" == typeof a.length;
  }function p(a) {
    return "function" == da(a);
  }function q(a) {
    var b = typeof a;return "object" == b && null != a || "function" == b;
  }var ia = "closure_uid_" + (1E9 * Math.random() >>> 0),
      ja = 0;function ka(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }
  function la(a, b, c) {
    if (!a) throw Error();if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);return function () {
        var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
      };
    }return function () {
      return a.apply(b, arguments);
    };
  }function r(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? r = ka : r = la;return r.apply(null, arguments);
  }
  function ma(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);return function () {
      var b = c.slice();b.push.apply(b, arguments);return a.apply(this, b);
    };
  }var na = Date.now || function () {
    return +new Date();
  };function t(a, b) {
    function c() {}c.prototype = b.prototype;a.ib = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.Nc = function (a, c, f) {
      for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
        d[e - 2] = arguments[e];
      }return b.prototype[c].apply(a, d);
    };
  };function u(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, u);else {
      var b = Error().stack;b && (this.stack = b);
    }a && (this.message = String(a));
  }t(u, Error);u.prototype.name = "CustomError";function oa(a, b) {
    for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
      d += c.shift() + e.shift();
    }return d + c.join("%s");
  }var pa = String.prototype.trim ? function (a) {
    return a.trim();
  } : function (a) {
    return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
  };
  function qa(a) {
    if (!ra.test(a)) return a;-1 != a.indexOf("&") && (a = a.replace(sa, "&amp;"));-1 != a.indexOf("<") && (a = a.replace(ta, "&lt;"));-1 != a.indexOf(">") && (a = a.replace(ua, "&gt;"));-1 != a.indexOf('"') && (a = a.replace(va, "&quot;"));-1 != a.indexOf("'") && (a = a.replace(wa, "&#39;"));-1 != a.indexOf("\x00") && (a = a.replace(xa, "&#0;"));return a;
  }var sa = /&/g,
      ta = /</g,
      ua = />/g,
      va = /"/g,
      wa = /'/g,
      xa = /\x00/g,
      ra = /[\x00&<>"']/;function v(a, b) {
    return -1 != a.indexOf(b);
  }function ya(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  };function za(a, b) {
    b.unshift(a);u.call(this, oa.apply(null, b));b.shift();
  }t(za, u);za.prototype.name = "AssertionError";function Aa(a, b) {
    throw new za("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
  };var Ba = Array.prototype.indexOf ? function (a, b, c) {
    return Array.prototype.indexOf.call(a, b, c);
  } : function (a, b, c) {
    c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;if (m(a)) return m(b) && 1 == b.length ? a.indexOf(b, c) : -1;for (; c < a.length; c++) {
      if (c in a && a[c] === b) return c;
    }return -1;
  },
      w = Array.prototype.forEach ? function (a, b, c) {
    Array.prototype.forEach.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = m(a) ? a.split("") : a, f = 0; f < d; f++) {
      f in e && b.call(c, e[f], f, a);
    }
  };
  function Ca(a, b) {
    var c = a.length,
        d = m(a) ? a.split("") : a;for (--c; 0 <= c; --c) {
      c in d && b.call(void 0, d[c], c, a);
    }
  }var Da = Array.prototype.map ? function (a, b, c) {
    return Array.prototype.map.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = Array(d), f = m(a) ? a.split("") : a, g = 0; g < d; g++) {
      g in f && (e[g] = b.call(c, f[g], g, a));
    }return e;
  },
      Ea = Array.prototype.some ? function (a, b, c) {
    return Array.prototype.some.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = m(a) ? a.split("") : a, f = 0; f < d; f++) {
      if (f in e && b.call(c, e[f], f, a)) return !0;
    }return !1;
  };
  function Fa(a) {
    a: {
      var b = Ga;for (var c = a.length, d = m(a) ? a.split("") : a, e = 0; e < c; e++) {
        if (e in d && b.call(void 0, d[e], e, a)) {
          b = e;break a;
        }
      }b = -1;
    }return 0 > b ? null : m(a) ? a.charAt(b) : a[b];
  }function Ha(a, b) {
    return 0 <= Ba(a, b);
  }function Ia(a, b) {
    b = Ba(a, b);var c;(c = 0 <= b) && Array.prototype.splice.call(a, b, 1);return c;
  }function Ja(a, b) {
    var c = 0;Ca(a, function (d, e) {
      b.call(void 0, d, e, a) && 1 == Array.prototype.splice.call(a, e, 1).length && c++;
    });
  }function Ka(a) {
    return Array.prototype.concat.apply([], arguments);
  }
  function La(a) {
    var b = a.length;if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++) {
        c[d] = a[d];
      }return c;
    }return [];
  };var Ma;a: {
    var Na = k.navigator;if (Na) {
      var Oa = Na.userAgent;if (Oa) {
        Ma = Oa;break a;
      }
    }Ma = "";
  }function x(a) {
    return v(Ma, a);
  };function Pa(a, b) {
    for (var c in a) {
      b.call(void 0, a[c], c, a);
    }
  }function Qa(a) {
    var b = [],
        c = 0,
        d;for (d in a) {
      b[c++] = a[d];
    }return b;
  }function Ra(a) {
    var b = [],
        c = 0,
        d;for (d in a) {
      b[c++] = d;
    }return b;
  }function Sa(a) {
    for (var b in a) {
      return !1;
    }return !0;
  }function Ta(a, b) {
    for (var c in a) {
      if (!(c in b) || a[c] !== b[c]) return !1;
    }for (c in b) {
      if (!(c in a)) return !1;
    }return !0;
  }function Ua(a) {
    var b = {},
        c;for (c in a) {
      b[c] = a[c];
    }return b;
  }var Va = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function Wa(a, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];for (c in d) {
        a[c] = d[c];
      }for (var f = 0; f < Va.length; f++) {
        c = Va[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
      }
    }
  };function Xa(a) {
    Xa[" "](a);return a;
  }Xa[" "] = ca;function Ya(a, b) {
    var c = Za;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
  };var $a = x("Opera"),
      y = x("Trident") || x("MSIE"),
      ab = x("Edge"),
      bb = ab || y,
      cb = x("Gecko") && !(v(Ma.toLowerCase(), "webkit") && !x("Edge")) && !(x("Trident") || x("MSIE")) && !x("Edge"),
      db = v(Ma.toLowerCase(), "webkit") && !x("Edge");function eb() {
    var a = k.document;return a ? a.documentMode : void 0;
  }var fb;
  a: {
    var gb = "",
        hb = function () {
      var a = Ma;if (cb) return (/rv\:([^\);]+)(\)|;)/.exec(a)
      );if (ab) return (/Edge\/([\d\.]+)/.exec(a)
      );if (y) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
      );if (db) return (/WebKit\/(\S+)/.exec(a)
      );if ($a) return (/(?:Version)[ \/]?(\S+)/.exec(a)
      );
    }();hb && (gb = hb ? hb[1] : "");if (y) {
      var ib = eb();if (null != ib && ib > parseFloat(gb)) {
        fb = String(ib);break a;
      }
    }fb = gb;
  }var Za = {};
  function jb(a) {
    return Ya(a, function () {
      for (var b = 0, c = pa(String(fb)).split("."), d = pa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
        var g = c[f] || "",
            l = d[f] || "";do {
          g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];l = /(\d*)(\D*)(.*)/.exec(l) || ["", "", "", ""];if (0 == g[0].length && 0 == l[0].length) break;b = ya(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == l[1].length ? 0 : parseInt(l[1], 10)) || ya(0 == g[2].length, 0 == l[2].length) || ya(g[2], l[2]);g = g[3];l = l[3];
        } while (0 == b);
      }return 0 <= b;
    });
  }var kb;var lb = k.document;
  kb = lb && y ? eb() || ("CSS1Compat" == lb.compatMode ? parseInt(fb, 10) : 5) : void 0;function mb(a) {
    a.prototype.then = a.prototype.then;a.prototype.$goog_Thenable = !0;
  }function nb(a) {
    if (!a) return !1;try {
      return !!a.$goog_Thenable;
    } catch (b) {
      return !1;
    }
  };function ob(a, b, c) {
    this.f = c;this.c = a;this.g = b;this.b = 0;this.a = null;
  }ob.prototype.get = function () {
    if (0 < this.b) {
      this.b--;var a = this.a;this.a = a.next;a.next = null;
    } else a = this.c();return a;
  };function pb(a, b) {
    a.g(b);a.b < a.f && (a.b++, b.next = a.a, a.a = b);
  };var rb = new ob(function () {
    return new qb();
  }, function (a) {
    a.reset();
  }, 100);function sb() {
    var a = tb,
        b = null;a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);return b;
  }function qb() {
    this.next = this.b = this.a = null;
  }qb.prototype.set = function (a, b) {
    this.a = a;this.b = b;this.next = null;
  };qb.prototype.reset = function () {
    this.next = this.b = this.a = null;
  };function ub(a) {
    k.setTimeout(function () {
      throw a;
    }, 0);
  }var wb;
  function xb() {
    var a = k.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !x("Presto") && (a = function a() {
      var a = document.createElement("IFRAME");a.style.display = "none";a.src = "";document.documentElement.appendChild(a);var b = a.contentWindow;a = b.document;a.open();a.write("");a.close();var c = "callImmediate" + Math.random(),
          d = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host;a = r(function (a) {
        if (("*" == d || a.origin == d) && a.data == c) this.port1.onmessage();
      }, this);b.addEventListener("message", a, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
          b.postMessage(c, d);
        } };
    });if ("undefined" !== typeof a && !x("Trident") && !x("MSIE")) {
      var b = new a(),
          c = {},
          d = c;b.port1.onmessage = function () {
        if (void 0 !== c.next) {
          c = c.next;var a = c.pb;c.pb = null;a();
        }
      };return function (a) {
        d.next = { pb: a };d = d.next;b.port2.postMessage(0);
      };
    }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (a) {
      var b = document.createElement("SCRIPT");
      b.onreadystatechange = function () {
        b.onreadystatechange = null;b.parentNode.removeChild(b);b = null;a();a = null;
      };document.documentElement.appendChild(b);
    } : function (a) {
      k.setTimeout(a, 0);
    };
  };function yb(a, b) {
    zb || Ab();Bb || (zb(), Bb = !0);var c = tb,
        d = rb.get();d.set(a, b);c.b ? c.b.next = d : c.a = d;c.b = d;
  }var zb;function Ab() {
    if (-1 != String(k.Promise).indexOf("[native code]")) {
      var a = k.Promise.resolve(void 0);zb = function zb() {
        a.then(Cb);
      };
    } else zb = function zb() {
      var a = Cb;!p(k.setImmediate) || k.Window && k.Window.prototype && !x("Edge") && k.Window.prototype.setImmediate == k.setImmediate ? (wb || (wb = xb()), wb(a)) : k.setImmediate(a);
    };
  }var Bb = !1,
      tb = new function () {
    this.b = this.a = null;
  }();
  function Cb() {
    for (var a; a = sb();) {
      try {
        a.a.call(a.b);
      } catch (b) {
        ub(b);
      }pb(rb, a);
    }Bb = !1;
  };function z(a, b) {
    this.a = Db;this.i = void 0;this.f = this.b = this.c = null;this.g = this.h = !1;if (a != ca) try {
      var c = this;a.call(b, function (a) {
        Eb(c, Fb, a);
      }, function (a) {
        if (!(a instanceof Gb)) try {
          if (a instanceof Error) throw a;throw Error("Promise rejected.");
        } catch (e) {}Eb(c, Hb, a);
      });
    } catch (d) {
      Eb(this, Hb, d);
    }
  }var Db = 0,
      Fb = 2,
      Hb = 3;function Ib() {
    this.next = this.f = this.b = this.g = this.a = null;this.c = !1;
  }Ib.prototype.reset = function () {
    this.f = this.b = this.g = this.a = null;this.c = !1;
  };
  var Jb = new ob(function () {
    return new Ib();
  }, function (a) {
    a.reset();
  }, 100);function Kb(a, b, c) {
    var d = Jb.get();d.g = a;d.b = b;d.f = c;return d;
  }function A(a) {
    if (a instanceof z) return a;var b = new z(ca);Eb(b, Fb, a);return b;
  }function B(a) {
    return new z(function (b, c) {
      c(a);
    });
  }function Lb(a, b, c) {
    Mb(a, b, c, null) || yb(ma(b, a));
  }function Nb(a) {
    return new z(function (b, c) {
      var d = a.length,
          e = [];if (d) for (var f = function f(a, c) {
        d--;e[a] = c;0 == d && b(e);
      }, g = function g(a) {
        c(a);
      }, l = 0, n; l < a.length; l++) {
        n = a[l], Lb(n, ma(f, l), g);
      } else b(e);
    });
  }
  function Ob(a) {
    return new z(function (b) {
      var c = a.length,
          d = [];if (c) for (var e = function e(a, _e, f) {
        c--;d[a] = _e ? { Qb: !0, value: f } : { Qb: !1, reason: f };0 == c && b(d);
      }, f = 0, g; f < a.length; f++) {
        g = a[f], Lb(g, ma(e, f, !0), ma(e, f, !1));
      } else b(d);
    });
  }z.prototype.then = function (a, b, c) {
    return Pb(this, p(a) ? a : null, p(b) ? b : null, c);
  };mb(z);function Qb(a, b) {
    b = Kb(b, b, void 0);b.c = !0;Rb(a, b);return a;
  }h = z.prototype;h.s = function (a, b) {
    return Pb(this, null, a, b);
  };h.cancel = function (a) {
    this.a == Db && yb(function () {
      var b = new Gb(a);Sb(this, b);
    }, this);
  };
  function Sb(a, b) {
    if (a.a == Db) if (a.c) {
      var c = a.c;if (c.b) {
        for (var d = 0, e = null, f = null, g = c.b; g && (g.c || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next) {
          e || (f = g);
        }e && (c.a == Db && 1 == d ? Sb(c, b) : (f ? (d = f, d.next == c.f && (c.f = d), d.next = d.next.next) : Tb(c), Ub(c, e, Hb, b)));
      }a.c = null;
    } else Eb(a, Hb, b);
  }function Rb(a, b) {
    a.b || a.a != Fb && a.a != Hb || Vb(a);a.f ? a.f.next = b : a.b = b;a.f = b;
  }
  function Pb(a, b, c, d) {
    var e = Kb(null, null, null);e.a = new z(function (a, g) {
      e.g = b ? function (c) {
        try {
          var e = b.call(d, c);a(e);
        } catch (D) {
          g(D);
        }
      } : a;e.b = c ? function (b) {
        try {
          var e = c.call(d, b);void 0 === e && b instanceof Gb ? g(b) : a(e);
        } catch (D) {
          g(D);
        }
      } : g;
    });e.a.c = a;Rb(a, e);return e.a;
  }h.wc = function (a) {
    this.a = Db;Eb(this, Fb, a);
  };h.xc = function (a) {
    this.a = Db;Eb(this, Hb, a);
  };
  function Eb(a, b, c) {
    a.a == Db && (a === c && (b = Hb, c = new TypeError("Promise cannot resolve to itself")), a.a = 1, Mb(c, a.wc, a.xc, a) || (a.i = c, a.a = b, a.c = null, Vb(a), b != Hb || c instanceof Gb || Wb(a, c)));
  }function Mb(a, b, c, d) {
    if (a instanceof z) return Rb(a, Kb(b || ca, c || null, d)), !0;if (nb(a)) return a.then(b, c, d), !0;if (q(a)) try {
      var e = a.then;if (p(e)) return Xb(a, e, b, c, d), !0;
    } catch (f) {
      return c.call(d, f), !0;
    }return !1;
  }
  function Xb(a, b, c, d, e) {
    function f(a) {
      l || (l = !0, d.call(e, a));
    }function g(a) {
      l || (l = !0, c.call(e, a));
    }var l = !1;try {
      b.call(a, g, f);
    } catch (n) {
      f(n);
    }
  }function Vb(a) {
    a.h || (a.h = !0, yb(a.Mb, a));
  }function Tb(a) {
    var b = null;a.b && (b = a.b, a.b = b.next, b.next = null);a.b || (a.f = null);return b;
  }h.Mb = function () {
    for (var a; a = Tb(this);) {
      Ub(this, a, this.a, this.i);
    }this.h = !1;
  };
  function Ub(a, b, c, d) {
    if (c == Hb && b.b && !b.c) for (; a && a.g; a = a.c) {
      a.g = !1;
    }if (b.a) b.a.c = null, Yb(b, c, d);else try {
      b.c ? b.g.call(b.f) : Yb(b, c, d);
    } catch (e) {
      Zb.call(null, e);
    }pb(Jb, b);
  }function Yb(a, b, c) {
    b == Fb ? a.g.call(a.f, c) : a.b && a.b.call(a.f, c);
  }function Wb(a, b) {
    a.g = !0;yb(function () {
      a.g && Zb.call(null, b);
    });
  }var Zb = ub;function Gb(a) {
    u.call(this, a);
  }t(Gb, u);Gb.prototype.name = "cancel";var $b = !y || 9 <= Number(kb);function ac() {
    this.a = "";this.b = bc;
  }ac.prototype.la = !0;ac.prototype.ja = function () {
    return this.a;
  };ac.prototype.toString = function () {
    return "Const{" + this.a + "}";
  };function cc(a) {
    if (a instanceof ac && a.constructor === ac && a.b === bc) return a.a;Aa("expected object of type Const, got '" + a + "'");return "type_error:Const";
  }var bc = {};function dc(a) {
    var b = new ac();b.a = a;return b;
  }dc("");function ec() {
    this.a = "";this.b = fc;
  }ec.prototype.la = !0;ec.prototype.ja = function () {
    return this.a;
  };ec.prototype.toString = function () {
    return "TrustedResourceUrl{" + this.a + "}";
  };function gc(a) {
    if (a instanceof ec && a.constructor === ec && a.b === fc) return a.a;Aa("expected object of type TrustedResourceUrl, got '" + a + "' of type " + da(a));return "type_error:TrustedResourceUrl";
  }function hc(a, b) {
    a = ic(a, b);b = new ec();b.a = a;return b;
  }
  function ic(a, b) {
    var c = cc(a);if (!jc.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);return c.replace(kc, function (a, e) {
      if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));a = b[e];return a instanceof ac ? cc(a) : encodeURIComponent(String(a));
    });
  }var kc = /%{(\w+)}/g,
      jc = /^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i,
      fc = {};function lc() {
    this.a = "";this.b = mc;
  }lc.prototype.la = !0;lc.prototype.ja = function () {
    return this.a;
  };lc.prototype.toString = function () {
    return "SafeUrl{" + this.a + "}";
  };function nc(a) {
    if (a instanceof lc && a.constructor === lc && a.b === mc) return a.a;Aa("expected object of type SafeUrl, got '" + a + "' of type " + da(a));return "type_error:SafeUrl";
  }var oc = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
  function pc(a) {
    if (a instanceof lc) return a;a = a.la ? a.ja() : String(a);oc.test(a) || (a = "about:invalid#zClosurez");return qc(a);
  }var mc = {};function qc(a) {
    var b = new lc();b.a = a;return b;
  }qc("about:blank");function rc() {
    this.a = "";this.b = sc;
  }rc.prototype.la = !0;rc.prototype.ja = function () {
    return this.a;
  };rc.prototype.toString = function () {
    return "SafeHtml{" + this.a + "}";
  };function uc(a) {
    if (a instanceof rc && a.constructor === rc && a.b === sc) return a.a;Aa("expected object of type SafeHtml, got '" + a + "' of type " + da(a));return "type_error:SafeHtml";
  }var sc = {};function vc(a) {
    var b = new rc();b.a = a;return b;
  }vc("<!DOCTYPE html>");vc("");vc("<br>");function wc(a) {
    var b = document;return m(a) ? b.getElementById(a) : a;
  }function xc(a, b) {
    Pa(b, function (b, d) {
      b && b.la && (b = b.ja());"style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : yc.hasOwnProperty(d) ? a.setAttribute(yc[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b;
    });
  }
  var yc = { cellpadding: "cellPadding", cellspacing: "cellSpacing", colspan: "colSpan", frameborder: "frameBorder", height: "height", maxlength: "maxLength", nonce: "nonce", role: "role", rowspan: "rowSpan", type: "type", usemap: "useMap", valign: "vAlign", width: "width" };
  function zc(a, b, c) {
    var d = arguments,
        e = document,
        f = String(d[0]),
        g = d[1];if (!$b && g && (g.name || g.type)) {
      f = ["<", f];g.name && f.push(' name="', qa(g.name), '"');if (g.type) {
        f.push(' type="', qa(g.type), '"');var l = {};Wa(l, g);delete l.type;g = l;
      }f.push(">");f = f.join("");
    }f = e.createElement(f);g && (m(g) ? f.className = g : fa(g) ? f.className = g.join(" ") : xc(f, g));2 < d.length && Ac(e, f, d);return f;
  }
  function Ac(a, b, c) {
    function d(c) {
      c && b.appendChild(m(c) ? a.createTextNode(c) : c);
    }for (var e = 2; e < c.length; e++) {
      var f = c[e];!ha(f) || q(f) && 0 < f.nodeType ? d(f) : w(Bc(f) ? La(f) : f, d);
    }
  }function Bc(a) {
    if (a && "number" == typeof a.length) {
      if (q(a)) return "function" == typeof a.item || "string" == typeof a.item;if (p(a)) return "function" == typeof a.item;
    }return !1;
  };function Cc(a) {
    var b = [];Dc(new Ec(), a, b);return b.join("");
  }function Ec() {}
  function Dc(a, b, c) {
    if (null == b) c.push("null");else {
      if ("object" == typeof b) {
        if (fa(b)) {
          var d = b;b = d.length;c.push("[");for (var e = "", f = 0; f < b; f++) {
            c.push(e), Dc(a, d[f], c), e = ",";
          }c.push("]");return;
        }if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
          c.push("{");e = "";for (d in b) {
            Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), Fc(d, c), c.push(":"), Dc(a, f, c), e = ","));
          }c.push("}");return;
        }
      }switch (typeof b) {case "string":
          Fc(b, c);break;case "number":
          c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");break;case "boolean":
          c.push(String(b));break;case "function":
          c.push("null");break;default:
          throw Error("Unknown type: " + typeof b);}
    }
  }var Gc = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
      Hc = /\uffff/.test("\uFFFF") ? /[\\\"\x00-\x1f\x7f-\uffff]/g : /[\\\"\x00-\x1f\x7f-\xff]/g;
  function Fc(a, b) {
    b.push('"', a.replace(Hc, function (a) {
      var b = Gc[a];b || (b = "\\u" + (a.charCodeAt(0) | 65536).toString(16).substr(1), Gc[a] = b);return b;
    }), '"');
  };function Ic() {
    0 != Jc && (Kc[this[ia] || (this[ia] = ++ja)] = this);this.oa = this.oa;this.Fa = this.Fa;
  }var Jc = 0,
      Kc = {};Ic.prototype.oa = !1;function Lc(a) {
    a.oa || (a.oa = !0, a.ta(), 0 != Jc && (a = a[ia] || (a[ia] = ++ja), delete Kc[a]));
  }Ic.prototype.ta = function () {
    if (this.Fa) for (; this.Fa.length;) {
      this.Fa.shift()();
    }
  };var Mc = Object.freeze || function (a) {
    return a;
  };var Nc = !y || 9 <= Number(kb),
      Oc = y && !jb("9"),
      Pc = function () {
    if (!k.addEventListener || !Object.defineProperty) return !1;var a = !1,
        b = Object.defineProperty({}, "passive", { get: function get() {
        a = !0;
      } });k.addEventListener("test", ca, b);k.removeEventListener("test", ca, b);return a;
  }();function C(a, b) {
    this.type = a;this.b = this.target = b;this.Ab = !0;
  }C.prototype.c = function () {
    this.Ab = !1;
  };function Qc(a, b) {
    C.call(this, a ? a.type : "");this.relatedTarget = this.b = this.target = null;this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;this.key = "";this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.pointerId = 0;this.pointerType = "";this.a = null;if (a) {
      var c = this.type = a.type,
          d = a.changedTouches ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.b = b;if (b = a.relatedTarget) {
        if (cb) {
          a: {
            try {
              Xa(b.nodeName);var e = !0;break a;
            } catch (f) {}e = !1;
          }e || (b = null);
        }
      } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;null === d ? (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0) : (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0);this.button = a.button;this.key = a.key || "";this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.pointerId = a.pointerId || 0;this.pointerType = m(a.pointerType) ? a.pointerType : Rc[a.pointerType] || "";this.a = a;a.defaultPrevented && this.c();
    }
  }t(Qc, C);var Rc = Mc({ 2: "touch", 3: "pen", 4: "mouse" });Qc.prototype.c = function () {
    Qc.ib.c.call(this);var a = this.a;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Oc) try {
      if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
  };Qc.prototype.g = function () {
    return this.a;
  };var Sc = "closure_listenable_" + (1E6 * Math.random() | 0),
      Tc = 0;function Uc(a, b, c, d, e) {
    this.listener = a;this.a = null;this.src = b;this.type = c;this.capture = !!d;this.La = e;this.key = ++Tc;this.ma = this.Ha = !1;
  }function Vc(a) {
    a.ma = !0;a.listener = null;a.a = null;a.src = null;a.La = null;
  };function Wc(a) {
    this.src = a;this.a = {};this.b = 0;
  }function Xc(a, b, c, d, e, f) {
    var g = b.toString();b = a.a[g];b || (b = a.a[g] = [], a.b++);var l = Yc(b, c, e, f);-1 < l ? (a = b[l], d || (a.Ha = !1)) : (a = new Uc(c, a.src, g, !!e, f), a.Ha = d, b.push(a));return a;
  }function Zc(a, b) {
    var c = b.type;c in a.a && Ia(a.a[c], b) && (Vc(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
  }function Yc(a, b, c, d) {
    for (var e = 0; e < a.length; ++e) {
      var f = a[e];if (!f.ma && f.listener == b && f.capture == !!c && f.La == d) return e;
    }return -1;
  };var $c = "closure_lm_" + (1E6 * Math.random() | 0),
      ad = {},
      bd = 0;function cd(a, b, c, d, e) {
    if (d && d.once) dd(a, b, c, d, e);else if (fa(b)) for (var f = 0; f < b.length; f++) {
      cd(a, b[f], c, d, e);
    } else c = ed(c), a && a[Sc] ? fd(a, b, c, q(d) ? !!d.capture : !!d, e) : gd(a, b, c, !1, d, e);
  }
  function gd(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");var g = q(e) ? !!e.capture : !!e,
        l = hd(a);l || (a[$c] = l = new Wc(a));c = Xc(l, b, c, d, g, f);if (!c.a) {
      d = id();c.a = d;d.src = a;d.listener = c;if (a.addEventListener) Pc || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(jd(b.toString()), d);else throw Error("addEventListener and attachEvent are unavailable.");bd++;
    }
  }
  function id() {
    var a = kd,
        b = Nc ? function (c) {
      return a.call(b.src, b.listener, c);
    } : function (c) {
      c = a.call(b.src, b.listener, c);if (!c) return c;
    };return b;
  }function dd(a, b, c, d, e) {
    if (fa(b)) for (var f = 0; f < b.length; f++) {
      dd(a, b[f], c, d, e);
    } else c = ed(c), a && a[Sc] ? ld(a, b, c, q(d) ? !!d.capture : !!d, e) : gd(a, b, c, !0, d, e);
  }
  function E(a, b, c, d, e) {
    if (fa(b)) for (var f = 0; f < b.length; f++) {
      E(a, b[f], c, d, e);
    } else (d = q(d) ? !!d.capture : !!d, c = ed(c), a && a[Sc]) ? (a = a.u, b = String(b).toString(), b in a.a && (f = a.a[b], c = Yc(f, c, d, e), -1 < c && (Vc(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = hd(a)) && (b = a.a[b.toString()], a = -1, b && (a = Yc(b, c, d, e)), (c = -1 < a ? b[a] : null) && md(c));
  }
  function md(a) {
    if ("number" != typeof a && a && !a.ma) {
      var b = a.src;if (b && b[Sc]) Zc(b.u, a);else {
        var c = a.type,
            d = a.a;b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent && b.detachEvent(jd(c), d);bd--;(c = hd(b)) ? (Zc(c, a), 0 == c.b && (c.src = null, b[$c] = null)) : Vc(a);
      }
    }
  }function jd(a) {
    return a in ad ? ad[a] : ad[a] = "on" + a;
  }function nd(a, b, c, d) {
    var e = !0;if (a = hd(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
      var f = b[a];f && f.capture == c && !f.ma && (f = od(f, d), e = e && !1 !== f);
    }return e;
  }
  function od(a, b) {
    var c = a.listener,
        d = a.La || a.src;a.Ha && md(a);return c.call(d, b);
  }
  function kd(a, b) {
    if (a.ma) return !0;if (!Nc) {
      if (!b) a: {
        b = ["window", "event"];for (var c = k, d = 0; d < b.length; d++) {
          if (c = c[b[d]], null == c) {
            b = null;break a;
          }
        }b = c;
      }d = b;b = new Qc(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
        a: {
          var e = !1;if (0 == d.keyCode) try {
            d.keyCode = -1;break a;
          } catch (g) {
            e = !0;
          }if (e || void 0 == d.returnValue) d.returnValue = !0;
        }d = [];for (e = b.b; e; e = e.parentNode) {
          d.push(e);
        }a = a.type;for (e = d.length - 1; 0 <= e; e--) {
          b.b = d[e];var f = nd(d[e], a, !0, b);c = c && f;
        }for (e = 0; e < d.length; e++) {
          b.b = d[e], f = nd(d[e], a, !1, b), c = c && f;
        }
      }return c;
    }return od(a, new Qc(b, this));
  }function hd(a) {
    a = a[$c];return a instanceof Wc ? a : null;
  }var pd = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);function ed(a) {
    if (p(a)) return a;a[pd] || (a[pd] = function (b) {
      return a.handleEvent(b);
    });return a[pd];
  };function F() {
    Ic.call(this);this.u = new Wc(this);this.Eb = this;this.Ra = null;
  }t(F, Ic);F.prototype[Sc] = !0;F.prototype.removeEventListener = function (a, b, c, d) {
    E(this, a, b, c, d);
  };
  function G(a, b) {
    var c,
        d = a.Ra;if (d) for (c = []; d; d = d.Ra) {
      c.push(d);
    }a = a.Eb;d = b.type || b;if (m(b)) b = new C(b, a);else if (b instanceof C) b.target = b.target || a;else {
      var e = b;b = new C(d, a);Wa(b, e);
    }e = !0;if (c) for (var f = c.length - 1; 0 <= f; f--) {
      var g = b.b = c[f];e = qd(g, d, !0, b) && e;
    }g = b.b = a;e = qd(g, d, !0, b) && e;e = qd(g, d, !1, b) && e;if (c) for (f = 0; f < c.length; f++) {
      g = b.b = c[f], e = qd(g, d, !1, b) && e;
    }
  }
  F.prototype.ta = function () {
    F.ib.ta.call(this);if (this.u) {
      var a = this.u,
          b = 0,
          c;for (c in a.a) {
        for (var d = a.a[c], e = 0; e < d.length; e++) {
          ++b, Vc(d[e]);
        }delete a.a[c];a.b--;
      }
    }this.Ra = null;
  };function fd(a, b, c, d, e) {
    Xc(a.u, String(b), c, !1, d, e);
  }function ld(a, b, c, d, e) {
    Xc(a.u, String(b), c, !0, d, e);
  }function qd(a, b, c, d) {
    b = a.u.a[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
      var g = b[f];if (g && !g.ma && g.capture == c) {
        var l = g.listener,
            n = g.La || g.src;g.Ha && Zc(a.u, g);e = !1 !== l.call(n, d) && e;
      }
    }return e && 0 != d.Ab;
  };function rd(a, b, c) {
    if (p(a)) c && (a = r(a, c));else if (a && "function" == typeof a.handleEvent) a = r(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
  }function sd(a) {
    var b = null;return new z(function (c, d) {
      b = rd(function () {
        c(void 0);
      }, a);-1 == b && d(Error("Failed to schedule timer."));
    }).s(function (a) {
      k.clearTimeout(b);throw a;
    });
  };function td(a, b, c, d, e) {
    this.reset(a, b, c, d, e);
  }td.prototype.a = null;var ud = 0;td.prototype.reset = function (a, b, c, d, e) {
    "number" == typeof e || ud++;d || na();this.b = b;delete this.a;
  };function vd(a) {
    this.f = a;this.b = this.c = this.a = null;
  }function wd(a, b) {
    this.name = a;this.value = b;
  }wd.prototype.toString = function () {
    return this.name;
  };var xd = new wd("SEVERE", 1E3),
      yd = new wd("CONFIG", 700),
      zd = new wd("FINE", 500);function Ad(a) {
    if (a.c) return a.c;if (a.a) return Ad(a.a);Aa("Root logger has no level set.");return null;
  }
  vd.prototype.log = function (a, b, c) {
    if (a.value >= Ad(this).value) for (p(b) && (b = b()), a = new td(a, String(b), this.f), c && (a.a = c), c = "log:" + a.b, (a = k.console) && a.timeStamp && a.timeStamp(c), (a = k.msWriteProfilerMark) && a(c), c = this; c;) {
      c = c.a;
    }
  };var Bd = {},
      Cd = null;function Dd(a) {
    Cd || (Cd = new vd(""), Bd[""] = Cd, Cd.c = yd);var b;if (!(b = Bd[a])) {
      b = new vd(a);var c = a.lastIndexOf("."),
          d = a.substr(c + 1);c = Dd(a.substr(0, c));c.b || (c.b = {});c.b[d] = b;b.a = c;Bd[a] = b;
    }return b;
  };function Ed(a, b) {
    this.b = {};this.a = [];this.c = 0;var c = arguments.length;if (1 < c) {
      if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
        this.set(arguments[d], arguments[d + 1]);
      }
    } else if (a) {
      a instanceof Ed ? (c = a.S(), d = a.P()) : (c = Ra(a), d = Qa(a));for (var e = 0; e < c.length; e++) {
        this.set(c[e], d[e]);
      }
    }
  }h = Ed.prototype;h.P = function () {
    Fd(this);for (var a = [], b = 0; b < this.a.length; b++) {
      a.push(this.b[this.a[b]]);
    }return a;
  };h.S = function () {
    Fd(this);return this.a.concat();
  };
  h.clear = function () {
    this.b = {};this.c = this.a.length = 0;
  };function Fd(a) {
    if (a.c != a.a.length) {
      for (var b = 0, c = 0; b < a.a.length;) {
        var d = a.a[b];Gd(a.b, d) && (a.a[c++] = d);b++;
      }a.a.length = c;
    }if (a.c != a.a.length) {
      var e = {};for (c = b = 0; b < a.a.length;) {
        d = a.a[b], Gd(e, d) || (a.a[c++] = d, e[d] = 1), b++;
      }a.a.length = c;
    }
  }h.get = function (a, b) {
    return Gd(this.b, a) ? this.b[a] : b;
  };h.set = function (a, b) {
    Gd(this.b, a) || (this.c++, this.a.push(a));this.b[a] = b;
  };
  h.forEach = function (a, b) {
    for (var c = this.S(), d = 0; d < c.length; d++) {
      var e = c[d],
          f = this.get(e);a.call(b, f, e, this);
    }
  };function Gd(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  };function H(a, b) {
    a && a.log(zd, b, void 0);
  };function Hd(a) {
    return Da(a, function (a) {
      a = a.toString(16);return 1 < a.length ? a : "0" + a;
    }).join("");
  };var Id = null,
      Jd = null;function Kd(a) {
    var b = "";Ld(a, function (a) {
      b += String.fromCharCode(a);
    });return b;
  }function Ld(a, b) {
    function c(b) {
      for (; d < a.length;) {
        var c = a.charAt(d++),
            e = Jd[c];if (null != e) return e;if (!/^[\s\xa0]*$/.test(c)) throw Error("Unknown base64 encoding at char: " + c);
      }return b;
    }Md();for (var d = 0;;) {
      var e = c(-1),
          f = c(0),
          g = c(64),
          l = c(64);if (64 === l && -1 === e) break;b(e << 2 | f >> 4);64 != g && (b(f << 4 & 240 | g >> 2), 64 != l && b(g << 6 & 192 | l));
    }
  }
  function Md() {
    if (!Id) {
      Id = {};Jd = {};for (var a = 0; 65 > a; a++) {
        Id[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a), Jd[Id[a]] = a, 62 <= a && (Jd["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)] = a);
      }
    }
  }; /*
     Portions of this code are from MochiKit, received by
     The Closure Authors under the MIT license. All other code is Copyright
     2005-2009 The Closure Authors. All Rights Reserved.
     */
  function Nd(a, b) {
    this.g = [];this.v = a;this.o = b || null;this.f = this.a = !1;this.c = void 0;this.u = this.w = this.i = !1;this.h = 0;this.b = null;this.l = 0;
  }Nd.prototype.cancel = function (a) {
    if (this.a) this.c instanceof Nd && this.c.cancel();else {
      if (this.b) {
        var b = this.b;delete this.b;a ? b.cancel(a) : (b.l--, 0 >= b.l && b.cancel());
      }this.v ? this.v.call(this.o, this) : this.u = !0;this.a || (a = new Od(), Pd(this), Qd(this, !1, a));
    }
  };Nd.prototype.m = function (a, b) {
    this.i = !1;Qd(this, a, b);
  };function Qd(a, b, c) {
    a.a = !0;a.c = c;a.f = !b;Rd(a);
  }
  function Pd(a) {
    if (a.a) {
      if (!a.u) throw new Sd();a.u = !1;
    }
  }Nd.prototype.A = function (a) {
    Pd(this);Qd(this, !0, a);
  };function Td(a, b) {
    Ud(a, null, b, void 0);
  }function Ud(a, b, c, d) {
    a.g.push([b, c, d]);a.a && Rd(a);
  }Nd.prototype.then = function (a, b, c) {
    var d,
        e,
        f = new z(function (a, b) {
      d = a;e = b;
    });Ud(this, d, function (a) {
      a instanceof Od ? f.cancel() : e(a);
    });return f.then(a, b, c);
  };mb(Nd);function Vd(a) {
    return Ea(a.g, function (a) {
      return p(a[1]);
    });
  }
  function Rd(a) {
    if (a.h && a.a && Vd(a)) {
      var b = a.h,
          c = Wd[b];c && (k.clearTimeout(c.a), delete Wd[b]);a.h = 0;
    }a.b && (a.b.l--, delete a.b);b = a.c;for (var d = c = !1; a.g.length && !a.i;) {
      var e = a.g.shift(),
          f = e[0],
          g = e[1];e = e[2];if (f = a.f ? g : f) try {
        var l = f.call(e || a.o, b);void 0 !== l && (a.f = a.f && (l == b || l instanceof Error), a.c = b = l);if (nb(b) || "function" === typeof k.Promise && b instanceof k.Promise) d = !0, a.i = !0;
      } catch (n) {
        b = n, a.f = !0, Vd(a) || (c = !0);
      }
    }a.c = b;d && (l = r(a.m, a, !0), d = r(a.m, a, !1), b instanceof Nd ? (Ud(b, l, d), b.w = !0) : b.then(l, d));c && (b = new Xd(b), Wd[b.a] = b, a.h = b.a);
  }function Sd() {
    u.call(this);
  }t(Sd, u);Sd.prototype.message = "Deferred has already fired";Sd.prototype.name = "AlreadyCalledError";function Od() {
    u.call(this);
  }t(Od, u);Od.prototype.message = "Deferred was canceled";Od.prototype.name = "CanceledError";function Xd(a) {
    this.a = k.setTimeout(r(this.c, this), 0);this.b = a;
  }Xd.prototype.c = function () {
    delete Wd[this.a];throw this.b;
  };var Wd = {};function Yd() {
    this.b = -1;
  };function Zd(a, b) {
    this.b = -1;this.b = $d;this.f = k.Uint8Array ? new Uint8Array(this.b) : Array(this.b);this.g = this.c = 0;this.a = [];this.i = a;this.h = b;this.l = k.Int32Array ? new Int32Array(64) : Array(64);ae || (k.Int32Array ? ae = new Int32Array(be) : ae = be);this.reset();
  }var ae;t(Zd, Yd);for (var $d = 64, ce = $d - 1, de = [], ee = 0; ee < ce; ee++) {
    de[ee] = 0;
  }var fe = Ka(128, de);Zd.prototype.reset = function () {
    this.g = this.c = 0;this.a = k.Int32Array ? new Int32Array(this.h) : La(this.h);
  };
  function ge(a) {
    for (var b = a.f, c = a.l, d = 0, e = 0; e < b.length;) {
      c[d++] = b[e] << 24 | b[e + 1] << 16 | b[e + 2] << 8 | b[e + 3], e = 4 * d;
    }for (b = 16; 64 > b; b++) {
      e = c[b - 15] | 0;d = c[b - 2] | 0;var f = (c[b - 16] | 0) + ((e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3) | 0,
          g = (c[b - 7] | 0) + ((d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10) | 0;c[b] = f + g | 0;
    }d = a.a[0] | 0;e = a.a[1] | 0;var l = a.a[2] | 0,
        n = a.a[3] | 0,
        D = a.a[4] | 0,
        vb = a.a[5] | 0,
        tc = a.a[6] | 0;f = a.a[7] | 0;for (b = 0; 64 > b; b++) {
      var Bj = ((d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10)) + (d & e ^ d & l ^ e & l) | 0;g = D & vb ^ ~D & tc;f = f + ((D >>> 6 | D << 26) ^ (D >>> 11 | D << 21) ^ (D >>> 25 | D << 7)) | 0;g = g + (ae[b] | 0) | 0;g = f + (g + (c[b] | 0) | 0) | 0;f = tc;tc = vb;vb = D;D = n + g | 0;n = l;l = e;e = d;d = g + Bj | 0;
    }a.a[0] = a.a[0] + d | 0;a.a[1] = a.a[1] + e | 0;a.a[2] = a.a[2] + l | 0;a.a[3] = a.a[3] + n | 0;a.a[4] = a.a[4] + D | 0;a.a[5] = a.a[5] + vb | 0;a.a[6] = a.a[6] + tc | 0;a.a[7] = a.a[7] + f | 0;
  }
  function he(a, b, c) {
    void 0 === c && (c = b.length);var d = 0,
        e = a.c;if (m(b)) for (; d < c;) {
      a.f[e++] = b.charCodeAt(d++), e == a.b && (ge(a), e = 0);
    } else if (ha(b)) for (; d < c;) {
      var f = b[d++];if (!("number" == typeof f && 0 <= f && 255 >= f && f == (f | 0))) throw Error("message must be a byte array");a.f[e++] = f;e == a.b && (ge(a), e = 0);
    } else throw Error("message must be string or array");a.c = e;a.g += c;
  }
  var be = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];function ie() {
    Zd.call(this, 8, je);
  }t(ie, Zd);var je = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225];function ke(a) {
    if (a.P && "function" == typeof a.P) return a.P();if (m(a)) return a.split("");if (ha(a)) {
      for (var b = [], c = a.length, d = 0; d < c; d++) {
        b.push(a[d]);
      }return b;
    }return Qa(a);
  }function le(a) {
    if (a.S && "function" == typeof a.S) return a.S();if (!a.P || "function" != typeof a.P) {
      if (ha(a) || m(a)) {
        var b = [];a = a.length;for (var c = 0; c < a; c++) {
          b.push(c);
        }return b;
      }return Ra(a);
    }
  }
  function me(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ha(a) || m(a)) w(a, b, void 0);else for (var c = le(a), d = ke(a), e = d.length, f = 0; f < e; f++) {
      b.call(void 0, d[f], c && c[f], a);
    }
  };var ne = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function oe(a, b) {
    if (a) {
      a = a.split("&");for (var c = 0; c < a.length; c++) {
        var d = a[c].indexOf("="),
            e = null;if (0 <= d) {
          var f = a[c].substring(0, d);e = a[c].substring(d + 1);
        } else f = a[c];b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
      }
    }
  };function pe(a, b) {
    this.b = this.l = this.c = "";this.i = null;this.h = this.g = "";this.f = !1;if (a instanceof pe) {
      this.f = void 0 !== b ? b : a.f;qe(this, a.c);this.l = a.l;this.b = a.b;re(this, a.i);this.g = a.g;b = a.a;var c = new se();c.c = b.c;b.a && (c.a = new Ed(b.a), c.b = b.b);te(this, c);this.h = a.h;
    } else a && (c = String(a).match(ne)) ? (this.f = !!b, qe(this, c[1] || "", !0), this.l = ue(c[2] || ""), this.b = ue(c[3] || "", !0), re(this, c[4]), this.g = ue(c[5] || "", !0), te(this, c[6] || "", !0), this.h = ue(c[7] || "")) : (this.f = !!b, this.a = new se(null, 0, this.f));
  }
  pe.prototype.toString = function () {
    var a = [],
        b = this.c;b && a.push(ve(b, we, !0), ":");var c = this.b;if (c || "file" == b) a.push("//"), (b = this.l) && a.push(ve(b, we, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.i, null != c && a.push(":", String(c));if (c = this.g) this.b && "/" != c.charAt(0) && a.push("/"), a.push(ve(c, "/" == c.charAt(0) ? xe : ye, !0));(c = this.a.toString()) && a.push("?", c);(c = this.h) && a.push("#", ve(c, ze));return a.join("");
  };
  function qe(a, b, c) {
    a.c = c ? ue(b, !0) : b;a.c && (a.c = a.c.replace(/:$/, ""));
  }function re(a, b) {
    if (b) {
      b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.i = b;
    } else a.i = null;
  }function te(a, b, c) {
    b instanceof se ? (a.a = b, Ae(a.a, a.f)) : (c || (b = ve(b, Be)), a.a = new se(b, 0, a.f));
  }function I(a, b, c) {
    a.a.set(b, c);
  }function Ce(a, b) {
    return a.a.get(b);
  }function De(a) {
    return a instanceof pe ? new pe(a) : new pe(a, void 0);
  }function Ee(a, b) {
    var c = new pe(null, void 0);qe(c, "https");a && (c.b = a);b && (c.g = b);return c;
  }
  function ue(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
  }function ve(a, b, c) {
    return m(a) ? (a = encodeURI(a).replace(b, Fe), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
  }function Fe(a) {
    a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
  }var we = /[#\/\?@]/g,
      ye = /[\#\?:]/g,
      xe = /[\#\?]/g,
      Be = /[\#\?@]/g,
      ze = /#/g;function se(a, b, c) {
    this.b = this.a = null;this.c = a || null;this.f = !!c;
  }
  function Ge(a) {
    a.a || (a.a = new Ed(), a.b = 0, a.c && oe(a.c, function (b, c) {
      He(a, decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
  }function Ie(a) {
    var b = le(a);if ("undefined" == typeof b) throw Error("Keys are undefined");var c = new se(null, 0, void 0);a = ke(a);for (var d = 0; d < b.length; d++) {
      var e = b[d],
          f = a[d];fa(f) ? Je(c, e, f) : He(c, e, f);
    }return c;
  }function He(a, b, c) {
    Ge(a);a.c = null;b = Ke(a, b);var d = a.a.get(b);d || a.a.set(b, d = []);d.push(c);a.b += 1;
  }
  function Le(a, b) {
    Ge(a);b = Ke(a, b);Gd(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, Gd(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Fd(a)));
  }h = se.prototype;h.clear = function () {
    this.a = this.c = null;this.b = 0;
  };function Me(a, b) {
    Ge(a);b = Ke(a, b);return Gd(a.a.b, b);
  }h.forEach = function (a, b) {
    Ge(this);this.a.forEach(function (c, d) {
      w(c, function (c) {
        a.call(b, c, d, this);
      }, this);
    }, this);
  };h.S = function () {
    Ge(this);for (var a = this.a.P(), b = this.a.S(), c = [], d = 0; d < b.length; d++) {
      for (var e = a[d], f = 0; f < e.length; f++) {
        c.push(b[d]);
      }
    }return c;
  };
  h.P = function (a) {
    Ge(this);var b = [];if (m(a)) Me(this, a) && (b = Ka(b, this.a.get(Ke(this, a))));else {
      a = this.a.P();for (var c = 0; c < a.length; c++) {
        b = Ka(b, a[c]);
      }
    }return b;
  };h.set = function (a, b) {
    Ge(this);this.c = null;a = Ke(this, a);Me(this, a) && (this.b -= this.a.get(a).length);this.a.set(a, [b]);this.b += 1;return this;
  };h.get = function (a, b) {
    a = a ? this.P(a) : [];return 0 < a.length ? String(a[0]) : b;
  };function Je(a, b, c) {
    Le(a, b);0 < c.length && (a.c = null, a.a.set(Ke(a, b), La(c)), a.b += c.length);
  }
  h.toString = function () {
    if (this.c) return this.c;if (!this.a) return "";for (var a = [], b = this.a.S(), c = 0; c < b.length; c++) {
      var d = b[c],
          e = encodeURIComponent(String(d));d = this.P(d);for (var f = 0; f < d.length; f++) {
        var g = e;"" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));a.push(g);
      }
    }return this.c = a.join("&");
  };function Ke(a, b) {
    b = String(b);a.f && (b = b.toLowerCase());return b;
  }function Ae(a, b) {
    b && !a.f && (Ge(a), a.c = null, a.a.forEach(function (a, b) {
      var c = b.toLowerCase();b != c && (Le(this, b), Je(this, c, a));
    }, a));a.f = b;
  };function Ne() {}Ne.prototype.c = null;function Oe(a) {
    return a.c || (a.c = a.b());
  };var Pe;function Qe() {}t(Qe, Ne);Qe.prototype.a = function () {
    var a = Re(this);return a ? new ActiveXObject(a) : new XMLHttpRequest();
  };Qe.prototype.b = function () {
    var a = {};Re(this) && (a[0] = !0, a[1] = !0);return a;
  };
  function Re(a) {
    if (!a.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
      for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
        var d = b[c];try {
          return new ActiveXObject(d), a.f = d;
        } catch (e) {}
      }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }return a.f;
  }Pe = new Qe();function Se(a) {
    F.call(this);this.headers = new Ed();this.w = a || null;this.b = !1;this.v = this.a = null;this.g = this.I = this.i = "";this.c = this.G = this.h = this.A = !1;this.f = 0;this.m = null;this.l = Te;this.o = this.N = !1;
  }t(Se, F);var Te = "",
      Ue = Se.prototype,
      Ve = Dd("goog.net.XhrIo");Ue.J = Ve;var We = /^https?$/i,
      Xe = ["POST", "PUT"];
  function Ye(a, b, c, d, e) {
    if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.i + "; newUri=" + b);c = c ? c.toUpperCase() : "GET";a.i = b;a.g = "";a.I = c;a.A = !1;a.b = !0;a.a = a.w ? a.w.a() : Pe.a();a.v = a.w ? Oe(a.w) : Oe(Pe);a.a.onreadystatechange = r(a.zb, a);try {
      H(a.J, Ze(a, "Opening Xhr")), a.G = !0, a.a.open(c, String(b), !0), a.G = !1;
    } catch (g) {
      H(a.J, Ze(a, "Error opening Xhr: " + g.message));$e(a, g);return;
    }b = d || "";var f = new Ed(a.headers);e && me(e, function (a, b) {
      f.set(b, a);
    });e = Fa(f.S());d = k.FormData && b instanceof k.FormData;!Ha(Xe, c) || e || d || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");f.forEach(function (a, b) {
      this.a.setRequestHeader(b, a);
    }, a);a.l && (a.a.responseType = a.l);"withCredentials" in a.a && a.a.withCredentials !== a.N && (a.a.withCredentials = a.N);try {
      af(a), 0 < a.f && (a.o = bf(a.a), H(a.J, Ze(a, "Will abort after " + a.f + "ms if incomplete, xhr2 " + a.o)), a.o ? (a.a.timeout = a.f, a.a.ontimeout = r(a.Ea, a)) : a.m = rd(a.Ea, a.f, a)), H(a.J, Ze(a, "Sending request")), a.h = !0, a.a.send(b), a.h = !1;
    } catch (g) {
      H(a.J, Ze(a, "Send error: " + g.message)), $e(a, g);
    }
  }function bf(a) {
    return y && jb(9) && "number" == typeof a.timeout && void 0 !== a.ontimeout;
  }function Ga(a) {
    return "content-type" == a.toLowerCase();
  }h = Se.prototype;h.Ea = function () {
    "undefined" != typeof aa && this.a && (this.g = "Timed out after " + this.f + "ms, aborting", H(this.J, Ze(this, this.g)), G(this, "timeout"), this.abort(8));
  };function $e(a, b) {
    a.b = !1;a.a && (a.c = !0, a.a.abort(), a.c = !1);a.g = b;cf(a);df(a);
  }function cf(a) {
    a.A || (a.A = !0, G(a, "complete"), G(a, "error"));
  }
  h.abort = function () {
    this.a && this.b && (H(this.J, Ze(this, "Aborting")), this.b = !1, this.c = !0, this.a.abort(), this.c = !1, G(this, "complete"), G(this, "abort"), df(this));
  };h.ta = function () {
    this.a && (this.b && (this.b = !1, this.c = !0, this.a.abort(), this.c = !1), df(this, !0));Se.ib.ta.call(this);
  };h.zb = function () {
    this.oa || (this.G || this.h || this.c ? ef(this) : this.fc());
  };h.fc = function () {
    ef(this);
  };
  function ef(a) {
    if (a.b && "undefined" != typeof aa) if (a.v[1] && 4 == ff(a) && 2 == gf(a)) H(a.J, Ze(a, "Local request error detected and ignored"));else if (a.h && 4 == ff(a)) rd(a.zb, 0, a);else if (G(a, "readystatechange"), 4 == ff(a)) {
      H(a.J, Ze(a, "Request complete"));a.b = !1;try {
        var b = gf(a);a: switch (b) {case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
            var c = !0;break a;default:
            c = !1;}var d;if (!(d = c)) {
          var e;if (e = 0 === b) {
            var f = String(a.i).match(ne)[1] || null;if (!f && k.self && k.self.location) {
              var g = k.self.location.protocol;
              f = g.substr(0, g.length - 1);
            }e = !We.test(f ? f.toLowerCase() : "");
          }d = e;
        }if (d) G(a, "complete"), G(a, "success");else {
          try {
            var l = 2 < ff(a) ? a.a.statusText : "";
          } catch (n) {
            H(a.J, "Can not get status: " + n.message), l = "";
          }a.g = l + " [" + gf(a) + "]";cf(a);
        }
      } finally {
        df(a);
      }
    }
  }function df(a, b) {
    if (a.a) {
      af(a);var c = a.a,
          d = a.v[0] ? ca : null;a.a = null;a.v = null;b || G(a, "ready");try {
        c.onreadystatechange = d;
      } catch (e) {
        (a = a.J) && a.log(xd, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
      }
    }
  }
  function af(a) {
    a.a && a.o && (a.a.ontimeout = null);"number" == typeof a.m && (k.clearTimeout(a.m), a.m = null);
  }function ff(a) {
    return a.a ? a.a.readyState : 0;
  }function gf(a) {
    try {
      return 2 < ff(a) ? a.a.status : -1;
    } catch (b) {
      return -1;
    }
  }function hf(a) {
    try {
      return a.a ? a.a.responseText : "";
    } catch (b) {
      return H(a.J, "Can not get responseText: " + b.message), "";
    }
  }
  h.getResponse = function () {
    try {
      if (!this.a) return null;if ("response" in this.a) return this.a.response;switch (this.l) {case Te:case "text":
          return this.a.responseText;case "arraybuffer":
          if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;}var a = this.J;a && a.log(xd, "Response type " + this.l + " is not supported on this browser", void 0);return null;
    } catch (b) {
      return H(this.J, "Can not get response: " + b.message), null;
    }
  };function Ze(a, b) {
    return b + " [" + a.I + " " + a.i + " " + gf(a) + "]";
  };var jf = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function kf(a) {
    var b = {},
        c = b.document || document,
        d = gc(a),
        e = document.createElement("SCRIPT"),
        f = { Bb: e, Ea: void 0 },
        g = new Nd(lf, f),
        l = null,
        n = null != b.timeout ? b.timeout : 5E3;0 < n && (l = window.setTimeout(function () {
      mf(e, !0);var a = new nf(of, "Timeout reached for loading script " + d);Pd(g);Qd(g, !1, a);
    }, n), f.Ea = l);e.onload = e.onreadystatechange = function () {
      e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (mf(e, b.Oc || !1, l), g.A(null));
    };e.onerror = function () {
      mf(e, !0, l);var a = new nf(pf, "Error while loading script " + d);Pd(g);Qd(g, !1, a);
    };f = b.attributes || {};Wa(f, { type: "text/javascript", charset: "UTF-8" });xc(e, f);e.src = gc(a);qf(c).appendChild(e);return g;
  }function qf(a) {
    var b;return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
  }function lf() {
    if (this && this.Bb) {
      var a = this.Bb;a && "SCRIPT" == a.tagName && mf(a, !0, this.Ea);
    }
  }
  function mf(a, b, c) {
    null != c && k.clearTimeout(c);a.onload = ca;a.onerror = ca;a.onreadystatechange = ca;b && window.setTimeout(function () {
      a && a.parentNode && a.parentNode.removeChild(a);
    }, 0);
  }var pf = 0,
      of = 1;function nf(a, b) {
    var c = "Jsloader error (code #" + a + ")";b && (c += ": " + b);u.call(this, c);this.code = a;
  }t(nf, u);function rf() {}t(rf, Ne);rf.prototype.a = function () {
    var a = new XMLHttpRequest();if ("withCredentials" in a) return a;if ("undefined" != typeof XDomainRequest) return new sf();throw Error("Unsupported browser");
  };rf.prototype.b = function () {
    return {};
  };
  function sf() {
    this.a = new XDomainRequest();this.readyState = 0;this.onreadystatechange = null;this.responseText = "";this.status = -1;this.statusText = this.responseXML = null;this.a.onload = r(this.Sb, this);this.a.onerror = r(this.wb, this);this.a.onprogress = r(this.Tb, this);this.a.ontimeout = r(this.Ub, this);
  }h = sf.prototype;h.open = function (a, b, c) {
    if (null != c && !c) throw Error("Only async requests are supported.");this.a.open(a, b);
  };
  h.send = function (a) {
    if (a) {
      if ("string" == typeof a) this.a.send(a);else throw Error("Only string data is supported");
    } else this.a.send();
  };h.abort = function () {
    this.a.abort();
  };h.setRequestHeader = function () {};h.getResponseHeader = function (a) {
    return "content-type" == a.toLowerCase() ? this.a.contentType : "";
  };h.Sb = function () {
    this.status = 200;this.responseText = this.a.responseText;tf(this, 4);
  };h.wb = function () {
    this.status = 500;this.responseText = "";tf(this, 4);
  };h.Ub = function () {
    this.wb();
  };
  h.Tb = function () {
    this.status = 200;tf(this, 1);
  };function tf(a, b) {
    a.readyState = b;if (a.onreadystatechange) a.onreadystatechange();
  }h.getAllResponseHeaders = function () {
    return "content-type: " + this.a.contentType;
  };function uf() {
    var a = J();return y && !!kb && 11 == kb || /Edge\/\d+/.test(a);
  }function vf() {
    return k.window && k.window.location.href || "";
  }function wf(a, b) {
    b = b || k.window;var c = "about:blank";a && (c = nc(pc(a)));b.location.href = c;
  }function xf(a, b) {
    var c = [],
        d;for (d in a) {
      d in b ? typeof a[d] != typeof b[d] ? c.push(d) : fa(a[d]) ? Ta(a[d], b[d]) || c.push(d) : "object" == typeof a[d] && null != a[d] && null != b[d] ? 0 < xf(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
    }for (d in b) {
      d in a || c.push(d);
    }return c;
  }
  function yf() {
    var a = J();a = zf(a) != Af ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;return a && 30 > a ? !1 : !y || !kb || 9 < kb;
  }function Bf(a) {
    a = (a || J()).toLowerCase();return a.match(/android/) || a.match(/webos/) || a.match(/iphone|ipad|ipod/) || a.match(/blackberry/) || a.match(/windows phone/) || a.match(/iemobile/) ? !0 : !1;
  }function Cf(a) {
    a = a || k.window;try {
      a.close();
    } catch (b) {}
  }
  function Df(a, b, c) {
    var d = Math.floor(1E9 * Math.random()).toString();b = b || 500;c = c || 600;var e = (window.screen.availHeight - c) / 2,
        f = (window.screen.availWidth - b) / 2;b = { width: b, height: c, top: 0 < e ? e : 0, left: 0 < f ? f : 0, location: !0, resizable: !0, statusbar: !0, toolbar: !1 };c = J().toLowerCase();d && (b.target = d, v(c, "crios/") && (b.target = "_blank"));zf(J()) == Ef && (a = a || "http://localhost", b.scrollbars = !0);c = a || "";(d = b) || (d = {});a = window;b = c instanceof lc ? c : pc("undefined" != typeof c.href ? c.href : String(c));c = d.target || c.target;e = [];
    for (g in d) {
      switch (g) {case "width":case "height":case "top":case "left":
          e.push(g + "=" + d[g]);break;case "target":case "noreferrer":
          break;default:
          e.push(g + "=" + (d[g] ? 1 : 0));}
    }var g = e.join(",");(x("iPhone") && !x("iPod") && !x("iPad") || x("iPad") || x("iPod")) && a.navigator && a.navigator.standalone && c && "_self" != c ? (g = a.document.createElement("A"), b instanceof lc || b instanceof lc || (b = b.la ? b.ja() : String(b), oc.test(b) || (b = "about:invalid#zClosurez"), b = qc(b)), g.href = nc(b), g.setAttribute("target", c), d.noreferrer && g.setAttribute("rel", "noreferrer"), d = document.createEvent("MouseEvent"), d.initMouseEvent("click", !0, !0, a, 1), g.dispatchEvent(d), g = {}) : d.noreferrer ? (g = a.open("", c, g), a = nc(b), g && (bb && v(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'"), g.opener = null, dc("b/12014412, meta tag with sanitized URL"), a = '<META HTTP-EQUIV="refresh" content="0; url=' + qa(a) + '">', a = vc(a), g.document.write(uc(a)), g.document.close())) : g = a.open(nc(b), c, g);if (g) try {
      g.focus();
    } catch (l) {}return g;
  }
  function Ff(a) {
    return new z(function (b) {
      function c() {
        sd(2E3).then(function () {
          if (!a || a.closed) b();else return c();
        });
      }return c();
    });
  }var Gf = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function Hf() {
    var a = null;return new z(function (b) {
      "complete" == k.document.readyState ? b() : (a = function a() {
        b();
      }, dd(window, "load", a));
    }).s(function (b) {
      E(window, "load", a);throw b;
    });
  }
  function If() {
    return Jf(void 0) ? Hf().then(function () {
      return new z(function (a, b) {
        var c = k.document,
            d = setTimeout(function () {
          b(Error("Cordova framework is not ready."));
        }, 1E3);c.addEventListener("deviceready", function () {
          clearTimeout(d);a();
        }, !1);
      });
    }) : B(Error("Cordova must run in an Android or iOS file scheme."));
  }function Jf(a) {
    a = a || J();return !("file:" !== Kf() || !a.toLowerCase().match(/iphone|ipad|ipod|android/));
  }function Lf() {
    var a = k.window;try {
      return !(!a || a == a.top);
    } catch (b) {
      return !1;
    }
  }
  function K() {
    return firebase.INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : firebase.INTERNAL.hasOwnProperty("node") ? "Node" : "Browser";
  }function Mf() {
    var a = K();return "ReactNative" === a || "Node" === a;
  }var Ef = "Firefox",
      Af = "Chrome";
  function zf(a) {
    var b = a.toLowerCase();if (v(b, "opera/") || v(b, "opr/") || v(b, "opios/")) return "Opera";if (v(b, "iemobile")) return "IEMobile";if (v(b, "msie") || v(b, "trident/")) return "IE";if (v(b, "edge/")) return "Edge";if (v(b, "firefox/")) return Ef;if (v(b, "silk/")) return "Silk";if (v(b, "blackberry")) return "Blackberry";if (v(b, "webos")) return "Webos";if (!v(b, "safari/") || v(b, "chrome/") || v(b, "crios/") || v(b, "android")) {
      if (!v(b, "chrome/") && !v(b, "crios/") || v(b, "edge/")) {
        if (v(b, "android")) return "Android";if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
      } else return Af;
    } else return "Safari";return "Other";
  }var Nf = { Cc: "FirebaseCore-web", Ec: "FirebaseUI-web" };function Of(a, b) {
    b = b || [];var c = [],
        d = {},
        e;for (e in Nf) {
      d[Nf[e]] = !0;
    }for (e = 0; e < b.length; e++) {
      "undefined" !== typeof d[b[e]] && (delete d[b[e]], c.push(b[e]));
    }c.sort();b = c;b.length || (b = ["FirebaseCore-web"]);c = K();d = "";"Browser" === c ? d = zf(J()) : d = c;return d + "/JsCore/" + a + "/" + b.join(",");
  }function J() {
    return k.navigator && k.navigator.userAgent || "";
  }
  function L(a, b) {
    a = a.split(".");b = b || k;for (var c = 0; c < a.length && "object" == typeof b && null != b; c++) {
      b = b[a[c]];
    }c != a.length && (b = void 0);return b;
  }function Pf() {
    try {
      var a = k.localStorage,
          b = Qf();if (a) return a.setItem(b, "1"), a.removeItem(b), uf() ? !!k.indexedDB : !0;
    } catch (c) {}return !1;
  }function Rf() {
    return (Sf() || "chrome-extension:" === Kf() || Jf()) && !Mf() && Pf();
  }function Sf() {
    return "http:" === Kf() || "https:" === Kf();
  }function Kf() {
    return k.location && k.location.protocol || null;
  }
  function Tf(a) {
    a = a || J();return Bf(a) || zf(a) == Ef ? !1 : !0;
  }function Uf(a) {
    return "undefined" === typeof a ? null : Cc(a);
  }function Vf(a) {
    var b = {},
        c;for (c in a) {
      a.hasOwnProperty(c) && null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
    }return b;
  }function Wf(a) {
    if (null !== a) return JSON.parse(a);
  }function Qf(a) {
    return a ? a : "" + Math.floor(1E9 * Math.random()).toString();
  }function Xf(a) {
    a = a || J();return "Safari" == zf(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0;
  }
  function Yf() {
    var a = k.___jsl;if (a && a.H) for (var b in a.H) {
      if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for (var c = 0; c < a.CP.length; c++) {
        a.CP[c] = null;
      }
    }
  }function Zf() {
    var a = k.navigator;return a && "boolean" === typeof a.onLine && (Sf() || "chrome-extension:" === Kf() || "undefined" !== typeof a.connection) ? a.onLine : !0;
  }function $f(a, b, c, d) {
    if (a > b) throw Error("Short delay should be less than long delay!");this.c = a;this.b = b;a = c || J();d = d || K();this.a = Bf(a) || "ReactNative" === d;
  }
  $f.prototype.get = function () {
    return this.a ? this.b : this.c;
  };function ag() {
    var a = k.document;return a && "undefined" !== typeof a.visibilityState ? "visible" == a.visibilityState : !0;
  }function bg() {
    var a = k.document,
        _b = null;return ag() || !a ? A() : new z(function (c) {
      _b = function b() {
        ag() && (a.removeEventListener("visibilitychange", _b, !1), c());
      };a.addEventListener("visibilitychange", _b, !1);
    }).s(function (c) {
      a.removeEventListener("visibilitychange", _b, !1);throw c;
    });
  }
  function cg(a) {
    try {
      var b = new Date(parseInt(a, 10));if (!isNaN(b.getTime()) && !/[^0-9]/.test(a)) return b.toUTCString();
    } catch (c) {}return null;
  };var dg = {};var eg;try {
    var fg = {};Object.defineProperty(fg, "abcd", { configurable: !0, enumerable: !0, value: 1 });Object.defineProperty(fg, "abcd", { configurable: !0, enumerable: !0, value: 2 });eg = 2 == fg.abcd;
  } catch (a) {
    eg = !1;
  }function M(a, b, c) {
    eg ? Object.defineProperty(a, b, { configurable: !0, enumerable: !0, value: c }) : a[b] = c;
  }function gg(a, b) {
    if (b) for (var c in b) {
      b.hasOwnProperty(c) && M(a, c, b[c]);
    }
  }function hg(a) {
    var b = {};gg(b, a);return b;
  }function ig(a) {
    var b = {},
        c;for (c in a) {
      a.hasOwnProperty(c) && (b[c] = a[c]);
    }return b;
  }
  function jg(a, b) {
    if (!b || !b.length) return !0;if (!a) return !1;for (var c = 0; c < b.length; c++) {
      var d = a[b[c]];if (void 0 === d || null === d || "" === d) return !1;
    }return !0;
  }function kg(a) {
    var b = a;if ("object" == typeof a && null != a) {
      b = "length" in a ? [] : {};for (var c in a) {
        M(b, c, kg(a[c]));
      }
    }return b;
  };function lg(a) {
    var b = {},
        c = a[mg],
        d = a[ng];a = a[og];if (!c || !a) throw Error("Invalid provider user info!");b[pg] = d || null;b[qg] = c;M(this, rg, a);M(this, sg, kg(b));
  }var mg = "email",
      ng = "newEmail",
      og = "requestType",
      qg = "email",
      pg = "fromEmail",
      sg = "data",
      rg = "operation";function N(a, b) {
    this.code = tg + a;this.message = b || ug[a] || "";
  }t(N, Error);N.prototype.B = function () {
    return { code: this.code, message: this.message };
  };N.prototype.toJSON = function () {
    return this.B();
  };function vg(a) {
    var b = a && a.code;return b ? new N(b.substring(tg.length), a.message) : null;
  }
  var tg = "auth/",
      ug = { "argument-error": "", "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.", "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.", "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
    "code-expired": "The SMS code has expired. Please re-send the verification code to try again.", "cordova-not-ready": "Cordova framework is not ready.", "cors-unsupported": "This browser is not supported.", "credential-already-in-use": "This credential is already associated with a different user account.", "custom-token-mismatch": "The custom token corresponds to a different audience.", "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
    "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.", "email-already-in-use": "The email address is already in use by another account.", "expired-action-code": "The action code has expired. ", "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.", "internal-error": "An internal error has occurred.", "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
    "invalid-app-id": "The mobile app identifier is not registed for the current project.", "invalid-user-token": "The user's credential is no longer valid. The user must sign in again.", "invalid-auth-event": "An internal error has occurred.", "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.", "invalid-continue-uri": "The continue URL provided in the request is invalid.",
    "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.", "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.", "invalid-email": "The email address is badly formatted.", "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.", "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
    "invalid-credential": "The supplied auth credential is malformed or has expired.", "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.", "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.", "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
    "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.", "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.", "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.", "wrong-password": "The password is invalid or the user does not have a password.", "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
    "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.", "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.", "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.", "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
    "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.", "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.", "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.", "missing-continue-uri": "A continue URL must be provided in the request.", "missing-iframe-start": "An internal error has occurred.",
    "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.", "missing-phone-number": "To send verification codes, provide a phone number for the recipient.", "missing-verification-id": "The phone auth credential was created with an empty verification ID.", "app-deleted": "This instance of FirebaseApp has been deleted.", "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
    "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.", "no-auth-event": "An internal error has occurred.", "no-such-provider": "User was not linked to an account with the given provider.", "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.", "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
    "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.", "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.", "provider-already-linked": "User can only be linked to one identity for the given provider.", "quota-exceeded": "The project's quota for this operation has been exceeded.", "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.", "redirect-operation-pending": "A redirect sign-in operation is already pending.",
    timeout: "The operation has timed out.", "user-token-expired": "The user's credential is no longer valid. The user must sign in again.", "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.", "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.", "unsupported-persistence-type": "The current environment does not support the specified persistence type.", "user-cancelled": "User did not grant your application the permissions it requested.",
    "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.", "user-disabled": "The user account has been disabled by an administrator.", "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.", "user-signed-out": "", "weak-password": "The password must be 6 characters long or more.", "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled." };function wg(a) {
    var b = a[xg];if ("undefined" === typeof b) throw new N("missing-continue-uri");if ("string" !== typeof b || "string" === typeof b && !b.length) throw new N("invalid-continue-uri");this.h = b;this.c = this.a = null;this.g = !1;var c = a[yg];if (c && "object" === typeof c) {
      b = c[zg];var d = c[Ag];c = c[Bg];if ("string" === typeof b && b.length) {
        this.a = b;if ("undefined" !== typeof d && "boolean" !== typeof d) throw new N("argument-error", Ag + " property must be a boolean when specified.");this.g = !!d;if ("undefined" !== typeof c && ("string" !== typeof c || "string" === typeof c && !c.length)) throw new N("argument-error", Bg + " property must be a non empty string when specified.");this.c = c || null;
      } else {
        if ("undefined" !== typeof b) throw new N("argument-error", zg + " property must be a non empty string when specified.");if ("undefined" !== typeof d || "undefined" !== typeof c) throw new N("missing-android-pkg-name");
      }
    } else if ("undefined" !== typeof c) throw new N("argument-error", yg + " property must be a non null object when specified.");this.b = null;if ((b = a[Cg]) && "object" === typeof b) {
      if (b = b[Dg], "string" === typeof b && b.length) this.b = b;else {
        if ("undefined" !== typeof b) throw new N("argument-error", Dg + " property must be a non empty string when specified.");
      }
    } else if ("undefined" !== typeof b) throw new N("argument-error", Cg + " property must be a non null object when specified.");a = a[Eg];if ("undefined" !== typeof a && "boolean" !== typeof a) throw new N("argument-error", Eg + " property must be a boolean when specified.");if ((this.f = !!a) && !this.b && !this.a) throw new N("argument-error", Eg + " property can't be true when no mobile application is provided.");
  }var yg = "android",
      Eg = "handleCodeInApp",
      Cg = "iOS",
      xg = "url",
      Ag = "installApp",
      Bg = "minimumVersion",
      zg = "packageName",
      Dg = "bundleId";function Fg(a) {
    var b = {};b.continueUrl = a.h;b.canHandleCodeInApp = a.f;if (b.androidPackageName = a.a) b.androidMinimumVersion = a.c, b.androidInstallApp = a.g;b.iOSBundleId = a.b;for (var c in b) {
      null === b[c] && delete b[c];
    }return b;
  };function Gg(a) {
    this.b = a.sub;na();this.a = a.provider_id || a.firebase && a.firebase.sign_in_provider || null;
  }function Hg(a) {
    a = a.split(".");if (3 != a.length) return null;a = a[1];for (var b = (4 - a.length % 4) % 4, c = 0; c < b; c++) {
      a += ".";
    }try {
      var d = JSON.parse(Kd(a));if (d.sub && d.iss && d.aud && d.exp) return new Gg(d);
    } catch (e) {}return null;
  };var Ig = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),
      Jg = ["client_id", "response_type", "scope", "redirect_uri", "state"],
      Kg = { Dc: { Ma: "locale", za: 500, ya: 600, Na: "facebook.com", $a: Jg }, Fc: { Ma: null, za: 500, ya: 620, Na: "github.com", $a: Jg }, Gc: { Ma: "hl", za: 515, ya: 680, Na: "google.com", $a: Jg }, Mc: { Ma: "lang", za: 485, ya: 705, Na: "twitter.com", $a: Ig } };function Lg(a) {
    for (var b in Kg) {
      if (Kg[b].Na == a) return Kg[b];
    }return null;
  };function Mg(a) {
    var b = {};b["facebook.com"] = Ng;b["google.com"] = Og;b["github.com"] = Pg;b["twitter.com"] = Qg;var c = a && a[Rg];try {
      if (c) return b[c] ? new b[c](a) : new Sg(a);if ("undefined" !== typeof a[Tg]) return new Ug(a);
    } catch (d) {}return null;
  }var Tg = "idToken",
      Rg = "providerId";function Ug(a) {
    var b = a[Rg];if (!b && a[Tg]) {
      var c = Hg(a[Tg]);c && c.a && (b = c.a);
    }if (!b) throw Error("Invalid additional user info!");a = !!a.isNewUser;M(this, "providerId", b);M(this, "isNewUser", a);
  }
  function Sg(a) {
    Ug.call(this, a);a = Wf(a.rawUserInfo || "{}");M(this, "profile", kg(a || {}));
  }t(Sg, Ug);function Ng(a) {
    Sg.call(this, a);if ("facebook.com" != this.providerId) throw Error("Invalid provider ID!");
  }t(Ng, Sg);function Pg(a) {
    Sg.call(this, a);if ("github.com" != this.providerId) throw Error("Invalid provider ID!");M(this, "username", this.profile && this.profile.login || null);
  }t(Pg, Sg);function Og(a) {
    Sg.call(this, a);if ("google.com" != this.providerId) throw Error("Invalid provider ID!");
  }t(Og, Sg);
  function Qg(a) {
    Sg.call(this, a);if ("twitter.com" != this.providerId) throw Error("Invalid provider ID!");M(this, "username", a.screenName || null);
  }t(Qg, Sg);function Vg(a, b) {
    return a.then(function (a) {
      if (a[_O]) {
        var c = Hg(a[_O]);if (!c || b != c.b) throw new N("user-mismatch");return a;
      }throw new N("user-mismatch");
    }).s(function (a) {
      throw a && a.code && a.code == tg + "user-not-found" ? new N("user-mismatch") : a;
    });
  }
  function Wg(a, b) {
    if (b.idToken || b.accessToken) b.idToken && M(this, "idToken", b.idToken), b.accessToken && M(this, "accessToken", b.accessToken);else if (b.oauthToken && b.oauthTokenSecret) M(this, "accessToken", b.oauthToken), M(this, "secret", b.oauthTokenSecret);else throw new N("internal-error", "failed to construct a credential");M(this, "providerId", a);
  }Wg.prototype.wa = function (a) {
    return Xg(a, Yg(this));
  };Wg.prototype.b = function (a, b) {
    var c = Yg(this);c.idToken = b;return Zg(a, c);
  };
  Wg.prototype.c = function (a, b) {
    var c = Yg(this);return Vg($g(a, c), b);
  };function Yg(a) {
    var b = {};a.idToken && (b.id_token = a.idToken);a.accessToken && (b.access_token = a.accessToken);a.secret && (b.oauth_token_secret = a.secret);b.providerId = a.providerId;return { postBody: Ie(b).toString(), requestUri: "http://localhost" };
  }
  Wg.prototype.B = function () {
    var a = { providerId: this.providerId };this.idToken && (a.oauthIdToken = this.idToken);this.accessToken && (a.oauthAccessToken = this.accessToken);this.secret && (a.oauthTokenSecret = this.secret);return a;
  };function ah(a, b) {
    this.nc = b || [];gg(this, { providerId: a, isOAuthProvider: !0 });this.qb = {};this.Wa = (Lg(a) || {}).Ma || null;this.Ua = null;
  }ah.prototype.Ba = function (a) {
    this.qb = Ua(a);return this;
  };function P(a) {
    ah.call(this, a, Jg);this.a = [];
  }t(P, ah);
  P.prototype.sa = function (a) {
    Ha(this.a, a) || this.a.push(a);return this;
  };P.prototype.vb = function () {
    return La(this.a);
  };P.prototype.credential = function (a, b) {
    if (!a && !b) throw new N("argument-error", "credential failed: must provide the ID token and/or the access token.");return new Wg(this.providerId, { idToken: a || null, accessToken: b || null });
  };function bh() {
    P.call(this, "facebook.com");
  }t(bh, P);M(bh, "PROVIDER_ID", "facebook.com");
  function ch(a) {
    if (!a) throw new N("argument-error", "credential failed: expected 1 argument (the OAuth access token).");var b = a;q(a) && (b = a.accessToken);return new bh().credential(null, b);
  }function dh() {
    P.call(this, "github.com");
  }t(dh, P);M(dh, "PROVIDER_ID", "github.com");function eh(a) {
    if (!a) throw new N("argument-error", "credential failed: expected 1 argument (the OAuth access token).");var b = a;q(a) && (b = a.accessToken);return new dh().credential(null, b);
  }
  function fh() {
    P.call(this, "google.com");this.sa("profile");
  }t(fh, P);M(fh, "PROVIDER_ID", "google.com");function gh(a, b) {
    var c = a;q(a) && (c = a.idToken, b = a.accessToken);return new fh().credential(c, b);
  }function hh() {
    ah.call(this, "twitter.com", Ig);
  }t(hh, ah);M(hh, "PROVIDER_ID", "twitter.com");
  function ih(a, b) {
    var c = a;q(c) || (c = { oauthToken: a, oauthTokenSecret: b });if (!c.oauthToken || !c.oauthTokenSecret) throw new N("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");return new Wg("twitter.com", c);
  }function jh(a, b) {
    this.a = a;this.f = b;M(this, "providerId", "password");
  }jh.prototype.wa = function (a) {
    return Q(a, kh, { email: this.a, password: this.f });
  };jh.prototype.b = function (a, b) {
    return Q(a, lh, { idToken: b, email: this.a, password: this.f });
  };
  jh.prototype.c = function (a, b) {
    return Vg(this.wa(a), b);
  };jh.prototype.B = function () {
    return { email: this.a, password: this.f };
  };function mh() {
    gg(this, { providerId: "password", isOAuthProvider: !1 });
  }gg(mh, { PROVIDER_ID: "password" });function nh(a) {
    if (!(a.Pa && a.Oa || a.Da && a.Y)) throw new N("internal-error");this.a = a;M(this, "providerId", "phone");
  }nh.prototype.wa = function (a) {
    return a.Qa(oh(this));
  };nh.prototype.b = function (a, b) {
    var c = oh(this);c.idToken = b;return Q(a, ph, c);
  };
  nh.prototype.c = function (a, b) {
    var c = oh(this);c.operation = "REAUTH";a = Q(a, qh, c);return Vg(a, b);
  };nh.prototype.B = function () {
    var a = { providerId: "phone" };this.a.Pa && (a.verificationId = this.a.Pa);this.a.Oa && (a.verificationCode = this.a.Oa);this.a.Da && (a.temporaryProof = this.a.Da);this.a.Y && (a.phoneNumber = this.a.Y);return a;
  };function oh(a) {
    return a.a.Da && a.a.Y ? { temporaryProof: a.a.Da, phoneNumber: a.a.Y } : { sessionInfo: a.a.Pa, code: a.a.Oa };
  }
  function rh(a) {
    try {
      this.a = a || firebase.auth();
    } catch (b) {
      throw new N("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
    }gg(this, { providerId: "phone", isOAuthProvider: !1 });
  }
  rh.prototype.Qa = function (a, b) {
    var c = this.a.c;return A(b.verify()).then(function (d) {
      if (!m(d)) throw new N("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch (b.type) {case "recaptcha":
          return sh(c, { phoneNumber: a, recaptchaToken: d }).then(function (a) {
            "function" === typeof b.reset && b.reset();return a;
          }, function (a) {
            "function" === typeof b.reset && b.reset();throw a;
          });default:
          throw new N("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}
    });
  };function th(a, b) {
    if (!a) throw new N("missing-verification-id");if (!b) throw new N("missing-verification-code");return new nh({ Pa: a, Oa: b });
  }gg(rh, { PROVIDER_ID: "phone" });
  function uh(a) {
    if (a.temporaryProof && a.phoneNumber) return new nh({ Da: a.temporaryProof, Y: a.phoneNumber });var b = a && a.providerId;if (!b || "password" === b) return null;var c = a && a.oauthAccessToken,
        d = a && a.oauthTokenSecret;a = a && a.oauthIdToken;try {
      switch (b) {case "google.com":
          return gh(a, c);case "facebook.com":
          return ch(c);case "github.com":
          return eh(c);case "twitter.com":
          return ih(c, d);default:
          return new P(b).credential(a, c);}
    } catch (e) {
      return null;
    }
  }
  function vh(a) {
    if (!a.isOAuthProvider) throw new N("invalid-oauth-provider");
  };function wh(a, b, c, d, e) {
    this.b = a;this.c = b || null;this.f = c || null;this.g = d || null;this.a = e || null;if (this.f || this.a) {
      if (this.f && this.a) throw new N("invalid-auth-event");if (this.f && !this.g) throw new N("invalid-auth-event");
    } else throw new N("invalid-auth-event");
  }wh.prototype.B = function () {
    return { type: this.b, eventId: this.c, urlResponse: this.f, sessionId: this.g, error: this.a && this.a.B() };
  };function xh(a) {
    a = a || {};return a.type ? new wh(a.type, a.eventId, a.urlResponse, a.sessionId, a.error && vg(a.error)) : null;
  };function yh(a) {
    var b = "unauthorized-domain",
        c = void 0,
        d = De(a);a = d.b;d = d.c;"chrome-extension" == d ? c = oa("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : "http" == d || "https" == d ? c = oa("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : b = "operation-not-supported-in-this-environment";
    N.call(this, b, c);
  }t(yh, N);function zh(a, b, c) {
    N.call(this, a, c);a = b || {};a.rb && M(this, "email", a.rb);a.Y && M(this, "phoneNumber", a.Y);a.credential && M(this, "credential", a.credential);
  }t(zh, N);zh.prototype.B = function () {
    var a = { code: this.code, message: this.message };this.email && (a.email = this.email);this.phoneNumber && (a.phoneNumber = this.phoneNumber);var b = this.credential && this.credential.B();b && Wa(a, b);return a;
  };zh.prototype.toJSON = function () {
    return this.B();
  };
  function Ah(a) {
    if (a.code) {
      var b = a.code || "";0 == b.indexOf(tg) && (b = b.substring(tg.length));var c = { credential: uh(a) };if (a.email) c.rb = a.email;else if (a.phoneNumber) c.Y = a.phoneNumber;else return new N(b, a.message || void 0);return new zh(b, c, a.message);
    }return null;
  };function Bh(a) {
    this.f = a;
  }t(Bh, Ne);Bh.prototype.a = function () {
    return new this.f();
  };Bh.prototype.b = function () {
    return {};
  };
  function Ch(a, b, c) {
    var d = "Node" == K();d = k.XMLHttpRequest || d && firebase.INTERNAL.node && firebase.INTERNAL.node.XMLHttpRequest;if (!d) throw new N("internal-error", "The XMLHttpRequest compatibility library was not found.");this.b = a;a = b || {};this.i = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";this.l = a.secureTokenTimeout || Dh;this.c = Ua(a.secureTokenHeaders || Eh);this.g = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h = a.firebaseTimeout || Fh;this.a = Ua(a.firebaseHeaders || Gh);c && (this.a["X-Client-Version"] = c, this.c["X-Client-Version"] = c);this.f = new rf();this.o = new Bh(d);
  }var Hh,
      _O = "idToken",
      Dh = new $f(3E4, 6E4),
      Eh = { "Content-Type": "application/x-www-form-urlencoded" },
      Fh = new $f(3E4, 6E4),
      Gh = { "Content-Type": "application/json" };function Ih(a, b) {
    b ? a.a["X-Firebase-Locale"] = b : delete a.a["X-Firebase-Locale"];
  }function Jh(a, b) {
    b ? (a.a["X-Client-Version"] = b, a.c["X-Client-Version"] = b) : (delete a.a["X-Client-Version"], delete a.c["X-Client-Version"]);
  }
  function Kh(a, b, c, d, e, f, g) {
    Zf() ? (yf() ? a = r(a.m, a) : (Hh || (Hh = new z(function (a, b) {
      Lh(a, b);
    })), a = r(a.u, a)), a(b, c, d, e, f, g)) : c && c(null);
  }
  Ch.prototype.m = function (a, b, c, d, e, f) {
    var g = "Node" == K(),
        l = Mf() ? g ? new Se(this.o) : new Se() : new Se(this.f);if (f) {
      l.f = Math.max(0, f);var n = setTimeout(function () {
        G(l, "timeout");
      }, f);
    }fd(l, "complete", function () {
      n && clearTimeout(n);var a = null;try {
        a = JSON.parse(hf(this)) || null;
      } catch (vb) {
        a = null;
      }b && b(a);
    });ld(l, "ready", function () {
      n && clearTimeout(n);Lc(this);
    });ld(l, "timeout", function () {
      n && clearTimeout(n);Lc(this);b && b(null);
    });Ye(l, a, c, d, e);
  };
  var Mh = dc("https://apis.google.com/js/client.js?onload=%{onload}"),
      Nh = "__fcb" + Math.floor(1E6 * Math.random()).toString();function Lh(a, b) {
    if (((window.gapi || {}).client || {}).request) a();else {
      k[Nh] = function () {
        ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
      };var c = hc(Mh, { onload: Nh });Td(kf(c), function () {
        b(Error("CORS_UNSUPPORTED"));
      });
    }
  }
  Ch.prototype.u = function (a, b, c, d, e) {
    var f = this;Hh.then(function () {
      window.gapi.client.setApiKey(f.b);var g = window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({ path: a, method: c, body: d, headers: e, authType: "none", callback: function callback(a) {
          window.gapi.auth.setToken(g);b && b(a);
        } });
    }).s(function (a) {
      b && b({ error: { message: a && a.message || "CORS_UNSUPPORTED" } });
    });
  };
  function Oh(a, b) {
    return new z(function (c, d) {
      "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? Kh(a, a.i + "?key=" + encodeURIComponent(a.b), function (a) {
        a ? a.error ? d(Ph(a)) : a.access_token && a.refresh_token ? c(a) : d(new N("internal-error")) : d(new N("network-request-failed"));
      }, "POST", Ie(b).toString(), a.c, a.l.get()) : d(new N("internal-error"));
    });
  }
  function Qh(a, b, c, d, e, f) {
    var g = De(a.g + b);I(g, "key", a.b);f && I(g, "cb", na().toString());var l = "GET" == c;if (l) for (var n in d) {
      d.hasOwnProperty(n) && I(g, n, d[n]);
    }return new z(function (b, f) {
      Kh(a, g.toString(), function (a) {
        a ? a.error ? f(Ph(a, e || {})) : b(a) : f(new N("network-request-failed"));
      }, c, l ? void 0 : Cc(Vf(d)), a.a, a.h.get());
    });
  }function Rh(a) {
    if (!jf.test(a.email)) throw new N("invalid-email");
  }function Sh(a) {
    "email" in a && Rh(a);
  }
  function Th(a, b) {
    return Q(a, Uh, { identifier: b, continueUri: Sf() ? vf() : "http://localhost" }).then(function (a) {
      return a.allProviders || [];
    });
  }function Vh(a) {
    return Q(a, Wh, {}).then(function (a) {
      return a.authorizedDomains || [];
    });
  }function Xh(a) {
    if (!a[_O]) throw new N("internal-error");
  }
  function Yh(a) {
    if (a.phoneNumber || a.temporaryProof) {
      if (!a.phoneNumber || !a.temporaryProof) throw new N("internal-error");
    } else {
      if (!a.sessionInfo) throw new N("missing-verification-id");if (!a.code) throw new N("missing-verification-code");
    }
  }Ch.prototype.gb = function () {
    return Q(this, Zh, {});
  };Ch.prototype.kb = function (a, b) {
    return Q(this, $h, { idToken: a, email: b });
  };Ch.prototype.lb = function (a, b) {
    return Q(this, lh, { idToken: a, password: b });
  };var ai = { displayName: "DISPLAY_NAME", photoUrl: "PHOTO_URL" };h = Ch.prototype;
  h.mb = function (a, b) {
    var c = { idToken: a },
        d = [];Pa(ai, function (a, f) {
      var e = b[f];null === e ? d.push(a) : f in b && (c[f] = e);
    });d.length && (c.deleteAttribute = d);return Q(this, $h, c);
  };h.cb = function (a, b) {
    a = { requestType: "PASSWORD_RESET", email: a };Wa(a, b);return Q(this, bi, a);
  };h.bb = function (a, b) {
    a = { requestType: "VERIFY_EMAIL", idToken: a };Wa(a, b);return Q(this, ci, a);
  };function sh(a, b) {
    return Q(a, di, b);
  }h.Qa = function (a) {
    return Q(this, ei, a);
  };function fi(a, b, c) {
    return Q(a, gi, { idToken: b, deleteProvider: c });
  }
  function hi(a) {
    if (!a.requestUri || !a.sessionId && !a.postBody) throw new N("internal-error");
  }function ii(a) {
    var b = null;a.needConfirmation ? (a.code = "account-exists-with-different-credential", b = Ah(a)) : "FEDERATED_USER_ID_ALREADY_LINKED" == a.errorMessage ? (a.code = "credential-already-in-use", b = Ah(a)) : "EMAIL_EXISTS" == a.errorMessage ? (a.code = "email-already-in-use", b = Ah(a)) : a.errorMessage && (b = ji(a.errorMessage));if (b) throw b;if (!a[_O]) throw new N("internal-error");
  }
  function Xg(a, b) {
    b.returnIdpCredential = !0;return Q(a, ki, b);
  }function Zg(a, b) {
    b.returnIdpCredential = !0;return Q(a, li, b);
  }function $g(a, b) {
    b.returnIdpCredential = !0;b.autoCreate = !1;return Q(a, mi, b);
  }function ni(a) {
    if (!a.oobCode) throw new N("invalid-action-code");
  }h.Ta = function (a, b) {
    return Q(this, oi, { oobCode: a, newPassword: b });
  };h.Ia = function (a) {
    return Q(this, pi, { oobCode: a });
  };h.Sa = function (a) {
    return Q(this, qi, { oobCode: a });
  };
  var qi = { endpoint: "setAccountInfo", D: ni, ga: "email" },
      pi = { endpoint: "resetPassword", D: ni, O: function O(a) {
      if (!a.email || !a.requestType) throw new N("internal-error");
    } },
      ri = { endpoint: "signupNewUser", D: function D(a) {
      Rh(a);if (!a.password) throw new N("weak-password");
    }, O: Xh, T: !0 },
      Uh = { endpoint: "createAuthUri" },
      si = { endpoint: "deleteAccount", ea: ["idToken"] },
      gi = { endpoint: "setAccountInfo", ea: ["idToken", "deleteProvider"], D: function D(a) {
      if (!fa(a.deleteProvider)) throw new N("internal-error");
    } },
      ti = { endpoint: "getAccountInfo" },
      ci = { endpoint: "getOobConfirmationCode", ea: ["idToken", "requestType"], D: function D(a) {
      if ("VERIFY_EMAIL" != a.requestType) throw new N("internal-error");
    }, ga: "email" },
      bi = { endpoint: "getOobConfirmationCode", ea: ["requestType"], D: function D(a) {
      if ("PASSWORD_RESET" != a.requestType) throw new N("internal-error");Rh(a);
    }, ga: "email" },
      Wh = { nb: !0, endpoint: "getProjectConfig", yb: "GET" },
      ui = { nb: !0, endpoint: "getRecaptchaParam", yb: "GET", O: function O(a) {
      if (!a.recaptchaSiteKey) throw new N("internal-error");
    } },
      oi = { endpoint: "resetPassword",
    D: ni, ga: "email" },
      di = { endpoint: "sendVerificationCode", ea: ["phoneNumber", "recaptchaToken"], ga: "sessionInfo" },
      $h = { endpoint: "setAccountInfo", ea: ["idToken"], D: Sh, T: !0 },
      lh = { endpoint: "setAccountInfo", ea: ["idToken"], D: function D(a) {
      Sh(a);if (!a.password) throw new N("weak-password");
    }, O: Xh, T: !0 },
      Zh = { endpoint: "signupNewUser", O: Xh, T: !0 },
      ki = { endpoint: "verifyAssertion", D: hi, O: ii, T: !0 },
      mi = { endpoint: "verifyAssertion", D: hi, O: function O(a) {
      if (a.errorMessage && "USER_NOT_FOUND" == a.errorMessage) throw new N("user-not-found");
      if (a.errorMessage) throw ji(a.errorMessage);if (!a[_O]) throw new N("internal-error");
    }, T: !0 },
      li = { endpoint: "verifyAssertion", D: function D(a) {
      hi(a);if (!a.idToken) throw new N("internal-error");
    }, O: ii, T: !0 },
      vi = { endpoint: "verifyCustomToken", D: function D(a) {
      if (!a.token) throw new N("invalid-custom-token");
    }, O: Xh, T: !0 },
      kh = { endpoint: "verifyPassword", D: function D(a) {
      Rh(a);if (!a.password) throw new N("wrong-password");
    }, O: Xh, T: !0 },
      ei = { endpoint: "verifyPhoneNumber", D: Yh, O: Xh },
      ph = { endpoint: "verifyPhoneNumber", D: function D(a) {
      if (!a.idToken) throw new N("internal-error");
      Yh(a);
    }, O: function O(a) {
      if (a.temporaryProof) throw a.code = "credential-already-in-use", Ah(a);Xh(a);
    } },
      qh = { Lb: { USER_NOT_FOUND: "user-not-found" }, endpoint: "verifyPhoneNumber", D: Yh, O: Xh };
  function Q(a, b, c) {
    if (!jg(c, b.ea)) return B(new N("internal-error"));var d = b.yb || "POST",
        e;return A(c).then(b.D).then(function () {
      b.T && (c.returnSecureToken = !0);return Qh(a, b.endpoint, d, c, b.Lb, b.nb || !1);
    }).then(function (a) {
      return e = a;
    }).then(b.O).then(function () {
      if (!b.ga) return e;if (!(b.ga in e)) throw new N("internal-error");return e[b.ga];
    });
  }function ji(a) {
    return Ph({ error: { errors: [{ message: a }], code: 400, message: a } });
  }
  function Ph(a, b) {
    var c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";var d = { keyInvalid: "invalid-api-key", ipRefererBlocked: "app-not-authorized" };if (c = d[c] ? new N(d[c]) : null) return c;c = a.error && a.error.message || "";d = { INVALID_CUSTOM_TOKEN: "invalid-custom-token", CREDENTIAL_MISMATCH: "custom-token-mismatch", MISSING_CUSTOM_TOKEN: "internal-error", INVALID_IDENTIFIER: "invalid-email", MISSING_CONTINUE_URI: "internal-error", INVALID_EMAIL: "invalid-email", INVALID_PASSWORD: "wrong-password", USER_DISABLED: "user-disabled",
      MISSING_PASSWORD: "internal-error", EMAIL_EXISTS: "email-already-in-use", PASSWORD_LOGIN_DISABLED: "operation-not-allowed", INVALID_IDP_RESPONSE: "invalid-credential", FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use", INVALID_MESSAGE_PAYLOAD: "invalid-message-payload", INVALID_RECIPIENT_EMAIL: "invalid-recipient-email", INVALID_SENDER: "invalid-sender", EMAIL_NOT_FOUND: "user-not-found", EXPIRED_OOB_CODE: "expired-action-code", INVALID_OOB_CODE: "invalid-action-code", MISSING_OOB_CODE: "internal-error", CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
      INVALID_ID_TOKEN: "invalid-user-token", TOKEN_EXPIRED: "user-token-expired", USER_NOT_FOUND: "user-token-expired", CORS_UNSUPPORTED: "cors-unsupported", DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated", INVALID_APP_ID: "invalid-app-id", TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests", WEAK_PASSWORD: "weak-password", OPERATION_NOT_ALLOWED: "operation-not-allowed", USER_CANCELLED: "user-cancelled", CAPTCHA_CHECK_FAILED: "captcha-check-failed", INVALID_APP_CREDENTIAL: "invalid-app-credential", INVALID_CODE: "invalid-verification-code",
      INVALID_PHONE_NUMBER: "invalid-phone-number", INVALID_SESSION_INFO: "invalid-verification-id", INVALID_TEMPORARY_PROOF: "invalid-credential", MISSING_APP_CREDENTIAL: "missing-app-credential", MISSING_CODE: "missing-verification-code", MISSING_PHONE_NUMBER: "missing-phone-number", MISSING_SESSION_INFO: "missing-verification-id", QUOTA_EXCEEDED: "quota-exceeded", SESSION_EXPIRED: "code-expired", INVALID_CONTINUE_URI: "invalid-continue-uri", MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name", MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
      UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri", INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id", INVALID_CERT_HASH: "invalid-cert-hash" };Wa(d, b || {});b = (b = c.match(/^[^\s]+\s*:\s*(.*)$/)) && 1 < b.length ? b[1] : void 0;for (var e in d) {
      if (0 === c.indexOf(e)) return new N(d[e], b);
    }!b && a && (b = Uf(a));return new N("internal-error", b);
  };var wi = { Ic: { Va: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/", ab: "https://securetoken.googleapis.com/v1/token", id: "p" }, Kc: { Va: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/", ab: "https://staging-securetoken.sandbox.googleapis.com/v1/token", id: "s" }, Lc: { Va: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/", ab: "https://test-securetoken.sandbox.googleapis.com/v1/token", id: "t" } };
  function xi(a) {
    for (var b in wi) {
      if (wi[b].id === a) return a = wi[b], { firebaseEndpoint: a.Va, secureTokenEndpoint: a.ab };
    }return null;
  }var yi;yi = xi("__EID__") ? "__EID__" : void 0;function zi(a) {
    this.b = a;this.a = null;this.Ya = Ai(this);
  }
  function Ai(a) {
    return Bi().then(function () {
      return new z(function (b, c) {
        L("gapi.iframes.getContext")().open({ where: document.body, url: a.b, messageHandlersFilter: L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"), attributes: { style: { position: "absolute", top: "-100px", width: "1px", height: "1px" } }, dontclear: !0 }, function (d) {
          function e() {
            clearTimeout(f);b();
          }a.a = d;a.a.restyle({ setHideOnLeave: !1 });var f = setTimeout(function () {
            c(Error("Network Error"));
          }, Ci.get());d.ping(e).then(e, function () {
            c(Error("Network Error"));
          });
        });
      });
    });
  }
  function Di(a, b) {
    return a.Ya.then(function () {
      return new z(function (c) {
        a.a.send(b.type, b, c, L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
      });
    });
  }function Ei(a, b) {
    a.Ya.then(function () {
      a.a.register("authEvent", b, L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
    });
  }var Fi = dc("https://apis.google.com/js/api.js?onload=%{onload}"),
      Gi = new $f(3E4, 6E4),
      Ci = new $f(5E3, 15E3),
      Hi = null;
  function Bi() {
    return Hi ? Hi : Hi = new z(function (a, b) {
      if (Zf()) {
        var c = function c() {
          Yf();L("gapi.load")("gapi.iframes", { callback: a, ontimeout: function ontimeout() {
              Yf();b(Error("Network Error"));
            }, timeout: Gi.get() });
        };if (L("gapi.iframes.Iframe")) a();else if (L("gapi.load")) c();else {
          var d = "__iframefcb" + Math.floor(1E6 * Math.random()).toString();k[d] = function () {
            L("gapi.load") ? c() : b(Error("Network Error"));
          };d = hc(Fi, { onload: d });A(kf(d)).s(function () {
            b(Error("Network Error"));
          });
        }
      } else b(Error("Network Error"));
    }).s(function (a) {
      Hi = null;throw a;
    });
  };function Ii(a, b, c) {
    this.i = a;this.g = b;this.h = c;this.f = null;this.a = Ee(this.i, "/__/auth/iframe");I(this.a, "apiKey", this.g);I(this.a, "appName", this.h);this.b = null;this.c = [];
  }Ii.prototype.toString = function () {
    this.f ? I(this.a, "v", this.f) : Le(this.a.a, "v");this.b ? I(this.a, "eid", this.b) : Le(this.a.a, "eid");this.c.length ? I(this.a, "fw", this.c.join(",")) : Le(this.a.a, "fw");return this.a.toString();
  };function Ji(a, b, c, d, e) {
    this.m = a;this.u = b;this.c = c;this.l = d;this.i = this.g = this.h = null;this.a = e;this.f = null;
  }
  Ji.prototype.toString = function () {
    var a = Ee(this.m, "/__/auth/handler");I(a, "apiKey", this.u);I(a, "appName", this.c);I(a, "authType", this.l);if (this.a.isOAuthProvider) {
      var b = this.a;try {
        var c = firebase.app(this.c).auth().$();
      } catch (l) {
        c = null;
      }b.Ua = c;I(a, "providerId", this.a.providerId);b = this.a;c = Vf(b.qb);for (var d in c) {
        c[d] = c[d].toString();
      }d = b.nc;c = Ua(c);for (var e = 0; e < d.length; e++) {
        var f = d[e];f in c && delete c[f];
      }b.Wa && b.Ua && !c[b.Wa] && (c[b.Wa] = b.Ua);Sa(c) || I(a, "customParameters", Uf(c));
    }"function" === typeof this.a.vb && (b = this.a.vb(), b.length && I(a, "scopes", b.join(",")));this.h ? I(a, "redirectUrl", this.h) : Le(a.a, "redirectUrl");this.g ? I(a, "eventId", this.g) : Le(a.a, "eventId");this.i ? I(a, "v", this.i) : Le(a.a, "v");if (this.b) for (var g in this.b) {
      this.b.hasOwnProperty(g) && !Ce(a, g) && I(a, g, this.b[g]);
    }this.f ? I(a, "eid", this.f) : Le(a.a, "eid");g = Ki(this.c);g.length && I(a, "fw", g.join(","));return a.toString();
  };function Ki(a) {
    try {
      return firebase.app(a).auth().Ka();
    } catch (b) {
      return [];
    }
  }
  function Li(a, b, c, d, e) {
    this.u = a;this.f = b;this.b = c;this.c = d || null;this.h = e || null;this.m = this.o = this.v = null;this.g = [];this.l = this.a = null;
  }
  function Mi(a) {
    var b = vf();return Vh(a).then(function (a) {
      a: {
        var c = De(b),
            e = c.c;c = c.b;for (var f = 0; f < a.length; f++) {
          var g = a[f];var l = c;var n = e;0 == g.indexOf("chrome-extension://") ? l = De(g).b == l && "chrome-extension" == n : "http" != n && "https" != n ? l = !1 : Gf.test(g) ? l = l == g : (g = g.split(".").join("\\."), l = new RegExp("^(.+\\." + g + "|" + g + ")$", "i").test(l));if (l) {
            a = !0;break a;
          }
        }a = !1;
      }if (!a) throw new yh(vf());
    });
  }
  function Ni(a) {
    if (a.l) return a.l;a.l = Hf().then(function () {
      if (!a.o) {
        var b = a.c,
            c = a.h,
            d = Ki(a.b),
            e = new Ii(a.u, a.f, a.b);e.f = b;e.b = c;e.c = La(d || []);a.o = e.toString();
      }a.i = new zi(a.o);Oi(a);
    });return a.l;
  }h = Li.prototype;h.Ca = function (a, b, c) {
    var d = new N("popup-closed-by-user"),
        e = new N("web-storage-unsupported"),
        f = this,
        g = !1;return this.ba().then(function () {
      Pi(f).then(function (c) {
        c || (a && Cf(a), b(e), g = !0);
      });
    }).s(function () {}).then(function () {
      if (!g) return Ff(a);
    }).then(function () {
      if (!g) return sd(c).then(function () {
        b(d);
      });
    });
  };
  h.Cb = function () {
    var a = J();return !Tf(a) && !Xf(a);
  };h.xb = function () {
    return !1;
  };
  h.ub = function (a, b, c, d, e, f, g) {
    if (!a) return B(new N("popup-blocked"));if (g && !Tf()) return this.ba().s(function (b) {
      Cf(a);e(b);
    }), d(), A();this.a || (this.a = Mi(Qi(this)));var l = this;return this.a.then(function () {
      var b = l.ba().s(function (b) {
        Cf(a);e(b);throw b;
      });d();return b;
    }).then(function () {
      vh(c);if (!g) {
        var d = Ri(l.u, l.f, l.b, b, c, null, f, l.c, void 0, l.h);wf(d, a);
      }
    }).s(function (a) {
      "auth/network-request-failed" == a.code && (l.a = null);throw a;
    });
  };
  function Qi(a) {
    a.m || (a.v = a.c ? Of(a.c, Ki(a.b)) : null, a.m = new Ch(a.f, xi(a.h), a.v));return a.m;
  }h.Aa = function (a, b, c) {
    this.a || (this.a = Mi(Qi(this)));var d = this;return this.a.then(function () {
      vh(b);var e = Ri(d.u, d.f, d.b, a, b, vf(), c, d.c, void 0, d.h);wf(e);
    }).s(function (a) {
      "auth/network-request-failed" == a.code && (d.a = null);throw a;
    });
  };h.ba = function () {
    var a = this;return Ni(this).then(function () {
      return a.i.Ya;
    }).s(function () {
      a.a = null;throw new N("network-request-failed");
    });
  };h.Db = function () {
    return !0;
  };
  function Ri(a, b, c, d, e, f, g, l, n, D) {
    a = new Ji(a, b, c, d, e);a.h = f;a.g = g;a.i = l;a.b = Ua(n || null);a.f = D;return a.toString();
  }function Oi(a) {
    if (!a.i) throw Error("IfcHandler must be initialized!");Ei(a.i, function (b) {
      var c = {};if (b && b.authEvent) {
        var d = !1;b = xh(b.authEvent);for (c = 0; c < a.g.length; c++) {
          d = a.g[c](b) || d;
        }c = {};c.status = d ? "ACK" : "ERROR";return A(c);
      }c.status = "ERROR";return A(c);
    });
  }
  function Pi(a) {
    var b = { type: "webStorageSupport" };return Ni(a).then(function () {
      return Di(a.i, b);
    }).then(function (a) {
      if (a && a.length && "undefined" !== typeof a[0].webStorageSupport) return a[0].webStorageSupport;throw Error();
    });
  }h.ua = function (a) {
    this.g.push(a);
  };h.Ja = function (a) {
    Ja(this.g, function (b) {
      return b == a;
    });
  };function Si(a) {
    this.a = a || firebase.INTERNAL.reactNative && firebase.INTERNAL.reactNative.AsyncStorage;if (!this.a) throw new N("internal-error", "The React Native compatibility library was not found.");
  }h = Si.prototype;h.get = function (a) {
    return A(this.a.getItem(a)).then(function (a) {
      return a && Wf(a);
    });
  };h.set = function (a, b) {
    return A(this.a.setItem(a, Uf(b)));
  };h.X = function (a) {
    return A(this.a.removeItem(a));
  };h.ia = function () {};h.da = function () {};function Ti() {
    this.a = {};
  }h = Ti.prototype;h.get = function (a) {
    return A(this.a[a]);
  };h.set = function (a, b) {
    this.a[a] = b;return A();
  };h.X = function (a) {
    delete this.a[a];return A();
  };h.ia = function () {};h.da = function () {};function Ui(a, b, c, d, e, f) {
    try {
      var g = !!k.indexedDB;
    } catch (l) {
      g = !1;
    }if (!g) throw new N("web-storage-unsupported");this.u = a;this.h = b;this.g = c;this.l = d;this.m = e;this.f = {};this.c = [];this.a = 0;this.o = f || k.indexedDB;
  }var Vi;function Wi(a) {
    return new z(function (b, c) {
      var d = a.o.open(a.u, a.m);d.onerror = function (a) {
        c(Error(a.target.errorCode));
      };d.onupgradeneeded = function (b) {
        b = b.target.result;try {
          b.createObjectStore(a.h, { keyPath: a.g });
        } catch (f) {
          c(f);
        }
      };d.onsuccess = function (a) {
        b(a.target.result);
      };
    });
  }
  function Xi(a) {
    a.i || (a.i = Wi(a));return a.i;
  }function Yi(a, b) {
    return b.objectStore(a.h);
  }function Zi(a, b, c) {
    return b.transaction([a.h], c ? "readwrite" : "readonly");
  }function $i(a) {
    return new z(function (b, c) {
      a.onsuccess = function (a) {
        a && a.target ? b(a.target.result) : b();
      };a.onerror = function (a) {
        c(Error(a.target.errorCode));
      };
    });
  }h = Ui.prototype;
  h.set = function (a, b) {
    var c = !1,
        d,
        e = this;return Qb(Xi(this).then(function (b) {
      d = b;b = Yi(e, Zi(e, d, !0));return $i(b.get(a));
    }).then(function (f) {
      var g = Yi(e, Zi(e, d, !0));if (f) return f.value = b, $i(g.put(f));e.a++;c = !0;f = {};f[e.g] = a;f[e.l] = b;return $i(g.add(f));
    }).then(function () {
      e.f[a] = b;
    }), function () {
      c && e.a--;
    });
  };h.get = function (a) {
    var b = this;return Xi(this).then(function (c) {
      return $i(Yi(b, Zi(b, c, !1)).get(a));
    }).then(function (a) {
      return a && a.value;
    });
  };
  h.X = function (a) {
    var b = !1,
        c = this;return Qb(Xi(this).then(function (d) {
      b = !0;c.a++;return $i(Yi(c, Zi(c, d, !0))["delete"](a));
    }).then(function () {
      delete c.f[a];
    }), function () {
      b && c.a--;
    });
  };
  h.vc = function () {
    var a = this;return Xi(this).then(function (b) {
      var c = Yi(a, Zi(a, b, !1));return c.getAll ? $i(c.getAll()) : new z(function (a, b) {
        var d = [],
            e = c.openCursor();e.onsuccess = function (b) {
          (b = b.target.result) ? (d.push(b.value), b["continue"]()) : a(d);
        };e.onerror = function (a) {
          b(Error(a.target.errorCode));
        };
      });
    }).then(function (b) {
      var c = {},
          d = [];if (0 == a.a) {
        for (d = 0; d < b.length; d++) {
          c[b[d][a.g]] = b[d][a.l];
        }d = xf(a.f, c);a.f = c;
      }return d;
    });
  };h.ia = function (a) {
    0 == this.c.length && aj(this);this.c.push(a);
  };
  h.da = function (a) {
    Ja(this.c, function (b) {
      return b == a;
    });0 == this.c.length && this.b && this.b.cancel("STOP_EVENT");
  };function aj(a) {
    function b() {
      a.b = sd(800).then(r(a.vc, a)).then(function (b) {
        0 < b.length && w(a.c, function (a) {
          a(b);
        });
      }).then(b).s(function (a) {
        "STOP_EVENT" != a.message && b();
      });return a.b;
    }a.b && a.b.cancel("STOP_EVENT");b();
  };function bj() {
    if (!cj()) {
      if ("Node" == K()) throw new N("internal-error", "The LocalStorage compatibility library was not found.");throw new N("web-storage-unsupported");
    }this.a = dj() || firebase.INTERNAL.node.localStorage;
  }function dj() {
    try {
      var a = k.localStorage,
          b = Qf();a && (a.setItem(b, "1"), a.removeItem(b));return a;
    } catch (c) {
      return null;
    }
  }
  function cj() {
    var a = "Node" == K();a = dj() || a && firebase.INTERNAL.node && firebase.INTERNAL.node.localStorage;if (!a) return !1;try {
      return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
    } catch (b) {
      return !1;
    }
  }h = bj.prototype;h.get = function (a) {
    var b = this;return A().then(function () {
      var c = b.a.getItem(a);return Wf(c);
    });
  };h.set = function (a, b) {
    var c = this;return A().then(function () {
      var d = Uf(b);null === d ? c.X(a) : c.a.setItem(a, d);
    });
  };h.X = function (a) {
    var b = this;return A().then(function () {
      b.a.removeItem(a);
    });
  };
  h.ia = function (a) {
    k.window && cd(k.window, "storage", a);
  };h.da = function (a) {
    k.window && E(k.window, "storage", a);
  };function ej() {}h = ej.prototype;h.get = function () {
    return A(null);
  };h.set = function () {
    return A();
  };h.X = function () {
    return A();
  };h.ia = function () {};h.da = function () {};function fj() {
    if (!gj()) {
      if ("Node" == K()) throw new N("internal-error", "The SessionStorage compatibility library was not found.");throw new N("web-storage-unsupported");
    }this.a = hj() || firebase.INTERNAL.node.sessionStorage;
  }function hj() {
    try {
      var a = k.sessionStorage,
          b = Qf();a && (a.setItem(b, "1"), a.removeItem(b));return a;
    } catch (c) {
      return null;
    }
  }
  function gj() {
    var a = "Node" == K();a = hj() || a && firebase.INTERNAL.node && firebase.INTERNAL.node.sessionStorage;if (!a) return !1;try {
      return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
    } catch (b) {
      return !1;
    }
  }h = fj.prototype;h.get = function (a) {
    var b = this;return A().then(function () {
      var c = b.a.getItem(a);return Wf(c);
    });
  };h.set = function (a, b) {
    var c = this;return A().then(function () {
      var d = Uf(b);null === d ? c.X(a) : c.a.setItem(a, d);
    });
  };h.X = function (a) {
    var b = this;return A().then(function () {
      b.a.removeItem(a);
    });
  };h.ia = function () {};
  h.da = function () {};function ij() {
    var a = {};a.Browser = jj;a.Node = kj;a.ReactNative = lj;this.a = a[K()];
  }var mj,
      jj = { C: bj, jb: fj },
      kj = { C: bj, jb: fj },
      lj = { C: Si, jb: ej };var nj = { Hc: "local", NONE: "none", Jc: "session" };function oj(a) {
    var b = new N("invalid-persistence-type"),
        c = new N("unsupported-persistence-type");a: {
      for (d in nj) {
        if (nj[d] == a) {
          var d = !0;break a;
        }
      }d = !1;
    }if (!d || "string" !== typeof a) throw b;switch (K()) {case "ReactNative":
        if ("session" === a) throw c;break;case "Node":
        if ("none" !== a) throw c;break;default:
        if (!Pf() && "none" !== a) throw c;}
  }
  function pj(a, b, c, d, e) {
    this.i = a;this.g = b;this.A = c;this.u = d;this.v = e;this.a = {};mj || (mj = new ij());a = mj;try {
      if (uf()) {
        Vi || (Vi = new Ui("firebaseLocalStorageDb", "firebaseLocalStorage", "fbase_key", "value", 1));var f = Vi;
      } else f = new a.a.C();this.l = f;
    } catch (g) {
      this.l = new Ti(), this.u = !0;
    }try {
      this.o = new a.a.jb();
    } catch (g) {
      this.o = new Ti();
    }this.w = new Ti();this.h = r(this.m, this);this.b = {};
  }var qj;function rj() {
    qj || (qj = new pj("firebase", ":", !Xf(J()) && Lf() ? !0 : !1, Tf(), Pf()));return qj;
  }
  function sj(a, b) {
    switch (b) {case "session":
        return a.o;case "none":
        return a.w;default:
        return a.l;}
  }function tj(a, b, c) {
    return a.i + a.g + b.name + (c ? a.g + c : "");
  }pj.prototype.get = function (a, b) {
    return sj(this, a.C).get(tj(this, a, b));
  };function uj(a, b, c) {
    c = tj(a, b, c);"local" == b.C && (a.b[c] = null);return sj(a, b.C).X(c);
  }pj.prototype.set = function (a, b, c) {
    var d = tj(this, a, c),
        e = this,
        f = sj(this, a.C);return f.set(d, b).then(function () {
      return f.get(d);
    }).then(function (b) {
      "local" == a.C && (e.b[d] = b);
    });
  };
  function vj(a, b, c, d) {
    b = tj(a, b, c);a.v && (a.b[b] = k.localStorage.getItem(b));Sa(a.a) && (sj(a, "local").ia(a.h), a.u || uf() || !a.v || wj(a));a.a[b] || (a.a[b] = []);a.a[b].push(d);
  }function xj(a, b, c) {
    b = tj(a, yj("local"), b);a.a[b] && (Ja(a.a[b], function (a) {
      return a == c;
    }), 0 == a.a[b].length && delete a.a[b]);Sa(a.a) && zj(a);
  }
  function wj(a) {
    Aj(a);a.f = setInterval(function () {
      for (var b in a.a) {
        var c = k.localStorage.getItem(b),
            d = a.b[b];c != d && (a.b[b] = c, c = new Qc({ type: "storage", key: b, target: window, oldValue: d, newValue: c, a: !0 }), a.m(c));
      }
    }, 1E3);
  }function Aj(a) {
    a.f && (clearInterval(a.f), a.f = null);
  }function zj(a) {
    sj(a, "local").da(a.h);Aj(a);
  }
  pj.prototype.m = function (a) {
    if (a && a.g) {
      var b = a.a.key;if (null == b) for (var c in this.a) {
        var d = this.b[c];"undefined" === typeof d && (d = null);var e = k.localStorage.getItem(c);e !== d && (this.b[c] = e, this.c(c));
      } else if (0 == b.indexOf(this.i + this.g) && this.a[b]) {
        "undefined" !== typeof a.a.a ? sj(this, "local").da(this.h) : Aj(this);if (this.A) if (c = k.localStorage.getItem(b), d = a.a.newValue, d !== c) null !== d ? k.localStorage.setItem(b, d) : k.localStorage.removeItem(b);else if (this.b[b] === d && "undefined" === typeof a.a.a) return;var f = this;
        c = function c() {
          if ("undefined" !== typeof a.a.a || f.b[b] !== k.localStorage.getItem(b)) f.b[b] = k.localStorage.getItem(b), f.c(b);
        };y && kb && 10 == kb && k.localStorage.getItem(b) !== a.a.newValue && a.a.newValue !== a.a.oldValue ? setTimeout(c, 10) : c();
      }
    } else w(a, r(this.c, this));
  };pj.prototype.c = function (a) {
    this.a[a] && w(this.a[a], function (a) {
      a();
    });
  };function Cj(a) {
    this.a = a;this.b = rj();
  }var Dj = { name: "authEvent", C: "local" };function Ej(a) {
    return a.b.get(Dj, a.a).then(function (a) {
      return xh(a);
    });
  };function Fj() {
    this.a = rj();
  };function Gj(a, b, c, d, e, f, g) {
    this.u = a;this.i = b;this.l = c;this.m = d || null;this.o = g || null;this.h = b + ":" + c;this.A = new Fj();this.g = new Cj(this.h);this.f = null;this.b = [];this.v = e || 500;this.w = f || 2E3;this.a = this.c = null;
  }function Hj(a) {
    return new N("invalid-cordova-configuration", a);
  }h = Gj.prototype;
  h.ba = function () {
    return this.xa ? this.xa : this.xa = If().then(function () {
      if ("function" !== typeof L("universalLinks.subscribe", k)) throw Hj("cordova-universal-links-plugin is not installed");if ("undefined" === typeof L("BuildInfo.packageName", k)) throw Hj("cordova-plugin-buildinfo is not installed");if ("function" !== typeof L("cordova.plugins.browsertab.openUrl", k)) throw Hj("cordova-plugin-browsertab is not installed");if ("function" !== typeof L("cordova.InAppBrowser.open", k)) throw Hj("cordova-plugin-inappbrowser is not installed");
    }, function () {
      throw new N("cordova-not-ready");
    });
  };function Ij() {
    for (var a = 20, b = []; 0 < a;) {
      b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
    }return b.join("");
  }function Jj(a) {
    var b = new ie();he(b, a);a = [];var c = 8 * b.g;56 > b.c ? he(b, fe, 56 - b.c) : he(b, fe, b.b - (b.c - 56));for (var d = 63; 56 <= d; d--) {
      b.f[d] = c & 255, c /= 256;
    }ge(b);for (d = c = 0; d < b.i; d++) {
      for (var e = 24; 0 <= e; e -= 8) {
        a[c++] = b.a[d] >> e & 255;
      }
    }return Hd(a);
  }
  h.Ca = function (a, b) {
    b(new N("operation-not-supported-in-this-environment"));return A();
  };h.ub = function () {
    return B(new N("operation-not-supported-in-this-environment"));
  };h.Db = function () {
    return !1;
  };h.Cb = function () {
    return !0;
  };h.xb = function () {
    return !0;
  };
  h.Aa = function (a, b, c) {
    if (this.c) return B(new N("redirect-operation-pending"));var d = this,
        e = k.document,
        f = null,
        g = null,
        l = null,
        n = null;return this.c = Qb(A().then(function () {
      vh(b);return Kj(d);
    }).then(function () {
      return Lj(d, a, b, c);
    }).then(function () {
      return new z(function (a, b) {
        g = function g() {
          var b = L("cordova.plugins.browsertab.close", k);a();"function" === typeof b && b();d.a && "function" === typeof d.a.close && (d.a.close(), d.a = null);return !1;
        };d.ua(g);l = function l() {
          f || (f = sd(d.w).then(function () {
            b(new N("redirect-cancelled-by-user"));
          }));
        };
        n = function n() {
          ag() && l();
        };e.addEventListener("resume", l, !1);J().toLowerCase().match(/android/) || e.addEventListener("visibilitychange", n, !1);
      }).s(function (a) {
        return Mj(d).then(function () {
          throw a;
        });
      });
    }), function () {
      l && e.removeEventListener("resume", l, !1);n && e.removeEventListener("visibilitychange", n, !1);f && f.cancel();g && d.Ja(g);d.c = null;
    });
  };
  function Lj(a, b, c, d) {
    var e = Ij(),
        f = new wh(b, d, null, e, new N("no-auth-event")),
        g = L("BuildInfo.packageName", k);if ("string" !== typeof g) throw new N("invalid-cordova-configuration");var l = L("BuildInfo.displayName", k),
        n = {};if (J().toLowerCase().match(/iphone|ipad|ipod/)) n.ibi = g;else if (J().toLowerCase().match(/android/)) n.apn = g;else return B(new N("operation-not-supported-in-this-environment"));l && (n.appDisplayName = l);e = Jj(e);n.sessionId = e;var D = Ri(a.u, a.i, a.l, b, c, null, d, a.m, n, a.o);return a.ba().then(function () {
      var b = a.h;return a.A.a.set(Dj, f.B(), b);
    }).then(function () {
      var b = L("cordova.plugins.browsertab.isAvailable", k);if ("function" !== typeof b) throw new N("invalid-cordova-configuration");var c = null;b(function (b) {
        if (b) {
          c = L("cordova.plugins.browsertab.openUrl", k);if ("function" !== typeof c) throw new N("invalid-cordova-configuration");c(D);
        } else {
          c = L("cordova.InAppBrowser.open", k);if ("function" !== typeof c) throw new N("invalid-cordova-configuration");b = J();b = !(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i) && !b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
          a.a = c(D, b ? "_blank" : "_system", "location=yes");
        }
      });
    });
  }function Nj(a, b) {
    for (var c = 0; c < a.b.length; c++) {
      try {
        a.b[c](b);
      } catch (d) {}
    }
  }function Kj(a) {
    a.f || (a.f = a.ba().then(function () {
      return new z(function (b) {
        function c(d) {
          b(d);a.Ja(c);return !1;
        }a.ua(c);Oj(a);
      });
    }));return a.f;
  }function Mj(a) {
    var b = null;return Ej(a.g).then(function (c) {
      b = c;c = a.g;return uj(c.b, Dj, c.a);
    }).then(function () {
      return b;
    });
  }
  function Oj(a) {
    function b(b) {
      e = !0;f && f.cancel();Mj(a).then(function (c) {
        var e = d;if (c && b && b.url) {
          e = null;var f = b.url;var g = De(f),
              l = Ce(g, "link"),
              n = Ce(De(l), "link");g = Ce(g, "deep_link_id");f = Ce(De(g), "link") || g || n || l || f;-1 != f.indexOf("/__/auth/callback") && (e = De(f), e = Wf(Ce(e, "firebaseError") || null), e = (e = "object" === typeof e ? vg(e) : null) ? new wh(c.b, c.c, null, null, e) : new wh(c.b, c.c, f, c.g));e = e || d;
        }Nj(a, e);
      });
    }var c = L("universalLinks.subscribe", k);if ("function" !== typeof c) throw new N("invalid-cordova-configuration");
    var d = new wh("unknown", null, null, null, new N("no-auth-event")),
        e = !1,
        f = sd(a.v).then(function () {
      return Mj(a).then(function () {
        e || Nj(a, d);
      });
    }),
        g = k.handleOpenURL;k.handleOpenURL = function (a) {
      0 == a.toLowerCase().indexOf(L("BuildInfo.packageName", k).toLowerCase() + "://") && b({ url: a });if ("function" === typeof g) try {
        g(a);
      } catch (n) {
        console.error(n);
      }
    };c(null, b);
  }
  h.ua = function (a) {
    this.b.push(a);Kj(this).s(function (b) {
      "auth/invalid-cordova-configuration" === b.code && (b = new wh("unknown", null, null, null, new N("no-auth-event")), a(b));
    });
  };h.Ja = function (a) {
    Ja(this.b, function (b) {
      return b == a;
    });
  };function Pj(a) {
    this.a = a;this.b = rj();
  }var Qj = { name: "pendingRedirect", C: "session" };function Rj(a) {
    return a.b.set(Qj, "pending", a.a);
  }function Sj(a) {
    return uj(a.b, Qj, a.a);
  }function Tj(a) {
    return a.b.get(Qj, a.a).then(function (a) {
      return "pending" == a;
    });
  };function Uj(a, b, c) {
    this.v = a;this.l = b;this.u = c;this.h = [];this.f = !1;this.i = r(this.m, this);this.c = new Vj();this.o = new Wj();this.g = new Pj(this.l + ":" + this.u);this.b = {};this.b.unknown = this.c;this.b.signInViaRedirect = this.c;this.b.linkViaRedirect = this.c;this.b.reauthViaRedirect = this.c;this.b.signInViaPopup = this.o;this.b.linkViaPopup = this.o;this.b.reauthViaPopup = this.o;this.a = Xj(this.v, this.l, this.u, yi);
  }
  function Xj(a, b, c, d) {
    var e = firebase.SDK_VERSION || null;return Jf() ? new Gj(a, b, c, e, void 0, void 0, d) : new Li(a, b, c, e, d);
  }Uj.prototype.reset = function () {
    this.f = !1;this.a.Ja(this.i);this.a = Xj(this.v, this.l, this.u);
  };function Yj(a) {
    a.f || (a.f = !0, a.a.ua(a.i));var b = a.a;return a.a.ba().s(function (c) {
      a.a == b && a.reset();throw c;
    });
  }function Zj(a) {
    a.a.Cb() && Yj(a).s(function (b) {
      var c = new wh("unknown", null, null, null, new N("operation-not-supported-in-this-environment"));ak(b) && a.m(c);
    });a.a.xb() || bk(a.c);
  }
  Uj.prototype.subscribe = function (a) {
    Ha(this.h, a) || this.h.push(a);if (!this.f) {
      var b = this;Tj(this.g).then(function (a) {
        a ? Sj(b.g).then(function () {
          Yj(b).s(function (a) {
            var c = new wh("unknown", null, null, null, new N("operation-not-supported-in-this-environment"));ak(a) && b.m(c);
          });
        }) : Zj(b);
      }).s(function () {
        Zj(b);
      });
    }
  };Uj.prototype.unsubscribe = function (a) {
    Ja(this.h, function (b) {
      return b == a;
    });
  };
  Uj.prototype.m = function (a) {
    if (!a) throw new N("invalid-auth-event");for (var b = !1, c = 0; c < this.h.length; c++) {
      var d = this.h[c];if (d.ob(a.b, a.c)) {
        (b = this.b[a.b]) && b.h(a, d);b = !0;break;
      }
    }bk(this.c);return b;
  };var ck = new $f(2E3, 1E4),
      dk = new $f(3E4, 6E4);Uj.prototype.aa = function () {
    return this.c.aa();
  };function ek(a, b, c, d, e, f) {
    return a.a.ub(b, c, d, function () {
      a.f || (a.f = !0, a.a.ua(a.i));
    }, function () {
      a.reset();
    }, e, f);
  }function ak(a) {
    return a && "auth/cordova-not-ready" == a.code ? !0 : !1;
  }
  Uj.prototype.Aa = function (a, b, c) {
    var d = this,
        e;return Rj(this.g).then(function () {
      return d.a.Aa(a, b, c).s(function (a) {
        if (ak(a)) throw new N("operation-not-supported-in-this-environment");e = a;return Sj(d.g).then(function () {
          throw e;
        });
      }).then(function () {
        return d.a.Db() ? new z(function () {}) : Sj(d.g).then(function () {
          return d.aa();
        }).then(function () {}).s(function () {});
      });
    });
  };Uj.prototype.Ca = function (a, b, c, d) {
    return this.a.Ca(c, function (c) {
      a.fa(b, null, c, d);
    }, ck.get());
  };var fk = {};
  function gk(a, b, c) {
    var d = b + ":" + c;fk[d] || (fk[d] = new Uj(a, b, c));return fk[d];
  }function Vj() {
    this.b = null;this.f = [];this.c = [];this.a = null;this.g = !1;
  }Vj.prototype.reset = function () {
    this.b = null;this.a && (this.a.cancel(), this.a = null);
  };
  Vj.prototype.h = function (a, b) {
    if (!a) return B(new N("invalid-auth-event"));this.reset();this.g = !0;var c = a.b,
        d = a.c,
        e = a.a && "auth/web-storage-unsupported" == a.a.code,
        f = a.a && "auth/operation-not-supported-in-this-environment" == a.a.code;"unknown" != c || e || f ? a.a ? (hk(this, !0, null, a.a), a = A()) : a = b.va(c, d) ? ik(this, a, b) : B(new N("invalid-auth-event")) : (hk(this, !1, null, null), a = A());return a;
  };function bk(a) {
    a.g || (a.g = !0, hk(a, !1, null, null));
  }
  function ik(a, b, c) {
    c = c.va(b.b, b.c);var d = b.f,
        e = b.g,
        f = !!b.b.match(/Redirect$/);return c(d, e).then(function (b) {
      hk(a, f, b, null);
    }).s(function (b) {
      hk(a, f, null, b);
    });
  }function jk(a, b) {
    a.b = function () {
      return B(b);
    };if (a.c.length) for (var c = 0; c < a.c.length; c++) {
      a.c[c](b);
    }
  }function kk(a, b) {
    a.b = function () {
      return A(b);
    };if (a.f.length) for (var c = 0; c < a.f.length; c++) {
      a.f[c](b);
    }
  }function hk(a, b, c, d) {
    b ? d ? jk(a, d) : kk(a, c) : kk(a, { user: null });a.f = [];a.c = [];
  }
  Vj.prototype.aa = function () {
    var a = this;return new z(function (b, c) {
      a.b ? a.b().then(b, c) : (a.f.push(b), a.c.push(c), lk(a));
    });
  };function lk(a) {
    var b = new N("timeout");a.a && a.a.cancel();a.a = sd(dk.get()).then(function () {
      a.b || hk(a, !0, null, b);
    });
  }function Wj() {}Wj.prototype.h = function (a, b) {
    if (!a) return B(new N("invalid-auth-event"));var c = a.b,
        d = a.c;a.a ? (b.fa(a.b, null, a.a, a.c), a = A()) : a = b.va(c, d) ? mk(a, b) : B(new N("invalid-auth-event"));return a;
  };
  function mk(a, b) {
    var c = a.c,
        d = a.b;return b.va(d, c)(a.f, a.g).then(function (a) {
      b.fa(d, a, null, c);
    }).s(function (a) {
      b.fa(d, null, a, c);
    });
  };function nk(a, b) {
    this.a = b;M(this, "verificationId", a);
  }nk.prototype.confirm = function (a) {
    a = th(this.verificationId, a);return this.a(a);
  };function ok(a, b, c, d) {
    return new rh(a).Qa(b, c).then(function (a) {
      return new nk(a, d);
    });
  };function pk(a, b, c, d, e, f) {
    this.h = a;this.i = b;this.g = c;this.c = d;this.f = e;this.l = !!f;this.b = null;this.a = this.c;if (this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
  }pk.prototype.start = function () {
    this.a = this.c;qk(this, !0);
  };function rk(a, b) {
    if (b) return a.a = a.c, a.g();b = a.a;a.a *= 2;a.a > a.f && (a.a = a.f);return b;
  }
  function qk(a, b) {
    sk(a);a.b = sd(rk(a, b)).then(function () {
      return a.l ? A() : bg();
    }).then(function () {
      return a.h();
    }).then(function () {
      qk(a, !0);
    }).s(function (b) {
      a.i(b) && qk(a, !1);
    });
  }function sk(a) {
    a.b && (a.b.cancel(), a.b = null);
  };function tk(a) {
    this.f = a;this.b = this.a = null;this.c = 0;
  }tk.prototype.B = function () {
    return { apiKey: this.f.b, refreshToken: this.a, accessToken: this.b, expirationTime: this.c };
  };function uk(a, b) {
    var c = b[_O],
        d = b.refreshToken;b = vk(b.expiresIn);a.b = c;a.c = b;a.a = d;
  }function vk(a) {
    return na() + 1E3 * parseInt(a, 10);
  }
  function wk(a, b) {
    return Oh(a.f, b).then(function (b) {
      a.b = b.access_token;a.c = vk(b.expires_in);a.a = b.refresh_token;return { accessToken: a.b, expirationTime: a.c, refreshToken: a.a };
    }).s(function (b) {
      "auth/user-token-expired" == b.code && (a.a = null);throw b;
    });
  }tk.prototype.getToken = function (a) {
    a = !!a;return this.b && !this.a ? B(new N("user-token-expired")) : a || !this.b || na() > this.c - 3E4 ? this.a ? wk(this, { grant_type: "refresh_token", refresh_token: this.a }) : A(null) : A({ accessToken: this.b, expirationTime: this.c, refreshToken: this.a });
  };function xk(a, b) {
    this.a = a || null;this.b = b || null;gg(this, { lastSignInTime: cg(b || null), creationTime: cg(a || null) });
  }function yk(a) {
    return new xk(a.a, a.b);
  }xk.prototype.B = function () {
    return { lastLoginAt: this.b, createdAt: this.a };
  };function zk(a, b, c, d, e, f) {
    gg(this, { uid: a, displayName: d || null, photoURL: e || null, email: c || null, phoneNumber: f || null, providerId: b });
  }function Ak(a, b) {
    C.call(this, a);for (var c in b) {
      this[c] = b[c];
    }
  }t(Ak, C);
  function Bk(a, b, c) {
    this.A = [];this.G = a.apiKey;this.o = a.appName;this.w = a.authDomain || null;a = firebase.SDK_VERSION ? Of(firebase.SDK_VERSION) : null;this.c = new Ch(this.G, xi(yi), a);this.h = new tk(this.c);Ck(this, b[_O]);uk(this.h, b);M(this, "refreshToken", this.h.a);Dk(this, c || {});F.call(this);this.I = !1;this.w && Rf() && (this.a = gk(this.w, this.G, this.o));this.N = [];this.i = null;this.l = Ek(this);this.U = r(this.Ga, this);var d = this;this.ha = null;this.ra = function (a) {
      d.na(a.h);
    };this.W = null;this.R = [];this.qa = function (a) {
      Fk(d, a.f);
    };this.V = null;
  }t(Bk, F);Bk.prototype.na = function (a) {
    this.ha = a;Ih(this.c, a);
  };Bk.prototype.$ = function () {
    return this.ha;
  };function Gk(a, b) {
    a.W && E(a.W, "languageCodeChanged", a.ra);(a.W = b) && cd(b, "languageCodeChanged", a.ra);
  }function Fk(a, b) {
    a.R = b;Jh(a.c, firebase.SDK_VERSION ? Of(firebase.SDK_VERSION, a.R) : null);
  }Bk.prototype.Ka = function () {
    return La(this.R);
  };function Hk(a, b) {
    a.V && E(a.V, "frameworkChanged", a.qa);(a.V = b) && cd(b, "frameworkChanged", a.qa);
  }Bk.prototype.Ga = function () {
    this.l.b && (sk(this.l), this.l.start());
  };
  function Ik(a) {
    try {
      return firebase.app(a.o).auth();
    } catch (b) {
      throw new N("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a.o + "'!");
    }
  }function Ek(a) {
    return new pk(function () {
      return a.F(!0);
    }, function (a) {
      return a && "auth/network-request-failed" == a.code ? !0 : !1;
    }, function () {
      var b = a.h.c - na() - 3E5;return 0 < b ? b : 0;
    }, 3E4, 96E4, !1);
  }function Jk(a) {
    a.m || a.l.b || (a.l.start(), E(a, "tokenChanged", a.U), cd(a, "tokenChanged", a.U));
  }function Kk(a) {
    E(a, "tokenChanged", a.U);sk(a.l);
  }
  function Ck(a, b) {
    a.pa = b;M(a, "_lat", b);
  }function Lk(a, b) {
    Ja(a.N, function (a) {
      return a == b;
    });
  }function Mk(a) {
    for (var b = [], c = 0; c < a.N.length; c++) {
      b.push(a.N[c](a));
    }return Ob(b).then(function () {
      return a;
    });
  }function Nk(a) {
    a.a && !a.I && (a.I = !0, a.a.subscribe(a));
  }
  function Dk(a, b) {
    gg(a, { uid: b.uid, displayName: b.displayName || null, photoURL: b.photoURL || null, email: b.email || null, emailVerified: b.emailVerified || !1, phoneNumber: b.phoneNumber || null, isAnonymous: b.isAnonymous || !1, metadata: new xk(b.createdAt, b.lastLoginAt), providerData: [] });
  }M(Bk.prototype, "providerId", "firebase");function Ok() {}function Pk(a) {
    return A().then(function () {
      if (a.m) throw new N("app-deleted");
    });
  }function Qk(a) {
    return Da(a.providerData, function (a) {
      return a.providerId;
    });
  }
  function Rk(a, b) {
    b && (Sk(a, b.providerId), a.providerData.push(b));
  }function Sk(a, b) {
    Ja(a.providerData, function (a) {
      return a.providerId == b;
    });
  }function Tk(a, b, c) {
    ("uid" != b || c) && a.hasOwnProperty(b) && M(a, b, c);
  }
  function Uk(a, b) {
    a != b && (gg(a, { uid: b.uid, displayName: b.displayName, photoURL: b.photoURL, email: b.email, emailVerified: b.emailVerified, phoneNumber: b.phoneNumber, isAnonymous: b.isAnonymous, providerData: [] }), b.metadata ? M(a, "metadata", yk(b.metadata)) : M(a, "metadata", new xk()), w(b.providerData, function (b) {
      Rk(a, b);
    }), a.h = b.h, M(a, "refreshToken", a.h.a));
  }h = Bk.prototype;h.reload = function () {
    var a = this;return R(this, Pk(this).then(function () {
      return Vk(a).then(function () {
        return Mk(a);
      }).then(Ok);
    }));
  };
  function Vk(a) {
    return a.F().then(function (b) {
      var c = a.isAnonymous;return Wk(a, b).then(function () {
        c || Tk(a, "isAnonymous", !1);return b;
      });
    });
  }h.F = function (a) {
    var b = this;return R(this, Pk(this).then(function () {
      return b.h.getToken(a);
    }).then(function (a) {
      if (!a) throw new N("internal-error");a.accessToken != b.pa && (Ck(b, a.accessToken), G(b, new Ak("tokenChanged")));Tk(b, "refreshToken", a.refreshToken);return a.accessToken;
    }));
  };
  h.getToken = function (a) {
    dg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."] || (dg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."] = !0, "undefined" !== typeof console && "function" === typeof console.warn && console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.F(a);
  };
  function Xk(a, b) {
    b[_O] && a.pa != b[_O] && (uk(a.h, b), G(a, new Ak("tokenChanged")), Ck(a, b[_O]), Tk(a, "refreshToken", a.h.a));
  }function Wk(a, b) {
    return Q(a.c, ti, { idToken: b }).then(r(a.gc, a));
  }
  h.gc = function (a) {
    a = a.users;if (!a || !a.length) throw new N("internal-error");a = a[0];Dk(this, { uid: a.localId, displayName: a.displayName, photoURL: a.photoUrl, email: a.email, emailVerified: !!a.emailVerified, phoneNumber: a.phoneNumber, lastLoginAt: a.lastLoginAt, createdAt: a.createdAt });for (var b = Yk(a), c = 0; c < b.length; c++) {
      Rk(this, b[c]);
    }Tk(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
  };
  function Yk(a) {
    return (a = a.providerUserInfo) && a.length ? Da(a, function (a) {
      return new zk(a.rawId, a.providerId, a.email, a.displayName, a.photoUrl, a.phoneNumber);
    }) : [];
  }h.Za = function (a) {
    var b = this,
        c = null;return R(this, a.c(this.c, this.uid).then(function (a) {
      Xk(b, a);c = Zk(b, a, "reauthenticate");b.i = null;return b.reload();
    }).then(function () {
      return c;
    }), !0);
  };h.hc = function (a) {
    return this.Za(a).then(function () {});
  };
  function $k(a, b) {
    return Vk(a).then(function () {
      if (Ha(Qk(a), b)) return Mk(a).then(function () {
        throw new N("provider-already-linked");
      });
    });
  }h.Xa = function (a) {
    var b = this,
        c = null;return R(this, $k(this, a.providerId).then(function () {
      return b.F();
    }).then(function (c) {
      return a.b(b.c, c);
    }).then(function (a) {
      c = Zk(b, a, "link");return al(b, a);
    }).then(function () {
      return c;
    }));
  };h.Zb = function (a) {
    return this.Xa(a).then(function (a) {
      return a.user;
    });
  };
  h.$b = function (a, b) {
    var c = this;return R(this, $k(this, "phone").then(function () {
      return ok(Ik(c), a, b, r(c.Xa, c));
    }));
  };h.ic = function (a, b) {
    var c = this;return R(this, A().then(function () {
      return ok(Ik(c), a, b, r(c.Za, c));
    }), !0);
  };function Zk(a, b, c) {
    var d = uh(b);b = Mg(b);return hg({ user: a, credential: d, additionalUserInfo: b, operationType: c });
  }function al(a, b) {
    Xk(a, b);return a.reload().then(function () {
      return a;
    });
  }
  h.kb = function (a) {
    var b = this;return R(this, this.F().then(function (c) {
      return b.c.kb(c, a);
    }).then(function (a) {
      Xk(b, a);return b.reload();
    }));
  };h.zc = function (a) {
    var b = this;return R(this, this.F().then(function (c) {
      return a.b(b.c, c);
    }).then(function (a) {
      Xk(b, a);return b.reload();
    }));
  };h.lb = function (a) {
    var b = this;return R(this, this.F().then(function (c) {
      return b.c.lb(c, a);
    }).then(function (a) {
      Xk(b, a);return b.reload();
    }));
  };
  h.mb = function (a) {
    if (void 0 === a.displayName && void 0 === a.photoURL) return Pk(this);var b = this;return R(this, this.F().then(function (c) {
      return b.c.mb(c, { displayName: a.displayName, photoUrl: a.photoURL });
    }).then(function (a) {
      Xk(b, a);Tk(b, "displayName", a.displayName || null);Tk(b, "photoURL", a.photoUrl || null);w(b.providerData, function (a) {
        "password" === a.providerId && (M(a, "displayName", b.displayName), M(a, "photoURL", b.photoURL));
      });return Mk(b);
    }).then(Ok));
  };
  h.yc = function (a) {
    var b = this;return R(this, Vk(this).then(function (c) {
      return Ha(Qk(b), a) ? fi(b.c, c, [a]).then(function (a) {
        var c = {};w(a.providerUserInfo || [], function (a) {
          c[a.providerId] = !0;
        });w(Qk(b), function (a) {
          c[a] || Sk(b, a);
        });c[rh.PROVIDER_ID] || M(b, "phoneNumber", null);return Mk(b);
      }) : Mk(b).then(function () {
        throw new N("no-such-provider");
      });
    }));
  };
  h.delete = function () {
    var a = this;return R(this, this.F().then(function (b) {
      return Q(a.c, si, { idToken: b });
    }).then(function () {
      G(a, new Ak("userDeleted"));
    })).then(function () {
      for (var b = 0; b < a.A.length; b++) {
        a.A[b].cancel("app-deleted");
      }Gk(a, null);Hk(a, null);a.A = [];a.m = !0;Kk(a);M(a, "refreshToken", null);a.a && a.a.unsubscribe(a);
    });
  };
  h.ob = function (a, b) {
    return "linkViaPopup" == a && (this.g || null) == b && this.f || "reauthViaPopup" == a && (this.g || null) == b && this.f || "linkViaRedirect" == a && (this.Z || null) == b || "reauthViaRedirect" == a && (this.Z || null) == b ? !0 : !1;
  };h.fa = function (a, b, c, d) {
    "linkViaPopup" != a && "reauthViaPopup" != a || d != (this.g || null) || (c && this.v ? this.v(c) : b && !c && this.f && this.f(b), this.b && (this.b.cancel(), this.b = null), delete this.f, delete this.v);
  };
  h.va = function (a, b) {
    return "linkViaPopup" == a && b == (this.g || null) ? r(this.sb, this) : "reauthViaPopup" == a && b == (this.g || null) ? r(this.tb, this) : "linkViaRedirect" == a && (this.Z || null) == b ? r(this.sb, this) : "reauthViaRedirect" == a && (this.Z || null) == b ? r(this.tb, this) : null;
  };h.ac = function (a) {
    var b = this;return bl(this, "linkViaPopup", a, function () {
      return $k(b, a.providerId).then(function () {
        return Mk(b);
      });
    }, !1);
  };h.jc = function (a) {
    return bl(this, "reauthViaPopup", a, function () {
      return A();
    }, !0);
  };
  function bl(a, b, c, d, e) {
    if (!Rf()) return B(new N("operation-not-supported-in-this-environment"));if (a.i && !e) return B(a.i);var f = Lg(c.providerId),
        g = Qf(a.uid + ":::"),
        l = null;(!Tf() || Lf()) && a.w && c.isOAuthProvider && (l = Ri(a.w, a.G, a.o, b, c, null, g, firebase.SDK_VERSION || null));var n = Df(l, f && f.za, f && f.ya);d = d().then(function () {
      cl(a);if (!e) return a.F().then(function () {});
    }).then(function () {
      return ek(a.a, n, b, c, g, !!l);
    }).then(function () {
      return new z(function (c, d) {
        a.fa(b, null, new N("cancelled-popup-request"), a.g || null);
        a.f = c;a.v = d;a.g = g;a.b = a.a.Ca(a, b, n, g);
      });
    }).then(function (a) {
      n && Cf(n);return a ? hg(a) : null;
    }).s(function (a) {
      n && Cf(n);throw a;
    });return R(a, d, e);
  }h.bc = function (a) {
    var b = this;return dl(this, "linkViaRedirect", a, function () {
      return $k(b, a.providerId);
    }, !1);
  };h.kc = function (a) {
    return dl(this, "reauthViaRedirect", a, function () {
      return A();
    }, !0);
  };
  function dl(a, b, c, d, e) {
    if (!Rf()) return B(new N("operation-not-supported-in-this-environment"));if (a.i && !e) return B(a.i);var f = null,
        g = Qf(a.uid + ":::");d = d().then(function () {
      cl(a);if (!e) return a.F().then(function () {});
    }).then(function () {
      a.Z = g;return Mk(a);
    }).then(function (b) {
      a.ca && (b = a.ca, b = b.b.set(el, a.B(), b.a));return b;
    }).then(function () {
      return a.a.Aa(b, c, g);
    }).s(function (b) {
      f = b;if (a.ca) return fl(a.ca);throw f;
    }).then(function () {
      if (f) throw f;
    });return R(a, d, e);
  }
  function cl(a) {
    if (!a.a || !a.I) {
      if (a.a && !a.I) throw new N("internal-error");throw new N("auth-domain-config-required");
    }
  }h.sb = function (a, b) {
    var c = this;this.b && (this.b.cancel(), this.b = null);var d = null,
        e = this.F().then(function (d) {
      return Zg(c.c, { requestUri: a, sessionId: b, idToken: d });
    }).then(function (a) {
      d = Zk(c, a, "link");return al(c, a);
    }).then(function () {
      return d;
    });return R(this, e);
  };
  h.tb = function (a, b) {
    var c = this;this.b && (this.b.cancel(), this.b = null);var d = null,
        e = A().then(function () {
      return Vg($g(c.c, { requestUri: a, sessionId: b }), c.uid);
    }).then(function (a) {
      d = Zk(c, a, "reauthenticate");Xk(c, a);c.i = null;return c.reload();
    }).then(function () {
      return d;
    });return R(this, e, !0);
  };h.bb = function (a) {
    var b = this,
        c = null;return R(this, this.F().then(function (b) {
      c = b;return "undefined" === typeof a || Sa(a) ? {} : Fg(new wg(a));
    }).then(function (a) {
      return b.c.bb(c, a);
    }).then(function (a) {
      if (b.email != a) return b.reload();
    }).then(function () {}));
  };
  function R(a, b, c) {
    var d = gl(a, b, c);a.A.push(d);Qb(d, function () {
      Ia(a.A, d);
    });return d;
  }function gl(a, b, c) {
    return a.i && !c ? (b.cancel(), B(a.i)) : b.s(function (b) {
      !b || "auth/user-disabled" != b.code && "auth/user-token-expired" != b.code || (a.i || G(a, new Ak("userInvalidated")), a.i = b);throw b;
    });
  }h.toJSON = function () {
    return this.B();
  };
  h.B = function () {
    var a = { uid: this.uid, displayName: this.displayName, photoURL: this.photoURL, email: this.email, emailVerified: this.emailVerified, phoneNumber: this.phoneNumber, isAnonymous: this.isAnonymous, providerData: [], apiKey: this.G, appName: this.o, authDomain: this.w, stsTokenManager: this.h.B(), redirectEventId: this.Z || null };this.metadata && Wa(a, this.metadata.B());w(this.providerData, function (b) {
      a.providerData.push(ig(b));
    });return a;
  };
  function hl(a) {
    if (!a.apiKey) return null;var b = { apiKey: a.apiKey, authDomain: a.authDomain, appName: a.appName },
        c = {};if (a.stsTokenManager && a.stsTokenManager.accessToken && a.stsTokenManager.expirationTime) c[_O] = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null, c.expiresIn = (a.stsTokenManager.expirationTime - na()) / 1E3;else return null;var d = new Bk(b, c, a);a.providerData && w(a.providerData, function (a) {
      a && Rk(d, hg(a));
    });a.redirectEventId && (d.Z = a.redirectEventId);return d;
  }
  function il(a, b, c, d) {
    var e = new Bk(a, b);c && (e.ca = c);d && Fk(e, d);return e.reload().then(function () {
      return e;
    });
  };function jl(a) {
    this.a = a;this.b = rj();
  }var el = { name: "redirectUser", C: "session" };function fl(a) {
    return uj(a.b, el, a.a);
  }function kl(a, b) {
    return a.b.get(el, a.a).then(function (a) {
      a && b && (a.authDomain = b);return hl(a || {});
    });
  };function ll(a, b) {
    this.a = a;this.b = b || rj();this.c = null;this.f = ml(this);vj(this.b, yj("local"), this.a, r(this.g, this));
  }ll.prototype.g = function () {
    var a = this,
        b = yj("local");nl(this, function () {
      return A().then(function () {
        return a.c && "local" != a.c.C ? a.b.get(b, a.a) : null;
      }).then(function (c) {
        if (c) return ol(a, "local").then(function () {
          a.c = b;
        });
      });
    });
  };function ol(a, b) {
    var c = [],
        d;for (d in nj) {
      nj[d] !== b && c.push(uj(a.b, yj(nj[d]), a.a));
    }c.push(uj(a.b, pl, a.a));return Nb(c);
  }
  function ml(a) {
    var b = yj("local"),
        c = yj("session"),
        d = yj("none");return a.b.get(c, a.a).then(function (e) {
      return e ? c : a.b.get(d, a.a).then(function (c) {
        return c ? d : a.b.get(b, a.a).then(function (c) {
          return c ? b : a.b.get(pl, a.a).then(function (a) {
            return a ? yj(a) : b;
          });
        });
      });
    }).then(function (b) {
      a.c = b;return ol(a, b.C);
    }).s(function () {
      a.c || (a.c = b);
    });
  }var pl = { name: "persistence", C: "session" };function yj(a) {
    return { name: "authUser", C: a };
  }
  ll.prototype.eb = function (a) {
    var b = null,
        c = this;oj(a);return nl(this, function () {
      return a != c.c.C ? c.b.get(c.c, c.a).then(function (d) {
        b = d;return ol(c, a);
      }).then(function () {
        c.c = yj(a);if (b) return c.b.set(c.c, b, c.a);
      }) : A();
    });
  };function ql(a) {
    return nl(a, function () {
      return a.b.set(pl, a.c.C, a.a);
    });
  }function rl(a, b) {
    return nl(a, function () {
      return a.b.set(a.c, b.B(), a.a);
    });
  }function sl(a) {
    return nl(a, function () {
      return uj(a.b, a.c, a.a);
    });
  }
  function tl(a, b) {
    return nl(a, function () {
      return a.b.get(a.c, a.a).then(function (a) {
        a && b && (a.authDomain = b);return hl(a || {});
      });
    });
  }function nl(a, b) {
    a.f = a.f.then(b, b);return a.f;
  };function ul(a) {
    this.l = !1;M(this, "app", a);if (S(this).options && S(this).options.apiKey) a = firebase.SDK_VERSION ? Of(firebase.SDK_VERSION) : null, this.c = new Ch(S(this).options && S(this).options.apiKey, xi(yi), a);else throw new N("invalid-api-key");this.N = [];this.m = [];this.I = [];this.Gb = firebase.INTERNAL.createSubscribe(r(this.Xb, this));this.R = void 0;this.Hb = firebase.INTERNAL.createSubscribe(r(this.Yb, this));vl(this, null);this.h = new ll(S(this).options.apiKey + ":" + S(this).name);this.G = new jl(S(this).options.apiKey + ":" + S(this).name);this.U = T(this, wl(this));this.i = T(this, xl(this));this.W = !1;this.ha = r(this.uc, this);this.Ga = r(this.ka, this);this.pa = r(this.Pb, this);this.qa = r(this.Vb, this);this.ra = r(this.Wb, this);yl(this);this.INTERNAL = {};this.INTERNAL["delete"] = r(this.delete, this);this.INTERNAL.logFramework = r(this.cc, this);this.o = 0;F.call(this);zl(this);this.A = [];
  }t(ul, F);function Al(a) {
    C.call(this, "languageCodeChanged");this.h = a;
  }t(Al, C);function Bl(a) {
    C.call(this, "frameworkChanged");this.f = a;
  }t(Bl, C);h = ul.prototype;
  h.eb = function (a) {
    a = this.h.eb(a);return T(this, a);
  };h.na = function (a) {
    this.V === a || this.l || (this.V = a, Ih(this.c, this.V), G(this, new Al(this.$())));
  };h.$ = function () {
    return this.V;
  };h.Ac = function () {
    var a = k.navigator;this.na(a ? a.languages && a.languages[0] || a.language || a.userLanguage || null : null);
  };h.cc = function (a) {
    this.A.push(a);Jh(this.c, firebase.SDK_VERSION ? Of(firebase.SDK_VERSION, this.A) : null);G(this, new Bl(this.A));
  };h.Ka = function () {
    return La(this.A);
  };
  function zl(a) {
    Object.defineProperty(a, "lc", { get: function get() {
        return this.$();
      }, set: function set(a) {
        this.na(a);
      }, enumerable: !1 });a.V = null;
  }h.toJSON = function () {
    return { apiKey: S(this).options.apiKey, authDomain: S(this).options.authDomain, appName: S(this).name, currentUser: U(this) && U(this).B() };
  };function Cl(a) {
    return a.Fb || B(new N("auth-domain-config-required"));
  }
  function yl(a) {
    var b = S(a).options.authDomain,
        c = S(a).options.apiKey;b && Rf() && (a.Fb = a.U.then(function () {
      if (!a.l) {
        a.a = gk(b, c, S(a).name);a.a.subscribe(a);U(a) && Nk(U(a));if (a.w) {
          Nk(a.w);var d = a.w;d.na(a.$());Gk(d, a);d = a.w;Fk(d, a.A);Hk(d, a);a.w = null;
        }return a.a;
      }
    }));
  }h.ob = function (a, b) {
    switch (a) {case "unknown":case "signInViaRedirect":
        return !0;case "signInViaPopup":
        return this.g == b && !!this.f;default:
        return !1;}
  };
  h.fa = function (a, b, c, d) {
    "signInViaPopup" == a && this.g == d && (c && this.v ? this.v(c) : b && !c && this.f && this.f(b), this.b && (this.b.cancel(), this.b = null), delete this.f, delete this.v);
  };h.va = function (a, b) {
    return "signInViaRedirect" == a || "signInViaPopup" == a && this.g == b && this.f ? r(this.Ob, this) : null;
  };
  h.Ob = function (a, b) {
    var c = this;a = { requestUri: a, sessionId: b };this.b && (this.b.cancel(), this.b = null);var d = null,
        e = null,
        f = Xg(c.c, a).then(function (a) {
      d = uh(a);e = Mg(a);return a;
    });a = c.U.then(function () {
      return f;
    }).then(function (a) {
      return Dl(c, a);
    }).then(function () {
      return hg({ user: U(c), credential: d, additionalUserInfo: e, operationType: "signIn" });
    });return T(this, a);
  };
  h.sc = function (a) {
    if (!Rf()) return B(new N("operation-not-supported-in-this-environment"));var b = this,
        c = Lg(a.providerId),
        d = Qf(),
        e = null;(!Tf() || Lf()) && S(this).options.authDomain && a.isOAuthProvider && (e = Ri(S(this).options.authDomain, S(this).options.apiKey, S(this).name, "signInViaPopup", a, null, d, firebase.SDK_VERSION || null));var f = Df(e, c && c.za, c && c.ya);c = Cl(this).then(function (b) {
      return ek(b, f, "signInViaPopup", a, d, !!e);
    }).then(function () {
      return new z(function (a, c) {
        b.fa("signInViaPopup", null, new N("cancelled-popup-request"), b.g);b.f = a;b.v = c;b.g = d;b.b = b.a.Ca(b, "signInViaPopup", f, d);
      });
    }).then(function (a) {
      f && Cf(f);return a ? hg(a) : null;
    }).s(function (a) {
      f && Cf(f);throw a;
    });return T(this, c);
  };h.tc = function (a) {
    if (!Rf()) return B(new N("operation-not-supported-in-this-environment"));var b = this,
        c = Cl(this).then(function () {
      return ql(b.h);
    }).then(function () {
      return b.a.Aa("signInViaRedirect", a);
    });return T(this, c);
  };
  h.aa = function () {
    if (!Rf()) return B(new N("operation-not-supported-in-this-environment"));var a = this,
        b = Cl(this).then(function () {
      return a.a.aa();
    }).then(function (a) {
      return a ? hg(a) : null;
    });return T(this, b);
  };function Dl(a, b) {
    var c = {};c.apiKey = S(a).options.apiKey;c.authDomain = S(a).options.authDomain;c.appName = S(a).name;return a.U.then(function () {
      return il(c, b, a.G, a.Ka());
    }).then(function (b) {
      if (U(a) && b.uid == U(a).uid) return Uk(U(a), b), a.ka(b);vl(a, b);Nk(b);return a.ka(b);
    }).then(function () {
      El(a);
    });
  }
  function vl(a, b) {
    U(a) && (Lk(U(a), a.Ga), E(U(a), "tokenChanged", a.pa), E(U(a), "userDeleted", a.qa), E(U(a), "userInvalidated", a.ra), Kk(U(a)));b && (b.N.push(a.Ga), cd(b, "tokenChanged", a.pa), cd(b, "userDeleted", a.qa), cd(b, "userInvalidated", a.ra), 0 < a.o && Jk(b));M(a, "currentUser", b);b && (b.na(a.$()), Gk(b, a), Fk(b, a.A), Hk(b, a));
  }h.hb = function () {
    var a = this,
        b = this.i.then(function () {
      if (!U(a)) return A();vl(a, null);return sl(a.h).then(function () {
        El(a);
      });
    });return T(this, b);
  };
  function Fl(a) {
    var b = kl(a.G, S(a).options.authDomain).then(function (b) {
      if (a.w = b) b.ca = a.G;return fl(a.G);
    });return T(a, b);
  }function wl(a) {
    var b = S(a).options.authDomain,
        c = Fl(a).then(function () {
      return tl(a.h, b);
    }).then(function (b) {
      return b ? (b.ca = a.G, a.w && (a.w.Z || null) == (b.Z || null) ? b : b.reload().then(function () {
        return rl(a.h, b).then(function () {
          return b;
        });
      }).s(function (c) {
        return "auth/network-request-failed" == c.code ? b : sl(a.h);
      })) : null;
    }).then(function (b) {
      vl(a, b || null);
    });return T(a, c);
  }
  function xl(a) {
    return a.U.then(function () {
      return a.aa();
    }).s(function () {}).then(function () {
      if (!a.l) return a.ha();
    }).s(function () {}).then(function () {
      if (!a.l) {
        a.W = !0;var b = a.h;vj(b.b, yj("local"), b.a, a.ha);
      }
    });
  }
  h.uc = function () {
    var a = this;return tl(this.h, S(this).options.authDomain).then(function (b) {
      if (!a.l) {
        var c;if (c = U(a) && b) {
          c = U(a).uid;var d = b.uid;c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
        }if (c) return Uk(U(a), b), U(a).F();if (U(a) || b) vl(a, b), b && (Nk(b), b.ca = a.G), a.a && a.a.subscribe(a), El(a);
      }
    });
  };h.ka = function (a) {
    return rl(this.h, a);
  };h.Pb = function () {
    El(this);this.ka(U(this));
  };h.Vb = function () {
    this.hb();
  };h.Wb = function () {
    this.hb();
  };
  function Gl(a, b) {
    var c = null,
        d = null;return T(a, b.then(function (b) {
      c = uh(b);d = Mg(b);return Dl(a, b);
    }).then(function () {
      return hg({ user: U(a), credential: c, additionalUserInfo: d, operationType: "signIn" });
    }));
  }h.Xb = function (a) {
    var b = this;this.addAuthTokenListener(function () {
      a.next(U(b));
    });
  };h.Yb = function (a) {
    var b = this;Hl(this, function () {
      a.next(U(b));
    });
  };h.ec = function (a, b, c) {
    var d = this;this.W && firebase.Promise.resolve().then(function () {
      p(a) ? a(U(d)) : p(a.next) && a.next(U(d));
    });return this.Gb(a, b, c);
  };
  h.dc = function (a, b, c) {
    var d = this;this.W && firebase.Promise.resolve().then(function () {
      d.R = d.getUid();p(a) ? a(U(d)) : p(a.next) && a.next(U(d));
    });return this.Hb(a, b, c);
  };h.Rb = function (a) {
    var b = this,
        c = this.i.then(function () {
      return U(b) ? U(b).F(a).then(function (a) {
        return { accessToken: a };
      }) : null;
    });return T(this, c);
  };h.pc = function (a) {
    var b = this;return this.i.then(function () {
      return Gl(b, Q(b.c, vi, { token: a }));
    }).then(function (a) {
      a = a.user;Tk(a, "isAnonymous", !1);return b.ka(a);
    }).then(function () {
      return U(b);
    });
  };
  h.qc = function (a, b) {
    var c = this;return this.i.then(function () {
      return Gl(c, Q(c.c, kh, { email: a, password: b }));
    }).then(function (a) {
      return a.user;
    });
  };h.Kb = function (a, b) {
    var c = this;return this.i.then(function () {
      return Gl(c, Q(c.c, ri, { email: a, password: b }));
    }).then(function (a) {
      return a.user;
    });
  };h.oc = function (a) {
    return this.fb(a).then(function (a) {
      return a.user;
    });
  };h.fb = function (a) {
    var b = this;return this.i.then(function () {
      return Gl(b, a.wa(b.c));
    });
  };
  h.gb = function () {
    var a = this;return this.i.then(function () {
      var b = U(a);return b && b.isAnonymous ? b : Gl(a, a.c.gb()).then(function (b) {
        b = b.user;Tk(b, "isAnonymous", !0);return a.ka(b);
      }).then(function () {
        return U(a);
      });
    });
  };function S(a) {
    return a.app;
  }function U(a) {
    return a.currentUser;
  }h.getUid = function () {
    return U(this) && U(this).uid || null;
  };function Il(a) {
    return U(a) && U(a)._lat || null;
  }
  function El(a) {
    if (a.W) {
      for (var b = 0; b < a.m.length; b++) {
        if (a.m[b]) a.m[b](Il(a));
      }if (a.R !== a.getUid() && a.I.length) for (a.R = a.getUid(), b = 0; b < a.I.length; b++) {
        if (a.I[b]) a.I[b](Il(a));
      }
    }
  }h.Ib = function (a) {
    this.addAuthTokenListener(a);this.o++;0 < this.o && U(this) && Jk(U(this));
  };h.mc = function (a) {
    var b = this;w(this.m, function (c) {
      c == a && b.o--;
    });0 > this.o && (this.o = 0);0 == this.o && U(this) && Kk(U(this));this.removeAuthTokenListener(a);
  };
  h.addAuthTokenListener = function (a) {
    var b = this;this.m.push(a);T(this, this.i.then(function () {
      b.l || Ha(b.m, a) && a(Il(b));
    }));
  };h.removeAuthTokenListener = function (a) {
    Ja(this.m, function (b) {
      return b == a;
    });
  };function Hl(a, b) {
    a.I.push(b);T(a, a.i.then(function () {
      !a.l && Ha(a.I, b) && a.R !== a.getUid() && (a.R = a.getUid(), b(Il(a)));
    }));
  }h.delete = function () {
    this.l = !0;for (var a = 0; a < this.N.length; a++) {
      this.N[a].cancel("app-deleted");
    }this.N = [];this.h && (a = this.h, xj(a.b, a.a, this.ha));this.a && this.a.unsubscribe(this);return firebase.Promise.resolve();
  };
  function T(a, b) {
    a.N.push(b);Qb(b, function () {
      Ia(a.N, b);
    });return b;
  }h.Nb = function (a) {
    return T(this, Th(this.c, a));
  };h.Bc = function (a) {
    return this.Ia(a).then(function (a) {
      return a.data.email;
    });
  };h.Ta = function (a, b) {
    return T(this, this.c.Ta(a, b).then(function () {}));
  };h.Ia = function (a) {
    return T(this, this.c.Ia(a).then(function (a) {
      return new lg(a);
    }));
  };h.Sa = function (a) {
    return T(this, this.c.Sa(a).then(function () {}));
  };
  h.cb = function (a, b) {
    var c = this;return T(this, A().then(function () {
      return "undefined" === typeof b || Sa(b) ? {} : Fg(new wg(b));
    }).then(function (b) {
      return c.c.cb(a, b);
    }).then(function () {}));
  };h.rc = function (a, b) {
    return T(this, ok(this, a, b, r(this.fb, this)));
  };function Jl(a, b, c, d) {
    a: {
      c = Array.prototype.slice.call(c);var e = 0;for (var f = !1, g = 0; g < b.length; g++) {
        if (b[g].optional) f = !0;else {
          if (f) throw new N("internal-error", "Argument validator encountered a required argument after an optional argument.");e++;
        }
      }f = b.length;if (c.length < e || f < c.length) d = "Expected " + (e == f ? 1 == e ? "1 argument" : e + " arguments" : e + "-" + f + " arguments") + " but got " + c.length + ".";else {
        for (e = 0; e < c.length; e++) {
          if (f = b[e].optional && void 0 === c[e], !b[e].M(c[e]) && !f) {
            b = b[e];if (0 > e || e >= Kl.length) throw new N("internal-error", "Argument validator received an unsupported number of arguments.");c = Kl[e];d = (d ? "" : c + " argument ") + (b.name ? '"' + b.name + '" ' : "") + "must be " + b.K + ".";break a;
          }
        }d = null;
      }
    }if (d) throw new N("argument-error", a + " failed: " + d);
  }var Kl = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a, b) {
    return { name: a || "", K: "a valid string", optional: !!b, M: m };
  }function Ll() {
    return { name: "opt_forceRefresh", K: "a boolean", optional: !0, M: ba };
  }
  function W(a, b) {
    return { name: a || "", K: "a valid object", optional: !!b, M: q };
  }function Ml(a, b) {
    return { name: a || "", K: "a function", optional: !!b, M: p };
  }function Nl(a, b) {
    return { name: a || "", K: "null", optional: !!b, M: ea };
  }function Ol() {
    return { name: "", K: "an HTML element", optional: !1, M: function M(a) {
        return !!(a && a instanceof Element);
      } };
  }function Pl() {
    return { name: "auth", K: "an instance of Firebase Auth", optional: !0, M: function M(a) {
        return !!(a && a instanceof ul);
      } };
  }
  function Ql() {
    return { name: "app", K: "an instance of Firebase App", optional: !0, M: function M(a) {
        return !!(a && a instanceof firebase.app.App);
      } };
  }function Rl(a) {
    return { name: a ? a + "Credential" : "credential", K: a ? "a valid " + a + " credential" : "a valid credential", optional: !1, M: function M(b) {
        if (!b) return !1;var c = !a || b.providerId === a;return !(!b.wa || !c);
      } };
  }
  function Sl() {
    return { name: "authProvider", K: "a valid Auth provider", optional: !1, M: function M(a) {
        return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
      } };
  }function Tl() {
    return { name: "applicationVerifier", K: "an implementation of firebase.auth.ApplicationVerifier", optional: !1, M: function M(a) {
        return !!(a && m(a.type) && p(a.verify));
      } };
  }function X(a, b, c, d) {
    return { name: c || "", K: a.K + " or " + b.K, optional: !!d, M: function M(c) {
        return a.M(c) || b.M(c);
      } };
  };function Ul(a, b, c, d, e, f) {
    M(this, "type", "recaptcha");this.b = this.c = null;this.m = !1;this.l = b;this.a = c || { theme: "light", type: "image" };this.g = [];if (this.a[Vl]) throw new N("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.h = "invisible" === this.a[Wl];if (!wc(b) || !this.h && wc(b).hasChildNodes()) throw new N("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");this.u = new Ch(a, f || null, e || null);
    this.o = d || function () {
      return null;
    };var g = this;this.i = [];var l = this.a[Xl];this.a[Xl] = function (a) {
      Yl(g, a);if ("function" === typeof l) l(a);else if ("string" === typeof l) {
        var b = L(l, k);"function" === typeof b && b(a);
      }
    };var n = this.a[Zl];this.a[Zl] = function () {
      Yl(g, null);if ("function" === typeof n) n();else if ("string" === typeof n) {
        var a = L(n, k);"function" === typeof a && a();
      }
    };
  }var Xl = "callback",
      Zl = "expired-callback",
      Vl = "sitekey",
      Wl = "size";function Yl(a, b) {
    for (var c = 0; c < a.i.length; c++) {
      try {
        a.i[c](b);
      } catch (d) {}
    }
  }
  function $l(a, b) {
    Ja(a.i, function (a) {
      return a == b;
    });
  }function am(a, b) {
    a.g.push(b);Qb(b, function () {
      Ia(a.g, b);
    });return b;
  }h = Ul.prototype;
  h.xa = function () {
    var a = this;return this.c ? this.c : this.c = am(this, A().then(function () {
      if (Sf()) return Hf();throw new N("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
    }).then(function () {
      return bm(cm(), a.o());
    }).then(function () {
      return Q(a.u, ui, {});
    }).then(function (b) {
      a.a[Vl] = b.recaptchaSiteKey;
    }).s(function (b) {
      a.c = null;throw b;
    }));
  };
  h.render = function () {
    dm(this);var a = this;return am(this, this.xa().then(function () {
      if (null === a.b) {
        var b = a.l;if (!a.h) {
          var c = wc(b);b = zc("DIV");c.appendChild(b);
        }a.b = grecaptcha.render(b, a.a);
      }return a.b;
    }));
  };h.verify = function () {
    dm(this);var a = this;return am(this, this.render().then(function (b) {
      return new z(function (c) {
        var d = grecaptcha.getResponse(b);if (d) c(d);else {
          var e = function e(b) {
            b && ($l(a, e), c(b));
          };a.i.push(e);a.h && grecaptcha.execute(a.b);
        }
      });
    }));
  };h.reset = function () {
    dm(this);null !== this.b && grecaptcha.reset(this.b);
  };
  function dm(a) {
    if (a.m) throw new N("internal-error", "RecaptchaVerifier instance has been destroyed.");
  }h.clear = function () {
    dm(this);this.m = !0;cm().b--;for (var a = 0; a < this.g.length; a++) {
      this.g[a].cancel("RecaptchaVerifier instance has been destroyed.");
    }if (!this.h) {
      a = wc(this.l);for (var b; b = a.firstChild;) {
        a.removeChild(b);
      }
    }
  };var em = dc("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}");
  function fm() {
    this.b = k.grecaptcha ? Infinity : 0;this.c = null;this.a = "__rcb" + Math.floor(1E6 * Math.random()).toString();
  }
  function bm(a, b) {
    return new z(function (c, d) {
      if (Zf()) {
        if (!k.grecaptcha || b !== a.c && !a.b) {
          k[a.a] = function () {
            if (k.grecaptcha) {
              a.c = b;var e = k.grecaptcha.render;k.grecaptcha.render = function (b, c) {
                b = e(b, c);a.b++;return b;
              };c();
            } else d(new N("internal-error"));delete k[a.a];
          };var e = hc(em, { onload: a.a, hl: b || "" });A(kf(e)).s(function () {
            d(new N("internal-error", "Unable to load external reCAPTCHA dependencies!"));
          });
        } else c();
      } else d(new N("network-request-failed"));
    });
  }var gm = null;
  function cm() {
    gm || (gm = new fm());return gm;
  }function hm(a, b, c) {
    try {
      this.f = c || firebase.app();
    } catch (f) {
      throw new N("argument-error", "No firebase.app.App instance is currently initialized.");
    }if (this.f.options && this.f.options.apiKey) c = this.f.options.apiKey;else throw new N("invalid-api-key");var d = this,
        e = null;try {
      e = this.f.auth().Ka();
    } catch (f) {}e = firebase.SDK_VERSION ? Of(firebase.SDK_VERSION, e) : null;Ul.call(this, c, a, b, function () {
      try {
        var a = d.f.auth().$();
      } catch (g) {
        a = null;
      }return a;
    }, e, xi(yi));
  }t(hm, Ul);function Y(a, b) {
    for (var c in b) {
      var d = b[c].name;a[d] = im(d, a[c], b[c].j);
    }
  }function Z(a, b, c, d) {
    a[b] = im(b, c, d);
  }function im(a, b, c) {
    function d() {
      var a = Array.prototype.slice.call(arguments);Jl(e, c, a);return b.apply(this, a);
    }if (!c) return b;var e = jm(a),
        f;for (f in b) {
      d[f] = b[f];
    }for (f in b.prototype) {
      d.prototype[f] = b.prototype[f];
    }return d;
  }function jm(a) {
    a = a.split(".");return a[a.length - 1];
  };Y(ul.prototype, { Sa: { name: "applyActionCode", j: [V("code")] }, Ia: { name: "checkActionCode", j: [V("code")] }, Ta: { name: "confirmPasswordReset", j: [V("code"), V("newPassword")] }, Kb: { name: "createUserWithEmailAndPassword", j: [V("email"), V("password")] }, Nb: { name: "fetchProvidersForEmail", j: [V("email")] }, aa: { name: "getRedirectResult", j: [] }, dc: { name: "onAuthStateChanged", j: [X(W(), Ml(), "nextOrObserver"), Ml("opt_error", !0), Ml("opt_completed", !0)] }, ec: { name: "onIdTokenChanged", j: [X(W(), Ml(), "nextOrObserver"), Ml("opt_error", !0), Ml("opt_completed", !0)] }, cb: { name: "sendPasswordResetEmail", j: [V("email"), X(W("opt_actionCodeSettings", !0), Nl(null, !0), "opt_actionCodeSettings", !0)] }, eb: { name: "setPersistence", j: [V("persistence")] }, fb: { name: "signInAndRetrieveDataWithCredential", j: [Rl()] }, gb: { name: "signInAnonymously", j: [] }, oc: { name: "signInWithCredential", j: [Rl()] }, pc: { name: "signInWithCustomToken", j: [V("token")] }, qc: { name: "signInWithEmailAndPassword", j: [V("email"), V("password")] }, rc: { name: "signInWithPhoneNumber", j: [V("phoneNumber"), Tl()] }, sc: { name: "signInWithPopup", j: [Sl()] }, tc: { name: "signInWithRedirect", j: [Sl()] }, hb: { name: "signOut", j: [] }, toJSON: { name: "toJSON", j: [V(null, !0)] }, Ac: { name: "useDeviceLanguage", j: [] }, Bc: { name: "verifyPasswordResetCode", j: [V("code")] } });(function (a, b) {
    for (var c in b) {
      var d = b[c].name;if (d !== c) {
        var e = b[c].Jb;Object.defineProperty(a, d, { get: function get() {
            return this[c];
          }, set: function set(a) {
            Jl(d, [e], [a], !0);this[c] = a;
          }, enumerable: !0 });
      }
    }
  })(ul.prototype, { lc: { name: "languageCode", Jb: X(V(), Nl(), "languageCode") } });
  ul.Persistence = nj;ul.Persistence.LOCAL = "local";ul.Persistence.SESSION = "session";ul.Persistence.NONE = "none";
  Y(Bk.prototype, { "delete": { name: "delete", j: [] }, F: { name: "getIdToken", j: [Ll()] }, getToken: { name: "getToken", j: [Ll()] }, Xa: { name: "linkAndRetrieveDataWithCredential", j: [Rl()] }, Zb: { name: "linkWithCredential", j: [Rl()] }, $b: { name: "linkWithPhoneNumber", j: [V("phoneNumber"), Tl()] }, ac: { name: "linkWithPopup", j: [Sl()] }, bc: { name: "linkWithRedirect", j: [Sl()] }, Za: { name: "reauthenticateAndRetrieveDataWithCredential", j: [Rl()] }, hc: { name: "reauthenticateWithCredential", j: [Rl()] }, ic: { name: "reauthenticateWithPhoneNumber", j: [V("phoneNumber"), Tl()] }, jc: { name: "reauthenticateWithPopup", j: [Sl()] }, kc: { name: "reauthenticateWithRedirect", j: [Sl()] }, reload: { name: "reload", j: [] }, bb: { name: "sendEmailVerification", j: [X(W("opt_actionCodeSettings", !0), Nl(null, !0), "opt_actionCodeSettings", !0)] }, toJSON: { name: "toJSON", j: [V(null, !0)] }, yc: { name: "unlink", j: [V("provider")] }, kb: { name: "updateEmail", j: [V("email")] }, lb: { name: "updatePassword", j: [V("password")] }, zc: { name: "updatePhoneNumber", j: [Rl("phone")] }, mb: { name: "updateProfile", j: [W("profile")] } });
  Y(z.prototype, { s: { name: "catch" }, then: { name: "then" } });Y(nk.prototype, { confirm: { name: "confirm", j: [V("verificationCode")] } });Z(mh, "credential", function (a, b) {
    return new jh(a, b);
  }, [V("email"), V("password")]);Y(bh.prototype, { sa: { name: "addScope", j: [V("scope")] }, Ba: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(bh, "credential", ch, [X(V(), W(), "token")]);Y(dh.prototype, { sa: { name: "addScope", j: [V("scope")] }, Ba: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });
  Z(dh, "credential", eh, [X(V(), W(), "token")]);Y(fh.prototype, { sa: { name: "addScope", j: [V("scope")] }, Ba: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(fh, "credential", gh, [X(V(), X(W(), Nl()), "idToken"), X(V(), Nl(), "accessToken", !0)]);Y(hh.prototype, { Ba: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(hh, "credential", ih, [X(V(), W(), "token"), V("secret", !0)]);
  Y(P.prototype, { sa: { name: "addScope", j: [V("scope")] }, credential: { name: "credential", j: [X(V(), Nl(), "idToken", !0), X(V(), Nl(), "accessToken", !0)] }, Ba: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(rh, "credential", th, [V("verificationId"), V("verificationCode")]);Y(rh.prototype, { Qa: { name: "verifyPhoneNumber", j: [V("phoneNumber"), Tl()] } });Y(N.prototype, { toJSON: { name: "toJSON", j: [V(null, !0)] } });Y(zh.prototype, { toJSON: { name: "toJSON", j: [V(null, !0)] } });
  Y(yh.prototype, { toJSON: { name: "toJSON", j: [V(null, !0)] } });Y(hm.prototype, { clear: { name: "clear", j: [] }, render: { name: "render", j: [] }, verify: { name: "verify", j: [] } });
  (function () {
    if ("undefined" !== typeof firebase && firebase.INTERNAL && firebase.INTERNAL.registerService) {
      var a = { Auth: ul, Error: N };Z(a, "EmailAuthProvider", mh, []);Z(a, "FacebookAuthProvider", bh, []);Z(a, "GithubAuthProvider", dh, []);Z(a, "GoogleAuthProvider", fh, []);Z(a, "TwitterAuthProvider", hh, []);Z(a, "OAuthProvider", P, [V("providerId")]);Z(a, "PhoneAuthProvider", rh, [Pl()]);Z(a, "RecaptchaVerifier", hm, [X(V(), Ol(), "recaptchaContainer"), W("recaptchaParameters", !0), Ql()]);firebase.INTERNAL.registerService("auth", function (a, c) {
        a = new ul(a);c({ INTERNAL: { getUid: r(a.getUid, a), getToken: r(a.Rb, a), addAuthTokenListener: r(a.Ib, a), removeAuthTokenListener: r(a.mc, a) } });return a;
      }, a, function (a, c) {
        if ("create" === a) try {
          c.auth();
        } catch (d) {}
      });firebase.INTERNAL.extendNamespace({ User: Bk });
    } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
  })();
}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "SUTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise__ = __webpack_require__("CWxw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shims_find__ = __webpack_require__("YsRl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shims_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_shims_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex__ = __webpack_require__("ZV5m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex__);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "SenR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var hash_1 = __webpack_require__("TGDM");
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */function (_super) {
    __extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] = buf.charCodeAt(opt_offset) << 24 | buf.charCodeAt(opt_offset + 1) << 16 | buf.charCodeAt(opt_offset + 2) << 8 | buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        } else {
            for (var i = 0; i < 16; i++) {
                W[i] = buf[opt_offset] << 24 | buf[opt_offset + 1] << 16 | buf[opt_offset + 2] << 8 | buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else {
                if (i < 60) {
                    f = b & c | d & (b | c);
                    k = 0x8f1bbcdc;
                } else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            } else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        } else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = this.chain_[i] >> j & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(hash_1.Hash);
exports.Sha1 = Sha1;

//# sourceMappingURL=sha1.js.map

/***/ }),

/***/ "TGDM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */function () {
  function Hash() {
    /**
     * The block size for the hasher.
     * @type {number}
     */
    this.blockSize = -1;
  }
  return Hash;
}();
exports.Hash = Hash;

//# sourceMappingURL=hash.js.map

/***/ }),

/***/ "UQex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "VKRH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"list__3Avq8","search":"search__2wcWR"};

/***/ }),

/***/ "W5gc":
/***/ (function(module, exports, __webpack_require__) {

var api = {};

if (typeof window !== "undefined") {
    var firebase = __webpack_require__("niZR");
    var firebaseui = __webpack_require__("No41");
    __webpack_require__("RFlV");
    __webpack_require__("n5gG");

    var highscoreLength = 25;

    var config = {
        apiKey: "AIzaSyBPDPqc5sdeCsQAeY6UsRSkiy2s5QDZkOQ",
        authDomain: "geo-training-608f8.firebaseapp.com",
        databaseURL: "https://geo-training-608f8.firebaseio.com",
        projectId: "geo-training-608f8",
        storageBucket: "geo-training-608f8.appspot.com",
        messagingSenderId: "4678400504"
    };

    var app = firebase.initializeApp(config);

    // Initialize Cloud Firestore through Firebase
    var db = firebase.firestore();

    api.persistHighscore = function (uid, identifier, name, points) {
        return new Promise(function (resolve) {
            var ref = db.collection("games").doc(identifier).collection("users").doc(uid);
            ref.get().then(function (doc) {
                if (doc.exists) {
                    var data = doc.data();
                    if (data.points < points) {
                        ref.set({ name: name, points: points, tries: data.tries + 1 }).then(function () {
                            return resolve();
                        });
                    } else {
                        resolve();
                    }
                } else {
                    ref.set({ name: name, points: points, tries: 1 }).then(function () {
                        return resolve();
                    });
                }
            });
        });
    };

    api.persistAnonymousHighscore = function (identifier, points) {
        return new Promise(function (resolve) {
            var timestamp = Date.now();
            var ref = db.collection("games").doc(identifier).collection("anonymous").doc(timestamp.toString());
            ref.set({ points: points, timestamp: timestamp }).then(function () {
                return resolve();
            });
        });
    };

    api.getHighscoreIdentifiert = function (stateNumber, townName, gameName) {
        var postfix = "";
        if (gameName !== 'street') {
            postfix = "-" + gameName;
        }
        return stateNumber + "-" + townName + postfix;
    };

    api.loadHighscore = function (identifier) {
        return new Promise(function (resolve) {
            var userRef = db.collection("games").doc(identifier).collection("users");
            var userQuery = userRef.where("points", ">", 0).orderBy("points", "desc").limit(highscoreLength);
            var anonymousRef = db.collection("games").doc(identifier).collection("anonymous");
            var anonymousQuery = anonymousRef.where("points", ">", 0).orderBy("points", "desc").limit(highscoreLength);
            Promise.all([userQuery.get(), anonymousQuery.get()]).then(function (_ref) {
                var userSnapshot = _ref[0],
                    anonymousSnapshot = _ref[1];

                var highscore = [];
                userSnapshot.forEach(function (doc) {
                    return highscore.push(doc.data());
                });
                anonymousSnapshot.forEach(function (doc) {
                    if (highscore.length < highscoreLength) {
                        var data = doc.data();
                        data.name = "Nicht angemeldet";
                        highscore.push(data);
                    }
                });

                highscore.sort(function (a, b) {
                    return b.points - a.points;
                });
                resolve(highscore);
            });
        });
    };

    /*
     function loadMostPopularByUser() {
     return new Promise((resolve) => {
     const ref = db.collection("games")
     const query = ref.where("tries", ">=", 0).orderBy("tries").limit(50);
     query.get().then(function(querySnapshot) {
     const highscore = [];
     querySnapshot.forEach((doc) => highscore.push(doc.data()));
     resolve(highscore);
     });
     });
     }
     */
    // Initialize the FirebaseUI Widget using Firebase.
    var authUi = new firebaseui.auth.AuthUI(firebase.auth());

    // FirebaseUI config.
    var uiConfig = {
        signInSuccessUrl: '/',
        signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        //firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        // firebase.auth.GithubAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID],
        // Terms of service url.
        tosUrl: '/'
    };

    api.startAuthUi = function (selector) {
        authUi.start(selector, uiConfig);
    };

    api.getUser = function (callback) {
        return firebase.auth().onAuthStateChanged(callback);
    };

    api.signOut = function () {
        return firebase.auth().signOut();
    };

    api.updateUser = function (_ref2) {
        var displayName = _ref2.displayName;

        var user = firebase.auth().currentUser;

        return user.updateProfile({
            displayName: displayName
        });
    };
} else {
    api.getUser = function (callback) {
        callback("user");
    };
    api.updateUser = function () {};
    api.signOut = function () {};
    api.getHighscoreIdentifiert = function () {};
    api.persistHighscore = function () {};
    api.persistAnonymousHighscore = function () {};
    api.loadHighscore = function () {};
    api.startAuthUi = function () {};
}

module.exports = api;

/***/ }),

/***/ "YsRl":
/***/ (function(module, exports) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This is the Array.prototype.find polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * https://tc39.github.io/ecma262/#sec-array.prototype.find
 */
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function value(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return undefined.
            return undefined;
        }
    });
}

//# sourceMappingURL=find.js.map

/***/ }),

/***/ "Z70r":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
  if (true) module.exports = factory(__webpack_require__("eW0v"), __webpack_require__("5D9O"), __webpack_require__("J4Nk"));else if (typeof define === 'function' && define.amd) define(["react", "prop-types", "object-assign"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("object-assign")) : factory(root["react"], root["prop-types"], root["object-assign"]);
    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(this, function (__WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 2);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = warn;
      function warn(s) {
        console.warn('[react-ga]', s);
      }

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = trim;
      // GA strings need to have leading/trailing whitespace trimmed, and not all
      // browsers have String.prototoype.trim().

      function trim(s) {
        return s.replace(/^\s+|\s+$/g, '');
      }

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.OutboundLink = exports.plugin = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.initialize = initialize;
      exports.ga = ga;
      exports.set = set;
      exports.send = send;
      exports.pageview = pageview;
      exports.modalview = modalview;
      exports.timing = timing;
      exports.event = event;
      exports.exception = exception;
      exports.outboundLink = outboundLink;

      var _format2 = __webpack_require__(3);

      var _format3 = _interopRequireDefault(_format2);

      var _removeLeadingSlash = __webpack_require__(6);

      var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

      var _trim = __webpack_require__(1);

      var _trim2 = _interopRequireDefault(_trim);

      var _loadGA = __webpack_require__(7);

      var _loadGA2 = _interopRequireDefault(_loadGA);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      var _log = __webpack_require__(8);

      var _log2 = _interopRequireDefault(_log);

      var _OutboundLink = __webpack_require__(9);

      var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
        }return target;
      }

      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }return arr2;
        } else {
          return Array.from(arr);
        }
      } /**
         * React Google Analytics Module
         *
         * @package react-ga
         * @author  Adam Lofting <adam@mozillafoundation.org>
         *          Atul Varma <atul@mozillafoundation.org>
         */

      /**
       * Utilities
       */

      var _debug = false;
      var _titleCase = true;

      var internalGa = function internalGa() {
        (0, _warn2.default)('ReactGA.initialize must be called first');
      };

      function _format(s) {
        return (0, _format3.default)(s, _titleCase);
      }

      function _gaCommand(trackerNames) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var command = args[0];
        if (typeof internalGa === 'function') {
          if (typeof command !== 'string') {
            (0, _warn2.default)('ga command must be a string');
            return;
          }

          internalGa.apply(undefined, args);
          if (Array.isArray(trackerNames)) {
            trackerNames.forEach(function (name) {
              internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
            });
          }
        }
      }

      function _initialize(gaTrackingID, options) {
        if (!gaTrackingID) {
          (0, _warn2.default)('gaTrackingID is required in initialize()');
          return;
        }

        if (options) {
          if (options.debug && options.debug === true) {
            _debug = true;
          }

          if (options.titleCase === false) {
            _titleCase = false;
          }
        }

        if (options && options.gaOptions) {
          internalGa('create', gaTrackingID, options.gaOptions);
        } else {
          internalGa('create', gaTrackingID, 'auto');
        }
      }

      function initialize(configs, options) {
        if (typeof window === 'undefined') {
          return false;
        }

        (0, _loadGA2.default)();
        internalGa = function internalGa() {
          var _window;

          return (_window = window).ga.apply(_window, arguments);
        };

        if (Array.isArray(configs)) {
          configs.forEach(function (config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
              (0, _warn2.default)('All configs must be an object');
              return;
            }
            _initialize(config.trackingId, config);
          });
        } else {
          _initialize(configs, options);
        }
        return true;
      }

      /**
       * ga:
       * Returns the original GA object.
       */
      function ga() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (args.length > 0) {
          internalGa.apply(undefined, args);
          if (_debug) {
            (0, _log2.default)('called ga(\'arguments\');');
            (0, _log2.default)('with arguments: ' + JSON.stringify(args));
          }
        }

        return window.ga;
      }

      /**
       * set:
       * GA tracker set method
       * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function set(fieldsObject, trackerNames) {
        if (!fieldsObject) {
          (0, _warn2.default)('`fieldsObject` is required in .set()');
          return;
        }

        if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
          (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
          return;
        }

        if (Object.keys(fieldsObject).length === 0) {
          (0, _warn2.default)('empty `fieldsObject` given to .set()');
        }

        _gaCommand(trackerNames, 'set', fieldsObject);

        if (_debug) {
          (0, _log2.default)('called ga(\'set\', fieldsObject);');
          (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
        }
      }

      /**
       * send:
       * Clone of the low level `ga.send` method
       * WARNING: No validations will be applied to this
       * @param  {Object} fieldObject - field object for tracking different analytics
       * @param  {Array} trackerNames - trackers to send the command to
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function send(fieldObject, trackerNames) {
        _gaCommand(trackerNames, 'send', fieldObject);
        if (_debug) {
          (0, _log2.default)('called ga(\'send\', fieldObject);');
          (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
          (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
        }
      }

      /**
       * pageview:
       * Basic GA pageview tracking
       * @param  {String} path - the current page page e.g. '/about'
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function pageview(rawPath, trackerNames) {
        if (!rawPath) {
          (0, _warn2.default)('path is required in .pageview()');
          return;
        }

        var path = (0, _trim2.default)(rawPath);
        if (path === '') {
          (0, _warn2.default)('path cannot be an empty string in .pageview()');
          return;
        }

        if (typeof ga === 'function') {
          _gaCommand(trackerNames, 'send', 'pageview', path);

          if (_debug) {
            (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
            (0, _log2.default)('with path: ' + path);
          }
        }
      }

      /**
       * modalview:
       * a proxy to basic GA pageview tracking to consistently track
       * modal views that are an equivalent UX to a traditional pageview
       * @param  {String} modalName e.g. 'add-or-edit-club'
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function modalview(rawModalName, trackerNames) {
        if (!rawModalName) {
          (0, _warn2.default)('modalName is required in .modalview(modalName)');
          return;
        }

        var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

        if (modalName === '') {
          (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
          return;
        }

        if (typeof ga === 'function') {
          var path = '/modal/' + modalName;
          _gaCommand(trackerNames, 'send', 'pageview', path);

          if (_debug) {
            (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
            (0, _log2.default)('with path: ' + path);
          }
        }
      }

      /**
       * timing:
       * GA timing
       * @param args.category {String} required
       * @param args.variable {String} required
       * @param args.value  {Int}  required
       * @param args.label  {String} required
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function timing() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            category = _ref.category,
            variable = _ref.variable,
            value = _ref.value,
            label = _ref.label;

        var trackerNames = arguments[1];

        if (typeof ga === 'function') {
          if (!category || !variable || !value || typeof value !== 'number') {
            (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'timing',
            timingCategory: _format(category),
            timingVar: _format(variable),
            timingValue: value
          };

          if (label) {
            fieldObject.timingLabel = _format(label);
          }

          send(fieldObject, trackerNames);
        }
      }

      /**
       * event:
       * GA event tracking
       * @param args.category {String} required
       * @param args.action {String} required
       * @param args.label {String} optional
       * @param args.value {Int} optional
       * @param args.nonInteraction {boolean} optional
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function event() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var trackerNames = arguments[1];

        var category = _ref2.category,
            action = _ref2.action,
            label = _ref2.label,
            value = _ref2.value,
            nonInteraction = _ref2.nonInteraction,
            transport = _ref2.transport,
            args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

        if (typeof ga === 'function') {
          // Simple Validation
          if (!category || !action) {
            (0, _warn2.default)('args.category AND args.action are required in event()');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'event',
            eventCategory: _format(category),
            eventAction: _format(action)
          };

          // Optional Fields
          if (label) {
            fieldObject.eventLabel = _format(label);
          }

          if (typeof value !== 'undefined') {
            if (typeof value !== 'number') {
              (0, _warn2.default)('Expected `args.value` arg to be a Number.');
            } else {
              fieldObject.eventValue = value;
            }
          }

          if (typeof nonInteraction !== 'undefined') {
            if (typeof nonInteraction !== 'boolean') {
              (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
            } else {
              fieldObject.nonInteraction = nonInteraction;
            }
          }

          if (typeof transport !== 'undefined') {
            if (typeof transport !== 'string') {
              (0, _warn2.default)('`args.transport` must be a string.');
            } else {
              if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
                (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
              }

              fieldObject.transport = transport;
            }
          }

          Object.keys(args).filter(function (key) {
            return key.substr(0, 'dimension'.length) === 'dimension';
          }).forEach(function (key) {
            fieldObject[key] = args[key];
          });

          Object.keys(args).filter(function (key) {
            return key.substr(0, 'metric'.length) === 'metric';
          }).forEach(function (key) {
            fieldObject[key] = args[key];
          });

          // Send to GA
          send(fieldObject, trackerNames);
        }
      }

      /**
       * exception:
       * GA exception tracking
       * @param args.description {String} optional
       * @param args.fatal {boolean} optional
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function exception(_ref3, trackerNames) {
        var description = _ref3.description,
            fatal = _ref3.fatal;

        if (typeof ga === 'function') {
          // Required Fields
          var fieldObject = {
            hitType: 'exception'
          };

          // Optional Fields
          if (description) {
            fieldObject.exDescription = _format(description);
          }

          if (typeof fatal !== 'undefined') {
            if (typeof fatal !== 'boolean') {
              (0, _warn2.default)('`args.fatal` must be a boolean.');
            } else {
              fieldObject.exFatal = fatal;
            }
          }

          // Send to GA
          send(fieldObject, trackerNames);
        }
      }

      var plugin = exports.plugin = {
        /**
         * require:
         * GA requires a plugin
         * @param name {String} e.g. 'ecommerce' or 'myplugin'
         * @param options {Object} optional e.g {path: '/log', debug: true}
         */
        require: function require(rawName, options) {
          if (typeof ga === 'function') {
            // Required Fields
            if (!rawName) {
              (0, _warn2.default)('`name` is required in .require()');
              return;
            }

            var name = (0, _trim2.default)(rawName);
            if (name === '') {
              (0, _warn2.default)('`name` cannot be an empty string in .require()');
              return;
            }

            // Optional Fields
            if (options) {
              if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
                (0, _warn2.default)('Expected `options` arg to be an Object');
                return;
              }

              if (Object.keys(options).length === 0) {
                (0, _warn2.default)('Empty `options` given to .require()');
              }

              ga('require', name, options);

              if (_debug) {
                (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
              }
            } else {
              ga('require', name);

              if (_debug) {
                (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
              }
            }
          }
        },

        /**
         * execute:
         * GA execute action for plugin
         * Takes variable number of arguments
         * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
         * @param action {String} e.g. 'addItem' or 'myCustomAction'
         * @param actionType {String} optional e.g. 'detail'
         * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
         */
        execute: function execute(pluginName, action) {
          var payload = void 0;
          var actionType = void 0;

          if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
            payload = arguments.length <= 2 ? undefined : arguments[2];
          } else {
            actionType = arguments.length <= 2 ? undefined : arguments[2];
            payload = arguments.length <= 3 ? undefined : arguments[3];
          }

          if (typeof ga === 'function') {
            if (typeof pluginName !== 'string') {
              (0, _warn2.default)('Expected `pluginName` arg to be a String.');
            } else if (typeof action !== 'string') {
              (0, _warn2.default)('Expected `action` arg to be a String.');
            } else {
              var command = pluginName + ':' + action;
              payload = payload || null;
              if (actionType && payload) {
                ga(command, actionType, payload);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                  (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
                }
              } else if (payload) {
                ga(command, payload);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                  (0, _log2.default)('with payload: ' + JSON.stringify(payload));
                }
              } else {
                ga(command);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                }
              }
            }
          }
        }
      };

      /**
       * outboundLink:
       * GA outboundLink tracking
       * @param args.label {String} e.g. url, or 'Create an Account'
       * @param {function} hitCallback - Called after processing a hit.
       */
      function outboundLink(args, hitCallback, trackerNames) {
        if (typeof hitCallback !== 'function') {
          (0, _warn2.default)('hitCallback function is required');
          return;
        }

        if (typeof ga === 'function') {
          // Simple Validation
          if (!args || !args.label) {
            (0, _warn2.default)('args.label is required in outboundLink()');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'event',
            eventCategory: 'Outbound',
            eventAction: 'Click',
            eventLabel: _format(args.label)
          };

          var safetyCallbackCalled = false;
          var safetyCallback = function safetyCallback() {
            // This prevents a delayed response from GA
            // causing hitCallback from being fired twice
            safetyCallbackCalled = true;

            hitCallback();
          };

          // Using a timeout to ensure the execution of critical application code
          // in the case when the GA server might be down
          // or an ad blocker prevents sending the data

          // register safety net timeout:
          var t = setTimeout(safetyCallback, 250);

          var clearableCallbackForGA = function clearableCallbackForGA() {
            clearTimeout(t);
            if (!safetyCallbackCalled) {
              hitCallback();
            }
          };

          fieldObject.hitCallback = clearableCallbackForGA;

          // Send to GA
          send(fieldObject, trackerNames);
        } else {
          // if ga is not defined, return the callback so the application
          // continues to work as expected
          setTimeout(hitCallback, 0);
        }
      }

      _OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
      _OutboundLink2.default.trackLink = outboundLink;
      var OutboundLink = exports.OutboundLink = _OutboundLink2.default;

      exports.default = {
        initialize: initialize,
        ga: ga,
        set: set,
        send: send,
        pageview: pageview,
        modalview: modalview,
        timing: timing,
        event: event,
        exception: exception,
        plugin: plugin,
        outboundLink: outboundLink,
        OutboundLink: OutboundLink
      };

      /***/
    },
    /* 3 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = format;

      var _mightBeEmail = __webpack_require__(4);

      var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

      var _toTitleCase = __webpack_require__(5);

      var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var redacted = 'REDACTED (Potential Email Address)';

      function format(s, titleCase) {
        if ((0, _mightBeEmail2.default)(s)) {
          (0, _warn2.default)('This arg looks like an email address, redacting.');
          return redacted;
        }

        if (titleCase) {
          return (0, _toTitleCase2.default)(s);
        }

        return s;
      }

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = mightBeEmail;
      // See if s could be an email address. We don't want to send personal data like email.
      // https://support.google.com/analytics/answer/2795983?hl=en
      function mightBeEmail(s) {
        // There's no point trying to validate rfc822 fully, just look for ...@...
        return (/[^@]+@[^@]+/.test(s)
        );
      }

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = toTitleCase;

      var _trim = __webpack_require__(1);

      var _trim2 = _interopRequireDefault(_trim);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                      * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                      * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                      * https://github.com/gouch/to-title-case
                                                                                                      */

      function toTitleCase(string) {
        return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
          if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
            return match.toLowerCase();
          }

          if (match.substr(1).search(/[A-Z]|\../) > -1) {
            return match;
          }

          return match.charAt(0).toUpperCase() + match.substr(1);
        });
      }

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = removeLeadingSlash;
      function removeLeadingSlash(string) {
        if (string.substring(0, 1) === '/') {
          return string.substring(1);
        }

        return string;
      }

      /***/
    },
    /* 7 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      exports.default = function () {
        // https://developers.google.com/analytics/devguides/collection/analyticsjs/
        /* eslint-disable */
        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r;
          i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
          }, i[r].l = 1 * new Date();
          a = s.createElement(o), m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
        /* eslint-enable */
      };

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = log;
      function log(s) {
        console.info('[react-ga]', s);
      }

      /***/
    },
    /* 9 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _react = __webpack_require__(10);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(11);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _objectAssign = __webpack_require__(12);

      var _objectAssign2 = _interopRequireDefault(_objectAssign);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var NEWTAB = '_blank';
      var MIDDLECLICK = 1;

      var OutboundLink = function (_Component) {
        _inherits(OutboundLink, _Component);

        function OutboundLink() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, OutboundLink);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            var _this$props = _this.props,
                target = _this$props.target,
                eventLabel = _this$props.eventLabel,
                to = _this$props.to,
                onClick = _this$props.onClick;

            var eventMeta = { label: eventLabel };
            var sameTarget = target !== NEWTAB;
            var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

            if (sameTarget && normalClick) {
              event.preventDefault();
              OutboundLink.trackLink(eventMeta, function () {
                window.location.href = to;
              });
            } else {
              OutboundLink.trackLink(eventMeta, function () {});
            }

            if (onClick) {
              onClick(event);
            }
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(OutboundLink, [{
          key: 'render',
          value: function render() {
            var props = (0, _objectAssign2.default)({}, this.props, {
              href: this.props.to,
              onClick: this.handleClick
            });
            delete props.eventLabel;
            return _react2.default.createElement('a', props);
          }
        }]);

        return OutboundLink;
      }(_react.Component);

      OutboundLink.propTypes = {
        eventLabel: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.string,
        to: _propTypes2.default.string,
        onClick: _propTypes2.default.func
      };
      OutboundLink.defaultProps = {
        target: null,
        to: null,
        onClick: null
      };

      OutboundLink.trackLink = function () {
        (0, _warn2.default)('ga tracking not enabled');
      };

      exports.default = OutboundLink;

      /***/
    },
    /* 10 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

      /***/
    },
    /* 11 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

      /***/
    },
    /* 12 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

      /***/
    }]
    /******/)
  );
});

/***/ }),

/***/ "ZMjw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B","active":"active__3dCN7"};

/***/ }),

/***/ "ZV5m":
/***/ (function(module, exports) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This is the Array.prototype.findIndex polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
 * https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
 */
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function value(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return -1.
            return -1;
        }
    });
}

//# sourceMappingURL=findIndex.js.map

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, elementProps, element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps();
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "eY1z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "j+dX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
exports.deepCopy = deepCopy;
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
exports.deepExtend = deepExtend;
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}
exports.patchProperty = patchProperty;

//# sourceMappingURL=deepCopy.js.map

/***/ }),

/***/ "ji/V":
/***/ (function(module, exports) {

module.exports = [{"name":"Burgenland","stateNumber":1},{"name":"Kärnten","stateNumber":2},{"name":"Niederösterreich","stateNumber":3},{"name":"Oberösterreich","stateNumber":4},{"name":"Salzburg","stateNumber":5},{"name":"Steiermark","stateNumber":6},{"name":"Tirol","stateNumber":7},{"name":"Vorarlberg","stateNumber":8},{"name":"Wien","stateNumber":9}]

/***/ }),

/***/ "lfEA":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "m6le":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
exports.createSubscribe = createSubscribe;
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function () {
            executor(_this);
        }).catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        } else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    } else {
                        observer.complete();
                    }
                } catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                } catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true).then(function () {
            fn.apply(void 0, args);
        }).catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
exports.async = async;
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {}
// do nothing


//# sourceMappingURL=subscribe.js.map

/***/ }),

/***/ "maYl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __webpack_require__("3al8");
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
exports.stringToByteArray = function (str) {
    var out = [],
        p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert_1.assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
exports.stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        } else if (c < 2048) {
            p += 2;
        } else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else {
            p += 3;
        }
    }
    return p;
};

//# sourceMappingURL=utf8.js.map

/***/ }),

/***/ "mnK5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("3al8"));
__export(__webpack_require__("7Oow"));
__export(__webpack_require__("MUsR"));
__export(__webpack_require__("j+dX"));
__export(__webpack_require__("rapL"));
__export(__webpack_require__("9BlA"));
__export(__webpack_require__("MB0S"));
__export(__webpack_require__("DUiD"));
__export(__webpack_require__("HW/i"));
__export(__webpack_require__("9fSs"));
__export(__webpack_require__("Fi7B"));
__export(__webpack_require__("SenR"));
__export(__webpack_require__("m6le"));
__export(__webpack_require__("L7k2"));
__export(__webpack_require__("maYl"));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "n1Uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/@firebase/app/dist/esm/index.js + 1 modules
var esm = __webpack_require__("qQjo");

// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/version.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = esm["default"].SDK_VERSION;

//# sourceMappingURL=version.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/log.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* tslint:disable:no-console */

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
})(LogLevel = LogLevel || (LogLevel = {}));
var logLevel = LogLevel.ERROR;
// Helper methods are needed because variables can't be exported as read/write
function getLogLevel() {
    return logLevel;
}
function setLogLevel(newLevel) {
    logLevel = newLevel;
}
function debug(tag, msg) {
    var obj = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        obj[_i - 2] = arguments[_i];
    }
    if (logLevel <= LogLevel.DEBUG) {
        var time = new Date().toISOString();
        var args = obj.map(argToString);
        console.log.apply(console, ["Firestore (" + SDK_VERSION + ") " + time + " [" + tag + "]: " + msg].concat(args));
    }
}
function log_error(msg) {
    var obj = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        obj[_i - 1] = arguments[_i];
    }
    if (logLevel <= LogLevel.ERROR) {
        var time = new Date().toISOString();
        var args = obj.map(argToString);
        console.error.apply(console, ["Firestore (" + SDK_VERSION + ") " + time + ": " + msg].concat(args));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */
function argToString(obj) {
    if (typeof obj === 'string') {
        return obj;
    } else {
        try {
            return JSON.stringify(obj);
        } catch (e) {
            // Converting to JSON failed, just log the object directly
            return obj;
        }
    }
}

//# sourceMappingURL=log.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/assert.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * Unconditionally fails, throwing an Error with the given message.
 *
 * Returns any so it can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */
function fail(failure) {
  // Log the failure in addition to throw an exception, just in case the
  // exception is swallowed.
  var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
  log_error(message);
  // NOTE: We don't use FirestoreError here because these are internal failures
  // that cannot be handled by the user. (Also it would create a circular
  // dependency between the error and assert modules which doesn't work.)
  throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 */
function assert(assertion, message) {
  if (!assertion) {
    fail(message);
  }
}

//# sourceMappingURL=assert.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/platform/platform.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */
var platform_PlatformSupport = /** @class */function () {
    function PlatformSupport() {}
    PlatformSupport.setPlatform = function (platform) {
        if (PlatformSupport.platform) {
            fail('Platform already defined');
        }
        PlatformSupport.platform = platform;
    };
    PlatformSupport.getPlatform = function () {
        if (!PlatformSupport.platform) {
            fail('Platform not set');
        }
        return PlatformSupport.platform;
    };
    return PlatformSupport;
}();

/**
 * Returns the representation of an empty "proto" byte string for the
 * platform.
 */
function emptyByteString() {
    return platform_PlatformSupport.getPlatform().emptyByteString;
}

//# sourceMappingURL=platform.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/error.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
var Code = {
  // Causes are copied from:
  // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
  /** Not an error; returned on success. */
  OK: 'ok',
  /** The operation was cancelled (typically by the caller). */
  CANCELLED: 'cancelled',
  /** Unknown error or an error from a different error domain. */
  UNKNOWN: 'unknown',
  /**
   * Client specified an invalid argument. Note that this differs from
   * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
   * problematic regardless of the state of the system (e.g., a malformed file
   * name).
   */
  INVALID_ARGUMENT: 'invalid-argument',
  /**
   * Deadline expired before operation could complete. For operations that
   * change the state of the system, this error may be returned even if the
   * operation has completed successfully. For example, a successful response
   * from a server could have been delayed long enough for the deadline to
   * expire.
   */
  DEADLINE_EXCEEDED: 'deadline-exceeded',
  /** Some requested entity (e.g., file or directory) was not found. */
  NOT_FOUND: 'not-found',
  /**
   * Some entity that we attempted to create (e.g., file or directory) already
   * exists.
   */
  ALREADY_EXISTS: 'already-exists',
  /**
   * The caller does not have permission to execute the specified operation.
   * PERMISSION_DENIED must not be used for rejections caused by exhausting
   * some resource (use RESOURCE_EXHAUSTED instead for those errors).
   * PERMISSION_DENIED must not be used if the caller can not be identified
   * (use UNAUTHENTICATED instead for those errors).
   */
  PERMISSION_DENIED: 'permission-denied',
  /**
   * The request does not have valid authentication credentials for the
   * operation.
   */
  UNAUTHENTICATED: 'unauthenticated',
  /**
   * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
   * entire file system is out of space.
   */
  RESOURCE_EXHAUSTED: 'resource-exhausted',
  /**
   * Operation was rejected because the system is not in a state required for
   * the operation's execution. For example, directory to be deleted may be
   * non-empty, an rmdir operation is applied to a non-directory, etc.
   *
   * A litmus test that may help a service implementor in deciding
   * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
   *  (a) Use UNAVAILABLE if the client can retry just the failing call.
   *  (b) Use ABORTED if the client should retry at a higher-level
   *      (e.g., restarting a read-modify-write sequence).
   *  (c) Use FAILED_PRECONDITION if the client should not retry until
   *      the system state has been explicitly fixed. E.g., if an "rmdir"
   *      fails because the directory is non-empty, FAILED_PRECONDITION
   *      should be returned since the client should not retry unless
   *      they have first fixed up the directory by deleting files from it.
   *  (d) Use FAILED_PRECONDITION if the client performs conditional
   *      REST Get/Update/Delete on a resource and the resource on the
   *      server does not match the condition. E.g., conflicting
   *      read-modify-write on the same resource.
   */
  FAILED_PRECONDITION: 'failed-precondition',
  /**
   * The operation was aborted, typically due to a concurrency issue like
   * sequencer check failures, transaction aborts, etc.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  ABORTED: 'aborted',
  /**
   * Operation was attempted past the valid range. E.g., seeking or reading
   * past end of file.
   *
   * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
   * if the system state changes. For example, a 32-bit file system will
   * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
   * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
   * an offset past the current file size.
   *
   * There is a fair bit of overlap between FAILED_PRECONDITION and
   * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
   * when it applies so that callers who are iterating through a space can
   * easily look for an OUT_OF_RANGE error to detect when they are done.
   */
  OUT_OF_RANGE: 'out-of-range',
  /** Operation is not implemented or not supported/enabled in this service. */
  UNIMPLEMENTED: 'unimplemented',
  /**
   * Internal errors. Means some invariants expected by underlying System has
   * been broken. If you see one of these errors, Something is very broken.
   */
  INTERNAL: 'internal',
  /**
   * The service is currently unavailable. This is a most likely a transient
   * condition and may be corrected by retrying with a backoff.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  UNAVAILABLE: 'unavailable',
  /** Unrecoverable data loss or corruption. */
  DATA_LOSS: 'data-loss'
};
/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */
var FirestoreError = /** @class */function (_super) {
  __extends(FirestoreError, _super);
  function FirestoreError(code, message) {
    var _this = _super.call(this, message) || this;
    _this.code = code;
    _this.message = message;
    _this.name = 'FirebaseError';
    // HACK: We write a toString property directly because Error is not a real
    // class and so inheritance does not work correctly. We could alternatively
    // do the same "back-door inheritance" trick that FirebaseError does.
    _this.toString = function () {
      return _this.name + ": [code=" + _this.code + "]: " + _this.message;
    };
    return _this;
  }
  return FirestoreError;
}(Error);


//# sourceMappingURL=error.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/api.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// We are doing some heavy reflective stuff, lots of any casting necessary
/* tslint:disable:no-any */

/**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */
function makeConstructorPrivate(cls, optionalMessage) {
    function PublicConstructor() {
        var error = 'This constructor is private.';
        if (optionalMessage) {
            error += ' ';
            error += optionalMessage;
        }
        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
    }
    // Make sure instanceof checks work and all methods are exposed on the public
    // constructor
    PublicConstructor.prototype = cls.prototype;
    // Copy any static methods/members
    for (var staticProperty in cls) {
        if (cls.hasOwnProperty(staticProperty)) {
            PublicConstructor[staticProperty] = cls[staticProperty];
        }
    }
    return PublicConstructor;
}

//# sourceMappingURL=api.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/obj.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function obj_get(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : null;
}
function obj_size(obj) {
    var count = 0;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            count++;
        }
    }
    return count;
}
/** Returns the given value if it's defined or the defaultValue otherwise. */
function defaulted(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
function forEachNumber(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var num = parseInt(key, 10);
            if (!isNaN(num)) {
                fn(num, obj[key]);
            }
        }
    }
}
function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
}
function lookupOrInsert(obj, key, valFn) {
    if (!contains(obj, key)) {
        obj[key] = valFn();
    }
    return obj[key];
}
function isEmpty(obj) {
    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function shallowCopy(obj) {
    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
    var result = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    }
    return result;
}

//# sourceMappingURL=obj.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/input_validation.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */
function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
    if (args.length !== numberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " + formatPlural(numberOfArgs, 'argument') + ', but was called with ' + formatPlural(args.length, 'argument') + '.');
    }
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */
function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
    if (args.length < minNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " + formatPlural(minNumberOfArgs, 'argument') + ', but was called with ' + formatPlural(args.length, 'argument') + '.');
    }
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */
function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " + (maxNumberOfArgs + " arguments, but was called with ") + formatPlural(args.length, 'argument') + '.');
    }
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */
function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
    if (!(value instanceof Array) || value.length < minNumberOfElements) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " + 'array with at least ' + (formatPlural(minNumberOfElements, 'element') + "."));
    }
}
/**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */
function validateArgType(functionName, type, position, argument) {
    validateType(functionName, type, ordinal(position) + " argument", argument);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateOptionalArgType(functionName, type, position, argument) {
    if (argument !== undefined) {
        validateArgType(functionName, type, position, argument);
    }
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */
function validateNamedType(functionName, type, optionName, argument) {
    validateType(functionName, type, optionName + " option", argument);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateNamedOptionalType(functionName, type, optionName, argument) {
    if (argument !== undefined) {
        validateNamedType(functionName, type, optionName, argument);
    }
}
/** Helper to validate the type of a provided input. */
function validateType(functionName, type, inputName, input) {
    if (typeof input !== type || type === 'object' && !isPlainObject(input)) {
        var description = valueDescription(input);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " + ("to be of type " + type + ", but it was: " + description));
    }
}
/**
 * Returns true iff it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */
function isPlainObject(input) {
    return typeof input === 'object' && input !== null && Object.getPrototypeOf(input) === Object.prototype;
}
/** Returns a string describing the type / value of the provided input. */
function valueDescription(input) {
    if (input === undefined) {
        return 'undefined';
    } else if (input === null) {
        return 'null';
    } else if (typeof input === 'string') {
        if (input.length > 20) {
            input = input.substring(0, 20) + "...";
        }
        return JSON.stringify(input);
    } else if (typeof input === 'number' || typeof input === 'boolean') {
        return '' + input;
    } else if (typeof input === 'object') {
        if (input instanceof Array) {
            return 'an array';
        } else {
            var customObjectName = tryGetCustomObjectType(input);
            if (customObjectName) {
                return "a custom " + customObjectName + " object";
            } else {
                return 'an object';
            }
        }
    } else if (typeof input === 'function') {
        return 'a function';
    } else {
        return fail('Unknown wrong type: ' + typeof input);
    }
}
/** Hacky method to try to get the constructor name for an object. */
function tryGetCustomObjectType(input) {
    if (input.constructor) {
        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
        var results = funcNameRegex.exec(input.constructor.toString());
        if (results && results.length > 1) {
            return results[1];
        }
    }
    return null;
}
/** Validates the provided argument is defined. */
function validateDefined(functionName, position, argument) {
    if (argument === undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " + "argument, but it was undefined.");
    }
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */
function validateOptionNames(functionName, options, optionNames) {
    forEach(options, function (key, _) {
        if (optionNames.indexOf(key) < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " + 'Available options: ' + optionNames.join(', '));
        }
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */
function invalidClassError(functionName, type, position, argument) {
    var description = valueDescription(argument);
    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " + ("argument to be a " + type + ", but it was: " + description));
}
/** Converts a number to its english word representation */
function ordinal(num) {
    switch (num) {
        case 1:
            return 'first';
        case 2:
            return 'second';
        case 3:
            return 'third';
        default:
            return num + 'th';
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */
function formatPlural(num, str) {
    return num + " " + str + (num === 1 ? '' : 's');
}

//# sourceMappingURL=input_validation.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/misc.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// tslint:disable-next-line:class-as-namespace
var misc_AutoId = /** @class */function () {
    function AutoId() {}
    AutoId.newId = function () {
        // Alphanumeric characters
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var autoId = '';
        for (var i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
        return autoId;
    };
    return AutoId;
}();

function primitiveComparator(left, right) {
    if (left < right) return -1;
    if (left > right) return 1;
    return 0;
}
/** Helper to compare nullable (or undefined-able) objects using equals(). */
function equals(left, right) {
    if (left !== null && left !== undefined) {
        return !!(right && left.equals(right));
    } else {
        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
        // smart enough.
        return left === right;
    }
}
/** Helper to compare arrays using equals(). */
function arrayEquals(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (!left[i].equals(right[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Returns the largest lexicographically smaller string of equal or smaller
 * length. Returns an empty string if there is no such predecessor (if the input
 * is empty).
 *
 * Strings returned from this method can be invalid UTF-16 but this is sufficent
 * in use for indexeddb because that depends on lexicographical ordering but
 * shouldn't be used elsewhere.
 */
function immediatePredecessor(s) {
    // We can decrement the last character in the string and be done
    // unless that character is 0 (0x0000), in which case we have to erase the
    // last character.
    var lastIndex = s.length - 1;
    if (s.length === 0) {
        // Special case the empty string.
        return '';
    } else if (s.charAt(lastIndex) === '\0') {
        return s.substring(0, lastIndex);
    } else {
        return s.substring(0, lastIndex) + String.fromCharCode(s.charCodeAt(lastIndex) - 1);
    }
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */
function immediateSuccessor(s) {
    // Return the input string, with an additional NUL byte appended.
    return s + '\0';
}

//# sourceMappingURL=misc.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/blob.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/** Helper function to assert Uint8Array is available at runtime. */
function assertUint8ArrayAvailable() {
    if (typeof Uint8Array === 'undefined') {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
    }
}
/** Helper function to assert Base64 functions are available at runtime. */
function assertBase64Available() {
    if (!platform_PlatformSupport.getPlatform().base64Available) {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
    }
}
/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */
var blob_Blob = /** @class */function () {
    function Blob(binaryString) {
        assertBase64Available();
        this._binaryString = binaryString;
    }
    Blob.fromBase64String = function (base64) {
        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
        validateArgType('Blob.fromBase64String', 'string', 1, base64);
        assertBase64Available();
        try {
            var binaryString = platform_PlatformSupport.getPlatform().atob(base64);
            return new Blob(binaryString);
        } catch (e) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
        }
    };
    Blob.fromUint8Array = function (array) {
        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
        assertUint8ArrayAvailable();
        if (!(array instanceof Uint8Array)) {
            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
        }
        // We can't call array.map directly because it expects the return type to
        // be a Uint8Array, whereas we can convert it to a regular array by invoking
        // map on the Array prototype.
        var binaryString = Array.prototype.map.call(array, function (char) {
            return String.fromCharCode(char);
        }).join('');
        return new Blob(binaryString);
    };
    Blob.prototype.toBase64 = function () {
        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
        assertBase64Available();
        return platform_PlatformSupport.getPlatform().btoa(this._binaryString);
    };
    Blob.prototype.toUint8Array = function () {
        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
        assertUint8ArrayAvailable();
        var buffer = new Uint8Array(this._binaryString.length);
        for (var i = 0; i < this._binaryString.length; i++) {
            buffer[i] = this._binaryString.charCodeAt(i);
        }
        return buffer;
    };
    Blob.prototype.toString = function () {
        return 'Blob(base64: ' + this.toBase64() + ')';
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    Blob.prototype._equals = function (other) {
        return this._binaryString === other._binaryString;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    Blob.prototype._compareTo = function (other) {
        return primitiveComparator(this._binaryString, other._binaryString);
    };
    return Blob;
}();

// Public instance that disallows construction at runtime. This constructor is
// used when exporting Blob on firebase.firestore.Blob and will be called Blob
// publicly. Internally we still use Blob which has a type checked private
// constructor. Note that Blob and PublicBlob can be used interchangeably in
// instanceof checks.
// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
// we need to use Blob as type and export it too.
// tslint:disable-next-line:variable-name We're treating this as a class name.
var PublicBlob = makeConstructorPrivate(blob_Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');

//# sourceMappingURL=blob.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/geo_point.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * Immutable class representing a geo point as latitude-longitude pair.
 * This class is directly exposed in the public API, including its constructor.
 */
var geo_point_GeoPoint = /** @class */function () {
    function GeoPoint(latitude, longitude) {
        validateExactNumberOfArgs('GeoPoint', arguments, 2);
        validateArgType('GeoPoint', 'number', 1, latitude);
        validateArgType('GeoPoint', 'number', 2, longitude);
        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
        }
        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
        }
        this._lat = latitude;
        this._long = longitude;
    }
    Object.defineProperty(GeoPoint.prototype, "latitude", {
        /**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */
        get: function get() {
            return this._lat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeoPoint.prototype, "longitude", {
        /**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */
        get: function get() {
            return this._long;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    GeoPoint.prototype._equals = function (other) {
        return this._lat === other._lat && this._long === other._long;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    GeoPoint.prototype._compareTo = function (other) {
        return primitiveComparator(this._lat, other._lat) || primitiveComparator(this._long, other._long);
    };
    return GeoPoint;
}();


//# sourceMappingURL=geo_point.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/database_info.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var DatabaseInfo = /** @class */function () {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     */
    function DatabaseInfo(databaseId, persistenceKey, host, ssl) {
        this.databaseId = databaseId;
        this.persistenceKey = persistenceKey;
        this.host = host;
        this.ssl = ssl;
    }
    return DatabaseInfo;
}();

/** The default database name for a project. */
var DEFAULT_DATABASE_NAME = '(default)';
/** Represents the database ID a Firestore client is associated with. */
var database_info_DatabaseId = /** @class */function () {
    function DatabaseId(projectId, database) {
        this.projectId = projectId;
        this.database = database ? database : DEFAULT_DATABASE_NAME;
    }
    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
        get: function get() {
            return this.database === DEFAULT_DATABASE_NAME;
        },
        enumerable: true,
        configurable: true
    });
    DatabaseId.prototype.equals = function (other) {
        return other instanceof DatabaseId && other.projectId === this.projectId && other.database === this.database;
    };
    DatabaseId.prototype.compareTo = function (other) {
        return primitiveComparator(this.projectId, other.projectId) || primitiveComparator(this.database, other.database);
    };
    return DatabaseId;
}();


//# sourceMappingURL=database_info.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/path.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var path___extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();


var DOCUMENT_KEY_NAME = '__name__';
/**
 * Path represents an ordered sequence of string segments.
 */
var path_Path = /** @class */function () {
    function Path(segments, offset, length) {
        this.init(segments, offset, length);
    }
    /**
     * An initialization method that can be called from outside the constructor.
     * We need this so that we can have a non-static construct method that returns
     * the polymorphic `this` type.
     */
    Path.prototype.init = function (segments, offset, length) {
        if (offset === undefined) {
            offset = 0;
        } else if (offset > segments.length) {
            fail('offset ' + offset + ' out of range ' + segments.length);
        }
        if (length === undefined) {
            length = segments.length - offset;
        } else if (length > segments.length - offset) {
            fail('length ' + length + ' out of range ' + (segments.length - offset));
        }
        this.segments = segments;
        this.offset = offset;
        this.len = length;
    };
    /**
     * Constructs a new instance of Path using the same concrete type as `this`.
     * We need this instead of using the normal constructor, because polymorphic
     * `this` doesn't work on static methods.
     */
    Path.prototype.construct = function (segments, offset, length) {
        var path = Object.create(Object.getPrototypeOf(this));
        path.init(segments, offset, length);
        return path;
    };
    Object.defineProperty(Path.prototype, "length", {
        get: function get() {
            return this.len;
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.equals = function (other) {
        return Path.comparator(this, other) === 0;
    };
    Path.prototype.child = function (nameOrPath) {
        var segments = this.segments.slice(this.offset, this.limit());
        if (nameOrPath instanceof Path) {
            nameOrPath.forEach(function (segment) {
                segments.push(segment);
            });
        } else if (typeof nameOrPath === 'string') {
            segments.push(nameOrPath);
        } else {
            fail('Unknown parameter type for Path.child(): ' + nameOrPath);
        }
        return this.construct(segments);
    };
    /** The index of one past the last segment of the path. */
    Path.prototype.limit = function () {
        return this.offset + this.length;
    };
    Path.prototype.popFirst = function (size) {
        size = size === undefined ? 1 : size;
        assert(this.length >= size, "Can't call popFirst() with less segments");
        return this.construct(this.segments, this.offset + size, this.length - size);
    };
    Path.prototype.popLast = function () {
        assert(!this.isEmpty(), "Can't call popLast() on empty path");
        return this.construct(this.segments, this.offset, this.length - 1);
    };
    Path.prototype.firstSegment = function () {
        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
        return this.segments[this.offset];
    };
    Path.prototype.lastSegment = function () {
        assert(!this.isEmpty(), "Can't call lastSegment() on empty path");
        return this.segments[this.limit() - 1];
    };
    Path.prototype.get = function (index) {
        assert(index < this.length, 'Index out of range');
        return this.segments[this.offset + index];
    };
    Path.prototype.isEmpty = function () {
        return this.length === 0;
    };
    Path.prototype.isPrefixOf = function (other) {
        if (other.length < this.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== other.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.forEach = function (fn) {
        for (var i = this.offset, end = this.limit(); i < end; i++) {
            fn(this.segments[i]);
        }
    };
    Path.prototype.toArray = function () {
        return this.segments.slice(this.offset, this.limit());
    };
    Path.comparator = function (p1, p2) {
        var len = Math.min(p1.length, p2.length);
        for (var i = 0; i < len; i++) {
            var left = p1.get(i);
            var right = p2.get(i);
            if (left < right) return -1;
            if (left > right) return 1;
        }
        if (p1.length < p2.length) return -1;
        if (p1.length > p2.length) return 1;
        return 0;
    };
    return Path;
}();

/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */
var path_ResourcePath = /** @class */function (_super) {
    path___extends(ResourcePath, _super);
    function ResourcePath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourcePath.prototype.canonicalString = function () {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join('/');
    };
    ResourcePath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Creates a resource path from the given slash-delimited string.
     */
    ResourcePath.fromString = function (path) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        if (path.indexOf('//') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
        }
        // We may still have an empty segment at the beginning or end if they had a
        // leading or trailing slash (which we allow).
        var segments = path.split('/').filter(function (segment) {
            return segment.length > 0;
        });
        return new ResourcePath(segments);
    };
    ResourcePath.EMPTY_PATH = new ResourcePath([]);
    return ResourcePath;
}(path_Path);

var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/** A dot-separated path for navigating sub-objects within a document. */
var path_FieldPath = /** @class */function (_super) {
    path___extends(FieldPath, _super);
    function FieldPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */
    FieldPath.isValidIdentifier = function (segment) {
        return identifierRegExp.test(segment);
    };
    FieldPath.prototype.canonicalString = function () {
        return this.toArray().map(function (str) {
            str = str.replace('\\', '\\\\').replace('`', '\\`');
            if (!FieldPath.isValidIdentifier(str)) {
                str = '`' + str + '`';
            }
            return str;
        }).join('.');
    };
    FieldPath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Returns true if this field references the key of a document.
     */
    FieldPath.prototype.isKeyField = function () {
        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
    };
    /**
     * The field designating the key of a document.
     */
    FieldPath.keyField = function () {
        return new FieldPath([DOCUMENT_KEY_NAME]);
    };
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */
    FieldPath.fromServerFormat = function (path) {
        var segments = [];
        var current = '';
        var i = 0;
        var addCurrentSegment = function addCurrentSegment() {
            if (current.length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " + "with '.', end with '.', or contain '..'");
            }
            segments.push(current);
            current = '';
        };
        var inBackticks = false;
        while (i < path.length) {
            var c = path[i];
            if (c === '\\') {
                if (i + 1 === path.length) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
                }
                var next = path[i + 1];
                if (!(next === '\\' || next === '.' || next === '`')) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
                }
                current += next;
                i += 2;
            } else if (c === '`') {
                inBackticks = !inBackticks;
                i++;
            } else if (c === '.' && !inBackticks) {
                addCurrentSegment();
                i++;
            } else {
                current += c;
                i++;
            }
        }
        addCurrentSegment();
        if (inBackticks) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
        }
        return new FieldPath(segments);
    };
    FieldPath.EMPTY_PATH = new FieldPath([]);
    return FieldPath;
}(path_Path);


//# sourceMappingURL=path.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/document_key.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var document_key_DocumentKey = /** @class */function () {
    function DocumentKey(path) {
        this.path = path;
        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' + path.toArray().join('/'));
    }
    DocumentKey.prototype.equals = function (other) {
        return other !== null && path_ResourcePath.comparator(this.path, other.path) === 0;
    };
    DocumentKey.prototype.toString = function () {
        return this.path.toString();
    };
    DocumentKey.comparator = function (k1, k2) {
        return path_ResourcePath.comparator(k1.path, k2.path);
    };
    DocumentKey.isDocumentKey = function (path) {
        return path.length % 2 === 0;
    };
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param path The segments of the path to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromSegments = function (segments) {
        return new DocumentKey(new path_ResourcePath(segments.slice()));
    };
    /**
     * Creates and returns a new document key using '/' to split the string into
     * segments.
     *
     * @param path The slash-separated path string to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromPathString = function (path) {
        return new DocumentKey(path_ResourcePath.fromString(path));
    };
    DocumentKey.EMPTY = new DocumentKey(new path_ResourcePath([]));
    return DocumentKey;
}();


//# sourceMappingURL=document_key.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/document.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var document_Document = /** @class */function () {
    function Document(key, version, data, options) {
        this.key = key;
        this.version = version;
        this.data = data;
        this.hasLocalMutations = options.hasLocalMutations;
    }
    Document.prototype.field = function (path) {
        return this.data.field(path);
    };
    Document.prototype.fieldValue = function (path) {
        var field = this.field(path);
        return field ? field.value() : undefined;
    };
    Document.prototype.value = function () {
        return this.data.value();
    };
    Document.prototype.equals = function (other) {
        return other instanceof Document && this.key.equals(other.key) && this.version.equals(other.version) && this.data.equals(other.data) && this.hasLocalMutations === other.hasLocalMutations;
    };
    Document.prototype.toString = function () {
        return "Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " + ("{hasLocalMutations: " + this.hasLocalMutations + "})");
    };
    Document.compareByKey = function (d1, d2) {
        return document_key_DocumentKey.comparator(d1.key, d2.key);
    };
    Document.compareByField = function (field, d1, d2) {
        var v1 = d1.field(field);
        var v2 = d2.field(field);
        if (v1 !== undefined && v2 !== undefined) {
            return v1.compareTo(v2);
        } else {
            return fail("Trying to compare documents on fields that don't exist");
        }
    };
    return Document;
}();

/**
 * A class representing a deleted document.
 * Version is set to 0 if we don't point to any specific time, otherwise it
 * denotes time we know it didn't exist at.
 */
var document_NoDocument = /** @class */function () {
    function NoDocument(key, version) {
        this.key = key;
        this.version = version;
    }
    NoDocument.prototype.toString = function () {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    };
    NoDocument.prototype.equals = function (other) {
        return other && other.version.equals(this.version) && other.key.equals(this.key);
    };
    NoDocument.compareByKey = function (d1, d2) {
        return document_key_DocumentKey.comparator(d1.key, d2.key);
    };
    return NoDocument;
}();


//# sourceMappingURL=document.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/sorted_map.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var sorted_map_SortedMap = /** @class */function () {
    function SortedMap(comparator, root) {
        this.comparator = comparator;
        this.root = root ? root : sorted_map_LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator, this.root.insert(key, value, this.comparator).copy(null, null, sorted_map_LLRBNode.BLACK, null, null));
    };
    // Returns a copy of the map, with the specified key removed.
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator, this.root.remove(key, this.comparator).copy(null, null, sorted_map_LLRBNode.BLACK, null, null));
    };
    // Returns the value of the node with the given key, or null.
    SortedMap.prototype.get = function (key) {
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return node.value;
            } else if (cmp < 0) {
                node = node.left;
            } else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    // Returns the key of the item *before* the specified key, or null if key is
    // the first item.
    SortedMap.prototype.getPredecessorKey = function (key) {
        var node = this.root;
        var rightParent = null;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty()) {
                        node = node.right;
                    }return node.key;
                } else if (rightParent) {
                    return rightParent.key;
                } else {
                    return null; // first item.
                }
            } else if (cmp < 0) {
                node = node.left;
            } else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw fail('Attempted to find predecessor key for a nonexistent key.' + '  What gives?');
    };
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    SortedMap.prototype.indexOf = function (key) {
        // Number of nodes that were pruned when descending right
        var prunedNodes = 0;
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return prunedNodes + node.left.size;
            } else if (cmp < 0) {
                node = node.left;
            } else {
                // Count all nodes left of the node plus the node itself
                prunedNodes += node.left.size + 1;
                node = node.right;
            }
        }
        // Node not found
        return -1;
    };
    SortedMap.prototype.isEmpty = function () {
        return this.root.isEmpty();
    };
    Object.defineProperty(SortedMap.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function get() {
            return this.root.size;
        },
        enumerable: true,
        configurable: true
    });
    // Returns the minimum key in the map.
    SortedMap.prototype.minKey = function () {
        return this.root.minKey();
    };
    // Returns the maximum key in the map.
    SortedMap.prototype.maxKey = function () {
        return this.root.maxKey();
    };
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root.inorderTraversal(action);
    };
    SortedMap.prototype.forEach = function (fn) {
        this.inorderTraversal(function (k, v) {
            fn(k, v);
            return false;
        });
    };
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root.reverseTraversal(action);
    };
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new sorted_map_SortedMapIterator(this.root, null, this.comparator, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new sorted_map_SortedMapIterator(this.root, key, this.comparator, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new sorted_map_SortedMapIterator(this.root, null, this.comparator, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new sorted_map_SortedMapIterator(this.root, key, this.comparator, true, resultGenerator);
    };
    return SortedMap;
}(); // end SortedMap

// An iterator over an LLRBNode.
var sorted_map_SortedMapIterator = /** @class */function () {
    function SortedMapIterator(node, startKey, comparator, isReverse, resultGenerator) {
        this.resultGenerator = resultGenerator || null;
        this.isReverse = isReverse;
        this.nodeStack = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse) {
                    node = node.left;
                } else {
                    node = node.right;
                }
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move
                // to the next one
                this.nodeStack.push(node);
                if (this.isReverse) {
                    node = node.right;
                } else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
        var node = this.nodeStack.pop();
        var result;
        if (this.resultGenerator) result = this.resultGenerator(node.key, node.value);else result = { key: node.key, value: node.value };
        if (this.isReverse) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack.length === 0) return null;
        var node = this.nodeStack[this.nodeStack.length - 1];
        if (this.resultGenerator) {
            return this.resultGenerator(node.key, node.value);
        } else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}(); // end SortedMapIterator

// Represents a node in a Left-leaning Red-Black tree.
var sorted_map_LLRBNode = /** @class */function () {
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : LLRBNode.EMPTY;
        this.right = right != null ? right : LLRBNode.EMPTY;
        this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.inorderTraversal = function (action) {
        return this.left.inorderTraversal(action) || action(this.key, this.value) || this.right.inorderTraversal(action);
    };
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.reverseTraversal = function (action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    };
    // Returns the minimum node in the tree.
    LLRBNode.prototype.min = function () {
        if (this.left.isEmpty()) {
            return this;
        } else {
            return this.left.min();
        }
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.minKey = function () {
        return this.min().key;
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        } else {
            return this.right.maxKey();
        }
    };
    // Returns new tree, with the key/value added.
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        } else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        } else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.removeMin = function () {
        if (this.left.isEmpty()) {
            return LLRBNode.EMPTY;
        }
        var n = this;
        if (!n.left.isRed() && !n.left.left.isRed()) n = n.moveRedLeft();
        n = n.copy(null, null, null, n.left.removeMin(), null);
        return n.fixUp();
    };
    // Returns new tree, with the specified item removed.
    LLRBNode.prototype.remove = function (key, comparator) {
        var smallest;
        var n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
                n = n.moveRedLeft();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed()) n = n.rotateRight();
            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
                n = n.moveRedRight();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return LLRBNode.EMPTY;
                } else {
                    smallest = n.right.min();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.isRed = function () {
        return this.color;
    };
    // Returns new tree after performing any needed rotations.
    LLRBNode.prototype.fixUp = function () {
        var n = this;
        if (n.right.isRed() && !n.left.isRed()) n = n.rotateLeft();
        if (n.left.isRed() && n.left.left.isRed()) n = n.rotateRight();
        if (n.left.isRed() && n.right.isRed()) n = n.colorFlip();
        return n;
    };
    LLRBNode.prototype.moveRedLeft = function () {
        var n = this.colorFlip();
        if (n.right.left.isRed()) {
            n = n.copy(null, null, null, null, n.right.rotateRight());
            n = n.rotateLeft();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.moveRedRight = function () {
        var n = this.colorFlip();
        if (n.left.left.isRed()) {
            n = n.rotateRight();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.rotateLeft = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    LLRBNode.prototype.rotateRight = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    LLRBNode.prototype.colorFlip = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    // For testing.
    LLRBNode.prototype.checkMaxDepth = function () {
        var blackDepth = this.check();
        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
            return true;
        } else {
            return false;
        }
    };
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    LLRBNode.prototype.check = function () {
        if (this.isRed() && this.left.isRed()) {
            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed()) {
            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        var blackDepth = this.left.check();
        if (blackDepth !== this.right.check()) {
            throw fail('Black depths differ');
        } else {
            return blackDepth + (this.isRed() ? 0 : 1);
        }
    };
    LLRBNode.EMPTY = null;
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}(); // end LLRBNode

// Represents an empty node (a leaf node in the Red-Black Tree).
var LLRBEmptyNode = /** @class */function () {
    function LLRBEmptyNode() {
        this.size = 0;
    }
    // Returns a copy of the current node.
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    // Returns a copy of the tree, with the specified key/value added.
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new sorted_map_LLRBNode(key, value);
    };
    // Returns a copy of the tree, with the specified key removed.
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.isRed = function () {
        return false;
    };
    // For testing.
    LLRBEmptyNode.prototype.checkMaxDepth = function () {
        return true;
    };
    LLRBEmptyNode.prototype.check = function () {
        return 0;
    };
    return LLRBEmptyNode;
}(); // end LLRBEmptyNode

sorted_map_LLRBNode.EMPTY = new LLRBEmptyNode();

//# sourceMappingURL=sorted_map.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/field_value.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var field_value___extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();




var TypeOrder;
(function (TypeOrder) {
    // This order is defined by the backend.
    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
})(TypeOrder = TypeOrder || (TypeOrder = {}));
/**
 * A field value represents a datatype as stored by Firestore.
 */
var field_value_FieldValue = /** @class */function () {
    function FieldValue() {}
    FieldValue.prototype.toString = function () {
        var val = this.value();
        return val === null ? 'null' : val.toString();
    };
    FieldValue.prototype.defaultCompareTo = function (other) {
        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
        return cmp;
    };
    return FieldValue;
}();

var NullValue = /** @class */function (_super) {
    field_value___extends(NullValue, _super);
    function NullValue() {
        var _this = _super.call(this) || this;
        _this.typeOrder = TypeOrder.NullValue;
        // internalValue is unused but we add it to work around
        // https://github.com/Microsoft/TypeScript/issues/15585
        _this.internalValue = null;
        return _this;
    }
    NullValue.prototype.value = function () {
        return null;
    };
    NullValue.prototype.equals = function (other) {
        return other instanceof NullValue;
    };
    NullValue.prototype.compareTo = function (other) {
        if (other instanceof NullValue) {
            return 0;
        }
        return this.defaultCompareTo(other);
    };
    NullValue.INSTANCE = new NullValue();
    return NullValue;
}(field_value_FieldValue);

var field_value_BooleanValue = /** @class */function (_super) {
    field_value___extends(BooleanValue, _super);
    function BooleanValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BooleanValue;
        return _this;
    }
    BooleanValue.prototype.value = function () {
        return this.internalValue;
    };
    BooleanValue.prototype.equals = function (other) {
        return other instanceof BooleanValue && this.internalValue === other.internalValue;
    };
    BooleanValue.prototype.compareTo = function (other) {
        if (other instanceof BooleanValue) {
            return primitiveComparator(this, other);
        }
        return this.defaultCompareTo(other);
    };
    BooleanValue.of = function (value) {
        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
    };
    BooleanValue.TRUE = new BooleanValue(true);
    BooleanValue.FALSE = new BooleanValue(false);
    return BooleanValue;
}(field_value_FieldValue);

/** Base class for IntegerValue and DoubleValue. */
var NumberValue = /** @class */function (_super) {
    field_value___extends(NumberValue, _super);
    function NumberValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.NumberValue;
        return _this;
    }
    NumberValue.prototype.value = function () {
        return this.internalValue;
    };
    NumberValue.prototype.compareTo = function (other) {
        if (other instanceof NumberValue) {
            return numericComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return NumberValue;
}(field_value_FieldValue);

/** Utility function to compare doubles (using Firestore semantics for NaN). */
function numericComparator(left, right) {
    if (left < right) {
        return -1;
    } else if (left > right) {
        return 1;
    } else if (left === right) {
        return 0;
    } else {
        // one or both are NaN.
        if (isNaN(left)) {
            return isNaN(right) ? 0 : -1;
        } else {
            return 1;
        }
    }
}
/**
 * Utility function to check numbers for equality using Firestore semantics
 * (NaN === NaN, -0.0 !== 0.0).
 */
function numericEquals(left, right) {
    // Implemented based on Object.is() polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    if (left === right) {
        // +0 != -0
        return left !== 0 || 1 / left === 1 / right;
    } else {
        // NaN == NaN
        return left !== left && right !== right;
    }
}
var IntegerValue = /** @class */function (_super) {
    field_value___extends(IntegerValue, _super);
    function IntegerValue(internalValue) {
        return _super.call(this, internalValue) || this;
    }
    IntegerValue.prototype.equals = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via equals().
        if (other instanceof IntegerValue) {
            return numericEquals(this.internalValue, other.internalValue);
        } else {
            return false;
        }
    };
    return IntegerValue;
}(NumberValue);

var DoubleValue = /** @class */function (_super) {
    field_value___extends(DoubleValue, _super);
    function DoubleValue(internalValue) {
        var _this = _super.call(this, internalValue) || this;
        _this.internalValue = internalValue;
        return _this;
    }
    DoubleValue.prototype.equals = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via equals().
        if (other instanceof DoubleValue) {
            return numericEquals(this.internalValue, other.internalValue);
        } else {
            return false;
        }
    };
    DoubleValue.NAN = new DoubleValue(NaN);
    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
    return DoubleValue;
}(NumberValue);

// TODO(b/37267885): Add truncation support
var field_value_StringValue = /** @class */function (_super) {
    field_value___extends(StringValue, _super);
    function StringValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.StringValue;
        return _this;
    }
    StringValue.prototype.value = function () {
        return this.internalValue;
    };
    StringValue.prototype.equals = function (other) {
        return other instanceof StringValue && this.internalValue === other.internalValue;
    };
    StringValue.prototype.compareTo = function (other) {
        if (other instanceof StringValue) {
            return primitiveComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return StringValue;
}(field_value_FieldValue);

var TimestampValue = /** @class */function (_super) {
    field_value___extends(TimestampValue, _super);
    function TimestampValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    TimestampValue.prototype.value = function () {
        return this.internalValue.toDate();
    };
    TimestampValue.prototype.equals = function (other) {
        return other instanceof TimestampValue && this.internalValue.equals(other.internalValue);
    };
    TimestampValue.prototype.compareTo = function (other) {
        if (other instanceof TimestampValue) {
            return this.internalValue.compareTo(other.internalValue);
        } else if (other instanceof ServerTimestampValue) {
            // Concrete timestamps come before server timestamps.
            return -1;
        } else {
            return this.defaultCompareTo(other);
        }
    };
    return TimestampValue;
}(field_value_FieldValue);

/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they evaluate to null.
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */
var ServerTimestampValue = /** @class */function (_super) {
    field_value___extends(ServerTimestampValue, _super);
    function ServerTimestampValue(localWriteTime) {
        var _this = _super.call(this) || this;
        _this.localWriteTime = localWriteTime;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    ServerTimestampValue.prototype.value = function () {
        return null;
    };
    ServerTimestampValue.prototype.equals = function (other) {
        return other instanceof ServerTimestampValue && this.localWriteTime.equals(other.localWriteTime);
    };
    ServerTimestampValue.prototype.compareTo = function (other) {
        if (other instanceof ServerTimestampValue) {
            return this.localWriteTime.compareTo(other.localWriteTime);
        } else if (other instanceof TimestampValue) {
            // Server timestamps come after all concrete timestamps.
            return 1;
        } else {
            return this.defaultCompareTo(other);
        }
    };
    ServerTimestampValue.prototype.toString = function () {
        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
    };
    return ServerTimestampValue;
}(field_value_FieldValue);

var BlobValue = /** @class */function (_super) {
    field_value___extends(BlobValue, _super);
    function BlobValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BlobValue;
        return _this;
    }
    BlobValue.prototype.value = function () {
        return this.internalValue;
    };
    BlobValue.prototype.equals = function (other) {
        return other instanceof BlobValue && this.internalValue._equals(other.internalValue);
    };
    BlobValue.prototype.compareTo = function (other) {
        if (other instanceof BlobValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return BlobValue;
}(field_value_FieldValue);

var field_value_RefValue = /** @class */function (_super) {
    field_value___extends(RefValue, _super);
    function RefValue(databaseId, key) {
        var _this = _super.call(this) || this;
        _this.databaseId = databaseId;
        _this.key = key;
        _this.typeOrder = TypeOrder.RefValue;
        return _this;
    }
    RefValue.prototype.value = function () {
        return this.key;
    };
    RefValue.prototype.equals = function (other) {
        if (other instanceof RefValue) {
            return this.key.equals(other.key) && this.databaseId.equals(other.databaseId);
        } else {
            return false;
        }
    };
    RefValue.prototype.compareTo = function (other) {
        if (other instanceof RefValue) {
            var cmp = this.databaseId.compareTo(other.databaseId);
            return cmp !== 0 ? cmp : document_key_DocumentKey.comparator(this.key, other.key);
        }
        return this.defaultCompareTo(other);
    };
    return RefValue;
}(field_value_FieldValue);

var GeoPointValue = /** @class */function (_super) {
    field_value___extends(GeoPointValue, _super);
    function GeoPointValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.GeoPointValue;
        return _this;
    }
    GeoPointValue.prototype.value = function () {
        return this.internalValue;
    };
    GeoPointValue.prototype.equals = function (other) {
        return other instanceof GeoPointValue && this.internalValue._equals(other.internalValue);
    };
    GeoPointValue.prototype.compareTo = function (other) {
        if (other instanceof GeoPointValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return GeoPointValue;
}(field_value_FieldValue);

var field_value_ObjectValue = /** @class */function (_super) {
    field_value___extends(ObjectValue, _super);
    function ObjectValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ObjectValue;
        return _this;
    }
    ObjectValue.prototype.value = function () {
        var result = {};
        this.internalValue.inorderTraversal(function (key, val) {
            result[key] = val.value();
        });
        return result;
    };
    ObjectValue.prototype.forEach = function (action) {
        this.internalValue.inorderTraversal(action);
    };
    ObjectValue.prototype.equals = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                if (next1.key !== next2.key || !next1.value.equals(next2.value)) {
                    return false;
                }
            }
            return !it1.hasNext() && !it2.hasNext();
        }
        return false;
    };
    ObjectValue.prototype.compareTo = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                var cmp = primitiveComparator(next1.key, next2.key) || next1.value.compareTo(next2.value);
                if (cmp) {
                    return cmp;
                }
            }
            // Only equal if both iterators are exhausted
            return primitiveComparator(it1.hasNext(), it2.hasNext());
        } else {
            return this.defaultCompareTo(other);
        }
    };
    ObjectValue.prototype.set = function (path, to) {
        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
        if (path.length === 1) {
            return this.setChild(path.firstSegment(), to);
        } else {
            var child = this.child(path.firstSegment());
            if (!(child instanceof ObjectValue)) {
                child = ObjectValue.EMPTY;
            }
            var newChild = child.set(path.popFirst(), to);
            return this.setChild(path.firstSegment(), newChild);
        }
    };
    ObjectValue.prototype.delete = function (path) {
        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
        if (path.length === 1) {
            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
        } else {
            // nested field
            var child = this.child(path.firstSegment());
            if (child instanceof ObjectValue) {
                var newChild = child.delete(path.popFirst());
                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
            } else {
                // Don't actually change a primitive value to an object for a delete
                return this;
            }
        }
    };
    ObjectValue.prototype.contains = function (path) {
        return this.field(path) !== undefined;
    };
    ObjectValue.prototype.field = function (path) {
        assert(!path.isEmpty(), "Can't get field of empty path");
        var field = this;
        path.forEach(function (pathSegment) {
            if (field instanceof ObjectValue) {
                field = field.internalValue.get(pathSegment) || undefined;
            } else {
                field = undefined;
            }
        });
        return field;
    };
    ObjectValue.prototype.toString = function () {
        return JSON.stringify(this.value());
    };
    ObjectValue.prototype.child = function (childName) {
        return this.internalValue.get(childName) || undefined;
    };
    ObjectValue.prototype.setChild = function (childName, value) {
        return new ObjectValue(this.internalValue.insert(childName, value));
    };
    ObjectValue.EMPTY = new ObjectValue(new sorted_map_SortedMap(primitiveComparator));
    return ObjectValue;
}(field_value_FieldValue);

var field_value_ArrayValue = /** @class */function (_super) {
    field_value___extends(ArrayValue, _super);
    function ArrayValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ArrayValue;
        return _this;
    }
    ArrayValue.prototype.value = function () {
        return this.internalValue.map(function (v) {
            return v.value();
        });
    };
    ArrayValue.prototype.forEach = function (action) {
        this.internalValue.forEach(action);
    };
    ArrayValue.prototype.equals = function (other) {
        if (other instanceof ArrayValue) {
            if (this.internalValue.length !== other.internalValue.length) {
                return false;
            }
            for (var i = 0; i < this.internalValue.length; i++) {
                if (!this.internalValue[i].equals(other.internalValue[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };
    ArrayValue.prototype.compareTo = function (other) {
        if (other instanceof ArrayValue) {
            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
            for (var i = 0; i < minLength; i++) {
                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
                if (cmp) {
                    return cmp;
                }
            }
            return primitiveComparator(this.internalValue.length, other.internalValue.length);
        } else {
            return this.defaultCompareTo(other);
        }
    };
    ArrayValue.prototype.toString = function () {
        return JSON.stringify(this.value());
    };
    return ArrayValue;
}(field_value_FieldValue);


//# sourceMappingURL=field_value.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/types.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Untyped Number alias we can use to check for ES6 methods / properties.
// tslint:disable-next-line:no-any variable-name
var NumberAsAny = Number;
/**
 * Minimum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
/**
 * Maximum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * Returns whether an number is an integer, uses native implementation if
 * available.
 * Added to not rely on ES6 features.
 * @param value The value to test for being an integer
 */
var isInteger = NumberAsAny.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
/**
 * Returns whether a variable is either undefined or null.
 */
function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */
function isSafeInteger(value) {
  return isInteger(value) && value <= MAX_SAFE_INTEGER && value >= MIN_SAFE_INTEGER;
}
/**
 * Safely checks if the number is NaN.
 */
function safeIsNaN(value) {
  if (NumberAsAny.IsNaN) {
    return NumberAsAny.IsNaN(value);
  } else {
    return typeof value === 'number' && isNaN(value);
  }
}

//# sourceMappingURL=types.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/query.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var query_Query = /** @class */function () {
    function Query(path, explicitOrderBy, filters, limit, startAt, endAt) {
        if (explicitOrderBy === void 0) {
            explicitOrderBy = [];
        }
        if (filters === void 0) {
            filters = [];
        }
        if (limit === void 0) {
            limit = null;
        }
        if (startAt === void 0) {
            startAt = null;
        }
        if (endAt === void 0) {
            endAt = null;
        }
        this.path = path;
        this.explicitOrderBy = explicitOrderBy;
        this.filters = filters;
        this.limit = limit;
        this.startAt = startAt;
        this.endAt = endAt;
        this.memoizedCanonicalId = null;
        this.memoizedOrderBy = null;
        if (this.startAt) {
            this.assertValidBound(this.startAt);
        }
        if (this.endAt) {
            this.assertValidBound(this.endAt);
        }
    }
    Query.atPath = function (path) {
        return new Query(path);
    };
    Object.defineProperty(Query.prototype, "orderBy", {
        get: function get() {
            if (this.memoizedOrderBy === null) {
                var inequalityField = this.getInequalityFilterField();
                var firstOrderByField = this.getFirstOrderByField();
                if (inequalityField !== null && firstOrderByField === null) {
                    // In order to implicitly add key ordering, we must also add the
                    // inequality filter field for it to be a valid query.
                    // Note that the default inequality field and key ordering is ascending.
                    if (inequalityField.isKeyField()) {
                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
                    } else {
                        this.memoizedOrderBy = [new query_OrderBy(inequalityField), KEY_ORDERING_ASC];
                    }
                } else {
                    assert(inequalityField === null || firstOrderByField !== null && inequalityField.equals(firstOrderByField), 'First orderBy should match inequality field.');
                    this.memoizedOrderBy = [];
                    var foundKeyOrdering = false;
                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
                        var orderBy = _a[_i];
                        this.memoizedOrderBy.push(orderBy);
                        if (orderBy.field.isKeyField()) {
                            foundKeyOrdering = true;
                        }
                    }
                    if (!foundKeyOrdering) {
                        // The order of the implicit key ordering always matches the last
                        // explicit order by
                        var lastDirection = this.explicitOrderBy.length > 0 ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir : Direction.ASCENDING;
                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING ? KEY_ORDERING_ASC : KEY_ORDERING_DESC);
                    }
                }
            }
            return this.memoizedOrderBy;
        },
        enumerable: true,
        configurable: true
    });
    Query.prototype.addFilter = function (filter) {
        assert(this.getInequalityFilterField() == null || !(filter instanceof query_RelationFilter) || !filter.isInequality() || filter.field.equals(this.getInequalityFilterField()), 'Query must only have one inequality field.');
        assert(!document_key_DocumentKey.isDocumentKey(this.path), 'No filtering allowed for document query');
        var newFilters = this.filters.concat([filter]);
        return new Query(this.path, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
    };
    Query.prototype.addOrderBy = function (orderBy) {
        assert(!document_key_DocumentKey.isDocumentKey(this.path), 'No ordering allowed for document query');
        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
        return new Query(this.path, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
    };
    Query.prototype.withLimit = function (limit) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
    };
    Query.prototype.withStartAt = function (bound) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
    };
    Query.prototype.withEndAt = function (bound) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
    };
    // TODO(b/29183165): This is used to get a unique string from a query to, for
    // example, use as a dictionary key, but the implementation is subject to
    // collisions. Make it collision-free.
    Query.prototype.canonicalId = function () {
        if (this.memoizedCanonicalId === null) {
            var canonicalId = this.path.canonicalString();
            canonicalId += '|f:';
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                canonicalId += filter.canonicalId();
                canonicalId += ',';
            }
            canonicalId += '|ob:';
            // TODO(dimond): make this collision resistant
            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
                var orderBy = _c[_b];
                canonicalId += orderBy.canonicalId();
                canonicalId += ',';
            }
            if (!isNullOrUndefined(this.limit)) {
                canonicalId += '|l:';
                canonicalId += this.limit;
            }
            if (this.startAt) {
                canonicalId += '|lb:';
                canonicalId += this.startAt.canonicalId();
            }
            if (this.endAt) {
                canonicalId += '|ub:';
                canonicalId += this.endAt.canonicalId();
            }
            this.memoizedCanonicalId = canonicalId;
        }
        return this.memoizedCanonicalId;
    };
    Query.prototype.toString = function () {
        var str = 'Query(' + this.path.canonicalString();
        if (this.filters.length > 0) {
            str += ", filters: [" + this.filters.join(', ') + "]";
        }
        if (!isNullOrUndefined(this.limit)) {
            str += ', limit: ' + this.limit;
        }
        if (this.explicitOrderBy.length > 0) {
            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
        }
        if (this.startAt) {
            str += ', startAt: ' + this.startAt.canonicalId();
        }
        if (this.endAt) {
            str += ', endAt: ' + this.endAt.canonicalId();
        }
        return str + ')';
    };
    Query.prototype.equals = function (other) {
        if (this.limit !== other.limit) {
            return false;
        }
        if (this.orderBy.length !== other.orderBy.length) {
            return false;
        }
        for (var i = 0; i < this.orderBy.length; i++) {
            if (!this.orderBy[i].equals(other.orderBy[i])) {
                return false;
            }
        }
        if (this.filters.length !== other.filters.length) {
            return false;
        }
        for (var i = 0; i < this.filters.length; i++) {
            if (!this.filters[i].equals(other.filters[i])) {
                return false;
            }
        }
        if (!this.path.equals(other.path)) {
            return false;
        }
        if (this.startAt !== null ? !this.startAt.equals(other.startAt) : other.startAt !== null) {
            return false;
        }
        return this.endAt !== null ? this.endAt.equals(other.endAt) : other.endAt === null;
    };
    Query.prototype.docComparator = function (d1, d2) {
        var comparedOnKeyField = false;
        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            var comp = orderBy.compare(d1, d2);
            if (comp !== 0) return comp;
            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
        }
        // Assert that we actually compared by key
        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
        return 0;
    };
    Query.prototype.matches = function (doc) {
        return this.matchesAncestor(doc) && this.matchesOrderBy(doc) && this.matchesFilters(doc) && this.matchesBounds(doc);
    };
    Query.prototype.hasLimit = function () {
        return !isNullOrUndefined(this.limit);
    };
    Query.prototype.getFirstOrderByField = function () {
        return this.explicitOrderBy.length > 0 ? this.explicitOrderBy[0].field : null;
    };
    Query.prototype.getInequalityFilterField = function () {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof query_RelationFilter && filter.isInequality()) {
                return filter.field;
            }
        }
        return null;
    };
    Query.prototype.isDocumentQuery = function () {
        return document_key_DocumentKey.isDocumentKey(this.path) && this.filters.length === 0;
    };
    Query.prototype.matchesAncestor = function (doc) {
        var docPath = doc.key.path;
        if (document_key_DocumentKey.isDocumentKey(this.path)) {
            // exact match for document queries
            return this.path.equals(docPath);
        } else {
            // shallow ancestor queries by default
            return this.path.isPrefixOf(docPath) && this.path.length === docPath.length - 1;
        }
    };
    /**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */
    Query.prototype.matchesOrderBy = function (doc) {
        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            // order by key always matches
            if (!orderBy.field.isKeyField() && doc.field(orderBy.field) === undefined) {
                return false;
            }
        }
        return true;
    };
    Query.prototype.matchesFilters = function (doc) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (!filter.matches(doc)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Makes sure a document is within the bounds, if provided.
     */
    Query.prototype.matchesBounds = function (doc) {
        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        return true;
    };
    Query.prototype.assertValidBound = function (bound) {
        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
    };
    return Query;
}();

var query_RelationOp = /** @class */function () {
    function RelationOp(name) {
        this.name = name;
    }
    RelationOp.fromString = function (op) {
        switch (op) {
            case '<':
                return RelationOp.LESS_THAN;
            case '<=':
                return RelationOp.LESS_THAN_OR_EQUAL;
            case '==':
                return RelationOp.EQUAL;
            case '>=':
                return RelationOp.GREATER_THAN_OR_EQUAL;
            case '>':
                return RelationOp.GREATER_THAN;
            default:
                return fail('Unknown relation: ' + op);
        }
    };
    RelationOp.prototype.toString = function () {
        return this.name;
    };
    RelationOp.prototype.equals = function (other) {
        return this.name === other.name;
    };
    RelationOp.LESS_THAN = new RelationOp('<');
    RelationOp.LESS_THAN_OR_EQUAL = new RelationOp('<=');
    RelationOp.EQUAL = new RelationOp('==');
    RelationOp.GREATER_THAN = new RelationOp('>');
    RelationOp.GREATER_THAN_OR_EQUAL = new RelationOp('>=');
    return RelationOp;
}();

var query_RelationFilter = /** @class */function () {
    function RelationFilter(field, op, value) {
        this.field = field;
        this.op = op;
        this.value = value;
    }
    RelationFilter.prototype.matches = function (doc) {
        if (this.field.isKeyField()) {
            assert(this.value instanceof field_value_RefValue, 'Comparing on key, but filter value not a RefValue');
            var refValue = this.value;
            var comparison = document_key_DocumentKey.comparator(doc.key, refValue.key);
            return this.matchesComparison(comparison);
        } else {
            var val = doc.field(this.field);
            return val !== undefined && this.matchesValue(val);
        }
    };
    RelationFilter.prototype.matchesValue = function (value) {
        // Only compare types with matching backend order (such as double and int).
        if (this.value.typeOrder !== value.typeOrder) {
            return false;
        }
        return this.matchesComparison(value.compareTo(this.value));
    };
    RelationFilter.prototype.matchesComparison = function (comparison) {
        switch (this.op) {
            case query_RelationOp.LESS_THAN:
                return comparison < 0;
            case query_RelationOp.LESS_THAN_OR_EQUAL:
                return comparison <= 0;
            case query_RelationOp.EQUAL:
                return comparison === 0;
            case query_RelationOp.GREATER_THAN:
                return comparison > 0;
            case query_RelationOp.GREATER_THAN_OR_EQUAL:
                return comparison >= 0;
            default:
                return fail('Unknown relation op' + this.op);
        }
    };
    RelationFilter.prototype.isInequality = function () {
        return this.op !== query_RelationOp.EQUAL;
    };
    RelationFilter.prototype.canonicalId = function () {
        // TODO(b/29183165): Technically, this won't be unique if two values have
        // the same description, such as the int 3 and the string "3". So we should
        // add the types in here somehow, too.
        return this.field.canonicalString() + this.op.toString() + this.value.toString();
    };
    RelationFilter.prototype.equals = function (other) {
        if (other instanceof RelationFilter) {
            return this.op.equals(other.op) && this.field.equals(other.field) && this.value.equals(other.value);
        } else {
            return false;
        }
    };
    RelationFilter.prototype.toString = function () {
        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
    };
    return RelationFilter;
}();

/**
 * Filter that matches 'null' values.
 */
var NullFilter = /** @class */function () {
    function NullFilter(field) {
        this.field = field;
    }
    NullFilter.prototype.matches = function (doc) {
        var val = doc.field(this.field);
        return val !== undefined && val.value() === null;
    };
    NullFilter.prototype.canonicalId = function () {
        return this.field.canonicalString() + ' IS null';
    };
    NullFilter.prototype.toString = function () {
        return this.field.canonicalString() + " IS null";
    };
    NullFilter.prototype.equals = function (other) {
        if (other instanceof NullFilter) {
            return this.field.equals(other.field);
        } else {
            return false;
        }
    };
    return NullFilter;
}();

/**
 * Filter that matches 'NaN' values.
 */
var NanFilter = /** @class */function () {
    function NanFilter(field) {
        this.field = field;
    }
    NanFilter.prototype.matches = function (doc) {
        var val = doc.field(this.field).value();
        return typeof val === 'number' && isNaN(val);
    };
    NanFilter.prototype.canonicalId = function () {
        return this.field.canonicalString() + ' IS NaN';
    };
    NanFilter.prototype.toString = function () {
        return this.field.canonicalString() + " IS NaN";
    };
    NanFilter.prototype.equals = function (other) {
        if (other instanceof NanFilter) {
            return this.field.equals(other.field);
        } else {
            return false;
        }
    };
    return NanFilter;
}();

/**
 * Creates a filter based on the provided arguments.
 */
function fieldFilter(field, op, value) {
    if (value.equals(NullValue.INSTANCE)) {
        if (op !== query_RelationOp.EQUAL) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on null.');
        }
        return new NullFilter(field);
    } else if (value.equals(DoubleValue.NAN)) {
        if (op !== query_RelationOp.EQUAL) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on NaN.');
        }
        return new NanFilter(field);
    } else {
        return new query_RelationFilter(field, op, value);
    }
}
/**
 * The direction of sorting in an order by.
 */
var Direction = /** @class */function () {
    function Direction(name) {
        this.name = name;
    }
    Direction.prototype.toString = function () {
        return this.name;
    };
    Direction.ASCENDING = new Direction('asc');
    Direction.DESCENDING = new Direction('desc');
    return Direction;
}();

/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */
var query_Bound = /** @class */function () {
    function Bound(position, before) {
        this.position = position;
        this.before = before;
    }
    Bound.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        var canonicalId = this.before ? 'b:' : 'a:';
        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
            var component = _a[_i];
            canonicalId += component.toString();
        }
        return canonicalId;
    };
    /**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */
    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
        var comparison = 0;
        for (var i = 0; i < this.position.length; i++) {
            var orderByComponent = orderBy[i];
            var component = this.position[i];
            if (orderByComponent.field.isKeyField()) {
                assert(component instanceof field_value_RefValue, 'Bound has a non-key value where the key path is being used.');
                comparison = document_key_DocumentKey.comparator(component.key, doc.key);
            } else {
                var docValue = doc.field(orderByComponent.field);
                assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
                comparison = component.compareTo(docValue);
            }
            if (orderByComponent.dir === Direction.DESCENDING) {
                comparison = comparison * -1;
            }
            if (comparison !== 0) {
                break;
            }
        }
        return this.before ? comparison <= 0 : comparison < 0;
    };
    Bound.prototype.equals = function (other) {
        if (other === null) {
            return false;
        }
        if (this.before !== other.before || this.position.length !== other.position.length) {
            return false;
        }
        for (var i = 0; i < this.position.length; i++) {
            var thisPosition = this.position[i];
            var otherPosition = other.position[i];
            return thisPosition.equals(otherPosition);
        }
        return true;
    };
    return Bound;
}();

/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */
var query_OrderBy = /** @class */function () {
    function OrderBy(field, dir) {
        this.field = field;
        if (dir === undefined) {
            dir = Direction.ASCENDING;
        }
        this.dir = dir;
        this.isKeyOrderBy = field.isKeyField();
    }
    OrderBy.prototype.compare = function (d1, d2) {
        var comparison = this.isKeyOrderBy ? document_Document.compareByKey(d1, d2) : document_Document.compareByField(this.field, d1, d2);
        switch (this.dir) {
            case Direction.ASCENDING:
                return comparison;
            case Direction.DESCENDING:
                return -1 * comparison;
            default:
                return fail('Unknown direction: ' + this.dir);
        }
    };
    OrderBy.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        return this.field.canonicalString() + this.dir.toString();
    };
    OrderBy.prototype.toString = function () {
        return this.field.canonicalString() + " (" + this.dir + ")";
    };
    OrderBy.prototype.equals = function (other) {
        return this.dir === other.dir && this.field.equals(other.field);
    };
    return OrderBy;
}();

var KEY_ORDERING_ASC = new query_OrderBy(path_FieldPath.keyField(), Direction.ASCENDING);
var KEY_ORDERING_DESC = new query_OrderBy(path_FieldPath.keyField(), Direction.DESCENDING);

//# sourceMappingURL=query.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/timestamp.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var isoRegExp = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
var timestamp_Timestamp = /** @class */function () {
    function Timestamp(seconds, nanos) {
        this.seconds = seconds;
        this.nanos = nanos;
        assert(nanos >= 0, 'timestamp nanoseconds out of range: ' + nanos);
        assert(nanos < 1e9, 'timestamp nanoseconds out of range' + nanos);
        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
        assert(seconds >= -62135596800, 'timestamp seconds out of range: ' + seconds);
        // This will break in the year 10,000.
        assert(seconds < 253402300800, 'timestamp seconds out of range' + seconds);
    }
    Timestamp.now = function () {
        return Timestamp.fromEpochMilliseconds(Date.now());
    };
    Timestamp.fromDate = function (date) {
        return Timestamp.fromEpochMilliseconds(date.getTime());
    };
    Timestamp.fromEpochMilliseconds = function (milliseconds) {
        var seconds = Math.floor(milliseconds / 1000);
        var nanos = (milliseconds - seconds * 1000) * 1e6;
        return new Timestamp(seconds, nanos);
    };
    Timestamp.fromISOString = function (utc) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var nanos = 0;
        var fraction = isoRegExp.exec(utc);
        assert(!!fraction, 'invalid timestamp: ' + utc);
        if (fraction[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var nanoStr = fraction[1];
            nanoStr = (nanoStr + '000000000').substr(0, 9);
            nanos = parseInt(nanoStr, 10);
        }
        // Parse the date to get the seconds.
        var date = new Date(utc);
        var seconds = Math.floor(date.getTime() / 1000);
        return new Timestamp(seconds, nanos);
    };
    Timestamp.prototype.toDate = function () {
        return new Date(this.toEpochMilliseconds());
    };
    Timestamp.prototype.toEpochMilliseconds = function () {
        return this.seconds * 1000 + this.nanos / 1e6;
    };
    Timestamp.prototype.compareTo = function (other) {
        if (this.seconds === other.seconds) {
            return primitiveComparator(this.nanos, other.nanos);
        }
        return primitiveComparator(this.seconds, other.seconds);
    };
    Timestamp.prototype.equals = function (other) {
        return other.seconds === this.seconds && other.nanos === this.nanos;
    };
    Timestamp.prototype.toString = function () {
        return 'Timestamp(seconds=' + this.seconds + ', nanos=' + this.nanos + ')';
    };
    return Timestamp;
}();


//# sourceMappingURL=timestamp.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/snapshot_version.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */
var snapshot_version_SnapshotVersion = /** @class */function () {
    function SnapshotVersion(timestamp) {
        this.timestamp = timestamp;
    }
    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
    // delete this constructor and use a timestamp-backed version everywhere.
    SnapshotVersion.fromMicroseconds = function (value) {
        var seconds = Math.floor(value / 1e6);
        var nanos = value % 1e6 * 1e3;
        return new SnapshotVersion(new timestamp_Timestamp(seconds, nanos));
    };
    SnapshotVersion.fromTimestamp = function (value) {
        return new SnapshotVersion(value);
    };
    SnapshotVersion.forDeletedDoc = function () {
        return SnapshotVersion.MIN;
    };
    SnapshotVersion.prototype.compareTo = function (other) {
        return this.timestamp.compareTo(other.timestamp);
    };
    SnapshotVersion.prototype.equals = function (other) {
        return this.timestamp.equals(other.timestamp);
    };
    /** Returns a number representation of the version for use in spec tests. */
    SnapshotVersion.prototype.toMicroseconds = function () {
        // Convert to microseconds.
        return this.timestamp.seconds * 1e6 + this.timestamp.nanos / 1000;
    };
    SnapshotVersion.prototype.toString = function () {
        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
    };
    SnapshotVersion.prototype.toTimestamp = function () {
        return this.timestamp;
    };
    SnapshotVersion.MIN = new SnapshotVersion(new timestamp_Timestamp(0, 0));
    return SnapshotVersion;
}();


//# sourceMappingURL=snapshot_version.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/query_data.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/** An enumeration of the different purposes we have for queries. */
var QueryPurpose;
(function (QueryPurpose) {
  /** A regular, normal query. */
  QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
  /**
   * The query was used to refill a query after an existence filter mismatch.
   */
  QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
  /** The query was used to resolve a limbo document. */
  QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
})(QueryPurpose = QueryPurpose || (QueryPurpose = {}));
/**
 * An immutable set of metadata that the local store tracks for each query.
 */
var query_data_QueryData = /** @class */function () {
  function QueryData(
  /** The query being listened to. */
  query,
  /**
   * The target ID to which the query corresponds; Assigned by the
   * LocalStore for user listens and by the SyncEngine for limbo watches.
   */
  targetId,
  /** The purpose of the query. */
  purpose,
  /** The latest snapshot version seen for this target. */
  snapshotVersion,
  /**
   * An opaque, server-assigned token that allows watching a query to be
   * resumed after disconnecting without retransmitting all the data that
   * matches the query. The resume token essentially identifies a point in
   * time from which the server should resume sending results.
   */
  resumeToken) {
    if (snapshotVersion === void 0) {
      snapshotVersion = snapshot_version_SnapshotVersion.MIN;
    }
    if (resumeToken === void 0) {
      resumeToken = emptyByteString();
    }
    this.query = query;
    this.targetId = targetId;
    this.purpose = purpose;
    this.snapshotVersion = snapshotVersion;
    this.resumeToken = resumeToken;
  }
  /**
   * Creates a new query data instance with an updated snapshot version and
   * resume token.
   */
  QueryData.prototype.update = function (updated) {
    return new QueryData(this.query, this.targetId, this.purpose, updated.snapshotVersion, updated.resumeToken);
  };
  QueryData.prototype.equals = function (other) {
    return this.targetId === other.targetId && this.purpose === other.purpose && this.snapshotVersion.equals(other.snapshotVersion) && this.resumeToken === other.resumeToken && this.query.equals(other.query);
  };
  return QueryData;
}();


//# sourceMappingURL=query_data.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/mutation.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var mutation___extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();





/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */
var mutation_FieldMask = /** @class */function () {
    function FieldMask(fields) {
        this.fields = fields;
        // TODO(dimond): validation of FieldMask
    }
    FieldMask.prototype.equals = function (other) {
        return arrayEquals(this.fields, other.fields);
    };
    return FieldMask;
}();

/** Transforms a value into a server-generated timestamp. */
var ServerTimestampTransform = /** @class */function () {
    function ServerTimestampTransform() {}
    ServerTimestampTransform.prototype.equals = function (other) {
        return other instanceof ServerTimestampTransform;
    };
    ServerTimestampTransform.instance = new ServerTimestampTransform();
    return ServerTimestampTransform;
}();

/** A field path and the TransformOperation to perform upon it. */
var FieldTransform = /** @class */function () {
    function FieldTransform(field, transform) {
        this.field = field;
        this.transform = transform;
    }
    FieldTransform.prototype.equals = function (other) {
        return this.field.equals(other.field) && this.transform.equals(other.transform);
    };
    return FieldTransform;
}();

/** The result of successfully applying a mutation to the backend. */
var MutationResult = /** @class */function () {
    function MutationResult(
    /**
       * The version at which the mutation was committed or null for a delete.
       */
    version,
    /**
       * The resulting fields returned from the backend after a
       * TransformMutation has been committed. Contains one FieldValue for each
       * FieldTransform that was in the mutation.
       *
       * Will be null if the mutation was not a TransformMutation.
       */
    transformResults) {
        this.version = version;
        this.transformResults = transformResults;
    }
    return MutationResult;
}();

var MutationType;
(function (MutationType) {
    MutationType[MutationType["Set"] = 0] = "Set";
    MutationType[MutationType["Patch"] = 1] = "Patch";
    MutationType[MutationType["Transform"] = 2] = "Transform";
    MutationType[MutationType["Delete"] = 3] = "Delete";
})(MutationType = MutationType || (MutationType = {}));
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */
var mutation_Precondition = /** @class */function () {
    function Precondition(updateTime, exists) {
        this.updateTime = updateTime;
        this.exists = exists;
        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
    }
    /** Creates a new Precondition with an exists flag. */
    Precondition.exists = function (exists) {
        return new Precondition(undefined, exists);
    };
    /** Creates a new Precondition based on a version a document exists at. */
    Precondition.updateTime = function (version) {
        return new Precondition(version);
    };
    Object.defineProperty(Precondition.prototype, "isNone", {
        /** Returns whether this Precondition is empty. */
        get: function get() {
            return this.updateTime === undefined && this.exists === undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */
    Precondition.prototype.isValidFor = function (maybeDoc) {
        if (this.updateTime !== undefined) {
            return maybeDoc instanceof document_Document && maybeDoc.version.equals(this.updateTime);
        } else if (this.exists !== undefined) {
            if (this.exists) {
                return maybeDoc instanceof document_Document;
            } else {
                return maybeDoc === null || maybeDoc instanceof document_NoDocument;
            }
        } else {
            assert(this.isNone, 'Precondition should be empty');
            return true;
        }
    };
    Precondition.prototype.equals = function (other) {
        return equals(this.updateTime, other.updateTime) && this.exists === other.exists;
    };
    Precondition.NONE = new Precondition();
    return Precondition;
}();

/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also it version.
 * In the case of Set, Patch, and Transform mutations we preserve the existing
 * version. In the case of Delete mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */
var mutation_Mutation = /** @class */function () {
    function Mutation() {}
    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
        if (maybeDoc != null) {
            assert(maybeDoc.key.equals(this.key), 'Can only apply a mutation to a document with the same key');
        }
    };
    /**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.MIN.
     */
    Mutation.getPostMutationVersion = function (maybeDoc) {
        if (maybeDoc instanceof document_Document) {
            return maybeDoc.version;
        } else {
            return snapshot_version_SnapshotVersion.MIN;
        }
    };
    return Mutation;
}();

/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */
var mutation_SetMutation = /** @class */function (_super) {
    mutation___extends(SetMutation, _super);
    function SetMutation(key, value, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.value = value;
        _this.precondition = precondition;
        _this.type = MutationType.Set;
        return _this;
    }
    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        var version = mutation_Mutation.getPostMutationVersion(maybeDoc);
        return new document_Document(this.key, version, this.value, {
            hasLocalMutations: false
        });
    };
    SetMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = mutation_Mutation.getPostMutationVersion(maybeDoc);
        return new document_Document(this.key, version, this.value, {
            hasLocalMutations: true
        });
    };
    SetMutation.prototype.equals = function (other) {
        return other instanceof SetMutation && this.key.equals(other.key) && this.value.equals(other.value) && this.precondition.equals(other.precondition);
    };
    return SetMutation;
}(mutation_Mutation);

/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */
var mutation_PatchMutation = /** @class */function (_super) {
    mutation___extends(PatchMutation, _super);
    function PatchMutation(key, data, fieldMask, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.data = data;
        _this.fieldMask = fieldMask;
        _this.precondition = precondition;
        _this.type = MutationType.Patch;
        return _this;
    }
    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
        // TODO(mcg): Relax enforcement of this precondition
        //
        // We shouldn't actually enforce the precondition since it already passed on
        // the backend, but we may not have a local version of the document to
        // patch, so we use the precondition to prevent incorrectly putting a
        // partial document into our cache.
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = mutation_Mutation.getPostMutationVersion(maybeDoc);
        var newData = this.patchDocument(maybeDoc);
        return new document_Document(this.key, version, newData, {
            hasLocalMutations: false
        });
    };
    PatchMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = mutation_Mutation.getPostMutationVersion(maybeDoc);
        var newData = this.patchDocument(maybeDoc);
        return new document_Document(this.key, version, newData, {
            hasLocalMutations: true
        });
    };
    PatchMutation.prototype.equals = function (other) {
        return other instanceof PatchMutation && this.key.equals(other.key) && this.fieldMask.equals(other.fieldMask) && this.precondition.equals(other.precondition);
    };
    /**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */
    PatchMutation.prototype.patchDocument = function (maybeDoc) {
        var data;
        if (maybeDoc instanceof document_Document) {
            data = maybeDoc.data;
        } else {
            data = field_value_ObjectValue.EMPTY;
        }
        return this.patchObject(data);
    };
    PatchMutation.prototype.patchObject = function (data) {
        for (var _i = 0, _a = this.fieldMask.fields; _i < _a.length; _i++) {
            var fieldPath = _a[_i];
            var newValue = this.data.field(fieldPath);
            if (newValue !== undefined) {
                data = data.set(fieldPath, newValue);
            } else {
                data = data.delete(fieldPath);
            }
        }
        return data;
    };
    return PatchMutation;
}(mutation_Mutation);

/**
 * A mutation that modifies specific fields of the document with transform
 * operations. Currently the only supported transform is a server timestamp, but
 * IP Address, increment(n), etc. could be supported in the future.
 *
 * It is somewhat similar to a PatchMutation in that it patches specific fields
 * and has no effect when applied to a null or NoDocument (see comment on
 * Mutation for rationale).
 */
var mutation_TransformMutation = /** @class */function (_super) {
    mutation___extends(TransformMutation, _super);
    function TransformMutation(key, fieldTransforms) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.fieldTransforms = fieldTransforms;
        _this.type = MutationType.Transform;
        // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        _this.precondition = mutation_Precondition.exists(true);
        return _this;
    }
    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
        var transformResults = mutationResult.transformResults;
        // TODO(mcg): Relax enforcement of this precondition
        //
        // We shouldn't actually enforce the precondition since it already passed on
        // the backend, but we may not have a local version of the document to
        // patch, so we use the precondition to prevent incorrectly putting a
        // partial document into our cache.
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var doc = this.requireDocument(maybeDoc);
        var newData = this.transformObject(doc.data, transformResults);
        return new document_Document(this.key, doc.version, newData, {
            hasLocalMutations: false
        });
    };
    TransformMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.localTransformResults(localWriteTime);
        var newData = this.transformObject(doc.data, transformResults);
        return new document_Document(this.key, doc.version, newData, {
            hasLocalMutations: true
        });
    };
    TransformMutation.prototype.equals = function (other) {
        return other instanceof TransformMutation && this.key.equals(other.key) && arrayEquals(this.fieldTransforms, other.fieldTransforms) && this.precondition.equals(other.precondition);
    };
    /**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */
    TransformMutation.prototype.requireDocument = function (maybeDoc) {
        assert(maybeDoc instanceof document_Document, 'Unknown MaybeDocument type ' + maybeDoc);
        var doc = maybeDoc;
        assert(doc.key.equals(this.key), 'Can only transform a document with the same key');
        return doc;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @return The transform results list.
     */
    TransformMutation.prototype.localTransformResults = function (localWriteTime) {
        var transformResults = [];
        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
            var fieldTransform = _a[_i];
            var transform = fieldTransform.transform;
            if (transform instanceof ServerTimestampTransform) {
                transformResults.push(new ServerTimestampValue(localWriteTime));
            } else {
                return fail('Encountered unknown transform: ' + transform);
            }
        }
        return transformResults;
    };
    TransformMutation.prototype.transformObject = function (data, transformResults) {
        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
        for (var i = 0; i < this.fieldTransforms.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var transform = fieldTransform.transform;
            var fieldPath = fieldTransform.field;
            if (transform instanceof ServerTimestampTransform) {
                data = data.set(fieldPath, transformResults[i]);
            } else {
                return fail('Encountered unknown transform: ' + transform);
            }
        }
        return data;
    };
    return TransformMutation;
}(mutation_Mutation);

/** A mutation that deletes the document at the given key. */
var mutation_DeleteMutation = /** @class */function (_super) {
    mutation___extends(DeleteMutation, _super);
    function DeleteMutation(key, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.precondition = precondition;
        _this.type = MutationType.Delete;
        return _this;
    }
    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return new document_NoDocument(this.key, snapshot_version_SnapshotVersion.MIN);
    };
    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        if (maybeDoc) {
            assert(maybeDoc.key.equals(this.key), 'Can only apply mutation to document with same key');
        }
        return new document_NoDocument(this.key, snapshot_version_SnapshotVersion.forDeletedDoc());
    };
    DeleteMutation.prototype.equals = function (other) {
        return other instanceof DeleteMutation && this.key.equals(other.key) && this.precondition.equals(other.precondition);
    };
    return DeleteMutation;
}(mutation_Mutation);


//# sourceMappingURL=mutation.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/existence_filter.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistenceFilter = /** @class */function () {
    // TODO(b/33078163): just use simplest form of existence filter for now
    function ExistenceFilter(count) {
        this.count = count;
    }
    ExistenceFilter.prototype.equals = function (other) {
        return other && other.count === this.count;
    };
    return ExistenceFilter;
}();


//# sourceMappingURL=existence_filter.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/rpc_error.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers.
 */
var RpcCode;
(function (RpcCode) {
    RpcCode[RpcCode["OK"] = 0] = "OK";
    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
})(RpcCode || (RpcCode = {}));
function isPermanentError(code) {
    switch (code) {
        case Code.OK:
            return fail('Treated status OK as error');
        case Code.CANCELLED:
        case Code.UNKNOWN:
        case Code.DEADLINE_EXCEEDED:
        case Code.RESOURCE_EXHAUSTED:
        case Code.INTERNAL:
        case Code.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        // TODO(b/37325376): Give up after second unauthenticated error.
        case Code.UNAUTHENTICATED:
            return false;
        case Code.INVALID_ARGUMENT:
        case Code.NOT_FOUND:
        case Code.ALREADY_EXISTS:
        case Code.PERMISSION_DENIED:
        case Code.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case Code.ABORTED:
        case Code.OUT_OF_RANGE:
        case Code.UNIMPLEMENTED:
        case Code.DATA_LOSS:
            return true;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */
function mapCodeFromRpcStatus(status) {
    // tslint:disable-next-line:no-any lookup by string
    var code = RpcCode[status];
    if (code === undefined) {
        return undefined;
    }
    return mapCodeFromRpcCode(code);
}
/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */
function mapCodeFromRpcCode(code) {
    switch (code) {
        case RpcCode.OK:
            return Code.OK;
        case RpcCode.CANCELLED:
            return Code.CANCELLED;
        case RpcCode.UNKNOWN:
            return Code.UNKNOWN;
        case RpcCode.DEADLINE_EXCEEDED:
            return Code.DEADLINE_EXCEEDED;
        case RpcCode.RESOURCE_EXHAUSTED:
            return Code.RESOURCE_EXHAUSTED;
        case RpcCode.INTERNAL:
            return Code.INTERNAL;
        case RpcCode.UNAVAILABLE:
            return Code.UNAVAILABLE;
        case RpcCode.UNAUTHENTICATED:
            return Code.UNAUTHENTICATED;
        case RpcCode.INVALID_ARGUMENT:
            return Code.INVALID_ARGUMENT;
        case RpcCode.NOT_FOUND:
            return Code.NOT_FOUND;
        case RpcCode.ALREADY_EXISTS:
            return Code.ALREADY_EXISTS;
        case RpcCode.PERMISSION_DENIED:
            return Code.PERMISSION_DENIED;
        case RpcCode.FAILED_PRECONDITION:
            return Code.FAILED_PRECONDITION;
        case RpcCode.ABORTED:
            return Code.ABORTED;
        case RpcCode.OUT_OF_RANGE:
            return Code.OUT_OF_RANGE;
        case RpcCode.UNIMPLEMENTED:
            return Code.UNIMPLEMENTED;
        case RpcCode.DATA_LOSS:
            return Code.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Maps an RPC code from a Code. This is the reverse operation from
 * mapCodeFromRpcCode and should really only be used in tests.
 */
function mapRpcCodeFromCode(code) {
    if (code === undefined) {
        return RpcCode.OK;
    }
    switch (code) {
        case Code.OK:
            return RpcCode.OK;
        case Code.CANCELLED:
            return RpcCode.CANCELLED;
        case Code.UNKNOWN:
            return RpcCode.UNKNOWN;
        case Code.DEADLINE_EXCEEDED:
            return RpcCode.DEADLINE_EXCEEDED;
        case Code.RESOURCE_EXHAUSTED:
            return RpcCode.RESOURCE_EXHAUSTED;
        case Code.INTERNAL:
            return RpcCode.INTERNAL;
        case Code.UNAVAILABLE:
            return RpcCode.UNAVAILABLE;
        case Code.UNAUTHENTICATED:
            return RpcCode.UNAUTHENTICATED;
        case Code.INVALID_ARGUMENT:
            return RpcCode.INVALID_ARGUMENT;
        case Code.NOT_FOUND:
            return RpcCode.NOT_FOUND;
        case Code.ALREADY_EXISTS:
            return RpcCode.ALREADY_EXISTS;
        case Code.PERMISSION_DENIED:
            return RpcCode.PERMISSION_DENIED;
        case Code.FAILED_PRECONDITION:
            return RpcCode.FAILED_PRECONDITION;
        case Code.ABORTED:
            return RpcCode.ABORTED;
        case Code.OUT_OF_RANGE:
            return RpcCode.OUT_OF_RANGE;
        case Code.UNIMPLEMENTED:
            return RpcCode.UNIMPLEMENTED;
        case Code.DATA_LOSS:
            return RpcCode.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Converts an HTTP Status Code to the equivalent error code.
 *
 * @param status An HTTP Status Code, like 200, 404, 503, etc.
 * @returns The equivalent Code. Unknown status codes are mapped to
 *     Code.UNKNOWN.
 */
function mapCodeFromHttpStatus(status) {
    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
    // status codes but the mapping is not bijective. In each case of ambiguity
    // this function chooses a primary error.
    //
    // [1]
    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
    switch (status) {
        case 200:
            // OK
            return Code.OK;
        case 400:
            // Bad Request
            return Code.INVALID_ARGUMENT;
        // Other possibilities based on the forward mapping
        // return Code.FAILED_PRECONDITION;
        // return Code.OUT_OF_RANGE;
        case 401:
            // Unauthorized
            return Code.UNAUTHENTICATED;
        case 403:
            // Forbidden
            return Code.PERMISSION_DENIED;
        case 404:
            // Not Found
            return Code.NOT_FOUND;
        case 409:
            // Conflict
            return Code.ABORTED;
        // Other possibilities:
        // return Code.ALREADY_EXISTS;
        case 416:
            // Range Not Satisfiable
            return Code.OUT_OF_RANGE;
        case 429:
            // Too Many Requests
            return Code.RESOURCE_EXHAUSTED;
        case 499:
            // Client Closed Request
            return Code.CANCELLED;
        case 500:
            // Internal Server Error
            return Code.UNKNOWN;
        // Other possibilities:
        // return Code.INTERNAL;
        // return Code.DATA_LOSS;
        case 501:
            // Unimplemented
            return Code.UNIMPLEMENTED;
        case 503:
            // Service Unavailable
            return Code.UNAVAILABLE;
        case 504:
            // Gateway Timeout
            return Code.DEADLINE_EXCEEDED;
        default:
            if (status >= 200 && status < 300) return Code.OK;
            if (status >= 400 && status < 500) return Code.FAILED_PRECONDITION;
            if (status >= 500 && status < 600) return Code.INTERNAL;
            return Code.UNKNOWN;
    }
}

//# sourceMappingURL=rpc_error.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/sorted_set.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */
var sorted_set_SortedSet = /** @class */function () {
    function SortedSet(comparator) {
        this.comparator = comparator;
        this.data = new sorted_map_SortedMap(this.comparator);
    }
    /**
     * Creates a SortedSet from the keys of the map.
     * This is currently implemented as an O(n) copy.
     */
    SortedSet.fromMapKeys = function (map) {
        var keys = new SortedSet(map.comparator);
        map.forEach(function (key) {
            keys = keys.add(key);
        });
        return keys;
    };
    SortedSet.prototype.has = function (elem) {
        return this.data.get(elem) !== null;
    };
    SortedSet.prototype.first = function () {
        return this.data.minKey();
    };
    SortedSet.prototype.last = function () {
        return this.data.maxKey();
    };
    Object.defineProperty(SortedSet.prototype, "size", {
        get: function get() {
            return this.data.size;
        },
        enumerable: true,
        configurable: true
    });
    SortedSet.prototype.indexOf = function (elem) {
        return this.data.indexOf(elem);
    };
    /** Iterates elements in order defined by "comparator" */
    SortedSet.prototype.forEach = function (cb) {
        this.data.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
    SortedSet.prototype.forEachInRange = function (range, cb) {
        var iter = this.data.getIteratorFrom(range[0]);
        while (iter.hasNext()) {
            var elem = iter.getNext();
            if (this.comparator(elem.key, range[1]) >= 0) return;
            cb(elem.key);
        }
    };
    /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */
    SortedSet.prototype.forEachWhile = function (cb, start) {
        var iter;
        if (start !== undefined) {
            iter = this.data.getIteratorFrom(start);
        } else {
            iter = this.data.getIterator();
        }
        while (iter.hasNext()) {
            var elem = iter.getNext();
            var result = cb(elem.key);
            if (!result) return;
        }
    };
    /** Finds the least element greater than or equal to `elem`. */
    SortedSet.prototype.firstAfterOrEqual = function (elem) {
        var iter = this.data.getIteratorFrom(elem);
        return iter.hasNext() ? iter.getNext().key : null;
    };
    /** Inserts or updates an element */
    SortedSet.prototype.add = function (elem) {
        return this.copy(this.data.remove(elem).insert(elem, true));
    };
    /** Deletes an element */
    SortedSet.prototype.delete = function (elem) {
        if (!this.has(elem)) return this;
        return this.copy(this.data.remove(elem));
    };
    SortedSet.prototype.isEmpty = function () {
        return this.data.isEmpty();
    };
    SortedSet.prototype.unionWith = function (other) {
        var result = this;
        other.forEach(function (elem) {
            result = result.add(elem);
        });
        return result;
    };
    SortedSet.prototype.equals = function (other) {
        if (!(other instanceof SortedSet)) return false;
        if (this.size !== other.size) return false;
        var thisIt = this.data.getIterator();
        var otherIt = other.data.getIterator();
        while (thisIt.hasNext()) {
            var thisElem = thisIt.getNext().key;
            var otherElem = otherIt.getNext().key;
            if (this.comparator(thisElem, otherElem) !== 0) return false;
        }
        return true;
    };
    SortedSet.prototype.toString = function () {
        var result = [];
        this.forEach(function (elem) {
            return result.push(elem);
        });
        return 'SortedSet(' + result.toString() + ')';
    };
    SortedSet.prototype.copy = function (data) {
        var result = new SortedSet(this.comparator);
        result.data = data;
        return result;
    };
    return SortedSet;
}();


//# sourceMappingURL=sorted_set.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/collections.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var EMPTY_MAYBE_DOCUMENT_MAP = new sorted_map_SortedMap(document_key_DocumentKey.comparator);
function maybeDocumentMap() {
    return EMPTY_MAYBE_DOCUMENT_MAP;
}
var EMPTY_DOCUMENT_MAP = new sorted_map_SortedMap(document_key_DocumentKey.comparator);
function documentMap() {
    return EMPTY_DOCUMENT_MAP;
}
var EMPTY_DOCUMENT_VERSION_MAP = new sorted_map_SortedMap(document_key_DocumentKey.comparator);
function documentVersionMap() {
    return EMPTY_DOCUMENT_VERSION_MAP;
}
var EMPTY_DOCUMENT_KEY_SET = new sorted_set_SortedSet(document_key_DocumentKey.comparator);
function documentKeySet() {
    return EMPTY_DOCUMENT_KEY_SET;
}

//# sourceMappingURL=collections.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/remote_event.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */
var remote_event_RemoteEvent = /** @class */function () {
    function RemoteEvent(
    /**
       * The snapshot version this event brings us up to, or MIN if not set.
       */
    snapshotVersion,
    /**
       * A map from target to changes to the target. See TargetChange.
       */
    targetChanges,
    /**
       * A set of which documents have changed or been deleted, along with the
       * doc's new values (if not deleted).
       */
    documentUpdates) {
        this.snapshotVersion = snapshotVersion;
        this.targetChanges = targetChanges;
        this.documentUpdates = documentUpdates;
    }
    RemoteEvent.prototype.addDocumentUpdate = function (doc) {
        this.documentUpdates = this.documentUpdates.insert(doc.key, doc);
    };
    RemoteEvent.prototype.handleExistenceFilterMismatch = function (targetId) {
        /*
         * An existence filter mismatch will reset the query and we need to reset
         * the mapping to contain no documents and an empty resume token.
         *
         * Note:
         *   * The reset mapping is empty, specifically forcing the consumer of the
         *     change to forget all keys for this targetID;
         *   * The resume snapshot for this target must be reset
         *   * The target must be unacked because unwatching and rewatching
         *     introduces a race for changes.
         */
        this.targetChanges[targetId] = {
            mapping: new ResetMapping(),
            snapshotVersion: snapshot_version_SnapshotVersion.MIN,
            currentStatusUpdate: CurrentStatusUpdate.MarkNotCurrent,
            resumeToken: emptyByteString()
        };
    };
    return RemoteEvent;
}();

/**
 * Represents an update to the current status of a target, either explicitly
 * having no new state, or the new value to set. Note "current" has special
 * meaning for in the RPC protocol that implies that a target is both up-to-date
 * and consistent with the rest of the watch stream.
 */
var CurrentStatusUpdate;
(function (CurrentStatusUpdate) {
    /** The current status is not affected and should not be modified. */
    CurrentStatusUpdate[CurrentStatusUpdate["None"] = 0] = "None";
    /** The target must be marked as no longer "current". */
    CurrentStatusUpdate[CurrentStatusUpdate["MarkNotCurrent"] = 1] = "MarkNotCurrent";
    /** The target must be marked as "current". */
    CurrentStatusUpdate[CurrentStatusUpdate["MarkCurrent"] = 2] = "MarkCurrent";
})(CurrentStatusUpdate = CurrentStatusUpdate || (CurrentStatusUpdate = {}));
var EMPTY_KEY_SET = documentKeySet();
var ResetMapping = /** @class */function () {
    function ResetMapping() {
        this.docs = EMPTY_KEY_SET;
    }
    Object.defineProperty(ResetMapping.prototype, "documents", {
        get: function get() {
            return this.docs;
        },
        enumerable: true,
        configurable: true
    });
    ResetMapping.prototype.add = function (key) {
        this.docs = this.docs.add(key);
    };
    ResetMapping.prototype.delete = function (key) {
        this.docs = this.docs.delete(key);
    };
    ResetMapping.prototype.equals = function (other) {
        return other !== null && this.docs.equals(other.docs);
    };
    return ResetMapping;
}();

var UpdateMapping = /** @class */function () {
    function UpdateMapping() {
        this.addedDocuments = EMPTY_KEY_SET;
        this.removedDocuments = EMPTY_KEY_SET;
    }
    UpdateMapping.prototype.applyToKeySet = function (keys) {
        var result = keys;
        this.addedDocuments.forEach(function (key) {
            return result = result.add(key);
        });
        this.removedDocuments.forEach(function (key) {
            return result = result.delete(key);
        });
        return result;
    };
    UpdateMapping.prototype.add = function (key) {
        this.addedDocuments = this.addedDocuments.add(key);
        this.removedDocuments = this.removedDocuments.delete(key);
    };
    UpdateMapping.prototype.delete = function (key) {
        this.addedDocuments = this.addedDocuments.delete(key);
        this.removedDocuments = this.removedDocuments.add(key);
    };
    UpdateMapping.prototype.equals = function (other) {
        return other !== null && this.addedDocuments.equals(other.addedDocuments) && this.removedDocuments.equals(other.removedDocuments);
    };
    return UpdateMapping;
}();


//# sourceMappingURL=remote_event.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/watch_change.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */
var DocumentWatchChange = /** @class */function () {
    function DocumentWatchChange(
    /** The new document applies to all of these targets. */
    updatedTargetIds,
    /** The new document is removed from all of these targets. */
    removedTargetIds,
    /** The key of the document for this change. */
    key,
    /**
       * The new document or NoDocument if it was deleted. Is null if the
       * document went out of view without the server sending a new document.
       */
    newDoc) {
        this.updatedTargetIds = updatedTargetIds;
        this.removedTargetIds = removedTargetIds;
        this.key = key;
        this.newDoc = newDoc;
    }
    return DocumentWatchChange;
}();

var ExistenceFilterChange = /** @class */function () {
    function ExistenceFilterChange(targetId, existenceFilter) {
        this.targetId = targetId;
        this.existenceFilter = existenceFilter;
    }
    return ExistenceFilterChange;
}();

var WatchTargetChangeState;
(function (WatchTargetChangeState) {
    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
})(WatchTargetChangeState = WatchTargetChangeState || (WatchTargetChangeState = {}));
var watch_change_WatchTargetChange = /** @class */function () {
    function WatchTargetChange(
    /** What kind of change occurred to the watch target. */
    state,
    /** The target IDs that were added/removed/set. */
    targetIds,
    /**
       * An opaque, server-assigned token that allows watching a query to be
       * resumed after disconnecting without retransmitting all the data that
       * matches the query. The resume token essentially identifies a point in
       * time from which the server should resume sending results.
       */
    resumeToken,
    /** An RPC error indicating why the watch failed. */
    cause) {
        if (resumeToken === void 0) {
            resumeToken = emptyByteString();
        }
        if (cause === void 0) {
            cause = null;
        }
        this.state = state;
        this.targetIds = targetIds;
        this.resumeToken = resumeToken;
        this.cause = cause;
    }
    return WatchTargetChange;
}();

/**
 * A helper class to accumulate watch changes into a RemoteEvent and other
 * target information.
 */
var watch_change_WatchChangeAggregator = /** @class */function () {
    function WatchChangeAggregator(snapshotVersion, listenTargets, pendingTargetResponses) {
        this.snapshotVersion = snapshotVersion;
        this.listenTargets = listenTargets;
        /** The existence filter - if any - for the given target IDs. */
        this.existenceFilters = {};
        /** Keeps track of the current target mappings */
        this.targetChanges = {};
        /** Keeps track of document to update */
        this.documentUpdates = maybeDocumentMap();
        /** Whether this aggregator was frozen and can no longer be modified */
        this.frozen = false;
        this.pendingTargetResponses = shallowCopy(pendingTargetResponses);
    }
    /** Aggregates a watch change into the current state */
    WatchChangeAggregator.prototype.add = function (watchChange) {
        assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
        if (watchChange instanceof DocumentWatchChange) {
            this.addDocumentChange(watchChange);
        } else if (watchChange instanceof watch_change_WatchTargetChange) {
            this.addTargetChange(watchChange);
        } else if (watchChange instanceof ExistenceFilterChange) {
            this.addExistenceFilterChange(watchChange);
        } else {
            fail('Unknown watch change: ' + watchChange);
        }
    };
    /** Aggregates all provided watch changes to the current state in order */
    WatchChangeAggregator.prototype.addChanges = function (watchChanges) {
        var _this = this;
        assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
        watchChanges.forEach(function (change) {
            return _this.add(change);
        });
    };
    /**
     * Converts the current state into a remote event with the snapshot version
     * provided via the constructor.
     */
    WatchChangeAggregator.prototype.createRemoteEvent = function () {
        var _this = this;
        var targetChanges = this.targetChanges;
        // Remove all the non-active targets from the remote event.
        forEachNumber(this.targetChanges, function (targetId) {
            if (!_this.isActiveTarget(targetId)) {
                delete targetChanges[targetId];
            }
        });
        // Mark this aggregator as frozen so no further modifications are made
        this.frozen = true;
        return new remote_event_RemoteEvent(this.snapshotVersion, targetChanges, this.documentUpdates);
    };
    WatchChangeAggregator.prototype.ensureTargetChange = function (targetId) {
        var change = this.targetChanges[targetId];
        if (!change) {
            // Create an UpdateMapping by default, since resets are always explicit.
            change = {
                currentStatusUpdate: CurrentStatusUpdate.None,
                snapshotVersion: this.snapshotVersion,
                mapping: new UpdateMapping(),
                resumeToken: emptyByteString()
            };
            this.targetChanges[targetId] = change;
        }
        return change;
    };
    /**
     * We need to wait for watch to ack targets before we process those events,
     * so to know if a target is active, there must be no pending acks we're
     * waiting for and it must be in the current list of targets that the client
     * cares about.
     *
     * This method is visible for testing.
     */
    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
        return !contains(this.pendingTargetResponses, targetId) && contains(this.listenTargets, targetId);
    };
    WatchChangeAggregator.prototype.addDocumentChange = function (docChange) {
        var relevant = false;
        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
            var targetId = _a[_i];
            if (this.isActiveTarget(targetId)) {
                var change = this.ensureTargetChange(targetId);
                change.mapping.add(docChange.key);
                relevant = true;
            }
        }
        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
            var targetId = _c[_b];
            if (this.isActiveTarget(targetId)) {
                var change = this.ensureTargetChange(targetId);
                change.mapping.delete(docChange.key);
                relevant = true;
            }
        }
        // Only update the document if there is a new document to replace to an
        // active target that is being listened to, this might be just a target
        // update instead.
        if (docChange.newDoc && relevant) {
            this.documentUpdates = this.documentUpdates.insert(docChange.key, docChange.newDoc);
        }
    };
    WatchChangeAggregator.prototype.addTargetChange = function (targetChange) {
        var _this = this;
        targetChange.targetIds.forEach(function (targetId) {
            var change = _this.ensureTargetChange(targetId);
            switch (targetChange.state) {
                case WatchTargetChangeState.NoChange:
                    if (_this.isActiveTarget(targetId)) {
                        // Creating the change above satisfies the semantics of no-change.
                        applyResumeToken(change, targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Added:
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    _this.recordTargetResponse(targetId);
                    if (!contains(_this.pendingTargetResponses, targetId)) {
                        // We have a freshly added target, so we need to reset any state
                        // that we had previously This can happen e.g. when remove and add
                        // back a target for existence filter mismatches.
                        change.mapping = new UpdateMapping();
                        change.currentStatusUpdate = CurrentStatusUpdate.None;
                        delete _this.existenceFilters[targetId];
                    }
                    applyResumeToken(change, targetChange.resumeToken);
                    break;
                case WatchTargetChangeState.Removed:
                    // We need to keep track of removed targets to we can
                    // post-filter and remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    _this.recordTargetResponse(targetId);
                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
                    break;
                case WatchTargetChangeState.Current:
                    if (_this.isActiveTarget(targetId)) {
                        change.currentStatusUpdate = CurrentStatusUpdate.MarkCurrent;
                        applyResumeToken(change, targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Reset:
                    if (_this.isActiveTarget(targetId)) {
                        // Overwrite any existing target mapping with a reset
                        // mapping. Every subsequent update will modify the reset
                        // mapping, not an update mapping.
                        change.mapping = new ResetMapping();
                        applyResumeToken(change, targetChange.resumeToken);
                    }
                    break;
                default:
                    fail('Unknown target watch change state: ' + targetChange.state);
            }
        });
    };
    /**
     * Record that we get a watch target add/remove by decrementing the number of
     * pending target responses that we have.
     */
    WatchChangeAggregator.prototype.recordTargetResponse = function (targetId) {
        var newCount = (this.pendingTargetResponses[targetId] || 0) - 1;
        if (newCount === 0) {
            delete this.pendingTargetResponses[targetId];
        } else {
            this.pendingTargetResponses[targetId] = newCount;
        }
    };
    WatchChangeAggregator.prototype.addExistenceFilterChange = function (change) {
        if (this.isActiveTarget(change.targetId)) {
            this.existenceFilters[change.targetId] = change.existenceFilter;
        }
    };
    return WatchChangeAggregator;
}();

/**
 * Applies the resume token to the TargetChange, but only when it has a new
 * value. null and empty resumeTokens are discarded.
 */
function applyResumeToken(change, resumeToken) {
    if (resumeToken.length > 0) {
        change.resumeToken = resumeToken;
    }
}

//# sourceMappingURL=watch_change.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/serializer.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



















var DIRECTIONS = function () {
    var dirs = {};
    dirs[Direction.ASCENDING.name] = 'ASCENDING';
    dirs[Direction.DESCENDING.name] = 'DESCENDING';
    return dirs;
}();
var OPERATORS = function () {
    var ops = {};
    ops[query_RelationOp.LESS_THAN.name] = 'LESS_THAN';
    ops[query_RelationOp.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
    ops[query_RelationOp.GREATER_THAN.name] = 'GREATER_THAN';
    ops[query_RelationOp.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
    ops[query_RelationOp.EQUAL.name] = 'EQUAL';
    return ops;
}();
function assertPresent(value, description) {
    assert(!isNullOrUndefined(value), description + ' is missing');
}
function parseInt64(value) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    if (typeof value === 'number') {
        return value;
    } else if (typeof value === 'string') {
        return parseInt(value, 10);
    } else {
        return fail("can't parse " + value);
    }
}
/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */
var serializer_JsonProtoSerializer = /** @class */function () {
    function JsonProtoSerializer(databaseId, options) {
        this.databaseId = databaseId;
        this.options = options;
    }
    JsonProtoSerializer.prototype.emptyByteString = function () {
        if (this.options.useProto3Json) {
            return '';
        } else {
            return new Uint8Array(0);
        }
    };
    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
        // byteStrings can be either string or UInt8Array, but the typings say
        // it's always a string. Cast as string to avoid type check failing
        return byteString;
    };
    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
        var code = status.code === undefined ? Code.UNKNOWN : mapCodeFromRpcCode(status.code);
        return new FirestoreError(code, status.message || '');
    };
    /**
     * Returns a value for a Date that's appropriate to put into a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say dates must be. But it's easier and safer
     * to actually return a Timestamp proto.
     */
    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
        return {
            seconds: timestamp.seconds,
            nanos: timestamp.nanos
            // tslint:disable-next-line:no-any
        };
    };
    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
        // The json interface (for the browser) will return an iso timestamp string,
        // while the proto js library (for node) will return a
        // google.protobuf.Timestamp instance.
        if (typeof date === 'string') {
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(this.options.useProto3Json,
            //   'The timestamp string format requires Proto3.');
            return timestamp_Timestamp.fromISOString(date);
        } else {
            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(!this.options.useProto3Json,
            //   'The timestamp instance format requires Proto JS.');
            var seconds = parseInt64(date.seconds || '0');
            var nanos = date.nanos || 0;
            return new timestamp_Timestamp(seconds, nanos);
        }
    };
    /**
     * Returns a value for bytes that's appropriate to put in a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say bytes must be. But it should return
     * an Uint8Array in Node.
     */
    JsonProtoSerializer.prototype.toBytes = function (bytes) {
        if (this.options.useProto3Json) {
            return bytes.toBase64();
        } else {
            // The typings say it's a string, but it needs to be a Uint8Array in Node.
            return this.unsafeCastProtoByteString(bytes.toUint8Array());
        }
    };
    /**
     * Parse the blob from the protos into the internal Blob class. Note that the
     * typings assume all blobs are strings, but they are actually Uint8Arrays
     * on Node.
     */
    JsonProtoSerializer.prototype.fromBlob = function (blob) {
        if (typeof blob === 'string') {
            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return blob_Blob.fromBase64String(blob);
        } else {
            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as string, but got something else instead.');
            return blob_Blob.fromUint8Array(blob);
        }
    };
    JsonProtoSerializer.prototype.toVersion = function (version) {
        return this.toTimestamp(version.toTimestamp());
    };
    JsonProtoSerializer.prototype.fromVersion = function (version) {
        assert(!!version, "Trying to deserialize version that isn't set");
        return snapshot_version_SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
    };
    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
        return this.fullyQualifiedPrefixPath(databaseId).child('documents').child(path).canonicalString();
    };
    JsonProtoSerializer.prototype.fromResourceName = function (name) {
        var resource = path_ResourcePath.fromString(name);
        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
        return resource;
    };
    JsonProtoSerializer.prototype.toName = function (key) {
        return this.toResourceName(this.databaseId, key.path);
    };
    JsonProtoSerializer.prototype.fromName = function (name) {
        var resource = this.fromResourceName(name);
        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' + resource.get(1) + ' vs ' + this.databaseId.projectId);
        assert(!resource.get(3) && !this.databaseId.database || resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' + resource.get(3) + ' vs ' + this.databaseId.database);
        return new document_key_DocumentKey(this.extractLocalPathFromResourceName(resource));
    };
    JsonProtoSerializer.prototype.toQueryPath = function (path) {
        if (path.length === 0) {
            // If the path is empty, the backend requires we leave off the /documents
            // at the end.
            return this.encodedDatabaseId;
        }
        return this.toResourceName(this.databaseId, path);
    };
    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
        var resourceName = this.fromResourceName(name);
        if (resourceName.length === 4) {
            return path_ResourcePath.EMPTY_PATH;
        }
        return this.extractLocalPathFromResourceName(resourceName);
    };
    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
        get: function get() {
            var path = new path_ResourcePath(['projects', this.databaseId.projectId, 'databases', this.databaseId.database]);
            return path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
        return new path_ResourcePath(['projects', databaseId.projectId, 'databases', databaseId.database]);
    };
    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
        return resourceName.popFirst(5);
    };
    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
        // Resource names have at least 4 components (project ID, database ID)
        return path.length >= 4 && path.get(0) === 'projects' && path.get(2) === 'databases';
    };
    JsonProtoSerializer.prototype.toValue = function (val) {
        if (val instanceof NullValue) {
            return { nullValue: 'NULL_VALUE' };
        } else if (val instanceof field_value_BooleanValue) {
            return { booleanValue: val.value() };
        } else if (val instanceof IntegerValue) {
            return { integerValue: '' + val.value() };
        } else if (val instanceof DoubleValue) {
            var doubleValue = val.value();
            if (this.options.useProto3Json) {
                // Proto 3 let's us encode NaN and Infinity as string values as
                // expected by the backend. This is currently not checked by our unit
                // tests because they rely on protobuf.js.
                if (isNaN(doubleValue)) {
                    return { doubleValue: 'NaN' };
                } else if (doubleValue === Infinity) {
                    return { doubleValue: 'Infinity' };
                } else if (doubleValue === -Infinity) {
                    return { doubleValue: '-Infinity' };
                }
            }
            return { doubleValue: val.value() };
        } else if (val instanceof field_value_StringValue) {
            return { stringValue: val.value() };
        } else if (val instanceof field_value_ObjectValue) {
            return { mapValue: this.toMapValue(val) };
        } else if (val instanceof field_value_ArrayValue) {
            return { arrayValue: this.toArrayValue(val) };
        } else if (val instanceof TimestampValue) {
            return {
                timestampValue: this.toTimestamp(val.internalValue)
            };
        } else if (val instanceof GeoPointValue) {
            return {
                geoPointValue: {
                    latitude: val.value().latitude,
                    longitude: val.value().longitude
                }
            };
        } else if (val instanceof BlobValue) {
            return {
                bytesValue: this.toBytes(val.value())
            };
        } else if (val instanceof field_value_RefValue) {
            return {
                referenceValue: this.toResourceName(val.databaseId, val.key.path)
            };
        } else {
            return fail('Unknown FieldValue ' + JSON.stringify(val));
        }
    };
    JsonProtoSerializer.prototype.fromValue = function (obj) {
        var _this = this;
        // tslint:disable-next-line:no-any
        var type = obj['value_type'];
        if (hasTag(obj, type, 'nullValue')) {
            return NullValue.INSTANCE;
        } else if (hasTag(obj, type, 'booleanValue')) {
            return field_value_BooleanValue.of(obj.booleanValue);
        } else if (hasTag(obj, type, 'integerValue')) {
            return new IntegerValue(parseInt64(obj.integerValue));
        } else if (hasTag(obj, type, 'doubleValue')) {
            if (this.options.useProto3Json) {
                // Proto 3 uses the string values 'NaN' and 'Infinity'.
                if (obj.doubleValue === 'NaN') {
                    return DoubleValue.NAN;
                } else if (obj.doubleValue === 'Infinity') {
                    return DoubleValue.POSITIVE_INFINITY;
                } else if (obj.doubleValue === '-Infinity') {
                    return DoubleValue.NEGATIVE_INFINITY;
                }
            }
            return new DoubleValue(obj.doubleValue);
        } else if (hasTag(obj, type, 'stringValue')) {
            return new field_value_StringValue(obj.stringValue);
        } else if (hasTag(obj, type, 'mapValue')) {
            return this.fromFields(obj.mapValue.fields || {});
        } else if (hasTag(obj, type, 'arrayValue')) {
            // "values" is not present if the array is empty
            assertPresent(obj.arrayValue, 'arrayValue');
            var values = obj.arrayValue.values || [];
            return new field_value_ArrayValue(values.map(function (v) {
                return _this.fromValue(v);
            }));
        } else if (hasTag(obj, type, 'timestampValue')) {
            assertPresent(obj.timestampValue, 'timestampValue');
            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
        } else if (hasTag(obj, type, 'geoPointValue')) {
            assertPresent(obj.geoPointValue, 'geoPointValue');
            var latitude = obj.geoPointValue.latitude || 0;
            var longitude = obj.geoPointValue.longitude || 0;
            return new GeoPointValue(new geo_point_GeoPoint(latitude, longitude));
        } else if (hasTag(obj, type, 'bytesValue')) {
            assertPresent(obj.bytesValue, 'bytesValue');
            var blob = this.fromBlob(obj.bytesValue);
            return new BlobValue(blob);
        } else if (hasTag(obj, type, 'referenceValue')) {
            assertPresent(obj.referenceValue, 'referenceValue');
            var resourceName = this.fromResourceName(obj.referenceValue);
            var dbId = new database_info_DatabaseId(resourceName.get(1), resourceName.get(3));
            var key = new document_key_DocumentKey(this.extractLocalPathFromResourceName(resourceName));
            return new field_value_RefValue(dbId, key);
        } else {
            return fail('Unknown Value proto ' + JSON.stringify(obj));
        }
    };
    /** Creates an api.Document from key and fields (but no create/update time) */
    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
        return {
            name: this.toName(key),
            fields: this.toFields(fields)
        };
    };
    JsonProtoSerializer.prototype.toDocument = function (document) {
        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
        return {
            name: this.toName(document.key),
            fields: this.toFields(document.data),
            updateTime: this.toTimestamp(document.version.toTimestamp())
        };
    };
    JsonProtoSerializer.prototype.fromDocument = function (document) {
        return new document_Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasLocalMutations: false });
    };
    JsonProtoSerializer.prototype.toFields = function (fields) {
        var _this = this;
        var result = {};
        fields.forEach(function (key, value) {
            result[key] = _this.toValue(value);
        });
        return result;
    };
    JsonProtoSerializer.prototype.fromFields = function (object) {
        var _this = this;
        // Proto map<string, Value> gets mapped to Object, so cast it.
        var map = object;
        var result = field_value_ObjectValue.EMPTY;
        forEach(map, function (key, value) {
            result = result.set(new path_FieldPath([key]), _this.fromValue(value));
        });
        return result;
    };
    JsonProtoSerializer.prototype.toMapValue = function (map) {
        return {
            fields: this.toFields(map)
        };
    };
    JsonProtoSerializer.prototype.toArrayValue = function (array) {
        var _this = this;
        var result = [];
        array.forEach(function (value) {
            result.push(_this.toValue(value));
        });
        return { values: result };
    };
    JsonProtoSerializer.prototype.fromFound = function (doc) {
        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
        assertPresent(doc.found.name, 'doc.found.name');
        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
        var key = this.fromName(doc.found.name);
        var version = this.fromVersion(doc.found.updateTime);
        var fields = this.fromFields(doc.found.fields || {});
        return new document_Document(key, version, fields, { hasLocalMutations: false });
    };
    JsonProtoSerializer.prototype.fromMissing = function (result) {
        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
        var key = this.fromName(result.missing);
        var version = this.fromVersion(result.readTime);
        return new document_NoDocument(key, version);
    };
    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
        // tslint:disable-next-line:no-any
        var type = result['result_type'];
        if (hasTag(result, type, 'found')) {
            return this.fromFound(result);
        } else if (hasTag(result, type, 'missing')) {
            return this.fromMissing(result);
        }
        return fail('invalid batch get response: ' + JSON.stringify(result));
    };
    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
        switch (state) {
            case WatchTargetChangeState.Added:
                return 'ADD';
            case WatchTargetChangeState.Current:
                return 'CURRENT';
            case WatchTargetChangeState.NoChange:
                return 'NO_CHANGE';
            case WatchTargetChangeState.Removed:
                return 'REMOVE';
            case WatchTargetChangeState.Reset:
                return 'RESET';
            default:
                return fail('Unknown WatchTargetChangeState: ' + state);
        }
    };
    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
        if (watchChange instanceof ExistenceFilterChange) {
            return {
                filter: {
                    count: watchChange.existenceFilter.count,
                    targetId: watchChange.targetId
                }
            };
        }
        if (watchChange instanceof DocumentWatchChange) {
            if (watchChange.newDoc instanceof document_Document) {
                var doc = watchChange.newDoc;
                return {
                    documentChange: {
                        document: {
                            name: this.toName(doc.key),
                            fields: this.toFields(doc.data),
                            updateTime: this.toVersion(doc.version)
                        },
                        targetIds: watchChange.updatedTargetIds,
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            } else if (watchChange.newDoc instanceof document_NoDocument) {
                var doc = watchChange.newDoc;
                return {
                    documentDelete: {
                        document: this.toName(doc.key),
                        readTime: this.toVersion(doc.version),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            } else if (watchChange.newDoc === null) {
                return {
                    documentRemove: {
                        document: this.toName(watchChange.key),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
        }
        if (watchChange instanceof watch_change_WatchTargetChange) {
            var cause = undefined;
            if (watchChange.cause) {
                cause = {
                    code: mapRpcCodeFromCode(watchChange.cause.code),
                    message: watchChange.cause.message
                };
            }
            return {
                targetChange: {
                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
                    targetIds: watchChange.targetIds,
                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
                    cause: cause
                }
            };
        }
        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
    };
    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
        // tslint:disable-next-line:no-any
        var type = change['change_type'];
        var watchChange;
        if (hasTag(change, type, 'targetChange')) {
            assertPresent(change.targetChange, 'targetChange');
            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
            // if unset
            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
            var targetIds = change.targetChange.targetIds || [];
            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
            var causeProto = change.targetChange.cause;
            var cause = causeProto && this.fromRpcStatus(causeProto);
            watchChange = new watch_change_WatchTargetChange(state, targetIds, resumeToken, cause || null);
        } else if (hasTag(change, type, 'documentChange')) {
            assertPresent(change.documentChange, 'documentChange');
            assertPresent(change.documentChange.document, 'documentChange.name');
            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
            var entityChange = change.documentChange;
            var key = this.fromName(entityChange.document.name);
            var version = this.fromVersion(entityChange.document.updateTime);
            var fields = this.fromFields(entityChange.document.fields || {});
            var doc = new document_Document(key, version, fields, {
                hasLocalMutations: false
            });
            var updatedTargetIds = entityChange.targetIds || [];
            var removedTargetIds = entityChange.removedTargetIds || [];
            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
        } else if (hasTag(change, type, 'documentDelete')) {
            assertPresent(change.documentDelete, 'documentDelete');
            assertPresent(change.documentDelete.document, 'documentDelete.document');
            var docDelete = change.documentDelete;
            var key = this.fromName(docDelete.document);
            var version = docDelete.readTime ? this.fromVersion(docDelete.readTime) : snapshot_version_SnapshotVersion.forDeletedDoc();
            var doc = new document_NoDocument(key, version);
            var removedTargetIds = docDelete.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
        } else if (hasTag(change, type, 'documentRemove')) {
            assertPresent(change.documentRemove, 'documentRemove');
            assertPresent(change.documentRemove.document, 'documentRemove');
            var docRemove = change.documentRemove;
            var key = this.fromName(docRemove.document);
            var removedTargetIds = docRemove.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
        } else if (hasTag(change, type, 'filter')) {
            // TODO(dimond): implement existence filter parsing with strategy.
            assertPresent(change.filter, 'filter');
            assertPresent(change.filter.targetId, 'filter.targetId');
            var filter = change.filter;
            var count = filter.count || 0;
            var existenceFilter = new ExistenceFilter(count);
            var targetId = filter.targetId;
            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
        } else {
            return fail('Unknown change type ' + JSON.stringify(change));
        }
        return watchChange;
    };
    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
        if (state === 'NO_CHANGE') {
            return WatchTargetChangeState.NoChange;
        } else if (state === 'ADD') {
            return WatchTargetChangeState.Added;
        } else if (state === 'REMOVE') {
            return WatchTargetChangeState.Removed;
        } else if (state === 'CURRENT') {
            return WatchTargetChangeState.Current;
        } else if (state === 'RESET') {
            return WatchTargetChangeState.Reset;
        } else {
            return fail('Got unexpected TargetChange.state: ' + state);
        }
    };
    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        // tslint:disable-next-line:no-any
        var type = change['response_type'];
        if (!hasTag(change, type, 'targetChange')) {
            return snapshot_version_SnapshotVersion.MIN;
        }
        var targetChange = change.targetChange;
        if (targetChange.targetIds && targetChange.targetIds.length) {
            return snapshot_version_SnapshotVersion.MIN;
        }
        if (!targetChange.readTime) {
            return snapshot_version_SnapshotVersion.MIN;
        }
        return this.fromVersion(targetChange.readTime);
    };
    JsonProtoSerializer.prototype.toMutation = function (mutation) {
        var _this = this;
        var result;
        if (mutation instanceof mutation_SetMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.value)
            };
        } else if (mutation instanceof mutation_DeleteMutation) {
            result = { delete: this.toName(mutation.key) };
        } else if (mutation instanceof mutation_PatchMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.data),
                updateMask: this.toDocumentMask(mutation.fieldMask)
            };
        } else if (mutation instanceof mutation_TransformMutation) {
            result = {
                transform: {
                    document: this.toName(mutation.key),
                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
                        return _this.toFieldTransform(transform);
                    })
                }
            };
        } else {
            return fail('Unknown mutation type ' + mutation.type);
        }
        if (!mutation.precondition.isNone) {
            result.currentDocument = this.toPrecondition(mutation.precondition);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromMutation = function (proto) {
        var _this = this;
        var precondition = proto.currentDocument ? this.fromPrecondition(proto.currentDocument) : mutation_Precondition.NONE;
        if (proto.update) {
            assertPresent(proto.update.name, 'name');
            var key = this.fromName(proto.update.name);
            var value = this.fromFields(proto.update.fields || {});
            if (proto.updateMask) {
                var fieldMask = this.fromDocumentMask(proto.updateMask);
                return new mutation_PatchMutation(key, value, fieldMask, precondition);
            } else {
                return new mutation_SetMutation(key, value, precondition);
            }
        } else if (proto.delete) {
            var key = this.fromName(proto.delete);
            return new mutation_DeleteMutation(key, precondition);
        } else if (proto.transform) {
            var key = this.fromName(proto.transform.document);
            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
                return _this.fromFieldTransform(transform);
            });
            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
            return new mutation_TransformMutation(key, fieldTransforms);
        } else {
            return fail('unknown mutation proto: ' + JSON.stringify(proto));
        }
    };
    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
        assert(!precondition.isNone, "Can't serialize an empty precondition");
        if (precondition.updateTime !== undefined) {
            return {
                updateTime: this.toVersion(precondition.updateTime)
            };
        } else if (precondition.exists !== undefined) {
            return { exists: precondition.exists };
        } else {
            return fail('Unknown precondition');
        }
    };
    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
        if (precondition.updateTime !== undefined) {
            return mutation_Precondition.updateTime(this.fromVersion(precondition.updateTime));
        } else if (precondition.exists !== undefined) {
            return mutation_Precondition.exists(precondition.exists);
        } else {
            return mutation_Precondition.NONE;
        }
    };
    JsonProtoSerializer.prototype.fromWriteResult = function (proto) {
        var _this = this;
        // NOTE: Deletes don't have an updateTime.
        var version = proto.updateTime ? this.fromVersion(proto.updateTime) : null;
        var transformResults = null;
        if (proto.transformResults) {
            transformResults = proto.transformResults.map(function (result) {
                return _this.fromValue(result);
            });
        }
        return new MutationResult(version, transformResults);
    };
    JsonProtoSerializer.prototype.fromWriteResults = function (protos) {
        var _this = this;
        return (protos || []).map(function (proto) {
            return _this.fromWriteResult(proto);
        });
    };
    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
        assert(fieldTransform.transform instanceof ServerTimestampTransform, 'Unknown transform: ' + fieldTransform.transform);
        return {
            fieldPath: fieldTransform.field.canonicalString(),
            setToServerValue: 'REQUEST_TIME'
        };
    };
    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
        assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown transform proto: ' + JSON.stringify(proto));
        var fieldPath = path_FieldPath.fromServerFormat(proto.fieldPath);
        return new FieldTransform(fieldPath, ServerTimestampTransform.instance);
    };
    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
        return { documents: [this.toQueryPath(query.path)] };
    };
    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
        var count = documentsTarget.documents.length;
        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
        var name = documentsTarget.documents[0];
        return query_Query.atPath(this.fromQueryPath(name));
    };
    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
        // Dissect the path into parent, collectionId, and optional key filter.
        var result = { structuredQuery: {} };
        if (query.path.isEmpty()) {
            result.parent = this.toQueryPath(path_ResourcePath.EMPTY_PATH);
        } else {
            var path = query.path;
            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
            result.parent = this.toQueryPath(path.popLast());
            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
        }
        var where = this.toFilter(query.filters);
        if (where) {
            result.structuredQuery.where = where;
        }
        var orderBy = this.toOrder(query.orderBy);
        if (orderBy) {
            result.structuredQuery.orderBy = orderBy;
        }
        var limit = this.toLimit(query.limit);
        if (limit !== undefined) {
            result.structuredQuery.limit = limit;
        }
        if (query.startAt) {
            result.structuredQuery.startAt = this.toCursor(query.startAt);
        }
        if (query.endAt) {
            result.structuredQuery.endAt = this.toCursor(query.endAt);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
        var path = this.fromQueryPath(target.parent);
        var query = target.structuredQuery;
        var fromCount = query.from ? query.from.length : 0;
        if (fromCount > 0) {
            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
            var from = query.from[0];
            path = path.child(from.collectionId);
        }
        var filterBy = [];
        if (query.where) {
            filterBy = this.fromFilter(query.where);
        }
        var orderBy = [];
        if (query.orderBy) {
            orderBy = this.fromOrder(query.orderBy);
        }
        var limit = null;
        if (query.limit) {
            limit = query.limit;
        }
        var startAt = null;
        if (query.startAt) {
            startAt = this.fromCursor(query.startAt);
        }
        var endAt = null;
        if (query.endAt) {
            endAt = this.fromCursor(query.endAt);
        }
        return new query_Query(path, orderBy, filterBy, limit, startAt, endAt);
    };
    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
        var value = this.toLabel(queryData.purpose);
        if (value == null) {
            return null;
        } else {
            return {
                'goog-listen-tags': value
            };
        }
    };
    JsonProtoSerializer.prototype.toLabel = function (purpose) {
        switch (purpose) {
            case QueryPurpose.Listen:
                return null;
            case QueryPurpose.ExistenceFilterMismatch:
                return 'existence-filter-mismatch';
            case QueryPurpose.LimboResolution:
                return 'limbo-document';
            default:
                return fail('Unrecognized query purpose: ' + purpose);
        }
    };
    JsonProtoSerializer.prototype.toTarget = function (queryData) {
        var result;
        var query = queryData.query;
        if (query.isDocumentQuery()) {
            result = { documents: this.toDocumentsTarget(query) };
        } else {
            result = { query: this.toQueryTarget(query) };
        }
        result.targetId = queryData.targetId;
        if (queryData.resumeToken.length > 0) {
            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
        }
        return result;
    };
    JsonProtoSerializer.prototype.toFilter = function (filters) {
        var _this = this;
        if (filters.length === 0) return;
        var protos = filters.map(function (filter) {
            return filter instanceof query_RelationFilter ? _this.toRelationFilter(filter) : _this.toUnaryFilter(filter);
        });
        if (protos.length === 1) {
            return protos[0];
        }
        return { compositeFilter: { op: 'AND', filters: protos } };
    };
    JsonProtoSerializer.prototype.fromFilter = function (filter) {
        var _this = this;
        if (!filter) {
            return [];
        } else if (filter.unaryFilter !== undefined) {
            return [this.fromUnaryFilter(filter)];
        } else if (filter.fieldFilter !== undefined) {
            return [this.fromRelationFilter(filter)];
        } else if (filter.compositeFilter !== undefined) {
            return filter.compositeFilter.filters.map(function (f) {
                return _this.fromFilter(f);
            }).reduce(function (accum, current) {
                return accum.concat(current);
            });
        } else {
            return fail('Unknown filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
        var _this = this;
        if (orderBys.length === 0) return;
        return orderBys.map(function (order) {
            return _this.toPropertyOrder(order);
        });
    };
    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
        var _this = this;
        return orderBys.map(function (order) {
            return _this.fromPropertyOrder(order);
        });
    };
    JsonProtoSerializer.prototype.toLimit = function (limit) {
        if (!isNullOrUndefined(limit)) {
            return limit;
        }
        return;
    };
    JsonProtoSerializer.prototype.toCursor = function (cursor) {
        var _this = this;
        return {
            before: cursor.before,
            values: cursor.position.map(function (component) {
                return _this.toValue(component);
            })
        };
    };
    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
        var _this = this;
        var before = !!cursor.before;
        var position = cursor.values.map(function (component) {
            return _this.fromValue(component);
        });
        return new query_Bound(position, before);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toDirection = function (dir) {
        return DIRECTIONS[dir.name];
    };
    // visible for testing
    JsonProtoSerializer.prototype.fromDirection = function (dir) {
        switch (dir) {
            case 'ASCENDING':
                return Direction.ASCENDING;
            case 'DESCENDING':
                return Direction.DESCENDING;
            default:
                return undefined;
        }
    };
    // visible for testing
    JsonProtoSerializer.prototype.toOperatorName = function (op) {
        return OPERATORS[op.name];
    };
    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
        switch (op) {
            case 'EQUAL':
                return query_RelationOp.EQUAL;
            case 'GREATER_THAN':
                return query_RelationOp.GREATER_THAN;
            case 'GREATER_THAN_OR_EQUAL':
                return query_RelationOp.GREATER_THAN_OR_EQUAL;
            case 'LESS_THAN':
                return query_RelationOp.LESS_THAN;
            case 'LESS_THAN_OR_EQUAL':
                return query_RelationOp.LESS_THAN_OR_EQUAL;
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified relation');
            default:
                return fail('Unknown relation');
        }
    };
    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
        return { fieldPath: path.canonicalString() };
    };
    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
        return path_FieldPath.fromServerFormat(fieldReference.fieldPath);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
        return {
            field: this.toFieldPathReference(orderBy.field),
            direction: this.toDirection(orderBy.dir)
        };
    };
    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
        return new query_OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toRelationFilter = function (filter) {
        if (filter instanceof query_RelationFilter) {
            return {
                fieldFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: this.toOperatorName(filter.op),
                    value: this.toValue(filter.value)
                }
            };
        } else {
            return fail('Unrecognized filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.fromRelationFilter = function (filter) {
        return new query_RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toUnaryFilter = function (filter) {
        if (filter instanceof NanFilter) {
            return {
                unaryFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: 'IS_NAN'
                }
            };
        } else if (filter instanceof NullFilter) {
            return {
                unaryFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: 'IS_NULL'
                }
            };
        } else {
            return fail('Unrecognized filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
        switch (filter.unaryFilter.op) {
            case 'IS_NAN':
                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
                return new NanFilter(nanField);
            case 'IS_NULL':
                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
                return new NullFilter(nullField);
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified filter');
            default:
                return fail('Unknown filter');
        }
    };
    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
        return {
            fieldPaths: fieldMask.fields.map(function (field) {
                return field.canonicalString();
            })
        };
    };
    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
        var paths = proto.fieldPaths || [];
        var fields = paths.map(function (path) {
            return path_FieldPath.fromServerFormat(path);
        });
        return new mutation_FieldMask(fields);
    };
    return JsonProtoSerializer;
}();

/**
 * Checks for a specific oneof tag in a protocol buffer message.
 *
 * This intentionally accommodates two distinct cases:
 *
 * 1) Messages containing a type tag: these are the format produced by GRPC in
 * return values. These may contain default-value mappings for all tags in the
 * oneof but the type tag specifies which one was actually set.
 *
 * 2) Messages that don't contain a type tag: these are the format required by
 * GRPC as inputs. If we emitted objects with type tags, ProtoBuf.js would
 * choke claiming that the tags aren't fields in the Message.
 *
 * Allowing both formats here makes the serializer able to consume the outputs
 * it produces: for all messages it supports, fromX(toX(value)) == value.
 *
 * Note that case 2 suffers from ambiguity: if multiple tags are present
 * without a type tag then the callers are structured in such a way that the
 * first invocation will win. Since we only parse in this mode when parsing
 * the output of a serialize method this works, but it's not a general
 * solution.
 *
 * Unfortunately there is no general solution here because proto3 makes it
 * impossible to distinguish unset from explicitly set fields: both have the
 * default value for the type. Without the type tag but multiple value tags
 * it's possible to have default values for each tag in the oneof and not be
 * able to know which was actually in effect.
 */
function hasTag(obj, type, tag) {
    return type === tag || !type && tag in obj;
}

//# sourceMappingURL=serializer.js.map
// EXTERNAL MODULE: ../node_modules/@firebase/webchannel-wrapper/dist/index.js
var dist = __webpack_require__("IIoC");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/stream_bridge.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */
var stream_bridge_StreamBridge = /** @class */function () {
    function StreamBridge(args) {
        this.wrappedOnOpen = null;
        this.wrappedOnClose = null;
        this.wrappedOnMessage = null;
        this.sendFn = args.sendFn;
        this.closeFn = args.closeFn;
    }
    StreamBridge.prototype.onOpen = function (callback) {
        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
        this.wrappedOnOpen = callback;
    };
    StreamBridge.prototype.onClose = function (callback) {
        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
        this.wrappedOnClose = callback;
    };
    StreamBridge.prototype.onMessage = function (callback) {
        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
        this.wrappedOnMessage = callback;
    };
    StreamBridge.prototype.close = function () {
        this.closeFn();
    };
    StreamBridge.prototype.send = function (msg) {
        this.sendFn(msg);
    };
    StreamBridge.prototype.callOnOpen = function () {
        assert(this.wrappedOnOpen !== null, 'Cannot call onOpen because no callback ' + 'was set');
        this.wrappedOnOpen();
    };
    StreamBridge.prototype.callOnClose = function (err) {
        assert(this.wrappedOnClose !== null, 'Cannot call onClose because no ' + 'callback was set');
        this.wrappedOnClose(err);
    };
    StreamBridge.prototype.callOnMessage = function (msg) {
        assert(this.wrappedOnMessage !== null, 'Cannot call onMessage because no ' + 'callback was set');
        this.wrappedOnMessage(msg);
    };
    return StreamBridge;
}();


//# sourceMappingURL=stream_bridge.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/platform_browser/webchannel_connection.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var LOG_TAG = 'Connection';
var RPC_URL_VERSION = 'v1beta1';
// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
// we are doing out-of-band releases. Once we release as part of Firebase, we
// should use the Firebase version instead.
var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
var XHR_TIMEOUT_SECS = 15;
var webchannel_connection_WebChannelConnection = /** @class */function () {
    function WebChannelConnection(info) {
        this.databaseId = info.databaseId;
        this.pool = new dist["XhrIoPool"]();
        var proto = info.ssl ? 'https' : 'http';
        this.baseUrl = proto + '://' + info.host;
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */
    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
        if (token) {
            for (var header in token.authHeaders) {
                if (token.authHeaders.hasOwnProperty(header)) {
                    headers[header] = token.authHeaders[header];
                }
            }
        }
        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
        // This header is used to improve routing and project isolation by the
        // backend.
        headers['google-cloud-resource-prefix'] = "projects/" + this.databaseId.projectId + "/" + ("databases/" + this.databaseId.database);
    };
    WebChannelConnection.prototype.invoke = function (rpcName, request, token) {
        var _this = this;
        var url = this.makeUrl(rpcName);
        return new Promise(function (resolve, reject) {
            _this.pool.getObject(function (xhr) {
                xhr.listenOnce(dist["EventType"].COMPLETE, function () {
                    try {
                        switch (xhr.getLastErrorCode()) {
                            case dist["ErrorCode"].NO_ERROR:
                                var json = xhr.getResponseJson();
                                debug(LOG_TAG, 'XHR received:', JSON.stringify(json));
                                resolve(json);
                                break;
                            case dist["ErrorCode"].TIMEOUT:
                                debug(LOG_TAG, 'RPC "' + rpcName + '" timed out');
                                reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
                                break;
                            case dist["ErrorCode"].HTTP_ERROR:
                                var status_1 = xhr.getStatus();
                                debug(LOG_TAG, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
                                if (status_1 > 0) {
                                    reject(new FirestoreError(mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
                                } else {
                                    // If we received an HTTP_ERROR but there's no status code,
                                    // it's most probably a connection issue
                                    debug(LOG_TAG, 'RPC "' + rpcName + '" failed');
                                    reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
                                }
                                break;
                            default:
                                fail('RPC "' + rpcName + '" failed with unanticipated ' + 'webchannel error ' + xhr.getLastErrorCode() + ': ' + xhr.getLastError() + ', giving up.');
                        }
                    } finally {
                        debug(LOG_TAG, 'RPC "' + rpcName + '" completed.');
                        _this.pool.releaseObject(xhr);
                    }
                });
                var requestString = JSON.stringify(request);
                debug(LOG_TAG, 'XHR sending: ', url + ' ' + requestString);
                // Content-Type: text/plain will avoid preflight requests which might
                // mess with CORS and redirects by proxies. If we add custom headers
                // we will need to change this code to potentially use the
                // $httpOverwrite parameter supported by ESF to avoid
                // triggering preflight requests.
                var headers = { 'Content-Type': 'text/plain' };
                _this.modifyHeadersForRequest(headers, token);
                xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
            });
        });
    };
    WebChannelConnection.prototype.openStream = function (rpcName, token) {
        var rpcService = WebChannelConnection.RPC_STREAM_SERVICE_MAPPING[rpcName];
        var rpcUrlName = WebChannelConnection.RPC_STREAM_NAME_MAPPING[rpcName];
        if (!rpcService || !rpcUrlName) {
            fail('Unknown RPC name: ' + rpcName);
        }
        var urlParts = [this.baseUrl, '/', rpcService, '/', rpcUrlName, '/channel'];
        var webchannelTransport = Object(dist["createWebChannelTransport"])();
        var request = {
            // Background channel test avoids the initial two test calls and decreases
            // initial cold start time.
            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
            // we should monitor closely for any reports.
            backgroundChannelTest: true,
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: 'gsessionid',
            initMessageHeaders: {},
            sendRawJson: true,
            supportsCrossDomainXhr: true
        };
        this.modifyHeadersForRequest(request.initMessageHeaders, token);
        var url = urlParts.join('');
        debug(LOG_TAG, 'Creating WebChannel: ' + url + ' ' + request);
        // tslint:disable-next-line:no-any Because listen isn't defined on it.
        var channel = webchannelTransport.createWebChannel(url, request);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        var opened = false;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        var closed = false;
        // tslint:disable-next-line:no-any
        var streamBridge = new stream_bridge_StreamBridge({
            sendFn: function sendFn(msg) {
                if (!closed) {
                    if (!opened) {
                        debug(LOG_TAG, 'Opening WebChannel transport.');
                        channel.open();
                        opened = true;
                    }
                    debug(LOG_TAG, 'WebChannel sending:', msg);
                    channel.send(msg);
                } else {
                    debug(LOG_TAG, 'Not sending because WebChannel is closed:', msg);
                }
            },
            closeFn: function closeFn() {
                return channel.close();
            }
        });
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        var unguardedEventListen = function unguardedEventListen(type, fn) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            channel.listen(type, function (param) {
                try {
                    fn(param);
                } catch (e) {
                    setTimeout(function () {
                        throw e;
                    }, 0);
                }
            });
        };
        unguardedEventListen(dist["WebChannel"].EventType.OPEN, function () {
            if (!closed) {
                debug(LOG_TAG, 'WebChannel transport opened.');
            }
        });
        unguardedEventListen(dist["WebChannel"].EventType.CLOSE, function () {
            if (!closed) {
                closed = true;
                debug(LOG_TAG, 'WebChannel transport closed');
                streamBridge.callOnClose();
            }
        });
        unguardedEventListen(dist["WebChannel"].EventType.ERROR, function (err) {
            if (!closed) {
                closed = true;
                debug(LOG_TAG, 'WebChannel transport errored:', err);
                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
            }
        });
        unguardedEventListen(dist["WebChannel"].EventType.MESSAGE, function (msg) {
            if (!closed) {
                // WebChannel delivers message events as array. If batching
                // is not enabled (it's off by default) each message will be
                // delivered alone, resulting in a single element array.
                var msgData = msg.data[0];
                assert(!!msgData, 'Got a webchannel message without data.');
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                var error = msgData.error || msgData[0] && msgData[0].error;
                if (error) {
                    debug(LOG_TAG, 'WebChannel received error:', error);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var status_2 = error.status;
                    var code = mapCodeFromRpcStatus(status_2);
                    var message = error.message;
                    if (code === undefined) {
                        code = Code.INTERNAL;
                        message = 'Unknown error status: ' + status_2 + ' with message ' + error.message;
                    }
                    // Mark closed so no further events are propagated
                    closed = true;
                    streamBridge.callOnClose(new FirestoreError(code, message));
                    channel.close();
                } else {
                    debug(LOG_TAG, 'WebChannel received:', msgData);
                    streamBridge.callOnMessage(msgData);
                }
            }
        });
        setTimeout(function () {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            streamBridge.callOnOpen();
        }, 0);
        return streamBridge;
    };
    // visible for testing
    WebChannelConnection.prototype.makeUrl = function (rpcName) {
        var url = [this.baseUrl, '/', RPC_URL_VERSION];
        url.push('/projects/');
        url.push(this.databaseId.projectId);
        url.push('/databases/');
        url.push(this.databaseId.database);
        url.push('/documents');
        url.push(':');
        url.push(rpcName);
        return url.join('');
    };
    /**
     * Mapping from RPC name to service providing the RPC.
     * For streaming RPCs only.
     */
    WebChannelConnection.RPC_STREAM_SERVICE_MAPPING = {
        Write: 'google.firestore.v1beta1.Firestore',
        Listen: 'google.firestore.v1beta1.Firestore'
    };
    /**
     * Mapping from RPC name to actual RPC name in URLs.
     * For streaming RPCs only.
     */
    WebChannelConnection.RPC_STREAM_NAME_MAPPING = {
        Write: 'Write',
        Listen: 'Listen'
    };
    return WebChannelConnection;
}();


//# sourceMappingURL=webchannel_connection.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/platform_browser/browser_platform.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var browser_platform_BrowserPlatform = /** @class */function () {
    function BrowserPlatform() {
        this.emptyByteString = '';
        this.base64Available = typeof atob !== 'undefined';
    }
    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
        return Promise.resolve(new webchannel_connection_WebChannelConnection(databaseInfo));
    };
    BrowserPlatform.prototype.newSerializer = function (databaseId) {
        return new serializer_JsonProtoSerializer(databaseId, { useProto3Json: true });
    };
    BrowserPlatform.prototype.atob = function (encoded) {
        return atob(encoded);
    };
    BrowserPlatform.prototype.btoa = function (raw) {
        return btoa(raw);
    };
    return BrowserPlatform;
}();


//# sourceMappingURL=browser_platform.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/platform_browser/browser_init.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * This code needs to run before Firestore is used. This can be achieved in
 * several ways:
 *   1) Through the JSCompiler compiling this code and then (automatically)
 *      executing it before exporting the Firestore symbols.
 *   2) Through importing this module first in a Firestore main module
 */
platform_PlatformSupport.setPlatform(new browser_platform_BrowserPlatform());

//# sourceMappingURL=browser_init.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/field_path.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */
var field_path_FieldPath = /** @class */function () {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */
    function FieldPath() {
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
        for (var i = 0; i < fieldNames.length; ++i) {
            validateArgType('FieldPath', 'string', i, fieldNames[i]);
            if (fieldNames[i].length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " + 'Field names must not be empty.');
            }
        }
        this._internalPath = new path_FieldPath(fieldNames);
    }
    FieldPath.documentId = function () {
        return FieldPath._DOCUMENT_ID;
    };
    /**
     * Internal Note: The backend doesn't technically support querying by
     * document ID. Instead it queries by the entire document name (full path
     * included), but in the cases we currently support documentId(), the net
     * effect is the same.
     */
    FieldPath._DOCUMENT_ID = new FieldPath(path_FieldPath.keyField().canonicalString());
    return FieldPath;
}();

/**
 * Matches any characters in a field path string that are reserved.
 */
var RESERVED = new RegExp('[~\\*/\\[\\]]');
/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */
function fromDotSeparatedString(path) {
    var found = path.search(RESERVED);
    if (found >= 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " + "'~', '*', '/', '[', or ']'");
    }
    try {
        return new (field_path_FieldPath.bind.apply(field_path_FieldPath, [void 0].concat(path.split('.'))))();
    } catch (e) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " + "begin with '.', end with '.', or contain '..'");
    }
}

//# sourceMappingURL=field_path.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/types.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Describes the online state of the Firestore client */
var OnlineState;
(function (OnlineState) {
  /**
   * The Firestore client is in an unknown online state. This means the client
   * is either not actively trying to establish a connection or it was
   * previously in an unknown state and is trying to establish a connection.
   */
  OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
  /**
   * The client is connected and the connections are healthy. This state is
   * reached after a successful connection and there has been at least one
   * succesful message received from the backends.
   */
  OnlineState[OnlineState["Healthy"] = 1] = "Healthy";
  /**
   * The client has tried to establish a connection but has failed.
   * This state is reached after either a connection attempt failed or a
   * healthy stream was closed for unexpected reasons.
   */
  OnlineState[OnlineState["Failed"] = 2] = "Failed";
})(OnlineState = OnlineState || (OnlineState = {}));

//# sourceMappingURL=types.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/view_snapshot.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Added"] = 0] = "Added";
    ChangeType[ChangeType["Removed"] = 1] = "Removed";
    ChangeType[ChangeType["Modified"] = 2] = "Modified";
    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
})(ChangeType = ChangeType || (ChangeType = {}));
var SyncState;
(function (SyncState) {
    SyncState[SyncState["Local"] = 0] = "Local";
    SyncState[SyncState["Synced"] = 1] = "Synced";
})(SyncState = SyncState || (SyncState = {}));
/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */
var view_snapshot_DocumentChangeSet = /** @class */function () {
    function DocumentChangeSet() {
        this.changeMap = new sorted_map_SortedMap(document_key_DocumentKey.comparator);
    }
    DocumentChangeSet.prototype.track = function (change) {
        var key = change.doc.key;
        var oldChange = this.changeMap.get(key);
        if (!oldChange) {
            this.changeMap = this.changeMap.insert(key, change);
            return;
        }
        // Merge the new change with the existing change.
        if (change.type !== ChangeType.Added && oldChange.type === ChangeType.Metadata) {
            this.changeMap = this.changeMap.insert(key, change);
        } else if (change.type === ChangeType.Metadata && oldChange.type !== ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: oldChange.type,
                doc: change.doc
            });
        } else if (change.type === ChangeType.Modified && oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        } else if (change.type === ChangeType.Modified && oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Added,
                doc: change.doc
            });
        } else if (change.type === ChangeType.Removed && oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.remove(key);
        } else if (change.type === ChangeType.Removed && oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Removed,
                doc: oldChange.doc
            });
        } else if (change.type === ChangeType.Added && oldChange.type === ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        } else {
            // This includes these cases, which don't make sense:
            // Added->Added
            // Removed->Removed
            // Modified->Added
            // Removed->Modified
            // Metadata->Added
            // Removed->Metadata
            fail('unsupported combination of changes: ' + JSON.stringify(change) + ' after ' + JSON.stringify(oldChange));
        }
    };
    DocumentChangeSet.prototype.getChanges = function () {
        var changes = [];
        this.changeMap.inorderTraversal(function (key, change) {
            changes.push(change);
        });
        return changes;
    };
    return DocumentChangeSet;
}();


//# sourceMappingURL=view_snapshot.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/document_set.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */
var document_set_DocumentSet = /** @class */function () {
    /** The default ordering is by key if the comparator is omitted */
    function DocumentSet(comp) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        if (comp) {
            this.comparator = function (d1, d2) {
                return comp(d1, d2) || document_key_DocumentKey.comparator(d1.key, d2.key);
            };
        } else {
            this.comparator = function (d1, d2) {
                return document_key_DocumentKey.comparator(d1.key, d2.key);
            };
        }
        this.keyedMap = documentMap();
        this.sortedSet = new sorted_map_SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */
    DocumentSet.emptySet = function (oldSet) {
        return new DocumentSet(oldSet.comparator);
    };
    DocumentSet.prototype.has = function (key) {
        return this.keyedMap.get(key) != null;
    };
    DocumentSet.prototype.get = function (key) {
        return this.keyedMap.get(key);
    };
    DocumentSet.prototype.first = function () {
        return this.sortedSet.minKey();
    };
    DocumentSet.prototype.last = function () {
        return this.sortedSet.maxKey();
    };
    DocumentSet.prototype.isEmpty = function () {
        return this.sortedSet.isEmpty();
    };
    /**
     * Returns previous document or null if it's a first doc.
     *
     * @param key A key that MUST be present in the DocumentSet.
     */
    DocumentSet.prototype.prevDoc = function (key) {
        assert(this.has(key), 'Trying to get a previous document to non-existing key: ' + key);
        var doc = this.keyedMap.get(key);
        return this.sortedSet.getPredecessorKey(doc);
    };
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */
    DocumentSet.prototype.indexOf = function (key) {
        var doc = this.keyedMap.get(key);
        return doc ? this.sortedSet.indexOf(doc) : -1;
    };
    Object.defineProperty(DocumentSet.prototype, "size", {
        get: function get() {
            return this.sortedSet.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Iterates documents in order defined by "comparator" */
    DocumentSet.prototype.forEach = function (cb) {
        this.sortedSet.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Inserts or updates a document with the same key */
    DocumentSet.prototype.add = function (doc) {
        // First remove the element if we have it.
        var set = this.delete(doc.key);
        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
    };
    /** Deletes a document with a given key */
    DocumentSet.prototype.delete = function (key) {
        var doc = this.get(key);
        if (!doc) {
            return this;
        }
        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
    };
    DocumentSet.prototype.equals = function (other) {
        if (!(other instanceof DocumentSet)) return false;
        if (this.size !== other.size) return false;
        var thisIt = this.sortedSet.getIterator();
        var otherIt = other.sortedSet.getIterator();
        while (thisIt.hasNext()) {
            var thisDoc = thisIt.getNext().key;
            var otherDoc = otherIt.getNext().key;
            if (!thisDoc.equals(otherDoc)) return false;
        }
        return true;
    };
    DocumentSet.prototype.toString = function () {
        var docStrings = [];
        this.forEach(function (doc) {
            docStrings.push(doc.toString());
        });
        if (docStrings.length === 0) {
            return 'DocumentSet ()';
        } else {
            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
        }
    };
    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
        var newSet = new DocumentSet();
        newSet.comparator = this.comparator;
        newSet.keyedMap = keyedMap;
        newSet.sortedSet = sortedSet;
        return newSet;
    };
    return DocumentSet;
}();


//# sourceMappingURL=document_set.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/obj_map.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A map implementation that uses objects as keys. Objects must implement the
 * Equatable interface and must be immutable. Entries in the map are stored
 * together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */
var obj_map_ObjectMap = /** @class */function () {
    function ObjectMap(mapKeyFn) {
        this.mapKeyFn = mapKeyFn;
        /**
         * The inner map for a key -> value pair. Due to the possibility of
         * collisions we keep a list of entries that we do a linear search through
         * to find an actual match. Note that collisions should be rare, so we still
         * expect near constant time lookups in practice.
         */
        this.inner = {};
    }
    /** Get a value for this key, or undefined if it does not exist. */
    ObjectMap.prototype.get = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return undefined;
        }
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var _a = matches_1[_i],
                otherKey = _a[0],
                value = _a[1];
            if (otherKey.equals(key)) {
                return value;
            }
        }
        return undefined;
    };
    ObjectMap.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    /** Put this key and value in the map. */
    ObjectMap.prototype.set = function (key, value) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            this.inner[id] = [[key, value]];
            return;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].equals(key)) {
                matches[i] = [key, value];
                return;
            }
        }
        matches.push([key, value]);
    };
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */
    ObjectMap.prototype.delete = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return false;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].equals(key)) {
                if (matches.length === 1) {
                    delete this.inner[id];
                } else {
                    matches.splice(i, 1);
                }
                return true;
            }
        }
        return false;
    };
    ObjectMap.prototype.forEach = function (fn) {
        forEach(this.inner, function (_, entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i],
                    k = _a[0],
                    v = _a[1];
                fn(k, v);
            }
        });
    };
    ObjectMap.prototype.isEmpty = function () {
        return isEmpty(this.inner);
    };
    return ObjectMap;
}();


//# sourceMappingURL=obj_map.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/event_manager.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */
var QueryListenersInfo = /** @class */function () {
    function QueryListenersInfo() {
        this.listeners = [];
    }
    return QueryListenersInfo;
}();
/**
 * EventManager is responsible for mapping queries to query event emitters.
 * It handles "fan-out". -- Identical queries will re-use the same watch on the
 * backend.
 */
var event_manager_EventManager = /** @class */function () {
    function EventManager(syncEngine) {
        this.syncEngine = syncEngine;
        this.queries = new obj_map_ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.onlineState = OnlineState.Unknown;
        this.syncEngine.subscribe(this.onChange.bind(this), this.onError.bind(this));
    }
    EventManager.prototype.listen = function (listener) {
        var query = listener.query;
        var firstListen = false;
        var queryInfo = this.queries.get(query);
        if (!queryInfo) {
            firstListen = true;
            queryInfo = new QueryListenersInfo();
            this.queries.set(query, queryInfo);
        }
        queryInfo.listeners.push(listener);
        listener.onOnlineStateChanged(this.onlineState);
        if (queryInfo.viewSnap) listener.onViewSnapshot(queryInfo.viewSnap);
        if (firstListen) {
            return this.syncEngine.listen(query).then(function (targetId) {
                queryInfo.targetId = targetId;
                return targetId;
            });
        } else {
            return Promise.resolve(queryInfo.targetId);
        }
    };
    EventManager.prototype.unlisten = function (listener) {
        var query = listener.query;
        var lastListen = false;
        var queryInfo = this.queries.get(query);
        if (queryInfo) {
            var i = queryInfo.listeners.indexOf(listener);
            if (i >= 0) {
                queryInfo.listeners.splice(i, 1);
                lastListen = queryInfo.listeners.length === 0;
            }
        }
        if (lastListen) {
            this.queries.delete(query);
            return this.syncEngine.unlisten(query);
        } else {
            return Promise.resolve();
        }
    };
    EventManager.prototype.onChange = function (viewSnaps) {
        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
            var viewSnap = viewSnaps_1[_i];
            var query = viewSnap.query;
            var queryInfo = this.queries.get(query);
            if (queryInfo) {
                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
                    var listener = _b[_a];
                    listener.onViewSnapshot(viewSnap);
                }
                queryInfo.viewSnap = viewSnap;
            }
        }
    };
    EventManager.prototype.onError = function (query, error) {
        var queryInfo = this.queries.get(query);
        if (queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onError(error);
            }
        }
        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
        // after an error.
        this.queries.delete(query);
    };
    EventManager.prototype.onOnlineStateChanged = function (onlineState) {
        this.onlineState = onlineState;
        this.queries.forEach(function (_, queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onOnlineStateChanged(onlineState);
            }
        });
    };
    return EventManager;
}();

/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */
var event_manager_QueryListener = /** @class */function () {
    function QueryListener(query, queryObserver, options) {
        this.query = query;
        this.queryObserver = queryObserver;
        /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */
        this.raisedInitialEvent = false;
        this.onlineState = OnlineState.Unknown;
        this.options = options || {};
    }
    QueryListener.prototype.onViewSnapshot = function (snap) {
        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
        if (!this.options.includeDocumentMetadataChanges) {
            // Remove the metadata only changes.
            var docChanges = [];
            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
                var docChange = _a[_i];
                if (docChange.type !== ChangeType.Metadata) {
                    docChanges.push(docChange);
                }
            }
            snap = {
                query: snap.query,
                docs: snap.docs,
                oldDocs: snap.oldDocs,
                docChanges: docChanges,
                fromCache: snap.fromCache,
                hasPendingWrites: snap.hasPendingWrites,
                syncStateChanged: snap.syncStateChanged
            };
        }
        if (!this.raisedInitialEvent) {
            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
                this.raiseInitialEvent(snap);
            }
        } else if (this.shouldRaiseEvent(snap)) {
            this.queryObserver.next(snap);
        }
        this.snap = snap;
    };
    QueryListener.prototype.onError = function (error) {
        this.queryObserver.error(error);
    };
    QueryListener.prototype.onOnlineStateChanged = function (onlineState) {
        this.onlineState = onlineState;
        if (this.snap && !this.raisedInitialEvent && this.shouldRaiseInitialEvent(this.snap, onlineState)) {
            this.raiseInitialEvent(this.snap);
        }
    };
    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
        // Always raise the first event when we're synced
        if (!snap.fromCache) {
            return true;
        }
        // NOTE: We consider OnlineState.Unknown as online (it should become Failed
        // or Online if we wait long enough).
        var maybeOnline = onlineState !== OnlineState.Failed;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        if (this.options.waitForSyncWhenOnline && maybeOnline) {
            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
            return false;
        }
        // Raise data from cache if we have any documents or we are offline
        return !snap.docs.isEmpty() || onlineState === OnlineState.Failed;
    };
    QueryListener.prototype.shouldRaiseEvent = function (snap) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (snap.docChanges.length > 0) {
            return true;
        }
        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
        if (snap.syncStateChanged || hasPendingWritesChanged) {
            return this.options.includeQueryMetadataChanges === true;
        }
        // Generally we should have hit one of the cases above, but it's possible
        // to get here if there were only metadata docChanges and they got
        // stripped out.
        return false;
    };
    QueryListener.prototype.raiseInitialEvent = function (snap) {
        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
        snap = {
            query: snap.query,
            docs: snap.docs,
            oldDocs: document_set_DocumentSet.emptySet(snap.docs),
            docChanges: QueryListener.getInitialViewChanges(snap),
            fromCache: snap.fromCache,
            hasPendingWrites: snap.hasPendingWrites,
            syncStateChanged: true
        };
        this.raisedInitialEvent = true;
        this.queryObserver.next(snap);
    };
    /** Returns changes as if all documents in the snap were added. */
    QueryListener.getInitialViewChanges = function (snap) {
        var result = [];
        snap.docs.forEach(function (doc) {
            result.push({ type: ChangeType.Added, doc: doc });
        });
        return result;
    };
    return QueryListener;
}();


//# sourceMappingURL=event_manager.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/persistence_promise.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * PersistencePromise<> is essentially a re-implementation of Promise<> except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise<> implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */
var persistence_promise_PersistencePromise = /** @class */function () {
    function PersistencePromise(callback) {
        var _this = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null;
        this.catchCallback = null;
        // When the operation resolves, we'll set result or error and mark isDone.
        this.result = undefined;
        this.error = null;
        this.isDone = false;
        // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false;
        callback(function (value) {
            _this.isDone = true;
            _this.result = value;
            if (_this.nextCallback) {
                // value should be defined unless T is Void, but we can't express
                // that in the type system.
                _this.nextCallback(value);
            }
        }, function (error) {
            _this.isDone = true;
            _this.error = error;
            if (_this.catchCallback) {
                _this.catchCallback(error);
            }
        });
    }
    PersistencePromise.prototype.catch = function (fn) {
        return this.next(undefined, fn);
    };
    PersistencePromise.prototype.next = function (nextFn, catchFn) {
        var _this = this;
        if (this.callbackAttached) {
            fail('Called next() or catch() twice for PersistencePromise');
        }
        this.callbackAttached = true;
        if (this.isDone) {
            if (!this.error) {
                return this.wrapSuccess(nextFn, this.result);
            } else {
                return this.wrapFailure(catchFn, this.error);
            }
        } else {
            return new PersistencePromise(function (resolve, reject) {
                _this.nextCallback = function (value) {
                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
                };
                _this.catchCallback = function (error) {
                    _this.wrapFailure(catchFn, error).next(resolve, reject);
                };
            });
        }
    };
    PersistencePromise.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.next(resolve, reject);
        });
    };
    PersistencePromise.prototype.wrapUserFunction = function (fn) {
        try {
            var result = fn();
            if (result instanceof PersistencePromise) {
                return result;
            } else {
                return PersistencePromise.resolve(result);
            }
        } catch (e) {
            return PersistencePromise.reject(e);
        }
    };
    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
        if (nextFn) {
            return this.wrapUserFunction(function () {
                return nextFn(value);
            });
        } else {
            // If there's no nextFn, then R must be the same as T but we
            // can't express that in the type system.
            return PersistencePromise.resolve(value);
        }
    };
    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
        if (catchFn) {
            return this.wrapUserFunction(function () {
                return catchFn(error);
            });
        } else {
            return PersistencePromise.reject(error);
        }
    };
    PersistencePromise.resolve = function (result) {
        return new PersistencePromise(function (resolve, reject) {
            resolve(result);
        });
    };
    PersistencePromise.reject = function (error) {
        return new PersistencePromise(function (resolve, reject) {
            reject(error);
        });
    };
    PersistencePromise.waitFor = function (all) {
        return all.reduce(function (promise, nextPromise, idx) {
            return promise.next(function () {
                return nextPromise;
            });
        }, PersistencePromise.resolve());
    };
    PersistencePromise.map = function (all) {
        var results = [];
        var first = true;
        // initial is ignored, so we can cheat on the type.
        var initial = PersistencePromise.resolve(null);
        return all.reduce(function (promise, nextPromise) {
            return promise.next(function (result) {
                if (!first) {
                    results.push(result);
                }
                first = false;
                return nextPromise;
            });
        }, initial).next(function (result) {
            results.push(result);
            return results;
        });
    };
    return PersistencePromise;
}();


//# sourceMappingURL=persistence_promise.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/eager_garbage_collector.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A garbage collector implementation that eagerly collects documents as soon as
 * they're no longer referenced in any of its registered GarbageSources.
 *
 * This implementation keeps track of a set of keys that are potentially garbage
 * without keeping an exact reference count. During collectGarbage, the
 * collector verifies that all potential garbage keys actually have no
 * references by consulting its list of garbage sources.
 */
var eager_garbage_collector_EagerGarbageCollector = /** @class */function () {
    function EagerGarbageCollector() {
        this.isEager = true;
        /**
         * The garbage collectible sources to double-check during garbage collection.
         */
        this.sources = [];
        /**
         * A set of potentially garbage keys.
         * PORTING NOTE: This would be a mutable set if Javascript had one.
         */
        this.potentialGarbage = documentKeySet();
    }
    EagerGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
        this.sources.push(garbageSource);
        garbageSource.setGarbageCollector(this);
    };
    EagerGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
        this.sources.splice(this.sources.indexOf(garbageSource), 1);
        garbageSource.setGarbageCollector(null);
    };
    EagerGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
        this.potentialGarbage = this.potentialGarbage.add(key);
    };
    EagerGarbageCollector.prototype.collectGarbage = function (txn) {
        var _this = this;
        var promises = [];
        var garbageKeys = documentKeySet();
        this.potentialGarbage.forEach(function (key) {
            var hasRefsPromise = _this.documentHasAnyReferences(txn, key);
            promises.push(hasRefsPromise.next(function (hasRefs) {
                // If there are no references, get the key.
                if (!hasRefs) {
                    garbageKeys = garbageKeys.add(key);
                }
                return persistence_promise_PersistencePromise.resolve();
            }));
        });
        // Clear locally retained potential keys and returned confirmed garbage.
        this.potentialGarbage = documentKeySet();
        return persistence_promise_PersistencePromise.waitFor(promises).next(function () {
            return garbageKeys;
        });
    };
    EagerGarbageCollector.prototype.documentHasAnyReferences = function (txn, key) {
        var initial = persistence_promise_PersistencePromise.resolve(false);
        return this.sources.map(function (source) {
            return function () {
                return source.containsKey(txn, key);
            };
        }).reduce(function (promise, nextPromise) {
            return promise.next(function (result) {
                if (result) {
                    return persistence_promise_PersistencePromise.resolve(true);
                } else {
                    return nextPromise();
                }
            });
        }, initial);
    };
    return EagerGarbageCollector;
}();


//# sourceMappingURL=eager_garbage_collector.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/local_view_changes.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */
var local_view_changes_LocalViewChanges = /** @class */function () {
    function LocalViewChanges(query, addedKeys, removedKeys) {
        this.query = query;
        this.addedKeys = addedKeys;
        this.removedKeys = removedKeys;
    }
    LocalViewChanges.fromSnapshot = function (viewSnapshot) {
        var addedKeys = documentKeySet();
        var removedKeys = documentKeySet();
        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
            var docChange = _a[_i];
            switch (docChange.type) {
                case ChangeType.Added:
                    addedKeys = addedKeys.add(docChange.doc.key);
                    break;
                case ChangeType.Removed:
                    removedKeys = removedKeys.add(docChange.doc.key);
                    break;
                default:
            }
        }
        return new LocalViewChanges(viewSnapshot.query, addedKeys, removedKeys);
    };
    return LocalViewChanges;
}();


//# sourceMappingURL=local_view_changes.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/reference_set.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */
var reference_set_ReferenceSet = /** @class */function () {
    function ReferenceSet() {
        // A set of outstanding references to a document sorted by key.
        this.refsByKey = new sorted_set_SortedSet(reference_set_DocReference.compareByKey);
        // A set of outstanding references to a document sorted by target id.
        this.refsByTarget = new sorted_set_SortedSet(reference_set_DocReference.compareByTargetId);
        /** Keeps track of keys that have references */
        this.garbageCollector = null;
    }
    /** Returns true if the reference set contains no references. */
    ReferenceSet.prototype.isEmpty = function () {
        return this.refsByKey.isEmpty();
    };
    /** Adds a reference to the given document key for the given ID. */
    ReferenceSet.prototype.addReference = function (key, id) {
        var ref = new reference_set_DocReference(key, id);
        this.refsByKey = this.refsByKey.add(ref);
        this.refsByTarget = this.refsByTarget.add(ref);
    };
    /** Add references to the given document keys for the given ID. */
    ReferenceSet.prototype.addReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) {
            return _this.addReference(key, id);
        });
    };
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */
    ReferenceSet.prototype.removeReference = function (key, id) {
        this.removeRef(new reference_set_DocReference(key, id));
    };
    ReferenceSet.prototype.removeReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) {
            return _this.removeReference(key, id);
        });
    };
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */
    ReferenceSet.prototype.removeReferencesForId = function (id) {
        var _this = this;
        var emptyKey = document_key_DocumentKey.EMPTY;
        var startRef = new reference_set_DocReference(emptyKey, id);
        var endRef = new reference_set_DocReference(emptyKey, id + 1);
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            _this.removeRef(ref);
        });
    };
    ReferenceSet.prototype.removeAllReferences = function () {
        var _this = this;
        this.refsByKey.forEach(function (ref) {
            return _this.removeRef(ref);
        });
    };
    ReferenceSet.prototype.removeRef = function (ref) {
        this.refsByKey = this.refsByKey.delete(ref);
        this.refsByTarget = this.refsByTarget.delete(ref);
        if (this.garbageCollector !== null) {
            this.garbageCollector.addPotentialGarbageKey(ref.key);
        }
    };
    ReferenceSet.prototype.referencesForId = function (id) {
        var emptyKey = document_key_DocumentKey.EMPTY;
        var startRef = new reference_set_DocReference(emptyKey, id);
        var endRef = new reference_set_DocReference(emptyKey, id + 1);
        var keys = documentKeySet();
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            keys = keys.add(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.setGarbageCollector = function (garbageCollector) {
        this.garbageCollector = garbageCollector;
    };
    ReferenceSet.prototype.containsKey = function (txn, key) {
        var ref = new reference_set_DocReference(key, 0);
        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
        return persistence_promise_PersistencePromise.resolve(firstRef !== null && key.equals(firstRef.key));
    };
    return ReferenceSet;
}();

var reference_set_DocReference = /** @class */function () {
    function DocReference(key, targetOrBatchId) {
        this.key = key;
        this.targetOrBatchId = targetOrBatchId;
    }
    /** Compare by key then by ID */
    DocReference.compareByKey = function (left, right) {
        return document_key_DocumentKey.comparator(left.key, right.key) || primitiveComparator(left.targetOrBatchId, right.targetOrBatchId);
    };
    /** Compare by ID then by key */
    DocReference.compareByTargetId = function (left, right) {
        return primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) || document_key_DocumentKey.comparator(left.key, right.key);
    };
    return DocReference;
}();


//# sourceMappingURL=reference_set.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/target_id_generator.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_BITS = 1;
var GeneratorIds;
(function (GeneratorIds) {
    GeneratorIds[GeneratorIds["LocalStore"] = 0] = "LocalStore";
    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine";
})(GeneratorIds || (GeneratorIds = {}));
/**
 * TargetIdGenerator generates monotonically increasing integer IDs. There are
 * separate generators for different scopes. While these generators will operate
 * independently of each other, they are scoped, such that no two generators
 * will ever produce the same ID. This is useful, because sometimes the backend
 * may group IDs from separate parts of the client into the same ID space.
 */
var TargetIdGenerator = /** @class */function () {
    function TargetIdGenerator(generatorId, initAfter) {
        if (initAfter === void 0) {
            initAfter = 0;
        }
        this.generatorId = generatorId;
        // Replace the generator part of initAfter with this generator's ID.
        var afterWithoutGenerator = initAfter >> RESERVED_BITS << RESERVED_BITS;
        var afterGenerator = initAfter - afterWithoutGenerator;
        if (afterGenerator >= generatorId) {
            // For example, if:
            //   this.generatorId = 0b0000
            //   after = 0b1011
            //   afterGenerator = 0b0001
            // Then:
            //   previous = 0b1010
            //   next = 0b1100
            this.previousId = afterWithoutGenerator | this.generatorId;
        } else {
            // For example, if:
            //   this.generatorId = 0b0001
            //   after = 0b1010
            //   afterGenerator = 0b0000
            // Then:
            //   previous = 0b1001
            //   next = 0b1011
            this.previousId = (afterWithoutGenerator | this.generatorId) - (1 << RESERVED_BITS);
        }
    }
    TargetIdGenerator.prototype.next = function () {
        this.previousId += 1 << RESERVED_BITS;
        return this.previousId;
    };
    TargetIdGenerator.forLocalStore = function (initAfter) {
        if (initAfter === void 0) {
            initAfter = 0;
        }
        return new TargetIdGenerator(GeneratorIds.LocalStore, initAfter);
    };
    TargetIdGenerator.forSyncEngine = function () {
        return new TargetIdGenerator(GeneratorIds.SyncEngine);
    };
    return TargetIdGenerator;
}();


//# sourceMappingURL=target_id_generator.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/view.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var AddedLimboDocument = /** @class */function () {
    function AddedLimboDocument(key) {
        this.key = key;
    }
    return AddedLimboDocument;
}();

var RemovedLimboDocument = /** @class */function () {
    function RemovedLimboDocument(key) {
        this.key = key;
    }
    return RemovedLimboDocument;
}();

/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */
var view_View = /** @class */function () {
    function View(query,
    /** Documents included in the remote target */
    syncedDocuments) {
        this.query = query;
        this.syncedDocuments = syncedDocuments;
        this.syncState = null;
        /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */
        this.current = false;
        /** Documents in the view but not in the remote target */
        this.limboDocuments = documentKeySet();
        /** Document Keys that have local changes */
        this.mutatedKeys = documentKeySet();
        this.documentSet = new document_set_DocumentSet(query.docComparator.bind(query));
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */
    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
        var _this = this;
        var changeSet = previousChanges ? previousChanges.changeSet : new view_snapshot_DocumentChangeSet();
        var oldDocumentSet = previousChanges ? previousChanges.documentSet : this.documentSet;
        var newMutatedKeys = previousChanges ? previousChanges.mutatedKeys : this.mutatedKeys;
        var newDocumentSet = oldDocumentSet;
        var needsRefill = false;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        //
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit ? oldDocumentSet.last() : null;
        docChanges.inorderTraversal(function (key, newMaybeDoc) {
            var oldDoc = oldDocumentSet.get(key);
            var newDoc = newMaybeDoc instanceof document_Document ? newMaybeDoc : null;
            if (newDoc) {
                assert(key.equals(newDoc.key), 'Mismatching keys found in document changes: ' + key + ' != ' + newDoc.key);
                newDoc = _this.query.matches(newDoc) ? newDoc : null;
            }
            if (newDoc) {
                newDocumentSet = newDocumentSet.add(newDoc);
                if (newDoc.hasLocalMutations) {
                    newMutatedKeys = newMutatedKeys.add(key);
                } else {
                    newMutatedKeys = newMutatedKeys.delete(key);
                }
            } else {
                newDocumentSet = newDocumentSet.delete(key);
                newMutatedKeys = newMutatedKeys.delete(key);
            }
            // Calculate change
            if (oldDoc && newDoc) {
                var docsEqual = oldDoc.data.equals(newDoc.data);
                if (!docsEqual || oldDoc.hasLocalMutations !== newDoc.hasLocalMutations) {
                    // only report a change if document actually changed
                    if (docsEqual) {
                        changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
                    } else {
                        changeSet.track({ type: ChangeType.Modified, doc: newDoc });
                    }
                    if (lastDocInLimit && _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
                        // This doc moved from inside the limit to after the limit.
                        // That means there may be some doc in the local cache that's
                        // actually less than this one.
                        needsRefill = true;
                    }
                }
            } else if (!oldDoc && newDoc) {
                changeSet.track({ type: ChangeType.Added, doc: newDoc });
            } else if (oldDoc && !newDoc) {
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
                if (lastDocInLimit) {
                    // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    needsRefill = true;
                }
            }
        });
        if (this.query.hasLimit()) {
            // TODO(klimt): Make DocumentSet size be constant time.
            while (newDocumentSet.size > this.query.limit) {
                var oldDoc = newDocumentSet.last();
                newDocumentSet = newDocumentSet.delete(oldDoc.key);
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
            }
        }
        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
        return {
            documentSet: newDocumentSet,
            changeSet: changeSet,
            needsRefill: needsRefill,
            mutatedKeys: newMutatedKeys
        };
    };
    /**
     * Updates the view with the given ViewDocumentChanges and updates limbo docs
     * and sync state from the given (optional) target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */
    View.prototype.applyChanges = function (docChanges, targetChange) {
        var _this = this;
        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
        var oldDocs = this.documentSet;
        this.documentSet = docChanges.documentSet;
        this.mutatedKeys = docChanges.mutatedKeys;
        // Sort changes based on type and query comparator
        var changes = docChanges.changeSet.getChanges();
        changes.sort(function (c1, c2) {
            return compareChangeType(c1.type, c2.type) || _this.query.docComparator(c1.doc, c2.doc);
        });
        var limboChanges = this.applyTargetChange(targetChange);
        var synced = this.limboDocuments.size === 0 && this.current;
        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
        var syncStateChanged = newSyncState !== this.syncState;
        this.syncState = newSyncState;
        if (changes.length === 0 && !syncStateChanged) {
            // no changes
            return { limboChanges: limboChanges };
        } else {
            return {
                snapshot: {
                    query: this.query,
                    docs: docChanges.documentSet,
                    oldDocs: oldDocs,
                    docChanges: changes,
                    fromCache: newSyncState === SyncState.Local,
                    syncStateChanged: syncStateChanged,
                    hasPendingWrites: !docChanges.mutatedKeys.isEmpty()
                },
                limboChanges: limboChanges
            };
        }
    };
    /**
     * Returns whether the doc for the given key should be in limbo.
     */
    View.prototype.shouldBeInLimbo = function (key) {
        // If the remote end says it's part of this query, it's not in limbo.
        if (this.syncedDocuments.has(key)) {
            return false;
        }
        // The local store doesn't think it's a result, so it shouldn't be in limbo.
        if (!this.documentSet.has(key)) {
            return false;
        }
        // If there are local changes to the doc, they might explain why the server
        // doesn't know that it's part of the query. So don't put it in limbo.
        // TODO(klimt): Ideally, we would only consider changes that might actually
        // affect this specific query.
        if (this.documentSet.get(key).hasLocalMutations) {
            return false;
        }
        // Everything else is in limbo.
        return true;
    };
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */
    View.prototype.applyTargetChange = function (targetChange) {
        var _this = this;
        if (targetChange) {
            var targetMapping = targetChange.mapping;
            if (targetMapping instanceof ResetMapping) {
                this.syncedDocuments = targetMapping.documents;
            } else if (targetMapping instanceof UpdateMapping) {
                this.syncedDocuments = targetMapping.applyToKeySet(this.syncedDocuments);
            }
            switch (targetChange.currentStatusUpdate) {
                case CurrentStatusUpdate.MarkCurrent:
                    this.current = true;
                    break;
                case CurrentStatusUpdate.MarkNotCurrent:
                    this.current = false;
                    break;
                case CurrentStatusUpdate.None:
                    break;
                default:
                    fail('Unknown current status update: ' + targetChange.currentStatusUpdate);
            }
        }
        // Recompute the set of limbo docs.
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var oldLimboDocuments = this.limboDocuments;
        this.limboDocuments = documentKeySet();
        if (this.current) {
            this.documentSet.forEach(function (doc) {
                if (_this.shouldBeInLimbo(doc.key)) {
                    _this.limboDocuments = _this.limboDocuments.add(doc.key);
                }
            });
        }
        // Diff the new limbo docs with the old limbo docs.
        var changes = [];
        oldLimboDocuments.forEach(function (key) {
            if (!_this.limboDocuments.has(key)) {
                changes.push(new RemovedLimboDocument(key));
            }
        });
        this.limboDocuments.forEach(function (key) {
            if (!oldLimboDocuments.has(key)) {
                changes.push(new AddedLimboDocument(key));
            }
        });
        return changes;
    };
    return View;
}();

function compareChangeType(c1, c2) {
    var order = function order(change) {
        switch (change) {
            case ChangeType.Added:
                return 1;
            case ChangeType.Modified:
                return 2;
            case ChangeType.Metadata:
                // A metadata change is converted to a modified change at the public
                // api layer.  Since we sort by document key and then change type,
                // metadata and modified changes must be sorted equivalently.
                return 2;
            case ChangeType.Removed:
                return 0;
            default:
                return fail('Unknown ChangeType: ' + change);
        }
    };
    return order(c1) - order(c2);
}

//# sourceMappingURL=view.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/sync_engine.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


















var sync_engine_LOG_TAG = 'SyncEngine';
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */
var QueryView = /** @class */function () {
    function QueryView(
    /**
     * The query itself.
     */
    query,
    /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */
    targetId,
    /**
     * An identifier from the datastore backend that indicates the last state
     * of the results that was received. This can be used to indicate where
     * to continue receiving new doc changes for the query.
     */
    resumeToken,
    /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */
    view) {
        this.query = query;
        this.targetId = targetId;
        this.resumeToken = resumeToken;
        this.view = view;
    }
    return QueryView;
}();
/**
 * SyncEngine is the central controller in the client SDK architecture. It is
 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
 * SyncEngine's responsibilities include:
 * 1. Coordinating client requests and remote events between the EventManager
 *    and the local and remote data stores.
 * 2. Managing a View object for each query, providing the unified view between
 *    the local and remote data stores.
 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
 *    queue that need sending to the backend.
 *
 * The SyncEngine’s methods should only ever be called by methods running in the
 * global async queue.
 */
var sync_engine_SyncEngine = /** @class */function () {
    function SyncEngine(localStore, remoteStore, currentUser) {
        this.localStore = localStore;
        this.remoteStore = remoteStore;
        this.currentUser = currentUser;
        this.viewHandler = null;
        this.errorHandler = null;
        this.queryViewsByQuery = new obj_map_ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.queryViewsByTarget = {};
        this.limboTargetsByKey = new sorted_map_SortedMap(document_key_DocumentKey.comparator);
        this.limboKeysByTarget = {};
        this.limboDocumentRefs = new reference_set_ReferenceSet();
        this.limboCollector = new eager_garbage_collector_EagerGarbageCollector();
        /** Stores user completion handlers, indexed by User and BatchId. */
        this.mutationUserCallbacks = {};
        this.targetIdGenerator = TargetIdGenerator.forSyncEngine();
    }
    /** Subscribes view and error handler. Can be called only once. */
    SyncEngine.prototype.subscribe = function (viewHandler, errorHandler) {
        assert(viewHandler !== null && errorHandler !== null, 'View and error handlers cannot be null');
        assert(this.viewHandler === null && this.errorHandler === null, 'SyncEngine already has a subscriber.');
        this.viewHandler = viewHandler;
        this.errorHandler = errorHandler;
        this.limboCollector.addGarbageSource(this.limboDocumentRefs);
    };
    /**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the targetId of the query.
     */
    SyncEngine.prototype.listen = function (query) {
        var _this = this;
        this.assertSubscribed('listen()');
        assert(!this.queryViewsByQuery.has(query), 'We already listen to the query: ' + query);
        return this.localStore.allocateQuery(query).then(function (queryData) {
            return _this.localStore.executeQuery(query).then(function (docs) {
                return _this.localStore.remoteDocumentKeys(queryData.targetId).then(function (remoteKeys) {
                    var view = new view_View(query, remoteKeys);
                    var viewDocChanges = view.computeDocChanges(docs);
                    var viewChange = view.applyChanges(viewDocChanges);
                    assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
                    assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
                    var data = new QueryView(query, queryData.targetId, queryData.resumeToken, view);
                    _this.queryViewsByQuery.set(query, data);
                    _this.queryViewsByTarget[queryData.targetId] = data;
                    _this.viewHandler([viewChange.snapshot]);
                    _this.remoteStore.listen(queryData);
                });
            }).then(function () {
                return queryData.targetId;
            });
        });
    };
    /** Stops listening to the query. */
    SyncEngine.prototype.unlisten = function (query) {
        var _this = this;
        this.assertSubscribed('unlisten()');
        var queryView = this.queryViewsByQuery.get(query);
        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
        return this.localStore.releaseQuery(query).then(function () {
            _this.remoteStore.unlisten(queryView.targetId);
            return _this.removeAndCleanupQuery(queryView).then(function () {
                return _this.localStore.collectGarbage();
            });
        });
    };
    /**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */
    SyncEngine.prototype.write = function (batch, userCallback) {
        var _this = this;
        this.assertSubscribed('write()');
        return this.localStore.localWrite(batch).then(function (result) {
            _this.addMutationCallback(result.batchId, userCallback);
            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
        }).then(function () {
            return _this.remoteStore.fillWritePipeline();
        });
    };
    // TODO(klimt): Wrap the given error in a standard Firestore error object.
    SyncEngine.prototype.wrapUpdateFunctionError = function (error) {
        return error;
    };
    /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If some other client has changed any of the data
     * referenced, then the updateFunction will be called again. If the
     * updateFunction still fails after the given number of retries, then the
     * transaction will be rejection.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The promise returned is resolved when the transaction is fully committed.
     */
    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
        var _this = this;
        if (retries === void 0) {
            retries = 5;
        }
        assert(retries >= 0, 'Got negative number of retries for transaction.');
        var transaction = this.remoteStore.createTransaction();
        var wrappedUpdateFunction = function wrappedUpdateFunction() {
            try {
                var userPromise = updateFunction(transaction);
                if (isNullOrUndefined(userPromise) || !userPromise.catch || !userPromise.then) {
                    return Promise.reject(Error('Transaction callback must return a Promise'));
                }
                return userPromise.catch(function (e) {
                    return Promise.reject(_this.wrapUpdateFunctionError(e));
                });
            } catch (e) {
                return Promise.reject(_this.wrapUpdateFunctionError(e));
            }
        };
        return wrappedUpdateFunction().then(function (result) {
            return transaction.commit().then(function () {
                return result;
            }).catch(function (error) {
                if (retries === 0) {
                    return Promise.reject(error);
                }
                // TODO(klimt): Put in a retry delay?
                return _this.runTransaction(updateFunction, retries - 1);
            });
        });
    };
    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        this.assertSubscribed('applyRemoteEvent()');
        // Make sure limbo documents are deleted if there were no results
        forEachNumber(remoteEvent.targetChanges, function (targetId, targetChange) {
            var limboKey = _this.limboKeysByTarget[targetId];
            if (limboKey && targetChange.currentStatusUpdate === CurrentStatusUpdate.MarkCurrent && !remoteEvent.documentUpdates.get(limboKey)) {
                // When listening to a query the server responds with a snapshot
                // containing documents matching the query and a current marker
                // telling us we're now in sync. It's possible for these to arrive
                // as separate remote events or as a single remote event.
                // For a document query, there will be no documents sent in the
                // response if the document doesn't exist.
                //
                // If the snapshot arrives separately from the current marker,
                // we handle it normally and updateTrackedLimbos will resolve the
                // limbo status of the document, removing it from limboDocumentRefs.
                // This works because clients only initiate limbo resolution when
                // a target is current and because all current targets are
                // always at a consistent snapshot.
                //
                // However, if the document doesn't exist and the current marker
                // arrives, the document is not present in the snapshot and our
                // normal view handling would consider the document to remain in
                // limbo indefinitely because there are no updates to the document.
                // To avoid this, we specially handle this just this case here:
                // synthesizing a delete.
                //
                // TODO(dimond): Ideally we would have an explicit lookup query
                // instead resulting in an explicit delete message and we could
                // remove this special logic.
                remoteEvent.addDocumentUpdate(new document_NoDocument(limboKey, remoteEvent.snapshotVersion));
            }
        });
        return this.localStore.applyRemoteEvent(remoteEvent).then(function (changes) {
            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
        });
    };
    SyncEngine.prototype.rejectListen = function (targetId, err) {
        var _this = this;
        this.assertSubscribed('rejectListens()');
        var limboKey = this.limboKeysByTarget[targetId];
        if (limboKey) {
            // Since this query failed, we won't want to manually unlisten to it.
            // So go ahead and remove it from bookkeeping.
            this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
            delete this.limboKeysByTarget[targetId];
            // TODO(klimt): We really only should do the following on permission
            // denied errors, but we don't have the cause code here.
            // It's a limbo doc. Create a synthetic event saying it was deleted.
            // This is kind of a hack. Ideally, we would have a method in the local
            // store to purge a document. However, it would be tricky to keep all of
            // the local store's invariants with another method.
            var docMap = new sorted_map_SortedMap(document_key_DocumentKey.comparator);
            docMap = docMap.insert(limboKey, new document_NoDocument(limboKey, snapshot_version_SnapshotVersion.forDeletedDoc()));
            var event_1 = new remote_event_RemoteEvent(snapshot_version_SnapshotVersion.MIN, {}, docMap);
            return this.applyRemoteEvent(event_1);
        } else {
            var queryView_1 = this.queryViewsByTarget[targetId];
            assert(!!queryView_1, 'Unknown targetId: ' + targetId);
            return this.localStore.releaseQuery(queryView_1.query).then(function () {
                return _this.removeAndCleanupQuery(queryView_1).then(function () {
                    _this.errorHandler(queryView_1.query, err);
                });
            });
        }
    };
    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
        var _this = this;
        this.assertSubscribed('applySuccessfulWrite()');
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        this.processUserCallback(mutationBatchResult.batch.batchId,
        /*error=*/null);
        return this.localStore.acknowledgeBatch(mutationBatchResult).then(function (changes) {
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        });
    };
    SyncEngine.prototype.rejectFailedWrite = function (batchId, error) {
        var _this = this;
        this.assertSubscribed('rejectFailedWrite()');
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        this.processUserCallback(batchId, error);
        return this.localStore.rejectBatch(batchId).then(function (changes) {
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        });
    };
    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        if (!newCallbacks) {
            newCallbacks = new sorted_map_SortedMap(primitiveComparator);
        }
        newCallbacks = newCallbacks.insert(batchId, callback);
        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
    };
    /**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */
    SyncEngine.prototype.processUserCallback = function (batchId, error) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        // NOTE: Mutations restored from persistence won't have callbacks, so it's
        // okay for there to be no callback for this ID.
        if (newCallbacks) {
            var callback = newCallbacks.get(batchId);
            if (callback) {
                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
                if (error) {
                    callback.reject(error);
                } else {
                    callback.resolve();
                }
                newCallbacks = newCallbacks.remove(batchId);
            }
            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
        }
    };
    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
        this.queryViewsByQuery.delete(queryView.query);
        delete this.queryViewsByTarget[queryView.targetId];
        this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
        return this.gcLimboDocuments();
    };
    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
            var limboChange = limboChanges_1[_i];
            if (limboChange instanceof AddedLimboDocument) {
                this.limboDocumentRefs.addReference(limboChange.key, targetId);
                this.trackLimboChange(limboChange);
            } else if (limboChange instanceof RemovedLimboDocument) {
                debug(sync_engine_LOG_TAG, 'Document no longer in limbo: ' + limboChange.key);
                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
            } else {
                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
            }
        }
        return this.gcLimboDocuments();
    };
    SyncEngine.prototype.trackLimboChange = function (limboChange) {
        var key = limboChange.key;
        if (!this.limboTargetsByKey.get(key)) {
            debug(sync_engine_LOG_TAG, 'New document in limbo: ' + key);
            var limboTargetId = this.targetIdGenerator.next();
            var query = query_Query.atPath(key.path);
            this.limboKeysByTarget[limboTargetId] = key;
            this.remoteStore.listen(new query_data_QueryData(query, limboTargetId, QueryPurpose.Listen));
            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
        }
    };
    SyncEngine.prototype.gcLimboDocuments = function () {
        var _this = this;
        // HACK: We can use a null transaction here, because we know that the
        // reference set is entirely within memory and doesn't need a store engine.
        return this.limboCollector.collectGarbage(null).next(function (keys) {
            keys.forEach(function (key) {
                var limboTargetId = _this.limboTargetsByKey.get(key);
                if (limboTargetId === null) {
                    // This target already got removed, because the query failed.
                    return;
                }
                _this.remoteStore.unlisten(limboTargetId);
                _this.limboTargetsByKey = _this.limboTargetsByKey.remove(key);
                delete _this.limboKeysByTarget[limboTargetId];
            });
        }).toPromise();
    };
    // Visible for testing
    SyncEngine.prototype.currentLimboDocs = function () {
        return this.limboTargetsByKey;
    };
    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
        var _this = this;
        var newSnaps = [];
        var docChangesInAllViews = [];
        var queriesProcessed = [];
        this.queryViewsByQuery.forEach(function (_, queryView) {
            queriesProcessed.push(Promise.resolve().then(function () {
                var viewDocChanges = queryView.view.computeDocChanges(changes);
                if (!viewDocChanges.needsRefill) {
                    return viewDocChanges;
                }
                // The query has a limit and some docs were removed, so we need
                // to re-run the query against the local store to make sure we
                // didn't lose any good docs that had been past the limit.
                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
                    return queryView.view.computeDocChanges(docs, viewDocChanges);
                });
            }).then(function (viewDocChanges) {
                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
                var viewChange = queryView.view.applyChanges(viewDocChanges, targetChange);
                return _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges).then(function () {
                    if (viewChange.snapshot) {
                        newSnaps.push(viewChange.snapshot);
                        var docChanges = local_view_changes_LocalViewChanges.fromSnapshot(viewChange.snapshot);
                        docChangesInAllViews.push(docChanges);
                    }
                });
            }));
        });
        return Promise.all(queriesProcessed).then(function () {
            _this.viewHandler(newSnaps);
            return _this.localStore.notifyLocalViewChanges(docChangesInAllViews);
        }).then(function () {
            return _this.localStore.collectGarbage();
        });
    };
    SyncEngine.prototype.assertSubscribed = function (fnName) {
        assert(this.viewHandler !== null && this.errorHandler !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
    };
    SyncEngine.prototype.handleUserChange = function (user) {
        var _this = this;
        this.currentUser = user;
        return this.localStore.handleUserChange(user).then(function (changes) {
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        }).then(function () {
            return _this.remoteStore.handleUserChange(user);
        });
    };
    return SyncEngine;
}();


//# sourceMappingURL=sync_engine.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/model/mutation_batch.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var BATCHID_UNKNOWN = -1;
/**
 * A batch of mutations that will be sent as one unit to the backend.
 */
var mutation_batch_MutationBatch = /** @class */function () {
    function MutationBatch(batchId, localWriteTime, mutations) {
        this.batchId = batchId;
        this.localWriteTime = localWriteTime;
        this.mutations = mutations;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */
    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
        if (maybeDoc) {
            assert(maybeDoc.key.equals(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var mutationResults = batchResult.mutationResults;
        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.equals(docKey)) {
                var mutationResult = mutationResults[i];
                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */
    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
        if (maybeDoc) {
            assert(maybeDoc.key.equals(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.equals(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, this.localWriteTime);
            }
        }
        return maybeDoc;
    };
    MutationBatch.prototype.keys = function () {
        var keySet = documentKeySet();
        for (var _i = 0, _a = this.mutations; _i < _a.length; _i++) {
            var mutation = _a[_i];
            keySet = keySet.add(mutation.key);
        }
        return keySet;
    };
    MutationBatch.prototype.equals = function (other) {
        return this.batchId === other.batchId && arrayEquals(this.mutations, other.mutations);
    };
    /**
     * Returns true if this mutation batch has already been removed from the
     * mutation queue.
     *
     * Note that not all implementations of the MutationQueue necessarily use
     * tombstones as part of their implementation and generally speaking no code
     * outside the mutation queues should really care about this.
     */
    MutationBatch.prototype.isTombstone = function () {
        return this.mutations.length === 0;
    };
    /** Converts this batch into a tombstone */
    MutationBatch.prototype.toTombstone = function () {
        return new MutationBatch(this.batchId, this.localWriteTime, []);
    };
    return MutationBatch;
}();

/** The result of applying a mutation batch to the backend. */
var mutation_batch_MutationBatchResult = /** @class */function () {
    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken,
    /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */
    docVersions) {
        this.batch = batch;
        this.commitVersion = commitVersion;
        this.mutationResults = mutationResults;
        this.streamToken = streamToken;
        this.docVersions = docVersions;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */
    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
        assert(batch.mutations.length === results.length, 'Mutations sent ' + batch.mutations.length + ' must equal results received ' + results.length);
        var versionMap = documentVersionMap();
        var mutations = batch.mutations;
        for (var i = 0; i < mutations.length; i++) {
            var version = results[i].version;
            if (version === null) {
                // deletes don't have a version, so we substitute the commitVersion
                // of the entire batch.
                version = commitVersion;
            }
            versionMap = versionMap.insert(mutations[i].key, version);
        }
        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
    };
    return MutationBatchResult;
}();


//# sourceMappingURL=mutation_batch.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/encoded_resource_path.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var escapeChar = '\x01';
var encodedSeparatorChar = '\x01';
var encodedNul = '\x10';
var encodedEscape = '\x11';
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */
function encode(path) {
    var result = '';
    for (var i = 0; i < path.length; i++) {
        if (result.length > 0) {
            result = encodeSeparator(result);
        }
        result = encodeSegment(path.get(i), result);
    }
    return encodeSeparator(result);
}
/** Encodes a single segment of a resource path into the given result */
function encodeSegment(segment, resultBuf) {
    var result = resultBuf;
    var length = segment.length;
    for (var i = 0; i < length; i++) {
        var c = segment.charAt(i);
        switch (c) {
            case '\0':
                result += escapeChar + encodedNul;
                break;
            case escapeChar:
                result += escapeChar + encodedEscape;
                break;
            default:
                result += c;
        }
    }
    return result;
}
/** Encodes a path separator into the given result */
function encodeSeparator(result) {
    return result + escapeChar + encodedSeparatorChar;
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */
function decode(path) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var length = path.length;
    assert(length >= 2, 'Invalid path ' + path);
    if (length === 2) {
        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
        return path_ResourcePath.EMPTY_PATH;
    }
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var lastReasonableEscapeIndex = length - 2;
    var segments = [];
    var segmentBuilder = '';
    for (var start = 0; start < length;) {
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var end = path.indexOf(escapeChar, start);
        if (end < 0 || end > lastReasonableEscapeIndex) {
            fail('Invalid encoded resource path: "' + path + '"');
        }
        var next = path.charAt(end + 1);
        switch (next) {
            case encodedSeparatorChar:
                var currentPiece = path.substring(start, end);
                var segment = void 0;
                if (segmentBuilder.length === 0) {
                    // Avoid copying for the common case of a segment that excludes \0
                    // and \001
                    segment = currentPiece;
                } else {
                    segmentBuilder += currentPiece;
                    segment = segmentBuilder;
                    segmentBuilder = '';
                }
                segments.push(segment);
                break;
            case encodedNul:
                segmentBuilder += path.substring(start, end);
                segmentBuilder += '\0';
                break;
            case encodedEscape:
                // The escape character can be used in the output to encode itself.
                segmentBuilder += path.substring(start, end + 1);
                break;
            default:
                fail('Invalid encoded resource path: "' + path + '"');
        }
        start = end + 2;
    }
    return new path_ResourcePath(segments);
}
/**
 * Computes the prefix successor of the given path, computed by encode above.
 * A prefix successor is the first key that cannot be prefixed by the given
 * path. It's useful for defining the end of a prefix scan such that all keys
 * in the scan have the same prefix.
 *
 * Note that this is not a general prefix successor implementation, which is
 * tricky to get right with Strings, given that they encode down to UTF-8.
 * Instead this relies on the fact that all paths encoded by this class are
 * always terminated with a separator, and so a successor can always be
 * cheaply computed by incrementing the last character of the path.
 */
function prefixSuccessor(path) {
    var c = path.charCodeAt(path.length - 1);
    // TODO(mcg): this really should be a general thing, but not worth it right
    // now
    assert(c === 1, 'successor may only operate on paths generated by encode');
    return path.substring(0, path.length - 1) + String.fromCharCode(c + 1);
}

//# sourceMappingURL=encoded_resource_path.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/indexeddb_schema.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var SCHEMA_VERSION = 1;
/** Performs database creation and (in the future) upgrades between versions. */
function createOrUpgradeDb(db, oldVersion) {
    assert(oldVersion === 0, 'Unexpected upgrade from version ' + oldVersion);
    db.createObjectStore(DbMutationQueue.store, {
        keyPath: DbMutationQueue.keyPath
    });
    // TODO(mikelehen): Get rid of "as any" if/when TypeScript fixes their
    // types. https://github.com/Microsoft/TypeScript/issues/14322
    db.createObjectStore(
    // tslint:disable-next-line:no-any
    DbMutationBatch.store, { keyPath: DbMutationBatch.keyPath });
    var targetDocumentsStore = db.createObjectStore(
    // tslint:disable-next-line:no-any
    DbTargetDocument.store, { keyPath: DbTargetDocument.keyPath });
    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
    var targetStore = db.createObjectStore(DbTarget.store, {
        keyPath: DbTarget.keyPath
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
    // NOTE: keys for these stores are specified explicitly rather than using a
    // keyPath.
    db.createObjectStore(indexeddb_schema_DbDocumentMutation.store);
    db.createObjectStore(DbRemoteDocument.store);
    db.createObjectStore(DbOwner.store);
    db.createObjectStore(DbTargetGlobal.store);
}
/**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */
var DbTimestamp = /** @class */function () {
    function DbTimestamp(seconds, nanos) {
        this.seconds = seconds;
        this.nanos = nanos;
    }
    return DbTimestamp;
}();

/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can be owned by a single tab at a given time. That tab
 * must validate that it is still the owner before every write operation and
 * should regularly write an updated timestamp to prevent other tabs from
 * "stealing" ownership of the db.
 */
var DbOwner = /** @class */function () {
    function DbOwner(ownerId, leaseTimestampMs) {
        this.ownerId = ownerId;
        this.leaseTimestampMs = leaseTimestampMs;
    }
    /** Name of the IndexedDb object store. */
    DbOwner.store = 'owner';
    return DbOwner;
}();

/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */
var DbMutationQueue = /** @class */function () {
    function DbMutationQueue(
    /**
       * The normalized user ID to which this queue belongs.
       */
    userId,
    /**
       * An identifier for the highest numbered batch that has been acknowledged
       * by the server. All MutationBatches in this queue with batchIds less
       * than or equal to this value are considered to have been acknowledged by
       * the server.
       */
    lastAcknowledgedBatchId,
    /**
       * A stream token that was previously sent by the server.
       *
       * See StreamingWriteRequest in datastore.proto for more details about
       * usage.
       *
       * After sending this token, earlier tokens may not be used anymore so
       * only a single stream token is retained.
       */
    lastStreamToken) {
        this.userId = userId;
        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
        this.lastStreamToken = lastStreamToken;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationQueue.store = 'mutationQueues';
    /** Keys are automatically assigned via the userId property. */
    DbMutationQueue.keyPath = 'userId';
    return DbMutationQueue;
}();

/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */
var DbMutationBatch = /** @class */function () {
    function DbMutationBatch(
    /**
       * The normalized user ID to which this batch belongs.
       */
    userId,
    /**
       * An identifier for this batch, allocated by the mutation queue in a
       * monotonically increasing manner.
       */
    batchId,
    /**
       * The local write time of the batch, stored as milliseconds since the
       * epoch.
       */
    localWriteTimeMs,
    /**
       * A list of mutations to apply. All mutations will be applied atomically.
       *
       * Mutations are serialized via JsonProtoSerializer.toMutation().
       */
    mutations) {
        this.userId = userId;
        this.batchId = batchId;
        this.localWriteTimeMs = localWriteTimeMs;
        this.mutations = mutations;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationBatch.store = 'mutations';
    /** Keys are automatically assigned via the userId, batchId properties. */
    DbMutationBatch.keyPath = ['userId', 'batchId'];
    return DbMutationBatch;
}();

/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */
var indexeddb_schema_DbDocumentMutation = /** @class */function () {
    function DbDocumentMutation() {}
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */
    DbDocumentMutation.prefixForUser = function (userId) {
        return [userId];
    };
    /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */
    DbDocumentMutation.prefixForPath = function (userId, path) {
        return [userId, encode(path)];
    };
    /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */
    DbDocumentMutation.key = function (userId, path, batchId) {
        return [userId, encode(path), batchId];
    };
    DbDocumentMutation.store = 'documentMutations';
    /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */
    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
    return DbDocumentMutation;
}();

/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbNoDocument = /** @class */function () {
    function DbNoDocument(path, readTime) {
        this.path = path;
        this.readTime = readTime;
    }
    return DbNoDocument;
}();

/**
 * An object to be stored in the 'remoteDocuments' store in IndexedDb. It
 * represents either a cached document (if it exists) or a cached "no-document"
 * (if it is known to not exist).
 *
 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
 * be made more general if necessary.
 */
var DbRemoteDocument = /** @class */function () {
    function DbRemoteDocument(
    /**
       * Set to an instance of a DbNoDocument if it is known that no document
       * exists.
       */
    noDocument,
    /**
       * Set to an instance of a Document if there's a cached version of the
       * document.
       */
    document) {
        this.noDocument = noDocument;
        this.document = document;
    }
    DbRemoteDocument.store = 'remoteDocuments';
    return DbRemoteDocument;
}();

/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */
var DbTarget = /** @class */function () {
    function DbTarget(
    /**
       * An auto-generated sequential numeric identifier for the query.
       *
       * Queries are stored using their canonicalId as the key, but these
       * canonicalIds can be quite long so we additionally assign a unique
       * queryId which can be used by referenced data structures (e.g.
       * indexes) to minimize the on-disk cost.
       */
    targetId,
    /**
       * The canonical string representing this query. This is not unique.
       */
    canonicalId,
    /**
       * The last readTime received from the Watch Service for this query.
       *
       * This is the same value as TargetChange.read_time in the protos.
       */
    readTime,
    /**
       * An opaque, server-assigned token that allows watching a query to be
       * resumed after disconnecting without retransmitting all the data
       * that matches the query. The resume token essentially identifies a
       * point in time from which the server should resume sending results.
       *
       * This is related to the snapshotVersion in that the resumeToken
       * effectively also encodes that value, but the resumeToken is opaque
       * and sometimes encodes additional information.
       *
       * A consequence of this is that the resumeToken should be used when
       * asking the server to reason about where this client is in the watch
       * stream, but the client should use the snapshotVersion for its own
       * purposes.
       *
       * This is the same value as TargetChange.resume_token in the protos.
       */
    resumeToken,
    /**
       * A sequence number representing the last time this query was
       * listened to, used for garbage collection purposes.
       *
       * Conventionally this would be a timestamp value, but device-local
       * clocks are unreliable and they must be able to create new listens
       * even while disconnected. Instead this should be a monotonically
       * increasing number that's incremented on each listen call.
       *
       * This is different from the queryId since the queryId is an
       * immutable identifier assigned to the Query on first use while
       * lastListenSequenceNumber is updated every time the query is
       * listened to.
       */
    lastListenSequenceNumber,
    /**
       * The query for this target.
       *
       * Because canonical ids are not unique we must store the actual query. We
       * use the proto to have an object we can persist without having to
       * duplicate translation logic to and from a `Query` object.
       */
    query) {
        this.targetId = targetId;
        this.canonicalId = canonicalId;
        this.readTime = readTime;
        this.resumeToken = resumeToken;
        this.lastListenSequenceNumber = lastListenSequenceNumber;
        this.query = query;
    }
    DbTarget.store = 'targets';
    /** Keys are automatically assigned via the targetId property. */
    DbTarget.keyPath = 'targetId';
    /** The name of the queryTargets index. */
    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
    /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */
    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
    return DbTarget;
}();

/**
 * An object representing an association between a target and a document.
 * Stored in the targetDocument object store to store the documents tracked by a
 * particular target.
 */
var DbTargetDocument = /** @class */function () {
    function DbTargetDocument(
    /**
       * The targetId identifying a target.
       */
    targetId,
    /**
       * The path to the document, as encoded in the key.
       */
    path) {
        this.targetId = targetId;
        this.path = path;
    }
    /** Name of the IndexedDb object store.  */
    DbTargetDocument.store = 'targetDocuments';
    /** Keys are automatically assigned via the targetId, path properties. */
    DbTargetDocument.keyPath = ['targetId', 'path'];
    /** The index name for the reverse index. */
    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
    /** We also need to create the reverse index for these properties. */
    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
    return DbTargetDocument;
}();

/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */
var DbTargetGlobal = /** @class */function () {
    function DbTargetGlobal(
    /**
       * The highest numbered target id across all targets.
       *
       * See DbTarget.targetId.
       */
    highestTargetId,
    /**
       * The highest numbered lastListenSequenceNumber across all targets.
       *
       * See DbTarget.lastListenSequenceNumber.
       */
    highestListenSequenceNumber,
    /**
       * A global snapshot version representing the last consistent snapshot we
       * received from the backend. This is monotonically increasing and any
       * snapshots received from the backend prior to this version (e.g. for
       * targets resumed with a resumeToken) should be suppressed (buffered)
       * until the backend has caught up to this snapshot version again. This
       * prevents our cache from ever going backwards in time.
       */
    lastRemoteSnapshotVersion) {
        this.highestTargetId = highestTargetId;
        this.highestListenSequenceNumber = highestListenSequenceNumber;
        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
    }
    /**
     * The key string used for the single object that exists in the
     * DbTargetGlobal store.
     */
    DbTargetGlobal.key = 'targetGlobalKey';
    DbTargetGlobal.store = 'targetGlobal';
    return DbTargetGlobal;
}();

/**
 * The list of all IndexedDB stored used by the SDK. This is used when creating
 * transactions so that access across all stores is done atomically.
 */
var ALL_STORES = [DbMutationQueue.store, DbMutationBatch.store, indexeddb_schema_DbDocumentMutation.store, DbRemoteDocument.store, DbTarget.store, DbOwner.store, DbTargetGlobal.store, DbTargetDocument.store];

//# sourceMappingURL=indexeddb_schema.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/simple_db.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var simple_db_LOG_TAG = 'SimpleDb';
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */
var simple_db_SimpleDb = /** @class */function () {
    function SimpleDb(db) {
        this.db = db;
    }
    /** Opens the specified database, creating or upgrading it if necessary. */
    SimpleDb.openOrCreate = function (name, version, runUpgrade) {
        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
        debug(simple_db_LOG_TAG, 'Opening database:', name);
        return new persistence_promise_PersistencePromise(function (resolve, reject) {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently.
            var request = window.indexedDB.open(name, version);
            request.onsuccess = function (event) {
                var db = event.target.result;
                resolve(new SimpleDb(db));
            };
            request.onerror = function (event) {
                reject(event.target.error);
            };
            request.onupgradeneeded = function (event) {
                debug(simple_db_LOG_TAG, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
                // TODO(mikelehen): If/when we need to do an actual data
                // migration, we'll want to wrap db in a SimpleDb and have the
                // runUpgrade function return a PersistencePromise, since we'll
                // likely need to do async reads and writes. For now we're
                // cheating and just passing the raw IndexedDB in, since
                // createObjectStore(), etc. are synchronous.
                var db = event.target.result;
                runUpgrade(db, event.oldVersion);
            };
        }).toPromise();
    };
    /** Deletes the specified database. */
    SimpleDb.delete = function (name) {
        debug(simple_db_LOG_TAG, 'Removing database:', name);
        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
    };
    /** Returns true if IndexedDB is available in the current environment. */
    SimpleDb.isAvailable = function () {
        if (typeof window === 'undefined' || window.indexedDB == null) {
            return false;
        }
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        var ua = window.navigator.userAgent;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {
            return false;
        } else {
            return true;
        }
    };
    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
        var transaction = new simple_db_SimpleDbTransaction(this.db, mode, objectStores);
        var transactionFnResult = transactionFn(transaction).catch(function (error) {
            // Abort the transaction if there was an
            // error.
            transaction.abort();
            return persistence_promise_PersistencePromise.reject(error);
        }).toPromise();
        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
        // fire), but still return the original transactionFnResult back to the
        // caller.
        return transaction.completionPromise.then(function () {
            return transactionFnResult;
        });
    };
    SimpleDb.prototype.close = function () {
        this.db.close();
    };
    return SimpleDb;
}();

/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */
var IterationController = /** @class */function () {
    function IterationController(dbCursor) {
        this.dbCursor = dbCursor;
        this.shouldStop = false;
        this.nextKey = null;
    }
    Object.defineProperty(IterationController.prototype, "isDone", {
        get: function get() {
            return this.shouldStop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "skipToKey", {
        get: function get() {
            return this.nextKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "cursor", {
        set: function set(value) {
            this.dbCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This function can be called to stop iteration at any point.
     */
    IterationController.prototype.done = function () {
        this.shouldStop = true;
    };
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */
    IterationController.prototype.skip = function (key) {
        this.nextKey = key;
    };
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */
    IterationController.prototype.delete = function () {
        return wrapRequest(this.dbCursor.delete());
    };
    return IterationController;
}();

/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */
var simple_db_SimpleDbTransaction = /** @class */function () {
    function SimpleDbTransaction(db, mode, objectStoresNames) {
        var _this = this;
        this.aborted = false;
        this.transaction = db.transaction(objectStoresNames, mode);
        this.completionPromise = new Promise(function (resolve, reject) {
            // We consider aborting to be "normal" and just resolve the promise.
            // May need to revisit if/when we actually need to abort transactions.
            _this.transaction.onabort = _this.transaction.oncomplete = function (event) {
                resolve();
            };
            _this.transaction.onerror = function (event) {
                reject(event.target.error);
            };
        });
    }
    SimpleDbTransaction.prototype.abort = function () {
        if (!this.aborted) {
            debug(simple_db_LOG_TAG, 'Aborting transaction.');
            this.aborted = true;
            this.transaction.abort();
        }
    };
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */
    SimpleDbTransaction.prototype.store = function (storeName) {
        var store = this.transaction.objectStore(storeName);
        assert(!!store, 'Object store not part of transaction: ' + storeName);
        return new simple_db_SimpleDbStore(store);
    };
    return SimpleDbTransaction;
}();

/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */
var simple_db_SimpleDbStore = /** @class */function () {
    function SimpleDbStore(store) {
        this.store = store;
    }
    SimpleDbStore.prototype.put = function (keyOrValue, value) {
        var request;
        if (value !== undefined) {
            debug(simple_db_LOG_TAG, 'PUT', this.store.name, keyOrValue, value);
            request = this.store.put(value, keyOrValue);
        } else {
            debug(simple_db_LOG_TAG, 'PUT', this.store.name, '<auto-key>', keyOrValue);
            request = this.store.put(keyOrValue);
        }
        return wrapRequest(request);
    };
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */
    SimpleDbStore.prototype.get = function (key) {
        var _this = this;
        var request = this.store.get(key);
        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
        return wrapRequest(request).next(function (result) {
            // Normalize nonexistence to null.
            if (result === undefined) {
                result = null;
            }
            debug(simple_db_LOG_TAG, 'GET', _this.store.name, key, result);
            return result;
        });
    };
    SimpleDbStore.prototype.delete = function (key) {
        debug(simple_db_LOG_TAG, 'DELETE', this.store.name, key);
        var request = this.store.delete(key);
        return wrapRequest(request);
    };
    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
        var cursor = this.cursor(this.options(indexOrRange, range));
        var results = [];
        return this.iterateCursor(cursor, function (key, value) {
            results.push(value);
        }).next(function () {
            return results;
        });
    };
    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
        debug(simple_db_LOG_TAG, 'DELETE ALL', this.store.name);
        var options = this.options(indexOrRange, range);
        options.keysOnly = false;
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, function (key, value, control) {
            // NOTE: Calling delete() on a cursor is documented as more efficient than
            // calling delete() on an object store with a single key
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
            // however, this requires us *not* to use a keysOnly cursor
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
            // may want to compare the performance of each method.
            return control.delete();
        });
    };
    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
        var options;
        if (!callback) {
            options = {};
            callback = optionsOrCallback;
        } else {
            options = optionsOrCallback;
        }
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, callback);
    };
    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
        var results = [];
        return new persistence_promise_PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                var controller = new IterationController(cursor);
                var userResult = fn(cursor.primaryKey, cursor.value, controller);
                if (userResult instanceof persistence_promise_PersistencePromise) {
                    results.push(userResult);
                }
                if (controller.isDone) {
                    resolve();
                } else if (controller.skipToKey === null) {
                    cursor.continue();
                } else {
                    cursor.continue(controller.skipToKey);
                }
            };
        }).next(function () {
            return persistence_promise_PersistencePromise.waitFor(results);
        });
    };
    SimpleDbStore.prototype.options = function (indexOrRange, range) {
        var indexName = undefined;
        if (indexOrRange !== undefined) {
            if (typeof indexOrRange === 'string') {
                indexName = indexOrRange;
            } else {
                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
                range = indexOrRange;
            }
        }
        return { index: indexName, range: range };
    };
    SimpleDbStore.prototype.cursor = function (options) {
        var direction = 'next';
        if (options.reverse) {
            direction = 'prev';
        }
        if (options.index) {
            var index = this.store.index(options.index);
            if (options.keysOnly) {
                return index.openKeyCursor(options.range, direction);
            } else {
                return index.openCursor(options.range, direction);
            }
        } else {
            return this.store.openCursor(options.range, direction);
        }
    };
    return SimpleDbStore;
}();

/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */
function wrapRequest(request) {
    return new persistence_promise_PersistencePromise(function (resolve, reject) {
        request.onsuccess = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        request.onerror = function (event) {
            reject(event.target.error);
        };
    });
}

//# sourceMappingURL=simple_db.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/indexeddb_mutation_queue.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








/** A mutation queue for a specific user, backed by IndexedDB. */
var indexeddb_mutation_queue_IndexedDbMutationQueue = /** @class */function () {
    function IndexedDbMutationQueue(
    /**
       * The normalized userId (e.g. null UID => "" userId) used to store /
       * retrieve mutations.
       */
    userId, serializer) {
        this.userId = userId;
        this.serializer = serializer;
        this.garbageCollector = null;
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */
    IndexedDbMutationQueue.forUser = function (user, serializer) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        assert(user.uid !== '', 'UserID must not be an empty string.');
        var userId = user.isUnauthenticated() ? '' : user.uid;
        return new IndexedDbMutationQueue(userId, serializer);
    };
    IndexedDbMutationQueue.prototype.start = function (transaction) {
        var _this = this;
        return IndexedDbMutationQueue.loadNextBatchIdFromDb(transaction).next(function (nextBatchId) {
            _this.nextBatchId = nextBatchId;
            return mutationQueuesStore(transaction).get(_this.userId);
        }).next(function (metadata) {
            if (!metadata) {
                metadata = new DbMutationQueue(_this.userId, BATCHID_UNKNOWN,
                /*lastStreamToken=*/'');
            }
            _this.metadata = metadata;
            // On restart, nextBatchId may end up lower than
            // lastAcknowledgedBatchId since it's computed from the queue
            // contents, and there may be no mutations in the queue. In this
            // case, we need to reset lastAcknowledgedBatchId (which is safe
            // since the queue must be empty).
            if (_this.metadata.lastAcknowledgedBatchId >= _this.nextBatchId) {
                return _this.checkEmpty(transaction).next(function (empty) {
                    assert(empty, 'Reset nextBatchID is only possible when the queue is empty');
                    _this.metadata.lastAcknowledgedBatchId = BATCHID_UNKNOWN;
                    return mutationQueuesStore(transaction).put(_this.metadata);
                });
            } else {
                return persistence_promise_PersistencePromise.resolve();
            }
        });
    };
    /**
     * Returns one larger than the largest batch ID that has been stored. If there
     * are no mutations returns 0. Note that batch IDs are global.
     */
    IndexedDbMutationQueue.loadNextBatchIdFromDb = function (txn) {
        var maxBatchId = BATCHID_UNKNOWN;
        return mutationsStore(txn).iterate({ reverse: true }, function (key, batch, control) {
            var userId = key[0],
                batchId = key[1];
            if (batchId > maxBatchId) {
                maxBatchId = batch.batchId;
            }
            if (userId === '') {
                // We can't compute a predecessor for the empty string, since it
                // is lexographically first. That also means that no other
                // userIds can come before this one, so we can just exit early.
                control.done();
            } else {
                var nextUser = immediatePredecessor(userId);
                control.skip([nextUser]);
            }
        }).next(function () {
            return maxBatchId + 1;
        });
    };
    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
        var empty = true;
        var range = IDBKeyRange.bound(this.keyForBatchId(Number.NEGATIVE_INFINITY), this.keyForBatchId(Number.POSITIVE_INFINITY));
        return mutationsStore(transaction).iterate({ range: range }, function (key, value, control) {
            empty = false;
            control.done();
        }).next(function () {
            return empty;
        });
    };
    IndexedDbMutationQueue.prototype.getNextBatchId = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.nextBatchId);
    };
    IndexedDbMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.metadata.lastAcknowledgedBatchId);
    };
    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        var batchId = batch.batchId;
        assert(batchId > this.metadata.lastAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
        this.metadata.lastAcknowledgedBatchId = batchId;
        this.metadata.lastStreamToken = validateStreamToken(streamToken);
        return mutationQueuesStore(transaction).put(this.metadata);
    };
    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.metadata.lastStreamToken);
    };
    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        this.metadata.lastStreamToken = validateStreamToken(streamToken);
        return mutationQueuesStore(transaction).put(this.metadata);
    };
    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
        var _this = this;
        var batchId = this.nextBatchId;
        this.nextBatchId++;
        var batch = new mutation_batch_MutationBatch(batchId, localWriteTime, mutations);
        var dbBatch = this.serializer.toDbMutationBatch(this.userId, batch);
        return mutationsStore(transaction).put(dbBatch).next(function () {
            var promises = [];
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                var encodedPath = encode(mutation.key.path);
                var indexKey = indexeddb_schema_DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
                documentMutationsStore(transaction).put(indexKey, indexeddb_schema_DbDocumentMutation.PLACEHOLDER);
            }
            return persistence_promise_PersistencePromise.waitFor(promises);
        }).next(function () {
            return batch;
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        var _this = this;
        return mutationsStore(transaction).get(this.keyForBatchId(batchId)).next(function (dbBatch) {
            return dbBatch ? _this.serializer.fromDbMutationBatch(dbBatch) : null;
        });
    };
    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var _this = this;
        var range = IDBKeyRange.lowerBound(this.keyForBatchId(batchId + 1));
        var foundBatch = null;
        return mutationsStore(transaction).iterate({ range: range }, function (key, dbBatch, control) {
            if (dbBatch.userId === _this.userId) {
                assert(dbBatch.batchId > batchId, 'Should have found mutation after ' + batchId);
                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
            }
            control.done();
        }).next(function () {
            return foundBatch;
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        var _this = this;
        var range = IDBKeyRange.bound(this.keyForBatchId(BATCHID_UNKNOWN), this.keyForBatchId(Number.POSITIVE_INFINITY));
        return mutationsStore(transaction).loadAll(range).next(function (dbBatches) {
            return dbBatches.map(function (dbBatch) {
                return _this.serializer.fromDbMutationBatch(dbBatch);
            });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
        var _this = this;
        var range = IDBKeyRange.bound(this.keyForBatchId(BATCHID_UNKNOWN), this.keyForBatchId(batchId));
        return mutationsStore(transaction).loadAll(range).next(function (dbBatches) {
            return dbBatches.map(function (dbBatch) {
                return _this.serializer.fromDbMutationBatch(dbBatch);
            });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        var indexPrefix = indexeddb_schema_DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        var results = [];
        return documentMutationsStore(transaction).iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0],
                encodedPath = indexKey[1],
                batchID = indexKey[2];
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            var path = decode(encodedPath);
            if (userID !== _this.userId || !documentKey.path.equals(path)) {
                control.done();
                return;
            }
            var mutationKey = _this.keyForBatchId(batchID);
            // Look up the mutation batch in the store.
            // PORTING NOTE: because iteration is callback driven in the web,
            // we just look up the key instead of keeping an open iterator
            // like iOS.
            return mutationsStore(transaction).get(mutationKey).next(function (dbBatch) {
                if (dbBatch === null) {
                    fail('Dangling document-mutation reference found: ' + indexKey + ' which points to ' + mutationKey);
                }
                results.push(_this.serializer.fromDbMutationBatch(dbBatch));
            });
        }).next(function () {
            return results;
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        var _this = this;
        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
        var queryPath = query.path;
        var immediateChildrenLength = queryPath.length + 1;
        // TODO(mcg): Actually implement a single-collection query
        //
        // This is actually executing an ancestor query, traversing the whole
        // subtree below the collection which can be horrifically inefficient for
        // some structures. The right way to solve this is to implement the full
        // value index, but that's not in the cards in the near future so this is
        // the best we can do for the moment.
        //
        // Since we don't yet index the actual properties in the mutations, our
        // current approach is to just return all mutation batches that affect
        // documents in the collection being queried.
        var indexPrefix = indexeddb_schema_DbDocumentMutation.prefixForPath(this.userId, queryPath);
        var encodedQueryPath = indexPrefix[1];
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        var uniqueBatchIDs = new sorted_set_SortedSet(primitiveComparator);
        return documentMutationsStore(transaction).iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0],
                encodedPath = indexKey[1],
                batchID = indexKey[2];
            var path = decode(encodedPath);
            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
                control.done();
                return;
            }
            // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            if (path.length !== immediateChildrenLength) {
                return;
            }
            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
        }).next(function () {
            var results = [];
            var promises = [];
            // TODO(rockwood): Implement this using iterate.
            uniqueBatchIDs.forEach(function (batchID) {
                var mutationKey = _this.keyForBatchId(batchID);
                promises.push(mutationsStore(transaction).get(mutationKey).next(function (mutation) {
                    if (mutation === null) {
                        fail('Dangling document-mutation reference found, ' + 'which points to ' + mutationKey);
                    }
                    results.push(_this.serializer.fromDbMutationBatch(mutation));
                }));
            });
            return persistence_promise_PersistencePromise.waitFor(promises).next(function () {
                return results;
            });
        });
    };
    IndexedDbMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
        var txn = mutationsStore(transaction);
        var indexTxn = documentMutationsStore(transaction);
        var promises = [];
        var _loop_1 = function _loop_1(batch) {
            var range = IDBKeyRange.only(this_1.keyForBatchId(batch.batchId));
            var numDeleted = 0;
            var removePromise = txn.iterate({ range: range }, function (key, value, control) {
                numDeleted++;
                return control.delete();
            });
            promises.push(removePromise.next(function () {
                assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' + batch.batchId);
            }));
            for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
                var mutation = _a[_i];
                var indexKey = indexeddb_schema_DbDocumentMutation.key(this_1.userId, mutation.key.path, batch.batchId);
                promises.push(indexTxn.delete(indexKey));
                if (this_1.garbageCollector !== null) {
                    this_1.garbageCollector.addPotentialGarbageKey(mutation.key);
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
            var batch = batches_1[_i];
            _loop_1(batch);
        }
        return persistence_promise_PersistencePromise.waitFor(promises);
    };
    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
        var _this = this;
        return this.checkEmpty(txn).next(function (empty) {
            if (!empty) {
                return persistence_promise_PersistencePromise.resolve();
            }
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var startRange = IDBKeyRange.lowerBound(indexeddb_schema_DbDocumentMutation.prefixForUser(_this.userId));
            var danglingMutationReferences = [];
            return documentMutationsStore(txn).iterate({ range: startRange }, function (key, _, control) {
                var userID = key[0];
                if (userID !== _this.userId) {
                    control.done();
                    return;
                } else {
                    var path = decode(key[1]);
                    danglingMutationReferences.push(path);
                }
            }).next(function () {
                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. Dangling keys: ' + danglingMutationReferences.map(function (p) {
                    return p.canonicalString();
                }));
            });
        });
    };
    IndexedDbMutationQueue.prototype.setGarbageCollector = function (gc) {
        this.garbageCollector = gc;
    };
    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
        var _this = this;
        var indexKey = indexeddb_schema_DbDocumentMutation.prefixForPath(this.userId, key.path);
        var encodedPath = indexKey[1];
        var startRange = IDBKeyRange.lowerBound(indexKey);
        var containsKey = false;
        return documentMutationsStore(txn).iterate({ range: startRange, keysOnly: true }, function (key, _, control) {
            var userID = key[0],
                keyPath = key[1],
                batchID = key[2];
            if (userID === _this.userId && keyPath === encodedPath) {
                containsKey = true;
            }
            control.done();
        }).next(function () {
            return containsKey;
        });
    };
    /**
     * Creates a [userId, batchId] key for use with the DbMutationQueue object
     * store.
     */
    IndexedDbMutationQueue.prototype.keyForBatchId = function (batchId) {
        return [this.userId, batchId];
    };
    return IndexedDbMutationQueue;
}();

function validateStreamToken(token) {
    assert(typeof token === 'string', 'Persisting non-string stream token not supported.');
    return token;
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */
function mutationsStore(txn) {
    return getStore(txn, DbMutationBatch.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function documentMutationsStore(txn) {
    return getStore(txn, indexeddb_schema_DbDocumentMutation.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function mutationQueuesStore(txn) {
    return getStore(txn, DbMutationQueue.store);
}
/**
 * Helper to get a typed SimpleDbStore from a transaction.
 */
function getStore(txn, store) {
    if (txn instanceof simple_db_SimpleDbTransaction) {
        return txn.store(store);
    } else {
        return fail('Invalid transaction object provided!');
    }
}

//# sourceMappingURL=indexeddb_mutation_queue.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/indexeddb_query_cache.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var indexeddb_query_cache_IndexedDbQueryCache = /** @class */function () {
    function IndexedDbQueryCache(serializer) {
        this.serializer = serializer;
        /**
         * The last received snapshot version. We store this seperately from the
         * metadata to avoid the extra conversion to/from DbTimestamp.
         */
        this.lastRemoteSnapshotVersion = snapshot_version_SnapshotVersion.MIN;
        /**
         * A cached copy of the metadata for the query cache.
         */
        this.metadata = new DbTargetGlobal(
        /*highestTargetId=*/0,
        /*lastListenSequenceNumber=*/0, snapshot_version_SnapshotVersion.MIN.toTimestamp());
        /** The garbage collector to notify about potential garbage keys. */
        this.garbageCollector = null;
    }
    IndexedDbQueryCache.prototype.start = function (transaction) {
        var _this = this;
        return globalTargetStore(transaction).get(DbTargetGlobal.key).next(function (metadata) {
            if (metadata !== null) {
                _this.metadata = metadata;
                var lastSavedVersion = metadata.lastRemoteSnapshotVersion;
                _this.lastRemoteSnapshotVersion = snapshot_version_SnapshotVersion.fromTimestamp(new timestamp_Timestamp(lastSavedVersion.seconds, lastSavedVersion.nanos));
            }
            return persistence_promise_PersistencePromise.resolve();
        });
    };
    IndexedDbQueryCache.prototype.getHighestTargetId = function () {
        return this.metadata.highestTargetId;
    };
    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
        return this.lastRemoteSnapshotVersion;
    };
    IndexedDbQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
        this.lastRemoteSnapshotVersion = snapshotVersion;
        this.metadata.lastRemoteSnapshotVersion = snapshotVersion.toTimestamp();
        return globalTargetStore(transaction).put(DbTargetGlobal.key, this.metadata);
    };
    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
        var _this = this;
        var targetId = queryData.targetId;
        var addedQueryPromise = targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
        if (targetId > this.metadata.highestTargetId) {
            this.metadata.highestTargetId = targetId;
            return addedQueryPromise.next(function () {
                return globalTargetStore(transaction).put(DbTargetGlobal.key, _this.metadata);
            });
        } else {
            return addedQueryPromise;
        }
    };
    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId).next(function () {
            targetsStore(transaction).delete(queryData.targetId);
        });
    };
    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
        var _this = this;
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficent.
        var canonicalId = query.canonicalId();
        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
        var result = null;
        return targetsStore(transaction).iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
            var found = _this.serializer.fromDbTarget(value);
            // After finding a potential match, check that the query is
            // actually equal to the requested query.
            if (query.equals(found.query)) {
                result = found;
                control.done();
            }
        }).next(function () {
            return result;
        });
    };
    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // Indexeddb.
        var promises = [];
        var store = documentTargetStore(txn);
        keys.forEach(function (key) {
            var path = encode(key.path);
            promises.push(store.put(new DbTargetDocument(targetId, path)));
        });
        return persistence_promise_PersistencePromise.waitFor(promises);
    };
    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var promises = [];
        var store = documentTargetStore(txn);
        keys.forEach(function (key) {
            var path = encode(key.path);
            promises.push(store.delete([targetId, path]));
            if (_this.garbageCollector !== null) {
                _this.garbageCollector.addPotentialGarbageKey(key);
            }
        });
        return persistence_promise_PersistencePromise.waitFor(promises);
    };
    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        var store = documentTargetStore(txn);
        var range = IDBKeyRange.bound([targetId], [targetId + 1],
        /*lowerOpen=*/false,
        /*upperOpen=*/true);
        return this.notifyGCForRemovedKeys(txn, range).next(function () {
            return store.delete(range);
        });
    };
    IndexedDbQueryCache.prototype.notifyGCForRemovedKeys = function (txn, range) {
        var _this = this;
        var store = documentTargetStore(txn);
        if (this.garbageCollector !== null && this.garbageCollector.isEager) {
            // In order to generate garbage events properly, we need to read these
            // keys before deleting.
            return store.iterate({ range: range, keysOnly: true }, function (key, _, control) {
                var path = decode(key[1]);
                var docKey = new document_key_DocumentKey(path);
                // Paranoid assertion in case the the collector is set to null
                // during the iteration.
                assert(_this.garbageCollector !== null, 'GarbageCollector for query cache set to null during key removal.');
                _this.garbageCollector.addPotentialGarbageKey(docKey);
            });
        } else {
            return persistence_promise_PersistencePromise.resolve();
        }
    };
    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var promises = [];
        var range = IDBKeyRange.bound([targetId], [targetId + 1],
        /*lowerOpen=*/false,
        /*upperOpen=*/true);
        var store = documentTargetStore(txn);
        var result = documentKeySet();
        return store.iterate({ range: range, keysOnly: true }, function (key, _, control) {
            var path = decode(key[1]);
            var docKey = new document_key_DocumentKey(path);
            result = result.add(docKey);
        }).next(function () {
            return result;
        });
    };
    IndexedDbQueryCache.prototype.setGarbageCollector = function (gc) {
        this.garbageCollector = gc;
    };
    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
        assert(txn !== null, 'Persistence Transaction cannot be null for query cache containsKey');
        var path = encode(key.path);
        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)],
        /*lowerOpen=*/false,
        /*upperOpen=*/true);
        var count = 0;
        return documentTargetStore(txn).iterate({
            index: DbTargetDocument.documentTargetsIndex,
            keysOnly: true,
            range: range
        }, function (key, _, control) {
            count++;
            control.done();
        }).next(function () {
            return count > 0;
        });
    };
    return IndexedDbQueryCache;
}();

/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */
function targetsStore(txn) {
    return indexeddb_query_cache_getStore(txn, DbTarget.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */
function globalTargetStore(txn) {
    return indexeddb_query_cache_getStore(txn, DbTargetGlobal.store);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */
function documentTargetStore(txn) {
    return indexeddb_query_cache_getStore(txn, DbTargetDocument.store);
}
/**
 * Helper to get a typed SimpleDbStore from a transaction.
 */
function indexeddb_query_cache_getStore(txn, store) {
    if (txn instanceof simple_db_SimpleDbTransaction) {
        return txn.store(store);
    } else {
        return fail('Invalid transaction object provided!');
    }
}

//# sourceMappingURL=indexeddb_query_cache.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/indexeddb_remote_document_cache.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var indexeddb_remote_document_cache_IndexedDbRemoteDocumentCache = /** @class */function () {
    function IndexedDbRemoteDocumentCache(serializer) {
        this.serializer = serializer;
    }
    IndexedDbRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
        return remoteDocumentsStore(transaction).put(dbKey(maybeDocument.key), this.serializer.toDbRemoteDocument(maybeDocument));
    };
    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        return remoteDocumentsStore(transaction).delete(dbKey(documentKey));
    };
    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction).get(dbKey(documentKey)).next(function (dbRemoteDoc) {
            return dbRemoteDoc ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc) : null;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var _this = this;
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var startKey = query.path.toArray();
        var range = IDBKeyRange.lowerBound(startKey);
        return remoteDocumentsStore(transaction).iterate({ range: range }, function (key, dbRemoteDoc, control) {
            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
                control.done();
            } else if (maybeDoc instanceof document_Document && query.matches(maybeDoc)) {
                results = results.insert(maybeDoc.key, maybeDoc);
            }
        }).next(function () {
            return results;
        });
    };
    return IndexedDbRemoteDocumentCache;
}();

/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */
function remoteDocumentsStore(txn) {
    if (txn instanceof simple_db_SimpleDbTransaction) {
        return txn.store(DbRemoteDocument.store);
    } else {
        return fail('Invalid transaction object provided!');
    }
}
function dbKey(docKey) {
    return docKey.path.toArray();
}

//# sourceMappingURL=indexeddb_remote_document_cache.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/local_serializer.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








/** Serializer for values stored in the LocalStore. */
var local_serializer_LocalSerializer = /** @class */function () {
    function LocalSerializer(remoteSerializer) {
        this.remoteSerializer = remoteSerializer;
    }
    /** Decodes a remote document from storage locally to a Document. */
    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
        if (remoteDoc.document) {
            return this.remoteSerializer.fromDocument(remoteDoc.document);
        } else if (remoteDoc.noDocument) {
            var key = document_key_DocumentKey.fromSegments(remoteDoc.noDocument.path);
            var readTime = remoteDoc.noDocument.readTime;
            var timestamp = new timestamp_Timestamp(readTime.seconds, readTime.nanos);
            return new document_NoDocument(key, snapshot_version_SnapshotVersion.fromTimestamp(timestamp));
        } else {
            return fail('Unexpected DbRemoteDocument');
        }
    };
    /** Encodes a document for storage locally. */
    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
        if (maybeDoc instanceof document_Document) {
            var doc = this.remoteSerializer.toDocument(maybeDoc);
            return new DbRemoteDocument(null, doc);
        } else {
            var path = maybeDoc.key.path.toArray();
            var timestamp = maybeDoc.version.toTimestamp();
            var readTime = new DbTimestamp(timestamp.seconds, timestamp.nanos);
            return new DbRemoteDocument(new DbNoDocument(path, readTime), null);
        }
    };
    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
        var _this = this;
        var serializedMutations = batch.mutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toEpochMilliseconds(), serializedMutations);
    };
    /** Decodes a DbMutationBatch into a MutationBatch */
    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
        var _this = this;
        var mutations = dbBatch.mutations.map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var timestamp = timestamp_Timestamp.fromEpochMilliseconds(dbBatch.localWriteTimeMs);
        return new mutation_batch_MutationBatch(dbBatch.batchId, timestamp, mutations);
    };
    /** Decodes a DbTarget into QueryData */
    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
        var readTime = new timestamp_Timestamp(dbTarget.readTime.seconds, dbTarget.readTime.nanos);
        var version = snapshot_version_SnapshotVersion.fromTimestamp(readTime);
        var query;
        if (isDocumentQuery(dbTarget.query)) {
            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
        } else {
            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
        }
        return new query_data_QueryData(query, dbTarget.targetId, QueryPurpose.Listen, version, dbTarget.resumeToken);
    };
    /** Encodes QueryData into a DbTarget for storage locally. */
    LocalSerializer.prototype.toDbTarget = function (queryData) {
        assert(QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' + QueryPurpose.Listen + ' may be stored, got ' + queryData.purpose);
        var timestamp = queryData.snapshotVersion.toTimestamp();
        var dbTimestamp = new DbTimestamp(timestamp.seconds, timestamp.nanos);
        var queryProto;
        if (queryData.query.isDocumentQuery()) {
            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
        } else {
            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
        }
        assert(typeof queryData.resumeToken === 'string', 'Persisting non-string resume token not supported.');
        var resumeToken = queryData.resumeToken;
        // lastListenSequenceNumber is always 0 until we do real GC.
        return new DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, 0, queryProto);
    };
    return LocalSerializer;
}();

/**
 * A helper function for figuring out what kind of query has been stored.
 */
function isDocumentQuery(dbQuery) {
    return dbQuery.documents !== undefined;
}

//# sourceMappingURL=local_serializer.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/indexeddb_persistence.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












var indexeddb_persistence_LOG_TAG = 'IndexedDbPersistence';
/** If the owner lease is older than 5 seconds, try to take ownership. */
var OWNER_LEASE_MAX_AGE_MS = 5000;
/** Refresh the owner lease every 4 seconds while owner. */
var OWNER_LEASE_REFRESH_INTERVAL_MS = 4000;
/** LocalStorage location to indicate a zombied ownerId (see class comment). */
var ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX = 'zombiedOwnerId';
/** Error when the owner lease cannot be acquired or is lost. */
var EXISTING_OWNER_ERROR_MSG = 'There is another tab open with offline' + ' persistence enabled. Only one such tab is allowed at a time. The' + ' other tab must be closed or persistence must be disabled.';
var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' + ' IndexedDB or is known to have an incomplete implementation. Offline' + ' persistence has been disabled.';
/**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * Currently the Firestore SDK only supports a single consumer of the database,
 * but browsers obviously support multiple tabs. IndexedDbPersistence ensures a
 * single consumer of the database via an "owner lease" stored in the database.
 *
 * On startup, IndexedDbPersistence assigns itself a random "ownerId" and writes
 * it to a special "owner" object in the database (if no entry exists already or
 * the current entry is expired). This owner lease is then verified inside every
 * transaction to ensure the lease has not been lost.
 *
 * If a tab opts not to acquire the owner lease (because there's an existing
 * non-expired owner) or loses the owner lease, IndexedDbPersistence enters a
 * failed state and all subsequent operations will automatically fail.
 *
 * The current owner regularly refreshes the owner lease with new timestamps to
 * prevent newly-opened tabs from taking over ownership.
 *
 * Additionally there is an optimization so that when a tab is closed, the owner
 * lease is released immediately (this is especially important to make sure that
 * a refreshed tab is able to immediately re-acquire the owner lease).
 * Unfortunately, IndexedDB cannot be reliably used in window.unload since it is
 * an asynchronous API. So in addition to attempting to give up the lease,
 * the owner writes its ownerId to a "zombiedOwnerId" entry in LocalStorage
 * which acts as an indicator that another tab should go ahead and take the
 * owner lease immediately regardless of the current lease timestamp.
 */
var indexeddb_persistence_IndexedDbPersistence = /** @class */function () {
    function IndexedDbPersistence(prefix, serializer) {
        this.ownerId = this.generateOwnerId();
        this.dbName = prefix + IndexedDbPersistence.MAIN_DATABASE;
        this.serializer = new local_serializer_LocalSerializer(serializer);
        this.localStoragePrefix = prefix;
    }
    IndexedDbPersistence.prototype.start = function () {
        var _this = this;
        if (!IndexedDbPersistence.isAvailable()) {
            this.persistenceError = new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
            return Promise.reject(this.persistenceError);
        }
        assert(!this.started, 'IndexedDbPersistence double-started!');
        this.started = true;
        return simple_db_SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, createOrUpgradeDb).then(function (db) {
            _this.simpleDb = db;
        }).then(function () {
            return _this.tryAcquireOwnerLease();
        }).then(function () {
            _this.scheduleOwnerLeaseRefreshes();
            _this.attachWindowUnloadHook();
        });
    };
    IndexedDbPersistence.prototype.shutdown = function () {
        var _this = this;
        assert(this.started, 'IndexedDbPersistence shutdown without start!');
        this.started = false;
        this.detachWindowUnloadHook();
        this.stopOwnerLeaseRefreshes();
        return this.releaseOwnerLease().then(function () {
            _this.simpleDb.close();
        });
    };
    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
        return indexeddb_mutation_queue_IndexedDbMutationQueue.forUser(user, this.serializer);
    };
    IndexedDbPersistence.prototype.getQueryCache = function () {
        return new indexeddb_query_cache_IndexedDbQueryCache(this.serializer);
    };
    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
        return new indexeddb_remote_document_cache_IndexedDbRemoteDocumentCache(this.serializer);
    };
    IndexedDbPersistence.prototype.runTransaction = function (action, operation) {
        var _this = this;
        if (this.persistenceError) {
            return Promise.reject(this.persistenceError);
        }
        debug(indexeddb_persistence_LOG_TAG, 'Starting transaction:', action);
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.simpleDb.runTransaction('readwrite', ALL_STORES, function (txn) {
            // Verify that we still have the owner lease as part of every transaction.
            return _this.ensureOwnerLease(txn).next(function () {
                return operation(txn);
            });
        });
    };
    IndexedDbPersistence.isAvailable = function () {
        return simple_db_SimpleDb.isAvailable();
    };
    /**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */
    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
        // Use two different prefix formats:
        //
        //   * firestore / persistenceKey / projectID . databaseID / ...
        //   * firestore / persistenceKey / projectID / ...
        //
        // projectIDs are DNS-compatible names and cannot contain dots
        // so there's no danger of collisions.
        var database = databaseInfo.databaseId.projectId;
        if (!databaseInfo.databaseId.isDefaultDatabase) {
            database += '.' + databaseInfo.databaseId.database;
        }
        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
    };
    /**
     * Acquires the owner lease if there's no valid owner. Else returns a rejected
     * promise.
     */
    IndexedDbPersistence.prototype.tryAcquireOwnerLease = function () {
        var _this = this;
        // NOTE: Don't use this.runTransaction, since it requires us to already
        // have the lease.
        return this.simpleDb.runTransaction('readwrite', [DbOwner.store], function (txn) {
            var store = txn.store(DbOwner.store);
            return store.get('owner').next(function (dbOwner) {
                if (!_this.validOwner(dbOwner)) {
                    var newDbOwner = new DbOwner(_this.ownerId, Date.now());
                    debug(indexeddb_persistence_LOG_TAG, 'No valid owner. Acquiring owner lease. Current owner:', dbOwner, 'New owner:', newDbOwner);
                    return store.put('owner', newDbOwner);
                } else {
                    debug(indexeddb_persistence_LOG_TAG, 'Valid owner already. Failing. Current owner:', dbOwner);
                    _this.persistenceError = new FirestoreError(Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
                    return persistence_promise_PersistencePromise.reject(_this.persistenceError);
                }
            });
        });
    };
    /** Checks the owner lease and deletes it if we are the current owner. */
    IndexedDbPersistence.prototype.releaseOwnerLease = function () {
        var _this = this;
        // NOTE: Don't use this.runTransaction, since it requires us to already
        // have the lease.
        return this.simpleDb.runTransaction('readwrite', [DbOwner.store], function (txn) {
            var store = txn.store(DbOwner.store);
            return store.get('owner').next(function (dbOwner) {
                if (dbOwner !== null && dbOwner.ownerId === _this.ownerId) {
                    debug(indexeddb_persistence_LOG_TAG, 'Releasing owner lease.');
                    return store.delete('owner');
                } else {
                    return persistence_promise_PersistencePromise.resolve();
                }
            });
        });
    };
    /**
     * Checks the owner lease and returns a rejected promise if we are not the
     * current owner. This should be included in every transaction to guard
     * against losing the owner lease.
     */
    IndexedDbPersistence.prototype.ensureOwnerLease = function (txn) {
        var _this = this;
        var store = txn.store(DbOwner.store);
        return store.get('owner').next(function (dbOwner) {
            if (dbOwner === null || dbOwner.ownerId !== _this.ownerId) {
                _this.persistenceError = new FirestoreError(Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
                return persistence_promise_PersistencePromise.reject(_this.persistenceError);
            } else {
                return persistence_promise_PersistencePromise.resolve();
            }
        });
    };
    /**
     * Returns true if the provided owner exists, has a recent timestamp, and
     * isn't zombied.
     *
     * NOTE: To determine if the owner is zombied, this method reads from
     * LocalStorage which could be mildly expensive.
     */
    IndexedDbPersistence.prototype.validOwner = function (dbOwner) {
        var now = Date.now();
        var minAcceptable = now - OWNER_LEASE_MAX_AGE_MS;
        var maxAcceptable = now;
        if (dbOwner === null) {
            return false; // no owner.
        } else if (dbOwner.leaseTimestampMs < minAcceptable) {
            return false; // owner lease has expired.
        } else if (dbOwner.leaseTimestampMs > maxAcceptable) {
            log_error('Persistence owner-lease is in the future. Discarding.', dbOwner);
            return false;
        } else if (dbOwner.ownerId === this.getZombiedOwnerId()) {
            return false; // owner's tab closed.
        } else {
            return true;
        }
    };
    /**
     * Schedules a recurring timer to update the owner lease timestamp to prevent
     * other tabs from taking the lease.
     */
    IndexedDbPersistence.prototype.scheduleOwnerLeaseRefreshes = function () {
        var _this = this;
        // NOTE: This doesn't need to be scheduled on the async queue and doing so
        // would increase the chances of us not refreshing on time if the queue is
        // backed up for some reason.
        this.ownerLeaseRefreshHandle = setInterval(function () {
            var txResult = _this.runTransaction('Refresh owner timestamp', function (txn) {
                // NOTE: We don't need to validate the current owner contents, since
                // runTransaction does that automatically.
                var store = txn.store(DbOwner.store);
                return store.put('owner', new DbOwner(_this.ownerId, Date.now()));
            });
            txResult.catch(function (reason) {
                // Probably means we lost the lease. Report the error and stop trying to
                // refresh the lease.
                log_error(reason);
                _this.stopOwnerLeaseRefreshes();
            });
        }, OWNER_LEASE_REFRESH_INTERVAL_MS);
    };
    IndexedDbPersistence.prototype.stopOwnerLeaseRefreshes = function () {
        if (this.ownerLeaseRefreshHandle) {
            clearInterval(this.ownerLeaseRefreshHandle);
            this.ownerLeaseRefreshHandle = null;
        }
    };
    /**
     * Attaches a window.unload handler that will synchronously write our
     * ownerId to a "zombie owner id" location in localstorage. This can be used
     * by tabs trying to acquire the lease to determine that the lease should be
     * acquired immediately even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the owner
     * lease). LocalStorage is used for this rather than IndexedDb because it is
     * a synchronous API and so can be used reliably from an unload handler.
     */
    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
        var _this = this;
        this.windowUnloadHandler = function () {
            // Record that we're zombied.
            _this.setZombiedOwnerId(_this.ownerId);
            // Attempt graceful shutdown (including releasing our owner lease), but
            // there's no guarantee it will complete.
            _this.shutdown();
        };
        window.addEventListener('unload', this.windowUnloadHandler);
    };
    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
        if (this.windowUnloadHandler) {
            window.removeEventListener('unload', this.windowUnloadHandler);
            this.windowUnloadHandler = null;
        }
    };
    /**
     * Returns any recorded "zombied owner" (i.e. a previous owner that became
     * zombied due to their tab closing) from LocalStorage, or null if no such
     * record exists.
     */
    IndexedDbPersistence.prototype.getZombiedOwnerId = function () {
        try {
            var zombiedOwnerId = window.localStorage.getItem(this.zombiedOwnerLocalStorageKey());
            debug(indexeddb_persistence_LOG_TAG, 'Zombied ownerID from LocalStorage:', zombiedOwnerId);
            return zombiedOwnerId;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            log_error(indexeddb_persistence_LOG_TAG, 'Failed to get zombie owner id.', e);
            return null;
        }
    };
    /**
     * Records a zombied owner (an owner that had its tab closed) in LocalStorage
     * or, if passed null, deletes any recorded zombied owner.
     */
    IndexedDbPersistence.prototype.setZombiedOwnerId = function (zombieOwnerId) {
        try {
            if (zombieOwnerId === null) {
                window.localStorage.removeItem(this.zombiedOwnerLocalStorageKey());
            } else {
                window.localStorage.setItem(this.zombiedOwnerLocalStorageKey(), zombieOwnerId);
            }
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            log_error(indexeddb_persistence_LOG_TAG, 'Failed to set zombie owner id.', e);
        }
    };
    IndexedDbPersistence.prototype.zombiedOwnerLocalStorageKey = function () {
        return this.localStoragePrefix + ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX;
    };
    IndexedDbPersistence.prototype.generateOwnerId = function () {
        // For convenience, just use an AutoId.
        return misc_AutoId.newId();
    };
    /**
     * The name of the main (and currently only) IndexedDB database. this name is
     * appended to the prefix provided to the IndexedDbPersistence constructor.
     */
    IndexedDbPersistence.MAIN_DATABASE = 'main';
    return IndexedDbPersistence;
}();


//# sourceMappingURL=indexeddb_persistence.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/local_documents_view.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */
var local_documents_view_LocalDocumentsView = /** @class */function () {
    function LocalDocumentsView(remoteDocumentCache, mutationQueue) {
        this.remoteDocumentCache = remoteDocumentCache;
        this.mutationQueue = mutationQueue;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */
    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
        var _this = this;
        return this.remoteDocumentCache.getEntry(transaction, key).next(function (remoteDoc) {
            return _this.computeLocalDocument(transaction, key, remoteDoc);
        });
    };
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */
    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
        var _this = this;
        var promises = [];
        var results = maybeDocumentMap();
        keys.forEach(function (key) {
            promises.push(_this.getDocument(transaction, key).next(function (maybeDoc) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                if (!maybeDoc) {
                    maybeDoc = new document_NoDocument(key, snapshot_version_SnapshotVersion.forDeletedDoc());
                }
                results = results.insert(key, maybeDoc);
            }));
        });
        return persistence_promise_PersistencePromise.waitFor(promises).next(function () {
            return results;
        });
    };
    /** Performs a query against the local view of all documents. */
    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        if (document_key_DocumentKey.isDocumentKey(query.path)) {
            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
        } else {
            return this.getDocumentsMatchingCollectionQuery(transaction, query);
        }
    };
    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
        // Just do a simple document lookup.
        return this.getDocument(transaction, new document_key_DocumentKey(docPath)).next(function (maybeDoc) {
            var result = documentMap();
            if (maybeDoc instanceof document_Document) {
                result = result.insert(maybeDoc.key, maybeDoc);
            }
            return result;
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
        var _this = this;
        // Query the remote documents and overlay mutations.
        // TODO(mikelehen): There may be significant overlap between the mutations
        // affecting these remote documents and the
        // getAllMutationBatchesAffectingQuery() mutations. Consider optimizing.
        var results;
        return this.remoteDocumentCache.getDocumentsMatchingQuery(transaction, query).next(function (queryResults) {
            return _this.computeLocalDocuments(transaction, queryResults);
        }).next(function (promisedResults) {
            results = promisedResults;
            // Now use the mutation queue to discover any other documents that may
            // match the query after applying mutations.
            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
        }).next(function (matchingMutationBatches) {
            var matchingKeys = documentKeySet();
            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
                var batch = matchingMutationBatches_1[_i];
                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                    var mutation = _b[_a];
                    // TODO(mikelehen): PERF: Check if this mutation actually
                    // affects the query to reduce work.
                    if (!results.get(mutation.key)) {
                        matchingKeys = matchingKeys.add(mutation.key);
                    }
                }
            }
            // Now add in the results for the matchingKeys.
            var promises = [];
            matchingKeys.forEach(function (key) {
                promises.push(_this.getDocument(transaction, key).next(function (doc) {
                    if (doc instanceof document_Document) {
                        results = results.insert(doc.key, doc);
                    }
                }));
            });
            return persistence_promise_PersistencePromise.waitFor(promises);
        }).next(function () {
            // Finally, filter out any documents that don't actually match
            // the query.
            results.forEach(function (key, doc) {
                if (!query.matches(doc)) {
                    results = results.remove(key);
                }
            });
            return results;
        });
    };
    /**
     * Takes a remote document and applies local mutations to generate the local
     * view of the document.
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the document (necessary when remoteDocument
     *     is null).
     * @param document The base remote document to apply mutations to or null.
     */
    LocalDocumentsView.prototype.computeLocalDocument = function (transaction, documentKey, document) {
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKey(transaction, documentKey).next(function (batches) {
            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
                var batch = batches_1[_i];
                document = batch.applyToLocalView(documentKey, document);
            }
            return document;
        });
    };
    /**
     * Takes a set of remote documents and applies local mutations to generate the
     * local view of the documents.
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documents The base remote documents to apply mutations to.
     * @return The local view of the documents.
     */
    LocalDocumentsView.prototype.computeLocalDocuments = function (transaction, documents) {
        var _this = this;
        var promises = [];
        documents.forEach(function (key, doc) {
            promises.push(_this.computeLocalDocument(transaction, key, doc).next(function (mutatedDoc) {
                if (mutatedDoc instanceof document_Document) {
                    documents = documents.insert(mutatedDoc.key, mutatedDoc);
                } else if (mutatedDoc instanceof document_NoDocument) {
                    documents = documents.remove(mutatedDoc.key);
                } else {
                    fail('Unknown MaybeDocument: ' + mutatedDoc);
                }
            }));
        });
        return persistence_promise_PersistencePromise.waitFor(promises).next(function () {
            return documents;
        });
    };
    return LocalDocumentsView;
}();


//# sourceMappingURL=local_documents_view.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/remote_document_change_buffer.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * NOTE: This class was introduced in iOS to work around a limitation in
 * LevelDB. Given IndexedDb has full transaction support with
 * read-your-own-writes capability, this class is not technically needed, but
 * has been preserved as a convenience and to aid portability.
 */
var remote_document_change_buffer_RemoteDocumentChangeBuffer = /** @class */function () {
    function RemoteDocumentChangeBuffer(remoteDocumentCache) {
        this.remoteDocumentCache = remoteDocumentCache;
        this.changes = maybeDocumentMap();
    }
    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
        var changes = this.assertChanges();
        this.changes = changes.insert(maybeDocument.key, maybeDocument);
    };
    // NOTE: removeEntry() is not presently necessary and so is omitted.
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */
    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
        var changes = this.assertChanges();
        var bufferedEntry = changes.get(documentKey);
        if (bufferedEntry) {
            return persistence_promise_PersistencePromise.resolve(bufferedEntry);
        } else {
            return this.remoteDocumentCache.getEntry(transaction, documentKey);
        }
    };
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */
    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var promises = [];
        changes.forEach(function (key, maybeDoc) {
            promises.push(_this.remoteDocumentCache.addEntry(transaction, maybeDoc));
        });
        // We should not be used to buffer any more changes.
        this.changes = null;
        return persistence_promise_PersistencePromise.waitFor(promises);
    };
    /** Helper to assert this.changes is not null and return it. */
    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
        assert(this.changes !== null, 'Changes have already been applied.');
        return this.changes;
    };
    return RemoteDocumentChangeBuffer;
}();


//# sourceMappingURL=remote_document_change_buffer.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/local_store.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */














var local_store_LOG_TAG = 'LocalStore';
/**
 * Local storage in the Firestore client. Coordinates persistence components
 * like the mutation queue and remote document cache to present a
 * latency-compensated view of stored data.
 *
 * The LocalStore is responsible for accepting mutations from the Sync Engine.
 * Writes from the client are put into a queue as provisional Mutations until
 * they are processed by the RemoteStore and confirmed as having been written
 * to the server.
 *
 * The local store provides the local version of documents that have been
 * modified locally. It maintains the constraint:
 *
 *   LocalDocument = RemoteDocument + Active(LocalMutations)
 *
 * (Active mutations are those that are enqueued and have not been previously
 * acknowledged or rejected).
 *
 * The RemoteDocument ("ground truth") state is provided via the
 * applyChangeBatch method. It will be some version of a server-provided
 * document OR will be a server-provided document PLUS acknowledged mutations:
 *
 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
 *
 * Note that this "dirty" version of a RemoteDocument will not be identical to a
 * server base version, since it has LocalMutations added to it pending getting
 * an authoritative copy from the server.
 *
 * Since LocalMutations can be rejected by the server, we have to be able to
 * revert a LocalMutation that has already been applied to the LocalDocument
 * (typically done by replaying all remaining LocalMutations to the
 * RemoteDocument to re-apply).
 *
 * The LocalStore is responsible for the garbage collection of the documents it
 * contains. For now, it every doc referenced by a view, the mutation queue, or
 * the RemoteStore.
 *
 * It also maintains the persistence of mapping queries to resume tokens and
 * target ids. It needs to know this data about queries to properly know what
 * docs it would be allowed to garbage collect.
 *
 * The LocalStore must be able to efficiently execute queries against its local
 * cache of the documents, to provide the initial set of results before any
 * remote changes have been received.
 *
 * Note: In TypeScript, most methods return Promises since the implementation
 * may rely on fetching data from IndexedDB which is async.
 * These Promises will only be rejected on an I/O error or other internal
 * (unexpected) failure (e.g. failed assert) and always represent an
 * unrecoverable error (should be caught / reported by the async_queue).
 */
var local_store_LocalStore = /** @class */function () {
    function LocalStore(
    /** Manages our in-memory or durable persistence. */
    persistence, initialUser,
    /**
       * The garbage collector collects documents that should no longer be
       * cached (e.g. if they are no longer retained by the above reference sets
       * and the garbage collector is performing eager collection).
       */
    garbageCollector) {
        this.persistence = persistence;
        this.garbageCollector = garbageCollector;
        /**
         * The set of document references maintained by any local views.
         */
        this.localViewReferences = new reference_set_ReferenceSet();
        /** Maps a targetID to data about its query. */
        this.targetIds = {};
        /** Used to generate targetIDs for queries tracked locally. */
        this.targetIdGenerator = TargetIdGenerator.forLocalStore();
        /**
         * A heldBatchResult is a mutation batch result (from a write acknowledgement)
         * that arrived before the watch stream got notified of a snapshot that
         * includes the write. So we "hold" it until the watch stream catches up. It
         * ensures that the local write remains visible (latency compensation) and
         * doesn't temporarily appear reverted because the watch stream is slower than
         * the write stream and so wasn't reflecting it.
         *
         * NOTE: Eventually we want to move this functionality into the remote store.
         */
        this.heldBatchResults = [];
        this.mutationQueue = persistence.getMutationQueue(initialUser);
        this.remoteDocuments = persistence.getRemoteDocumentCache();
        this.queryCache = persistence.getQueryCache();
        this.localDocuments = new local_documents_view_LocalDocumentsView(this.remoteDocuments, this.mutationQueue);
        this.garbageCollector.addGarbageSource(this.localViewReferences);
        this.garbageCollector.addGarbageSource(this.queryCache);
        this.garbageCollector.addGarbageSource(this.mutationQueue);
    }
    /** Performs any initial startup actions required by the local store. */
    LocalStore.prototype.start = function () {
        var _this = this;
        return this.persistence.runTransaction('Start LocalStore', function (txn) {
            return _this.startMutationQueue(txn).next(function () {
                return _this.startQueryCache(txn);
            });
        });
    };
    /**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */
    LocalStore.prototype.handleUserChange = function (user) {
        var _this = this;
        return this.persistence.runTransaction('Handle user change', function (txn) {
            // Swap out the mutation queue, grabbing the pending mutation batches
            // before and after.
            var oldBatches;
            return _this.mutationQueue.getAllMutationBatches(txn).next(function (promisedOldBatches) {
                oldBatches = promisedOldBatches;
                _this.garbageCollector.removeGarbageSource(_this.mutationQueue);
                _this.mutationQueue = _this.persistence.getMutationQueue(user);
                _this.garbageCollector.addGarbageSource(_this.mutationQueue);
                return _this.startMutationQueue(txn);
            }).next(function () {
                // Recreate our LocalDocumentsView using the new
                // MutationQueue.
                _this.localDocuments = new local_documents_view_LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue);
                return _this.mutationQueue.getAllMutationBatches(txn);
            }).next(function (newBatches) {
                // Union the old/new changed keys.
                var changedKeys = documentKeySet();
                for (var _i = 0, _a = [oldBatches, newBatches]; _i < _a.length; _i++) {
                    var batches = _a[_i];
                    for (var _b = 0, batches_1 = batches; _b < batches_1.length; _b++) {
                        var batch = batches_1[_b];
                        for (var _c = 0, _d = batch.mutations; _c < _d.length; _c++) {
                            var mutation = _d[_c];
                            changedKeys = changedKeys.add(mutation.key);
                        }
                    }
                }
                // Return the set of all (potentially) changed documents as the
                // result of the user change.
                return _this.localDocuments.getDocuments(txn, changedKeys);
            });
        });
    };
    LocalStore.prototype.startQueryCache = function (txn) {
        var _this = this;
        return this.queryCache.start(txn).next(function () {
            var targetId = _this.queryCache.getHighestTargetId();
            _this.targetIdGenerator = TargetIdGenerator.forLocalStore(targetId);
        });
    };
    LocalStore.prototype.startMutationQueue = function (txn) {
        var _this = this;
        return this.mutationQueue.start(txn).next(function () {
            // If we have any leftover mutation batch results from a prior run,
            // just drop them.
            // TODO(http://b/33446471): We probably need to repopulate
            // heldBatchResults or similar instead, but that is not
            // straightforward since we're not persisting the write ack versions.
            _this.heldBatchResults = [];
            return _this.mutationQueue.getHighestAcknowledgedBatchId(txn);
        }).next(function (highestAck) {
            // TODO(mikelehen): This is the only usage of
            // getAllMutationBatchesThroughBatchId(). Consider removing it in
            // favor of a getAcknowledgedBatches() method.
            if (highestAck !== BATCHID_UNKNOWN) {
                return _this.mutationQueue.getAllMutationBatchesThroughBatchId(txn, highestAck);
            } else {
                return persistence_promise_PersistencePromise.resolve([]);
            }
        }).next(function (ackedBatches) {
            if (ackedBatches.length > 0) {
                return _this.mutationQueue.removeMutationBatches(txn, ackedBatches);
            } else {
                return persistence_promise_PersistencePromise.resolve();
            }
        });
    };
    /* Accept locally generated Mutations and commit them to storage. */
    LocalStore.prototype.localWrite = function (mutations) {
        var _this = this;
        return this.persistence.runTransaction('Locally write mutations', function (txn) {
            var batch;
            var localWriteTime = timestamp_Timestamp.now();
            return _this.mutationQueue.addMutationBatch(txn, localWriteTime, mutations).next(function (promisedBatch) {
                batch = promisedBatch;
                // TODO(koss): This is doing an N^2 update by replaying ALL the
                // mutations on each document (instead of just the ones added) in
                // this batch.
                var keys = batch.keys();
                return _this.localDocuments.getDocuments(txn, keys);
            }).next(function (changedDocuments) {
                return { batchId: batch.batchId, changes: changedDocuments };
            });
        });
    };
    /**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */
    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
        var _this = this;
        return this.persistence.runTransaction('Acknowledge batch', function (txn) {
            var affected;
            return _this.mutationQueue.acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken).next(function () {
                if (_this.shouldHoldBatchResult(batchResult.commitVersion)) {
                    _this.heldBatchResults.push(batchResult);
                    affected = documentKeySet();
                    return persistence_promise_PersistencePromise.resolve();
                } else {
                    var documentBuffer_1 = new remote_document_change_buffer_RemoteDocumentChangeBuffer(_this.remoteDocuments);
                    return _this.releaseBatchResults(txn, [batchResult], documentBuffer_1).next(function (promisedAffectedKeys) {
                        affected = promisedAffectedKeys;
                        return documentBuffer_1.apply(txn);
                    });
                }
            }).next(function () {
                return _this.mutationQueue.performConsistencyCheck(txn);
            }).next(function () {
                return _this.localDocuments.getDocuments(txn, affected);
            });
        });
    };
    /**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */
    LocalStore.prototype.rejectBatch = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Reject batch', function (txn) {
            var toReject;
            var affectedKeys;
            return _this.mutationQueue.lookupMutationBatch(txn, batchId).next(function (promisedToReject) {
                assert(promisedToReject != null, 'Attempt to reject nonexistent batch!');
                toReject = promisedToReject;
                return _this.mutationQueue.getHighestAcknowledgedBatchId(txn).next(function (lastAcked) {
                    assert(batchId > lastAcked, "Acknowledged batches can't be rejected.");
                    return toReject;
                });
            }).next(function () {
                return _this.removeMutationBatch(txn, toReject);
            }).next(function (promisedAffectedKeys) {
                affectedKeys = promisedAffectedKeys;
                return _this.mutationQueue.performConsistencyCheck(txn);
            }).next(function () {
                return _this.localDocuments.getDocuments(txn, affectedKeys);
            });
        });
    };
    /** Returns the last recorded stream token for the current user. */
    LocalStore.prototype.getLastStreamToken = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last stream token', function (txn) {
            return _this.mutationQueue.getLastStreamToken(txn);
        });
    };
    /**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */
    LocalStore.prototype.setLastStreamToken = function (streamToken) {
        var _this = this;
        return this.persistence.runTransaction('Set last stream token', function (txn) {
            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
        });
    };
    /**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */
    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
        return this.queryCache.getLastRemoteSnapshotVersion();
    };
    /**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */
    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        var documentBuffer = new remote_document_change_buffer_RemoteDocumentChangeBuffer(this.remoteDocuments);
        return this.persistence.runTransaction('Apply remote event', function (txn) {
            var promises = [];
            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
                // Do not ref/unref unassigned targetIds - it may lead to leaks.
                var queryData = _this.targetIds[targetId];
                if (!queryData) return;
                var mapping = change.mapping;
                if (mapping) {
                    // First make sure that all references are deleted
                    if (mapping instanceof ResetMapping) {
                        promises.push(_this.queryCache.removeMatchingKeysForTargetId(txn, targetId).next(function () {
                            return _this.queryCache.addMatchingKeys(txn, mapping.documents, targetId);
                        }));
                    } else if (mapping instanceof UpdateMapping) {
                        promises.push(_this.queryCache.removeMatchingKeys(txn, mapping.removedDocuments, targetId).next(function () {
                            return _this.queryCache.addMatchingKeys(txn, mapping.addedDocuments, targetId);
                        }));
                    } else {
                        return fail('Unknown mapping type: ' + JSON.stringify(mapping));
                    }
                }
                // Update the resume token if the change includes one. Don't clear
                // any preexisting value.
                var resumeToken = change.resumeToken;
                if (resumeToken.length > 0) {
                    queryData = queryData.update({
                        resumeToken: resumeToken,
                        snapshotVersion: change.snapshotVersion
                    });
                    _this.targetIds[targetId] = queryData;
                    promises.push(_this.queryCache.addQueryData(txn, queryData));
                }
            });
            var changedDocKeys = documentKeySet();
            remoteEvent.documentUpdates.forEach(function (key, doc) {
                changedDocKeys = changedDocKeys.add(key);
                promises.push(documentBuffer.getEntry(txn, key).next(function (existingDoc) {
                    // Make sure we don't apply an old document version to the remote
                    // cache, though we make an exception for SnapshotVersion.MIN which
                    // can happen for manufactured events (e.g. in the case of a limbo
                    // document resolution failing).
                    if (existingDoc == null || doc.version.equals(snapshot_version_SnapshotVersion.MIN) || doc.version.compareTo(existingDoc.version) >= 0) {
                        documentBuffer.addEntry(doc);
                    } else {
                        debug(local_store_LOG_TAG, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
                    }
                    // The document might be garbage because it was unreferenced by
                    // everything. Make sure to mark it as garbage if it is...
                    _this.garbageCollector.addPotentialGarbageKey(key);
                }));
            });
            // HACK: The only reason we allow a null snapshot version is so that we
            // can synthesize remote events when we get permission denied errors while
            // trying to resolve the state of a locally cached document that is in
            // limbo.
            var lastRemoteVersion = _this.queryCache.getLastRemoteSnapshotVersion();
            var remoteVersion = remoteEvent.snapshotVersion;
            if (!remoteVersion.equals(snapshot_version_SnapshotVersion.MIN)) {
                assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' + remoteVersion + ' < ' + lastRemoteVersion);
                promises.push(_this.queryCache.setLastRemoteSnapshotVersion(txn, remoteVersion));
            }
            var releasedWriteKeys;
            return persistence_promise_PersistencePromise.waitFor(promises).next(function () {
                return _this.releaseHeldBatchResults(txn, documentBuffer);
            }).next(function (promisedReleasedWriteKeys) {
                releasedWriteKeys = promisedReleasedWriteKeys;
                return documentBuffer.apply(txn);
            }).next(function () {
                return _this.localDocuments.getDocuments(txn, changedDocKeys.unionWith(releasedWriteKeys));
            });
        });
    };
    /**
     * Notify local store of the changed views to locally pin documents.
     */
    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
        var _this = this;
        return this.persistence.runTransaction('Notify local view changes', function (txn) {
            var promises = [];
            var _loop_1 = function _loop_1(view) {
                promises.push(_this.queryCache.getQueryData(txn, view.query).next(function (queryData) {
                    assert(queryData !== null, 'Local view changes contain unallocated query.');
                    var targetId = queryData.targetId;
                    _this.localViewReferences.addReferences(view.addedKeys, targetId);
                    _this.localViewReferences.removeReferences(view.removedKeys, targetId);
                }));
            };
            for (var _i = 0, viewChanges_1 = viewChanges; _i < viewChanges_1.length; _i++) {
                var view = viewChanges_1[_i];
                _loop_1(view);
            }
            return persistence_promise_PersistencePromise.waitFor(promises);
        });
    };
    /**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */
    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
        var _this = this;
        return this.persistence.runTransaction('Get next mutation batch', function (txn) {
            if (afterBatchId === undefined) {
                afterBatchId = BATCHID_UNKNOWN;
            }
            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
        });
    };
    /**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */
    LocalStore.prototype.readDocument = function (key) {
        var _this = this;
        return this.persistence.runTransaction('read document', function (txn) {
            return _this.localDocuments.getDocument(txn, key);
        });
    };
    /**
     * Assigns the given query an internal ID so that its results can be pinned so
     * they don't get GC'd. A query must be allocated in the local store before
     * the store can be used to manage its view.
     */
    LocalStore.prototype.allocateQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Allocate query', function (txn) {
            var queryData;
            return _this.queryCache.getQueryData(txn, query).next(function (cached) {
                if (cached) {
                    // This query has been listened to previously, so reuse the
                    // previous targetID.
                    // TODO(mcg): freshen last accessed date?
                    queryData = cached;
                    return persistence_promise_PersistencePromise.resolve();
                } else {
                    var targetId = _this.targetIdGenerator.next();
                    queryData = new query_data_QueryData(query, targetId, QueryPurpose.Listen);
                    return _this.queryCache.addQueryData(txn, queryData);
                }
            }).next(function () {
                assert(!_this.targetIds[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
                _this.targetIds[queryData.targetId] = queryData;
                return queryData;
            });
        });
    };
    /** Unpin all the documents associated with the given query. */
    LocalStore.prototype.releaseQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Release query', function (txn) {
            return _this.queryCache.getQueryData(txn, query).next(function (queryData) {
                assert(queryData != null, 'Tried to release nonexistent query: ' + query);
                _this.localViewReferences.removeReferencesForId(queryData.targetId);
                delete _this.targetIds[queryData.targetId];
                if (_this.garbageCollector.isEager) {
                    return _this.queryCache.removeQueryData(txn, queryData);
                } else {
                    return persistence_promise_PersistencePromise.resolve();
                }
            }).next(function () {
                // If this was the last watch target, then we won't get any more
                // watch snapshots, so we should release any held batch results.
                if (isEmpty(_this.targetIds)) {
                    var documentBuffer_2 = new remote_document_change_buffer_RemoteDocumentChangeBuffer(_this.remoteDocuments);
                    return _this.releaseHeldBatchResults(txn, documentBuffer_2).next(function () {
                        documentBuffer_2.apply(txn);
                    });
                } else {
                    return persistence_promise_PersistencePromise.resolve();
                }
            });
        });
    };
    /**
     * Runs the specified query against all the documents in the local store and
     * returns the results.
     */
    LocalStore.prototype.executeQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Execute query', function (txn) {
            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
        });
    };
    /**
     * Returns the keys of the documents that are associated with the given
     * target id in the remote table.
     */
    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
        var _this = this;
        return this.persistence.runTransaction('Remote document keys', function (txn) {
            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
        });
    };
    /**
     * Collect garbage if necessary.
     * Should be called periodically by Sync Engine to recover resources. The
     * implementation must guarantee that GC won't happen in other places than
     * this method call.
     */
    LocalStore.prototype.collectGarbage = function () {
        var _this = this;
        // Call collectGarbage regardless of whether isGCEnabled so the referenceSet
        // doesn't continue to accumulate the garbage keys.
        return this.persistence.runTransaction('Garbage collection', function (txn) {
            return _this.garbageCollector.collectGarbage(txn).next(function (garbage) {
                var promises = [];
                garbage.forEach(function (key) {
                    promises.push(_this.remoteDocuments.removeEntry(txn, key));
                });
                return persistence_promise_PersistencePromise.waitFor(promises);
            });
        });
    };
    LocalStore.prototype.releaseHeldBatchResults = function (txn, documentBuffer) {
        var toRelease = [];
        for (var _i = 0, _a = this.heldBatchResults; _i < _a.length; _i++) {
            var batchResult = _a[_i];
            if (!this.isRemoteUpToVersion(batchResult.commitVersion)) {
                break;
            }
            toRelease.push(batchResult);
        }
        if (toRelease.length === 0) {
            return persistence_promise_PersistencePromise.resolve(documentKeySet());
        } else {
            this.heldBatchResults.splice(0, toRelease.length);
            return this.releaseBatchResults(txn, toRelease, documentBuffer);
        }
    };
    LocalStore.prototype.isRemoteUpToVersion = function (version) {
        // If there are no watch targets, then we won't get remote snapshots, and
        // we are always "up-to-date."
        var lastRemoteVersion = this.queryCache.getLastRemoteSnapshotVersion();
        return version.compareTo(lastRemoteVersion) <= 0 || isEmpty(this.targetIds);
    };
    LocalStore.prototype.shouldHoldBatchResult = function (version) {
        // Check if watcher isn't up to date or prior results are already held.
        return !this.isRemoteUpToVersion(version) || this.heldBatchResults.length > 0;
    };
    LocalStore.prototype.releaseBatchResults = function (txn, batchResults, documentBuffer) {
        var _this = this;
        var promiseChain = persistence_promise_PersistencePromise.resolve();
        var _loop_2 = function _loop_2(batchResult) {
            promiseChain = promiseChain.next(function () {
                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
            });
        };
        for (var _i = 0, batchResults_1 = batchResults; _i < batchResults_1.length; _i++) {
            var batchResult = batchResults_1[_i];
            _loop_2(batchResult);
        }
        return promiseChain.next(function () {
            return _this.removeMutationBatches(txn, batchResults.map(function (result) {
                return result.batch;
            }));
        });
    };
    LocalStore.prototype.removeMutationBatch = function (txn, batch) {
        return this.removeMutationBatches(txn, [batch]);
    };
    /** Removes all the mutation batches named in the given array. */
    LocalStore.prototype.removeMutationBatches = function (txn, batches) {
        var affectedDocs = documentKeySet();
        for (var _i = 0, batches_2 = batches; _i < batches_2.length; _i++) {
            var batch = batches_2[_i];
            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                var mutation = _b[_a];
                var key = mutation.key;
                affectedDocs = affectedDocs.add(key);
            }
        }
        return this.mutationQueue.removeMutationBatches(txn, batches).next(function () {
            return affectedDocs;
        });
    };
    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
        var batch = batchResult.batch;
        var docKeys = batch.keys();
        var promiseChain = persistence_promise_PersistencePromise.resolve();
        docKeys.forEach(function (docKey) {
            promiseChain = promiseChain.next(function () {
                return documentBuffer.getEntry(txn, docKey);
            }).next(function (remoteDoc) {
                var doc = remoteDoc;
                var ackVersion = batchResult.docVersions.get(docKey);
                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
                if (!doc || doc.version.compareTo(ackVersion) < 0) {
                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
                    if (!doc) {
                        assert(!remoteDoc, 'Mutation batch ' + batch + ' applied to document ' + remoteDoc + ' resulted in null');
                    } else {
                        documentBuffer.addEntry(doc);
                    }
                }
            });
        });
        return promiseChain;
    };
    return LocalStore;
}();


//# sourceMappingURL=local_store.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/memory_mutation_queue.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var memory_mutation_queue_MemoryMutationQueue = /** @class */function () {
    function MemoryMutationQueue() {
        /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */
        this.mutationQueue = [];
        /** Next value to use when assigning sequential IDs to each mutation batch. */
        this.nextBatchId = 1;
        /** The highest acknowledged mutation in the queue. */
        this.highestAcknowledgedBatchId = BATCHID_UNKNOWN;
        /** The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         */
        this.lastStreamToken = emptyByteString();
        /** The garbage collector to notify about potential garbage keys. */
        this.garbageCollector = null;
        /** An ordered mapping between documents and the mutations batch IDs. */
        this.batchesByDocumentKey = new sorted_set_SortedSet(reference_set_DocReference.compareByKey);
    }
    MemoryMutationQueue.prototype.start = function (transaction) {
        // NOTE: The queue may be shutdown / started multiple times, since we
        // maintain the queue for the duration of the app session in case a user
        // logs out / back in. To behave like the LevelDB-backed MutationQueue (and
        // accommodate tests that expect as much), we reset nextBatchId and
        // highestAcknowledgedBatchId if the queue is empty.
        if (this.mutationQueue.length === 0) {
            this.nextBatchId = 1;
            this.highestAcknowledgedBatchId = BATCHID_UNKNOWN;
        }
        assert(this.highestAcknowledgedBatchId < this.nextBatchId, 'highestAcknowledgedBatchId must be less than the nextBatchId');
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.mutationQueue.length === 0);
    };
    MemoryMutationQueue.prototype.getNextBatchId = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.nextBatchId);
    };
    MemoryMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.highestAcknowledgedBatchId);
    };
    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        var batchId = batch.batchId;
        assert(batchId > this.highestAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
        // Verify that the batch in the queue is the one to be acknowledged.
        var check = this.mutationQueue[batchIndex];
        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' + batchId + ', got batch ' + check.batchId);
        assert(!check.isTombstone(), "Can't acknowledge a previously removed batch");
        this.highestAcknowledgedBatchId = batchId;
        this.lastStreamToken = streamToken;
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.lastStreamToken);
    };
    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        this.lastStreamToken = streamToken;
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
        assert(mutations.length !== 0, 'Mutation batches should not be empty');
        var batchId = this.nextBatchId;
        this.nextBatchId++;
        if (this.mutationQueue.length > 0) {
            var prior = this.mutationQueue[this.mutationQueue.length - 1];
            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
        }
        var batch = new mutation_batch_MutationBatch(batchId, localWriteTime, mutations);
        this.mutationQueue.push(batch);
        // Track references by document key.
        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
            var mutation = mutations_1[_i];
            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new reference_set_DocReference(mutation.key, batchId));
        }
        return persistence_promise_PersistencePromise.resolve(batch);
    };
    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        return persistence_promise_PersistencePromise.resolve(this.findMutationBatch(batchId));
    };
    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var size = this.mutationQueue.length;
        // All batches with batchId <= this.highestAcknowledgedBatchId have been
        // acknowledged so the first unacknowledged batch after batchID will have a
        // batchID larger than both of these values.
        batchId = Math.max(batchId + 1, this.highestAcknowledgedBatchId);
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        var rawIndex = this.indexOfBatchId(batchId);
        var index = rawIndex < 0 ? 0 : rawIndex;
        // Finally return the first non-tombstone batch.
        for (; index < size; index++) {
            var batch = this.mutationQueue[index];
            if (!batch.isTombstone()) {
                return persistence_promise_PersistencePromise.resolve(batch);
            }
        }
        return persistence_promise_PersistencePromise.resolve(null);
    };
    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        return persistence_promise_PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(this.mutationQueue.length));
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
        var count = this.mutationQueue.length;
        var endIndex = this.indexOfBatchId(batchId);
        if (endIndex < 0) {
            endIndex = 0;
        } else if (endIndex >= count) {
            endIndex = count;
        } else {
            // The endIndex is in the queue so increment to pull everything in the
            // queue including it.
            endIndex++;
        }
        return persistence_promise_PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(endIndex));
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        var start = new reference_set_DocReference(documentKey, 0);
        var end = new reference_set_DocReference(documentKey, Number.POSITIVE_INFINITY);
        var result = [];
        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
            assert(documentKey.equals(ref.key), "Should only iterate over a single key's batches");
            var batch = _this.findMutationBatch(ref.targetOrBatchId);
            assert(batch !== null, 'Batches in the index must exist in the main table');
            result.push(batch);
        });
        return persistence_promise_PersistencePromise.resolve(result);
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        var _this = this;
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var prefix = query.path;
        var immediateChildrenPathLength = prefix.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        var startPath = prefix;
        if (!document_key_DocumentKey.isDocumentKey(startPath)) {
            startPath = startPath.child('');
        }
        var start = new reference_set_DocReference(new document_key_DocumentKey(startPath), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        var uniqueBatchIDs = new sorted_set_SortedSet(primitiveComparator);
        this.batchesByDocumentKey.forEachWhile(function (ref) {
            var rowKeyPath = ref.key.path;
            if (!prefix.isPrefixOf(rowKeyPath)) {
                return false;
            } else {
                // Rows with document keys more than one segment longer than the query
                // path can't be matches. For example, a query on 'rooms' can't match
                // the document /rooms/abc/messages/xyx.
                // TODO(mcg): we'll need a different scanner when we implement
                // ancestor queries.
                if (rowKeyPath.length === immediateChildrenPathLength) {
                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
                }
                return true;
            }
        }, start);
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        var result = [];
        uniqueBatchIDs.forEach(function (batchId) {
            var batch = _this.findMutationBatch(batchId);
            if (batch !== null) {
                result.push(batch);
            }
        });
        return persistence_promise_PersistencePromise.resolve(result);
    };
    MemoryMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
        var batchCount = batches.length;
        assert(batchCount > 0, 'Should not remove mutations when none exist.');
        var firstBatchId = batches[0].batchId;
        var queueCount = this.mutationQueue.length;
        // Find the position of the first batch for removal. This need not be the
        // first entry in the queue.
        var startIndex = this.indexOfExistingBatchId(firstBatchId, 'removed');
        assert(this.mutationQueue[startIndex].batchId === firstBatchId, 'Removed batches must exist in the queue');
        // Check that removed batches are contiguous (while excluding tombstones).
        var batchIndex = 1;
        var queueIndex = startIndex + 1;
        while (batchIndex < batchCount && queueIndex < queueCount) {
            var batch = this.mutationQueue[queueIndex];
            if (batch.isTombstone()) {
                queueIndex++;
                continue;
            }
            assert(batch.batchId === batches[batchIndex].batchId, 'Removed batches must be contiguous in the queue');
            batchIndex++;
            queueIndex++;
        }
        // Only actually remove batches if removing at the front of the queue.
        // Previously rejected batches may have left tombstones in the queue, so
        // expand the removal range to include any tombstones.
        if (startIndex === 0) {
            for (; queueIndex < queueCount; queueIndex++) {
                var batch = this.mutationQueue[queueIndex];
                if (!batch.isTombstone()) {
                    break;
                }
            }
            var length_1 = queueIndex - startIndex;
            this.mutationQueue.splice(startIndex, length_1);
        } else {
            // Mark the tombstones
            for (var i = startIndex; i < queueIndex; i++) {
                this.mutationQueue[i] = this.mutationQueue[i].toTombstone();
            }
        }
        var references = this.batchesByDocumentKey;
        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
            var batch = batches_1[_i];
            var batchId = batch.batchId;
            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                var mutation = _b[_a];
                var key = mutation.key;
                if (this.garbageCollector !== null) {
                    this.garbageCollector.addPotentialGarbageKey(key);
                }
                var ref = new reference_set_DocReference(key, batchId);
                references = references.delete(ref);
            }
        }
        this.batchesByDocumentKey = references;
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.setGarbageCollector = function (garbageCollector) {
        this.garbageCollector = garbageCollector;
    };
    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
        var ref = new reference_set_DocReference(key, 0);
        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
        return persistence_promise_PersistencePromise.resolve(key.equals(firstRef && firstRef.key));
    };
    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
        if (this.mutationQueue.length === 0) {
            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
        }
        return persistence_promise_PersistencePromise.resolve();
    };
    /**
     * A private helper that collects all the mutations batches in the queue up to
     * but not including the given endIndex. All tombstones in the queue are
     * excluded.
     */
    MemoryMutationQueue.prototype.getAllLiveMutationBatchesBeforeIndex = function (endIndex) {
        var result = [];
        for (var i = 0; i < endIndex; i++) {
            var batch = this.mutationQueue[i];
            if (!batch.isTombstone()) {
                result.push(batch);
            }
        }
        return result;
    };
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */
    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
        var index = this.indexOfBatchId(batchId);
        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
        return index;
    };
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */
    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
        if (this.mutationQueue.length === 0) {
            // As an index this is past the end of the queue
            return 0;
        }
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        var firstBatchId = this.mutationQueue[0].batchId;
        return batchId - firstBatchId;
    };
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */
    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
        var index = this.indexOfBatchId(batchId);
        if (index < 0 || index >= this.mutationQueue.length) {
            return null;
        }
        var batch = this.mutationQueue[index];
        assert(batch.batchId === batchId, 'If found batch must match');
        return batch.isTombstone() ? null : batch;
    };
    return MemoryMutationQueue;
}();


//# sourceMappingURL=memory_mutation_queue.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/memory_query_cache.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var memory_query_cache_MemoryQueryCache = /** @class */function () {
    function MemoryQueryCache() {
        /**
         * Maps a query to the data about that query
         */
        this.queries = new obj_map_ObjectMap(function (q) {
            return q.canonicalId();
        });
        /** The last received snapshot version. */
        this.lastRemoteSnapshotVersion = snapshot_version_SnapshotVersion.MIN;
        /** The highest numbered target ID encountered. */
        this.highestTargetId = 0;
        /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */
        this.references = new reference_set_ReferenceSet();
    }
    MemoryQueryCache.prototype.start = function (transaction) {
        // Nothing to do.
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
        return this.lastRemoteSnapshotVersion;
    };
    MemoryQueryCache.prototype.getHighestTargetId = function () {
        return this.highestTargetId;
    };
    MemoryQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
        this.lastRemoteSnapshotVersion = snapshotVersion;
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
        this.queries.set(queryData.query, queryData);
        var targetId = queryData.targetId;
        if (targetId > this.highestTargetId) {
            this.highestTargetId = targetId;
        }
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        this.queries.delete(queryData.query);
        this.references.removeReferencesForId(queryData.targetId);
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
        var queryData = this.queries.get(query) || null;
        return persistence_promise_PersistencePromise.resolve(queryData);
    };
    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        this.references.addReferences(keys, targetId);
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        this.references.removeReferences(keys, targetId);
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        this.references.removeReferencesForId(targetId);
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var matchingKeys = this.references.referencesForId(targetId);
        return persistence_promise_PersistencePromise.resolve(matchingKeys);
    };
    MemoryQueryCache.prototype.setGarbageCollector = function (gc) {
        this.references.setGarbageCollector(gc);
    };
    MemoryQueryCache.prototype.containsKey = function (txn, key) {
        return this.references.containsKey(txn, key);
    };
    return MemoryQueryCache;
}();


//# sourceMappingURL=memory_query_cache.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/memory_remote_document_cache.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var memory_remote_document_cache_MemoryRemoteDocumentCache = /** @class */function () {
    function MemoryRemoteDocumentCache() {
        this.docs = maybeDocumentMap();
    }
    MemoryRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
        this.docs = this.docs.insert(maybeDocument.key, maybeDocument);
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        this.docs = this.docs.remove(documentKey);
        return persistence_promise_PersistencePromise.resolve();
    };
    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        return persistence_promise_PersistencePromise.resolve(this.docs.get(documentKey));
    };
    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var prefix = new document_key_DocumentKey(query.path.child(''));
        var iterator = this.docs.getIteratorFrom(prefix);
        while (iterator.hasNext()) {
            var _a = iterator.getNext(),
                key = _a.key,
                maybeDoc = _a.value;
            if (!query.path.isPrefixOf(key.path)) {
                break;
            }
            if (maybeDoc instanceof document_Document && query.matches(maybeDoc)) {
                results = results.insert(maybeDoc.key, maybeDoc);
            }
        }
        return persistence_promise_PersistencePromise.resolve(results);
    };
    return MemoryRemoteDocumentCache;
}();


//# sourceMappingURL=memory_remote_document_cache.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/memory_persistence.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var memory_persistence_LOG_TAG = 'MemoryPersistence';
/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */
var memory_persistence_MemoryPersistence = /** @class */function () {
    function MemoryPersistence() {
        /**
         * Note that these are retained here to make it easier to write tests
         * affecting both the in-memory and IndexedDB-backed persistence layers. Tests
         * can create a new LocalStore wrapping this Persistence instance and this
         * will make the in-memory persistence layer behave as if it were actually
         * persisting values.
         */
        this.mutationQueues = {};
        this.remoteDocumentCache = new memory_remote_document_cache_MemoryRemoteDocumentCache();
        this.queryCache = new memory_query_cache_MemoryQueryCache();
        this.started = false;
    }
    MemoryPersistence.prototype.start = function () {
        assert(!this.started, 'MemoryPersistence double-started!');
        this.started = true;
        // No durable state to read on startup.
        return Promise.resolve();
    };
    MemoryPersistence.prototype.shutdown = function () {
        // No durable state to ensure is closed on shutdown.
        assert(this.started, 'MemoryPersistence shutdown without start!');
        this.started = false;
        return Promise.resolve();
    };
    MemoryPersistence.prototype.getMutationQueue = function (user) {
        var queue = this.mutationQueues[user.toKey()];
        if (!queue) {
            queue = new memory_mutation_queue_MemoryMutationQueue();
            this.mutationQueues[user.toKey()] = queue;
        }
        return queue;
    };
    MemoryPersistence.prototype.getQueryCache = function () {
        return this.queryCache;
    };
    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
        return this.remoteDocumentCache;
    };
    MemoryPersistence.prototype.runTransaction = function (action, operation) {
        debug(memory_persistence_LOG_TAG, 'Starting transaction:', action);
        return operation(new MemoryPersistenceTransaction()).toPromise();
    };
    return MemoryPersistence;
}();

/** Dummy class since memory persistence doesn't actually use transactions. */
var MemoryPersistenceTransaction = /** @class */function () {
    function MemoryPersistenceTransaction() {}
    return MemoryPersistenceTransaction;
}();

//# sourceMappingURL=memory_persistence.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/local/no_op_garbage_collector.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A garbage collector implementation that does absolutely nothing. It ignores
 * all addGarbageSource and addPotentialGarbageKey messages and and never
 * produces any garbage.
 */
var no_op_garbage_collector_NoOpGarbageCollector = /** @class */function () {
    function NoOpGarbageCollector() {
        this.isEager = false;
    }
    NoOpGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
        // Not tracking garbage so don't track sources.
    };
    NoOpGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
        // Not tracking garbage so don't track sources.
    };
    NoOpGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
        // Not tracking garbage so ignore.
    };
    NoOpGarbageCollector.prototype.collectGarbage = function (txn) {
        return persistence_promise_PersistencePromise.resolve(documentKeySet());
    };
    return NoOpGarbageCollector;
}();


//# sourceMappingURL=no_op_garbage_collector.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/promise.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Deferred;
}();

/**
 * Takes an array of values and sequences them using the promise (or value)
 * returned by the supplied callback. The callback for each item is called
 * after the promise is resolved for the previous item.
 * The function returns a promise which is resolved after the promise for
 * the last item is resolved.
 */
function sequence(values, fn, initialValue) {
    var result = Promise.resolve(initialValue);
    values.forEach(function (value) {
        result = result.then(function (lastResult) {
            return fn(value, lastResult);
        });
    });
    return result;
}

//# sourceMappingURL=promise.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/backoff.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var backoff_LOG_TAG = 'ExponentialBackoff';
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */
var backoff_ExponentialBackoff = /** @class */function () {
    function ExponentialBackoff(
    /**
       * The initial delay (used as the base delay on the first retry attempt).
       * Note that jitter will still be applied, so the actual delay could be as
       * little as 0.5*initialDelayMs.
       */
    initialDelayMs,
    /**
       * The multiplier to use to determine the extended base delay after each
       * attempt.
       */
    backoffFactor,
    /**
       * The maximum base delay after which no further backoff is performed.
       * Note that jitter will still be applied, so the actual delay could be as
       * much as 1.5*maxDelayMs.
       */
    maxDelayMs) {
        this.initialDelayMs = initialDelayMs;
        this.backoffFactor = backoffFactor;
        this.maxDelayMs = maxDelayMs;
        this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */
    ExponentialBackoff.prototype.reset = function () {
        this.currentBaseMs = 0;
    };
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */
    ExponentialBackoff.prototype.resetToMax = function () {
        this.currentBaseMs = this.maxDelayMs;
    };
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts.
     */
    ExponentialBackoff.prototype.backoffAndWait = function () {
        var def = new Deferred();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var delayWithJitterMs = this.currentBaseMs + this.jitterDelayMs();
        if (this.currentBaseMs > 0) {
            debug(backoff_LOG_TAG, "Backing off for " + delayWithJitterMs + " ms " + ("(base delay: " + this.currentBaseMs + " ms)"));
        }
        setTimeout(function () {
            def.resolve();
        }, delayWithJitterMs);
        // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.currentBaseMs *= this.backoffFactor;
        if (this.currentBaseMs < this.initialDelayMs) {
            this.currentBaseMs = this.initialDelayMs;
        }
        if (this.currentBaseMs > this.maxDelayMs) {
            this.currentBaseMs = this.maxDelayMs;
        }
        return def.promise;
    };
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
    ExponentialBackoff.prototype.jitterDelayMs = function () {
        return (Math.random() - 0.5) * this.currentBaseMs;
    };
    return ExponentialBackoff;
}();


//# sourceMappingURL=backoff.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/persistent_stream.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var persistent_stream___extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();





var persistent_stream_LOG_TAG = 'PersistentStream';
var PersistentStreamState;
(function (PersistentStreamState) {
    /**
     * The streaming RPC is not running and there's no error condition.
     * Calling `start` will start the stream immediately without backoff.
     * While in this state isStarted will return false.
     */
    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
    /**
     * The stream is starting, and is waiting for an auth token to attach to
     * the initial request. While in this state, isStarted will return
     * true but isOpen will return false.
     */
    PersistentStreamState[PersistentStreamState["Auth"] = 1] = "Auth";
    /**
     * The streaming RPC is up and running. Requests and responses can flow
     * freely. Both isStarted and isOpen will return true.
     */
    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
    /**
     * The stream encountered an error. The next start attempt will back off.
     * While in this state isStarted() will return false.
     *
     */
    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
    /**
     * An in-between state after an error where the stream is waiting before
     * re-starting. After
     * waiting is complete, the stream will try to open. While in this
     * state isStarted() will return YES but isOpen will return false.
     */
    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
    /**
     * The stream has been explicitly stopped; no further events will be emitted.
     */
    PersistentStreamState[PersistentStreamState["Stopped"] = 5] = "Stopped";
})(PersistentStreamState || (PersistentStreamState = {}));
/**
 * Initial backoff time in milliseconds after an error.
 * Set to 1s according to https://cloud.google.com/apis/design/errors.
 */
var BACKOFF_INITIAL_DELAY_MS = 1000;
/** Maximum backoff time in milliseconds */
var BACKOFF_MAX_DELAY_MS = 60 * 1000;
var BACKOFF_FACTOR = 1.5;
/** The time a stream stays open after it is marked idle. */
var IDLE_TIMEOUT_MS = 60 * 1000;
/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be `start`ed before messages can
 * be sent and received. The PersistentStream will call the onOpen function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a `start` fail, PersistentStream will call the registered
 * onClose with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */
var persistent_stream_PersistentStream = /** @class */function () {
    function PersistentStream(queue, connection, credentialsProvider,
    // Used for faster retries in testing
    initialBackoffDelay) {
        this.queue = queue;
        this.connection = connection;
        this.credentialsProvider = credentialsProvider;
        this.idle = false;
        this.stream = null;
        this.listener = null;
        this.backoff = new backoff_ExponentialBackoff(initialBackoffDelay ? initialBackoffDelay : BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
        this.state = PersistentStreamState.Initial;
    }
    /**
     * Returns true if `start` has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use `isOpen` to determine if the stream is open and ready for
     * outbound requests.
     */
    PersistentStream.prototype.isStarted = function () {
        return this.state === PersistentStreamState.Backoff || this.state === PersistentStreamState.Auth || this.state === PersistentStreamState.Open;
    };
    /**
     * Returns true if the underlying RPC is open (the openHandler has been
     * called) and the stream is ready for outbound requests.
     */
    PersistentStream.prototype.isOpen = function () {
        return this.state === PersistentStreamState.Open;
    };
    /**
     * Starts the RPC. Only allowed if isStarted returns false. The stream is
     * not immediately ready for use: onOpen will be invoked when the RPC is ready
     * for outbound requests, at which point isOpen will return true.
     *
     *  When start returns, isStarted will return true.
     */
    PersistentStream.prototype.start = function (listener) {
        if (this.state === PersistentStreamState.Error) {
            this.performBackoff(listener);
            return;
        }
        assert(this.state === PersistentStreamState.Initial, 'Already started');
        this.listener = listener;
        this.auth();
    };
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted state.
     *
     * When stop returns, isStarted and isOpen will both return false.
     */
    PersistentStream.prototype.stop = function () {
        if (this.isStarted()) {
            this.close(PersistentStreamState.Stopped);
        }
    };
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose function. That function can decide to
     * inhibit backoff if required.
     */
    PersistentStream.prototype.inhibitBackoff = function () {
        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
        this.state = PersistentStreamState.Initial;
        this.backoff.reset();
    };
    /**
     * Initializes the idle timer. If no write takes place within one minute, the
     * WebChannel stream will be closed.
     */
    PersistentStream.prototype.markIdle = function () {
        var _this = this;
        this.idle = true;
        this.queue.schedule(function () {
            return _this.handleIdleCloseTimer();
        }, IDLE_TIMEOUT_MS).catch(function (err) {
            // When the AsyncQueue gets drained during testing, pending Promises
            // (including these idle checks) will get rejected. We special-case
            // these cancelled idle checks to make sure that these specific Promise
            // rejections are not considered unhandled.
            assert(err.code === Code.CANCELLED, "Received unexpected error in idle timeout closure. Expected CANCELLED, but was: " + err);
        });
    };
    /** Sends a message to the underlying stream. */
    PersistentStream.prototype.sendRequest = function (msg) {
        this.cancelIdleCheck();
        this.stream.send(msg);
    };
    /** Called by the idle timer when the stream should close due to inactivity. */
    PersistentStream.prototype.handleIdleCloseTimer = function () {
        if (this.isOpen() && this.idle) {
            // When timing out an idle stream there's no reason to force the stream into backoff when
            // it restarts so set the stream state to Initial instead of Error.
            return this.close(PersistentStreamState.Initial);
        }
        return Promise.resolve();
    };
    /** Marks the stream as active again. */
    PersistentStream.prototype.cancelIdleCheck = function () {
        this.idle = false;
    };
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling `start` unless `finalState` is set to
     * `PersistentStreamState.Stopped`.
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */
    PersistentStream.prototype.close = function (finalState, error) {
        assert(finalState == PersistentStreamState.Error || isNullOrUndefined(error), "Can't provide an error when not in an error state.");
        this.cancelIdleCheck();
        if (finalState != PersistentStreamState.Error) {
            // If this is an intentional close ensure we don't delay our next connection attempt.
            this.backoff.reset();
        } else if (error && error.code === Code.RESOURCE_EXHAUSTED) {
            debug(persistent_stream_LOG_TAG, 'Using maximum backoff delay to prevent overloading the backend.');
            this.backoff.resetToMax();
        }
        // Clean up the underlying stream because we are no longer interested in events.
        if (this.stream !== null) {
            this.tearDown();
            this.stream.close();
            this.stream = null;
        }
        // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = finalState;
        var listener = this.listener;
        // Clear the listener to avoid bleeding of events from the underlying streams.
        this.listener = null;
        // If the caller explicitly requested a stream stop, don't notify them of a closing stream (it
        // could trigger undesirable recovery logic, etc.).
        if (finalState != PersistentStreamState.Stopped) {
            return listener.onClose(error);
        } else {
            return Promise.resolve();
        }
    };
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */
    PersistentStream.prototype.tearDown = function () {};
    PersistentStream.prototype.auth = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
        this.state = PersistentStreamState.Auth;
        this.credentialsProvider.getToken( /*forceRefresh=*/false).then(function (token) {
            // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            _this.startStream(token);
        }, function (error) {
            _this.queue.schedule(function () {
                if (_this.state !== PersistentStreamState.Stopped) {
                    // Stream can be stopped while waiting for authorization.
                    var rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error.message);
                    return _this.handleStreamClose(rpcError);
                } else {
                    return Promise.resolve();
                }
            });
        });
    };
    PersistentStream.prototype.startStream = function (token) {
        var _this = this;
        if (this.state === PersistentStreamState.Stopped) {
            // Stream can be stopped while waiting for authorization.
            return;
        }
        assert(this.state === PersistentStreamState.Auth, 'Trying to start stream in a non-auth state');
        // Helper function to dispatch to AsyncQueue and make sure that any
        // close will seem instantaneous and events are prevented from being
        // raised after the close call
        var dispatchIfStillActive = function dispatchIfStillActive(stream, fn) {
            _this.queue.schedule(function () {
                // Only raise events if the stream instance has not changed
                if (_this.stream === stream) {
                    return fn();
                } else {
                    return Promise.resolve();
                }
            });
        };
        // Only start stream if listener has not changed
        if (this.listener !== null) {
            var currentStream_1 = this.startRpc(token);
            this.stream = currentStream_1;
            this.stream.onOpen(function () {
                dispatchIfStillActive(currentStream_1, function () {
                    assert(_this.state === PersistentStreamState.Auth, 'Expected stream to be in state auth, but was ' + _this.state);
                    _this.state = PersistentStreamState.Open;
                    return _this.listener.onOpen();
                });
            });
            this.stream.onClose(function (error) {
                dispatchIfStillActive(currentStream_1, function () {
                    return _this.handleStreamClose(error);
                });
            });
            this.stream.onMessage(function (msg) {
                dispatchIfStillActive(currentStream_1, function () {
                    return _this.onMessage(msg);
                });
            });
        }
    };
    PersistentStream.prototype.performBackoff = function (listener) {
        var _this = this;
        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff in an error case');
        this.state = PersistentStreamState.Backoff;
        this.backoff.backoffAndWait().then(function () {
            // Backoff does not run on the AsyncQueue, so we need to reschedule to
            // make sure the queue blocks
            _this.queue.schedule(function () {
                if (_this.state === PersistentStreamState.Stopped) {
                    // Stream can be stopped while waiting for backoff to complete.
                    return Promise.resolve();
                }
                _this.state = PersistentStreamState.Initial;
                _this.start(listener);
                assert(_this.isStarted(), 'PersistentStream should have started');
                return Promise.resolve();
            });
        });
    };
    PersistentStream.prototype.handleStreamClose = function (error) {
        assert(this.isStarted(), "Can't handle server close on non-started stream");
        debug(persistent_stream_LOG_TAG, "close with error: " + error);
        this.stream = null;
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return this.close(PersistentStreamState.Error, error);
    };
    return PersistentStream;
}();

/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the openHandler, any number of listen and
 * unlisten calls calls can be sent to control what changes will be sent from
 * the server for ListenResponses.
 */
var PersistentListenStream = /** @class */function (_super) {
    persistent_stream___extends(PersistentListenStream, _super);
    function PersistentListenStream(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
        var _this = _super.call(this, queue, connection, credentials, initialBackoffDelay) || this;
        _this.databaseInfo = databaseInfo;
        _this.serializer = serializer;
        return _this;
    }
    PersistentListenStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Listen', token);
    };
    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
        // A successful response means the stream is healthy
        this.backoff.reset();
        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
        return this.listener.onWatchChange(watchChange, snapshot);
    };
    /**
     * Registers interest in the results of the given query. If the query
     * includes a resumeToken it will be included in the request. Results that
     * affect the query will be streamed back as WatchChange messages that
     * reference the targetId.
     */
    PersistentListenStream.prototype.watch = function (queryData) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.addTarget = this.serializer.toTarget(queryData);
        var labels = this.serializer.toListenRequestLabels(queryData);
        if (labels) {
            request.labels = labels;
        }
        this.sendRequest(request);
    };
    /**
     * Unregisters interest in the results of the query associated with the
     * given targetId.
     */
    PersistentListenStream.prototype.unwatch = function (targetId) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.removeTarget = targetId;
        this.sendRequest(request);
    };
    return PersistentListenStream;
}(persistent_stream_PersistentStream);

/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */
var persistent_stream_PersistentWriteStream = /** @class */function (_super) {
    persistent_stream___extends(PersistentWriteStream, _super);
    function PersistentWriteStream(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
        var _this = _super.call(this, queue, connection, credentials, initialBackoffDelay) || this;
        _this.databaseInfo = databaseInfo;
        _this.serializer = serializer;
        _this.handshakeComplete_ = false;
        return _this;
    }
    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */
        get: function get() {
            return this.handshakeComplete_;
        },
        enumerable: true,
        configurable: true
    });
    // Override of PersistentStream.start
    PersistentWriteStream.prototype.start = function (listener) {
        this.handshakeComplete_ = false;
        _super.prototype.start.call(this, listener);
    };
    PersistentWriteStream.prototype.tearDown = function () {
        if (this.handshakeComplete_) {
            this.writeMutations([]);
        }
    };
    PersistentWriteStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Write', token);
    };
    PersistentWriteStream.prototype.onMessage = function (responseProto) {
        // Always capture the last stream token.
        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
        this.lastStreamToken = responseProto.streamToken;
        if (!this.handshakeComplete_) {
            // The first response is always the handshake response
            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
            this.handshakeComplete_ = true;
            return this.listener.onHandshakeComplete();
        } else {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.backoff.reset();
            var results = this.serializer.fromWriteResults(responseProto.writeResults);
            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
            return this.listener.onMutationResult(commitVersion, results);
        }
    };
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */
    PersistentWriteStream.prototype.writeHandshake = function () {
        assert(this.isOpen(), 'Writing handshake requires an opened stream');
        assert(!this.handshakeComplete_, 'Handshake already completed');
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        this.sendRequest(request);
    };
    /** Sends a group of mutations to the Firestore backend to apply. */
    PersistentWriteStream.prototype.writeMutations = function (mutations) {
        var _this = this;
        assert(this.isOpen(), 'Writing mutations requires an opened stream');
        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
        var request = {
            // Protos are typed with string, but we support UInt8Array on Node
            // tslint:disable-next-line:no-any
            streamToken: this.lastStreamToken,
            writes: mutations.map(function (mutation) {
                return _this.serializer.toMutation(mutation);
            })
        };
        this.sendRequest(request);
    };
    return PersistentWriteStream;
}(persistent_stream_PersistentStream);


//# sourceMappingURL=persistent_stream.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/datastore.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
 * which provides an interface that is more convenient for the rest of the
 * client SDK architecture to consume.
 */
var datastore_Datastore = /** @class */function () {
    function Datastore(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
        this.databaseInfo = databaseInfo;
        this.queue = queue;
        this.connection = connection;
        this.credentials = credentials;
        this.serializer = serializer;
        this.initialBackoffDelay = initialBackoffDelay;
    }
    Datastore.prototype.newPersistentWriteStream = function () {
        return new persistent_stream_PersistentWriteStream(this.databaseInfo, this.queue, this.connection, this.credentials, this.serializer, this.initialBackoffDelay);
    };
    Datastore.prototype.newPersistentWatchStream = function () {
        return new PersistentListenStream(this.databaseInfo, this.queue, this.connection, this.credentials, this.serializer, this.initialBackoffDelay);
    };
    Datastore.prototype.commit = function (mutations) {
        var _this = this;
        var params = {
            writes: mutations.map(function (m) {
                return _this.serializer.toMutation(m);
            })
        };
        return this.invokeRPC('commit', params).then(function (response) {
            return _this.serializer.fromWriteResults(response.writeResults);
        });
    };
    Datastore.prototype.lookup = function (keys) {
        var _this = this;
        var params = {
            documents: keys.map(function (k) {
                return _this.serializer.toName(k);
            })
        };
        return this.invokeRPC('batchGet', params).then(function (response) {
            var docs = maybeDocumentMap();
            response.forEach(function (proto) {
                var doc = _this.serializer.fromMaybeDocument(proto);
                docs = docs.insert(doc.key, doc);
            });
            var result = [];
            keys.forEach(function (key) {
                var doc = docs.get(key);
                assert(!!doc, 'Missing entity in write response for ' + key);
                result.push(doc);
            });
            return result;
        });
    };
    /** Gets an auth token and invokes the provided RPC. */
    Datastore.prototype.invokeRPC = function (rpcName, request) {
        var _this = this;
        // TODO(mikelehen): Retry (with backoff) on token failures?
        return this.credentials.getToken( /*forceRefresh=*/false).then(function (token) {
            return _this.connection.invoke(rpcName, request, token);
        });
    };
    return Datastore;
}();


//# sourceMappingURL=datastore.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/transaction.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */
var transaction_Transaction = /** @class */function () {
    function Transaction(datastore) {
        this.datastore = datastore;
        // The version of each document that was read during this transaction.
        this.readVersions = documentVersionMap();
        this.mutations = [];
        this.committed = false;
    }
    Transaction.prototype.recordVersion = function (doc) {
        var docVersion = doc.version;
        if (doc instanceof document_NoDocument) {
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            docVersion = snapshot_version_SnapshotVersion.forDeletedDoc();
        }
        var existingVersion = this.readVersions.get(doc.key);
        if (existingVersion !== null) {
            if (!docVersion.equals(existingVersion)) {
                // This transaction will fail no matter what.
                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
            }
        } else {
            this.readVersions = this.readVersions.insert(doc.key, docVersion);
        }
    };
    Transaction.prototype.lookup = function (keys) {
        var _this = this;
        if (this.committed) {
            return Promise.reject('Transaction has already completed.');
        }
        if (this.mutations.length > 0) {
            return Promise.reject('Transactions lookups are invalid after writes.');
        }
        return this.datastore.lookup(keys).then(function (docs) {
            docs.forEach(function (doc) {
                return _this.recordVersion(doc);
            });
            return docs;
        });
    };
    Transaction.prototype.write = function (mutations) {
        if (this.committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Transaction has already completed.');
        }
        this.mutations = this.mutations.concat(mutations);
    };
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */
    Transaction.prototype.precondition = function (key) {
        var version = this.readVersions.get(key);
        if (version) {
            return mutation_Precondition.updateTime(version);
        } else {
            return mutation_Precondition.NONE;
        }
    };
    /**
     * Returns the precondition for a document if the operation is an update.
     */
    Transaction.prototype.preconditionForUpdate = function (key) {
        var version = this.readVersions.get(key);
        if (version && version.equals(snapshot_version_SnapshotVersion.forDeletedDoc())) {
            // The document doesn't exist, so fail the transaction.
            throw new FirestoreError(Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
        } else if (version) {
            // Document exists, base precondition on document update time.
            return mutation_Precondition.updateTime(version);
        } else {
            // Document was not read, so we just use the preconditions for a blind
            // update.
            return mutation_Precondition.exists(true);
        }
    };
    Transaction.prototype.set = function (key, data) {
        this.write(data.toMutations(key, this.precondition(key)));
    };
    Transaction.prototype.update = function (key, data) {
        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
    };
    Transaction.prototype.delete = function (key) {
        this.write([new mutation_DeleteMutation(key, this.precondition(key))]);
        // Since the delete will be applied before all following writes, we need to
        // ensure that the precondition for the next write will be exists: false.
        this.readVersions = this.readVersions.insert(key, snapshot_version_SnapshotVersion.forDeletedDoc());
    };
    Transaction.prototype.commit = function () {
        var _this = this;
        var unwritten = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach(function (mutation) {
            unwritten = unwritten.remove(mutation.key);
        });
        if (!unwritten.isEmpty()) {
            return Promise.reject(Error('Every document read in a transaction must also be written.'));
        }
        return this.datastore.commit(this.mutations).then(function () {
            _this.committed = true;
        });
    };
    return Transaction;
}();


//# sourceMappingURL=transaction.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/remote/remote_store.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */















var remote_store_LOG_TAG = 'RemoteStore';
// TODO(b/35853402): Negotiate this with the stream.
var MAX_PENDING_WRITES = 10;
// The RemoteStore notifies an onlineStateHandler with OnlineState.Failed if we
// fail to connect to the backend. This subsequently triggers get() requests to
// fail or use cached data, etc. Unfortunately, our connections have
// historically been subject to various transient failures. So we wait for
// multiple failures before notifying the onlineStateHandler.
var ONLINE_ATTEMPTS_BEFORE_FAILURE = 2;
/**
 * RemoteStore - An interface to remotely stored data, basically providing a
 * wrapper around the Datastore that is more reliable for the rest of the
 * system.
 *
 * RemoteStore is responsible for maintaining the connection to the server.
 * - maintaining a list of active listens.
 * - reconnecting when the connection is dropped.
 * - resuming all the active listens on reconnect.
 *
 * RemoteStore handles all incoming events from the Datastore.
 * - listening to the watch stream and repackaging the events as RemoteEvents
 * - notifying SyncEngine of any changes to the active listens.
 *
 * RemoteStore takes writes from other components and handles them reliably.
 * - pulling pending mutations from LocalStore and sending them to Datastore.
 * - retrying mutations that failed because of network problems.
 * - acking mutations to the SyncEngine once they are accepted or rejected.
 */
var remote_store_RemoteStore = /** @class */function () {
    function RemoteStore(databaseInfo, asyncQueue,
    /**
     * The local store, used to fill the write pipeline with outbound
     * mutations and resolve existence filter mismatches.
     */
    localStore,
    /** The client-side proxy for interacting with the backend. */
    datastore, onlineStateHandler) {
        this.databaseInfo = databaseInfo;
        this.asyncQueue = asyncQueue;
        this.localStore = localStore;
        this.datastore = datastore;
        this.onlineStateHandler = onlineStateHandler;
        this.pendingWrites = [];
        this.lastBatchSeen = BATCHID_UNKNOWN;
        /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */
        this.listenTargets = {};
        /**
         * A mapping of targetId to pending acks needed.
         *
         * If a targetId is present in this map, then we're waiting for watch to
         * acknowledge a removal or addition of the target. If a target is not in this
         * mapping, and it's in the listenTargets map, then we consider the target to
         * be active.
         *
         * We increment the count here every time we issue a request over the stream
         * to watch or unwatch. We then decrement the count every time we get a target
         * added or target removed message from the server. Once the count is equal to
         * 0 we know that the client and server are in the same state (once this state
         * is reached the targetId is removed from the map to free the memory).
         */
        this.pendingTargetResponses = {};
        this.accumulatedWatchChanges = [];
        this.watchStream = null;
        this.writeStream = null;
        /**
         * The online state of the watch stream. The state is set to healthy if and
         * only if there are messages received by the backend.
         */
        this.watchStreamOnlineState = OnlineState.Unknown;
        /** A count of consecutive failures to open the stream. */
        this.watchStreamFailures = 0;
    }
    /**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */
    RemoteStore.prototype.start = function () {
        return this.enableNetwork();
    };
    RemoteStore.prototype.setOnlineStateToHealthy = function () {
        this.updateAndBroadcastOnlineState(OnlineState.Healthy);
    };
    RemoteStore.prototype.setOnlineStateToUnknown = function () {
        // The state is set to unknown when a healthy stream is closed (e.g. due to
        // a token timeout) or when we have no active listens and therefore there's
        // no need to start the stream. Assuming there is (possibly in the future)
        // an active listen, then we will eventually move to state Online or Failed,
        // but we always want to make at least ONLINE_ATTEMPTS_BEFORE_FAILURE
        // attempts before failing, so we reset the count here.
        this.watchStreamFailures = 0;
        this.updateAndBroadcastOnlineState(OnlineState.Unknown);
    };
    RemoteStore.prototype.updateOnlineStateAfterFailure = function () {
        // The first failure after we are successfully connected moves us to the
        // 'Unknown' state. We then may make multiple attempts (based on
        // ONLINE_ATTEMPTS_BEFORE_FAILURE) before we actually report failure.
        if (this.watchStreamOnlineState === OnlineState.Healthy) {
            this.setOnlineStateToUnknown();
        } else {
            this.watchStreamFailures++;
            if (this.watchStreamFailures >= ONLINE_ATTEMPTS_BEFORE_FAILURE) {
                this.updateAndBroadcastOnlineState(OnlineState.Failed);
            }
        }
    };
    RemoteStore.prototype.updateAndBroadcastOnlineState = function (onlineState) {
        var didChange = this.watchStreamOnlineState !== onlineState;
        this.watchStreamOnlineState = onlineState;
        if (didChange) {
            this.onlineStateHandler(onlineState);
        }
    };
    RemoteStore.prototype.isNetworkEnabled = function () {
        assert(this.watchStream == null == (this.writeStream == null), 'WatchStream and WriteStream should both be null or non-null');
        return this.watchStream != null;
    };
    /** Re-enables the network. Only to be called as the counterpart to disableNetwork(). */
    RemoteStore.prototype.enableNetwork = function () {
        var _this = this;
        assert(this.watchStream == null, 'enableNetwork() called with non-null watchStream.');
        assert(this.writeStream == null, 'enableNetwork() called with non-null writeStream.');
        // Create new streams (but note they're not started yet).
        this.watchStream = this.datastore.newPersistentWatchStream();
        this.writeStream = this.datastore.newPersistentWriteStream();
        // Load any saved stream token from persistent storage
        return this.localStore.getLastStreamToken().then(function (token) {
            _this.writeStream.lastStreamToken = token;
            if (_this.shouldStartWatchStream()) {
                _this.startWatchStream();
            }
            _this.updateAndBroadcastOnlineState(OnlineState.Unknown);
            return _this.fillWritePipeline(); // This may start the writeStream.
        });
    };
    /** Temporarily disables the network. The network can be re-enabled using enableNetwork(). */
    RemoteStore.prototype.disableNetwork = function () {
        this.updateAndBroadcastOnlineState(OnlineState.Failed);
        // NOTE: We're guaranteed not to get any further events from these streams (not even a close
        // event).
        this.watchStream.stop();
        this.writeStream.stop();
        this.cleanUpWatchStreamState();
        this.cleanUpWriteStreamState();
        this.writeStream = null;
        this.watchStream = null;
        return Promise.resolve();
    };
    RemoteStore.prototype.shutdown = function () {
        debug(remote_store_LOG_TAG, 'RemoteStore shutting down.');
        this.disableNetwork();
        return Promise.resolve(undefined);
    };
    /** Starts new listen for the given query. Uses resume token if provided */
    RemoteStore.prototype.listen = function (queryData) {
        assert(!contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
        // Mark this as something the client is currently listening for.
        this.listenTargets[queryData.targetId] = queryData;
        if (this.shouldStartWatchStream()) {
            // The listen will be sent in onWatchStreamOpen
            this.startWatchStream();
        } else if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
            this.sendWatchRequest(queryData);
        }
    };
    /** Removes the listen from server */
    RemoteStore.prototype.unlisten = function (targetId) {
        assert(contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
        var queryData = this.listenTargets[targetId];
        delete this.listenTargets[targetId];
        if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
            this.sendUnwatchRequest(targetId);
            if (isEmpty(this.listenTargets)) {
                this.watchStream.markIdle();
            }
        }
    };
    /**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */
    RemoteStore.prototype.sendWatchRequest = function (queryData) {
        this.recordPendingTargetRequest(queryData.targetId);
        this.watchStream.watch(queryData);
    };
    /**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */
    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
        this.recordPendingTargetRequest(targetId);
        this.watchStream.unwatch(targetId);
    };
    /**
     * Increment the mapping of how many acks are needed from watch before we can
     * consider the server to be 'in-sync' with the client's active targets.
     */
    RemoteStore.prototype.recordPendingTargetRequest = function (targetId) {
        // For each request we get we need to record we need a response for it.
        this.pendingTargetResponses[targetId] = (this.pendingTargetResponses[targetId] || 0) + 1;
    };
    RemoteStore.prototype.startWatchStream = function () {
        assert(this.shouldStartWatchStream(), 'startWriteStream() called when shouldStartWatchStream() is false.');
        this.watchStream.start({
            onOpen: this.onWatchStreamOpen.bind(this),
            onClose: this.onWatchStreamClose.bind(this),
            onWatchChange: this.onWatchStreamChange.bind(this)
        });
    };
    /**
     * Returns whether the watch stream should be started because there are
     * active targets trying to be listened too
     */
    RemoteStore.prototype.shouldStartWatchStream = function () {
        return this.isNetworkEnabled() && !this.watchStream.isStarted() && !isEmpty(this.listenTargets);
    };
    RemoteStore.prototype.cleanUpWatchStreamState = function () {
        // If the connection is closed then we'll never get a snapshot version for
        // the accumulated changes and so we'll never be able to complete the batch.
        // When we start up again the server is going to resend these changes
        // anyway, so just toss the accumulated state.
        this.accumulatedWatchChanges = [];
        this.pendingTargetResponses = {};
    };
    RemoteStore.prototype.onWatchStreamOpen = function () {
        var _this = this;
        // TODO(b/35852690): close the stream again (with some timeout?) if no watch
        // targets are active
        forEachNumber(this.listenTargets, function (targetId, queryData) {
            _this.sendWatchRequest(queryData);
        });
        return Promise.resolve();
    };
    RemoteStore.prototype.onWatchStreamClose = function (error) {
        assert(this.isNetworkEnabled(), 'onWatchStreamClose() should only be called when the network is enabled');
        this.cleanUpWatchStreamState();
        // If there was an error, retry the connection.
        if (this.shouldStartWatchStream()) {
            this.updateOnlineStateAfterFailure();
            this.startWatchStream();
        } else {
            // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            this.setOnlineStateToUnknown();
        }
        return Promise.resolve();
    };
    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
        // Mark the connection as healthy because we got a message from the server
        this.setOnlineStateToHealthy();
        if (watchChange instanceof watch_change_WatchTargetChange && watchChange.state === WatchTargetChangeState.Removed && watchChange.cause) {
            // There was an error on a target, don't wait for a consistent snapshot
            // to raise events
            return this.handleTargetError(watchChange);
        }
        // Accumulate watch changes but don't process them if there's no
        // snapshotVersion or it's older than a previous snapshot we've processed
        // (can happen after we resume a target using a resume token).
        this.accumulatedWatchChanges.push(watchChange);
        if (!snapshotVersion.equals(snapshot_version_SnapshotVersion.MIN) && snapshotVersion.compareTo(this.localStore.getLastRemoteSnapshotVersion()) >= 0) {
            var changes = this.accumulatedWatchChanges;
            this.accumulatedWatchChanges = [];
            return this.handleWatchChangeBatch(snapshotVersion, changes);
        } else {
            return Promise.resolve();
        }
    };
    /**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */
    RemoteStore.prototype.handleWatchChangeBatch = function (snapshotVersion, changes) {
        var _this = this;
        var aggregator = new watch_change_WatchChangeAggregator(snapshotVersion, this.listenTargets, this.pendingTargetResponses);
        aggregator.addChanges(changes);
        var remoteEvent = aggregator.createRemoteEvent();
        // Get the new response counts from the aggregator
        this.pendingTargetResponses = aggregator.pendingTargetResponses;
        var promises = [];
        // Handle existence filters and existence filter mismatches.
        forEachNumber(aggregator.existenceFilters, function (targetId, filter) {
            var queryData = _this.listenTargets[targetId];
            if (!queryData) {
                // A watched target might have been removed already.
                return;
            }
            var query = queryData.query;
            if (query.isDocumentQuery()) {
                if (filter.count === 0) {
                    // The existence filter told us the document does not exist.
                    // We need to deduce that this document does not exist and apply
                    // a deleted document to our updates. Without applying a deleted
                    // document there might be another query that will raise this
                    // document as part of a snapshot until it is resolved,
                    // essentially exposing inconsistency between queries.
                    var key = new document_key_DocumentKey(query.path);
                    var deletedDoc = new document_NoDocument(key, snapshotVersion);
                    remoteEvent.addDocumentUpdate(deletedDoc);
                } else {
                    assert(filter.count === 1, 'Single document existence filter with count: ' + filter.count);
                }
            } else {
                // Not a document query.
                var promise = _this.localStore.remoteDocumentKeys(targetId).then(function (trackedRemote) {
                    if (remoteEvent.targetChanges[targetId]) {
                        var mapping = remoteEvent.targetChanges[targetId].mapping;
                        if (mapping !== null) {
                            if (mapping instanceof UpdateMapping) {
                                trackedRemote = mapping.applyToKeySet(trackedRemote);
                            } else {
                                assert(mapping instanceof ResetMapping, 'Expected either reset or update mapping but got something else: ' + mapping);
                                trackedRemote = mapping.documents;
                            }
                        }
                    }
                    if (trackedRemote.size !== filter.count) {
                        // Existence filter mismatch, resetting mapping.
                        // Make sure the mismatch is exposed in the remote event.
                        remoteEvent.handleExistenceFilterMismatch(targetId);
                        // Clear the resume token for the query, since we're in a
                        // known mismatch state.
                        var newQueryData = new query_data_QueryData(query, targetId, queryData.purpose);
                        _this.listenTargets[targetId] = newQueryData;
                        // Cause a hard reset by unwatching and rewatching
                        // immediately, but deliberately don't send a resume token
                        // so that we get a full update.
                        // Make sure we expect that this acks are going to happen.
                        _this.sendUnwatchRequest(targetId);
                        // Mark the query we send as being on behalf of an existence
                        // filter mismatch, but don't actually retain that in
                        // listenTargets. This ensures that we flag the first
                        // re-listen this way without impacting future listens of
                        // this target (that might happen e.g. on reconnect).
                        var requestQueryData = new query_data_QueryData(query, targetId, QueryPurpose.ExistenceFilterMismatch);
                        _this.sendWatchRequest(requestQueryData);
                    }
                });
                promises.push(promise);
            }
        });
        return Promise.all(promises).then(function () {
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
                if (change.resumeToken.length > 0) {
                    var queryData = _this.listenTargets[targetId];
                    // A watched target might have been removed already.
                    if (queryData) {
                        _this.listenTargets[targetId] = queryData.update({
                            resumeToken: change.resumeToken,
                            snapshotVersion: change.snapshotVersion
                        });
                    }
                }
            });
            // Finally handle remote event
            return _this.syncEngine.applyRemoteEvent(remoteEvent);
        });
    };
    /** Handles an error on a target */
    RemoteStore.prototype.handleTargetError = function (watchChange) {
        var _this = this;
        assert(!!watchChange.cause, 'Handling target error without a cause');
        var error = watchChange.cause;
        var promiseChain = Promise.resolve();
        watchChange.targetIds.forEach(function (targetId) {
            promiseChain = promiseChain.then(function () {
                if (contains(_this.listenTargets, targetId)) {
                    delete _this.listenTargets[targetId];
                    return _this.syncEngine.rejectListen(targetId, error);
                } else {
                    // A watched target might have been removed already.
                    return Promise.resolve();
                }
            });
        });
        return promiseChain;
    };
    RemoteStore.prototype.cleanUpWriteStreamState = function () {
        this.lastBatchSeen = BATCHID_UNKNOWN;
        this.pendingWrites = [];
    };
    /**
     * Notifies that there are new mutations to process in the queue. This is
     * typically called by SyncEngine after it has sent mutations to LocalStore.
     */
    RemoteStore.prototype.fillWritePipeline = function () {
        var _this = this;
        if (!this.canWriteMutations()) {
            return Promise.resolve();
        } else {
            return this.localStore.nextMutationBatch(this.lastBatchSeen).then(function (batch) {
                if (batch === null) {
                    if (_this.pendingWrites.length == 0) {
                        _this.writeStream.markIdle();
                    }
                    return Promise.resolve();
                } else {
                    _this.commit(batch);
                    return _this.fillWritePipeline();
                }
            });
        }
    };
    /**
     * Returns true if the backend can accept additional write requests.
     *
     * When sending mutations to the write stream (e.g. in fillWritePipeline),
     * call this method first to check if more mutations can be sent.
     *
     * Currently the only thing that can prevent the backend from accepting
     * write requests is if there are too many requests already outstanding. As
     * writes complete the backend will be able to accept more.
     */
    RemoteStore.prototype.canWriteMutations = function () {
        return this.isNetworkEnabled() && this.pendingWrites.length < MAX_PENDING_WRITES;
    };
    // For testing
    RemoteStore.prototype.outstandingWrites = function () {
        return this.pendingWrites.length;
    };
    /**
     * Given mutations to commit, actually commits them to the Datastore. Note
     * that this does *not* return a Promise specifically because the AsyncQueue
     * should not block operations for this.
     */
    RemoteStore.prototype.commit = function (batch) {
        assert(this.canWriteMutations(), "commit called when batches can't be written");
        this.lastBatchSeen = batch.batchId;
        this.pendingWrites.push(batch);
        if (this.shouldStartWriteStream()) {
            this.startWriteStream();
        } else if (this.isNetworkEnabled() && this.writeStream.handshakeComplete) {
            this.writeStream.writeMutations(batch.mutations);
        }
    };
    RemoteStore.prototype.shouldStartWriteStream = function () {
        return this.isNetworkEnabled() && !this.writeStream.isStarted() && this.pendingWrites.length > 0;
    };
    RemoteStore.prototype.startWriteStream = function () {
        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
        this.writeStream.start({
            onOpen: this.onWriteStreamOpen.bind(this),
            onClose: this.onWriteStreamClose.bind(this),
            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
            onMutationResult: this.onMutationResult.bind(this)
        });
    };
    RemoteStore.prototype.onWriteStreamOpen = function () {
        this.writeStream.writeHandshake();
        return Promise.resolve();
    };
    RemoteStore.prototype.onWriteHandshakeComplete = function () {
        var _this = this;
        // Record the stream token.
        return this.localStore.setLastStreamToken(this.writeStream.lastStreamToken).then(function () {
            // Drain any pending writes.
            //
            // Note that at this point pendingWrites contains mutations that
            // have already been accepted by fillWritePipeline/commitBatch. If
            // the pipeline is full, canWriteMutations will be false, despite
            // the fact that we actually need to send mutations over.
            //
            // This also means that this method indirectly respects the limits
            // imposed by canWriteMutations since writes can't be added to the
            // pendingWrites array when canWriteMutations is false. If the
            // limits imposed by canWriteMutations actually protect us from
            // DOSing ourselves then those limits won't be exceeded here and
            // we'll continue to make progress.
            for (var _i = 0, _a = _this.pendingWrites; _i < _a.length; _i++) {
                var batch = _a[_i];
                _this.writeStream.writeMutations(batch.mutations);
            }
        });
    };
    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
        var _this = this;
        // This is a response to a write containing mutations and should be
        // correlated to the first pending write.
        assert(this.pendingWrites.length > 0, 'Got result for empty pending writes');
        var batch = this.pendingWrites.shift();
        var success = mutation_batch_MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
        return this.syncEngine.applySuccessfulWrite(success).then(function () {
            // It's possible that with the completion of this mutation another
            // slot has freed up.
            return _this.fillWritePipeline();
        });
    };
    RemoteStore.prototype.onWriteStreamClose = function (error) {
        var _this = this;
        assert(this.isNetworkEnabled(), 'onWriteStreamClose() should only be called when the network is enabled');
        // If the write stream closed due to an error, invoke the error callbacks if
        // there are pending writes.
        if (error && this.pendingWrites.length > 0) {
            assert(!!error, 'We have pending writes, but the write stream closed without an error');
            // A promise that is resolved after we processed the error
            var errorHandling = void 0;
            if (this.writeStream.handshakeComplete) {
                // This error affects the actual write.
                errorHandling = this.handleWriteError(error);
            } else {
                // If there was an error before the handshake has finished, it's
                // possible that the server is unable to process the stream token
                // we're sending. (Perhaps it's too old?)
                errorHandling = this.handleHandshakeError(error);
            }
            return errorHandling.then(function () {
                // The write stream might have been started by refilling the write
                // pipeline for failed writes
                if (_this.shouldStartWriteStream()) {
                    _this.startWriteStream();
                }
            });
        } else {
            // No pending writes, nothing to do
            return Promise.resolve();
        }
    };
    RemoteStore.prototype.handleHandshakeError = function (error) {
        // Reset the token if it's a permanent error or the error code is
        // ABORTED, signaling the write stream is no longer valid.
        if (isPermanentError(error.code) || error.code === Code.ABORTED) {
            debug(remote_store_LOG_TAG, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
            this.writeStream.lastStreamToken = emptyByteString();
            return this.localStore.setLastStreamToken(emptyByteString());
        } else {
            // Some other error, don't reset stream token. Our stream logic will
            // just retry with exponential backoff.
            return Promise.resolve();
        }
    };
    RemoteStore.prototype.handleWriteError = function (error) {
        var _this = this;
        if (isPermanentError(error.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            var batch = this.pendingWrites.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            this.writeStream.inhibitBackoff();
            return this.syncEngine.rejectFailedWrite(batch.batchId, error).then(function () {
                // It's possible that with the completion of this mutation
                // another slot has freed up.
                return _this.fillWritePipeline();
            });
        } else {
            // Transient error, just let the retry logic kick in.
            return Promise.resolve();
        }
    };
    RemoteStore.prototype.createTransaction = function () {
        return new transaction_Transaction(this.datastore);
    };
    RemoteStore.prototype.handleUserChange = function (user) {
        debug(remote_store_LOG_TAG, 'RemoteStore changing users: uid=', user.uid);
        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
        // (since mutations are per-user).
        this.disableNetwork();
        return this.enableNetwork();
    };
    return RemoteStore;
}();


//# sourceMappingURL=remote_store.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/core/firestore_client.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */













var firestore_client_LOG_TAG = 'FirestoreClient';
/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */
var firestore_client_FirestoreClient = /** @class */function () {
    function FirestoreClient(platform, databaseInfo, credentials,
    /**
       * Asynchronous queue responsible for all of our internal processing. When
       * we get incoming work from the user (via public API) or the network
       * (incoming GRPC messages), we should always schedule onto this queue.
       * This ensures all of our work is properly serialized (e.g. we don't
       * start processing a new operation while the previous one is waiting for
       * an async I/O to complete).
       */
    asyncQueue) {
        this.platform = platform;
        this.databaseInfo = databaseInfo;
        this.credentials = credentials;
        this.asyncQueue = asyncQueue;
    }
    /**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param usePersistence Whether or not to attempt to enable persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */
    FirestoreClient.prototype.start = function (usePersistence) {
        var _this = this;
        // We defer our initialization until we get the current user from
        // setUserChangeListener(). We block the async queue until we got the
        // initial user and the initialization is completed. This will prevent
        // any scheduled work from happening before initialization is completed.
        //
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        var initializationDone = new Deferred();
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        //
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        var persistenceResult = new Deferred();
        var initialized = false;
        this.credentials.setUserChangeListener(function (user) {
            if (!initialized) {
                initialized = true;
                _this.initializePersistence(usePersistence, persistenceResult).then(function () {
                    return _this.initializeRest(user);
                }).then(initializationDone.resolve, initializationDone.reject);
            } else {
                _this.asyncQueue.schedule(function () {
                    return _this.handleUserChange(user);
                });
            }
        });
        // Block the async queue until initialization is done
        this.asyncQueue.schedule(function () {
            return initializationDone.promise;
        });
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return persistenceResult.promise;
    };
    /** Enables the network connection and requeues all pending operations. */
    FirestoreClient.prototype.enableNetwork = function () {
        var _this = this;
        return this.asyncQueue.schedule(function () {
            return _this.remoteStore.enableNetwork();
        });
    };
    /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param usePersistence indicates whether or not to use offline persistence
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */
    FirestoreClient.prototype.initializePersistence = function (usePersistence, persistenceResult) {
        var _this = this;
        if (usePersistence) {
            return this.startIndexedDbPersistence().then(persistenceResult.resolve).catch(function (error) {
                // Regardless of whether or not the retry succeeds, from an user
                // perspective, offline persistence has failed.
                persistenceResult.reject(error);
                // An unknown failure on the first stage shuts everything down.
                if (!_this.canFallback(error)) {
                    return Promise.reject(error);
                }
                console.warn('Error enabling offline storage. Falling back to' + ' storage disabled: ' + error);
                return _this.startMemoryPersistence();
            });
        } else {
            // When usePersistence == false, enabling offline persistence is defined
            // to unconditionally succeed. This allows start() to have the same
            // signature for both cases, despite the fact that the returned promise
            // is only used in the enablePersistence call.
            persistenceResult.resolve();
            return this.startMemoryPersistence();
        }
    };
    FirestoreClient.prototype.canFallback = function (error) {
        return error.code === Code.FAILED_PRECONDITION || error.code === Code.UNIMPLEMENTED;
    };
    /**
     * Starts IndexedDB-based persistence.
     *
     * @returns A promise indicating success or failure.
     */
    FirestoreClient.prototype.startIndexedDbPersistence = function () {
        // TODO(http://b/33384523): For now we just disable garbage collection
        // when persistence is enabled.
        this.garbageCollector = new no_op_garbage_collector_NoOpGarbageCollector();
        var storagePrefix = indexeddb_persistence_IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
        var serializer = new serializer_JsonProtoSerializer(this.databaseInfo.databaseId, {
            useProto3Json: true
        });
        this.persistence = new indexeddb_persistence_IndexedDbPersistence(storagePrefix, serializer);
        return this.persistence.start();
    };
    /**
     * Starts Memory-backed persistence. In practice this cannot fail.
     *
     * @returns A promise that will successfully resolve.
     */
    FirestoreClient.prototype.startMemoryPersistence = function () {
        this.garbageCollector = new eager_garbage_collector_EagerGarbageCollector();
        this.persistence = new memory_persistence_MemoryPersistence();
        return this.persistence.start();
    };
    /**
     * Initializes the rest of the FirestoreClient, assuming the initial user
     * has been obtained from the credential provider and some persistence
     * implementation is available in this.persistence.
     */
    FirestoreClient.prototype.initializeRest = function (user) {
        var _this = this;
        return this.platform.loadConnection(this.databaseInfo).then(function (connection) {
            _this.localStore = new local_store_LocalStore(_this.persistence, user, _this.garbageCollector);
            var serializer = _this.platform.newSerializer(_this.databaseInfo.databaseId);
            var datastore = new datastore_Datastore(_this.databaseInfo, _this.asyncQueue, connection, _this.credentials, serializer);
            var onlineStateChangedHandler = function onlineStateChangedHandler(onlineState) {
                _this.eventMgr.onOnlineStateChanged(onlineState);
            };
            _this.remoteStore = new remote_store_RemoteStore(_this.databaseInfo, _this.asyncQueue, _this.localStore, datastore, onlineStateChangedHandler);
            _this.syncEngine = new sync_engine_SyncEngine(_this.localStore, _this.remoteStore, user);
            // Setup wiring between sync engine and remote store
            _this.remoteStore.syncEngine = _this.syncEngine;
            _this.eventMgr = new event_manager_EventManager(_this.syncEngine);
            // NOTE: RemoteStore depends on LocalStore (for persisting stream
            // tokens, refilling mutation queue, etc.) so must be started after
            // LocalStore.
            return _this.localStore.start();
        }).then(function () {
            return _this.remoteStore.start();
        });
    };
    FirestoreClient.prototype.handleUserChange = function (user) {
        this.asyncQueue.verifyOperationInProgress();
        debug(firestore_client_LOG_TAG, 'User Changed: ' + user.uid);
        return this.syncEngine.handleUserChange(user);
    };
    /** Disables the network connection. Pending operations will not complete. */
    FirestoreClient.prototype.disableNetwork = function () {
        var _this = this;
        return this.asyncQueue.schedule(function () {
            return _this.remoteStore.disableNetwork();
        });
    };
    FirestoreClient.prototype.shutdown = function () {
        var _this = this;
        return this.asyncQueue.schedule(function () {
            _this.credentials.removeUserChangeListener();
            return _this.remoteStore.shutdown();
        }).then(function () {
            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
            return _this.persistence.shutdown();
        });
    };
    FirestoreClient.prototype.listen = function (query, observer, options) {
        var _this = this;
        var listener = new event_manager_QueryListener(query, observer, options);
        this.asyncQueue.schedule(function () {
            return _this.eventMgr.listen(listener);
        });
        return listener;
    };
    FirestoreClient.prototype.unlisten = function (listener) {
        var _this = this;
        this.asyncQueue.schedule(function () {
            return _this.eventMgr.unlisten(listener);
        });
    };
    FirestoreClient.prototype.write = function (mutations) {
        var _this = this;
        var deferred = new Deferred();
        this.asyncQueue.schedule(function () {
            return _this.syncEngine.write(mutations, deferred);
        });
        return deferred.promise;
    };
    FirestoreClient.prototype.databaseId = function () {
        return this.databaseInfo.databaseId;
    };
    FirestoreClient.prototype.transaction = function (updateFunction) {
        var _this = this;
        // We have to wait for the async queue to be sure syncEngine is initialized.
        return this.asyncQueue.schedule(function () {
            return Promise.resolve();
        }).then(function () {
            return _this.syncEngine.runTransaction(updateFunction);
        });
    };
    return FirestoreClient;
}();


//# sourceMappingURL=firestore_client.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/async_observer.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */
var AsyncObserver = /** @class */function () {
    function AsyncObserver(observer) {
        this.observer = observer;
        /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */
        this.muted = false;
    }
    AsyncObserver.prototype.next = function (value) {
        this.scheduleEvent(this.observer.next, value);
    };
    AsyncObserver.prototype.error = function (error) {
        this.scheduleEvent(this.observer.error, error);
    };
    AsyncObserver.prototype.mute = function () {
        this.muted = true;
    };
    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
        var _this = this;
        if (!this.muted) {
            setTimeout(function () {
                if (!_this.muted) {
                    eventHandler(event);
                }
            }, 0);
        }
    };
    return AsyncObserver;
}();


//# sourceMappingURL=async_observer.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/util/async_queue.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var async_queue_AsyncQueue = /** @class */function () {
    function AsyncQueue() {
        // The last promise in the queue.
        this.tail = Promise.resolve();
        // A list with timeout handles and their respective deferred promises.
        // Contains an entry for each operation that is queued to run in the future
        // (i.e. it has a delay that has not yet elapsed). Prior to cleanup, this list
        // may also contain entries that have already been run (in which case `handle` is
        // null).
        this.delayedOperations = [];
        // The number of operations that are queued to be run in the future (i.e. they
        // have a delay that has not yet elapsed). Unlike `delayedOperations`, this
        // is guaranteed to only contain operations that have not yet been run.
        //
        // Visible for testing.
        this.delayedOperationsCount = 0;
        // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.operationInProgress = false;
    }
    /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     *
     * Can optionally specify a delay (in milliseconds) to wait before queuing the
     * operation.
     */
    AsyncQueue.prototype.schedule = function (op, delay) {
        var _this = this;
        if (this.failure) {
            fail('AsyncQueue is already failed: ' + (this.failure.stack || this.failure.message));
        }
        if ((delay || 0) > 0) {
            this.delayedOperationsCount++;
            var delayedOp_1 = {
                handle: null,
                op: op,
                deferred: new Deferred()
            };
            delayedOp_1.handle = setTimeout(function () {
                _this.scheduleInternal(function () {
                    return delayedOp_1.op().then(function (result) {
                        delayedOp_1.deferred.resolve(result);
                    });
                });
                delayedOp_1.handle = null;
                _this.delayedOperationsCount--;
                if (_this.delayedOperationsCount === 0) {
                    _this.delayedOperations = [];
                }
            }, delay);
            this.delayedOperations.push(delayedOp_1);
            return delayedOp_1.deferred.promise;
        } else {
            return this.scheduleInternal(op);
        }
    };
    AsyncQueue.prototype.scheduleInternal = function (op) {
        var _this = this;
        this.tail = this.tail.then(function () {
            _this.operationInProgress = true;
            return op().catch(function (error) {
                _this.failure = error;
                _this.operationInProgress = false;
                var message = error.stack || error.message || '';
                log_error('INTERNAL UNHANDLED ERROR: ', message);
                // Escape the promise chain and throw the error globally so that
                // e.g. any global crash reporting library detects and reports it.
                // (but not for simulated errors in our tests since this breaks mocha)
                if (message.indexOf('Firestore Test Simulated Error') < 0) {
                    setTimeout(function () {
                        throw error;
                    }, 0);
                }
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw error;
            }).then(function () {
                _this.operationInProgress = false;
            });
        });
        return this.tail;
    };
    /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */
    AsyncQueue.prototype.verifyOperationInProgress = function () {
        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
    };
    /**
     * Waits until all currently scheduled tasks are finished executing. Tasks
     * scheduled with a delay can be rejected or queued for immediate execution.
     */
    AsyncQueue.prototype.drain = function (executeDelayedTasks) {
        var _this = this;
        this.delayedOperations.forEach(function (entry) {
            if (entry.handle) {
                clearTimeout(entry.handle);
                if (executeDelayedTasks) {
                    _this.scheduleInternal(entry.op).then(entry.deferred.resolve, entry.deferred.reject);
                } else {
                    entry.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled by shutdown'));
                }
            }
        });
        this.delayedOperations = [];
        this.delayedOperationsCount = 0;
        return this.schedule(function () {
            return Promise.resolve();
        });
    };
    return AsyncQueue;
}();


//# sourceMappingURL=async_queue.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/auth/user.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */
var User = /** @class */function () {
    function User(uid) {
        this.uid = uid;
    }
    User.prototype.isUnauthenticated = function () {
        return this.uid == null;
    };
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */
    User.prototype.toKey = function () {
        if (this.isUnauthenticated()) {
            return 'anonymous-user';
        } else {
            return 'uid:' + this.uid;
        }
    };
    User.prototype.equals = function (otherUser) {
        return otherUser.uid === this.uid;
    };
    /** A user with a null UID. */
    User.UNAUTHENTICATED = new User(null);
    // TODO(mikelehen): Look into getting a proper uid-equivalent for
    // non-FirebaseAuth providers.
    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
    User.FIRST_PARTY = new User('first-party-uid');
    return User;
}();


//# sourceMappingURL=user.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/credentials.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var OAuthToken = /** @class */function () {
    function OAuthToken(value, user) {
        this.user = user;
        this.type = 'OAuth';
        this.authHeaders = { Authorization: "Bearer " + value };
    }
    return OAuthToken;
}();

/** A CredentialsProvider that always yields an empty token. */
var credentials_EmptyCredentialsProvider = /** @class */function () {
    function EmptyCredentialsProvider() {
        /**
         * Stores the User listener registered with setUserChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */
        this.userListener = null;
    }
    EmptyCredentialsProvider.prototype.getToken = function (forceRefresh) {
        return Promise.resolve(null);
    };
    EmptyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
        assert(!this.userListener, 'Can only call setUserChangeListener() once.');
        this.userListener = listener;
        // Fire with initial user.
        listener(User.UNAUTHENTICATED);
    };
    EmptyCredentialsProvider.prototype.removeUserChangeListener = function () {
        assert(this.userListener !== null, 'removeUserChangeListener() when no listener registered');
        this.userListener = null;
    };
    return EmptyCredentialsProvider;
}();

var credentials_FirebaseCredentialsProvider = /** @class */function () {
    function FirebaseCredentialsProvider(app) {
        var _this = this;
        this.app = app;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */
        this.tokenListener = null;
        /**
         * Counter used to detect if the user changed while a getToken request was
         * outstanding.
         */
        this.userCounter = 0;
        /** The User listener registered with setUserChangeListener(). */
        this.userListener = null;
        // We listen for token changes but all we really care about is knowing when
        // the uid may have changed.
        this.tokenListener = function () {
            var newUser = _this.getUser();
            if (!_this.currentUser || !newUser.equals(_this.currentUser)) {
                _this.currentUser = newUser;
                _this.userCounter++;
                if (_this.userListener) {
                    _this.userListener(_this.currentUser);
                }
            }
        };
        this.userCounter = 0;
        // Will fire at least once where we set this.currentUser
        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
    }
    FirebaseCredentialsProvider.prototype.getToken = function (forceRefresh) {
        var _this = this;
        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
        // Take note of the current value of the userCounter so that this method can
        // fail (with an ABORTED error) if there is a user change while the request
        // is outstanding.
        var initialUserCounter = this.userCounter;
        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
            // Cancel the request since the user changed while the request was
            // outstanding so the response is likely for a previous user (which
            // user, we can't be sure).
            if (_this.userCounter !== initialUserCounter) {
                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to uid change.');
            } else {
                if (tokenData) {
                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
                } else {
                    return null;
                }
            }
        });
    };
    FirebaseCredentialsProvider.prototype.setUserChangeListener = function (listener) {
        assert(!this.userListener, 'Can only call setUserChangeListener() once.');
        this.userListener = listener;
        // Fire the initial event, but only if we received the initial user
        if (this.currentUser) {
            listener(this.currentUser);
        }
    };
    FirebaseCredentialsProvider.prototype.removeUserChangeListener = function () {
        assert(this.tokenListener != null, 'removeUserChangeListener() called twice');
        assert(this.userListener !== null, 'removeUserChangeListener() called when no listener registered');
        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
        this.tokenListener = null;
        this.userListener = null;
    };
    FirebaseCredentialsProvider.prototype.getUser = function () {
        // TODO(mikelehen): Remove this check once we're shipping with firebase.js.
        if (typeof this.app.INTERNAL.getUid !== 'function') {
            fail('This version of the Firestore SDK requires at least version' + ' 3.7.0 of firebase.js.');
        }
        var currentUid = this.app.INTERNAL.getUid();
        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
        return new User(currentUid);
    };
    return FirebaseCredentialsProvider;
}();

// Wrap a google-auth-library client as a CredentialsProvider.
// NOTE: grpc-connection can natively accept a google-auth-library
// client via createFromGoogleCredential(), but we opt to plumb the tokens
// through our CredentialsProvider interface, at least for now.
var credentials_GoogleCredentialsProvider = /** @class */function () {
    function GoogleCredentialsProvider(authClient) {
        this.authClient = authClient;
    }
    GoogleCredentialsProvider.prototype.getToken = function (forceRefresh) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // TODO(b/32935141): ideally this would be declared as an extern
            _this.authClient['getAccessToken'](function (error, tokenLiteral) {
                if (error) {
                    reject(error);
                } else {
                    resolve(new OAuthToken(tokenLiteral, User.GOOGLE_CREDENTIALS));
                }
            });
        });
    };
    // NOTE: A google-auth-library client represents an immutable "user", so
    // once we fire the initial event, it'll never change.
    GoogleCredentialsProvider.prototype.setUserChangeListener = function (listener) {
        // Fire with initial uid.
        listener(User.GOOGLE_CREDENTIALS);
    };
    GoogleCredentialsProvider.prototype.removeUserChangeListener = function () {};
    return GoogleCredentialsProvider;
}();

/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * TODO(b/33147818) this implementation violates the current assumption that
 * tokens are immutable.  We need to either revisit this assumption or come
 * up with some way for FPA to use the listen/unlisten interface.
 */
var credentials_FirstPartyToken = /** @class */function () {
    function FirstPartyToken(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        this.type = 'FirstParty';
        this.user = User.FIRST_PARTY;
        assert(this.gapi && this.gapi['auth'] && this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
    }
    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
        get: function get() {
            return {
                Authorization: this.gapi['auth']['getAuthHeaderValueForFirstParty']([]),
                'X-Goog-AuthUser': this.sessionIndex
            };
        },
        enumerable: true,
        configurable: true
    });
    return FirstPartyToken;
}();

/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */
var credentials_FirstPartyCredentialsProvider = /** @class */function () {
    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        assert(this.gapi && this.gapi['auth'] && this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
    }
    FirstPartyCredentialsProvider.prototype.getToken = function (forceRefresh) {
        return Promise.resolve(new credentials_FirstPartyToken(this.gapi, this.sessionIndex));
    };
    // TODO(33108925): can someone switch users w/o a page refresh?
    // TODO(33110621): need to understand token/session lifecycle
    FirstPartyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
        // Fire with initial uid.
        listener(User.FIRST_PARTY);
    };
    FirstPartyCredentialsProvider.prototype.removeUserChangeListener = function () {};
    return FirstPartyCredentialsProvider;
}();

/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */
function makeCredentialsProvider(credentials) {
    if (!credentials) {
        return new credentials_EmptyCredentialsProvider();
    }
    switch (credentials.type) {
        case 'google-auth':
            return new credentials_GoogleCredentialsProvider(credentials.client);
        case 'gapi':
            return new credentials_FirstPartyCredentialsProvider(credentials.client, credentials.sessionIndex || '0');
        case 'provider':
            return credentials.client;
        default:
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
    }
}

//# sourceMappingURL=credentials.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/observer.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isPartialObserver(obj) {
    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    var object = obj;
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in object && typeof object[method] === 'function') {
            return true;
        }
    }
    return false;
}

//# sourceMappingURL=observer.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/field_value.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var api_field_value___extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */
// tslint:disable-next-line:class-as-namespace  We use this as a base class.
var FieldValueImpl = /** @class */function () {
    function FieldValueImpl() {}
    FieldValueImpl.delete = function () {
        return DeleteFieldValueImpl.instance;
    };
    FieldValueImpl.serverTimestamp = function () {
        return ServerTimestampFieldValueImpl.instance;
    };
    return FieldValueImpl;
}();

var DeleteFieldValueImpl = /** @class */function (_super) {
    api_field_value___extends(DeleteFieldValueImpl, _super);
    function DeleteFieldValueImpl() {
        return _super.call(this) || this;
    }
    /** Singleton instance. */
    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
    return DeleteFieldValueImpl;
}(FieldValueImpl);

var ServerTimestampFieldValueImpl = /** @class */function (_super) {
    api_field_value___extends(ServerTimestampFieldValueImpl, _super);
    function ServerTimestampFieldValueImpl() {
        return _super.call(this) || this;
    }
    /** Singleton instance. */
    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
    return ServerTimestampFieldValueImpl;
}(FieldValueImpl);

// Public instance that disallows construction at runtime. This constructor is
// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
// be called FieldValue publicly. Internally we still use FieldValueImpl which
// has a type-checked private constructor. Note that FieldValueImpl and
// PublicFieldValue can be used interchangeably in instanceof checks.
// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
// and so we need to use FieldValueImpl as type and export it too.
// tslint:disable-next-line:variable-name  We treat this as a class name.
var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');

//# sourceMappingURL=field_value.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/user_data_converter.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
















var RESERVED_FIELD_REGEX = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */
var user_data_converter_ParsedSetData = /** @class */function () {
    function ParsedSetData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedSetData.prototype.toMutations = function (key, precondition) {
        var mutations = [];
        if (this.fieldMask !== null) {
            mutations.push(new mutation_PatchMutation(key, this.data, this.fieldMask, precondition));
        } else {
            mutations.push(new mutation_SetMutation(key, this.data, precondition));
        }
        if (this.fieldTransforms.length > 0) {
            mutations.push(new mutation_TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedSetData;
}();

/** The result of parsing "update" data (i.e. for an updateData call). */
var user_data_converter_ParsedUpdateData = /** @class */function () {
    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
        var mutations = [new mutation_PatchMutation(key, this.data, this.fieldMask, precondition)];
        if (this.fieldTransforms.length > 0) {
            mutations.push(new mutation_TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedUpdateData;
}();

/*
 * Represents what type of API method provided the data being parsed; useful
 * for determining which error conditions apply during parsing and providing
 * better error messages.
 */
var UserDataSource;
(function (UserDataSource) {
    UserDataSource[UserDataSource["Set"] = 0] = "Set";
    UserDataSource[UserDataSource["Update"] = 1] = "Update";
    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
    UserDataSource[UserDataSource["QueryValue"] = 3] = "QueryValue"; // from a where clause or cursor bound
})(UserDataSource || (UserDataSource = {}));
function isWrite(dataSource) {
    switch (dataSource) {
        case UserDataSource.Set: // fall through
        case UserDataSource.MergeSet: // fall through
        case UserDataSource.Update:
            return true;
        case UserDataSource.QueryValue:
            return false;
        default:
            throw fail("Unexpected case for UserDataSource: " + dataSource);
    }
}
/** A "context" object passed around while parsing user data. */
var user_data_converter_ParseContext = /** @class */function () {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param dataSource Indicates what kind of API method this data came from.
     * @param methodName The name of the method the user called to create this
     *     ParseContext.
     * @param path A path within the object being parsed. This could be an empty
     *     path (in which case the context represents the root of the data being
     *     parsed), or a nonempty path (indicating the context represents a nested
     *     location within the data).
     * @param arrayElement Whether or not this context corresponds to an element
     *     of an array.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */
    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
        this.dataSource = dataSource;
        this.methodName = methodName;
        this.path = path;
        this.arrayElement = arrayElement;
        // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        if (fieldTransforms === undefined) {
            this.validatePath();
        }
        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
        this.fieldTransforms = fieldTransforms || [];
        this.fieldMask = fieldMask || [];
    }
    ParseContext.prototype.childContextForField = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath,
        /*arrayElement=*/false, this.fieldTransforms, this.fieldMask);
        context.validatePathSegment(field);
        return context;
    };
    ParseContext.prototype.childContextForFieldPath = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath,
        /*arrayElement=*/false, this.fieldTransforms, this.fieldMask);
        context.validatePath();
        return context;
    };
    ParseContext.prototype.childContextForArray = function (index) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // null.
        return new ParseContext(this.dataSource, this.methodName,
        /*path=*/null,
        /*arrayElement=*/true, this.fieldTransforms, this.fieldMask);
    };
    ParseContext.prototype.createError = function (reason) {
        var fieldDescription = this.path === null || this.path.isEmpty() ? '' : " (found in field " + this.path.toString() + ")";
        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " + reason + fieldDescription);
    };
    ParseContext.prototype.validatePath = function () {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path === null) {
            return;
        }
        for (var i = 0; i < this.path.length; i++) {
            this.validatePathSegment(this.path.get(i));
        }
    };
    ParseContext.prototype.validatePathSegment = function (segment) {
        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
            throw this.createError('Document fields cannot begin and end with __');
        }
    };
    ParseContext.prototype.isWrite = function () {
        return this.dataSource === UserDataSource.Set || this.dataSource === UserDataSource.Update;
    };
    return ParseContext;
}();
/**
 * A placeholder object for DocumentReferences in this file, in order to
 * avoid a circular dependency. See the comments for `DataPreConverter` for
 * the full context.
 */
var DocumentKeyReference = /** @class */function () {
    function DocumentKeyReference(databaseId, key) {
        this.databaseId = databaseId;
        this.key = key;
    }
    return DocumentKeyReference;
}();

/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */
var user_data_converter_UserDataConverter = /** @class */function () {
    function UserDataConverter(preConverter) {
        this.preConverter = preConverter;
    }
    /** Parse document data from a non-merge set() call.*/
    UserDataConverter.prototype.parseSetData = function (methodName, input) {
        var context = new user_data_converter_ParseContext(UserDataSource.Set, methodName, path_FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        return new user_data_converter_ParsedSetData(updateData,
        /* fieldMask= */null, context.fieldTransforms);
    };
    /** Parse document data from a set() call with '{merge:true}'. */
    UserDataConverter.prototype.parseMergeData = function (methodName, input) {
        var context = new user_data_converter_ParseContext(UserDataSource.MergeSet, methodName, path_FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        var fieldMask = new mutation_FieldMask(context.fieldMask);
        return new user_data_converter_ParsedSetData(updateData, fieldMask, context.fieldTransforms);
    };
    /** Parse update data from an update() call. */
    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
        var _this = this;
        var context = new user_data_converter_ParseContext(UserDataSource.Update, methodName, path_FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var fieldMaskPaths = [];
        var updateData = field_value_ObjectValue.EMPTY;
        forEach(input, function (key, value) {
            var path = fieldPathFromDotSeparatedString(methodName, key);
            var childContext = context.childContextForFieldPath(path);
            value = _this.runPreConverter(value, childContext);
            if (value instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths.push(path);
            } else {
                var parsedValue = _this.parseData(value, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths.push(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        });
        var mask = new mutation_FieldMask(fieldMaskPaths);
        return new user_data_converter_ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /** Parse update data from a list of field/value arguments. */
    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
        var context = new user_data_converter_ParseContext(UserDataSource.Update, methodName, path_FieldPath.EMPTY_PATH);
        var keys = [fieldPathFromArgument(methodName, field)];
        var values = [value];
        if (moreFieldsAndValues.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " + 'of arguments that alternate between field names and values.');
        }
        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
            values.push(moreFieldsAndValues[i + 1]);
        }
        var fieldMaskPaths = [];
        var updateData = field_value_ObjectValue.EMPTY;
        for (var i = 0; i < keys.length; ++i) {
            var path = keys[i];
            var childContext = context.childContextForFieldPath(path);
            var value_1 = this.runPreConverter(values[i], childContext);
            if (value_1 instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths.push(path);
            } else {
                var parsedValue = this.parseData(value_1, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths.push(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        }
        var mask = new mutation_FieldMask(fieldMaskPaths);
        return new user_data_converter_ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     */
    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
        var context = new user_data_converter_ParseContext(UserDataSource.QueryValue, methodName, path_FieldPath.EMPTY_PATH);
        var parsed = this.parseData(input, context);
        assert(parsed != null, 'Parsed data should not be null.');
        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
        return parsed;
    };
    /** Sends data through this.preConverter, handling any thrown errors. */
    UserDataConverter.prototype.runPreConverter = function (input, context) {
        try {
            return this.preConverter(input);
        } catch (e) {
            var message = errorMessage(e);
            throw context.createError(message);
        }
    };
    /**
     * Internal helper for parsing user data.
     *
     * @param input Data to be parsed.
     * @param context A context object representing the current path being parsed,
     * the source of the data being parsed, etc.
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */
    UserDataConverter.prototype.parseData = function (input, context) {
        input = this.runPreConverter(input, context);
        if (input instanceof Array) {
            // TODO(b/34871131): Include the path containing the array in the error
            // message.
            if (context.arrayElement) {
                throw context.createError('Nested arrays are not supported');
            }
            // If context.path is null we are already inside an array and we don't
            // support field mask paths more granular than the top-level array.
            if (context.path) {
                context.fieldMask.push(context.path);
            }
            return this.parseArray(input, context);
        } else if (looksLikeJsonObject(input)) {
            validatePlainObject('Unsupported field value:', context, input);
            return this.parseObject(input, context);
        } else {
            // If context.path is null, we are inside an array and we should have
            // already added the root of the array to the field mask.
            if (context.path) {
                context.fieldMask.push(context.path);
            }
            return this.parseScalarValue(input, context);
        }
    };
    UserDataConverter.prototype.parseArray = function (array, context) {
        var result = [];
        var entryIndex = 0;
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var entry = array_1[_i];
            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
            if (parsedEntry == null) {
                // Just include nulls in the array for fields being replaced with a
                // sentinel.
                parsedEntry = NullValue.INSTANCE;
            }
            result.push(parsedEntry);
            entryIndex++;
        }
        return new field_value_ArrayValue(result);
    };
    UserDataConverter.prototype.parseObject = function (obj, context) {
        var _this = this;
        var result = new sorted_map_SortedMap(primitiveComparator);
        forEach(obj, function (key, val) {
            var parsedValue = _this.parseData(val, context.childContextForField(key));
            if (parsedValue != null) {
                result = result.insert(key, parsedValue);
            }
        });
        return new field_value_ObjectValue(result);
    };
    /**
     * Helper to parse a scalar value (i.e. not an Object or Array)
     *
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */
    UserDataConverter.prototype.parseScalarValue = function (value, context) {
        if (value === null) {
            return NullValue.INSTANCE;
        } else if (typeof value === 'number') {
            if (isSafeInteger(value)) {
                return new IntegerValue(value);
            } else {
                return new DoubleValue(value);
            }
        } else if (typeof value === 'boolean') {
            return field_value_BooleanValue.of(value);
        } else if (typeof value === 'string') {
            return new field_value_StringValue(value);
        } else if (value instanceof Date) {
            return new TimestampValue(timestamp_Timestamp.fromDate(value));
        } else if (value instanceof geo_point_GeoPoint) {
            return new GeoPointValue(value);
        } else if (value instanceof blob_Blob) {
            return new BlobValue(value);
        } else if (value instanceof DocumentKeyReference) {
            return new field_value_RefValue(value.databaseId, value.key);
        } else if (value instanceof FieldValueImpl) {
            if (value instanceof DeleteFieldValueImpl) {
                if (context.dataSource == UserDataSource.MergeSet) {
                    return null;
                } else if (context.dataSource === UserDataSource.Update) {
                    assert(context.path == null || context.path.length > 0, 'FieldValue.delete() at the top level should have already' + ' been handled.');
                    throw context.createError('FieldValue.delete() can only appear at the top level ' + 'of your update data');
                } else {
                    // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
                    throw context.createError('FieldValue.delete() can only be used with update() and set() with {merge:true}');
                }
            } else if (value instanceof ServerTimestampFieldValueImpl) {
                if (!isWrite(context.dataSource)) {
                    throw context.createError('FieldValue.serverTimestamp() can only be used with set()' + ' and update()');
                }
                if (context.path === null) {
                    throw context.createError('FieldValue.serverTimestamp() is not currently' + ' supported inside arrays');
                }
                context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
                // Return null so this value is omitted from the parsed result.
                return null;
            } else {
                return fail('Unknown FieldValue type: ' + value);
            }
        } else {
            throw context.createError("Unsupported field value: " + valueDescription(value));
        }
    };
    return UserDataConverter;
}();

/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */
function looksLikeJsonObject(input) {
    return typeof input === 'object' && input !== null && !(input instanceof Array) && !(input instanceof Date) && !(input instanceof geo_point_GeoPoint) && !(input instanceof blob_Blob) && !(input instanceof DocumentKeyReference) && !(input instanceof FieldValueImpl);
}
function validatePlainObject(message, context, input) {
    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
        var description = valueDescription(input);
        if (description === 'an object') {
            // Massage the error if it was an object.
            throw context.createError(message + ' a custom object');
        } else {
            throw context.createError(message + ' ' + description);
        }
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */
function fieldPathFromArgument(methodName, path) {
    if (path instanceof field_path_FieldPath) {
        return path._internalPath;
    } else if (typeof path === 'string') {
        return fieldPathFromDotSeparatedString(methodName, path);
    } else {
        var message = 'Field path arguments must be of type string or FieldPath.';
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */
function fieldPathFromDotSeparatedString(methodName, path) {
    try {
        return fromDotSeparatedString(path)._internalPath;
    } catch (e) {
        var message = errorMessage(e);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */
function errorMessage(error) {
    return error instanceof Error ? error.message : error.toString();
}

//# sourceMappingURL=user_data_converter.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/api/database.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var database___extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
























// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
var DEFAULT_HOST = 'firestore.googleapis.com';
var DEFAULT_SSL = true;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied firestore.Settings object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */
var database_FirestoreSettings = /** @class */function () {
    function FirestoreSettings(settings) {
        if (settings.host === undefined) {
            if (settings.ssl !== undefined) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            }
            this.host = DEFAULT_HOST;
            this.ssl = DEFAULT_SSL;
        } else {
            validateNamedType('settings', 'string', 'host', settings.host);
            this.host = settings.host;
            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
        }
        validateOptionNames('settings', settings, ['host', 'ssl', 'credentials']);
        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
        this.credentials = settings.credentials;
    }
    FirestoreSettings.prototype.equals = function (other) {
        return this.host === other.host && this.ssl === other.ssl && this.credentials === other.credentials;
    };
    return FirestoreSettings;
}();
var FirestoreConfig = /** @class */function () {
    function FirestoreConfig() {}
    return FirestoreConfig;
}();
/**
 * The root reference to the database.
 */
var database_Firestore = /** @class */function () {
    function Firestore(databaseIdOrApp) {
        var _this = this;
        this._queue = new async_queue_AsyncQueue();
        this.INTERNAL = {
            delete: function _delete() {
                if (_this._firestoreClient) {
                    return _this._firestoreClient.shutdown();
                } else {
                    return Promise.resolve();
                }
            },
            // Exposed via INTERNAL for use in tests.
            disableNetwork: function disableNetwork() {
                return _this._firestoreClient.disableNetwork();
            },
            enableNetwork: function enableNetwork() {
                return _this._firestoreClient.enableNetwork();
            },
            drainAsyncQueue: function drainAsyncQueue(executeDelayedTasks) {
                return _this._queue.drain(executeDelayedTasks);
            }
        };
        var config = new FirestoreConfig();
        if (typeof databaseIdOrApp.options === 'object') {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var app = databaseIdOrApp;
            config.firebaseApp = app;
            config.databaseId = Firestore.databaseIdFromApp(app);
            config.persistenceKey = config.firebaseApp.name;
            config.credentials = new credentials_FirebaseCredentialsProvider(app);
        } else {
            var external_1 = databaseIdOrApp;
            if (!external_1.projectId) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
            }
            config.databaseId = new database_info_DatabaseId(external_1.projectId, external_1.database);
            // Use a default persistenceKey that lines up with FirebaseApp.
            config.persistenceKey = '[DEFAULT]';
            config.credentials = new credentials_EmptyCredentialsProvider();
        }
        config.settings = new database_FirestoreSettings({});
        this._config = config;
        this._databaseId = config.databaseId;
    }
    Firestore.prototype.settings = function (settingsLiteral) {
        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
        if (contains(settingsLiteral, 'persistence')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' + 'firestore.enablePersistence().');
        }
        var newSettings = new database_FirestoreSettings(settingsLiteral);
        if (this._firestoreClient && !this._config.settings.equals(newSettings)) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' + 'be changed. You can only call settings() before calling any other ' + 'methods on a Firestore object.');
        }
        this._config.settings = newSettings;
        if (newSettings.credentials !== undefined) {
            this._config.credentials = makeCredentialsProvider(newSettings.credentials);
        }
    };
    Firestore.prototype.enablePersistence = function () {
        if (this._firestoreClient) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' + 'be enabled. You can only call enablePersistence() before calling ' + 'any other methods on a Firestore object.');
        }
        return this.configureClient( /* persistence= */true);
    };
    Firestore.prototype.ensureClientConfigured = function () {
        if (!this._firestoreClient) {
            this.configureClient( /* persistence= */false);
        }
        return this._firestoreClient;
    };
    Firestore.prototype.configureClient = function (persistence) {
        var _this = this;
        assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
        assert(!this._firestoreClient, 'configureClient() called multiple times');
        var databaseInfo = new DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl);
        var preConverter = function preConverter(value) {
            if (value instanceof database_DocumentReference) {
                var thisDb = _this._config.databaseId;
                var otherDb = value.firestore._config.databaseId;
                if (!otherDb.equals(thisDb)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' + (otherDb.projectId + "/" + otherDb.database + " but should be ") + ("for database " + thisDb.projectId + "/" + thisDb.database));
                }
                return new DocumentKeyReference(_this._config.databaseId, value._key);
            } else {
                return value;
            }
        };
        this._dataConverter = new user_data_converter_UserDataConverter(preConverter);
        this._firestoreClient = new firestore_client_FirestoreClient(platform_PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
        return this._firestoreClient.start(persistence);
    };
    Firestore.databaseIdFromApp = function (app) {
        var options = app.options;
        if (!contains(options, 'projectId')) {
            // TODO(b/62673263): We can safely remove the special handling of
            // 'firestoreId' once alpha testers have upgraded.
            if (contains(options, 'firestoreId')) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, '"firestoreId" is now specified as "projectId" in ' + 'firebase.initializeApp.');
            }
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        }
        if (contains(options, 'firestoreOptions')) {
            // TODO(b/62673263): We can safely remove the special handling of
            // 'firestoreOptions' once alpha testers have upgraded.
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"firestoreOptions" values are now specified with ' + 'Firestore.settings()');
        }
        var projectId = options['projectId'];
        if (!projectId || typeof projectId !== 'string') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
        }
        return new database_info_DatabaseId(projectId);
    };
    Object.defineProperty(Firestore.prototype, "app", {
        get: function get() {
            if (!this._config.firebaseApp) {
                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " + 'not available');
            }
            return this._config.firebaseApp;
        },
        enumerable: true,
        configurable: true
    });
    Firestore.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
        validateArgType('Firestore.collection', 'string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection path to collection()');
        }
        this.ensureClientConfigured();
        return new database_CollectionReference(path_ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.doc = function (pathString) {
        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
        validateArgType('Firestore.doc', 'string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty document path to doc()');
        }
        this.ensureClientConfigured();
        return database_DocumentReference.forPath(path_ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.runTransaction = function (updateFunction) {
        var _this = this;
        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
        return this.ensureClientConfigured().transaction(function (transaction) {
            return updateFunction(new database_Transaction(_this, transaction));
        });
    };
    Firestore.prototype.batch = function () {
        this.ensureClientConfigured();
        return new database_WriteBatch(this);
    };
    Object.defineProperty(Firestore, "logLevel", {
        get: function get() {
            switch (getLogLevel()) {
                case LogLevel.DEBUG:
                    return 'debug';
                case LogLevel.ERROR:
                    return 'error';
                case LogLevel.SILENT:
                    return 'silent';
                default:
                    return fail('Unknown log level: ' + getLogLevel());
            }
        },
        enumerable: true,
        configurable: true
    });
    Firestore.setLogLevel = function (level) {
        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
        validateArgType('Firestore.setLogLevel', 'string', 1, level);
        switch (level) {
            case 'debug':
                setLogLevel(LogLevel.DEBUG);
                break;
            case 'error':
                setLogLevel(LogLevel.ERROR);
                break;
            case 'silent':
                setLogLevel(LogLevel.SILENT);
                break;
            default:
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
        }
    };
    return Firestore;
}();

/**
 * A reference to a transaction.
 */
var database_Transaction = /** @class */function () {
    function Transaction(_firestore, _transaction) {
        this._firestore = _firestore;
        this._transaction = _transaction;
    }
    Transaction.prototype.get = function (documentRef) {
        var _this = this;
        validateExactNumberOfArgs('Transaction.get', arguments, 1);
        var ref = validateReference('Transaction.get', documentRef, this._firestore);
        return this._transaction.lookup([ref._key]).then(function (docs) {
            if (!docs || docs.length !== 1) {
                return fail('Mismatch in docs returned from document lookup.');
            }
            var doc = docs[0];
            if (doc instanceof document_NoDocument) {
                return new database_DocumentSnapshot(_this._firestore, ref._key, null, false);
            }
            return new database_DocumentSnapshot(_this._firestore, ref._key, doc, false);
        });
    };
    Transaction.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
        var ref = validateReference('Transaction.set', documentRef, this._firestore);
        options = validateSetOptions('Transaction.set', options);
        var parsed = options.merge ? this._firestore._dataConverter.parseMergeData('Transaction.set', value) : this._firestore._dataConverter.parseSetData('Transaction.set', value);
        this._transaction.set(ref._key, parsed);
        return this;
    };
    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' || fieldOrUpdateData instanceof field_path_FieldPath) {
            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
        } else {
            validateExactNumberOfArgs('Transaction.update', arguments, 2);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
        }
        this._transaction.update(ref._key, parsed);
        return this;
    };
    Transaction.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
        this._transaction.delete(ref._key);
        return this;
    };
    return Transaction;
}();

var database_WriteBatch = /** @class */function () {
    function WriteBatch(_firestore) {
        this._firestore = _firestore;
        this._mutations = [];
        this._committed = false;
    }
    WriteBatch.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
        options = validateSetOptions('WriteBatch.set', options);
        var parsed = options.merge ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value) : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, mutation_Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        this.verifyNotCommitted();
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' || fieldOrUpdateData instanceof field_path_FieldPath) {
            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
        } else {
            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
        }
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, mutation_Precondition.exists(true)));
        return this;
    };
    WriteBatch.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
        this._mutations = this._mutations.concat(new mutation_DeleteMutation(ref._key, mutation_Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.commit = function () {
        this.verifyNotCommitted();
        this._committed = true;
        if (this._mutations.length > 0) {
            return this._firestore.ensureClientConfigured().write(this._mutations);
        } else {
            return Promise.resolve();
        }
    };
    WriteBatch.prototype.verifyNotCommitted = function () {
        if (this._committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' + 'has been called.');
        }
    };
    return WriteBatch;
}();

/**
 * A reference to a particular document in a collection in the database.
 */
var database_DocumentReference = /** @class */function () {
    function DocumentReference(_key, firestore) {
        this._key = _key;
        this.firestore = firestore;
        this._firestoreClient = this.firestore.ensureClientConfigured();
    }
    DocumentReference.forPath = function (path, firestore) {
        if (path.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' + 'references must have an even number of segments, but ' + (path.canonicalString() + " has " + path.length));
        }
        return new DocumentReference(new document_key_DocumentKey(path), firestore);
    };
    Object.defineProperty(DocumentReference.prototype, "id", {
        get: function get() {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "parent", {
        get: function get() {
            return new database_CollectionReference(this._key.path.popLast(), this.firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "path", {
        get: function get() {
            return this._key.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    DocumentReference.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
        validateArgType('DocumentReference.collection', 'string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
        }
        var path = path_ResourcePath.fromString(pathString);
        return new database_CollectionReference(this._key.path.child(path), this.firestore);
    };
    DocumentReference.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentReference)) {
            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
        }
        return this.firestore === other.firestore && this._key.equals(other._key);
    };
    DocumentReference.prototype.set = function (value, options) {
        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
        options = validateSetOptions('DocumentReference.set', options);
        var parsed = options.merge ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value) : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
        return this._firestoreClient.write(parsed.toMutations(this._key, mutation_Precondition.NONE));
    };
    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 2] = arguments[_i];
        }
        var parsed;
        if (typeof fieldOrUpdateData === 'string' || fieldOrUpdateData instanceof field_path_FieldPath) {
            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
        } else {
            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
        }
        return this._firestoreClient.write(parsed.toMutations(this._key, mutation_Precondition.exists(true)));
    };
    DocumentReference.prototype.delete = function () {
        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
        return this._firestoreClient.write([new mutation_DeleteMutation(this._key, mutation_Precondition.NONE)]);
    };
    DocumentReference.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
        var options = {
            includeMetadataChanges: false
        };
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' && !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('DocumentReference.onSnapshot', options, ['includeMetadataChanges']);
            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        var internalOptions = {
            includeDocumentMetadataChanges: options.includeMetadataChanges,
            includeQueryMetadataChanges: options.includeMetadataChanges
        };
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        } else {
            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(internalOptions, observer);
    };
    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function errHandler(err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function next(snapshot) {
                if (observer.next) {
                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
                    var doc = snapshot.docs.get(_this._key);
                    observer.next(new database_DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache));
                }
            },
            error: errHandler
        });
        var internalListener = this._firestoreClient.listen(query_Query.atPath(this._key.path), asyncObserver, options);
        return function () {
            asyncObserver.mute();
            _this._firestoreClient.unlisten(internalListener);
        };
    };
    DocumentReference.prototype.get = function () {
        var _this = this;
        validateExactNumberOfArgs('DocumentReference.get', arguments, 0);
        return new Promise(function (resolve, reject) {
            var unlisten = _this.onSnapshotInternal({
                includeQueryMetadataChanges: true,
                includeDocumentMetadataChanges: true,
                waitForSyncWhenOnline: true
            }, {
                next: function next(snap) {
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    unlisten();
                    if (!snap.exists && snap.metadata.fromCache) {
                        // TODO(dimond): If we're online and the document doesn't
                        // exist then we resolve with a doc.exists set to false. If
                        // we're offline however, we reject the Promise in this
                        // case. Two options: 1) Cache the negative response from
                        // the server so we can deliver that even when you're
                        // offline 2) Actually reject the Promise in the online case
                        // if the document doesn't exist.
                        reject(new FirestoreError(Code.ABORTED, 'Failed to get document because the client is ' + 'offline.'));
                    } else {
                        resolve(snap);
                    }
                },
                error: reject
            });
        });
    };
    return DocumentReference;
}();

var database_DocumentSnapshot = /** @class */function () {
    function DocumentSnapshot(_firestore, _key, _document, _fromCache) {
        this._firestore = _firestore;
        this._key = _key;
        this._document = _document;
        this._fromCache = _fromCache;
    }
    DocumentSnapshot.prototype.data = function () {
        validateExactNumberOfArgs('DocumentSnapshot.data', arguments, 0);
        if (!this._document) {
            throw new FirestoreError(Code.NOT_FOUND, "This document doesn't exist. Check doc.exists to make sure " + 'the document exists before calling doc.data().');
        }
        return this.convertObject(this._document.data);
    };
    DocumentSnapshot.prototype.get = function (fieldPath) {
        validateExactNumberOfArgs('DocumentSnapshot.get', arguments, 1);
        if (!this._document) {
            throw new FirestoreError(Code.NOT_FOUND, "This document doesn't exist. Check doc.exists to make sure " + 'the document exists before calling doc.get().');
        }
        var value = this._document.data.field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
        return value === undefined ? undefined : this.convertValue(value);
    };
    Object.defineProperty(DocumentSnapshot.prototype, "id", {
        get: function get() {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
        get: function get() {
            return new database_DocumentReference(this._key, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
        get: function get() {
            return this._document !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
        get: function get() {
            return {
                hasPendingWrites: this._document !== null && this._document.hasLocalMutations,
                fromCache: this._fromCache
            };
        },
        enumerable: true,
        configurable: true
    });
    DocumentSnapshot.prototype.convertObject = function (data) {
        var _this = this;
        var result = {};
        data.forEach(function (key, value) {
            result[key] = _this.convertValue(value);
        });
        return result;
    };
    DocumentSnapshot.prototype.convertValue = function (value) {
        if (value instanceof field_value_ObjectValue) {
            return this.convertObject(value);
        } else if (value instanceof field_value_ArrayValue) {
            return this.convertArray(value);
        } else if (value instanceof field_value_RefValue) {
            var key = value.value();
            var database = this._firestore.ensureClientConfigured().databaseId();
            if (!value.databaseId.equals(database)) {
                // TODO(b/64130202): Somehow support foreign references.
                log_error("Document " + this._key.path + " contains a document " + "reference within a different database (" + (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") + "supported. It will be treated as a reference in the current " + ("database (" + database.projectId + "/" + database.database + ") ") + "instead.");
            }
            return new database_DocumentReference(key, this._firestore);
        } else {
            return value.value();
        }
    };
    DocumentSnapshot.prototype.convertArray = function (data) {
        var _this = this;
        return data.internalValue.map(function (value) {
            return _this.convertValue(value);
        });
    };
    return DocumentSnapshot;
}();

var database_Query = /** @class */function () {
    function Query(_query, firestore) {
        this._query = _query;
        this.firestore = firestore;
    }
    Query.prototype.where = function (field, opStr, value) {
        validateExactNumberOfArgs('Query.where', arguments, 3);
        validateArgType('Query.where', 'string', 2, opStr);
        validateDefined('Query.where', 3, value);
        var fieldValue;
        var fieldPath = fieldPathFromArgument('Query.where', field);
        if (fieldPath.isKeyField()) {
            if (typeof value === 'string') {
                if (value.indexOf('/') !== -1) {
                    // TODO(dimond): Allow slashes once ancestor queries are supported
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' + 'valid document ID if the first parameter is ' + 'FieldPath.documentId(), but it contains a slash.');
                }
                if (value === '') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' + 'valid document ID if the first parameter is ' + 'FieldPath.documentId(), but it was an empty string.');
                }
                var path = this._query.path.child(new path_ResourcePath([value]));
                assert(path.length % 2 === 0, 'Path should be a document key');
                fieldValue = new field_value_RefValue(this.firestore._databaseId, new document_key_DocumentKey(path));
            } else if (value instanceof database_DocumentReference) {
                var ref = value;
                fieldValue = new field_value_RefValue(this.firestore._databaseId, ref._key);
            } else {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " + "string or a DocumentReference if the first parameter is " + "FieldPath.documentId(), but it was: " + (valueDescription(value) + "."));
            }
        } else {
            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
        }
        var filter = fieldFilter(fieldPath, query_RelationOp.fromString(opStr), fieldValue);
        this.validateNewFilter(filter);
        return new Query(this._query.addFilter(filter), this.firestore);
    };
    Query.prototype.orderBy = function (field, directionStr) {
        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
        validateOptionalArgType('Query.orderBy', 'string', 2, directionStr);
        var direction;
        if (directionStr === undefined || directionStr === 'asc') {
            direction = Direction.ASCENDING;
        } else if (directionStr === 'desc') {
            direction = Direction.DESCENDING;
        } else {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " + "expected 'asc' or 'desc'.");
        }
        if (this._query.startAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' + 'Query.startAfter() before calling Query.orderBy().');
        }
        if (this._query.endAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' + 'Query.endBefore() before calling Query.orderBy().');
        }
        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
        var orderBy = new query_OrderBy(fieldPath, direction);
        this.validateNewOrderBy(orderBy);
        return new Query(this._query.addOrderBy(orderBy), this.firestore);
    };
    Query.prototype.limit = function (n) {
        validateExactNumberOfArgs('Query.limit', arguments, 1);
        validateArgType('Query.limit', 'number', 1, n);
        if (n <= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " + 'positive.');
        }
        return new Query(this._query.withLimit(n), this.firestore);
    };
    Query.prototype.startAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields,
        /*before=*/true);
        return new Query(this._query.withStartAt(bound), this.firestore);
    };
    Query.prototype.startAfter = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields,
        /*before=*/false);
        return new Query(this._query.withStartAt(bound), this.firestore);
    };
    Query.prototype.endBefore = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields,
        /*before=*/true);
        return new Query(this._query.withEndAt(bound), this.firestore);
    };
    Query.prototype.endAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields,
        /*before=*/false);
        return new Query(this._query.withEndAt(bound), this.firestore);
    };
    Query.prototype.isEqual = function (other) {
        if (!(other instanceof Query)) {
            throw invalidClassError('isEqual', 'Query', 1, other);
        }
        return this.firestore === other.firestore && this._query.equals(other._query);
    };
    /** Helper function to create a bound from a document or fields */
    Query.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
        validateDefined(methodName, 1, docOrField);
        if (docOrField instanceof database_DocumentSnapshot) {
            if (fields.length > 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
            }
            var snap = docOrField;
            if (!snap.exists) {
                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + (methodName + "()."));
            }
            return this.boundFromDocument(methodName, snap._document, before);
        } else {
            var allFields = [docOrField].concat(fields);
            return this.boundFromFields(methodName, allFields, before);
        }
    };
    /**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query.
     */
    Query.prototype.boundFromDocument = function (methodName, doc, before) {
        var components = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            if (orderBy.field.isKeyField()) {
                components.push(new field_value_RefValue(this.firestore._databaseId, doc.key));
            } else {
                var value = doc.field(orderBy.field);
                if (value !== undefined) {
                    components.push(value);
                } else {
                    var field = orderBy.field.canonicalString();
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " + ("document for which the field '" + field + "' (used as the ") + "orderBy) does not exist.");
                }
            }
        }
        return new query_Bound(components, before);
    };
    /**
     * Converts a list of field values to a Bound for the given query.
     */
    Query.prototype.boundFromFields = function (methodName, values, before) {
        // Use explicit order by's because it has to match the query the user made
        var orderBy = this._query.explicitOrderBy;
        if (values.length > orderBy.length) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " + "The number of arguments must be less than or equal to the " + "number of Query.orderBy() clauses");
        }
        var components = [];
        for (var i = 0; i < values.length; i++) {
            var rawValue = values[i];
            var orderByComponent = orderBy[i];
            if (orderByComponent.field.isKeyField()) {
                if (typeof rawValue !== 'string') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + (methodName + "(), but got a " + typeof rawValue));
                }
                if (rawValue.indexOf('/') !== -1) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Document ID '" + rawValue + "' contains a slash in " + (methodName + "()"));
                }
                var key = new document_key_DocumentKey(this._query.path.child(rawValue));
                components.push(new field_value_RefValue(this.firestore._databaseId, key));
            } else {
                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
                components.push(wrapped);
            }
        }
        return new query_Bound(components, before);
    };
    Query.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
        var options = {};
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' && !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('Query.onSnapshot', options, ['includeQueryMetadataChanges', 'includeDocumentMetadataChanges']);
            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeDocumentMetadataChanges', options.includeDocumentMetadataChanges);
            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeQueryMetadataChanges', options.includeQueryMetadataChanges);
            currArg++;
        }
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        } else {
            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(options, observer);
    };
    Query.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function errHandler(err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function next(result) {
                if (observer.next) {
                    observer.next(new database_QuerySnapshot(_this.firestore, _this._query, result));
                }
            },
            error: errHandler
        });
        var firestoreClient = this.firestore.ensureClientConfigured();
        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
        return function () {
            asyncObserver.mute();
            firestoreClient.unlisten(internalListener);
        };
    };
    Query.prototype.get = function () {
        var _this = this;
        validateExactNumberOfArgs('Query.get', arguments, 0);
        return new Promise(function (resolve, reject) {
            var unlisten = _this.onSnapshotInternal({
                includeDocumentMetadataChanges: false,
                includeQueryMetadataChanges: true,
                waitForSyncWhenOnline: true
            }, {
                next: function next(result) {
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    unlisten();
                    resolve(result);
                },
                error: reject
            });
        });
    };
    Query.prototype.validateNewFilter = function (filter) {
        if (filter instanceof query_RelationFilter && filter.isInequality()) {
            var existingField = this._query.getInequalityFilterField();
            if (existingField !== null && !existingField.equals(filter.field)) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' + ' (<, <=, >, or >=) must be on the same field. But you have' + (" inequality filters on '" + existingField.toString() + "'") + (" and '" + filter.field.toString() + "'"));
            }
            var firstOrderByField = this._query.getFirstOrderByField();
            if (firstOrderByField !== null) {
                this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
            }
        }
    };
    Query.prototype.validateNewOrderBy = function (orderBy) {
        if (this._query.getFirstOrderByField() === null) {
            // This is the first order by. It must match any inequality.
            var inequalityField = this._query.getInequalityFilterField();
            if (inequalityField !== null) {
                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
            }
        }
    };
    Query.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
        if (!orderBy.equals(inequality)) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " + ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") + ("and so you must also use '" + inequality.toString() + "' ") + "as your first Query.orderBy(), but your first Query.orderBy() " + ("is on field '" + orderBy.toString() + "' instead."));
        }
    };
    return Query;
}();

var database_QuerySnapshot = /** @class */function () {
    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
        this._firestore = _firestore;
        this._originalQuery = _originalQuery;
        this._snapshot = _snapshot;
        this._cachedChanges = null;
        this.metadata = {
            fromCache: _snapshot.fromCache,
            hasPendingWrites: _snapshot.hasPendingWrites
        };
    }
    Object.defineProperty(QuerySnapshot.prototype, "docs", {
        get: function get() {
            var result = [];
            this.forEach(function (doc) {
                return result.push(doc);
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "empty", {
        get: function get() {
            return this._snapshot.docs.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "size", {
        get: function get() {
            return this._snapshot.docs.size;
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
        this._snapshot.docs.forEach(function (doc) {
            callback.call(thisArg, _this.convertToDocumentImpl(doc));
        });
    };
    Object.defineProperty(QuerySnapshot.prototype, "query", {
        get: function get() {
            return new database_Query(this._originalQuery, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "docChanges", {
        get: function get() {
            if (!this._cachedChanges) {
                this._cachedChanges = changesFromSnapshot(this._firestore, this._snapshot);
            }
            return this._cachedChanges;
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
        return new database_DocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache);
    };
    return QuerySnapshot;
}();

var database_CollectionReference = /** @class */function (_super) {
    database___extends(CollectionReference, _super);
    function CollectionReference(path, firestore) {
        var _this = _super.call(this, query_Query.atPath(path), firestore) || this;
        if (path.length % 2 !== 1) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' + 'references must have an odd number of segments, but ' + (path.canonicalString() + " has " + path.length));
        }
        return _this;
    }
    Object.defineProperty(CollectionReference.prototype, "id", {
        get: function get() {
            return this._query.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "parent", {
        get: function get() {
            var parentPath = this._query.path.popLast();
            if (parentPath.isEmpty()) {
                return null;
            } else {
                return new database_DocumentReference(new document_key_DocumentKey(parentPath), this.firestore);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "path", {
        get: function get() {
            return this._query.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    CollectionReference.prototype.doc = function (pathString) {
        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
        // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        if (arguments.length === 0) {
            pathString = misc_AutoId.newId();
        }
        validateArgType('CollectionReference.doc', 'string', 1, pathString);
        if (pathString === '') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
        }
        var path = path_ResourcePath.fromString(pathString);
        return database_DocumentReference.forPath(this._query.path.child(path), this.firestore);
    };
    CollectionReference.prototype.add = function (value) {
        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
        validateArgType('CollectionReference.add', 'object', 1, value);
        var docRef = this.doc();
        return docRef.set(value).then(function () {
            return docRef;
        });
    };
    return CollectionReference;
}(database_Query);

function validateSetOptions(methodName, options) {
    if (options === undefined) {
        return {
            merge: false
        };
    }
    validateOptionNames(methodName, options, ['merge']);
    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
    return options;
}
function validateReference(methodName, documentRef, firestore) {
    if (!(documentRef instanceof database_DocumentReference)) {
        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
    } else if (documentRef.firestore !== firestore) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
    } else {
        return documentRef;
    }
}
/**
 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
 *
 * Exported for testing.
 */
function changesFromSnapshot(firestore, snapshot) {
    if (snapshot.oldDocs.isEmpty()) {
        // Special case the first snapshot because index calculation is easy and
        // fast
        var lastDoc_1;
        var index_1 = 0;
        return snapshot.docChanges.map(function (change) {
            var doc = new database_DocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
            lastDoc_1 = change.doc;
            return {
                type: 'added',
                doc: doc,
                oldIndex: -1,
                newIndex: index_1++
            };
        });
    } else {
        // A DocumentSet that is updated incrementally as changes are applied to use
        // to lookup the index of a document.
        var indexTracker_1 = snapshot.oldDocs;
        return snapshot.docChanges.map(function (change) {
            var doc = new database_DocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
            var oldIndex = -1;
            var newIndex = -1;
            if (change.type !== ChangeType.Added) {
                oldIndex = indexTracker_1.indexOf(change.doc.key);
                assert(oldIndex >= 0, 'Index for document not found');
                indexTracker_1 = indexTracker_1.delete(change.doc.key);
            }
            if (change.type !== ChangeType.Removed) {
                indexTracker_1 = indexTracker_1.add(change.doc);
                newIndex = indexTracker_1.indexOf(change.doc.key);
            }
            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
        });
    }
}
function resultChangeType(type) {
    switch (type) {
        case ChangeType.Added:
            return 'added';
        case ChangeType.Modified:
        case ChangeType.Metadata:
            return 'modified';
        case ChangeType.Removed:
            return 'removed';
        default:
            return fail('Unknown change type: ' + type);
    }
}
// Export the classes with a private constructor (it will fail if invoked
// at runtime). Note that this still allows instanceof checks.
// We're treating the variables as class names, so disable checking for lower
// case variable names.
// tslint:disable:variable-name
var PublicFirestore = makeConstructorPrivate(database_Firestore, 'Use firebase.firestore() instead.');
var PublicTransaction = makeConstructorPrivate(database_Transaction, 'Use firebase.firestore().runTransaction() instead.');
var PublicWriteBatch = makeConstructorPrivate(database_WriteBatch, 'Use firebase.firestore().batch() instead.');
var PublicDocumentReference = makeConstructorPrivate(database_DocumentReference, 'Use firebase.firestore().doc() instead.');
var PublicDocumentSnapshot = makeConstructorPrivate(database_DocumentSnapshot);
var PublicQuery = makeConstructorPrivate(database_Query);
var PublicQuerySnapshot = makeConstructorPrivate(database_QuerySnapshot);
var PublicCollectionReference = makeConstructorPrivate(database_CollectionReference, 'Use firebase.firestore().collection() instead.');
// tslint:enable:variable-name

//# sourceMappingURL=database.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/src/platform/config.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var firestoreNamespace = {
  Firestore: PublicFirestore,
  GeoPoint: geo_point_GeoPoint,
  Blob: PublicBlob,
  Transaction: PublicTransaction,
  WriteBatch: PublicWriteBatch,
  DocumentReference: PublicDocumentReference,
  DocumentSnapshot: PublicDocumentSnapshot,
  Query: PublicQuery,
  QuerySnapshot: PublicQuerySnapshot,
  CollectionReference: PublicCollectionReference,
  FieldPath: field_path_FieldPath,
  FieldValue: PublicFieldValue,
  setLogLevel: database_Firestore.setLogLevel
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 */
function configureForFirebase(firebase) {
  firebase.INTERNAL.registerService('firestore', function (app) {
    return new database_Firestore(app);
  }, shallowCopy(firestoreNamespace));
}
/**
 * Exports the Firestore namespace into the provided `exportObject` object under
 * the key 'firestore'. This is used for wrapped binary that exposes Firestore
 * as a goog module.
 */
function configureForStandalone(exportObject) {
  var copiedNamespace = shallowCopy(firestoreNamespace);
  // Unlike the use with Firebase, the standalone allows the use of the
  // constructor, so export it's internal class
  copiedNamespace['Firestore'] = database_Firestore;
  exportObject['firestore'] = copiedNamespace;
}

//# sourceMappingURL=config.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/firestore/dist/esm/index.js
/* harmony export (immutable) */ __webpack_exports__["registerFirestore"] = registerFirestore;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



function registerFirestore(instance) {
  configureForFirebase(instance);
}
registerFirestore(esm["default"]);

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "n5gG":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__("n1Uv");

/***/ }),

/***/ "niZR":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__("SUTf");
module.exports = __webpack_require__("qQjo").default;

/***/ }),

/***/ "p90z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urldecode", function() { return urldecode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlencode", function() { return urlencode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryParam", function() { return getQueryParam; });
function shuffle(input) {
    var a = input.slice();
    for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var _ref = [a[j], a[i]];
        a[i] = _ref[0];
        a[j] = _ref[1];
    }
    return a;
}

function urldecode(url) {
    return url.replace(/_/g, " ");
}

function urlencode(url) {
    return url.replace(/ /g, "_");
}

function getQueryParam(name) {
    if (typeof document !== "undefined") {
        var qs = document.location.search;
        qs = qs.replace(/\+/g, " ");
        var params = {},
            re = /[?&]?([^=]+)=([^&]*)/g,
            tokens;

        while (tokens = re.exec(qs)) {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        }

        return params[name];
    }
}



/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qQjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/@firebase/util/dist/cjs/index.js
var cjs = __webpack_require__("mnK5");
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);

// CONCATENATED MODULE: ../node_modules/@firebase/app/dist/esm/src/firebaseApp.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var contains = function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var firebaseApp_FirebaseAppImpl = /** @class */function () {
    function FirebaseAppImpl(options, name, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = name;
        this.options_ = Object(cjs["deepCopy"])(options);
        this.INTERNAL = {
            getUid: function getUid() {
                return null;
            },
            getToken: function getToken() {
                return Promise.resolve(null);
            },
            addAuthTokenListener: function addAuthTokenListener(callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () {
                    return callback(null);
                }, 0);
            },
            removeAuthTokenListener: function removeAuthTokenListener(callback) {
                tokenListeners = tokenListeners.filter(function (listener) {
                    return listener !== callback;
                });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function get() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function get() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        }).then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) {
            instanceIdentifier = DEFAULT_ENTRY_NAME;
        }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME ? instanceIdentifier : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        Object(cjs["deepExtend"])(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
firebaseApp_FirebaseAppImpl.prototype.name && firebaseApp_FirebaseAppImpl.prototype.options || firebaseApp_FirebaseAppImpl.prototype.delete || console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '4.6.1',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: cjs["createSubscribe"],
            ErrorFactory: cjs["ErrorFactory"],
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: cjs["deepExtend"]
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    Object(cjs["patchProperty"])(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    Object(cjs["patchProperty"])(app, 'App', firebaseApp_FirebaseAppImpl);
    /**
     * Create a new App instance (name must be unique).
     */
    function initializeApp(options, name) {
        if (name === undefined) {
            name = DEFAULT_ENTRY_NAME;
        } else {
            if (typeof name !== 'string' || name === '') {
                error('bad-app-name', { name: name + '' });
            }
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new firebaseApp_FirebaseAppImpl(options, name, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) {
            return apps_[name];
        });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function serviceNamespace(appArg) {
            if (appArg === void 0) {
                appArg = app();
            }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            Object(cjs["deepExtend"])(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        firebaseApp_FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        Object(cjs["deepExtend"])(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " + 'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' + 'account is only allowed in a Node.js environment. On client ' + 'devices, you should instead initialize the SDK with an api key and ' + 'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' + 'Firebase App instance.'
};
var appErrors = new cjs["ErrorFactory"]('app', 'Firebase', errors);

//# sourceMappingURL=firebaseApp.js.map
// CONCATENATED MODULE: ../node_modules/@firebase/app/dist/esm/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebase", function() { return firebase; });
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var firebase = createFirebaseNamespace();
/* harmony default export */ var esm = __webpack_exports__["default"] = (firebase);

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "rapL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", { value: true });
var Deferred = /** @class */function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
    * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
    * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
    * and returns a node-style callback which will resolve or reject the Deferred's promise.
    * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
    * @return {!function(?(Error), ?=)}
    */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            } else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () {});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                } else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}();
exports.Deferred = Deferred;

//# sourceMappingURL=deferred.js.map

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "u3et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI","active":"active__3gItZ"};

/***/ }),

/***/ "wRU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("UQex");
var invariant = __webpack_require__("wRU+");
var ReactPropTypesSecret = __webpack_require__("Asjh");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.6b3ec.js